// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"eAoc2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _database = require("firebase/database");
var _config = require("./config");
var _storage = require("firebase/storage");
var _auth = require("firebase/auth");
var _html2PdfJs = require("html2pdf.js");
var _html2PdfJsDefault = parcelHelpers.interopDefault(_html2PdfJs);
// const { initializeApp } = window.FirebaseApp,
//   { getDatabase, ref, push, set, get } = window.FirebaseDatabase,
//   {
//     getStorage,
//     ref: sRef,
//     uploadBytes,
//     getDownloadURL,
//   } = window.FirebaseStorage;
let databaseInstance = null, storageInstance = null, currentVoucherId = null, isRecipientMode = !1, auth = null, adminId = null;
let activeLs = [];
// const FIREBASE_HARDCODED_CONFIG = {
//   apiKey: 'YOUR_API_KEY_HERE',
//   databaseURL: 'https://YOUR_DATABASE_://firebaseio.com',
//   projectId: 'YOUR_PROJECT_ID_HERE',
//   storageBucket: 'YOUR_STORAGE_BUCKET_://appspot.com',
// };
document.addEventListener('DOMContentLoaded', ()=>{
    initializeFirebasePipeline();
    document.getElementById('upload-btn').addEventListener('click', executeDatabaseAndCloudUpload);
    document.getElementById('print-local-btn').addEventListener('click', ()=>window.print());
    document.getElementById('reset-btn').addEventListener('click', resetFormWorkspace);
    initializeSignaturePad('canvas-landlord', 'clear-landlord', '#0f2d59');
    initializeSignaturePad('canvas-officer', 'clear-officer', '#b45309');
});
function setDefaultSystemDates() {
    const today = new Date().toISOString().split('T');
    document.getElementById('voucher-date').value = today[0];
    document.getElementById('sig-date').value = today[0];
}
// Add these updates to the top of your existing compressed sign.js file
async function initializeFirebasePipeline() {
    try {
        (0, _config.initFb)();
        adminId = await getCurrentUserId();
        databaseInstance = (0, _database.getDatabase)();
        const dbAdmin = (0, _database.ref)(databaseInstance, `admin/${adminId}`);
        const dbAdminSnapshot = await (0, _database.get)(dbAdmin);
        let isAdmin = dbAdminSnapshot.exists() && dbAdminSnapshot.val() === true;
        storageInstance = (0, _storage.getStorage)();
        setDefaultSystemDates();
        const urlParams = new URLSearchParams(window.location.search);
        const signatureToken = urlParams.get('token');
        const incomingCaseId = urlParams.get('caseId'); // NEW: Captures parent case ID from portal.html
        if (signatureToken || !isAdmin) {
            isRecipientMode = !0;
            await loadRecipientSigningInterface(signatureToken);
        } else {
            generateAndSetNewVoucherId();
            // NEW: If launched from a case row, bind the case tracking property to the form state
            if (incomingCaseId) {
                console.log('Voucher securely attached to parent case workspace: ' + incomingCaseId);
                // Optional: Store this variable globally inside your form payload object
                window.activeParentCaseId = incomingCaseId;
            }
        }
    } catch (t) {
        alert('Init Fail: ' + t.message);
    }
}
function getCurrentUserId() {
    return new Promise((resolve, reject)=>{
        auth = (0, _auth.getAuth)();
        let unsub = (0, _auth.onAuthStateChanged)(auth, (user)=>{
            unsub();
            if (user) {
                adminId = user.uid;
                resolve(adminId);
            } else reject(new Error('No user signed in.'));
        });
    });
}
async function loadRecipientSigningInterface(t) {
    const e = document.getElementById('status-display');
    e.innerText = 'Status: Validating token...';
    try {
        const a = await (0, _database.get)((0, _database.ref)(databaseInstance, `signatureTokens/${t}`));
        if (!a.exists()) return alert('Invalid Link'), void (e.innerText = 'ERROR: Denied.');
        const n = a.val();
        currentVoucherId = n.voucherId;
        document.getElementById('data-voucherNum').value = currentVoucherId;
        const d = await (0, _database.get)((0, _database.ref)(databaseInstance, `DISB/${currentVoucherId}`));
        if (!d.exists()) return void alert('Record missing.');
        const r = d.val();
        document.getElementById('data-orgName').value = r.organization.name;
        document.getElementById('data-ein').value = r.organization.ein;
        document.getElementById('data-orgEmail').value = r.organization.email;
        document.getElementById('data-wireRef').value = r.metadata.wireReference;
        document.getElementById('data-recipName').value = r.recipient.name;
        document.getElementById('data-recipId').value = r.recipient.idNumber;
        document.getElementById('data-recipBank').value = r.recipient.bank;
        document.getElementById('data-benefName').value = r.beneficiary.name;
        document.getElementById('data-address').value = r.beneficiary.location;
        document.getElementById('data-category').value = r.beneficiary.aidCategory;
        document.getElementById('data-description').value = r.financials.allocationDescription;
        document.getElementById('data-amtUsd').value = r.financials.usdAmount;
        document.getElementById('data-currencyCode').value = r.financials.localCurrencyCode;
        document.getElementById('data-amtLocal').value = r.financials.localConvertedAmount;
        document.querySelectorAll('input,select').forEach((t)=>{
            'sig-date' !== t.id && (t.setAttribute('disabled', 'true'), t.style.backgroundColor = '#f8fafc');
        });
        document.getElementById('officer-sig-box').style.display = 'none';
        document.getElementById('attachment-container').style.display = 'none';
        document.getElementById('reset-btn').style.display = 'none';
        const o = document.getElementById('upload-btn');
        o.innerText = 'Submit Signature';
        o.removeAttribute('disabled');
        e.style.color = '#16a34a';
        e.innerText = 'Ready to sign.';
    } catch (t) {
        alert('Err: ' + t.message);
    }
}
function generateAndSetNewVoucherId() {
    if (!databaseInstance) return;
    const t = (0, _database.push)((0, _database.ref)(databaseInstance, 'DISB')).key;
    currentVoucherId = t;
    document.getElementById('data-voucherNum').value = t;
    document.getElementById('status-display').innerText = 'Status: ID ' + t + ' allocated.';
}
function initializeSignaturePad(t, e, a) {
    const n = document.getElementById(t), d = n.getContext('2d'), r = document.getElementById(e);
    function o() {
        const t = n.getBoundingClientRect();
        n.width = t.width;
        n.height = t.height;
        d.strokeStyle = a;
        d.lineWidth = 2;
        d.lineCap = 'round';
    }
    window.addEventListener('resize', o);
    setTimeout(o, 400);
    let c = !1;
    const i = (t)=>{
        const e = n.getBoundingClientRect();
        return {
            x: (t.touches ? t.touches.clientX : t.clientX) - e.left,
            y: (t.touches ? t.touches.clientY : t.clientY) - e.top
        };
    };
    const s = (t)=>{
        c = !0;
        const e = i(t);
        d.beginPath();
        d.moveTo(e.x, e.y);
        t.preventDefault();
    };
    const m = (t)=>{
        if (c) {
            const e = i(t);
            d.lineTo(e.x, e.y);
            d.stroke();
        }
        t.preventDefault();
    };
    n.addEventListener('mousedown', s);
    n.addEventListener('mousemove', m);
    window.addEventListener('mouseup', ()=>c = !1);
    n.addEventListener('touchstart', s, {
        passive: !1
    });
    n.addEventListener('touchmove', m, {
        passive: !1
    });
    window.addEventListener('touchend', ()=>c = !1);
    r.addEventListener('click', ()=>d.clearRect(0, 0, n.width, n.height));
}
async function executeDatabaseAndCloudUpload() {
    if (!databaseInstance || !storageInstance) return;
    if (!isRecipientMode) {
        document.querySelectorAll('input,select').forEach((t)=>t.style.borderColor = '');
        const t = [
            'data-wireRef',
            'data-recipName',
            'data-recipId',
            'data-recipBank',
            'data-benefName',
            'data-address',
            'data-category',
            'data-description',
            'data-amtUsd'
        ];
        let e = 0;
        if (t.forEach((t)=>{
            const a = document.getElementById(t);
            a && a.value.trim() || (a.style.borderColor = '#ef4444', e++);
        }), e > 0) return void alert('Error: Required fields are missing.');
    }
    const statusDisplay = document.getElementById('status-display');
    statusDisplay.innerText = 'Status: Exporting payload...';
    const payload = {
        voucherId: currentVoucherId,
        adminId: adminId,
        caseId: window.activeParentCaseId || 'N/A',
        voucherDate: document.getElementById('voucher-date').value,
        wireRef: document.getElementById('data-wireRef').value,
        signDate: document.getElementById('sig-date').value,
        payeeName: document.getElementById('data-recipName').value,
        payeeId: document.getElementById('data-recipId').value,
        payeeBank: document.getElementById('data-recipBank').value,
        doneeName: document.getElementById('data-recipName').value,
        doneeAddress: document.getElementById('data-address').value,
        program: document.getElementById('data-category').value,
        purpose: document.getElementById('data-description').value,
        usdAmount: document.getElementById('data-amtUsd').value,
        localCurrency: (document.getElementById('data-currencyCode').value || '').toUpperCase(),
        localAmount: document.getElementById('data-amtLocal').value,
        date: new Date().getTime(),
        timestamp: new Date().toISOString()
    };
    try {
        await (0, _database.set)((0, _database.ref)(databaseInstance, `DISB/${currentVoucherId}`), payload);
        statusDisplay.innerText = 'Status: Compiling PDF...';
        const a = await (0, _html2PdfJsDefault.default)().set({
            margin: 0.2,
            filename: currentVoucherId + '_Voucher.pdf',
            image: {
                type: 'jpeg',
                quality: 0.98
            },
            html2canvas: {
                scale: 2,
                useCORS: !0
            },
            jsPDF: {
                unit: 'in',
                format: 'letter',
                orientation: 'portrait'
            }
        }).from(document.getElementById('invoice-render-target')).output('blob');
        statusDisplay.innerText = 'Status: Uploading PDF...';
        const n = (0, _storage.ref)(storageInstance, `DISBFiles/${currentVoucherId}/${currentVoucherId}_Voucher.pdf`);
        await (0, _storage.uploadBytes)(n, a);
        const url = await (0, _storage.getDownloadURL)(n);
        await (0, _database.set)((0, _database.push)((0, _database.ref)(databaseInstance, `disbFiles/${currentVoucherId}`)), url);
        if (!isRecipientMode) {
            const inAddionalFiles = document.getElementById('additional-files-input');
            if (inAddionalFiles.files.length > 0) for(let e = 0; e < inAddionalFiles.files.length; e++){
                const a = (0, _storage.ref)(storageInstance, `DISBFiles/${currentVoucherId}/attachments/${Date.now()}_${inAddionalFiles.files[e].name}`);
                await (0, _storage.uploadBytes)(a, inAddionalFiles.files[e]);
                const n = await (0, _storage.getDownloadURL)(a);
                await (0, _database.set)((0, _database.push)((0, _database.ref)(databaseInstance, `disbFiles/${currentVoucherId}`)), n);
            }
        }
        lockDownVoucherInterface();
        statusDisplay.style.color = '#16a34a';
        statusDisplay.innerText = 'SUCCESS: Locked.';
        alert('Sync complete.');
    } catch (e) {
        statusDisplay.style.color = '#dc2626';
        statusDisplay.innerText = 'ERROR: ' + e.message;
    }
}
function lockDownVoucherInterface() {
    document.querySelectorAll('input,select').forEach((t)=>{
        t.setAttribute('disabled', 'true');
        t.style.backgroundColor = '#e2e8f0';
    });
    document.getElementById('upload-btn').setAttribute('disabled', 'true');
    document.getElementById('upload-btn').style.backgroundColor = '#64748b';
    document.getElementById('clear-landlord').style.display = 'none';
    document.getElementById('clear-officer').style.display = 'none';
    const t = document.getElementById('attachment-container');
    t && (t.style.opacity = '0.5');
}
function resetFormWorkspace() {
    if (!confirm('Clear form?')) return;
    document.querySelectorAll('input,select').forEach((t)=>{
        'data-orgName' !== t.id && 'data-ein' !== t.id && 'data-orgEmail' !== t.id && (t.value = ''), t.removeAttribute('disabled'), t.style.backgroundColor = '#fff', t.style.borderColor = '';
    });
    document.getElementById('upload-btn').removeAttribute('disabled');
    document.getElementById('upload-btn').style.backgroundColor = '#0f2d59';
    document.getElementById('clear-landlord').style.display = 'block';
    document.getElementById('clear-officer').style.display = 'block';
    document.getElementById('attachment-container').style.opacity = '1';
    document.getElementById('status-display').style.color = '#1e40af';
    [
        'canvas-landlord',
        'canvas-officer'
    ].forEach((t)=>{
        const e = document.getElementById(t);
        e.getContext('2d').clearRect(0, 0, e.width, e.height);
    });
    setDefaultSystemDates();
    generateAndSetNewVoucherId();
}

},{"firebase/database":"3h9CB","./config":"324tf","firebase/storage":"9JHfQ","firebase/auth":"dZ6yw","html2pdf.js":"9Ncaj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Ncaj":[function(require,module,exports,__globalThis) {
var global = arguments[3];
/*!
 * html2pdf.js v0.14.0
 * Copyright (c) 2026 Erik Koopmans
 * Released under the MIT License.
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory(require("3af49d75da587f8"));
})(self, function(__WEBPACK_EXTERNAL_MODULE_html2canvas__) {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ "./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js": /*!*********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js ***!
  \*********************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ _arrayLikeToArray;
                    }
                });
                function _arrayLikeToArray(r, a) {
                    (null == a || a > r.length) && (a = r.length);
                    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
                    return n;
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js": /*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js ***!
  \*******************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ _arrayWithHoles;
                    }
                });
                function _arrayWithHoles(r) {
                    if (Array.isArray(r)) return r;
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js": /*!*********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js ***!
  \*********************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ _asyncToGenerator;
                    }
                });
                function asyncGeneratorStep(n, t, e, r, o, a, c) {
                    try {
                        var i = n[a](c), u = i.value;
                    } catch (n) {
                        return void e(n);
                    }
                    i.done ? t(u) : Promise.resolve(u).then(r, o);
                }
                function _asyncToGenerator(n) {
                    return function() {
                        var t = this, e = arguments;
                        return new Promise(function(r, o) {
                            var a = n.apply(t, e);
                            function _next(n) {
                                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
                            }
                            function _throw(n) {
                                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
                            }
                            _next(void 0);
                        });
                    };
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js": /*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \*******************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ _defineProperty;
                    }
                });
                /* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js");
                function _defineProperty(e, r, t) {
                    return (r = (0, _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r)) in e ? Object.defineProperty(e, r, {
                        value: t,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[r] = t, e;
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js": /*!*************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js ***!
  \*************************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ _iterableToArrayLimit;
                    }
                });
                function _iterableToArrayLimit(r, l) {
                    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                    if (null != t) {
                        var e, n, i, u, a = [], f = !0, o = !1;
                        try {
                            if (i = (t = t.call(r)).next, 0 === l) {
                                if (Object(t) !== t) return;
                                f = !1;
                            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
                        } catch (r) {
                            o = !0, n = r;
                        } finally{
                            try {
                                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
                            } finally{
                                if (o) throw n;
                            }
                        }
                        return a;
                    }
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js": /*!********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js ***!
  \********************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ _nonIterableRest;
                    }
                });
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js": /*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js ***!
  \******************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ _slicedToArray;
                    }
                });
                /* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayWithHoles.js */ "./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js");
                /* harmony import */ var _iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iterableToArrayLimit.js */ "./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js");
                /* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js");
                /* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./nonIterableRest.js */ "./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js");
                function _slicedToArray(r, e) {
                    return (0, _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r) || (0, _iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__["default"])(r, e) || (0, _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__["default"])(r, e) || (0, _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__["default"])();
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/esm/toPrimitive.js": /*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js ***!
  \****************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ toPrimitive;
                    }
                });
                /* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/esm/typeof.js");
                function toPrimitive(t, r) {
                    if ("object" != (0, _typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != (0, _typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js": /*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js ***!
  \******************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ toPropertyKey;
                    }
                });
                /* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/esm/typeof.js");
                /* harmony import */ var _toPrimitive_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/@babel/runtime/helpers/esm/toPrimitive.js");
                function toPropertyKey(t) {
                    var i = (0, _toPrimitive_js__WEBPACK_IMPORTED_MODULE_1__["default"])(t, "string");
                    return "symbol" == (0, _typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(i) ? i : i + "";
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/esm/typeof.js": /*!***********************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \***********************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ _typeof;
                    }
                });
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js": /*!*******************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js ***!
  \*******************************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ _unsupportedIterableToArray;
                    }
                });
                /* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");
                function _unsupportedIterableToArray(r, a) {
                    if (r) {
                        if ("string" == typeof r) return (0, _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r, a);
                        var t = ({}).toString.call(r).slice(8, -1);
                        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r, a) : void 0;
                    }
                }
            /***/ },
            /***/ "./node_modules/canvg/lib/index.es.js": /*!********************************************!*\
  !*** ./node_modules/canvg/lib/index.es.js ***!
  \********************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ AElement: function() {
                        return /* binding */ AElement;
                    },
                    /* harmony export */ AnimateColorElement: function() {
                        return /* binding */ AnimateColorElement;
                    },
                    /* harmony export */ AnimateElement: function() {
                        return /* binding */ AnimateElement;
                    },
                    /* harmony export */ AnimateTransformElement: function() {
                        return /* binding */ AnimateTransformElement;
                    },
                    /* harmony export */ BoundingBox: function() {
                        return /* binding */ BoundingBox;
                    },
                    /* harmony export */ CB1: function() {
                        return /* binding */ CB1;
                    },
                    /* harmony export */ CB2: function() {
                        return /* binding */ CB2;
                    },
                    /* harmony export */ CB3: function() {
                        return /* binding */ CB3;
                    },
                    /* harmony export */ CB4: function() {
                        return /* binding */ CB4;
                    },
                    /* harmony export */ Canvg: function() {
                        return /* binding */ Canvg;
                    },
                    /* harmony export */ CircleElement: function() {
                        return /* binding */ CircleElement;
                    },
                    /* harmony export */ ClipPathElement: function() {
                        return /* binding */ ClipPathElement;
                    },
                    /* harmony export */ DefsElement: function() {
                        return /* binding */ DefsElement;
                    },
                    /* harmony export */ DescElement: function() {
                        return /* binding */ DescElement;
                    },
                    /* harmony export */ Document: function() {
                        return /* binding */ Document;
                    },
                    /* harmony export */ Element: function() {
                        return /* binding */ Element;
                    },
                    /* harmony export */ EllipseElement: function() {
                        return /* binding */ EllipseElement;
                    },
                    /* harmony export */ FeColorMatrixElement: function() {
                        return /* binding */ FeColorMatrixElement;
                    },
                    /* harmony export */ FeCompositeElement: function() {
                        return /* binding */ FeCompositeElement;
                    },
                    /* harmony export */ FeDropShadowElement: function() {
                        return /* binding */ FeDropShadowElement;
                    },
                    /* harmony export */ FeGaussianBlurElement: function() {
                        return /* binding */ FeGaussianBlurElement;
                    },
                    /* harmony export */ FeMorphologyElement: function() {
                        return /* binding */ FeMorphologyElement;
                    },
                    /* harmony export */ FilterElement: function() {
                        return /* binding */ FilterElement;
                    },
                    /* harmony export */ Font: function() {
                        return /* binding */ Font;
                    },
                    /* harmony export */ FontElement: function() {
                        return /* binding */ FontElement;
                    },
                    /* harmony export */ FontFaceElement: function() {
                        return /* binding */ FontFaceElement;
                    },
                    /* harmony export */ GElement: function() {
                        return /* binding */ GElement;
                    },
                    /* harmony export */ GlyphElement: function() {
                        return /* binding */ GlyphElement;
                    },
                    /* harmony export */ GradientElement: function() {
                        return /* binding */ GradientElement;
                    },
                    /* harmony export */ ImageElement: function() {
                        return /* binding */ ImageElement;
                    },
                    /* harmony export */ LineElement: function() {
                        return /* binding */ LineElement;
                    },
                    /* harmony export */ LinearGradientElement: function() {
                        return /* binding */ LinearGradientElement;
                    },
                    /* harmony export */ MarkerElement: function() {
                        return /* binding */ MarkerElement;
                    },
                    /* harmony export */ MaskElement: function() {
                        return /* binding */ MaskElement;
                    },
                    /* harmony export */ Matrix: function() {
                        return /* binding */ Matrix;
                    },
                    /* harmony export */ MissingGlyphElement: function() {
                        return /* binding */ MissingGlyphElement;
                    },
                    /* harmony export */ Mouse: function() {
                        return /* binding */ Mouse;
                    },
                    /* harmony export */ PSEUDO_ZERO: function() {
                        return /* binding */ PSEUDO_ZERO;
                    },
                    /* harmony export */ Parser: function() {
                        return /* binding */ Parser;
                    },
                    /* harmony export */ PathElement: function() {
                        return /* binding */ PathElement;
                    },
                    /* harmony export */ PathParser: function() {
                        return /* binding */ PathParser;
                    },
                    /* harmony export */ PatternElement: function() {
                        return /* binding */ PatternElement;
                    },
                    /* harmony export */ Point: function() {
                        return /* binding */ Point;
                    },
                    /* harmony export */ PolygonElement: function() {
                        return /* binding */ PolygonElement;
                    },
                    /* harmony export */ PolylineElement: function() {
                        return /* binding */ PolylineElement;
                    },
                    /* harmony export */ Property: function() {
                        return /* binding */ Property;
                    },
                    /* harmony export */ QB1: function() {
                        return /* binding */ QB1;
                    },
                    /* harmony export */ QB2: function() {
                        return /* binding */ QB2;
                    },
                    /* harmony export */ QB3: function() {
                        return /* binding */ QB3;
                    },
                    /* harmony export */ RadialGradientElement: function() {
                        return /* binding */ RadialGradientElement;
                    },
                    /* harmony export */ RectElement: function() {
                        return /* binding */ RectElement;
                    },
                    /* harmony export */ RenderedElement: function() {
                        return /* binding */ RenderedElement;
                    },
                    /* harmony export */ Rotate: function() {
                        return /* binding */ Rotate;
                    },
                    /* harmony export */ SVGElement: function() {
                        return /* binding */ SVGElement;
                    },
                    /* harmony export */ SVGFontLoader: function() {
                        return /* binding */ SVGFontLoader;
                    },
                    /* harmony export */ Scale: function() {
                        return /* binding */ Scale;
                    },
                    /* harmony export */ Screen: function() {
                        return /* binding */ Screen;
                    },
                    /* harmony export */ Skew: function() {
                        return /* binding */ Skew;
                    },
                    /* harmony export */ SkewX: function() {
                        return /* binding */ SkewX;
                    },
                    /* harmony export */ SkewY: function() {
                        return /* binding */ SkewY;
                    },
                    /* harmony export */ StopElement: function() {
                        return /* binding */ StopElement;
                    },
                    /* harmony export */ StyleElement: function() {
                        return /* binding */ StyleElement;
                    },
                    /* harmony export */ SymbolElement: function() {
                        return /* binding */ SymbolElement;
                    },
                    /* harmony export */ TRefElement: function() {
                        return /* binding */ TRefElement;
                    },
                    /* harmony export */ TSpanElement: function() {
                        return /* binding */ TSpanElement;
                    },
                    /* harmony export */ TextElement: function() {
                        return /* binding */ TextElement;
                    },
                    /* harmony export */ TextPathElement: function() {
                        return /* binding */ TextPathElement;
                    },
                    /* harmony export */ TitleElement: function() {
                        return /* binding */ TitleElement;
                    },
                    /* harmony export */ Transform: function() {
                        return /* binding */ Transform;
                    },
                    /* harmony export */ Translate: function() {
                        return /* binding */ Translate;
                    },
                    /* harmony export */ UnknownElement: function() {
                        return /* binding */ UnknownElement;
                    },
                    /* harmony export */ UseElement: function() {
                        return /* binding */ UseElement;
                    },
                    /* harmony export */ ViewPort: function() {
                        return /* binding */ ViewPort;
                    },
                    /* harmony export */ compressSpaces: function() {
                        return /* binding */ compressSpaces;
                    },
                    /* harmony export */ "default": function() {
                        return /* binding */ Canvg;
                    },
                    /* harmony export */ getSelectorSpecificity: function() {
                        return /* binding */ getSelectorSpecificity;
                    },
                    /* harmony export */ normalizeAttributeName: function() {
                        return /* binding */ normalizeAttributeName;
                    },
                    /* harmony export */ normalizeColor: function() {
                        return /* binding */ normalizeColor;
                    },
                    /* harmony export */ parseExternalUrl: function() {
                        return /* binding */ parseExternalUrl;
                    },
                    /* harmony export */ presets: function() {
                        return /* binding */ index;
                    },
                    /* harmony export */ toNumbers: function() {
                        return /* binding */ toNumbers;
                    },
                    /* harmony export */ trimLeft: function() {
                        return /* binding */ trimLeft;
                    },
                    /* harmony export */ trimRight: function() {
                        return /* binding */ trimRight;
                    },
                    /* harmony export */ vectorMagnitude: function() {
                        return /* binding */ vectorMagnitude;
                    },
                    /* harmony export */ vectorsAngle: function() {
                        return /* binding */ vectorsAngle;
                    },
                    /* harmony export */ vectorsRatio: function() {
                        return /* binding */ vectorsRatio;
                    }
                });
                /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.promise.js */ "./node_modules/core-js/modules/es.promise.js");
                /* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
                /* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.string.match.js */ "./node_modules/core-js/modules/es.string.match.js");
                /* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.replace.js */ "./node_modules/core-js/modules/es.string.replace.js");
                /* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.starts-with.js */ "./node_modules/core-js/modules/es.string.starts-with.js");
                /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator.js */ "./node_modules/core-js/modules/es.array.iterator.js");
                /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator.js */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
                /* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
                /* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.reduce.js */ "./node_modules/core-js/modules/es.array.reduce.js");
                /* harmony import */ var core_js_modules_es_string_ends_with_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.ends-with.js */ "./node_modules/core-js/modules/es.string.ends-with.js");
                /* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.split.js */ "./node_modules/core-js/modules/es.string.split.js");
                /* harmony import */ var raf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! raf */ "./node_modules/raf/index.js");
                /* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.trim.js */ "./node_modules/core-js/modules/es.string.trim.js");
                /* harmony import */ var rgbcolor__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! rgbcolor */ "./node_modules/rgbcolor/index.js");
                /* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.array.index-of.js */ "./node_modules/core-js/modules/es.array.index-of.js");
                /* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.includes.js */ "./node_modules/core-js/modules/es.string.includes.js");
                /* harmony import */ var core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.array.reverse.js */ "./node_modules/core-js/modules/es.array.reverse.js");
                /* harmony import */ var svg_pathdata__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! svg-pathdata */ "./node_modules/svg-pathdata/lib/SVGPathData.module.js");
                /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string.js */ "./node_modules/core-js/modules/es.regexp.to-string.js");
                /* harmony import */ var stackblur_canvas__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! stackblur-canvas */ "./node_modules/stackblur-canvas/dist/stackblur-es.js");
                /**
 * Options preset for `OffscreenCanvas`.
 * @param config - Preset requirements.
 * @param config.DOMParser - XML/HTML parser from string into DOM Document.
 * @returns Preset object.
 */ function offscreen() {
                    var { DOMParser: DOMParserFallback } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var preset = {
                        window: null,
                        ignoreAnimation: true,
                        ignoreMouse: true,
                        DOMParser: DOMParserFallback,
                        createCanvas (width, height) {
                            return new OffscreenCanvas(width, height);
                        },
                        createImage (url) {
                            return (0, _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function*() {
                                var response = yield fetch(url);
                                var blob = yield response.blob();
                                var img = yield createImageBitmap(blob);
                                return img;
                            })();
                        }
                    };
                    if (typeof DOMParser !== 'undefined' || typeof DOMParserFallback === 'undefined') Reflect.deleteProperty(preset, 'DOMParser');
                    return preset;
                }
                /**
 * Options preset for `node-canvas`.
 * @param config - Preset requirements.
 * @param config.DOMParser - XML/HTML parser from string into DOM Document.
 * @param config.canvas - `node-canvas` exports.
 * @param config.fetch - WHATWG-compatible `fetch` function.
 * @returns Preset object.
 */ function node(_ref) {
                    var { DOMParser: DOMParser1, canvas, fetch: fetch1 } = _ref;
                    return {
                        window: null,
                        ignoreAnimation: true,
                        ignoreMouse: true,
                        DOMParser: DOMParser1,
                        fetch: fetch1,
                        createCanvas: canvas.createCanvas,
                        createImage: canvas.loadImage
                    };
                }
                var index = /*#__PURE__*/ Object.freeze({
                    __proto__: null,
                    offscreen: offscreen,
                    node: node
                });
                /**
 * HTML-safe compress white-spaces.
 * @param str - String to compress.
 * @returns String.
 */ function compressSpaces(str) {
                    return str.replace(/(?!\u3000)\s+/gm, ' ');
                }
                /**
 * HTML-safe left trim.
 * @param str - String to trim.
 * @returns String.
 */ function trimLeft(str) {
                    return str.replace(/^[\n \t]+/, '');
                }
                /**
 * HTML-safe right trim.
 * @param str - String to trim.
 * @returns String.
 */ function trimRight(str) {
                    return str.replace(/[\n \t]+$/, '');
                }
                /**
 * String to numbers array.
 * @param str - Numbers string.
 * @returns Numbers array.
 */ function toNumbers(str) {
                    var matches = (str || '').match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [];
                    return matches.map(parseFloat);
                } // Microsoft Edge fix
                var allUppercase = /^[A-Z-]+$/;
                /**
 * Normalize attribute name.
 * @param name - Attribute name.
 * @returns Normalized attribute name.
 */ function normalizeAttributeName(name) {
                    if (allUppercase.test(name)) return name.toLowerCase();
                    return name;
                }
                /**
 * Parse external URL.
 * @param url - CSS url string.
 * @returns Parsed URL.
 */ function parseExternalUrl(url) {
                    //                      single quotes [2]
                    //                      v         double quotes [3]
                    //                      v         v         no quotes [4]
                    //                      v         v         v
                    var urlMatch = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(url) || [];
                    return urlMatch[2] || urlMatch[3] || urlMatch[4];
                }
                /**
 * Transform floats to integers in rgb colors.
 * @param color - Color to normalize.
 * @returns Normalized color.
 */ function normalizeColor(color) {
                    if (!color.startsWith('rgb')) return color;
                    var rgbParts = 3;
                    var normalizedColor = color.replace(/\d+(\.\d+)?/g, (num, isFloat)=>rgbParts-- && isFloat ? String(Math.round(parseFloat(num))) : num);
                    return normalizedColor;
                }
                // slightly modified version of https://github.com/keeganstreet/specificity/blob/master/specificity.js
                var attributeRegex = /(\[[^\]]+\])/g;
                var idRegex = /(#[^\s+>~.[:]+)/g;
                var classRegex = /(\.[^\s+>~.[:]+)/g;
                var pseudoElementRegex = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi;
                var pseudoClassWithBracketsRegex = /(:[\w-]+\([^)]*\))/gi;
                var pseudoClassRegex = /(:[^\s+>~.[:]+)/g;
                var elementRegex = /([^\s+>~.[:]+)/g;
                function findSelectorMatch(selector, regex) {
                    var matches = regex.exec(selector);
                    if (!matches) return [
                        selector,
                        0
                    ];
                    return [
                        selector.replace(regex, ' '),
                        matches.length
                    ];
                }
                /**
 * Measure selector specificity.
 * @param selector - Selector to measure.
 * @returns Specificity.
 */ function getSelectorSpecificity(selector) {
                    var specificity = [
                        0,
                        0,
                        0
                    ];
                    var currentSelector = selector.replace(/:not\(([^)]*)\)/g, '     $1 ').replace(/{[\s\S]*/gm, ' ');
                    var delta = 0;
                    [currentSelector, delta] = findSelectorMatch(currentSelector, attributeRegex);
                    specificity[1] += delta;
                    [currentSelector, delta] = findSelectorMatch(currentSelector, idRegex);
                    specificity[0] += delta;
                    [currentSelector, delta] = findSelectorMatch(currentSelector, classRegex);
                    specificity[1] += delta;
                    [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoElementRegex);
                    specificity[2] += delta;
                    [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoClassWithBracketsRegex);
                    specificity[1] += delta;
                    [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoClassRegex);
                    specificity[1] += delta;
                    currentSelector = currentSelector.replace(/[*\s+>~]/g, ' ').replace(/[#.]/g, ' ');
                    [currentSelector, delta] = findSelectorMatch(currentSelector, elementRegex); // lgtm [js/useless-assignment-to-local]
                    specificity[2] += delta;
                    return specificity.join('');
                }
                var PSEUDO_ZERO = .00000001;
                /**
 * Vector magnitude.
 * @param v
 * @returns Number result.
 */ function vectorMagnitude(v) {
                    return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
                }
                /**
 * Ratio between two vectors.
 * @param u
 * @param v
 * @returns Number result.
 */ function vectorsRatio(u, v) {
                    return (u[0] * v[0] + u[1] * v[1]) / (vectorMagnitude(u) * vectorMagnitude(v));
                }
                /**
 * Angle between two vectors.
 * @param u
 * @param v
 * @returns Number result.
 */ function vectorsAngle(u, v) {
                    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vectorsRatio(u, v));
                }
                function CB1(t) {
                    return t * t * t;
                }
                function CB2(t) {
                    return 3 * t * t * (1 - t);
                }
                function CB3(t) {
                    return 3 * t * (1 - t) * (1 - t);
                }
                function CB4(t) {
                    return (1 - t) * (1 - t) * (1 - t);
                }
                function QB1(t) {
                    return t * t;
                }
                function QB2(t) {
                    return 2 * t * (1 - t);
                }
                function QB3(t) {
                    return (1 - t) * (1 - t);
                }
                class Property {
                    constructor(document1, name, value){
                        this.document = document1;
                        this.name = name;
                        this.value = value;
                        this.isNormalizedColor = false;
                    }
                    static empty(document1) {
                        return new Property(document1, 'EMPTY', '');
                    }
                    split() {
                        var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ' ';
                        var { document: document1, name } = this;
                        return compressSpaces(this.getString()).trim().split(separator).map((value)=>new Property(document1, name, value));
                    }
                    hasValue(zeroIsValue) {
                        var { value } = this;
                        return value !== null && value !== '' && (zeroIsValue || value !== 0) && typeof value !== 'undefined';
                    }
                    isString(regexp) {
                        var { value } = this;
                        var result = typeof value === 'string';
                        if (!result || !regexp) return result;
                        return regexp.test(value);
                    }
                    isUrlDefinition() {
                        return this.isString(/^url\(/);
                    }
                    isPixels() {
                        if (!this.hasValue()) return false;
                        var asString = this.getString();
                        switch(true){
                            case asString.endsWith('px'):
                            case /^[0-9]+$/.test(asString):
                                return true;
                            default:
                                return false;
                        }
                    }
                    setValue(value) {
                        this.value = value;
                        return this;
                    }
                    getValue(def) {
                        if (typeof def === 'undefined' || this.hasValue()) return this.value;
                        return def;
                    }
                    getNumber(def) {
                        if (!this.hasValue()) {
                            if (typeof def === 'undefined') return 0;
                            return parseFloat(def);
                        }
                        var { value } = this;
                        var n = parseFloat(value);
                        if (this.isString(/%$/)) n /= 100.0;
                        return n;
                    }
                    getString(def) {
                        if (typeof def === 'undefined' || this.hasValue()) return typeof this.value === 'undefined' ? '' : String(this.value);
                        return String(def);
                    }
                    getColor(def) {
                        var color = this.getString(def);
                        if (this.isNormalizedColor) return color;
                        this.isNormalizedColor = true;
                        color = normalizeColor(color);
                        this.value = color;
                        return color;
                    }
                    getDpi() {
                        return 96.0; // TODO: compute?
                    }
                    getRem() {
                        return this.document.rootEmSize;
                    }
                    getEm() {
                        return this.document.emSize;
                    }
                    getUnits() {
                        return this.getString().replace(/[0-9.-]/g, '');
                    }
                    getPixels(axisOrIsFontSize) {
                        var processPercent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        if (!this.hasValue()) return 0;
                        var [axis, isFontSize] = typeof axisOrIsFontSize === 'boolean' ? [
                            undefined,
                            axisOrIsFontSize
                        ] : [
                            axisOrIsFontSize
                        ];
                        var { viewPort } = this.document.screen;
                        switch(true){
                            case this.isString(/vmin$/):
                                return this.getNumber() / 100.0 * Math.min(viewPort.computeSize('x'), viewPort.computeSize('y'));
                            case this.isString(/vmax$/):
                                return this.getNumber() / 100.0 * Math.max(viewPort.computeSize('x'), viewPort.computeSize('y'));
                            case this.isString(/vw$/):
                                return this.getNumber() / 100.0 * viewPort.computeSize('x');
                            case this.isString(/vh$/):
                                return this.getNumber() / 100.0 * viewPort.computeSize('y');
                            case this.isString(/rem$/):
                                return this.getNumber() * this.getRem();
                            case this.isString(/em$/):
                                return this.getNumber() * this.getEm();
                            case this.isString(/ex$/):
                                return this.getNumber() * this.getEm() / 2.0;
                            case this.isString(/px$/):
                                return this.getNumber();
                            case this.isString(/pt$/):
                                return this.getNumber() * this.getDpi() * (1.0 / 72.0);
                            case this.isString(/pc$/):
                                return this.getNumber() * 15;
                            case this.isString(/cm$/):
                                return this.getNumber() * this.getDpi() / 2.54;
                            case this.isString(/mm$/):
                                return this.getNumber() * this.getDpi() / 25.4;
                            case this.isString(/in$/):
                                return this.getNumber() * this.getDpi();
                            case this.isString(/%$/) && isFontSize:
                                return this.getNumber() * this.getEm();
                            case this.isString(/%$/):
                                return this.getNumber() * viewPort.computeSize(axis);
                            default:
                                var n = this.getNumber();
                                if (processPercent && n < 1.0) return n * viewPort.computeSize(axis);
                                return n;
                        }
                    }
                    getMilliseconds() {
                        if (!this.hasValue()) return 0;
                        if (this.isString(/ms$/)) return this.getNumber();
                        return this.getNumber() * 1000;
                    }
                    getRadians() {
                        if (!this.hasValue()) return 0;
                        switch(true){
                            case this.isString(/deg$/):
                                return this.getNumber() * (Math.PI / 180.0);
                            case this.isString(/grad$/):
                                return this.getNumber() * (Math.PI / 200.0);
                            case this.isString(/rad$/):
                                return this.getNumber();
                            default:
                                return this.getNumber() * (Math.PI / 180.0);
                        }
                    }
                    getDefinition() {
                        var asString = this.getString();
                        var name = /#([^)'"]+)/.exec(asString);
                        if (name) name = name[1];
                        if (!name) name = asString;
                        return this.document.definitions[name];
                    }
                    getFillStyleDefinition(element, opacity) {
                        var def = this.getDefinition();
                        if (!def) return null;
                         // gradient
                        if (typeof def.createGradient === 'function') return def.createGradient(this.document.ctx, element, opacity);
                         // pattern
                        if (typeof def.createPattern === 'function') {
                            if (def.getHrefAttribute().hasValue()) {
                                var patternTransform = def.getAttribute('patternTransform');
                                def = def.getHrefAttribute().getDefinition();
                                if (patternTransform.hasValue()) def.getAttribute('patternTransform', true).setValue(patternTransform.value);
                            }
                            return def.createPattern(this.document.ctx, element, opacity);
                        }
                        return null;
                    }
                    getTextBaseline() {
                        if (!this.hasValue()) return null;
                        return Property.textBaselineMapping[this.getString()];
                    }
                    addOpacity(opacity) {
                        var value = this.getColor();
                        var len = value.length;
                        var commas = 0; // Simulate old RGBColor version, which can't parse rgba.
                        for(var i = 0; i < len; i++){
                            if (value[i] === ',') commas++;
                            if (commas === 3) break;
                        }
                        if (opacity.hasValue() && this.isString() && commas !== 3) {
                            var color = new rgbcolor__WEBPACK_IMPORTED_MODULE_13__(value);
                            if (color.ok) {
                                color.alpha = opacity.getNumber();
                                value = color.toRGBA();
                            }
                        }
                        return new Property(this.document, this.name, value);
                    }
                }
                Property.textBaselineMapping = {
                    'baseline': 'alphabetic',
                    'before-edge': 'top',
                    'text-before-edge': 'top',
                    'middle': 'middle',
                    'central': 'middle',
                    'after-edge': 'bottom',
                    'text-after-edge': 'bottom',
                    'ideographic': 'ideographic',
                    'alphabetic': 'alphabetic',
                    'hanging': 'hanging',
                    'mathematical': 'alphabetic'
                };
                class ViewPort {
                    constructor(){
                        this.viewPorts = [];
                    }
                    clear() {
                        this.viewPorts = [];
                    }
                    setCurrent(width, height) {
                        this.viewPorts.push({
                            width,
                            height
                        });
                    }
                    removeCurrent() {
                        this.viewPorts.pop();
                    }
                    getCurrent() {
                        var { viewPorts } = this;
                        return viewPorts[viewPorts.length - 1];
                    }
                    get width() {
                        return this.getCurrent().width;
                    }
                    get height() {
                        return this.getCurrent().height;
                    }
                    computeSize(d) {
                        if (typeof d === 'number') return d;
                        if (d === 'x') return this.width;
                        if (d === 'y') return this.height;
                        return Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
                    }
                }
                class Point {
                    constructor(x, y){
                        this.x = x;
                        this.y = y;
                    }
                    static parse(point) {
                        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        var [x = defaultValue, y = defaultValue] = toNumbers(point);
                        return new Point(x, y);
                    }
                    static parseScale(scale) {
                        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                        var [x = defaultValue, y = x] = toNumbers(scale);
                        return new Point(x, y);
                    }
                    static parsePath(path) {
                        var points = toNumbers(path);
                        var len = points.length;
                        var pathPoints = [];
                        for(var i = 0; i < len; i += 2)pathPoints.push(new Point(points[i], points[i + 1]));
                        return pathPoints;
                    }
                    angleTo(point) {
                        return Math.atan2(point.y - this.y, point.x - this.x);
                    }
                    applyTransform(transform) {
                        var { x, y } = this;
                        var xp = x * transform[0] + y * transform[2] + transform[4];
                        var yp = x * transform[1] + y * transform[3] + transform[5];
                        this.x = xp;
                        this.y = yp;
                    }
                }
                class Mouse {
                    constructor(screen){
                        this.screen = screen;
                        this.working = false;
                        this.events = [];
                        this.eventElements = []; // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        this.onClick = this.onClick.bind(this); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        this.onMouseMove = this.onMouseMove.bind(this);
                    }
                    isWorking() {
                        return this.working;
                    }
                    start() {
                        if (this.working) return;
                        var { screen, onClick, onMouseMove } = this;
                        var canvas = screen.ctx.canvas;
                        canvas.onclick = onClick;
                        canvas.onmousemove = onMouseMove;
                        this.working = true;
                    }
                    stop() {
                        if (!this.working) return;
                        var canvas = this.screen.ctx.canvas;
                        this.working = false;
                        canvas.onclick = null;
                        canvas.onmousemove = null;
                    }
                    hasEvents() {
                        return this.working && this.events.length > 0;
                    }
                    runEvents() {
                        if (!this.working) return;
                        var { screen: document1, events, eventElements } = this;
                        var { style } = document1.ctx.canvas;
                        if (style) style.cursor = '';
                        events.forEach((_ref, i)=>{
                            var { run } = _ref;
                            var element = eventElements[i];
                            while(element){
                                run(element);
                                element = element.parent;
                            }
                        }); // done running, clear
                        this.events = [];
                        this.eventElements = [];
                    }
                    checkPath(element, ctx) {
                        if (!this.working || !ctx) return;
                        var { events, eventElements } = this;
                        events.forEach((_ref2, i)=>{
                            var { x, y } = _ref2;
                            if (!eventElements[i] && ctx.isPointInPath && ctx.isPointInPath(x, y)) eventElements[i] = element;
                        });
                    }
                    checkBoundingBox(element, boundingBox) {
                        if (!this.working || !boundingBox) return;
                        var { events, eventElements } = this;
                        events.forEach((_ref3, i)=>{
                            var { x, y } = _ref3;
                            if (!eventElements[i] && boundingBox.isPointInBox(x, y)) eventElements[i] = element;
                        });
                    }
                    mapXY(x, y) {
                        var { window: window1, ctx } = this.screen;
                        var point = new Point(x, y);
                        var element = ctx.canvas;
                        while(element){
                            point.x -= element.offsetLeft;
                            point.y -= element.offsetTop;
                            element = element.offsetParent;
                        }
                        if (window1.scrollX) point.x += window1.scrollX;
                        if (window1.scrollY) point.y += window1.scrollY;
                        return point;
                    }
                    onClick(event) {
                        var { x, y } = this.mapXY(event.clientX, event.clientY);
                        this.events.push({
                            type: 'onclick',
                            x,
                            y,
                            run (eventTarget) {
                                if (eventTarget.onClick) eventTarget.onClick();
                            }
                        });
                    }
                    onMouseMove(event) {
                        var { x, y } = this.mapXY(event.clientX, event.clientY);
                        this.events.push({
                            type: 'onmousemove',
                            x,
                            y,
                            run (eventTarget) {
                                if (eventTarget.onMouseMove) eventTarget.onMouseMove();
                            }
                        });
                    }
                }
                var defaultWindow = typeof window !== 'undefined' ? window : null;
                var defaultFetch$1 = typeof fetch !== 'undefined' ? fetch.bind(undefined) // `fetch` depends on context: `someObject.fetch(...)` will throw error.
                 : null;
                class Screen {
                    constructor(ctx){
                        var { fetch: fetch1 = defaultFetch$1, window: window1 = defaultWindow } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        this.ctx = ctx;
                        this.FRAMERATE = 30;
                        this.MAX_VIRTUAL_PIXELS = 30000;
                        this.CLIENT_WIDTH = 800;
                        this.CLIENT_HEIGHT = 600;
                        this.viewPort = new ViewPort();
                        this.mouse = new Mouse(this);
                        this.animations = [];
                        this.waits = [];
                        this.frameDuration = 0;
                        this.isReadyLock = false;
                        this.isFirstRender = true;
                        this.intervalId = null;
                        this.window = window1;
                        this.fetch = fetch1;
                    }
                    wait(checker) {
                        this.waits.push(checker);
                    }
                    ready() {
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        if (!this.readyPromise) return Promise.resolve();
                        return this.readyPromise;
                    }
                    isReady() {
                        if (this.isReadyLock) return true;
                        var isReadyLock = this.waits.every((_)=>_());
                        if (isReadyLock) {
                            this.waits = [];
                            if (this.resolveReady) this.resolveReady();
                        }
                        this.isReadyLock = isReadyLock;
                        return isReadyLock;
                    }
                    setDefaults(ctx) {
                        // initial values and defaults
                        ctx.strokeStyle = 'rgba(0,0,0,0)';
                        ctx.lineCap = 'butt';
                        ctx.lineJoin = 'miter';
                        ctx.miterLimit = 4;
                    }
                    setViewBox(_ref) {
                        var { document: document1, ctx, aspectRatio, width, desiredWidth, height, desiredHeight, minX = 0, minY = 0, refX, refY, clip = false, clipX = 0, clipY = 0 } = _ref;
                        // aspect ratio - http://www.w3.org/TR/SVG/coords.html#PreserveAspectRatioAttribute
                        var cleanAspectRatio = compressSpaces(aspectRatio).replace(/^defer\s/, ''); // ignore defer
                        var [aspectRatioAlign, aspectRatioMeetOrSlice] = cleanAspectRatio.split(' ');
                        var align = aspectRatioAlign || 'xMidYMid';
                        var meetOrSlice = aspectRatioMeetOrSlice || 'meet'; // calculate scale
                        var scaleX = width / desiredWidth;
                        var scaleY = height / desiredHeight;
                        var scaleMin = Math.min(scaleX, scaleY);
                        var scaleMax = Math.max(scaleX, scaleY);
                        var finalDesiredWidth = desiredWidth;
                        var finalDesiredHeight = desiredHeight;
                        if (meetOrSlice === 'meet') {
                            finalDesiredWidth *= scaleMin;
                            finalDesiredHeight *= scaleMin;
                        }
                        if (meetOrSlice === 'slice') {
                            finalDesiredWidth *= scaleMax;
                            finalDesiredHeight *= scaleMax;
                        }
                        var refXProp = new Property(document1, 'refX', refX);
                        var refYProp = new Property(document1, 'refY', refY);
                        var hasRefs = refXProp.hasValue() && refYProp.hasValue();
                        if (hasRefs) ctx.translate(-scaleMin * refXProp.getPixels('x'), -scaleMin * refYProp.getPixels('y'));
                        if (clip) {
                            var scaledClipX = scaleMin * clipX;
                            var scaledClipY = scaleMin * clipY;
                            ctx.beginPath();
                            ctx.moveTo(scaledClipX, scaledClipY);
                            ctx.lineTo(width, scaledClipY);
                            ctx.lineTo(width, height);
                            ctx.lineTo(scaledClipX, height);
                            ctx.closePath();
                            ctx.clip();
                        }
                        if (!hasRefs) {
                            var isMeetMinY = meetOrSlice === 'meet' && scaleMin === scaleY;
                            var isSliceMaxY = meetOrSlice === 'slice' && scaleMax === scaleY;
                            var isMeetMinX = meetOrSlice === 'meet' && scaleMin === scaleX;
                            var isSliceMaxX = meetOrSlice === 'slice' && scaleMax === scaleX;
                            if (align.startsWith('xMid') && (isMeetMinY || isSliceMaxY)) ctx.translate(width / 2.0 - finalDesiredWidth / 2.0, 0);
                            if (align.endsWith('YMid') && (isMeetMinX || isSliceMaxX)) ctx.translate(0, height / 2.0 - finalDesiredHeight / 2.0);
                            if (align.startsWith('xMax') && (isMeetMinY || isSliceMaxY)) ctx.translate(width - finalDesiredWidth, 0);
                            if (align.endsWith('YMax') && (isMeetMinX || isSliceMaxX)) ctx.translate(0, height - finalDesiredHeight);
                        } // scale
                        switch(true){
                            case align === 'none':
                                ctx.scale(scaleX, scaleY);
                                break;
                            case meetOrSlice === 'meet':
                                ctx.scale(scaleMin, scaleMin);
                                break;
                            case meetOrSlice === 'slice':
                                ctx.scale(scaleMax, scaleMax);
                                break;
                        } // translate
                        ctx.translate(-minX, -minY);
                    }
                    start(element) {
                        var { enableRedraw = false, ignoreMouse = false, ignoreAnimation = false, ignoreDimensions = false, ignoreClear = false, forceRedraw, scaleWidth, scaleHeight, offsetX, offsetY } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var { FRAMERATE, mouse } = this;
                        var frameDuration = 1000 / FRAMERATE;
                        this.frameDuration = frameDuration;
                        this.readyPromise = new Promise((resolve)=>{
                            this.resolveReady = resolve;
                        });
                        if (this.isReady()) this.render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
                        if (!enableRedraw) return;
                        var now = Date.now();
                        var then = now;
                        var delta = 0;
                        var tick = ()=>{
                            now = Date.now();
                            delta = now - then;
                            if (delta >= frameDuration) {
                                then = now - delta % frameDuration;
                                if (this.shouldUpdate(ignoreAnimation, forceRedraw)) {
                                    this.render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
                                    mouse.runEvents();
                                }
                            }
                            this.intervalId = raf__WEBPACK_IMPORTED_MODULE_11__(tick);
                        };
                        if (!ignoreMouse) mouse.start();
                        this.intervalId = raf__WEBPACK_IMPORTED_MODULE_11__(tick);
                    }
                    stop() {
                        if (this.intervalId) {
                            raf__WEBPACK_IMPORTED_MODULE_11__.cancel(this.intervalId);
                            this.intervalId = null;
                        }
                        this.mouse.stop();
                    }
                    shouldUpdate(ignoreAnimation, forceRedraw) {
                        // need update from animations?
                        if (!ignoreAnimation) {
                            var { frameDuration } = this;
                            var shouldUpdate = this.animations.reduce((shouldUpdate, animation)=>animation.update(frameDuration) || shouldUpdate, false);
                            if (shouldUpdate) return true;
                        } // need update from redraw?
                        if (typeof forceRedraw === 'function' && forceRedraw()) return true;
                        if (!this.isReadyLock && this.isReady()) return true;
                         // need update from mouse events?
                        if (this.mouse.hasEvents()) return true;
                        return false;
                    }
                    render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY) {
                        var { CLIENT_WIDTH, CLIENT_HEIGHT, viewPort, ctx, isFirstRender } = this;
                        var canvas = ctx.canvas;
                        viewPort.clear();
                        if (canvas.width && canvas.height) viewPort.setCurrent(canvas.width, canvas.height);
                        else viewPort.setCurrent(CLIENT_WIDTH, CLIENT_HEIGHT);
                        var widthStyle = element.getStyle('width');
                        var heightStyle = element.getStyle('height');
                        if (!ignoreDimensions && (isFirstRender || typeof scaleWidth !== 'number' && typeof scaleHeight !== 'number')) {
                            // set canvas size
                            if (widthStyle.hasValue()) {
                                canvas.width = widthStyle.getPixels('x');
                                if (canvas.style) canvas.style.width = "".concat(canvas.width, "px");
                            }
                            if (heightStyle.hasValue()) {
                                canvas.height = heightStyle.getPixels('y');
                                if (canvas.style) canvas.style.height = "".concat(canvas.height, "px");
                            }
                        }
                        var cWidth = canvas.clientWidth || canvas.width;
                        var cHeight = canvas.clientHeight || canvas.height;
                        if (ignoreDimensions && widthStyle.hasValue() && heightStyle.hasValue()) {
                            cWidth = widthStyle.getPixels('x');
                            cHeight = heightStyle.getPixels('y');
                        }
                        viewPort.setCurrent(cWidth, cHeight);
                        if (typeof offsetX === 'number') element.getAttribute('x', true).setValue(offsetX);
                        if (typeof offsetY === 'number') element.getAttribute('y', true).setValue(offsetY);
                        if (typeof scaleWidth === 'number' || typeof scaleHeight === 'number') {
                            var viewBox = toNumbers(element.getAttribute('viewBox').getString());
                            var xRatio = 0;
                            var yRatio = 0;
                            if (typeof scaleWidth === 'number') {
                                var _widthStyle = element.getStyle('width');
                                if (_widthStyle.hasValue()) xRatio = _widthStyle.getPixels('x') / scaleWidth;
                                else if (!isNaN(viewBox[2])) xRatio = viewBox[2] / scaleWidth;
                            }
                            if (typeof scaleHeight === 'number') {
                                var _heightStyle = element.getStyle('height');
                                if (_heightStyle.hasValue()) yRatio = _heightStyle.getPixels('y') / scaleHeight;
                                else if (!isNaN(viewBox[3])) yRatio = viewBox[3] / scaleHeight;
                            }
                            if (!xRatio) xRatio = yRatio;
                            if (!yRatio) yRatio = xRatio;
                            element.getAttribute('width', true).setValue(scaleWidth);
                            element.getAttribute('height', true).setValue(scaleHeight);
                            var transformStyle = element.getStyle('transform', true, true);
                            transformStyle.setValue("".concat(transformStyle.getString(), " scale(").concat(1.0 / xRatio, ", ").concat(1.0 / yRatio, ")"));
                        } // clear and render
                        if (!ignoreClear) ctx.clearRect(0, 0, cWidth, cHeight);
                        element.render(ctx);
                        if (isFirstRender) this.isFirstRender = false;
                    }
                }
                Screen.defaultWindow = defaultWindow;
                Screen.defaultFetch = defaultFetch$1;
                var { defaultFetch } = Screen;
                var DefaultDOMParser = typeof DOMParser !== 'undefined' ? DOMParser : null;
                class Parser {
                    constructor(){
                        var { fetch: fetch1 = defaultFetch, DOMParser: DOMParser1 = DefaultDOMParser } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        this.fetch = fetch1;
                        this.DOMParser = DOMParser1;
                    }
                    parse(resource) {
                        var _this = this;
                        return (0, _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function*() {
                            if (resource.startsWith('<')) return _this.parseFromString(resource);
                            return _this.load(resource);
                        })();
                    }
                    parseFromString(xml) {
                        var parser = new this.DOMParser();
                        try {
                            return this.checkDocument(parser.parseFromString(xml, 'image/svg+xml'));
                        } catch (err) {
                            return this.checkDocument(parser.parseFromString(xml, 'text/xml'));
                        }
                    }
                    checkDocument(document1) {
                        var parserError = document1.getElementsByTagName('parsererror')[0];
                        if (parserError) throw new Error(parserError.textContent);
                        return document1;
                    }
                    load(url) {
                        var _this2 = this;
                        return (0, _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function*() {
                            var response = yield _this2.fetch(url);
                            var xml = yield response.text();
                            return _this2.parseFromString(xml);
                        })();
                    }
                }
                class Translate {
                    constructor(_, point){
                        this.type = 'translate';
                        this.point = null;
                        this.point = Point.parse(point);
                    }
                    apply(ctx) {
                        var { x, y } = this.point;
                        ctx.translate(x || 0.0, y || 0.0);
                    }
                    unapply(ctx) {
                        var { x, y } = this.point;
                        ctx.translate(-1 * x || 0.0, -1 * y || 0.0);
                    }
                    applyToPoint(point) {
                        var { x, y } = this.point;
                        point.applyTransform([
                            1,
                            0,
                            0,
                            1,
                            x || 0.0,
                            y || 0.0
                        ]);
                    }
                }
                class Rotate {
                    constructor(document1, rotate, transformOrigin){
                        this.type = 'rotate';
                        this.angle = null;
                        this.originX = null;
                        this.originY = null;
                        this.cx = 0;
                        this.cy = 0;
                        var numbers = toNumbers(rotate);
                        this.angle = new Property(document1, 'angle', numbers[0]);
                        this.originX = transformOrigin[0];
                        this.originY = transformOrigin[1];
                        this.cx = numbers[1] || 0;
                        this.cy = numbers[2] || 0;
                    }
                    apply(ctx) {
                        var { cx, cy, originX, originY, angle } = this;
                        var tx = cx + originX.getPixels('x');
                        var ty = cy + originY.getPixels('y');
                        ctx.translate(tx, ty);
                        ctx.rotate(angle.getRadians());
                        ctx.translate(-tx, -ty);
                    }
                    unapply(ctx) {
                        var { cx, cy, originX, originY, angle } = this;
                        var tx = cx + originX.getPixels('x');
                        var ty = cy + originY.getPixels('y');
                        ctx.translate(tx, ty);
                        ctx.rotate(-1 * angle.getRadians());
                        ctx.translate(-tx, -ty);
                    }
                    applyToPoint(point) {
                        var { cx, cy, angle } = this;
                        var rad = angle.getRadians();
                        point.applyTransform([
                            1,
                            0,
                            0,
                            1,
                            cx || 0.0,
                            cy || 0.0 // this.p.y
                        ]);
                        point.applyTransform([
                            Math.cos(rad),
                            Math.sin(rad),
                            -Math.sin(rad),
                            Math.cos(rad),
                            0,
                            0
                        ]);
                        point.applyTransform([
                            1,
                            0,
                            0,
                            1,
                            -cx || 0.0,
                            -cy || 0.0 // -this.p.y
                        ]);
                    }
                }
                class Scale {
                    constructor(_, scale, transformOrigin){
                        this.type = 'scale';
                        this.scale = null;
                        this.originX = null;
                        this.originY = null;
                        var scaleSize = Point.parseScale(scale); // Workaround for node-canvas
                        if (scaleSize.x === 0 || scaleSize.y === 0) {
                            scaleSize.x = PSEUDO_ZERO;
                            scaleSize.y = PSEUDO_ZERO;
                        }
                        this.scale = scaleSize;
                        this.originX = transformOrigin[0];
                        this.originY = transformOrigin[1];
                    }
                    apply(ctx) {
                        var { scale: { x, y }, originX, originY } = this;
                        var tx = originX.getPixels('x');
                        var ty = originY.getPixels('y');
                        ctx.translate(tx, ty);
                        ctx.scale(x, y || x);
                        ctx.translate(-tx, -ty);
                    }
                    unapply(ctx) {
                        var { scale: { x, y }, originX, originY } = this;
                        var tx = originX.getPixels('x');
                        var ty = originY.getPixels('y');
                        ctx.translate(tx, ty);
                        ctx.scale(1.0 / x, 1.0 / y || x);
                        ctx.translate(-tx, -ty);
                    }
                    applyToPoint(point) {
                        var { x, y } = this.scale;
                        point.applyTransform([
                            x || 0.0,
                            0,
                            0,
                            y || 0.0,
                            0,
                            0
                        ]);
                    }
                }
                class Matrix {
                    constructor(_, matrix, transformOrigin){
                        this.type = 'matrix';
                        this.matrix = [];
                        this.originX = null;
                        this.originY = null;
                        this.matrix = toNumbers(matrix);
                        this.originX = transformOrigin[0];
                        this.originY = transformOrigin[1];
                    }
                    apply(ctx) {
                        var { originX, originY, matrix } = this;
                        var tx = originX.getPixels('x');
                        var ty = originY.getPixels('y');
                        ctx.translate(tx, ty);
                        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                        ctx.translate(-tx, -ty);
                    }
                    unapply(ctx) {
                        var { originX, originY, matrix } = this;
                        var a = matrix[0];
                        var b = matrix[2];
                        var c = matrix[4];
                        var d = matrix[1];
                        var e = matrix[3];
                        var f = matrix[5];
                        var g = 0.0;
                        var h = 0.0;
                        var i = 1.0;
                        var det = 1 / (a * (e * i - f * h) - b * (d * i - f * g) + c * (d * h - e * g));
                        var tx = originX.getPixels('x');
                        var ty = originY.getPixels('y');
                        ctx.translate(tx, ty);
                        ctx.transform(det * (e * i - f * h), det * (f * g - d * i), det * (c * h - b * i), det * (a * i - c * g), det * (b * f - c * e), det * (c * d - a * f));
                        ctx.translate(-tx, -ty);
                    }
                    applyToPoint(point) {
                        point.applyTransform(this.matrix);
                    }
                }
                class Skew extends Matrix {
                    constructor(document1, skew, transformOrigin){
                        super(document1, skew, transformOrigin);
                        this.type = 'skew';
                        this.angle = null;
                        this.angle = new Property(document1, 'angle', skew);
                    }
                }
                class SkewX extends Skew {
                    constructor(document1, skew, transformOrigin){
                        super(document1, skew, transformOrigin);
                        this.type = 'skewX';
                        this.matrix = [
                            1,
                            0,
                            Math.tan(this.angle.getRadians()),
                            1,
                            0,
                            0
                        ];
                    }
                }
                class SkewY extends Skew {
                    constructor(document1, skew, transformOrigin){
                        super(document1, skew, transformOrigin);
                        this.type = 'skewY';
                        this.matrix = [
                            1,
                            Math.tan(this.angle.getRadians()),
                            0,
                            1,
                            0,
                            0
                        ];
                    }
                }
                function parseTransforms(transform) {
                    return compressSpaces(transform).trim().replace(/\)([a-zA-Z])/g, ') $1').replace(/\)(\s?,\s?)/g, ') ').split(/\s(?=[a-z])/);
                }
                function parseTransform(transform) {
                    var [type, value] = transform.split('(');
                    return [
                        type.trim(),
                        value.trim().replace(')', '')
                    ];
                }
                class Transform {
                    constructor(document1, transform, transformOrigin){
                        this.document = document1;
                        this.transforms = [];
                        var data = parseTransforms(transform);
                        data.forEach((transform)=>{
                            if (transform === 'none') return;
                            var [type, value] = parseTransform(transform);
                            var TransformType = Transform.transformTypes[type];
                            if (typeof TransformType !== 'undefined') this.transforms.push(new TransformType(this.document, value, transformOrigin));
                        });
                    }
                    static fromElement(document1, element) {
                        var transformStyle = element.getStyle('transform', false, true);
                        var [transformOriginXProperty, transformOriginYProperty = transformOriginXProperty] = element.getStyle('transform-origin', false, true).split();
                        var transformOrigin = [
                            transformOriginXProperty,
                            transformOriginYProperty
                        ];
                        if (transformStyle.hasValue()) return new Transform(document1, transformStyle.getString(), transformOrigin);
                        return null;
                    }
                    apply(ctx) {
                        var { transforms } = this;
                        var len = transforms.length;
                        for(var i = 0; i < len; i++)transforms[i].apply(ctx);
                    }
                    unapply(ctx) {
                        var { transforms } = this;
                        var len = transforms.length;
                        for(var i = len - 1; i >= 0; i--)transforms[i].unapply(ctx);
                    }
                    applyToPoint(point) {
                        var { transforms } = this;
                        var len = transforms.length;
                        for(var i = 0; i < len; i++)transforms[i].applyToPoint(point);
                    }
                }
                Transform.transformTypes = {
                    translate: Translate,
                    rotate: Rotate,
                    scale: Scale,
                    matrix: Matrix,
                    skewX: SkewX,
                    skewY: SkewY
                };
                class Element {
                    constructor(document1, node){
                        var captureTextNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        this.document = document1;
                        this.node = node;
                        this.captureTextNodes = captureTextNodes;
                        this.attributes = Object.create(null);
                        this.styles = Object.create(null);
                        this.stylesSpecificity = Object.create(null);
                        this.animationFrozen = false;
                        this.animationFrozenValue = '';
                        this.parent = null;
                        this.children = [];
                        if (!node || node.nodeType !== 1) // ELEMENT_NODE
                        return;
                         // add attributes
                        Array.from(node.attributes).forEach((attribute)=>{
                            var nodeName = normalizeAttributeName(attribute.nodeName);
                            this.attributes[nodeName] = new Property(document1, nodeName, attribute.value);
                        });
                        this.addStylesFromStyleDefinition(); // add inline styles
                        if (this.getAttribute('style').hasValue()) {
                            var styles = this.getAttribute('style').getString().split(';').map((_)=>_.trim());
                            styles.forEach((style)=>{
                                if (!style) return;
                                var [name, value] = style.split(':').map((_)=>_.trim());
                                this.styles[name] = new Property(document1, name, value);
                            });
                        }
                        var { definitions } = document1;
                        var id = this.getAttribute('id'); // add id
                        if (id.hasValue()) {
                            if (!definitions[id.getString()]) definitions[id.getString()] = this;
                        }
                        Array.from(node.childNodes).forEach((childNode)=>{
                            if (childNode.nodeType === 1) this.addChild(childNode); // ELEMENT_NODE
                            else if (captureTextNodes && (childNode.nodeType === 3 || childNode.nodeType === 4)) {
                                var textNode = document1.createTextNode(childNode);
                                if (textNode.getText().length > 0) this.addChild(textNode); // TEXT_NODE
                            }
                        });
                    }
                    getAttribute(name) {
                        var createIfNotExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        var attr = this.attributes[name];
                        if (!attr && createIfNotExists) {
                            var _attr = new Property(this.document, name, '');
                            this.attributes[name] = _attr;
                            return _attr;
                        }
                        return attr || Property.empty(this.document);
                    }
                    getHrefAttribute() {
                        for(var key in this.attributes){
                            if (key === 'href' || key.endsWith(':href')) return this.attributes[key];
                        }
                        return Property.empty(this.document);
                    }
                    getStyle(name) {
                        var createIfNotExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        var skipAncestors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var style = this.styles[name];
                        if (style) return style;
                        var attr = this.getAttribute(name);
                        if (attr !== null && attr !== void 0 && attr.hasValue()) {
                            this.styles[name] = attr; // move up to me to cache
                            return attr;
                        }
                        if (!skipAncestors) {
                            var { parent } = this;
                            if (parent) {
                                var parentStyle = parent.getStyle(name);
                                if (parentStyle !== null && parentStyle !== void 0 && parentStyle.hasValue()) return parentStyle;
                            }
                        }
                        if (createIfNotExists) {
                            var _style = new Property(this.document, name, '');
                            this.styles[name] = _style;
                            return _style;
                        }
                        return style || Property.empty(this.document);
                    }
                    render(ctx) {
                        // don't render display=none
                        // don't render visibility=hidden
                        if (this.getStyle('display').getString() === 'none' || this.getStyle('visibility').getString() === 'hidden') return;
                        ctx.save();
                        if (this.getStyle('mask').hasValue()) {
                            // mask
                            var mask = this.getStyle('mask').getDefinition();
                            if (mask) {
                                this.applyEffects(ctx);
                                mask.apply(ctx, this);
                            }
                        } else if (this.getStyle('filter').getValue('none') !== 'none') {
                            // filter
                            var filter = this.getStyle('filter').getDefinition();
                            if (filter) {
                                this.applyEffects(ctx);
                                filter.apply(ctx, this);
                            }
                        } else {
                            this.setContext(ctx);
                            this.renderChildren(ctx);
                            this.clearContext(ctx);
                        }
                        ctx.restore();
                    }
                    setContext(_) {}
                    applyEffects(ctx) {
                        // transform
                        var transform = Transform.fromElement(this.document, this);
                        if (transform) transform.apply(ctx);
                         // clip
                        var clipPathStyleProp = this.getStyle('clip-path', false, true);
                        if (clipPathStyleProp.hasValue()) {
                            var clip = clipPathStyleProp.getDefinition();
                            if (clip) clip.apply(ctx);
                        }
                    }
                    clearContext(_) {}
                    renderChildren(ctx) {
                        this.children.forEach((child)=>{
                            child.render(ctx);
                        });
                    }
                    addChild(childNode) {
                        var child = childNode instanceof Element ? childNode : this.document.createElement(childNode);
                        child.parent = this;
                        if (!Element.ignoreChildTypes.includes(child.type)) this.children.push(child);
                    }
                    matchesSelector(selector) {
                        var _node$getAttribute;
                        var { node } = this;
                        if (typeof node.matches === 'function') return node.matches(selector);
                        var styleClasses = (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'class');
                        if (!styleClasses || styleClasses === '') return false;
                        return styleClasses.split(' ').some((styleClass)=>".".concat(styleClass) === selector);
                    }
                    addStylesFromStyleDefinition() {
                        var { styles, stylesSpecificity } = this.document;
                        for(var selector in styles)if (!selector.startsWith('@') && this.matchesSelector(selector)) {
                            var style = styles[selector];
                            var specificity = stylesSpecificity[selector];
                            if (style) for(var name in style){
                                var existingSpecificity = this.stylesSpecificity[name];
                                if (typeof existingSpecificity === 'undefined') existingSpecificity = '000';
                                if (specificity >= existingSpecificity) {
                                    this.styles[name] = style[name];
                                    this.stylesSpecificity[name] = specificity;
                                }
                            }
                        }
                    }
                    removeStyles(element, ignoreStyles) {
                        var toRestore = ignoreStyles.reduce((toRestore, name)=>{
                            var styleProp = element.getStyle(name);
                            if (!styleProp.hasValue()) return toRestore;
                            var value = styleProp.getString();
                            styleProp.setValue('');
                            return [
                                ...toRestore,
                                [
                                    name,
                                    value
                                ]
                            ];
                        }, []);
                        return toRestore;
                    }
                    restoreStyles(element, styles) {
                        styles.forEach((_ref)=>{
                            var [name, value] = _ref;
                            element.getStyle(name, true).setValue(value);
                        });
                    }
                    isFirstChild() {
                        var _this$parent;
                        return ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.children.indexOf(this)) === 0;
                    }
                }
                Element.ignoreChildTypes = [
                    'title'
                ];
                class UnknownElement extends Element {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                    }
                }
                function wrapFontFamily(fontFamily) {
                    var trimmed = fontFamily.trim();
                    return /^('|")/.test(trimmed) ? trimmed : "\"".concat(trimmed, "\"");
                }
                function prepareFontFamily(fontFamily) {
                    return fontFamily;
                }
                /**
 * https://developer.mozilla.org/en-US/docs/Web/CSS/font-style
 * @param fontStyle
 * @returns CSS font style.
 */ function prepareFontStyle(fontStyle) {
                    if (!fontStyle) return '';
                    var targetFontStyle = fontStyle.trim().toLowerCase();
                    switch(targetFontStyle){
                        case 'normal':
                        case 'italic':
                        case 'oblique':
                        case 'inherit':
                        case 'initial':
                        case 'unset':
                            return targetFontStyle;
                        default:
                            if (/^oblique\s+(-|)\d+deg$/.test(targetFontStyle)) return targetFontStyle;
                            return '';
                    }
                }
                /**
 * https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
 * @param fontWeight
 * @returns CSS font weight.
 */ function prepareFontWeight(fontWeight) {
                    if (!fontWeight) return '';
                    var targetFontWeight = fontWeight.trim().toLowerCase();
                    switch(targetFontWeight){
                        case 'normal':
                        case 'bold':
                        case 'lighter':
                        case 'bolder':
                        case 'inherit':
                        case 'initial':
                        case 'unset':
                            return targetFontWeight;
                        default:
                            if (/^[\d.]+$/.test(targetFontWeight)) return targetFontWeight;
                            return '';
                    }
                }
                class Font {
                    constructor(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit){
                        var inheritFont = inherit ? typeof inherit === 'string' ? Font.parse(inherit) : inherit : {};
                        this.fontFamily = fontFamily || inheritFont.fontFamily;
                        this.fontSize = fontSize || inheritFont.fontSize;
                        this.fontStyle = fontStyle || inheritFont.fontStyle;
                        this.fontWeight = fontWeight || inheritFont.fontWeight;
                        this.fontVariant = fontVariant || inheritFont.fontVariant;
                    }
                    static parse() {
                        var font = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                        var inherit = arguments.length > 1 ? arguments[1] : undefined;
                        var fontStyle = '';
                        var fontVariant = '';
                        var fontWeight = '';
                        var fontSize = '';
                        var fontFamily = '';
                        var parts = compressSpaces(font).trim().split(' ');
                        var set = {
                            fontSize: false,
                            fontStyle: false,
                            fontWeight: false,
                            fontVariant: false
                        };
                        parts.forEach((part)=>{
                            switch(true){
                                case !set.fontStyle && Font.styles.includes(part):
                                    if (part !== 'inherit') fontStyle = part;
                                    set.fontStyle = true;
                                    break;
                                case !set.fontVariant && Font.variants.includes(part):
                                    if (part !== 'inherit') fontVariant = part;
                                    set.fontStyle = true;
                                    set.fontVariant = true;
                                    break;
                                case !set.fontWeight && Font.weights.includes(part):
                                    if (part !== 'inherit') fontWeight = part;
                                    set.fontStyle = true;
                                    set.fontVariant = true;
                                    set.fontWeight = true;
                                    break;
                                case !set.fontSize:
                                    if (part !== 'inherit') [fontSize] = part.split('/');
                                    set.fontStyle = true;
                                    set.fontVariant = true;
                                    set.fontWeight = true;
                                    set.fontSize = true;
                                    break;
                                default:
                                    if (part !== 'inherit') fontFamily += part;
                            }
                        });
                        return new Font(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit);
                    }
                    toString() {
                        return [
                            prepareFontStyle(this.fontStyle),
                            this.fontVariant,
                            prepareFontWeight(this.fontWeight),
                            this.fontSize,
                            prepareFontFamily(this.fontFamily)
                        ].join(' ').trim();
                    }
                }
                Font.styles = 'normal|italic|oblique|inherit';
                Font.variants = 'normal|small-caps|inherit';
                Font.weights = 'normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit';
                class BoundingBox {
                    constructor(){
                        var x1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.NaN;
                        var y1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.NaN;
                        var x2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.NaN;
                        var y2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Number.NaN;
                        this.x1 = x1;
                        this.y1 = y1;
                        this.x2 = x2;
                        this.y2 = y2;
                        this.addPoint(x1, y1);
                        this.addPoint(x2, y2);
                    }
                    get x() {
                        return this.x1;
                    }
                    get y() {
                        return this.y1;
                    }
                    get width() {
                        return this.x2 - this.x1;
                    }
                    get height() {
                        return this.y2 - this.y1;
                    }
                    addPoint(x, y) {
                        if (typeof x !== 'undefined') {
                            if (isNaN(this.x1) || isNaN(this.x2)) {
                                this.x1 = x;
                                this.x2 = x;
                            }
                            if (x < this.x1) this.x1 = x;
                            if (x > this.x2) this.x2 = x;
                        }
                        if (typeof y !== 'undefined') {
                            if (isNaN(this.y1) || isNaN(this.y2)) {
                                this.y1 = y;
                                this.y2 = y;
                            }
                            if (y < this.y1) this.y1 = y;
                            if (y > this.y2) this.y2 = y;
                        }
                    }
                    addX(x) {
                        this.addPoint(x, null);
                    }
                    addY(y) {
                        this.addPoint(null, y);
                    }
                    addBoundingBox(boundingBox) {
                        if (!boundingBox) return;
                        var { x1, y1, x2, y2 } = boundingBox;
                        this.addPoint(x1, y1);
                        this.addPoint(x2, y2);
                    }
                    sumCubic(t, p0, p1, p2, p3) {
                        return Math.pow(1 - t, 3) * p0 + 3 * Math.pow(1 - t, 2) * t * p1 + 3 * (1 - t) * Math.pow(t, 2) * p2 + Math.pow(t, 3) * p3;
                    }
                    bezierCurveAdd(forX, p0, p1, p2, p3) {
                        var b = 6 * p0 - 12 * p1 + 6 * p2;
                        var a = -3 * p0 + 9 * p1 - 9 * p2 + 3 * p3;
                        var c = 3 * p1 - 3 * p0;
                        if (a === 0) {
                            if (b === 0) return;
                            var t = -c / b;
                            if (0 < t && t < 1) {
                                if (forX) this.addX(this.sumCubic(t, p0, p1, p2, p3));
                                else this.addY(this.sumCubic(t, p0, p1, p2, p3));
                            }
                            return;
                        }
                        var b2ac = Math.pow(b, 2) - 4 * c * a;
                        if (b2ac < 0) return;
                        var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                        if (0 < t1 && t1 < 1) {
                            if (forX) this.addX(this.sumCubic(t1, p0, p1, p2, p3));
                            else this.addY(this.sumCubic(t1, p0, p1, p2, p3));
                        }
                        var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                        if (0 < t2 && t2 < 1) {
                            if (forX) this.addX(this.sumCubic(t2, p0, p1, p2, p3));
                            else this.addY(this.sumCubic(t2, p0, p1, p2, p3));
                        }
                    }
                    addBezierCurve(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
                        this.addPoint(p0x, p0y);
                        this.addPoint(p3x, p3y);
                        this.bezierCurveAdd(true, p0x, p1x, p2x, p3x);
                        this.bezierCurveAdd(false, p0y, p1y, p2y, p3y);
                    }
                    addQuadraticCurve(p0x, p0y, p1x, p1y, p2x, p2y) {
                        var cp1x = p0x + 2 / 3 * (p1x - p0x); // CP1 = QP0 + 2/3 *(QP1-QP0)
                        var cp1y = p0y + 2 / 3 * (p1y - p0y); // CP1 = QP0 + 2/3 *(QP1-QP0)
                        var cp2x = cp1x + 1 / 3 * (p2x - p0x); // CP2 = CP1 + 1/3 *(QP2-QP0)
                        var cp2y = cp1y + 1 / 3 * (p2y - p0y); // CP2 = CP1 + 1/3 *(QP2-QP0)
                        this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
                    }
                    isPointInBox(x, y) {
                        var { x1, y1, x2, y2 } = this;
                        return x1 <= x && x <= x2 && y1 <= y && y <= y2;
                    }
                }
                class PathParser extends svg_pathdata__WEBPACK_IMPORTED_MODULE_17__.SVGPathData {
                    constructor(path){
                        super(path // Fix spaces after signs.
                        .replace(/([+\-.])\s+/gm, '$1') // Remove invalid part.
                        .replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, ''));
                        this.control = null;
                        this.start = null;
                        this.current = null;
                        this.command = null;
                        this.commands = this.commands;
                        this.i = -1;
                        this.previousCommand = null;
                        this.points = [];
                        this.angles = [];
                    }
                    reset() {
                        this.i = -1;
                        this.command = null;
                        this.previousCommand = null;
                        this.start = new Point(0, 0);
                        this.control = new Point(0, 0);
                        this.current = new Point(0, 0);
                        this.points = [];
                        this.angles = [];
                    }
                    isEnd() {
                        var { i, commands } = this;
                        return i >= commands.length - 1;
                    }
                    next() {
                        var command = this.commands[++this.i];
                        this.previousCommand = this.command;
                        this.command = command;
                        return command;
                    }
                    getPoint() {
                        var xProp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'x';
                        var yProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'y';
                        var point = new Point(this.command[xProp], this.command[yProp]);
                        return this.makeAbsolute(point);
                    }
                    getAsControlPoint(xProp, yProp) {
                        var point = this.getPoint(xProp, yProp);
                        this.control = point;
                        return point;
                    }
                    getAsCurrentPoint(xProp, yProp) {
                        var point = this.getPoint(xProp, yProp);
                        this.current = point;
                        return point;
                    }
                    getReflectedControlPoint() {
                        var previousCommand = this.previousCommand.type;
                        if (previousCommand !== svg_pathdata__WEBPACK_IMPORTED_MODULE_17__.SVGPathData.CURVE_TO && previousCommand !== svg_pathdata__WEBPACK_IMPORTED_MODULE_17__.SVGPathData.SMOOTH_CURVE_TO && previousCommand !== svg_pathdata__WEBPACK_IMPORTED_MODULE_17__.SVGPathData.QUAD_TO && previousCommand !== svg_pathdata__WEBPACK_IMPORTED_MODULE_17__.SVGPathData.SMOOTH_QUAD_TO) return this.current;
                         // reflect point
                        var { current: { x: cx, y: cy }, control: { x: ox, y: oy } } = this;
                        var point = new Point(2 * cx - ox, 2 * cy - oy);
                        return point;
                    }
                    makeAbsolute(point) {
                        if (this.command.relative) {
                            var { x, y } = this.current;
                            point.x += x;
                            point.y += y;
                        }
                        return point;
                    }
                    addMarker(point, from, priorTo) {
                        var { points, angles } = this; // if the last angle isn't filled in because we didn't have this point yet ...
                        if (priorTo && angles.length > 0 && !angles[angles.length - 1]) angles[angles.length - 1] = points[points.length - 1].angleTo(priorTo);
                        this.addMarkerAngle(point, from ? from.angleTo(point) : null);
                    }
                    addMarkerAngle(point, angle) {
                        this.points.push(point);
                        this.angles.push(angle);
                    }
                    getMarkerPoints() {
                        return this.points;
                    }
                    getMarkerAngles() {
                        var { angles } = this;
                        var len = angles.length;
                        for(var i = 0; i < len; i++)if (!angles[i]) {
                            for(var j = i + 1; j < len; j++)if (angles[j]) {
                                angles[i] = angles[j];
                                break;
                            }
                        }
                        return angles;
                    }
                }
                class RenderedElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.modifiedEmSizeStack = false;
                    }
                    calculateOpacity() {
                        var opacity = 1.0; // eslint-disable-next-line @typescript-eslint/no-this-alias, consistent-this
                        var element = this;
                        while(element){
                            var opacityStyle = element.getStyle('opacity', false, true); // no ancestors on style call
                            if (opacityStyle.hasValue(true)) opacity *= opacityStyle.getNumber();
                            element = element.parent;
                        }
                        return opacity;
                    }
                    setContext(ctx) {
                        var fromMeasure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        if (!fromMeasure) {
                            // causes stack overflow when measuring text with gradients
                            // fill
                            var fillStyleProp = this.getStyle('fill');
                            var fillOpacityStyleProp = this.getStyle('fill-opacity');
                            var strokeStyleProp = this.getStyle('stroke');
                            var strokeOpacityProp = this.getStyle('stroke-opacity');
                            if (fillStyleProp.isUrlDefinition()) {
                                var fillStyle = fillStyleProp.getFillStyleDefinition(this, fillOpacityStyleProp);
                                if (fillStyle) ctx.fillStyle = fillStyle;
                            } else if (fillStyleProp.hasValue()) {
                                if (fillStyleProp.getString() === 'currentColor') fillStyleProp.setValue(this.getStyle('color').getColor());
                                var _fillStyle = fillStyleProp.getColor();
                                if (_fillStyle !== 'inherit') ctx.fillStyle = _fillStyle === 'none' ? 'rgba(0,0,0,0)' : _fillStyle;
                            }
                            if (fillOpacityStyleProp.hasValue()) {
                                var _fillStyle2 = new Property(this.document, 'fill', ctx.fillStyle).addOpacity(fillOpacityStyleProp).getColor();
                                ctx.fillStyle = _fillStyle2;
                            } // stroke
                            if (strokeStyleProp.isUrlDefinition()) {
                                var strokeStyle = strokeStyleProp.getFillStyleDefinition(this, strokeOpacityProp);
                                if (strokeStyle) ctx.strokeStyle = strokeStyle;
                            } else if (strokeStyleProp.hasValue()) {
                                if (strokeStyleProp.getString() === 'currentColor') strokeStyleProp.setValue(this.getStyle('color').getColor());
                                var _strokeStyle = strokeStyleProp.getString();
                                if (_strokeStyle !== 'inherit') ctx.strokeStyle = _strokeStyle === 'none' ? 'rgba(0,0,0,0)' : _strokeStyle;
                            }
                            if (strokeOpacityProp.hasValue()) {
                                var _strokeStyle2 = new Property(this.document, 'stroke', ctx.strokeStyle).addOpacity(strokeOpacityProp).getString();
                                ctx.strokeStyle = _strokeStyle2;
                            }
                            var strokeWidthStyleProp = this.getStyle('stroke-width');
                            if (strokeWidthStyleProp.hasValue()) {
                                var newLineWidth = strokeWidthStyleProp.getPixels();
                                ctx.lineWidth = !newLineWidth ? PSEUDO_ZERO // browsers don't respect 0 (or node-canvas? :-)
                                 : newLineWidth;
                            }
                            var strokeLinecapStyleProp = this.getStyle('stroke-linecap');
                            var strokeLinejoinStyleProp = this.getStyle('stroke-linejoin');
                            var strokeMiterlimitProp = this.getStyle('stroke-miterlimit'); // NEED TEST
                            // const pointOrderStyleProp = this.getStyle('paint-order');
                            var strokeDasharrayStyleProp = this.getStyle('stroke-dasharray');
                            var strokeDashoffsetProp = this.getStyle('stroke-dashoffset');
                            if (strokeLinecapStyleProp.hasValue()) ctx.lineCap = strokeLinecapStyleProp.getString();
                            if (strokeLinejoinStyleProp.hasValue()) ctx.lineJoin = strokeLinejoinStyleProp.getString();
                            if (strokeMiterlimitProp.hasValue()) ctx.miterLimit = strokeMiterlimitProp.getNumber();
                             // NEED TEST
                            // if (pointOrderStyleProp.hasValue()) {
                            // 	// ?
                            // 	ctx.paintOrder = pointOrderStyleProp.getValue();
                            // }
                            if (strokeDasharrayStyleProp.hasValue() && strokeDasharrayStyleProp.getString() !== 'none') {
                                var gaps = toNumbers(strokeDasharrayStyleProp.getString());
                                if (typeof ctx.setLineDash !== 'undefined') ctx.setLineDash(gaps);
                                else if (typeof ctx.webkitLineDash !== 'undefined') // @ts-expect-error Handle browser prefix.
                                ctx.webkitLineDash = gaps;
                                else if (typeof ctx.mozDash !== 'undefined' && !(gaps.length === 1 && gaps[0] === 0)) // @ts-expect-error Handle browser prefix.
                                ctx.mozDash = gaps;
                                var offset = strokeDashoffsetProp.getPixels();
                                if (typeof ctx.lineDashOffset !== 'undefined') ctx.lineDashOffset = offset;
                                else if (typeof ctx.webkitLineDashOffset !== 'undefined') // @ts-expect-error Handle browser prefix.
                                ctx.webkitLineDashOffset = offset;
                                else if (typeof ctx.mozDashOffset !== 'undefined') // @ts-expect-error Handle browser prefix.
                                ctx.mozDashOffset = offset;
                            }
                        } // font
                        this.modifiedEmSizeStack = false;
                        if (typeof ctx.font !== 'undefined') {
                            var fontStyleProp = this.getStyle('font');
                            var fontStyleStyleProp = this.getStyle('font-style');
                            var fontVariantStyleProp = this.getStyle('font-variant');
                            var fontWeightStyleProp = this.getStyle('font-weight');
                            var fontSizeStyleProp = this.getStyle('font-size');
                            var fontFamilyStyleProp = this.getStyle('font-family');
                            var font = new Font(fontStyleStyleProp.getString(), fontVariantStyleProp.getString(), fontWeightStyleProp.getString(), fontSizeStyleProp.hasValue() ? "".concat(fontSizeStyleProp.getPixels(true), "px") : '', fontFamilyStyleProp.getString(), Font.parse(fontStyleProp.getString(), ctx.font));
                            fontStyleStyleProp.setValue(font.fontStyle);
                            fontVariantStyleProp.setValue(font.fontVariant);
                            fontWeightStyleProp.setValue(font.fontWeight);
                            fontSizeStyleProp.setValue(font.fontSize);
                            fontFamilyStyleProp.setValue(font.fontFamily);
                            ctx.font = font.toString();
                            if (fontSizeStyleProp.isPixels()) {
                                this.document.emSize = fontSizeStyleProp.getPixels();
                                this.modifiedEmSizeStack = true;
                            }
                        }
                        if (!fromMeasure) {
                            // effects
                            this.applyEffects(ctx); // opacity
                            ctx.globalAlpha = this.calculateOpacity();
                        }
                    }
                    clearContext(ctx) {
                        super.clearContext(ctx);
                        if (this.modifiedEmSizeStack) this.document.popEmSize();
                    }
                }
                class PathElement extends RenderedElement {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'path';
                        this.pathParser = null;
                        this.pathParser = new PathParser(this.getAttribute('d').getString());
                    }
                    path(ctx) {
                        var { pathParser } = this;
                        var boundingBox = new BoundingBox();
                        pathParser.reset();
                        if (ctx) ctx.beginPath();
                        while(!pathParser.isEnd())switch(pathParser.next().type){
                            case PathParser.MOVE_TO:
                                this.pathM(ctx, boundingBox);
                                break;
                            case PathParser.LINE_TO:
                                this.pathL(ctx, boundingBox);
                                break;
                            case PathParser.HORIZ_LINE_TO:
                                this.pathH(ctx, boundingBox);
                                break;
                            case PathParser.VERT_LINE_TO:
                                this.pathV(ctx, boundingBox);
                                break;
                            case PathParser.CURVE_TO:
                                this.pathC(ctx, boundingBox);
                                break;
                            case PathParser.SMOOTH_CURVE_TO:
                                this.pathS(ctx, boundingBox);
                                break;
                            case PathParser.QUAD_TO:
                                this.pathQ(ctx, boundingBox);
                                break;
                            case PathParser.SMOOTH_QUAD_TO:
                                this.pathT(ctx, boundingBox);
                                break;
                            case PathParser.ARC:
                                this.pathA(ctx, boundingBox);
                                break;
                            case PathParser.CLOSE_PATH:
                                this.pathZ(ctx, boundingBox);
                                break;
                        }
                        return boundingBox;
                    }
                    getBoundingBox(_) {
                        return this.path();
                    }
                    getMarkers() {
                        var { pathParser } = this;
                        var points = pathParser.getMarkerPoints();
                        var angles = pathParser.getMarkerAngles();
                        var markers = points.map((point, i)=>[
                                point,
                                angles[i]
                            ]);
                        return markers;
                    }
                    renderChildren(ctx) {
                        this.path(ctx);
                        this.document.screen.mouse.checkPath(this, ctx);
                        var fillRuleStyleProp = this.getStyle('fill-rule');
                        if (ctx.fillStyle !== '') {
                            if (fillRuleStyleProp.getString('inherit') !== 'inherit') ctx.fill(fillRuleStyleProp.getString());
                            else ctx.fill();
                        }
                        if (ctx.strokeStyle !== '') {
                            if (this.getAttribute('vector-effect').getString() === 'non-scaling-stroke') {
                                ctx.save();
                                ctx.setTransform(1, 0, 0, 1, 0, 0);
                                ctx.stroke();
                                ctx.restore();
                            } else ctx.stroke();
                        }
                        var markers = this.getMarkers();
                        if (markers) {
                            var markersLastIndex = markers.length - 1;
                            var markerStartStyleProp = this.getStyle('marker-start');
                            var markerMidStyleProp = this.getStyle('marker-mid');
                            var markerEndStyleProp = this.getStyle('marker-end');
                            if (markerStartStyleProp.isUrlDefinition()) {
                                var marker = markerStartStyleProp.getDefinition();
                                var [point, angle] = markers[0];
                                marker.render(ctx, point, angle);
                            }
                            if (markerMidStyleProp.isUrlDefinition()) {
                                var _marker = markerMidStyleProp.getDefinition();
                                for(var i = 1; i < markersLastIndex; i++){
                                    var [_point, _angle] = markers[i];
                                    _marker.render(ctx, _point, _angle);
                                }
                            }
                            if (markerEndStyleProp.isUrlDefinition()) {
                                var _marker2 = markerEndStyleProp.getDefinition();
                                var [_point2, _angle2] = markers[markersLastIndex];
                                _marker2.render(ctx, _point2, _angle2);
                            }
                        }
                    }
                    static pathM(pathParser) {
                        var point = pathParser.getAsCurrentPoint();
                        pathParser.start = pathParser.current;
                        return {
                            point
                        };
                    }
                    pathM(ctx, boundingBox) {
                        var { pathParser } = this;
                        var { point } = PathElement.pathM(pathParser);
                        var { x, y } = point;
                        pathParser.addMarker(point);
                        boundingBox.addPoint(x, y);
                        if (ctx) ctx.moveTo(x, y);
                    }
                    static pathL(pathParser) {
                        var { current } = pathParser;
                        var point = pathParser.getAsCurrentPoint();
                        return {
                            current,
                            point
                        };
                    }
                    pathL(ctx, boundingBox) {
                        var { pathParser } = this;
                        var { current, point } = PathElement.pathL(pathParser);
                        var { x, y } = point;
                        pathParser.addMarker(point, current);
                        boundingBox.addPoint(x, y);
                        if (ctx) ctx.lineTo(x, y);
                    }
                    static pathH(pathParser) {
                        var { current, command } = pathParser;
                        var point = new Point((command.relative ? current.x : 0) + command.x, current.y);
                        pathParser.current = point;
                        return {
                            current,
                            point
                        };
                    }
                    pathH(ctx, boundingBox) {
                        var { pathParser } = this;
                        var { current, point } = PathElement.pathH(pathParser);
                        var { x, y } = point;
                        pathParser.addMarker(point, current);
                        boundingBox.addPoint(x, y);
                        if (ctx) ctx.lineTo(x, y);
                    }
                    static pathV(pathParser) {
                        var { current, command } = pathParser;
                        var point = new Point(current.x, (command.relative ? current.y : 0) + command.y);
                        pathParser.current = point;
                        return {
                            current,
                            point
                        };
                    }
                    pathV(ctx, boundingBox) {
                        var { pathParser } = this;
                        var { current, point } = PathElement.pathV(pathParser);
                        var { x, y } = point;
                        pathParser.addMarker(point, current);
                        boundingBox.addPoint(x, y);
                        if (ctx) ctx.lineTo(x, y);
                    }
                    static pathC(pathParser) {
                        var { current } = pathParser;
                        var point = pathParser.getPoint('x1', 'y1');
                        var controlPoint = pathParser.getAsControlPoint('x2', 'y2');
                        var currentPoint = pathParser.getAsCurrentPoint();
                        return {
                            current,
                            point,
                            controlPoint,
                            currentPoint
                        };
                    }
                    pathC(ctx, boundingBox) {
                        var { pathParser } = this;
                        var { current, point, controlPoint, currentPoint } = PathElement.pathC(pathParser);
                        pathParser.addMarker(currentPoint, controlPoint, point);
                        boundingBox.addBezierCurve(current.x, current.y, point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                        if (ctx) ctx.bezierCurveTo(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                    }
                    static pathS(pathParser) {
                        var { current } = pathParser;
                        var point = pathParser.getReflectedControlPoint();
                        var controlPoint = pathParser.getAsControlPoint('x2', 'y2');
                        var currentPoint = pathParser.getAsCurrentPoint();
                        return {
                            current,
                            point,
                            controlPoint,
                            currentPoint
                        };
                    }
                    pathS(ctx, boundingBox) {
                        var { pathParser } = this;
                        var { current, point, controlPoint, currentPoint } = PathElement.pathS(pathParser);
                        pathParser.addMarker(currentPoint, controlPoint, point);
                        boundingBox.addBezierCurve(current.x, current.y, point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                        if (ctx) ctx.bezierCurveTo(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                    }
                    static pathQ(pathParser) {
                        var { current } = pathParser;
                        var controlPoint = pathParser.getAsControlPoint('x1', 'y1');
                        var currentPoint = pathParser.getAsCurrentPoint();
                        return {
                            current,
                            controlPoint,
                            currentPoint
                        };
                    }
                    pathQ(ctx, boundingBox) {
                        var { pathParser } = this;
                        var { current, controlPoint, currentPoint } = PathElement.pathQ(pathParser);
                        pathParser.addMarker(currentPoint, controlPoint, controlPoint);
                        boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                        if (ctx) ctx.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                    }
                    static pathT(pathParser) {
                        var { current } = pathParser;
                        var controlPoint = pathParser.getReflectedControlPoint();
                        pathParser.control = controlPoint;
                        var currentPoint = pathParser.getAsCurrentPoint();
                        return {
                            current,
                            controlPoint,
                            currentPoint
                        };
                    }
                    pathT(ctx, boundingBox) {
                        var { pathParser } = this;
                        var { current, controlPoint, currentPoint } = PathElement.pathT(pathParser);
                        pathParser.addMarker(currentPoint, controlPoint, controlPoint);
                        boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                        if (ctx) ctx.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                    }
                    static pathA(pathParser) {
                        var { current, command } = pathParser;
                        var { rX, rY, xRot, lArcFlag, sweepFlag } = command;
                        var xAxisRotation = xRot * (Math.PI / 180.0);
                        var currentPoint = pathParser.getAsCurrentPoint(); // Conversion from endpoint to center parameterization
                        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
                        // x1', y1'
                        var currp = new Point(Math.cos(xAxisRotation) * (current.x - currentPoint.x) / 2.0 + Math.sin(xAxisRotation) * (current.y - currentPoint.y) / 2.0, -Math.sin(xAxisRotation) * (current.x - currentPoint.x) / 2.0 + Math.cos(xAxisRotation) * (current.y - currentPoint.y) / 2.0); // adjust radii
                        var l = Math.pow(currp.x, 2) / Math.pow(rX, 2) + Math.pow(currp.y, 2) / Math.pow(rY, 2);
                        if (l > 1) {
                            rX *= Math.sqrt(l);
                            rY *= Math.sqrt(l);
                        } // cx', cy'
                        var s = (lArcFlag === sweepFlag ? -1 : 1) * Math.sqrt((Math.pow(rX, 2) * Math.pow(rY, 2) - Math.pow(rX, 2) * Math.pow(currp.y, 2) - Math.pow(rY, 2) * Math.pow(currp.x, 2)) / (Math.pow(rX, 2) * Math.pow(currp.y, 2) + Math.pow(rY, 2) * Math.pow(currp.x, 2)));
                        if (isNaN(s)) s = 0;
                        var cpp = new Point(s * rX * currp.y / rY, s * -rY * currp.x / rX); // cx, cy
                        var centp = new Point((current.x + currentPoint.x) / 2.0 + Math.cos(xAxisRotation) * cpp.x - Math.sin(xAxisRotation) * cpp.y, (current.y + currentPoint.y) / 2.0 + Math.sin(xAxisRotation) * cpp.x + Math.cos(xAxisRotation) * cpp.y); // initial angle
                        var a1 = vectorsAngle([
                            1,
                            0
                        ], [
                            (currp.x - cpp.x) / rX,
                            (currp.y - cpp.y) / rY
                        ]); // θ1
                        // angle delta
                        var u = [
                            (currp.x - cpp.x) / rX,
                            (currp.y - cpp.y) / rY
                        ];
                        var v = [
                            (-currp.x - cpp.x) / rX,
                            (-currp.y - cpp.y) / rY
                        ];
                        var ad = vectorsAngle(u, v); // Δθ
                        if (vectorsRatio(u, v) <= -1) ad = Math.PI;
                        if (vectorsRatio(u, v) >= 1) ad = 0;
                        return {
                            currentPoint,
                            rX,
                            rY,
                            sweepFlag,
                            xAxisRotation,
                            centp,
                            a1,
                            ad
                        };
                    }
                    pathA(ctx, boundingBox) {
                        var { pathParser } = this;
                        var { currentPoint, rX, rY, sweepFlag, xAxisRotation, centp, a1, ad } = PathElement.pathA(pathParser); // for markers
                        var dir = 1 - sweepFlag ? 1.0 : -1;
                        var ah = a1 + dir * (ad / 2.0);
                        var halfWay = new Point(centp.x + rX * Math.cos(ah), centp.y + rY * Math.sin(ah));
                        pathParser.addMarkerAngle(halfWay, ah - dir * Math.PI / 2);
                        pathParser.addMarkerAngle(currentPoint, ah - dir * Math.PI);
                        boundingBox.addPoint(currentPoint.x, currentPoint.y); // TODO: this is too naive, make it better
                        if (ctx && !isNaN(a1) && !isNaN(ad)) {
                            var r = rX > rY ? rX : rY;
                            var sx = rX > rY ? 1 : rX / rY;
                            var sy = rX > rY ? rY / rX : 1;
                            ctx.translate(centp.x, centp.y);
                            ctx.rotate(xAxisRotation);
                            ctx.scale(sx, sy);
                            ctx.arc(0, 0, r, a1, a1 + ad, Boolean(1 - sweepFlag));
                            ctx.scale(1 / sx, 1 / sy);
                            ctx.rotate(-xAxisRotation);
                            ctx.translate(-centp.x, -centp.y);
                        }
                    }
                    static pathZ(pathParser) {
                        pathParser.current = pathParser.start;
                    }
                    pathZ(ctx, boundingBox) {
                        PathElement.pathZ(this.pathParser);
                        if (ctx) // only close path if it is not a straight line
                        {
                            if (boundingBox.x1 !== boundingBox.x2 && boundingBox.y1 !== boundingBox.y2) ctx.closePath();
                        }
                    }
                }
                class GlyphElement extends PathElement {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'glyph';
                        this.horizAdvX = this.getAttribute('horiz-adv-x').getNumber();
                        this.unicode = this.getAttribute('unicode').getString();
                        this.arabicForm = this.getAttribute('arabic-form').getString();
                    }
                }
                class TextElement extends RenderedElement {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, new.target === TextElement ? true : captureTextNodes);
                        this.type = 'text';
                        this.x = 0;
                        this.y = 0;
                        this.measureCache = -1;
                    }
                    setContext(ctx) {
                        var fromMeasure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        super.setContext(ctx, fromMeasure);
                        var textBaseline = this.getStyle('dominant-baseline').getTextBaseline() || this.getStyle('alignment-baseline').getTextBaseline();
                        if (textBaseline) ctx.textBaseline = textBaseline;
                    }
                    initializeCoordinates() {
                        this.x = 0;
                        this.y = 0;
                        this.leafTexts = [];
                        this.textChunkStart = 0;
                        this.minX = Number.POSITIVE_INFINITY;
                        this.maxX = Number.NEGATIVE_INFINITY;
                    }
                    getBoundingBox(ctx) {
                        if (this.type !== 'text') return this.getTElementBoundingBox(ctx);
                         // first, calculate child positions
                        this.initializeCoordinates();
                        this.adjustChildCoordinatesRecursive(ctx);
                        var boundingBox = null; // then calculate bounding box
                        this.children.forEach((_, i)=>{
                            var childBoundingBox = this.getChildBoundingBox(ctx, this, this, i);
                            if (!boundingBox) boundingBox = childBoundingBox;
                            else boundingBox.addBoundingBox(childBoundingBox);
                        });
                        return boundingBox;
                    }
                    getFontSize() {
                        var { document: document1, parent } = this;
                        var inheritFontSize = Font.parse(document1.ctx.font).fontSize;
                        var fontSize = parent.getStyle('font-size').getNumber(inheritFontSize);
                        return fontSize;
                    }
                    getTElementBoundingBox(ctx) {
                        var fontSize = this.getFontSize();
                        return new BoundingBox(this.x, this.y - fontSize, this.x + this.measureText(ctx), this.y);
                    }
                    getGlyph(font, text, i) {
                        var char = text[i];
                        var glyph = null;
                        if (font.isArabic) {
                            var len = text.length;
                            var prevChar = text[i - 1];
                            var nextChar = text[i + 1];
                            var arabicForm = 'isolated';
                            if ((i === 0 || prevChar === ' ') && i < len - 1 && nextChar !== ' ') arabicForm = 'terminal';
                            if (i > 0 && prevChar !== ' ' && i < len - 1 && nextChar !== ' ') arabicForm = 'medial';
                            if (i > 0 && prevChar !== ' ' && (i === len - 1 || nextChar === ' ')) arabicForm = 'initial';
                            if (typeof font.glyphs[char] !== 'undefined') {
                                // NEED TEST
                                var maybeGlyph = font.glyphs[char];
                                glyph = maybeGlyph instanceof GlyphElement ? maybeGlyph : maybeGlyph[arabicForm];
                            }
                        } else glyph = font.glyphs[char];
                        if (!glyph) glyph = font.missingGlyph;
                        return glyph;
                    }
                    getText() {
                        return '';
                    }
                    getTextFromNode(node) {
                        var textNode = node || this.node;
                        var childNodes = Array.from(textNode.parentNode.childNodes);
                        var index = childNodes.indexOf(textNode);
                        var lastIndex = childNodes.length - 1;
                        var text = compressSpaces(// || textNode.text
                        textNode.textContent || '');
                        if (index === 0) text = trimLeft(text);
                        if (index === lastIndex) text = trimRight(text);
                        return text;
                    }
                    renderChildren(ctx) {
                        if (this.type !== 'text') {
                            this.renderTElementChildren(ctx);
                            return;
                        } // first, calculate child positions
                        this.initializeCoordinates();
                        this.adjustChildCoordinatesRecursive(ctx); // then render
                        this.children.forEach((_, i)=>{
                            this.renderChild(ctx, this, this, i);
                        });
                        var { mouse } = this.document.screen; // Do not calc bounding box if mouse is not working.
                        if (mouse.isWorking()) mouse.checkBoundingBox(this, this.getBoundingBox(ctx));
                    }
                    renderTElementChildren(ctx) {
                        var { document: document1, parent } = this;
                        var renderText = this.getText();
                        var customFont = parent.getStyle('font-family').getDefinition();
                        if (customFont) {
                            var { unitsPerEm } = customFont.fontFace;
                            var ctxFont = Font.parse(document1.ctx.font);
                            var fontSize = parent.getStyle('font-size').getNumber(ctxFont.fontSize);
                            var fontStyle = parent.getStyle('font-style').getString(ctxFont.fontStyle);
                            var scale = fontSize / unitsPerEm;
                            var text = customFont.isRTL ? renderText.split('').reverse().join('') : renderText;
                            var dx = toNumbers(parent.getAttribute('dx').getString());
                            var len = text.length;
                            for(var i = 0; i < len; i++){
                                var glyph = this.getGlyph(customFont, text, i);
                                ctx.translate(this.x, this.y);
                                ctx.scale(scale, -scale);
                                var lw = ctx.lineWidth;
                                ctx.lineWidth = ctx.lineWidth * unitsPerEm / fontSize;
                                if (fontStyle === 'italic') ctx.transform(1, 0, .4, 1, 0, 0);
                                glyph.render(ctx);
                                if (fontStyle === 'italic') ctx.transform(1, 0, -0.4, 1, 0, 0);
                                ctx.lineWidth = lw;
                                ctx.scale(1 / scale, -1 / scale);
                                ctx.translate(-this.x, -this.y);
                                this.x += fontSize * (glyph.horizAdvX || customFont.horizAdvX) / unitsPerEm;
                                if (typeof dx[i] !== 'undefined' && !isNaN(dx[i])) this.x += dx[i];
                            }
                            return;
                        }
                        var { x, y } = this; // NEED TEST
                        // if (ctx.paintOrder === 'stroke') {
                        // 	if (ctx.strokeStyle) {
                        // 		ctx.strokeText(renderText, x, y);
                        // 	}
                        // 	if (ctx.fillStyle) {
                        // 		ctx.fillText(renderText, x, y);
                        // 	}
                        // } else {
                        if (ctx.fillStyle) ctx.fillText(renderText, x, y);
                        if (ctx.strokeStyle) ctx.strokeText(renderText, x, y);
                         // }
                    }
                    applyAnchoring() {
                        if (this.textChunkStart >= this.leafTexts.length) return;
                         // This is basically the "Apply anchoring" part of https://www.w3.org/TR/SVG2/text.html#TextLayoutAlgorithm.
                        // The difference is that we apply the anchoring as soon as a chunk is finished. This saves some extra looping.
                        // Vertical text is not supported.
                        var firstElement = this.leafTexts[this.textChunkStart];
                        var textAnchor = firstElement.getStyle('text-anchor').getString('start');
                        var isRTL = false; // we treat RTL like LTR
                        var shift = 0;
                        if (textAnchor === 'start' && !isRTL || textAnchor === 'end' && isRTL) shift = firstElement.x - this.minX;
                        else if (textAnchor === 'end' && !isRTL || textAnchor === 'start' && isRTL) shift = firstElement.x - this.maxX;
                        else shift = firstElement.x - (this.minX + this.maxX) / 2;
                        for(var i = this.textChunkStart; i < this.leafTexts.length; i++)this.leafTexts[i].x += shift;
                         // start new chunk
                        this.minX = Number.POSITIVE_INFINITY;
                        this.maxX = Number.NEGATIVE_INFINITY;
                        this.textChunkStart = this.leafTexts.length;
                    }
                    adjustChildCoordinatesRecursive(ctx) {
                        this.children.forEach((_, i)=>{
                            this.adjustChildCoordinatesRecursiveCore(ctx, this, this, i);
                        });
                        this.applyAnchoring();
                    }
                    adjustChildCoordinatesRecursiveCore(ctx, textParent, parent, i) {
                        var child = parent.children[i];
                        if (child.children.length > 0) child.children.forEach((_, i)=>{
                            textParent.adjustChildCoordinatesRecursiveCore(ctx, textParent, child, i);
                        });
                        else // only leafs are relevant
                        this.adjustChildCoordinates(ctx, textParent, parent, i);
                    }
                    adjustChildCoordinates(ctx, textParent, parent, i) {
                        var child = parent.children[i];
                        if (typeof child.measureText !== 'function') return child;
                        ctx.save();
                        child.setContext(ctx, true);
                        var xAttr = child.getAttribute('x');
                        var yAttr = child.getAttribute('y');
                        var dxAttr = child.getAttribute('dx');
                        var dyAttr = child.getAttribute('dy');
                        var customFont = child.getStyle('font-family').getDefinition();
                        var isRTL = Boolean(customFont) && customFont.isRTL;
                        if (i === 0) {
                            // First children inherit attributes from parent(s). Positional attributes
                            // are only inherited from a parent to it's first child.
                            if (!xAttr.hasValue()) xAttr.setValue(child.getInheritedAttribute('x'));
                            if (!yAttr.hasValue()) yAttr.setValue(child.getInheritedAttribute('y'));
                            if (!dxAttr.hasValue()) dxAttr.setValue(child.getInheritedAttribute('dx'));
                            if (!dyAttr.hasValue()) dyAttr.setValue(child.getInheritedAttribute('dy'));
                        }
                        var width = child.measureText(ctx);
                        if (isRTL) textParent.x -= width;
                        if (xAttr.hasValue()) {
                            // an "x" attribute marks the start of a new chunk
                            textParent.applyAnchoring();
                            child.x = xAttr.getPixels('x');
                            if (dxAttr.hasValue()) child.x += dxAttr.getPixels('x');
                        } else {
                            if (dxAttr.hasValue()) textParent.x += dxAttr.getPixels('x');
                            child.x = textParent.x;
                        }
                        textParent.x = child.x;
                        if (!isRTL) textParent.x += width;
                        if (yAttr.hasValue()) {
                            child.y = yAttr.getPixels('y');
                            if (dyAttr.hasValue()) child.y += dyAttr.getPixels('y');
                        } else {
                            if (dyAttr.hasValue()) textParent.y += dyAttr.getPixels('y');
                            child.y = textParent.y;
                        }
                        textParent.y = child.y; // update the current chunk and it's bounds
                        textParent.leafTexts.push(child);
                        textParent.minX = Math.min(textParent.minX, child.x, child.x + width);
                        textParent.maxX = Math.max(textParent.maxX, child.x, child.x + width);
                        child.clearContext(ctx);
                        ctx.restore();
                        return child;
                    }
                    getChildBoundingBox(ctx, textParent, parent, i) {
                        var child = parent.children[i]; // not a text node?
                        if (typeof child.getBoundingBox !== 'function') return null;
                        var boundingBox = child.getBoundingBox(ctx);
                        if (!boundingBox) return null;
                        child.children.forEach((_, i)=>{
                            var childBoundingBox = textParent.getChildBoundingBox(ctx, textParent, child, i);
                            boundingBox.addBoundingBox(childBoundingBox);
                        });
                        return boundingBox;
                    }
                    renderChild(ctx, textParent, parent, i) {
                        var child = parent.children[i];
                        child.render(ctx);
                        child.children.forEach((_, i)=>{
                            textParent.renderChild(ctx, textParent, child, i);
                        });
                    }
                    measureText(ctx) {
                        var { measureCache } = this;
                        if (~measureCache) return measureCache;
                        var renderText = this.getText();
                        var measure = this.measureTargetText(ctx, renderText);
                        this.measureCache = measure;
                        return measure;
                    }
                    measureTargetText(ctx, targetText) {
                        if (!targetText.length) return 0;
                        var { parent } = this;
                        var customFont = parent.getStyle('font-family').getDefinition();
                        if (customFont) {
                            var fontSize = this.getFontSize();
                            var text = customFont.isRTL ? targetText.split('').reverse().join('') : targetText;
                            var dx = toNumbers(parent.getAttribute('dx').getString());
                            var len = text.length;
                            var _measure = 0;
                            for(var i = 0; i < len; i++){
                                var glyph = this.getGlyph(customFont, text, i);
                                _measure += (glyph.horizAdvX || customFont.horizAdvX) * fontSize / customFont.fontFace.unitsPerEm;
                                if (typeof dx[i] !== 'undefined' && !isNaN(dx[i])) _measure += dx[i];
                            }
                            return _measure;
                        }
                        if (!ctx.measureText) return targetText.length * 10;
                        ctx.save();
                        this.setContext(ctx, true);
                        var { width: measure } = ctx.measureText(targetText);
                        this.clearContext(ctx);
                        ctx.restore();
                        return measure;
                    }
                    /**
   * Inherits positional attributes from {@link TextElement} parent(s). Attributes
   * are only inherited from a parent to its first child.
   * @param name - The attribute name.
   * @returns The attribute value or null.
   */ getInheritedAttribute(name) {
                        // eslint-disable-next-line @typescript-eslint/no-this-alias,consistent-this
                        var current = this;
                        while(current instanceof TextElement && current.isFirstChild()){
                            var parentAttr = current.parent.getAttribute(name);
                            if (parentAttr.hasValue(true)) return parentAttr.getValue('0');
                            current = current.parent;
                        }
                        return null;
                    }
                }
                class TSpanElement extends TextElement {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, new.target === TSpanElement ? true : captureTextNodes);
                        this.type = 'tspan'; // if this node has children, then they own the text
                        this.text = this.children.length > 0 ? '' : this.getTextFromNode();
                    }
                    getText() {
                        return this.text;
                    }
                }
                class TextNode extends TSpanElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'textNode';
                    }
                }
                class SVGElement extends RenderedElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'svg';
                        this.root = false;
                    }
                    setContext(ctx) {
                        var _this$node$parentNode;
                        var { document: document1 } = this;
                        var { screen, window: window1 } = document1;
                        var canvas = ctx.canvas;
                        screen.setDefaults(ctx);
                        if (canvas.style && typeof ctx.font !== 'undefined' && window1 && typeof window1.getComputedStyle !== 'undefined') {
                            ctx.font = window1.getComputedStyle(canvas).getPropertyValue('font');
                            var fontSizeProp = new Property(document1, 'fontSize', Font.parse(ctx.font).fontSize);
                            if (fontSizeProp.hasValue()) {
                                document1.rootEmSize = fontSizeProp.getPixels('y');
                                document1.emSize = document1.rootEmSize;
                            }
                        } // create new view port
                        if (!this.getAttribute('x').hasValue()) this.getAttribute('x', true).setValue(0);
                        if (!this.getAttribute('y').hasValue()) this.getAttribute('y', true).setValue(0);
                        var { width, height } = screen.viewPort;
                        if (!this.getStyle('width').hasValue()) this.getStyle('width', true).setValue('100%');
                        if (!this.getStyle('height').hasValue()) this.getStyle('height', true).setValue('100%');
                        if (!this.getStyle('color').hasValue()) this.getStyle('color', true).setValue('black');
                        var refXAttr = this.getAttribute('refX');
                        var refYAttr = this.getAttribute('refY');
                        var viewBoxAttr = this.getAttribute('viewBox');
                        var viewBox = viewBoxAttr.hasValue() ? toNumbers(viewBoxAttr.getString()) : null;
                        var clip = !this.root && this.getStyle('overflow').getValue('hidden') !== 'visible';
                        var minX = 0;
                        var minY = 0;
                        var clipX = 0;
                        var clipY = 0;
                        if (viewBox) {
                            minX = viewBox[0];
                            minY = viewBox[1];
                        }
                        if (!this.root) {
                            width = this.getStyle('width').getPixels('x');
                            height = this.getStyle('height').getPixels('y');
                            if (this.type === 'marker') {
                                clipX = minX;
                                clipY = minY;
                                minX = 0;
                                minY = 0;
                            }
                        }
                        screen.viewPort.setCurrent(width, height); // Default value of transform-origin is center only for root SVG elements
                        // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform-origin
                        if (this.node // is not temporary SVGElement
                         && (!this.parent || ((_this$node$parentNode = this.node.parentNode) === null || _this$node$parentNode === void 0 ? void 0 : _this$node$parentNode.nodeName) === 'foreignObject') && this.getStyle('transform', false, true).hasValue() && !this.getStyle('transform-origin', false, true).hasValue()) this.getStyle('transform-origin', true, true).setValue('50% 50%');
                        super.setContext(ctx);
                        ctx.translate(this.getAttribute('x').getPixels('x'), this.getAttribute('y').getPixels('y'));
                        if (viewBox) {
                            width = viewBox[2];
                            height = viewBox[3];
                        }
                        document1.setViewBox({
                            ctx,
                            aspectRatio: this.getAttribute('preserveAspectRatio').getString(),
                            width: screen.viewPort.width,
                            desiredWidth: width,
                            height: screen.viewPort.height,
                            desiredHeight: height,
                            minX,
                            minY,
                            refX: refXAttr.getValue(),
                            refY: refYAttr.getValue(),
                            clip,
                            clipX,
                            clipY
                        });
                        if (viewBox) {
                            screen.viewPort.removeCurrent();
                            screen.viewPort.setCurrent(width, height);
                        }
                    }
                    clearContext(ctx) {
                        super.clearContext(ctx);
                        this.document.screen.viewPort.removeCurrent();
                    }
                    /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */ resize(width) {
                        var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
                        var preserveAspectRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var widthAttr = this.getAttribute('width', true);
                        var heightAttr = this.getAttribute('height', true);
                        var viewBoxAttr = this.getAttribute('viewBox');
                        var styleAttr = this.getAttribute('style');
                        var originWidth = widthAttr.getNumber(0);
                        var originHeight = heightAttr.getNumber(0);
                        if (preserveAspectRatio) {
                            if (typeof preserveAspectRatio === 'string') this.getAttribute('preserveAspectRatio', true).setValue(preserveAspectRatio);
                            else {
                                var preserveAspectRatioAttr = this.getAttribute('preserveAspectRatio');
                                if (preserveAspectRatioAttr.hasValue()) preserveAspectRatioAttr.setValue(preserveAspectRatioAttr.getString().replace(/^\s*(\S.*\S)\s*$/, '$1'));
                            }
                        }
                        widthAttr.setValue(width);
                        heightAttr.setValue(height);
                        if (!viewBoxAttr.hasValue()) viewBoxAttr.setValue("0 0 ".concat(originWidth || width, " ").concat(originHeight || height));
                        if (styleAttr.hasValue()) {
                            var widthStyle = this.getStyle('width');
                            var heightStyle = this.getStyle('height');
                            if (widthStyle.hasValue()) widthStyle.setValue("".concat(width, "px"));
                            if (heightStyle.hasValue()) heightStyle.setValue("".concat(height, "px"));
                        }
                    }
                }
                class RectElement extends PathElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'rect';
                    }
                    path(ctx) {
                        var x = this.getAttribute('x').getPixels('x');
                        var y = this.getAttribute('y').getPixels('y');
                        var width = this.getStyle('width', false, true).getPixels('x');
                        var height = this.getStyle('height', false, true).getPixels('y');
                        var rxAttr = this.getAttribute('rx');
                        var ryAttr = this.getAttribute('ry');
                        var rx = rxAttr.getPixels('x');
                        var ry = ryAttr.getPixels('y');
                        if (rxAttr.hasValue() && !ryAttr.hasValue()) ry = rx;
                        if (ryAttr.hasValue() && !rxAttr.hasValue()) rx = ry;
                        rx = Math.min(rx, width / 2.0);
                        ry = Math.min(ry, height / 2.0);
                        if (ctx) {
                            var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
                            ctx.beginPath(); // always start the path so we don't fill prior paths
                            if (height > 0 && width > 0) {
                                ctx.moveTo(x + rx, y);
                                ctx.lineTo(x + width - rx, y);
                                ctx.bezierCurveTo(x + width - rx + KAPPA * rx, y, x + width, y + ry - KAPPA * ry, x + width, y + ry);
                                ctx.lineTo(x + width, y + height - ry);
                                ctx.bezierCurveTo(x + width, y + height - ry + KAPPA * ry, x + width - rx + KAPPA * rx, y + height, x + width - rx, y + height);
                                ctx.lineTo(x + rx, y + height);
                                ctx.bezierCurveTo(x + rx - KAPPA * rx, y + height, x, y + height - ry + KAPPA * ry, x, y + height - ry);
                                ctx.lineTo(x, y + ry);
                                ctx.bezierCurveTo(x, y + ry - KAPPA * ry, x + rx - KAPPA * rx, y, x + rx, y);
                                ctx.closePath();
                            }
                        }
                        return new BoundingBox(x, y, x + width, y + height);
                    }
                    getMarkers() {
                        return null;
                    }
                }
                class CircleElement extends PathElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'circle';
                    }
                    path(ctx) {
                        var cx = this.getAttribute('cx').getPixels('x');
                        var cy = this.getAttribute('cy').getPixels('y');
                        var r = this.getAttribute('r').getPixels();
                        if (ctx && r > 0) {
                            ctx.beginPath();
                            ctx.arc(cx, cy, r, 0, Math.PI * 2, false);
                            ctx.closePath();
                        }
                        return new BoundingBox(cx - r, cy - r, cx + r, cy + r);
                    }
                    getMarkers() {
                        return null;
                    }
                }
                class EllipseElement extends PathElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'ellipse';
                    }
                    path(ctx) {
                        var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
                        var rx = this.getAttribute('rx').getPixels('x');
                        var ry = this.getAttribute('ry').getPixels('y');
                        var cx = this.getAttribute('cx').getPixels('x');
                        var cy = this.getAttribute('cy').getPixels('y');
                        if (ctx && rx > 0 && ry > 0) {
                            ctx.beginPath();
                            ctx.moveTo(cx + rx, cy);
                            ctx.bezierCurveTo(cx + rx, cy + KAPPA * ry, cx + KAPPA * rx, cy + ry, cx, cy + ry);
                            ctx.bezierCurveTo(cx - KAPPA * rx, cy + ry, cx - rx, cy + KAPPA * ry, cx - rx, cy);
                            ctx.bezierCurveTo(cx - rx, cy - KAPPA * ry, cx - KAPPA * rx, cy - ry, cx, cy - ry);
                            ctx.bezierCurveTo(cx + KAPPA * rx, cy - ry, cx + rx, cy - KAPPA * ry, cx + rx, cy);
                            ctx.closePath();
                        }
                        return new BoundingBox(cx - rx, cy - ry, cx + rx, cy + ry);
                    }
                    getMarkers() {
                        return null;
                    }
                }
                class LineElement extends PathElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'line';
                    }
                    getPoints() {
                        return [
                            new Point(this.getAttribute('x1').getPixels('x'), this.getAttribute('y1').getPixels('y')),
                            new Point(this.getAttribute('x2').getPixels('x'), this.getAttribute('y2').getPixels('y'))
                        ];
                    }
                    path(ctx) {
                        var [{ x: x0, y: y0 }, { x: x1, y: y1 }] = this.getPoints();
                        if (ctx) {
                            ctx.beginPath();
                            ctx.moveTo(x0, y0);
                            ctx.lineTo(x1, y1);
                        }
                        return new BoundingBox(x0, y0, x1, y1);
                    }
                    getMarkers() {
                        var [p0, p1] = this.getPoints();
                        var a = p0.angleTo(p1);
                        return [
                            [
                                p0,
                                a
                            ],
                            [
                                p1,
                                a
                            ]
                        ];
                    }
                }
                class PolylineElement extends PathElement {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'polyline';
                        this.points = [];
                        this.points = Point.parsePath(this.getAttribute('points').getString());
                    }
                    path(ctx) {
                        var { points } = this;
                        var [{ x: x0, y: y0 }] = points;
                        var boundingBox = new BoundingBox(x0, y0);
                        if (ctx) {
                            ctx.beginPath();
                            ctx.moveTo(x0, y0);
                        }
                        points.forEach((_ref)=>{
                            var { x, y } = _ref;
                            boundingBox.addPoint(x, y);
                            if (ctx) ctx.lineTo(x, y);
                        });
                        return boundingBox;
                    }
                    getMarkers() {
                        var { points } = this;
                        var lastIndex = points.length - 1;
                        var markers = [];
                        points.forEach((point, i)=>{
                            if (i === lastIndex) return;
                            markers.push([
                                point,
                                point.angleTo(points[i + 1])
                            ]);
                        });
                        if (markers.length > 0) markers.push([
                            points[points.length - 1],
                            markers[markers.length - 1][1]
                        ]);
                        return markers;
                    }
                }
                class PolygonElement extends PolylineElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'polygon';
                    }
                    path(ctx) {
                        var boundingBox = super.path(ctx);
                        var [{ x, y }] = this.points;
                        if (ctx) {
                            ctx.lineTo(x, y);
                            ctx.closePath();
                        }
                        return boundingBox;
                    }
                }
                class PatternElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.type = 'pattern';
                    }
                    createPattern(ctx, _, parentOpacityProp) {
                        var width = this.getStyle('width').getPixels('x', true);
                        var height = this.getStyle('height').getPixels('y', true); // render me using a temporary svg element
                        var patternSvg = new SVGElement(this.document, null);
                        patternSvg.attributes.viewBox = new Property(this.document, 'viewBox', this.getAttribute('viewBox').getValue());
                        patternSvg.attributes.width = new Property(this.document, 'width', "".concat(width, "px"));
                        patternSvg.attributes.height = new Property(this.document, 'height', "".concat(height, "px"));
                        patternSvg.attributes.transform = new Property(this.document, 'transform', this.getAttribute('patternTransform').getValue());
                        patternSvg.children = this.children;
                        var patternCanvas = this.document.createCanvas(width, height);
                        var patternCtx = patternCanvas.getContext('2d');
                        var xAttr = this.getAttribute('x');
                        var yAttr = this.getAttribute('y');
                        if (xAttr.hasValue() && yAttr.hasValue()) patternCtx.translate(xAttr.getPixels('x', true), yAttr.getPixels('y', true));
                        if (parentOpacityProp.hasValue()) this.styles['fill-opacity'] = parentOpacityProp;
                        else Reflect.deleteProperty(this.styles, 'fill-opacity');
                         // render 3x3 grid so when we transform there's no white space on edges
                        for(var x = -1; x <= 1; x++)for(var y = -1; y <= 1; y++){
                            patternCtx.save();
                            patternSvg.attributes.x = new Property(this.document, 'x', x * patternCanvas.width);
                            patternSvg.attributes.y = new Property(this.document, 'y', y * patternCanvas.height);
                            patternSvg.render(patternCtx);
                            patternCtx.restore();
                        }
                        var pattern = ctx.createPattern(patternCanvas, 'repeat');
                        return pattern;
                    }
                }
                class MarkerElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.type = 'marker';
                    }
                    render(ctx, point, angle) {
                        if (!point) return;
                        var { x, y } = point;
                        var orient = this.getAttribute('orient').getString('auto');
                        var markerUnits = this.getAttribute('markerUnits').getString('strokeWidth');
                        ctx.translate(x, y);
                        if (orient === 'auto') ctx.rotate(angle);
                        if (markerUnits === 'strokeWidth') ctx.scale(ctx.lineWidth, ctx.lineWidth);
                        ctx.save(); // render me using a temporary svg element
                        var markerSvg = new SVGElement(this.document, null);
                        markerSvg.type = this.type;
                        markerSvg.attributes.viewBox = new Property(this.document, 'viewBox', this.getAttribute('viewBox').getValue());
                        markerSvg.attributes.refX = new Property(this.document, 'refX', this.getAttribute('refX').getValue());
                        markerSvg.attributes.refY = new Property(this.document, 'refY', this.getAttribute('refY').getValue());
                        markerSvg.attributes.width = new Property(this.document, 'width', this.getAttribute('markerWidth').getValue());
                        markerSvg.attributes.height = new Property(this.document, 'height', this.getAttribute('markerHeight').getValue());
                        markerSvg.attributes.overflow = new Property(this.document, 'overflow', this.getAttribute('overflow').getValue());
                        markerSvg.attributes.fill = new Property(this.document, 'fill', this.getAttribute('fill').getColor('black'));
                        markerSvg.attributes.stroke = new Property(this.document, 'stroke', this.getAttribute('stroke').getValue('none'));
                        markerSvg.children = this.children;
                        markerSvg.render(ctx);
                        ctx.restore();
                        if (markerUnits === 'strokeWidth') ctx.scale(1 / ctx.lineWidth, 1 / ctx.lineWidth);
                        if (orient === 'auto') ctx.rotate(-angle);
                        ctx.translate(-x, -y);
                    }
                }
                class DefsElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.type = 'defs';
                    }
                    render() {}
                }
                class GElement extends RenderedElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'g';
                    }
                    getBoundingBox(ctx) {
                        var boundingBox = new BoundingBox();
                        this.children.forEach((child)=>{
                            boundingBox.addBoundingBox(child.getBoundingBox(ctx));
                        });
                        return boundingBox;
                    }
                }
                class GradientElement extends Element {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.attributesToInherit = [
                            'gradientUnits'
                        ];
                        this.stops = [];
                        var { stops, children } = this;
                        children.forEach((child)=>{
                            if (child.type === 'stop') stops.push(child);
                        });
                    }
                    getGradientUnits() {
                        return this.getAttribute('gradientUnits').getString('objectBoundingBox');
                    }
                    createGradient(ctx, element, parentOpacityProp) {
                        // eslint-disable-next-line @typescript-eslint/no-this-alias, consistent-this
                        var stopsContainer = this;
                        if (this.getHrefAttribute().hasValue()) {
                            stopsContainer = this.getHrefAttribute().getDefinition();
                            this.inheritStopContainer(stopsContainer);
                        }
                        var { stops } = stopsContainer;
                        var gradient = this.getGradient(ctx, element);
                        if (!gradient) return this.addParentOpacity(parentOpacityProp, stops[stops.length - 1].color);
                        stops.forEach((stop)=>{
                            gradient.addColorStop(stop.offset, this.addParentOpacity(parentOpacityProp, stop.color));
                        });
                        if (this.getAttribute('gradientTransform').hasValue()) {
                            // render as transformed pattern on temporary canvas
                            var { document: document1 } = this;
                            var { MAX_VIRTUAL_PIXELS, viewPort } = document1.screen;
                            var [rootView] = viewPort.viewPorts;
                            var rect = new RectElement(document1, null);
                            rect.attributes.x = new Property(document1, 'x', -MAX_VIRTUAL_PIXELS / 3.0);
                            rect.attributes.y = new Property(document1, 'y', -MAX_VIRTUAL_PIXELS / 3.0);
                            rect.attributes.width = new Property(document1, 'width', MAX_VIRTUAL_PIXELS);
                            rect.attributes.height = new Property(document1, 'height', MAX_VIRTUAL_PIXELS);
                            var group = new GElement(document1, null);
                            group.attributes.transform = new Property(document1, 'transform', this.getAttribute('gradientTransform').getValue());
                            group.children = [
                                rect
                            ];
                            var patternSvg = new SVGElement(document1, null);
                            patternSvg.attributes.x = new Property(document1, 'x', 0);
                            patternSvg.attributes.y = new Property(document1, 'y', 0);
                            patternSvg.attributes.width = new Property(document1, 'width', rootView.width);
                            patternSvg.attributes.height = new Property(document1, 'height', rootView.height);
                            patternSvg.children = [
                                group
                            ];
                            var patternCanvas = document1.createCanvas(rootView.width, rootView.height);
                            var patternCtx = patternCanvas.getContext('2d');
                            patternCtx.fillStyle = gradient;
                            patternSvg.render(patternCtx);
                            return patternCtx.createPattern(patternCanvas, 'no-repeat');
                        }
                        return gradient;
                    }
                    inheritStopContainer(stopsContainer) {
                        this.attributesToInherit.forEach((attributeToInherit)=>{
                            if (!this.getAttribute(attributeToInherit).hasValue() && stopsContainer.getAttribute(attributeToInherit).hasValue()) this.getAttribute(attributeToInherit, true).setValue(stopsContainer.getAttribute(attributeToInherit).getValue());
                        });
                    }
                    addParentOpacity(parentOpacityProp, color) {
                        if (parentOpacityProp.hasValue()) {
                            var colorProp = new Property(this.document, 'color', color);
                            return colorProp.addOpacity(parentOpacityProp).getColor();
                        }
                        return color;
                    }
                }
                class LinearGradientElement extends GradientElement {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'linearGradient';
                        this.attributesToInherit.push('x1', 'y1', 'x2', 'y2');
                    }
                    getGradient(ctx, element) {
                        var isBoundingBoxUnits = this.getGradientUnits() === 'objectBoundingBox';
                        var boundingBox = isBoundingBoxUnits ? element.getBoundingBox(ctx) : null;
                        if (isBoundingBoxUnits && !boundingBox) return null;
                        if (!this.getAttribute('x1').hasValue() && !this.getAttribute('y1').hasValue() && !this.getAttribute('x2').hasValue() && !this.getAttribute('y2').hasValue()) {
                            this.getAttribute('x1', true).setValue(0);
                            this.getAttribute('y1', true).setValue(0);
                            this.getAttribute('x2', true).setValue(1);
                            this.getAttribute('y2', true).setValue(0);
                        }
                        var x1 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('x1').getNumber() : this.getAttribute('x1').getPixels('x');
                        var y1 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('y1').getNumber() : this.getAttribute('y1').getPixels('y');
                        var x2 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('x2').getNumber() : this.getAttribute('x2').getPixels('x');
                        var y2 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('y2').getNumber() : this.getAttribute('y2').getPixels('y');
                        if (x1 === x2 && y1 === y2) return null;
                        return ctx.createLinearGradient(x1, y1, x2, y2);
                    }
                }
                class RadialGradientElement extends GradientElement {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'radialGradient';
                        this.attributesToInherit.push('cx', 'cy', 'r', 'fx', 'fy', 'fr');
                    }
                    getGradient(ctx, element) {
                        var isBoundingBoxUnits = this.getGradientUnits() === 'objectBoundingBox';
                        var boundingBox = element.getBoundingBox(ctx);
                        if (isBoundingBoxUnits && !boundingBox) return null;
                        if (!this.getAttribute('cx').hasValue()) this.getAttribute('cx', true).setValue('50%');
                        if (!this.getAttribute('cy').hasValue()) this.getAttribute('cy', true).setValue('50%');
                        if (!this.getAttribute('r').hasValue()) this.getAttribute('r', true).setValue('50%');
                        var cx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('cx').getNumber() : this.getAttribute('cx').getPixels('x');
                        var cy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('cy').getNumber() : this.getAttribute('cy').getPixels('y');
                        var fx = cx;
                        var fy = cy;
                        if (this.getAttribute('fx').hasValue()) fx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('fx').getNumber() : this.getAttribute('fx').getPixels('x');
                        if (this.getAttribute('fy').hasValue()) fy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('fy').getNumber() : this.getAttribute('fy').getPixels('y');
                        var r = isBoundingBoxUnits ? (boundingBox.width + boundingBox.height) / 2.0 * this.getAttribute('r').getNumber() : this.getAttribute('r').getPixels();
                        var fr = this.getAttribute('fr').getPixels();
                        return ctx.createRadialGradient(fx, fy, fr, cx, cy, r);
                    }
                }
                class StopElement extends Element {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'stop';
                        var offset = Math.max(0, Math.min(1, this.getAttribute('offset').getNumber()));
                        var stopOpacity = this.getStyle('stop-opacity');
                        var stopColor = this.getStyle('stop-color', true);
                        if (stopColor.getString() === '') stopColor.setValue('#000');
                        if (stopOpacity.hasValue()) stopColor = stopColor.addOpacity(stopOpacity);
                        this.offset = offset;
                        this.color = stopColor.getColor();
                    }
                }
                class AnimateElement extends Element {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'animate';
                        this.duration = 0;
                        this.initialValue = null;
                        this.initialUnits = '';
                        this.removed = false;
                        this.frozen = false;
                        document1.screen.animations.push(this);
                        this.begin = this.getAttribute('begin').getMilliseconds();
                        this.maxDuration = this.begin + this.getAttribute('dur').getMilliseconds();
                        this.from = this.getAttribute('from');
                        this.to = this.getAttribute('to');
                        this.values = new Property(document1, 'values', null);
                        var valuesAttr = this.getAttribute('values');
                        if (valuesAttr.hasValue()) this.values.setValue(valuesAttr.getString().split(';'));
                    }
                    getProperty() {
                        var attributeType = this.getAttribute('attributeType').getString();
                        var attributeName = this.getAttribute('attributeName').getString();
                        if (attributeType === 'CSS') return this.parent.getStyle(attributeName, true);
                        return this.parent.getAttribute(attributeName, true);
                    }
                    calcValue() {
                        var { initialUnits } = this;
                        var { progress, from, to } = this.getProgress(); // tween value linearly
                        var newValue = from.getNumber() + (to.getNumber() - from.getNumber()) * progress;
                        if (initialUnits === '%') newValue *= 100.0; // numValue() returns 0-1 whereas properties are 0-100
                        return "".concat(newValue).concat(initialUnits);
                    }
                    update(delta) {
                        var { parent } = this;
                        var prop = this.getProperty(); // set initial value
                        if (!this.initialValue) {
                            this.initialValue = prop.getString();
                            this.initialUnits = prop.getUnits();
                        } // if we're past the end time
                        if (this.duration > this.maxDuration) {
                            var fill = this.getAttribute('fill').getString('remove'); // loop for indefinitely repeating animations
                            if (this.getAttribute('repeatCount').getString() === 'indefinite' || this.getAttribute('repeatDur').getString() === 'indefinite') this.duration = 0;
                            else if (fill === 'freeze' && !this.frozen) {
                                this.frozen = true;
                                parent.animationFrozen = true;
                                parent.animationFrozenValue = prop.getString();
                            } else if (fill === 'remove' && !this.removed) {
                                this.removed = true;
                                prop.setValue(parent.animationFrozen ? parent.animationFrozenValue : this.initialValue);
                                return true;
                            }
                            return false;
                        }
                        this.duration += delta; // if we're past the begin time
                        var updated = false;
                        if (this.begin < this.duration) {
                            var newValue = this.calcValue(); // tween
                            var typeAttr = this.getAttribute('type');
                            if (typeAttr.hasValue()) {
                                // for transform, etc.
                                var type = typeAttr.getString();
                                newValue = "".concat(type, "(").concat(newValue, ")");
                            }
                            prop.setValue(newValue);
                            updated = true;
                        }
                        return updated;
                    }
                    getProgress() {
                        var { document: document1, values } = this;
                        var result = {
                            progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
                        };
                        if (values.hasValue()) {
                            var p = result.progress * (values.getValue().length - 1);
                            var lb = Math.floor(p);
                            var ub = Math.ceil(p);
                            result.from = new Property(document1, 'from', parseFloat(values.getValue()[lb]));
                            result.to = new Property(document1, 'to', parseFloat(values.getValue()[ub]));
                            result.progress = (p - lb) / (ub - lb);
                        } else {
                            result.from = this.from;
                            result.to = this.to;
                        }
                        return result;
                    }
                }
                class AnimateColorElement extends AnimateElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'animateColor';
                    }
                    calcValue() {
                        var { progress, from, to } = this.getProgress();
                        var colorFrom = new rgbcolor__WEBPACK_IMPORTED_MODULE_13__(from.getColor());
                        var colorTo = new rgbcolor__WEBPACK_IMPORTED_MODULE_13__(to.getColor());
                        if (colorFrom.ok && colorTo.ok) {
                            // tween color linearly
                            var r = colorFrom.r + (colorTo.r - colorFrom.r) * progress;
                            var g = colorFrom.g + (colorTo.g - colorFrom.g) * progress;
                            var b = colorFrom.b + (colorTo.b - colorFrom.b) * progress; // ? alpha
                            return "rgb(".concat(Math.floor(r), ", ").concat(Math.floor(g), ", ").concat(Math.floor(b), ")");
                        }
                        return this.getAttribute('from').getColor();
                    }
                }
                class AnimateTransformElement extends AnimateElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'animateTransform';
                    }
                    calcValue() {
                        var { progress, from, to } = this.getProgress(); // tween value linearly
                        var transformFrom = toNumbers(from.getString());
                        var transformTo = toNumbers(to.getString());
                        var newValue = transformFrom.map((from, i)=>{
                            var to = transformTo[i];
                            return from + (to - from) * progress;
                        }).join(' ');
                        return newValue;
                    }
                }
                class FontElement extends Element {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'font';
                        this.glyphs = Object.create(null);
                        this.horizAdvX = this.getAttribute('horiz-adv-x').getNumber();
                        var { definitions } = document1;
                        var { children } = this;
                        for (var child of children)switch(child.type){
                            case 'font-face':
                                this.fontFace = child;
                                var fontFamilyStyle = child.getStyle('font-family');
                                if (fontFamilyStyle.hasValue()) definitions[fontFamilyStyle.getString()] = this;
                                break;
                            case 'missing-glyph':
                                this.missingGlyph = child;
                                break;
                            case 'glyph':
                                var glyph = child;
                                if (glyph.arabicForm) {
                                    this.isRTL = true;
                                    this.isArabic = true;
                                    if (typeof this.glyphs[glyph.unicode] === 'undefined') this.glyphs[glyph.unicode] = Object.create(null);
                                    this.glyphs[glyph.unicode][glyph.arabicForm] = glyph;
                                } else this.glyphs[glyph.unicode] = glyph;
                                break;
                        }
                    }
                    render() {}
                }
                class FontFaceElement extends Element {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'font-face';
                        this.ascent = this.getAttribute('ascent').getNumber();
                        this.descent = this.getAttribute('descent').getNumber();
                        this.unitsPerEm = this.getAttribute('units-per-em').getNumber();
                    }
                }
                class MissingGlyphElement extends PathElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'missing-glyph';
                        this.horizAdvX = 0;
                    }
                }
                class TRefElement extends TextElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'tref';
                    }
                    getText() {
                        var element = this.getHrefAttribute().getDefinition();
                        if (element) {
                            var firstChild = element.children[0];
                            if (firstChild) return firstChild.getText();
                        }
                        return '';
                    }
                }
                class AElement extends TextElement {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'a';
                        var { childNodes } = node;
                        var firstChild = childNodes[0];
                        var hasText = childNodes.length > 0 && Array.from(childNodes).every((node)=>node.nodeType === 3);
                        this.hasText = hasText;
                        this.text = hasText ? this.getTextFromNode(firstChild) : '';
                    }
                    getText() {
                        return this.text;
                    }
                    renderChildren(ctx) {
                        if (this.hasText) {
                            // render as text element
                            super.renderChildren(ctx);
                            var { document: document1, x, y } = this;
                            var { mouse } = document1.screen;
                            var fontSize = new Property(document1, 'fontSize', Font.parse(document1.ctx.font).fontSize); // Do not calc bounding box if mouse is not working.
                            if (mouse.isWorking()) mouse.checkBoundingBox(this, new BoundingBox(x, y - fontSize.getPixels('y'), x + this.measureText(ctx), y));
                        } else if (this.children.length > 0) {
                            // render as temporary group
                            var g = new GElement(this.document, null);
                            g.children = this.children;
                            g.parent = this;
                            g.render(ctx);
                        }
                    }
                    onClick() {
                        var { window: window1 } = this.document;
                        if (window1) window1.open(this.getHrefAttribute().getString());
                    }
                    onMouseMove() {
                        var ctx = this.document.ctx;
                        ctx.canvas.style.cursor = 'pointer';
                    }
                }
                function ownKeys$2(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        if (enumerableOnly) symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        });
                        keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread$2(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = arguments[i] != null ? arguments[i] : {};
                        if (i % 2) ownKeys$2(Object(source), true).forEach(function(key) {
                            (0, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])(target, key, source[key]);
                        });
                        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                        else ownKeys$2(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                class TextPathElement extends TextElement {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'textPath';
                        this.textWidth = 0;
                        this.textHeight = 0;
                        this.pathLength = -1;
                        this.glyphInfo = null;
                        this.letterSpacingCache = [];
                        this.measuresCache = new Map([
                            [
                                '',
                                0
                            ]
                        ]);
                        var pathElement = this.getHrefAttribute().getDefinition();
                        this.text = this.getTextFromNode();
                        this.dataArray = this.parsePathData(pathElement);
                    }
                    getText() {
                        return this.text;
                    }
                    path(ctx) {
                        var { dataArray } = this;
                        if (ctx) ctx.beginPath();
                        dataArray.forEach((_ref)=>{
                            var { type, points } = _ref;
                            switch(type){
                                case PathParser.LINE_TO:
                                    if (ctx) ctx.lineTo(points[0], points[1]);
                                    break;
                                case PathParser.MOVE_TO:
                                    if (ctx) ctx.moveTo(points[0], points[1]);
                                    break;
                                case PathParser.CURVE_TO:
                                    if (ctx) ctx.bezierCurveTo(points[0], points[1], points[2], points[3], points[4], points[5]);
                                    break;
                                case PathParser.QUAD_TO:
                                    if (ctx) ctx.quadraticCurveTo(points[0], points[1], points[2], points[3]);
                                    break;
                                case PathParser.ARC:
                                    var [cx, cy, rx, ry, theta, dTheta, psi, fs] = points;
                                    var r = rx > ry ? rx : ry;
                                    var scaleX = rx > ry ? 1 : rx / ry;
                                    var scaleY = rx > ry ? ry / rx : 1;
                                    if (ctx) {
                                        ctx.translate(cx, cy);
                                        ctx.rotate(psi);
                                        ctx.scale(scaleX, scaleY);
                                        ctx.arc(0, 0, r, theta, theta + dTheta, Boolean(1 - fs));
                                        ctx.scale(1 / scaleX, 1 / scaleY);
                                        ctx.rotate(-psi);
                                        ctx.translate(-cx, -cy);
                                    }
                                    break;
                                case PathParser.CLOSE_PATH:
                                    if (ctx) ctx.closePath();
                                    break;
                            }
                        });
                    }
                    renderChildren(ctx) {
                        this.setTextData(ctx);
                        ctx.save();
                        var textDecoration = this.parent.getStyle('text-decoration').getString();
                        var fontSize = this.getFontSize();
                        var { glyphInfo } = this;
                        var fill = ctx.fillStyle;
                        if (textDecoration === 'underline') ctx.beginPath();
                        glyphInfo.forEach((glyph, i)=>{
                            var { p0, p1, rotation, text: partialText } = glyph;
                            ctx.save();
                            ctx.translate(p0.x, p0.y);
                            ctx.rotate(rotation);
                            if (ctx.fillStyle) ctx.fillText(partialText, 0, 0);
                            if (ctx.strokeStyle) ctx.strokeText(partialText, 0, 0);
                            ctx.restore();
                            if (textDecoration === 'underline') {
                                if (i === 0) ctx.moveTo(p0.x, p0.y + fontSize / 8);
                                ctx.lineTo(p1.x, p1.y + fontSize / 5);
                            } // // To assist with debugging visually, uncomment following
                        //
                        // ctx.beginPath();
                        // if (i % 2)
                        // 	ctx.strokeStyle = 'red';
                        // else
                        // 	ctx.strokeStyle = 'green';
                        // ctx.moveTo(p0.x, p0.y);
                        // ctx.lineTo(p1.x, p1.y);
                        // ctx.stroke();
                        // ctx.closePath();
                        });
                        if (textDecoration === 'underline') {
                            ctx.lineWidth = fontSize / 20;
                            ctx.strokeStyle = fill;
                            ctx.stroke();
                            ctx.closePath();
                        }
                        ctx.restore();
                    }
                    getLetterSpacingAt() {
                        var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                        return this.letterSpacingCache[idx] || 0;
                    }
                    findSegmentToFitChar(ctx, anchor, textFullWidth, fullPathWidth, spacesNumber, inputOffset, dy, c, charI) {
                        var offset = inputOffset;
                        var glyphWidth = this.measureText(ctx, c);
                        if (c === ' ' && anchor === 'justify' && textFullWidth < fullPathWidth) glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
                        if (charI > -1) offset += this.getLetterSpacingAt(charI);
                        var splineStep = this.textHeight / 20;
                        var p0 = this.getEquidistantPointOnPath(offset, splineStep, 0);
                        var p1 = this.getEquidistantPointOnPath(offset + glyphWidth, splineStep, 0);
                        var segment = {
                            p0,
                            p1
                        };
                        var rotation = p0 && p1 ? Math.atan2(p1.y - p0.y, p1.x - p0.x) : 0;
                        if (dy) {
                            var dyX = Math.cos(Math.PI / 2 + rotation) * dy;
                            var dyY = Math.cos(-rotation) * dy;
                            segment.p0 = _objectSpread$2(_objectSpread$2({}, p0), {}, {
                                x: p0.x + dyX,
                                y: p0.y + dyY
                            });
                            segment.p1 = _objectSpread$2(_objectSpread$2({}, p1), {}, {
                                x: p1.x + dyX,
                                y: p1.y + dyY
                            });
                        }
                        offset += glyphWidth;
                        return {
                            offset,
                            segment,
                            rotation
                        };
                    }
                    measureText(ctx, text) {
                        var { measuresCache } = this;
                        var targetText = text || this.getText();
                        if (measuresCache.has(targetText)) return measuresCache.get(targetText);
                        var measure = this.measureTargetText(ctx, targetText);
                        measuresCache.set(targetText, measure);
                        return measure;
                    }
                    // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
                    // You need to call this method manually to update glyphs cache.
                    setTextData(ctx) {
                        if (this.glyphInfo) return;
                        var renderText = this.getText();
                        var chars = renderText.split('');
                        var spacesNumber = renderText.split(' ').length - 1;
                        var dx = this.parent.getAttribute('dx').split().map((_)=>_.getPixels('x'));
                        var dy = this.parent.getAttribute('dy').getPixels('y');
                        var anchor = this.parent.getStyle('text-anchor').getString('start');
                        var thisSpacing = this.getStyle('letter-spacing');
                        var parentSpacing = this.parent.getStyle('letter-spacing');
                        var letterSpacing = 0;
                        if (!thisSpacing.hasValue() || thisSpacing.getValue() === 'inherit') letterSpacing = parentSpacing.getPixels();
                        else if (thisSpacing.hasValue()) {
                            if (thisSpacing.getValue() !== 'initial' && thisSpacing.getValue() !== 'unset') letterSpacing = thisSpacing.getPixels();
                        } // fill letter-spacing cache
                        var letterSpacingCache = [];
                        var textLen = renderText.length;
                        this.letterSpacingCache = letterSpacingCache;
                        for(var i = 0; i < textLen; i++)letterSpacingCache.push(typeof dx[i] !== 'undefined' ? dx[i] : letterSpacing);
                        var dxSum = letterSpacingCache.reduce((acc, cur, i)=>i === 0 ? 0 : acc + cur || 0, 0);
                        var textWidth = this.measureText(ctx);
                        var textFullWidth = Math.max(textWidth + dxSum, 0);
                        this.textWidth = textWidth;
                        this.textHeight = this.getFontSize();
                        this.glyphInfo = [];
                        var fullPathWidth = this.getPathLength();
                        var startOffset = this.getStyle('startOffset').getNumber(0) * fullPathWidth;
                        var offset = 0;
                        if (anchor === 'middle' || anchor === 'center') offset = -textFullWidth / 2;
                        if (anchor === 'end' || anchor === 'right') offset = -textFullWidth;
                        offset += startOffset;
                        chars.forEach((char, i)=>{
                            // Find such segment what distance between p0 and p1 is approx. width of glyph
                            var { offset: nextOffset, segment, rotation } = this.findSegmentToFitChar(ctx, anchor, textFullWidth, fullPathWidth, spacesNumber, offset, dy, char, i);
                            offset = nextOffset;
                            if (!segment.p0 || !segment.p1) return;
                             // const width = this.getLineLength(
                            // 	segment.p0.x,
                            // 	segment.p0.y,
                            // 	segment.p1.x,
                            // 	segment.p1.y
                            // );
                            // Note: Since glyphs are rendered one at a time, any kerning pair data built into the font will not be used.
                            // Can foresee having a rough pair table built in that the developer can override as needed.
                            // Or use "dx" attribute of the <text> node as a naive replacement
                            // const kern = 0;
                            // placeholder for future implementation
                            // const midpoint = this.getPointOnLine(
                            // 	kern + width / 2.0,
                            // 	segment.p0.x, segment.p0.y, segment.p1.x, segment.p1.y
                            // );
                            this.glyphInfo.push({
                                // transposeX: midpoint.x,
                                // transposeY: midpoint.y,
                                text: chars[i],
                                p0: segment.p0,
                                p1: segment.p1,
                                rotation
                            });
                        });
                    }
                    parsePathData(path) {
                        this.pathLength = -1; // reset path length
                        if (!path) return [];
                        var pathCommands = [];
                        var { pathParser } = path;
                        pathParser.reset(); // convert l, H, h, V, and v to L
                        while(!pathParser.isEnd()){
                            var { current } = pathParser;
                            var startX = current ? current.x : 0;
                            var startY = current ? current.y : 0;
                            var command = pathParser.next();
                            var nextCommandType = command.type;
                            var points = [];
                            switch(command.type){
                                case PathParser.MOVE_TO:
                                    this.pathM(pathParser, points);
                                    break;
                                case PathParser.LINE_TO:
                                    nextCommandType = this.pathL(pathParser, points);
                                    break;
                                case PathParser.HORIZ_LINE_TO:
                                    nextCommandType = this.pathH(pathParser, points);
                                    break;
                                case PathParser.VERT_LINE_TO:
                                    nextCommandType = this.pathV(pathParser, points);
                                    break;
                                case PathParser.CURVE_TO:
                                    this.pathC(pathParser, points);
                                    break;
                                case PathParser.SMOOTH_CURVE_TO:
                                    nextCommandType = this.pathS(pathParser, points);
                                    break;
                                case PathParser.QUAD_TO:
                                    this.pathQ(pathParser, points);
                                    break;
                                case PathParser.SMOOTH_QUAD_TO:
                                    nextCommandType = this.pathT(pathParser, points);
                                    break;
                                case PathParser.ARC:
                                    points = this.pathA(pathParser);
                                    break;
                                case PathParser.CLOSE_PATH:
                                    PathElement.pathZ(pathParser);
                                    break;
                            }
                            if (command.type !== PathParser.CLOSE_PATH) pathCommands.push({
                                type: nextCommandType,
                                points,
                                start: {
                                    x: startX,
                                    y: startY
                                },
                                pathLength: this.calcLength(startX, startY, nextCommandType, points)
                            });
                            else pathCommands.push({
                                type: PathParser.CLOSE_PATH,
                                points: [],
                                pathLength: 0
                            });
                        }
                        return pathCommands;
                    }
                    pathM(pathParser, points) {
                        var { x, y } = PathElement.pathM(pathParser).point;
                        points.push(x, y);
                    }
                    pathL(pathParser, points) {
                        var { x, y } = PathElement.pathL(pathParser).point;
                        points.push(x, y);
                        return PathParser.LINE_TO;
                    }
                    pathH(pathParser, points) {
                        var { x, y } = PathElement.pathH(pathParser).point;
                        points.push(x, y);
                        return PathParser.LINE_TO;
                    }
                    pathV(pathParser, points) {
                        var { x, y } = PathElement.pathV(pathParser).point;
                        points.push(x, y);
                        return PathParser.LINE_TO;
                    }
                    pathC(pathParser, points) {
                        var { point, controlPoint, currentPoint } = PathElement.pathC(pathParser);
                        points.push(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                    }
                    pathS(pathParser, points) {
                        var { point, controlPoint, currentPoint } = PathElement.pathS(pathParser);
                        points.push(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                        return PathParser.CURVE_TO;
                    }
                    pathQ(pathParser, points) {
                        var { controlPoint, currentPoint } = PathElement.pathQ(pathParser);
                        points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                    }
                    pathT(pathParser, points) {
                        var { controlPoint, currentPoint } = PathElement.pathT(pathParser);
                        points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
                        return PathParser.QUAD_TO;
                    }
                    pathA(pathParser) {
                        var { rX, rY, sweepFlag, xAxisRotation, centp, a1, ad } = PathElement.pathA(pathParser);
                        if (sweepFlag === 0 && ad > 0) ad -= 2 * Math.PI;
                        if (sweepFlag === 1 && ad < 0) ad += 2 * Math.PI;
                        return [
                            centp.x,
                            centp.y,
                            rX,
                            rY,
                            a1,
                            ad,
                            xAxisRotation,
                            sweepFlag
                        ];
                    }
                    calcLength(x, y, commandType, points) {
                        var len = 0;
                        var p1 = null;
                        var p2 = null;
                        var t = 0;
                        switch(commandType){
                            case PathParser.LINE_TO:
                                return this.getLineLength(x, y, points[0], points[1]);
                            case PathParser.CURVE_TO:
                                // Approximates by breaking curve into 100 line segments
                                len = 0.0;
                                p1 = this.getPointOnCubicBezier(0, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                                for(t = 0.01; t <= 1; t += 0.01){
                                    p2 = this.getPointOnCubicBezier(t, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                                    len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
                                    p1 = p2;
                                }
                                return len;
                            case PathParser.QUAD_TO:
                                // Approximates by breaking curve into 100 line segments
                                len = 0.0;
                                p1 = this.getPointOnQuadraticBezier(0, x, y, points[0], points[1], points[2], points[3]);
                                for(t = 0.01; t <= 1; t += 0.01){
                                    p2 = this.getPointOnQuadraticBezier(t, x, y, points[0], points[1], points[2], points[3]);
                                    len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
                                    p1 = p2;
                                }
                                return len;
                            case PathParser.ARC:
                                // Approximates by breaking curve into line segments
                                len = 0.0;
                                var start = points[4]; // 4 = theta
                                var dTheta = points[5]; // 5 = dTheta
                                var end = points[4] + dTheta;
                                var inc = Math.PI / 180.0; // 1 degree resolution
                                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                                 // Note: for purpose of calculating arc length, not going to worry about rotating X-axis by angle psi
                                p1 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                                if (dTheta < 0) // clockwise
                                for(t = start - inc; t > end; t -= inc){
                                    p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                                    len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
                                    p1 = p2;
                                }
                                else // counter-clockwise
                                for(t = start + inc; t < end; t += inc){
                                    p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                                    len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
                                    p1 = p2;
                                }
                                p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                                len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
                                return len;
                        }
                        return 0;
                    }
                    getPointOnLine(dist, p1x, p1y, p2x, p2y) {
                        var fromX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : p1x;
                        var fromY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : p1y;
                        var m = (p2y - p1y) / (p2x - p1x + PSEUDO_ZERO);
                        var run = Math.sqrt(dist * dist / (1 + m * m));
                        if (p2x < p1x) run *= -1;
                        var rise = m * run;
                        var pt = null;
                        if (p2x === p1x) // vertical line
                        pt = {
                            x: fromX,
                            y: fromY + rise
                        };
                        else if ((fromY - p1y) / (fromX - p1x + PSEUDO_ZERO) === m) pt = {
                            x: fromX + run,
                            y: fromY + rise
                        };
                        else {
                            var ix = 0;
                            var iy = 0;
                            var len = this.getLineLength(p1x, p1y, p2x, p2y);
                            if (len < PSEUDO_ZERO) return null;
                            var u = (fromX - p1x) * (p2x - p1x) + (fromY - p1y) * (p2y - p1y);
                            u /= len * len;
                            ix = p1x + u * (p2x - p1x);
                            iy = p1y + u * (p2y - p1y);
                            var pRise = this.getLineLength(fromX, fromY, ix, iy);
                            var pRun = Math.sqrt(dist * dist - pRise * pRise);
                            run = Math.sqrt(pRun * pRun / (1 + m * m));
                            if (p2x < p1x) run *= -1;
                            rise = m * run;
                            pt = {
                                x: ix + run,
                                y: iy + rise
                            };
                        }
                        return pt;
                    }
                    getPointOnPath(distance) {
                        var fullLen = this.getPathLength();
                        var cumulativePathLength = 0;
                        var p = null;
                        if (distance < -0.00005 || distance - 0.00005 > fullLen) return null;
                        var { dataArray } = this;
                        for (var command of dataArray){
                            if (command && (command.pathLength < 0.00005 || cumulativePathLength + command.pathLength + 0.00005 < distance)) {
                                cumulativePathLength += command.pathLength;
                                continue;
                            }
                            var delta = distance - cumulativePathLength;
                            var currentT = 0;
                            switch(command.type){
                                case PathParser.LINE_TO:
                                    p = this.getPointOnLine(delta, command.start.x, command.start.y, command.points[0], command.points[1], command.start.x, command.start.y);
                                    break;
                                case PathParser.ARC:
                                    var start = command.points[4]; // 4 = theta
                                    var dTheta = command.points[5]; // 5 = dTheta
                                    var end = command.points[4] + dTheta;
                                    currentT = start + delta / command.pathLength * dTheta;
                                    if (dTheta < 0 && currentT < end || dTheta >= 0 && currentT > end) break;
                                    p = this.getPointOnEllipticalArc(command.points[0], command.points[1], command.points[2], command.points[3], currentT, command.points[6]);
                                    break;
                                case PathParser.CURVE_TO:
                                    currentT = delta / command.pathLength;
                                    if (currentT > 1) currentT = 1;
                                    p = this.getPointOnCubicBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3], command.points[4], command.points[5]);
                                    break;
                                case PathParser.QUAD_TO:
                                    currentT = delta / command.pathLength;
                                    if (currentT > 1) currentT = 1;
                                    p = this.getPointOnQuadraticBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3]);
                                    break;
                            }
                            if (p) return p;
                            break;
                        }
                        return null;
                    }
                    getLineLength(x1, y1, x2, y2) {
                        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
                    }
                    getPathLength() {
                        if (this.pathLength === -1) this.pathLength = this.dataArray.reduce((length, command)=>command.pathLength > 0 ? length + command.pathLength : length, 0);
                        return this.pathLength;
                    }
                    getPointOnCubicBezier(pct, p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
                        var x = p4x * CB1(pct) + p3x * CB2(pct) + p2x * CB3(pct) + p1x * CB4(pct);
                        var y = p4y * CB1(pct) + p3y * CB2(pct) + p2y * CB3(pct) + p1y * CB4(pct);
                        return {
                            x,
                            y
                        };
                    }
                    getPointOnQuadraticBezier(pct, p1x, p1y, p2x, p2y, p3x, p3y) {
                        var x = p3x * QB1(pct) + p2x * QB2(pct) + p1x * QB3(pct);
                        var y = p3y * QB1(pct) + p2y * QB2(pct) + p1y * QB3(pct);
                        return {
                            x,
                            y
                        };
                    }
                    getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
                        var cosPsi = Math.cos(psi);
                        var sinPsi = Math.sin(psi);
                        var pt = {
                            x: rx * Math.cos(theta),
                            y: ry * Math.sin(theta)
                        };
                        return {
                            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
                            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
                        };
                    }
                    buildEquidistantCache(inputStep, inputPrecision) {
                        var fullLen = this.getPathLength();
                        var precision = inputPrecision || 0.25; // accuracy vs performance
                        var step = inputStep || fullLen / 100;
                        if (!this.equidistantCache || this.equidistantCache.step !== step || this.equidistantCache.precision !== precision) {
                            // Prepare cache
                            this.equidistantCache = {
                                step,
                                precision,
                                points: []
                            }; // Calculate points
                            var s = 0;
                            for(var l = 0; l <= fullLen; l += precision){
                                var p0 = this.getPointOnPath(l);
                                var p1 = this.getPointOnPath(l + precision);
                                if (!p0 || !p1) continue;
                                s += this.getLineLength(p0.x, p0.y, p1.x, p1.y);
                                if (s >= step) {
                                    this.equidistantCache.points.push({
                                        x: p0.x,
                                        y: p0.y,
                                        distance: l
                                    });
                                    s -= step;
                                }
                            }
                        }
                    }
                    getEquidistantPointOnPath(targetDistance, step, precision) {
                        this.buildEquidistantCache(step, precision);
                        if (targetDistance < 0 || targetDistance - this.getPathLength() > 0.00005) return null;
                        var idx = Math.round(targetDistance / this.getPathLength() * (this.equidistantCache.points.length - 1));
                        return this.equidistantCache.points[idx] || null;
                    }
                }
                var dataUriRegex = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
                class ImageElement extends RenderedElement {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'image';
                        this.loaded = false;
                        var href = this.getHrefAttribute().getString();
                        if (!href) return;
                        var isSvg = href.endsWith('.svg') || /^\s*data:image\/svg\+xml/i.test(href);
                        document1.images.push(this);
                        if (!isSvg) this.loadImage(href);
                        else this.loadSvg(href);
                        this.isSvg = isSvg;
                    }
                    loadImage(href) {
                        var _this = this;
                        return (0, _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function*() {
                            try {
                                var image = yield _this.document.createImage(href);
                                _this.image = image;
                            } catch (err) {
                                console.error("Error while loading image \"".concat(href, "\":"), err);
                            }
                            _this.loaded = true;
                        })();
                    }
                    loadSvg(href) {
                        var _this2 = this;
                        return (0, _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function*() {
                            var match = dataUriRegex.exec(href);
                            if (match) {
                                var data = match[5];
                                if (match[4] === 'base64') _this2.image = atob(data);
                                else _this2.image = decodeURIComponent(data);
                            } else try {
                                var response = yield _this2.document.fetch(href);
                                var svg = yield response.text();
                                _this2.image = svg;
                            } catch (err) {
                                console.error("Error while loading image \"".concat(href, "\":"), err);
                            }
                            _this2.loaded = true;
                        })();
                    }
                    renderChildren(ctx) {
                        var { document: document1, image, loaded } = this;
                        var x = this.getAttribute('x').getPixels('x');
                        var y = this.getAttribute('y').getPixels('y');
                        var width = this.getStyle('width').getPixels('x');
                        var height = this.getStyle('height').getPixels('y');
                        if (!loaded || !image || !width || !height) return;
                        ctx.save();
                        ctx.translate(x, y);
                        if (this.isSvg) {
                            var subDocument = document1.canvg.forkString(ctx, this.image, {
                                ignoreMouse: true,
                                ignoreAnimation: true,
                                ignoreDimensions: true,
                                ignoreClear: true,
                                offsetX: 0,
                                offsetY: 0,
                                scaleWidth: width,
                                scaleHeight: height
                            });
                            subDocument.document.documentElement.parent = this;
                            subDocument.render();
                        } else {
                            var _image = this.image;
                            document1.setViewBox({
                                ctx,
                                aspectRatio: this.getAttribute('preserveAspectRatio').getString(),
                                width,
                                desiredWidth: _image.width,
                                height,
                                desiredHeight: _image.height
                            });
                            if (this.loaded) {
                                if (typeof _image.complete === 'undefined' || _image.complete) ctx.drawImage(_image, 0, 0);
                            }
                        }
                        ctx.restore();
                    }
                    getBoundingBox() {
                        var x = this.getAttribute('x').getPixels('x');
                        var y = this.getAttribute('y').getPixels('y');
                        var width = this.getStyle('width').getPixels('x');
                        var height = this.getStyle('height').getPixels('y');
                        return new BoundingBox(x, y, x + width, y + height);
                    }
                }
                class SymbolElement extends RenderedElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'symbol';
                    }
                    render(_) {}
                }
                class SVGFontLoader {
                    constructor(document1){
                        this.document = document1;
                        this.loaded = false;
                        document1.fonts.push(this);
                    }
                    load(fontFamily, url) {
                        var _this = this;
                        return (0, _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function*() {
                            try {
                                var { document: document1 } = _this;
                                var svgDocument = yield document1.canvg.parser.load(url);
                                var fonts = svgDocument.getElementsByTagName('font');
                                Array.from(fonts).forEach((fontNode)=>{
                                    var font = document1.createElement(fontNode);
                                    document1.definitions[fontFamily] = font;
                                });
                            } catch (err) {
                                console.error("Error while loading font \"".concat(url, "\":"), err);
                            }
                            _this.loaded = true;
                        })();
                    }
                }
                class StyleElement extends Element {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'style';
                        var css = compressSpaces(Array.from(node.childNodes) // NEED TEST
                        .map((_)=>_.textContent).join('').replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, '') // remove comments
                        .replace(/@import.*;/g, '') // remove imports
                        );
                        var cssDefs = css.split('}');
                        cssDefs.forEach((_)=>{
                            var def = _.trim();
                            if (!def) return;
                            var cssParts = def.split('{');
                            var cssClasses = cssParts[0].split(',');
                            var cssProps = cssParts[1].split(';');
                            cssClasses.forEach((_)=>{
                                var cssClass = _.trim();
                                if (!cssClass) return;
                                var props = document1.styles[cssClass] || {};
                                cssProps.forEach((cssProp)=>{
                                    var prop = cssProp.indexOf(':');
                                    var name = cssProp.substr(0, prop).trim();
                                    var value = cssProp.substr(prop + 1, cssProp.length - prop).trim();
                                    if (name && value) props[name] = new Property(document1, name, value);
                                });
                                document1.styles[cssClass] = props;
                                document1.stylesSpecificity[cssClass] = getSelectorSpecificity(cssClass);
                                if (cssClass === '@font-face') {
                                    //  && !nodeEnv
                                    var fontFamily = props['font-family'].getString().replace(/"|'/g, '');
                                    var srcs = props.src.getString().split(',');
                                    srcs.forEach((src)=>{
                                        if (src.indexOf('format("svg")') > 0) {
                                            var url = parseExternalUrl(src);
                                            if (url) new SVGFontLoader(document1).load(fontFamily, url);
                                        }
                                    });
                                }
                            });
                        });
                    }
                }
                StyleElement.parseExternalUrl = parseExternalUrl;
                class UseElement extends RenderedElement {
                    constructor(){
                        super(...arguments);
                        this.type = 'use';
                    }
                    setContext(ctx) {
                        super.setContext(ctx);
                        var xAttr = this.getAttribute('x');
                        var yAttr = this.getAttribute('y');
                        if (xAttr.hasValue()) ctx.translate(xAttr.getPixels('x'), 0);
                        if (yAttr.hasValue()) ctx.translate(0, yAttr.getPixels('y'));
                    }
                    path(ctx) {
                        var { element } = this;
                        if (element) element.path(ctx);
                    }
                    renderChildren(ctx) {
                        var { document: document1, element } = this;
                        if (element) {
                            var tempSvg = element;
                            if (element.type === 'symbol') {
                                // render me using a temporary svg element in symbol cases (http://www.w3.org/TR/SVG/struct.html#UseElement)
                                tempSvg = new SVGElement(document1, null);
                                tempSvg.attributes.viewBox = new Property(document1, 'viewBox', element.getAttribute('viewBox').getString());
                                tempSvg.attributes.preserveAspectRatio = new Property(document1, 'preserveAspectRatio', element.getAttribute('preserveAspectRatio').getString());
                                tempSvg.attributes.overflow = new Property(document1, 'overflow', element.getAttribute('overflow').getString());
                                tempSvg.children = element.children; // element is still the parent of the children
                                element.styles.opacity = new Property(document1, 'opacity', this.calculateOpacity());
                            }
                            if (tempSvg.type === 'svg') {
                                var widthStyle = this.getStyle('width', false, true);
                                var heightStyle = this.getStyle('height', false, true); // if symbol or svg, inherit width/height from me
                                if (widthStyle.hasValue()) tempSvg.attributes.width = new Property(document1, 'width', widthStyle.getString());
                                if (heightStyle.hasValue()) tempSvg.attributes.height = new Property(document1, 'height', heightStyle.getString());
                            }
                            var oldParent = tempSvg.parent;
                            tempSvg.parent = this;
                            tempSvg.render(ctx);
                            tempSvg.parent = oldParent;
                        }
                    }
                    getBoundingBox(ctx) {
                        var { element } = this;
                        if (element) return element.getBoundingBox(ctx);
                        return null;
                    }
                    elementTransform() {
                        var { document: document1, element } = this;
                        return Transform.fromElement(document1, element);
                    }
                    get element() {
                        if (!this.cachedElement) this.cachedElement = this.getHrefAttribute().getDefinition();
                        return this.cachedElement;
                    }
                }
                function imGet(img, x, y, width, _height, rgba) {
                    return img[y * width * 4 + x * 4 + rgba];
                }
                function imSet(img, x, y, width, _height, rgba, val) {
                    img[y * width * 4 + x * 4 + rgba] = val;
                }
                function m(matrix, i, v) {
                    var mi = matrix[i];
                    return mi * v;
                }
                function c(a, m1, m2, m3) {
                    return m1 + Math.cos(a) * m2 + Math.sin(a) * m3;
                }
                class FeColorMatrixElement extends Element {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'feColorMatrix';
                        var matrix = toNumbers(this.getAttribute('values').getString());
                        switch(this.getAttribute('type').getString('matrix')){
                            // http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
                            case 'saturate':
                                var s = matrix[0];
                                /* eslint-disable array-element-newline */ matrix = [
                                    0.213 + 0.787 * s,
                                    0.715 - 0.715 * s,
                                    0.072 - 0.072 * s,
                                    0,
                                    0,
                                    0.213 - 0.213 * s,
                                    0.715 + 0.285 * s,
                                    0.072 - 0.072 * s,
                                    0,
                                    0,
                                    0.213 - 0.213 * s,
                                    0.715 - 0.715 * s,
                                    0.072 + 0.928 * s,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1
                                ];
                                break;
                            case 'hueRotate':
                                var a = matrix[0] * Math.PI / 180.0;
                                /* eslint-disable array-element-newline */ matrix = [
                                    c(a, 0.213, 0.787, -0.213),
                                    c(a, 0.715, -0.715, -0.715),
                                    c(a, 0.072, -0.072, 0.928),
                                    0,
                                    0,
                                    c(a, 0.213, -0.213, 0.143),
                                    c(a, 0.715, 0.285, 0.140),
                                    c(a, 0.072, -0.072, -0.283),
                                    0,
                                    0,
                                    c(a, 0.213, -0.213, -0.787),
                                    c(a, 0.715, -0.715, 0.715),
                                    c(a, 0.072, 0.928, 0.072),
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1
                                ];
                                break;
                            case 'luminanceToAlpha':
                                /* eslint-disable array-element-newline */ matrix = [
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0.2125,
                                    0.7154,
                                    0.0721,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1
                                ];
                                break;
                        }
                        this.matrix = matrix;
                        this.includeOpacity = this.getAttribute('includeOpacity').hasValue();
                    }
                    apply(ctx, _x, _y, width, height) {
                        // assuming x==0 && y==0 for now
                        var { includeOpacity, matrix } = this;
                        var srcData = ctx.getImageData(0, 0, width, height);
                        for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
                            var r = imGet(srcData.data, x, y, width, height, 0);
                            var g = imGet(srcData.data, x, y, width, height, 1);
                            var b = imGet(srcData.data, x, y, width, height, 2);
                            var a = imGet(srcData.data, x, y, width, height, 3);
                            var nr = m(matrix, 0, r) + m(matrix, 1, g) + m(matrix, 2, b) + m(matrix, 3, a) + m(matrix, 4, 1);
                            var ng = m(matrix, 5, r) + m(matrix, 6, g) + m(matrix, 7, b) + m(matrix, 8, a) + m(matrix, 9, 1);
                            var nb = m(matrix, 10, r) + m(matrix, 11, g) + m(matrix, 12, b) + m(matrix, 13, a) + m(matrix, 14, 1);
                            var na = m(matrix, 15, r) + m(matrix, 16, g) + m(matrix, 17, b) + m(matrix, 18, a) + m(matrix, 19, 1);
                            if (includeOpacity) {
                                nr = 0;
                                ng = 0;
                                nb = 0;
                                na *= a / 255;
                            }
                            imSet(srcData.data, x, y, width, height, 0, nr);
                            imSet(srcData.data, x, y, width, height, 1, ng);
                            imSet(srcData.data, x, y, width, height, 2, nb);
                            imSet(srcData.data, x, y, width, height, 3, na);
                        }
                        ctx.clearRect(0, 0, width, height);
                        ctx.putImageData(srcData, 0, 0);
                    }
                }
                class MaskElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.type = 'mask';
                    }
                    apply(ctx, element) {
                        var { document: document1 } = this; // render as temp svg
                        var x = this.getAttribute('x').getPixels('x');
                        var y = this.getAttribute('y').getPixels('y');
                        var width = this.getStyle('width').getPixels('x');
                        var height = this.getStyle('height').getPixels('y');
                        if (!width && !height) {
                            var boundingBox = new BoundingBox();
                            this.children.forEach((child)=>{
                                boundingBox.addBoundingBox(child.getBoundingBox(ctx));
                            });
                            x = Math.floor(boundingBox.x1);
                            y = Math.floor(boundingBox.y1);
                            width = Math.floor(boundingBox.width);
                            height = Math.floor(boundingBox.height);
                        }
                        var ignoredStyles = this.removeStyles(element, MaskElement.ignoreStyles);
                        var maskCanvas = document1.createCanvas(x + width, y + height);
                        var maskCtx = maskCanvas.getContext('2d');
                        document1.screen.setDefaults(maskCtx);
                        this.renderChildren(maskCtx); // convert mask to alpha with a fake node
                        // TODO: refactor out apply from feColorMatrix
                        new FeColorMatrixElement(document1, {
                            nodeType: 1,
                            childNodes: [],
                            attributes: [
                                {
                                    nodeName: 'type',
                                    value: 'luminanceToAlpha'
                                },
                                {
                                    nodeName: 'includeOpacity',
                                    value: 'true'
                                }
                            ]
                        }).apply(maskCtx, 0, 0, x + width, y + height);
                        var tmpCanvas = document1.createCanvas(x + width, y + height);
                        var tmpCtx = tmpCanvas.getContext('2d');
                        document1.screen.setDefaults(tmpCtx);
                        element.render(tmpCtx);
                        tmpCtx.globalCompositeOperation = 'destination-in';
                        tmpCtx.fillStyle = maskCtx.createPattern(maskCanvas, 'no-repeat');
                        tmpCtx.fillRect(0, 0, x + width, y + height);
                        ctx.fillStyle = tmpCtx.createPattern(tmpCanvas, 'no-repeat');
                        ctx.fillRect(0, 0, x + width, y + height); // reassign mask
                        this.restoreStyles(element, ignoredStyles);
                    }
                    render(_) {}
                }
                MaskElement.ignoreStyles = [
                    'mask',
                    'transform',
                    'clip-path'
                ];
                var noop = ()=>{};
                class ClipPathElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.type = 'clipPath';
                    }
                    apply(ctx) {
                        var { document: document1 } = this;
                        var contextProto = Reflect.getPrototypeOf(ctx);
                        var { beginPath, closePath } = ctx;
                        if (contextProto) {
                            contextProto.beginPath = noop;
                            contextProto.closePath = noop;
                        }
                        Reflect.apply(beginPath, ctx, []);
                        this.children.forEach((child)=>{
                            if (typeof child.path === 'undefined') return;
                            var transform = typeof child.elementTransform !== 'undefined' ? child.elementTransform() : null; // handle <use />
                            if (!transform) transform = Transform.fromElement(document1, child);
                            if (transform) transform.apply(ctx);
                            child.path(ctx);
                            if (contextProto) contextProto.closePath = closePath;
                            if (transform) transform.unapply(ctx);
                        });
                        Reflect.apply(closePath, ctx, []);
                        ctx.clip();
                        if (contextProto) {
                            contextProto.beginPath = beginPath;
                            contextProto.closePath = closePath;
                        }
                    }
                    render(_) {}
                }
                class FilterElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.type = 'filter';
                    }
                    apply(ctx, element) {
                        // render as temp svg
                        var { document: document1, children } = this;
                        var boundingBox = element.getBoundingBox(ctx);
                        if (!boundingBox) return;
                        var px = 0;
                        var py = 0;
                        children.forEach((child)=>{
                            var efd = child.extraFilterDistance || 0;
                            px = Math.max(px, efd);
                            py = Math.max(py, efd);
                        });
                        var width = Math.floor(boundingBox.width);
                        var height = Math.floor(boundingBox.height);
                        var tmpCanvasWidth = width + 2 * px;
                        var tmpCanvasHeight = height + 2 * py;
                        if (tmpCanvasWidth < 1 || tmpCanvasHeight < 1) return;
                        var x = Math.floor(boundingBox.x);
                        var y = Math.floor(boundingBox.y);
                        var ignoredStyles = this.removeStyles(element, FilterElement.ignoreStyles);
                        var tmpCanvas = document1.createCanvas(tmpCanvasWidth, tmpCanvasHeight);
                        var tmpCtx = tmpCanvas.getContext('2d');
                        document1.screen.setDefaults(tmpCtx);
                        tmpCtx.translate(-x + px, -y + py);
                        element.render(tmpCtx); // apply filters
                        children.forEach((child)=>{
                            if (typeof child.apply === 'function') child.apply(tmpCtx, 0, 0, tmpCanvasWidth, tmpCanvasHeight);
                        }); // render on me
                        ctx.drawImage(tmpCanvas, 0, 0, tmpCanvasWidth, tmpCanvasHeight, x - px, y - py, tmpCanvasWidth, tmpCanvasHeight);
                        this.restoreStyles(element, ignoredStyles);
                    }
                    render(_) {}
                }
                FilterElement.ignoreStyles = [
                    'filter',
                    'transform',
                    'clip-path'
                ];
                class FeDropShadowElement extends Element {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'feDropShadow';
                        this.addStylesFromStyleDefinition();
                    }
                    apply(_, _x, _y, _width, _height) {}
                }
                class FeMorphologyElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.type = 'feMorphology';
                    }
                    apply(_, _x, _y, _width, _height) {}
                }
                class FeCompositeElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.type = 'feComposite';
                    }
                    apply(_, _x, _y, _width, _height) {}
                }
                class FeGaussianBlurElement extends Element {
                    constructor(document1, node, captureTextNodes){
                        super(document1, node, captureTextNodes);
                        this.type = 'feGaussianBlur';
                        this.blurRadius = Math.floor(this.getAttribute('stdDeviation').getNumber());
                        this.extraFilterDistance = this.blurRadius;
                    }
                    apply(ctx, x, y, width, height) {
                        var { document: document1, blurRadius } = this;
                        var body = document1.window ? document1.window.document.body : null;
                        var canvas = ctx.canvas; // StackBlur requires canvas be on document
                        canvas.id = document1.getUniqueId();
                        if (body) {
                            canvas.style.display = 'none';
                            body.appendChild(canvas);
                        }
                        (0, stackblur_canvas__WEBPACK_IMPORTED_MODULE_19__.canvasRGBA)(canvas, x, y, width, height, blurRadius);
                        if (body) body.removeChild(canvas);
                    }
                }
                class TitleElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.type = 'title';
                    }
                }
                class DescElement extends Element {
                    constructor(){
                        super(...arguments);
                        this.type = 'desc';
                    }
                }
                var elements = {
                    'svg': SVGElement,
                    'rect': RectElement,
                    'circle': CircleElement,
                    'ellipse': EllipseElement,
                    'line': LineElement,
                    'polyline': PolylineElement,
                    'polygon': PolygonElement,
                    'path': PathElement,
                    'pattern': PatternElement,
                    'marker': MarkerElement,
                    'defs': DefsElement,
                    'linearGradient': LinearGradientElement,
                    'radialGradient': RadialGradientElement,
                    'stop': StopElement,
                    'animate': AnimateElement,
                    'animateColor': AnimateColorElement,
                    'animateTransform': AnimateTransformElement,
                    'font': FontElement,
                    'font-face': FontFaceElement,
                    'missing-glyph': MissingGlyphElement,
                    'glyph': GlyphElement,
                    'text': TextElement,
                    'tspan': TSpanElement,
                    'tref': TRefElement,
                    'a': AElement,
                    'textPath': TextPathElement,
                    'image': ImageElement,
                    'g': GElement,
                    'symbol': SymbolElement,
                    'style': StyleElement,
                    'use': UseElement,
                    'mask': MaskElement,
                    'clipPath': ClipPathElement,
                    'filter': FilterElement,
                    'feDropShadow': FeDropShadowElement,
                    'feMorphology': FeMorphologyElement,
                    'feComposite': FeCompositeElement,
                    'feColorMatrix': FeColorMatrixElement,
                    'feGaussianBlur': FeGaussianBlurElement,
                    'title': TitleElement,
                    'desc': DescElement
                };
                function ownKeys$1(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        if (enumerableOnly) symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        });
                        keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread$1(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = arguments[i] != null ? arguments[i] : {};
                        if (i % 2) ownKeys$1(Object(source), true).forEach(function(key) {
                            (0, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])(target, key, source[key]);
                        });
                        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                        else ownKeys$1(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                function createCanvas(width, height) {
                    var canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    return canvas;
                }
                function createImage(_x) {
                    return _createImage.apply(this, arguments);
                }
                function _createImage() {
                    _createImage = (0, _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function*(src) {
                        var anonymousCrossOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        var image = document.createElement('img');
                        if (anonymousCrossOrigin) image.crossOrigin = 'Anonymous';
                        return new Promise((resolve, reject)=>{
                            image.onload = ()=>{
                                resolve(image);
                            };
                            image.onerror = (_event, _source, _lineno, _colno, error)=>{
                                reject(error);
                            };
                            image.src = src;
                        });
                    });
                    return _createImage.apply(this, arguments);
                }
                class Document {
                    constructor(canvg){
                        var { rootEmSize = 12, emSize = 12, createCanvas = Document.createCanvas, createImage = Document.createImage, anonymousCrossOrigin } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        this.canvg = canvg;
                        this.definitions = Object.create(null);
                        this.styles = Object.create(null);
                        this.stylesSpecificity = Object.create(null);
                        this.images = [];
                        this.fonts = [];
                        this.emSizeStack = [];
                        this.uniqueId = 0;
                        this.screen = canvg.screen;
                        this.rootEmSize = rootEmSize;
                        this.emSize = emSize;
                        this.createCanvas = createCanvas;
                        this.createImage = this.bindCreateImage(createImage, anonymousCrossOrigin);
                        this.screen.wait(this.isImagesLoaded.bind(this));
                        this.screen.wait(this.isFontsLoaded.bind(this));
                    }
                    bindCreateImage(createImage, anonymousCrossOrigin) {
                        if (typeof anonymousCrossOrigin === 'boolean') return (source, forceAnonymousCrossOrigin)=>createImage(source, typeof forceAnonymousCrossOrigin === 'boolean' ? forceAnonymousCrossOrigin : anonymousCrossOrigin);
                        return createImage;
                    }
                    get window() {
                        return this.screen.window;
                    }
                    get fetch() {
                        return this.screen.fetch;
                    }
                    get ctx() {
                        return this.screen.ctx;
                    }
                    get emSize() {
                        var { emSizeStack } = this;
                        return emSizeStack[emSizeStack.length - 1];
                    }
                    set emSize(value) {
                        var { emSizeStack } = this;
                        emSizeStack.push(value);
                    }
                    popEmSize() {
                        var { emSizeStack } = this;
                        emSizeStack.pop();
                    }
                    getUniqueId() {
                        return "canvg".concat(++this.uniqueId);
                    }
                    isImagesLoaded() {
                        return this.images.every((_)=>_.loaded);
                    }
                    isFontsLoaded() {
                        return this.fonts.every((_)=>_.loaded);
                    }
                    createDocumentElement(document1) {
                        var documentElement = this.createElement(document1.documentElement);
                        documentElement.root = true;
                        documentElement.addStylesFromStyleDefinition();
                        this.documentElement = documentElement;
                        return documentElement;
                    }
                    createElement(node) {
                        var elementType = node.nodeName.replace(/^[^:]+:/, '');
                        var ElementType = Document.elementTypes[elementType];
                        if (typeof ElementType !== 'undefined') return new ElementType(this, node);
                        return new UnknownElement(this, node);
                    }
                    createTextNode(node) {
                        return new TextNode(this, node);
                    }
                    setViewBox(config) {
                        this.screen.setViewBox(_objectSpread$1({
                            document: this
                        }, config));
                    }
                }
                Document.createCanvas = createCanvas;
                Document.createImage = createImage;
                Document.elementTypes = elements;
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        if (enumerableOnly) symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        });
                        keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = arguments[i] != null ? arguments[i] : {};
                        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                            (0, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])(target, key, source[key]);
                        });
                        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                        else ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                /**
 * SVG renderer on canvas.
 */ class Canvg {
                    /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */ constructor(ctx, svg){
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        this.parser = new Parser(options);
                        this.screen = new Screen(ctx, options);
                        this.options = options;
                        var document1 = new Document(this, options);
                        var documentElement = document1.createDocumentElement(svg);
                        this.document = document1;
                        this.documentElement = documentElement;
                    }
                    /**
   * Create Canvg instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */ static from(ctx, svg) {
                        var _arguments = arguments;
                        return (0, _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function*() {
                            var options = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};
                            var parser = new Parser(options);
                            var svgDocument = yield parser.parse(svg);
                            return new Canvg(ctx, svgDocument, options);
                        })();
                    }
                    /**
   * Create Canvg instance from SVG source string.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */ static fromString(ctx, svg) {
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var parser = new Parser(options);
                        var svgDocument = parser.parseFromString(svg);
                        return new Canvg(ctx, svgDocument, options);
                    }
                    /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */ fork(ctx, svg) {
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        return Canvg.from(ctx, svg, _objectSpread(_objectSpread({}, this.options), options));
                    }
                    /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */ forkString(ctx, svg) {
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        return Canvg.fromString(ctx, svg, _objectSpread(_objectSpread({}, this.options), options));
                    }
                    /**
   * Document is ready promise.
   * @returns Ready promise.
   */ ready() {
                        return this.screen.ready();
                    }
                    /**
   * Document is ready value.
   * @returns Is ready or not.
   */ isReady() {
                        return this.screen.isReady();
                    }
                    /**
   * Render only first frame, ignoring animations and mouse.
   * @param options - Rendering options.
   */ render() {
                        var _arguments2 = arguments, _this = this;
                        return (0, _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function*() {
                            var options = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
                            _this.start(_objectSpread({
                                enableRedraw: true,
                                ignoreAnimation: true,
                                ignoreMouse: true
                            }, options));
                            yield _this.ready();
                            _this.stop();
                        })();
                    }
                    /**
   * Start rendering.
   * @param options - Render options.
   */ start() {
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        var { documentElement, screen, options: baseOptions } = this;
                        screen.start(documentElement, _objectSpread(_objectSpread({
                            enableRedraw: true
                        }, baseOptions), options));
                    }
                    /**
   * Stop rendering.
   */ stop() {
                        this.screen.stop();
                    }
                    /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */ resize(width) {
                        var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
                        var preserveAspectRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        this.documentElement.resize(width, height, preserveAspectRatio);
                    }
                }
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            /***/ },
            /***/ "./node_modules/core-js/internals/a-callable.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/a-callable.js ***!
  \******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var tryToString = __webpack_require__(/*! ../internals/try-to-string */ "./node_modules/core-js/internals/try-to-string.js");
                var $TypeError = TypeError;
                // `Assert: IsCallable(argument) is true`
                module1.exports = function(argument) {
                    if (isCallable(argument)) return argument;
                    throw new $TypeError(tryToString(argument) + ' is not a function');
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/a-constructor.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/a-constructor.js ***!
  \*********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isConstructor = __webpack_require__(/*! ../internals/is-constructor */ "./node_modules/core-js/internals/is-constructor.js");
                var tryToString = __webpack_require__(/*! ../internals/try-to-string */ "./node_modules/core-js/internals/try-to-string.js");
                var $TypeError = TypeError;
                // `Assert: IsConstructor(argument) is true`
                module1.exports = function(argument) {
                    if (isConstructor(argument)) return argument;
                    throw new $TypeError(tryToString(argument) + ' is not a constructor');
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/a-possible-prototype.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/a-possible-prototype.js ***!
  \****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isPossiblePrototype = __webpack_require__(/*! ../internals/is-possible-prototype */ "./node_modules/core-js/internals/is-possible-prototype.js");
                var $String = String;
                var $TypeError = TypeError;
                module1.exports = function(argument) {
                    if (isPossiblePrototype(argument)) return argument;
                    throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/a-set.js": /*!*************************************************!*\
  !*** ./node_modules/core-js/internals/a-set.js ***!
  \*************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var has = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js").has;
                // Perform ? RequireInternalSlot(M, [[SetData]])
                module1.exports = function(it) {
                    has(it);
                    return it;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/add-to-unscopables.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/add-to-unscopables.js ***!
  \**************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
                var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
                var UNSCOPABLES = wellKnownSymbol('unscopables');
                var ArrayPrototype = Array.prototype;
                // Array.prototype[@@unscopables]
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                if (ArrayPrototype[UNSCOPABLES] === undefined) defineProperty(ArrayPrototype, UNSCOPABLES, {
                    configurable: true,
                    value: create(null)
                });
                // add a key to Array.prototype[@@unscopables]
                module1.exports = function(key) {
                    ArrayPrototype[UNSCOPABLES][key] = true;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/advance-string-index.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/advance-string-index.js ***!
  \****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var charAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js").charAt;
                // `AdvanceStringIndex` abstract operation
                // https://tc39.es/ecma262/#sec-advancestringindex
                module1.exports = function(S, index, unicode) {
                    return index + (unicode ? charAt(S, index).length : 1);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/an-instance.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/an-instance.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isPrototypeOf = __webpack_require__(/*! ../internals/object-is-prototype-of */ "./node_modules/core-js/internals/object-is-prototype-of.js");
                var $TypeError = TypeError;
                module1.exports = function(it, Prototype) {
                    if (isPrototypeOf(Prototype, it)) return it;
                    throw new $TypeError('Incorrect invocation');
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/an-object.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/an-object.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var $String = String;
                var $TypeError = TypeError;
                // `Assert: Type(argument) is Object`
                module1.exports = function(argument) {
                    if (isObject(argument)) return argument;
                    throw new $TypeError($String(argument) + ' is not an object');
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/array-buffer-non-extensible.js": /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/array-buffer-non-extensible.js ***!
  \***********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                module1.exports = fails(function() {
                    if (typeof ArrayBuffer == 'function') {
                        var buffer = new ArrayBuffer(8);
                        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
                        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
                            value: 8
                        });
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/array-for-each.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-for-each.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").forEach;
                var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");
                var STRICT_METHOD = arrayMethodIsStrict('forEach');
                // `Array.prototype.forEach` method implementation
                // https://tc39.es/ecma262/#sec-array.prototype.foreach
                module1.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
                    return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                // eslint-disable-next-line es/no-array-prototype-foreach -- safe
                } : [].forEach;
            /***/ },
            /***/ "./node_modules/core-js/internals/array-from.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/array-from.js ***!
  \******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
                var callWithSafeIterationClosing = __webpack_require__(/*! ../internals/call-with-safe-iteration-closing */ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js");
                var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js");
                var isConstructor = __webpack_require__(/*! ../internals/is-constructor */ "./node_modules/core-js/internals/is-constructor.js");
                var lengthOfArrayLike = __webpack_require__(/*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js");
                var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
                var getIterator = __webpack_require__(/*! ../internals/get-iterator */ "./node_modules/core-js/internals/get-iterator.js");
                var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");
                var $Array = Array;
                // `Array.from` method implementation
                // https://tc39.es/ecma262/#sec-array.from
                module1.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
                    var O = toObject(arrayLike);
                    var IS_CONSTRUCTOR = isConstructor(this);
                    var argumentsLength = arguments.length;
                    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
                    var mapping = mapfn !== undefined;
                    if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
                    var iteratorMethod = getIteratorMethod(O);
                    var index = 0;
                    var length, result, step, iterator, next, value;
                    // if the target is not iterable or it's an array with the default iterator - use a simple case
                    if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
                        result = IS_CONSTRUCTOR ? new this() : [];
                        iterator = getIterator(O, iteratorMethod);
                        next = iterator.next;
                        for(; !(step = call(next, iterator)).done; index++){
                            value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                                step.value,
                                index
                            ], true) : step.value;
                            createProperty(result, index, value);
                        }
                    } else {
                        length = lengthOfArrayLike(O);
                        result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
                        for(; length > index; index++){
                            value = mapping ? mapfn(O[index], index) : O[index];
                            createProperty(result, index, value);
                        }
                    }
                    result.length = index;
                    return result;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/array-includes.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-includes.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
                var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");
                var lengthOfArrayLike = __webpack_require__(/*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js");
                // `Array.prototype.{ indexOf, includes }` methods implementation
                var createMethod = function(IS_INCLUDES) {
                    return function($this, el, fromIndex) {
                        var O = toIndexedObject($this);
                        var length = lengthOfArrayLike(O);
                        if (length === 0) return !IS_INCLUDES && -1;
                        var index = toAbsoluteIndex(fromIndex, length);
                        var value;
                        // Array#includes uses SameValueZero equality algorithm
                        // eslint-disable-next-line no-self-compare -- NaN check
                        if (IS_INCLUDES && el !== el) while(length > index){
                            value = O[index++];
                            // eslint-disable-next-line no-self-compare -- NaN check
                            if (value !== value) return true;
                        // Array#indexOf ignores holes, Array#includes - not
                        }
                        else for(; length > index; index++){
                            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                        }
                        return !IS_INCLUDES && -1;
                    };
                };
                module1.exports = {
                    // `Array.prototype.includes` method
                    // https://tc39.es/ecma262/#sec-array.prototype.includes
                    includes: createMethod(true),
                    // `Array.prototype.indexOf` method
                    // https://tc39.es/ecma262/#sec-array.prototype.indexof
                    indexOf: createMethod(false)
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/array-iteration.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/array-iteration.js ***!
  \***********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
                var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
                var lengthOfArrayLike = __webpack_require__(/*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js");
                var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js");
                var push = uncurryThis([].push);
                // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
                var createMethod = function(TYPE) {
                    var IS_MAP = TYPE === 1;
                    var IS_FILTER = TYPE === 2;
                    var IS_SOME = TYPE === 3;
                    var IS_EVERY = TYPE === 4;
                    var IS_FIND_INDEX = TYPE === 6;
                    var IS_FILTER_REJECT = TYPE === 7;
                    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
                    return function($this, callbackfn, that, specificCreate) {
                        var O = toObject($this);
                        var self1 = IndexedObject(O);
                        var length = lengthOfArrayLike(self1);
                        var boundFunction = bind(callbackfn, that);
                        var index = 0;
                        var create = specificCreate || arraySpeciesCreate;
                        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
                        var value, result;
                        for(; length > index; index++)if (NO_HOLES || index in self1) {
                            value = self1[index];
                            result = boundFunction(value, index, O);
                            if (TYPE) {
                                if (IS_MAP) target[index] = result; // map
                                else if (result) switch(TYPE){
                                    case 3:
                                        return true; // some
                                    case 5:
                                        return value; // find
                                    case 6:
                                        return index; // findIndex
                                    case 2:
                                        push(target, value); // filter
                                }
                                else switch(TYPE){
                                    case 4:
                                        return false; // every
                                    case 7:
                                        push(target, value); // filterReject
                                }
                            }
                        }
                        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
                    };
                };
                module1.exports = {
                    // `Array.prototype.forEach` method
                    // https://tc39.es/ecma262/#sec-array.prototype.foreach
                    forEach: createMethod(0),
                    // `Array.prototype.map` method
                    // https://tc39.es/ecma262/#sec-array.prototype.map
                    map: createMethod(1),
                    // `Array.prototype.filter` method
                    // https://tc39.es/ecma262/#sec-array.prototype.filter
                    filter: createMethod(2),
                    // `Array.prototype.some` method
                    // https://tc39.es/ecma262/#sec-array.prototype.some
                    some: createMethod(3),
                    // `Array.prototype.every` method
                    // https://tc39.es/ecma262/#sec-array.prototype.every
                    every: createMethod(4),
                    // `Array.prototype.find` method
                    // https://tc39.es/ecma262/#sec-array.prototype.find
                    find: createMethod(5),
                    // `Array.prototype.findIndex` method
                    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
                    findIndex: createMethod(6),
                    // `Array.prototype.filterReject` method
                    // https://github.com/tc39/proposal-array-filtering
                    filterReject: createMethod(7)
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/array-method-has-species-support.js": /*!****************************************************************************!*\
  !*** ./node_modules/core-js/internals/array-method-has-species-support.js ***!
  \****************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var V8_VERSION = __webpack_require__(/*! ../internals/environment-v8-version */ "./node_modules/core-js/internals/environment-v8-version.js");
                var SPECIES = wellKnownSymbol('species');
                module1.exports = function(METHOD_NAME) {
                    // We can't use this feature detection in V8 since it causes
                    // deoptimization and serious performance degradation
                    // https://github.com/zloirock/core-js/issues/677
                    return V8_VERSION >= 51 || !fails(function() {
                        var array = [];
                        var constructor = array.constructor = {};
                        constructor[SPECIES] = function() {
                            return {
                                foo: 1
                            };
                        };
                        return array[METHOD_NAME](Boolean).foo !== 1;
                    });
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/array-method-is-strict.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/array-method-is-strict.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                module1.exports = function(METHOD_NAME, argument) {
                    var method = [][METHOD_NAME];
                    return !!method && fails(function() {
                        // eslint-disable-next-line no-useless-call -- required for testing
                        method.call(null, argument || function() {
                            return 1;
                        }, 1);
                    });
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/array-reduce.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/array-reduce.js ***!
  \********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
                var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
                var lengthOfArrayLike = __webpack_require__(/*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js");
                var $TypeError = TypeError;
                var REDUCE_EMPTY = 'Reduce of empty array with no initial value';
                // `Array.prototype.{ reduce, reduceRight }` methods implementation
                var createMethod = function(IS_RIGHT) {
                    return function(that, callbackfn, argumentsLength, memo) {
                        var O = toObject(that);
                        var self1 = IndexedObject(O);
                        var length = lengthOfArrayLike(O);
                        aCallable(callbackfn);
                        if (length === 0 && argumentsLength < 2) throw new $TypeError(REDUCE_EMPTY);
                        var index = IS_RIGHT ? length - 1 : 0;
                        var i = IS_RIGHT ? -1 : 1;
                        if (argumentsLength < 2) while(true){
                            if (index in self1) {
                                memo = self1[index];
                                index += i;
                                break;
                            }
                            index += i;
                            if (IS_RIGHT ? index < 0 : length <= index) throw new $TypeError(REDUCE_EMPTY);
                        }
                        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
                        return memo;
                    };
                };
                module1.exports = {
                    // `Array.prototype.reduce` method
                    // https://tc39.es/ecma262/#sec-array.prototype.reduce
                    left: createMethod(false),
                    // `Array.prototype.reduceRight` method
                    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
                    right: createMethod(true)
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/array-slice.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/array-slice.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                module1.exports = uncurryThis([].slice);
            /***/ },
            /***/ "./node_modules/core-js/internals/array-species-constructor.js": /*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/array-species-constructor.js ***!
  \*********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
                var isConstructor = __webpack_require__(/*! ../internals/is-constructor */ "./node_modules/core-js/internals/is-constructor.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var SPECIES = wellKnownSymbol('species');
                var $Array = Array;
                // a part of `ArraySpeciesCreate` abstract operation
                // https://tc39.es/ecma262/#sec-arrayspeciescreate
                module1.exports = function(originalArray) {
                    var C;
                    if (isArray(originalArray)) {
                        C = originalArray.constructor;
                        // cross-realm fallback
                        if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
                        else if (isObject(C)) {
                            C = C[SPECIES];
                            if (C === null) C = undefined;
                        }
                    }
                    return C === undefined ? $Array : C;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/array-species-create.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/array-species-create.js ***!
  \****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var arraySpeciesConstructor = __webpack_require__(/*! ../internals/array-species-constructor */ "./node_modules/core-js/internals/array-species-constructor.js");
                // `ArraySpeciesCreate` abstract operation
                // https://tc39.es/ecma262/#sec-arrayspeciescreate
                module1.exports = function(originalArray, length) {
                    return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js": /*!****************************************************************************!*\
  !*** ./node_modules/core-js/internals/call-with-safe-iteration-closing.js ***!
  \****************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var iteratorClose = __webpack_require__(/*! ../internals/iterator-close */ "./node_modules/core-js/internals/iterator-close.js");
                // call something on iterator step with safe closing on error
                module1.exports = function(iterator, fn, value, ENTRIES) {
                    try {
                        return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
                    } catch (error) {
                        iteratorClose(iterator, 'throw', error);
                    }
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/check-correctness-of-iteration.js": /*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/check-correctness-of-iteration.js ***!
  \**************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var ITERATOR = wellKnownSymbol('iterator');
                var SAFE_CLOSING = false;
                try {
                    var called = 0;
                    var iteratorWithReturn = {
                        next: function() {
                            return {
                                done: !!called++
                            };
                        },
                        'return': function() {
                            SAFE_CLOSING = true;
                        }
                    };
                    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                    iteratorWithReturn[ITERATOR] = function() {
                        return this;
                    };
                    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
                    Array.from(iteratorWithReturn, function() {
                        throw 2;
                    });
                } catch (error) {}
                module1.exports = function(exec, SKIP_CLOSING) {
                    try {
                        if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
                    } catch (error) {
                        return false;
                    } // workaround of old WebKit + `eval` bug
                    var ITERATION_SUPPORT = false;
                    try {
                        var object = {};
                        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                        object[ITERATOR] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: ITERATION_SUPPORT = true
                                    };
                                }
                            };
                        };
                        exec(object);
                    } catch (error) {}
                    return ITERATION_SUPPORT;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/classof-raw.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/classof-raw.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var toString = uncurryThis({}.toString);
                var stringSlice = uncurryThis(''.slice);
                module1.exports = function(it) {
                    return stringSlice(toString(it), 8, -1);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/classof.js": /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/classof.js ***!
  \***************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var classofRaw = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var $Object = Object;
                // ES3 wrong here
                var CORRECT_ARGUMENTS = classofRaw(function() {
                    return arguments;
                }()) === 'Arguments';
                // fallback for IE11 Script Access Denied error
                var tryGet = function(it, key) {
                    try {
                        return it[key];
                    } catch (error) {}
                };
                // getting tag from ES6+ `Object.prototype.toString`
                module1.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
                    var O, tag, result;
                    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/collection-strong.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/collection-strong.js ***!
  \*************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
                var defineBuiltInAccessor = __webpack_require__(/*! ../internals/define-built-in-accessor */ "./node_modules/core-js/internals/define-built-in-accessor.js");
                var defineBuiltIns = __webpack_require__(/*! ../internals/define-built-ins */ "./node_modules/core-js/internals/define-built-ins.js");
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
                var isNullOrUndefined = __webpack_require__(/*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js");
                var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
                var defineIterator = __webpack_require__(/*! ../internals/iterator-define */ "./node_modules/core-js/internals/iterator-define.js");
                var createIterResultObject = __webpack_require__(/*! ../internals/create-iter-result-object */ "./node_modules/core-js/internals/create-iter-result-object.js");
                var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/core-js/internals/set-species.js");
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var fastKey = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js").fastKey;
                var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
                var setInternalState = InternalStateModule.set;
                var internalStateGetterFor = InternalStateModule.getterFor;
                module1.exports = {
                    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
                        var Constructor = wrapper(function(that, iterable) {
                            anInstance(that, Prototype);
                            setInternalState(that, {
                                type: CONSTRUCTOR_NAME,
                                index: create(null),
                                first: null,
                                last: null,
                                size: 0
                            });
                            if (!DESCRIPTORS) that.size = 0;
                            if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
                                that: that,
                                AS_ENTRIES: IS_MAP
                            });
                        });
                        var Prototype = Constructor.prototype;
                        var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
                        var define = function(that, key, value) {
                            var state = getInternalState(that);
                            var entry = getEntry(that, key);
                            var previous, index;
                            // change existing entry
                            if (entry) entry.value = value;
                            else {
                                state.last = entry = {
                                    index: index = fastKey(key, true),
                                    key: key,
                                    value: value,
                                    previous: previous = state.last,
                                    next: null,
                                    removed: false
                                };
                                if (!state.first) state.first = entry;
                                if (previous) previous.next = entry;
                                if (DESCRIPTORS) state.size++;
                                else that.size++;
                                // add to index
                                if (index !== 'F') state.index[index] = entry;
                            }
                            return that;
                        };
                        var getEntry = function(that, key) {
                            var state = getInternalState(that);
                            // fast case
                            var index = fastKey(key);
                            var entry;
                            if (index !== 'F') return state.index[index];
                            // frozen object case
                            for(entry = state.first; entry; entry = entry.next){
                                if (entry.key === key) return entry;
                            }
                        };
                        defineBuiltIns(Prototype, {
                            // `{ Map, Set }.prototype.clear()` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.clear
                            // https://tc39.es/ecma262/#sec-set.prototype.clear
                            clear: function clear() {
                                var that = this;
                                var state = getInternalState(that);
                                var entry = state.first;
                                while(entry){
                                    entry.removed = true;
                                    if (entry.previous) entry.previous = entry.previous.next = null;
                                    entry = entry.next;
                                }
                                state.first = state.last = null;
                                state.index = create(null);
                                if (DESCRIPTORS) state.size = 0;
                                else that.size = 0;
                            },
                            // `{ Map, Set }.prototype.delete(key)` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.delete
                            // https://tc39.es/ecma262/#sec-set.prototype.delete
                            'delete': function(key) {
                                var that = this;
                                var state = getInternalState(that);
                                var entry = getEntry(that, key);
                                if (entry) {
                                    var next = entry.next;
                                    var prev = entry.previous;
                                    delete state.index[entry.index];
                                    entry.removed = true;
                                    if (prev) prev.next = next;
                                    if (next) next.previous = prev;
                                    if (state.first === entry) state.first = next;
                                    if (state.last === entry) state.last = prev;
                                    if (DESCRIPTORS) state.size--;
                                    else that.size--;
                                }
                                return !!entry;
                            },
                            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.foreach
                            // https://tc39.es/ecma262/#sec-set.prototype.foreach
                            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                                var state = getInternalState(this);
                                var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                                var entry;
                                while(entry = entry ? entry.next : state.first){
                                    boundFunction(entry.value, entry.key, this);
                                    // revert to the last existing entry
                                    while(entry && entry.removed)entry = entry.previous;
                                }
                            },
                            // `{ Map, Set}.prototype.has(key)` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.has
                            // https://tc39.es/ecma262/#sec-set.prototype.has
                            has: function has(key) {
                                return !!getEntry(this, key);
                            }
                        });
                        defineBuiltIns(Prototype, IS_MAP ? {
                            // `Map.prototype.get(key)` method
                            // https://tc39.es/ecma262/#sec-map.prototype.get
                            get: function get(key) {
                                var entry = getEntry(this, key);
                                return entry && entry.value;
                            },
                            // `Map.prototype.set(key, value)` method
                            // https://tc39.es/ecma262/#sec-map.prototype.set
                            set: function set(key, value) {
                                return define(this, key === 0 ? 0 : key, value);
                            }
                        } : {
                            // `Set.prototype.add(value)` method
                            // https://tc39.es/ecma262/#sec-set.prototype.add
                            add: function add(value) {
                                return define(this, value = value === 0 ? 0 : value, value);
                            }
                        });
                        if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
                            configurable: true,
                            get: function() {
                                return getInternalState(this).size;
                            }
                        });
                        return Constructor;
                    },
                    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
                        var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
                        var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
                        var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
                        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
                        // https://tc39.es/ecma262/#sec-map.prototype.entries
                        // https://tc39.es/ecma262/#sec-map.prototype.keys
                        // https://tc39.es/ecma262/#sec-map.prototype.values
                        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
                        // https://tc39.es/ecma262/#sec-set.prototype.entries
                        // https://tc39.es/ecma262/#sec-set.prototype.keys
                        // https://tc39.es/ecma262/#sec-set.prototype.values
                        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
                        defineIterator(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
                            setInternalState(this, {
                                type: ITERATOR_NAME,
                                target: iterated,
                                state: getInternalCollectionState(iterated),
                                kind: kind,
                                last: null
                            });
                        }, function() {
                            var state = getInternalIteratorState(this);
                            var kind = state.kind;
                            var entry = state.last;
                            // revert to the last existing entry
                            while(entry && entry.removed)entry = entry.previous;
                            // get next entry
                            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                                // or finish the iteration
                                state.target = null;
                                return createIterResultObject(undefined, true);
                            }
                            // return step by kind
                            if (kind === 'keys') return createIterResultObject(entry.key, false);
                            if (kind === 'values') return createIterResultObject(entry.value, false);
                            return createIterResultObject([
                                entry.key,
                                entry.value
                            ], false);
                        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
                        // `{ Map, Set }.prototype[@@species]` accessors
                        // https://tc39.es/ecma262/#sec-get-map-@@species
                        // https://tc39.es/ecma262/#sec-get-set-@@species
                        setSpecies(CONSTRUCTOR_NAME);
                    }
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/collection.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/collection.js ***!
  \******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                var InternalMetadataModule = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js");
                var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
                var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isNullOrUndefined = __webpack_require__(/*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js");
                var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
                var inheritIfRequired = __webpack_require__(/*! ../internals/inherit-if-required */ "./node_modules/core-js/internals/inherit-if-required.js");
                module1.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
                    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
                    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
                    var ADDER = IS_MAP ? 'set' : 'add';
                    var NativeConstructor = globalThis1[CONSTRUCTOR_NAME];
                    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
                    var Constructor = NativeConstructor;
                    var exported = {};
                    var fixMethod = function(KEY) {
                        var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
                        defineBuiltIn(NativePrototype, KEY, KEY === 'add' ? function add(value) {
                            uncurriedNativeMethod(this, value === 0 ? 0 : value);
                            return this;
                        } : KEY === 'delete' ? function(key) {
                            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                        } : KEY === 'get' ? function get(key) {
                            return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                        } : KEY === 'has' ? function has(key) {
                            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                        } : function set(key, value) {
                            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
                            return this;
                        });
                    };
                    var REPLACE = isForced(CONSTRUCTOR_NAME, !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function() {
                        new NativeConstructor().entries().next();
                    })));
                    if (REPLACE) {
                        // create collection constructor
                        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
                        InternalMetadataModule.enable();
                    } else if (isForced(CONSTRUCTOR_NAME, true)) {
                        var instance = new Constructor();
                        // early implementations not supports chaining
                        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
                        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
                        var THROWS_ON_PRIMITIVES = fails(function() {
                            instance.has(1);
                        });
                        // most early implementations doesn't supports iterables, most modern - not close it correctly
                        // eslint-disable-next-line no-new -- required for testing
                        var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function(iterable) {
                            new NativeConstructor(iterable);
                        });
                        // for early implementations -0 and +0 not the same
                        var BUGGY_ZERO = !IS_WEAK && fails(function() {
                            // V8 ~ Chromium 42- fails only with 5+ elements
                            var $instance = new NativeConstructor();
                            var index = 5;
                            while(index--)$instance[ADDER](index, index);
                            return !$instance.has(-0);
                        });
                        if (!ACCEPT_ITERABLES) {
                            Constructor = wrapper(function(dummy, iterable) {
                                anInstance(dummy, NativePrototype);
                                var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
                                if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
                                    that: that,
                                    AS_ENTRIES: IS_MAP
                                });
                                return that;
                            });
                            Constructor.prototype = NativePrototype;
                            NativePrototype.constructor = Constructor;
                        }
                        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
                            fixMethod('delete');
                            fixMethod('has');
                            IS_MAP && fixMethod('get');
                        }
                        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
                        // weak collections should not contains .clear method
                        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
                    }
                    exported[CONSTRUCTOR_NAME] = Constructor;
                    $({
                        global: true,
                        constructor: true,
                        forced: Constructor !== NativeConstructor
                    }, exported);
                    setToStringTag(Constructor, CONSTRUCTOR_NAME);
                    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
                    return Constructor;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/copy-constructor-properties.js": /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/copy-constructor-properties.js ***!
  \***********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var ownKeys = __webpack_require__(/*! ../internals/own-keys */ "./node_modules/core-js/internals/own-keys.js");
                var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
                var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
                module1.exports = function(target, source, exceptions) {
                    var keys = ownKeys(source);
                    var defineProperty = definePropertyModule.f;
                    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                    }
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/correct-is-regexp-logic.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/correct-is-regexp-logic.js ***!
  \*******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var MATCH = wellKnownSymbol('match');
                module1.exports = function(METHOD_NAME) {
                    var regexp = /./;
                    try {
                        '/./'[METHOD_NAME](regexp);
                    } catch (error1) {
                        try {
                            regexp[MATCH] = false;
                            return '/./'[METHOD_NAME](regexp);
                        } catch (error2) {}
                    }
                    return false;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/correct-prototype-getter.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/correct-prototype-getter.js ***!
  \********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                module1.exports = !fails(function() {
                    function F() {}
                    F.prototype.constructor = null;
                    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
                    return Object.getPrototypeOf(new F()) !== F.prototype;
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/create-html.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/create-html.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var quot = /"/g;
                var replace = uncurryThis(''.replace);
                // `CreateHTML` abstract operation
                // https://tc39.es/ecma262/#sec-createhtml
                module1.exports = function(string, tag, attribute, value) {
                    var S = toString(requireObjectCoercible(string));
                    var p1 = '<' + tag;
                    if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
                    return p1 + '>' + S + '</' + tag + '>';
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/create-iter-result-object.js": /*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-iter-result-object.js ***!
  \*********************************************************************/ /***/ function(module1) {
                "use strict";
                // `CreateIterResultObject` abstract operation
                // https://tc39.es/ecma262/#sec-createiterresultobject
                module1.exports = function(value, done) {
                    return {
                        value: value,
                        done: done
                    };
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/create-non-enumerable-property.js": /*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/create-non-enumerable-property.js ***!
  \**************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
                var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
                module1.exports = DESCRIPTORS ? function(object, key, value) {
                    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
                } : function(object, key, value) {
                    object[key] = value;
                    return object;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/create-property-descriptor.js": /*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-property-descriptor.js ***!
  \**********************************************************************/ /***/ function(module1) {
                "use strict";
                module1.exports = function(bitmap, value) {
                    return {
                        enumerable: !(bitmap & 1),
                        configurable: !(bitmap & 2),
                        writable: !(bitmap & 4),
                        value: value
                    };
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/create-property.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/create-property.js ***!
  \***********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
                var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
                module1.exports = function(object, key, value) {
                    if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
                    else object[key] = value;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/define-built-in-accessor.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/define-built-in-accessor.js ***!
  \********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var makeBuiltIn = __webpack_require__(/*! ../internals/make-built-in */ "./node_modules/core-js/internals/make-built-in.js");
                var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
                module1.exports = function(target, name, descriptor) {
                    if (descriptor.get) makeBuiltIn(descriptor.get, name, {
                        getter: true
                    });
                    if (descriptor.set) makeBuiltIn(descriptor.set, name, {
                        setter: true
                    });
                    return defineProperty.f(target, name, descriptor);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/define-built-in.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/define-built-in.js ***!
  \***********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
                var makeBuiltIn = __webpack_require__(/*! ../internals/make-built-in */ "./node_modules/core-js/internals/make-built-in.js");
                var defineGlobalProperty = __webpack_require__(/*! ../internals/define-global-property */ "./node_modules/core-js/internals/define-global-property.js");
                module1.exports = function(O, key, value, options) {
                    if (!options) options = {};
                    var simple = options.enumerable;
                    var name = options.name !== undefined ? options.name : key;
                    if (isCallable(value)) makeBuiltIn(value, name, options);
                    if (options.global) {
                        if (simple) O[key] = value;
                        else defineGlobalProperty(key, value);
                    } else {
                        try {
                            if (!options.unsafe) delete O[key];
                            else if (O[key]) simple = true;
                        } catch (error) {}
                        if (simple) O[key] = value;
                        else definePropertyModule.f(O, key, {
                            value: value,
                            enumerable: false,
                            configurable: !options.nonConfigurable,
                            writable: !options.nonWritable
                        });
                    }
                    return O;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/define-built-ins.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/define-built-ins.js ***!
  \************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                module1.exports = function(target, src, options) {
                    for(var key in src)defineBuiltIn(target, key, src[key], options);
                    return target;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/define-global-property.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/define-global-property.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                var defineProperty = Object.defineProperty;
                module1.exports = function(key, value) {
                    try {
                        defineProperty(globalThis1, key, {
                            value: value,
                            configurable: true,
                            writable: true
                        });
                    } catch (error) {
                        globalThis1[key] = value;
                    }
                    return value;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/descriptors.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/descriptors.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                // Detect IE8's incomplete defineProperty implementation
                module1.exports = !fails(function() {
                    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
                    return Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1] !== 7;
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/document-create-element.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/document-create-element.js ***!
  \*******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var document1 = globalThis1.document;
                // typeof document.createElement is 'object' in old IE
                var EXISTS = isObject(document1) && isObject(document1.createElement);
                module1.exports = function(it) {
                    return EXISTS ? document1.createElement(it) : {};
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/does-not-exceed-safe-integer.js": /*!************************************************************************!*\
  !*** ./node_modules/core-js/internals/does-not-exceed-safe-integer.js ***!
  \************************************************************************/ /***/ function(module1) {
                "use strict";
                var $TypeError = TypeError;
                var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
                module1.exports = function(it) {
                    if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
                    return it;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/dom-iterables.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/dom-iterables.js ***!
  \*********************************************************/ /***/ function(module1) {
                "use strict";
                // iterable DOM collections
                // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
                module1.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/dom-token-list-prototype.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/dom-token-list-prototype.js ***!
  \********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
                var documentCreateElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");
                var classList = documentCreateElement('span').classList;
                var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
                module1.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;
            /***/ },
            /***/ "./node_modules/core-js/internals/enum-bug-keys.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/enum-bug-keys.js ***!
  \*********************************************************/ /***/ function(module1) {
                "use strict";
                // IE8- don't enum bug keys
                module1.exports = [
                    'constructor',
                    'hasOwnProperty',
                    'isPrototypeOf',
                    'propertyIsEnumerable',
                    'toLocaleString',
                    'toString',
                    'valueOf'
                ];
            /***/ },
            /***/ "./node_modules/core-js/internals/environment-is-ios-pebble.js": /*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/environment-is-ios-pebble.js ***!
  \*********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var userAgent = __webpack_require__(/*! ../internals/environment-user-agent */ "./node_modules/core-js/internals/environment-user-agent.js");
                module1.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';
            /***/ },
            /***/ "./node_modules/core-js/internals/environment-is-ios.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/environment-is-ios.js ***!
  \**************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var userAgent = __webpack_require__(/*! ../internals/environment-user-agent */ "./node_modules/core-js/internals/environment-user-agent.js");
                // eslint-disable-next-line redos/no-vulnerable -- safe
                module1.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
            /***/ },
            /***/ "./node_modules/core-js/internals/environment-is-node.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/environment-is-node.js ***!
  \***************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ENVIRONMENT = __webpack_require__(/*! ../internals/environment */ "./node_modules/core-js/internals/environment.js");
                module1.exports = ENVIRONMENT === 'NODE';
            /***/ },
            /***/ "./node_modules/core-js/internals/environment-is-webos-webkit.js": /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/environment-is-webos-webkit.js ***!
  \***********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var userAgent = __webpack_require__(/*! ../internals/environment-user-agent */ "./node_modules/core-js/internals/environment-user-agent.js");
                module1.exports = /web0s(?!.*chrome)/i.test(userAgent);
            /***/ },
            /***/ "./node_modules/core-js/internals/environment-user-agent.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/environment-user-agent.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var navigator1 = globalThis1.navigator;
                var userAgent = navigator1 && navigator1.userAgent;
                module1.exports = userAgent ? String(userAgent) : '';
            /***/ },
            /***/ "./node_modules/core-js/internals/environment-v8-version.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/environment-v8-version.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var userAgent = __webpack_require__(/*! ../internals/environment-user-agent */ "./node_modules/core-js/internals/environment-user-agent.js");
                var process = globalThis1.process;
                var Deno1 = globalThis1.Deno;
                var versions = process && process.versions || Deno1 && Deno1.version;
                var v8 = versions && versions.v8;
                var match, version;
                if (v8) {
                    match = v8.split('.');
                    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
                    // but their correct versions are not interesting for us
                    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
                }
                // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
                // so check `userAgent` even if `.v8` exists, but 0
                if (!version && userAgent) {
                    match = userAgent.match(/Edge\/(\d+)/);
                    if (!match || match[1] >= 74) {
                        match = userAgent.match(/Chrome\/(\d+)/);
                        if (match) version = +match[1];
                    }
                }
                module1.exports = version;
            /***/ },
            /***/ "./node_modules/core-js/internals/environment.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/environment.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* global Bun, Deno -- detection */ var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var userAgent = __webpack_require__(/*! ../internals/environment-user-agent */ "./node_modules/core-js/internals/environment-user-agent.js");
                var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
                var userAgentStartsWith = function(string) {
                    return userAgent.slice(0, string.length) === string;
                };
                module1.exports = function() {
                    if (userAgentStartsWith('Bun/')) return 'BUN';
                    if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
                    if (userAgentStartsWith('Deno/')) return 'DENO';
                    if (userAgentStartsWith('Node.js/')) return 'NODE';
                    if (globalThis1.Bun && typeof Bun.version == 'string') return 'BUN';
                    if (globalThis1.Deno && typeof Deno.version == 'object') return 'DENO';
                    if (classof(globalThis1.process) === 'process') return 'NODE';
                    if (globalThis1.window && globalThis1.document) return 'BROWSER';
                    return 'REST';
                }();
            /***/ },
            /***/ "./node_modules/core-js/internals/export.js": /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/export.js ***!
  \**************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
                var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                var defineGlobalProperty = __webpack_require__(/*! ../internals/define-global-property */ "./node_modules/core-js/internals/define-global-property.js");
                var copyConstructorProperties = __webpack_require__(/*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js");
                var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
                /*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module1.exports = function(options, source) {
                    var TARGET = options.target;
                    var GLOBAL = options.global;
                    var STATIC = options.stat;
                    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
                    if (GLOBAL) target = globalThis1;
                    else if (STATIC) target = globalThis1[TARGET] || defineGlobalProperty(TARGET, {});
                    else target = globalThis1[TARGET] && globalThis1[TARGET].prototype;
                    if (target) for(key in source){
                        sourceProperty = source[key];
                        if (options.dontCallGetSet) {
                            descriptor = getOwnPropertyDescriptor(target, key);
                            targetProperty = descriptor && descriptor.value;
                        } else targetProperty = target[key];
                        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
                        // contained in target
                        if (!FORCED && targetProperty !== undefined) {
                            if (typeof sourceProperty == typeof targetProperty) continue;
                            copyConstructorProperties(sourceProperty, targetProperty);
                        }
                        // add a flag to not completely full polyfills
                        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, 'sham', true);
                        defineBuiltIn(target, key, sourceProperty, options);
                    }
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/fails.js": /*!*************************************************!*\
  !*** ./node_modules/core-js/internals/fails.js ***!
  \*************************************************/ /***/ function(module1) {
                "use strict";
                module1.exports = function(exec) {
                    try {
                        return !!exec();
                    } catch (error) {
                        return true;
                    }
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js": /*!******************************************************************************!*\
  !*** ./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js ***!
  \******************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove from `core-js@4` since it's moved to entry points
                __webpack_require__(/*! ../modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                var regexpExec = __webpack_require__(/*! ../internals/regexp-exec */ "./node_modules/core-js/internals/regexp-exec.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
                var SPECIES = wellKnownSymbol('species');
                var RegExpPrototype = RegExp.prototype;
                module1.exports = function(KEY, exec, FORCED, SHAM) {
                    var SYMBOL = wellKnownSymbol(KEY);
                    var DELEGATES_TO_SYMBOL = !fails(function() {
                        // String methods call symbol-named RegExp methods
                        var O = {};
                        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                        O[SYMBOL] = function() {
                            return 7;
                        };
                        return ''[KEY](O) !== 7;
                    });
                    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
                        // Symbol-named RegExp methods call .exec
                        var execCalled = false;
                        var re = /a/;
                        if (KEY === 'split') {
                            // We can't use real regex here since it causes deoptimization
                            // and serious performance degradation in V8
                            // https://github.com/zloirock/core-js/issues/306
                            // RegExp[@@split] doesn't call the regex's exec method, but first creates
                            // a new one. We need to return the patched regex when creating the new one.
                            var constructor = {};
                            // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                            constructor[SPECIES] = function() {
                                return re;
                            };
                            re = {
                                constructor: constructor,
                                flags: ''
                            };
                            // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                            re[SYMBOL] = /./[SYMBOL];
                        }
                        re.exec = function() {
                            execCalled = true;
                            return null;
                        };
                        re[SYMBOL]('');
                        return !execCalled;
                    });
                    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
                        var nativeRegExpMethod = /./[SYMBOL];
                        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
                            var $exec = regexp.exec;
                            if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
                                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                                // polyfilled function), leasing to infinite recursion.
                                // We avoid it by directly calling the native @@method method.
                                return {
                                    done: true,
                                    value: call(nativeRegExpMethod, regexp, str, arg2)
                                };
                                return {
                                    done: true,
                                    value: call(nativeMethod, str, regexp, arg2)
                                };
                            }
                            return {
                                done: false
                            };
                        });
                        defineBuiltIn(String.prototype, KEY, methods[0]);
                        defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
                    }
                    if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/freezing.js": /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/freezing.js ***!
  \****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                module1.exports = !fails(function() {
                    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
                    return Object.isExtensible(Object.preventExtensions({}));
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/function-apply.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/function-apply.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var NATIVE_BIND = __webpack_require__(/*! ../internals/function-bind-native */ "./node_modules/core-js/internals/function-bind-native.js");
                var FunctionPrototype = Function.prototype;
                var apply = FunctionPrototype.apply;
                var call = FunctionPrototype.call;
                // eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
                module1.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function() {
                    return call.apply(apply, arguments);
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/function-bind-context.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/function-bind-context.js ***!
  \*****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this-clause */ "./node_modules/core-js/internals/function-uncurry-this-clause.js");
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var NATIVE_BIND = __webpack_require__(/*! ../internals/function-bind-native */ "./node_modules/core-js/internals/function-bind-native.js");
                var bind = uncurryThis(uncurryThis.bind);
                // optional / simple context binding
                module1.exports = function(fn, that) {
                    aCallable(fn);
                    return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function() {
                        return fn.apply(that, arguments);
                    };
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/function-bind-native.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/function-bind-native.js ***!
  \****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                module1.exports = !fails(function() {
                    // eslint-disable-next-line es/no-function-prototype-bind -- safe
                    var test = (function() {}).bind();
                    // eslint-disable-next-line no-prototype-builtins -- safe
                    return typeof test != 'function' || test.hasOwnProperty('prototype');
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/function-call.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/function-call.js ***!
  \*********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var NATIVE_BIND = __webpack_require__(/*! ../internals/function-bind-native */ "./node_modules/core-js/internals/function-bind-native.js");
                var call = Function.prototype.call;
                // eslint-disable-next-line es/no-function-prototype-bind -- safe
                module1.exports = NATIVE_BIND ? call.bind(call) : function() {
                    return call.apply(call, arguments);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/function-name.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/function-name.js ***!
  \*********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var FunctionPrototype = Function.prototype;
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
                var EXISTS = hasOwn(FunctionPrototype, 'name');
                // additional protection from minified / mangled / dropped function names
                var PROPER = EXISTS && (function something() {}).name === 'something';
                var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
                module1.exports = {
                    EXISTS: EXISTS,
                    PROPER: PROPER,
                    CONFIGURABLE: CONFIGURABLE
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/function-uncurry-this-accessor.js": /*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/function-uncurry-this-accessor.js ***!
  \**************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                module1.exports = function(object, key, method) {
                    try {
                        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                        return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
                    } catch (error) {}
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/function-uncurry-this-clause.js": /*!************************************************************************!*\
  !*** ./node_modules/core-js/internals/function-uncurry-this-clause.js ***!
  \************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var classofRaw = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                module1.exports = function(fn) {
                    // Nashorn bug:
                    //   https://github.com/zloirock/core-js/issues/1128
                    //   https://github.com/zloirock/core-js/issues/1130
                    if (classofRaw(fn) === 'Function') return uncurryThis(fn);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/function-uncurry-this.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/function-uncurry-this.js ***!
  \*****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var NATIVE_BIND = __webpack_require__(/*! ../internals/function-bind-native */ "./node_modules/core-js/internals/function-bind-native.js");
                var FunctionPrototype = Function.prototype;
                var call = FunctionPrototype.call;
                // eslint-disable-next-line es/no-function-prototype-bind -- safe
                var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
                module1.exports = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
                    return function() {
                        return call.apply(fn, arguments);
                    };
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/get-built-in.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/get-built-in.js ***!
  \********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var aFunction = function(argument) {
                    return isCallable(argument) ? argument : undefined;
                };
                module1.exports = function(namespace, method) {
                    return arguments.length < 2 ? aFunction(globalThis1[namespace]) : globalThis1[namespace] && globalThis1[namespace][method];
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/get-iterator-direct.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator-direct.js ***!
  \***************************************************************/ /***/ function(module1) {
                "use strict";
                // `GetIteratorDirect(obj)` abstract operation
                // https://tc39.es/ecma262/#sec-getiteratordirect
                module1.exports = function(obj) {
                    return {
                        iterator: obj,
                        next: obj.next,
                        done: false
                    };
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/get-iterator-method.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator-method.js ***!
  \***************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
                var getMethod = __webpack_require__(/*! ../internals/get-method */ "./node_modules/core-js/internals/get-method.js");
                var isNullOrUndefined = __webpack_require__(/*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js");
                var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var ITERATOR = wellKnownSymbol('iterator');
                module1.exports = function(it) {
                    if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/get-iterator.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator.js ***!
  \********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var tryToString = __webpack_require__(/*! ../internals/try-to-string */ "./node_modules/core-js/internals/try-to-string.js");
                var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");
                var $TypeError = TypeError;
                module1.exports = function(argument, usingIterator) {
                    var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
                    if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
                    throw new $TypeError(tryToString(argument) + ' is not iterable');
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/get-method.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/get-method.js ***!
  \******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var isNullOrUndefined = __webpack_require__(/*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js");
                // `GetMethod` abstract operation
                // https://tc39.es/ecma262/#sec-getmethod
                module1.exports = function(V, P) {
                    var func = V[P];
                    return isNullOrUndefined(func) ? undefined : aCallable(func);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/get-set-record.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/get-set-record.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var toIntegerOrInfinity = __webpack_require__(/*! ../internals/to-integer-or-infinity */ "./node_modules/core-js/internals/to-integer-or-infinity.js");
                var getIteratorDirect = __webpack_require__(/*! ../internals/get-iterator-direct */ "./node_modules/core-js/internals/get-iterator-direct.js");
                var INVALID_SIZE = 'Invalid size';
                var $RangeError = RangeError;
                var $TypeError = TypeError;
                var max = Math.max;
                var SetRecord = function(set, intSize) {
                    this.set = set;
                    this.size = max(intSize, 0);
                    this.has = aCallable(set.has);
                    this.keys = aCallable(set.keys);
                };
                SetRecord.prototype = {
                    getIterator: function() {
                        return getIteratorDirect(anObject(call(this.keys, this.set)));
                    },
                    includes: function(it) {
                        return call(this.has, this.set, it);
                    }
                };
                // `GetSetRecord` abstract operation
                // https://tc39.es/proposal-set-methods/#sec-getsetrecord
                module1.exports = function(obj) {
                    anObject(obj);
                    var numSize = +obj.size;
                    // NOTE: If size is undefined, then numSize will be NaN
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (numSize !== numSize) throw new $TypeError(INVALID_SIZE);
                    var intSize = toIntegerOrInfinity(numSize);
                    if (intSize < 0) throw new $RangeError(INVALID_SIZE);
                    return new SetRecord(obj, intSize);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/get-substitution.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/get-substitution.js ***!
  \************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
                var floor = Math.floor;
                var charAt = uncurryThis(''.charAt);
                var replace = uncurryThis(''.replace);
                var stringSlice = uncurryThis(''.slice);
                // eslint-disable-next-line redos/no-vulnerable -- safe
                var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
                var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
                // `GetSubstitution` abstract operation
                // https://tc39.es/ecma262/#sec-getsubstitution
                module1.exports = function(matched, str, position, captures, namedCaptures, replacement) {
                    var tailPos = position + matched.length;
                    var m = captures.length;
                    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
                    if (namedCaptures !== undefined) {
                        namedCaptures = toObject(namedCaptures);
                        symbols = SUBSTITUTION_SYMBOLS;
                    }
                    return replace(replacement, symbols, function(match, ch) {
                        var capture;
                        switch(charAt(ch, 0)){
                            case '$':
                                return '$';
                            case '&':
                                return matched;
                            case '`':
                                return stringSlice(str, 0, position);
                            case "'":
                                return stringSlice(str, tailPos);
                            case '<':
                                capture = namedCaptures[stringSlice(ch, 1, -1)];
                                break;
                            default:
                                var n = +ch;
                                if (n === 0) return match;
                                if (n > m) {
                                    var f = floor(n / 10);
                                    if (f === 0) return match;
                                    if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
                                    return match;
                                }
                                capture = captures[n - 1];
                        }
                        return capture === undefined ? '' : capture;
                    });
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/global-this.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/global-this.js ***!
  \*******************************************************/ /***/ function(module1) {
                "use strict";
                var check = function(it) {
                    return it && it.Math === Math && it;
                };
                // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
                module1.exports = // eslint-disable-next-line es/no-global-this -- safe
                check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
                check(typeof self == 'object' && self) || check(typeof global == 'object' && global) || check(typeof this == 'object' && this) || // eslint-disable-next-line no-new-func -- fallback
                function() {
                    return this;
                }() || Function('return this')();
            /***/ },
            /***/ "./node_modules/core-js/internals/has-own-property.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/has-own-property.js ***!
  \************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
                var hasOwnProperty = uncurryThis({}.hasOwnProperty);
                // `HasOwnProperty` abstract operation
                // https://tc39.es/ecma262/#sec-hasownproperty
                // eslint-disable-next-line es/no-object-hasown -- safe
                module1.exports = Object.hasOwn || function hasOwn(it, key) {
                    return hasOwnProperty(toObject(it), key);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/hidden-keys.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/hidden-keys.js ***!
  \*******************************************************/ /***/ function(module1) {
                "use strict";
                module1.exports = {};
            /***/ },
            /***/ "./node_modules/core-js/internals/host-report-errors.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/host-report-errors.js ***!
  \**************************************************************/ /***/ function(module1) {
                "use strict";
                module1.exports = function(a, b) {
                    try {
                        // eslint-disable-next-line no-console -- safe
                        arguments.length === 1 ? console.error(a) : console.error(a, b);
                    } catch (error) {}
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/html.js": /*!************************************************!*\
  !*** ./node_modules/core-js/internals/html.js ***!
  \************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                module1.exports = getBuiltIn('document', 'documentElement');
            /***/ },
            /***/ "./node_modules/core-js/internals/ie8-dom-define.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/ie8-dom-define.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var createElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");
                // Thanks to IE8 for its funny defineProperty
                module1.exports = !DESCRIPTORS && !fails(function() {
                    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
                    return Object.defineProperty(createElement('div'), 'a', {
                        get: function() {
                            return 7;
                        }
                    }).a !== 7;
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/indexed-object.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/indexed-object.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
                var $Object = Object;
                var split = uncurryThis(''.split);
                // fallback for non-array-like ES3 and non-enumerable old V8 strings
                module1.exports = fails(function() {
                    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
                    // eslint-disable-next-line no-prototype-builtins -- safe
                    return !$Object('z').propertyIsEnumerable(0);
                }) ? function(it) {
                    return classof(it) === 'String' ? split(it, '') : $Object(it);
                } : $Object;
            /***/ },
            /***/ "./node_modules/core-js/internals/inherit-if-required.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/inherit-if-required.js ***!
  \***************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");
                // makes subclassing work correct for wrapped built-ins
                module1.exports = function($this, dummy, Wrapper) {
                    var NewTarget, NewTargetPrototype;
                    if (// it can work only with native `setPrototypeOf`
                    setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
                    isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
                    return $this;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/inspect-source.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/inspect-source.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var store = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js");
                var functionToString = uncurryThis(Function.toString);
                // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
                if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
                    return functionToString(it);
                };
                module1.exports = store.inspectSource;
            /***/ },
            /***/ "./node_modules/core-js/internals/internal-metadata.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/internal-metadata.js ***!
  \*************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
                var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js");
                var getOwnPropertyNamesExternalModule = __webpack_require__(/*! ../internals/object-get-own-property-names-external */ "./node_modules/core-js/internals/object-get-own-property-names-external.js");
                var isExtensible = __webpack_require__(/*! ../internals/object-is-extensible */ "./node_modules/core-js/internals/object-is-extensible.js");
                var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
                var FREEZING = __webpack_require__(/*! ../internals/freezing */ "./node_modules/core-js/internals/freezing.js");
                var REQUIRED = false;
                var METADATA = uid('meta');
                var id = 0;
                var setMetadata = function(it) {
                    defineProperty(it, METADATA, {
                        value: {
                            objectID: 'O' + id++,
                            weakData: {} // weak collections IDs
                        }
                    });
                };
                var fastKey = function(it, create) {
                    // return a primitive with prefix
                    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
                    if (!hasOwn(it, METADATA)) {
                        // can't set metadata to uncaught frozen object
                        if (!isExtensible(it)) return 'F';
                        // not necessary to add metadata
                        if (!create) return 'E';
                        // add missing metadata
                        setMetadata(it);
                    // return object ID
                    }
                    return it[METADATA].objectID;
                };
                var getWeakData = function(it, create) {
                    if (!hasOwn(it, METADATA)) {
                        // can't set metadata to uncaught frozen object
                        if (!isExtensible(it)) return true;
                        // not necessary to add metadata
                        if (!create) return false;
                        // add missing metadata
                        setMetadata(it);
                    // return the store of weak collections IDs
                    }
                    return it[METADATA].weakData;
                };
                // add metadata on freeze-family methods calling
                var onFreeze = function(it) {
                    if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
                    return it;
                };
                var enable = function() {
                    meta.enable = function() {};
                    REQUIRED = true;
                    var getOwnPropertyNames = getOwnPropertyNamesModule.f;
                    var splice = uncurryThis([].splice);
                    var test = {};
                    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                    test[METADATA] = 1;
                    // prevent exposing of metadata key
                    if (getOwnPropertyNames(test).length) {
                        getOwnPropertyNamesModule.f = function(it) {
                            var result = getOwnPropertyNames(it);
                            for(var i = 0, length = result.length; i < length; i++)if (result[i] === METADATA) {
                                splice(result, i, 1);
                                break;
                            }
                            return result;
                        };
                        $({
                            target: 'Object',
                            stat: true,
                            forced: true
                        }, {
                            getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
                        });
                    }
                };
                var meta = module1.exports = {
                    enable: enable,
                    fastKey: fastKey,
                    getWeakData: getWeakData,
                    onFreeze: onFreeze
                };
                hiddenKeys[METADATA] = true;
            /***/ },
            /***/ "./node_modules/core-js/internals/internal-state.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/internal-state.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var NATIVE_WEAK_MAP = __webpack_require__(/*! ../internals/weak-map-basic-detection */ "./node_modules/core-js/internals/weak-map-basic-detection.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var shared = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js");
                var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
                var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
                var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
                var TypeError1 = globalThis1.TypeError;
                var WeakMap = globalThis1.WeakMap;
                var set, get, has;
                var enforce = function(it) {
                    return has(it) ? get(it) : set(it, {});
                };
                var getterFor = function(TYPE) {
                    return function(it) {
                        var state;
                        if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError1('Incompatible receiver, ' + TYPE + ' required');
                        return state;
                    };
                };
                if (NATIVE_WEAK_MAP || shared.state) {
                    var store = shared.state || (shared.state = new WeakMap());
                    /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
                    store.has = store.has;
                    store.set = store.set;
                    /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
                        if (store.has(it)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                        metadata.facade = it;
                        store.set(it, metadata);
                        return metadata;
                    };
                    get = function(it) {
                        return store.get(it) || {};
                    };
                    has = function(it) {
                        return store.has(it);
                    };
                } else {
                    var STATE = sharedKey('state');
                    hiddenKeys[STATE] = true;
                    set = function(it, metadata) {
                        if (hasOwn(it, STATE)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                        metadata.facade = it;
                        createNonEnumerableProperty(it, STATE, metadata);
                        return metadata;
                    };
                    get = function(it) {
                        return hasOwn(it, STATE) ? it[STATE] : {};
                    };
                    has = function(it) {
                        return hasOwn(it, STATE);
                    };
                }
                module1.exports = {
                    set: set,
                    get: get,
                    has: has,
                    enforce: enforce,
                    getterFor: getterFor
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/is-array-iterator-method.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/is-array-iterator-method.js ***!
  \********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
                var ITERATOR = wellKnownSymbol('iterator');
                var ArrayPrototype = Array.prototype;
                // check on default Array iterator
                module1.exports = function(it) {
                    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/is-array.js": /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/is-array.js ***!
  \****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
                // `IsArray` abstract operation
                // https://tc39.es/ecma262/#sec-isarray
                // eslint-disable-next-line es/no-array-isarray -- safe
                module1.exports = Array.isArray || function isArray(argument) {
                    return classof(argument) === 'Array';
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/is-callable.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/is-callable.js ***!
  \*******************************************************/ /***/ function(module1) {
                "use strict";
                // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
                var documentAll = typeof document == 'object' && document.all;
                // `IsCallable` abstract operation
                // https://tc39.es/ecma262/#sec-iscallable
                // eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
                module1.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function(argument) {
                    return typeof argument == 'function' || argument === documentAll;
                } : function(argument) {
                    return typeof argument == 'function';
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/is-constructor.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/is-constructor.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                var inspectSource = __webpack_require__(/*! ../internals/inspect-source */ "./node_modules/core-js/internals/inspect-source.js");
                var noop = function() {};
                var construct = getBuiltIn('Reflect', 'construct');
                var constructorRegExp = /^\s*(?:class|function)\b/;
                var exec = uncurryThis(constructorRegExp.exec);
                var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
                var isConstructorModern = function isConstructor(argument) {
                    if (!isCallable(argument)) return false;
                    try {
                        construct(noop, [], argument);
                        return true;
                    } catch (error) {
                        return false;
                    }
                };
                var isConstructorLegacy = function isConstructor(argument) {
                    if (!isCallable(argument)) return false;
                    switch(classof(argument)){
                        case 'AsyncFunction':
                        case 'GeneratorFunction':
                        case 'AsyncGeneratorFunction':
                            return false;
                    }
                    try {
                        // we can't check .prototype since constructors produced by .bind haven't it
                        // `Function#toString` throws on some built-it function in some legacy engines
                        // (for example, `DOMQuad` and similar in FF41-)
                        return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
                    } catch (error) {
                        return true;
                    }
                };
                isConstructorLegacy.sham = true;
                // `IsConstructor` abstract operation
                // https://tc39.es/ecma262/#sec-isconstructor
                module1.exports = !construct || fails(function() {
                    var called;
                    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
                        called = true;
                    }) || called;
                }) ? isConstructorLegacy : isConstructorModern;
            /***/ },
            /***/ "./node_modules/core-js/internals/is-forced.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-forced.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var replacement = /#|\.prototype\./;
                var isForced = function(feature, detection) {
                    var value = data[normalize(feature)];
                    return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
                };
                var normalize = isForced.normalize = function(string) {
                    return String(string).replace(replacement, '.').toLowerCase();
                };
                var data = isForced.data = {};
                var NATIVE = isForced.NATIVE = 'N';
                var POLYFILL = isForced.POLYFILL = 'P';
                module1.exports = isForced;
            /***/ },
            /***/ "./node_modules/core-js/internals/is-iterable.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/is-iterable.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var isNullOrUndefined = __webpack_require__(/*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
                var ITERATOR = wellKnownSymbol('iterator');
                var $Object = Object;
                module1.exports = function(it) {
                    if (isNullOrUndefined(it)) return false;
                    var O = $Object(it);
                    return O[ITERATOR] !== undefined || '@@iterator' in O || hasOwn(Iterators, classof(O));
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/is-null-or-undefined.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/is-null-or-undefined.js ***!
  \****************************************************************/ /***/ function(module1) {
                "use strict";
                // we can't use just `it == null` since of `document.all` special case
                // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
                module1.exports = function(it) {
                    return it === null || it === undefined;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/is-object.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-object.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                module1.exports = function(it) {
                    return typeof it == 'object' ? it !== null : isCallable(it);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/is-possible-prototype.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/is-possible-prototype.js ***!
  \*****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                module1.exports = function(argument) {
                    return isObject(argument) || argument === null;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/is-pure.js": /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/is-pure.js ***!
  \***************************************************/ /***/ function(module1) {
                "use strict";
                module1.exports = false;
            /***/ },
            /***/ "./node_modules/core-js/internals/is-raw-json.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/is-raw-json.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var getInternalState = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js").get;
                module1.exports = function isRawJSON(O) {
                    if (!isObject(O)) return false;
                    var state = getInternalState(O);
                    return !!state && state.type === 'RawJSON';
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/is-regexp.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-regexp.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var MATCH = wellKnownSymbol('match');
                // `IsRegExp` abstract operation
                // https://tc39.es/ecma262/#sec-isregexp
                module1.exports = function(it) {
                    var isRegExp;
                    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/is-symbol.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-symbol.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isPrototypeOf = __webpack_require__(/*! ../internals/object-is-prototype-of */ "./node_modules/core-js/internals/object-is-prototype-of.js");
                var USE_SYMBOL_AS_UID = __webpack_require__(/*! ../internals/use-symbol-as-uid */ "./node_modules/core-js/internals/use-symbol-as-uid.js");
                var $Object = Object;
                module1.exports = USE_SYMBOL_AS_UID ? function(it) {
                    return typeof it == 'symbol';
                } : function(it) {
                    var $Symbol = getBuiltIn('Symbol');
                    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterate-simple.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/iterate-simple.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                module1.exports = function(record, fn, ITERATOR_INSTEAD_OF_RECORD) {
                    var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
                    var next = record.next;
                    var step, result;
                    while(!(step = call(next, iterator)).done){
                        result = fn(step.value);
                        if (result !== undefined) return result;
                    }
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterate.js": /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/iterate.js ***!
  \***************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var tryToString = __webpack_require__(/*! ../internals/try-to-string */ "./node_modules/core-js/internals/try-to-string.js");
                var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js");
                var lengthOfArrayLike = __webpack_require__(/*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js");
                var isPrototypeOf = __webpack_require__(/*! ../internals/object-is-prototype-of */ "./node_modules/core-js/internals/object-is-prototype-of.js");
                var getIterator = __webpack_require__(/*! ../internals/get-iterator */ "./node_modules/core-js/internals/get-iterator.js");
                var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");
                var iteratorClose = __webpack_require__(/*! ../internals/iterator-close */ "./node_modules/core-js/internals/iterator-close.js");
                var $TypeError = TypeError;
                var Result = function(stopped, result) {
                    this.stopped = stopped;
                    this.result = result;
                };
                var ResultPrototype = Result.prototype;
                module1.exports = function(iterable, unboundFunction, options) {
                    var that = options && options.that;
                    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
                    var IS_RECORD = !!(options && options.IS_RECORD);
                    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
                    var INTERRUPTED = !!(options && options.INTERRUPTED);
                    var fn = bind(unboundFunction, that);
                    var iterator, iterFn, index, length, result, next, step;
                    var stop = function(condition) {
                        if (iterator) iteratorClose(iterator, 'normal');
                        return new Result(true, condition);
                    };
                    var callFn = function(value) {
                        if (AS_ENTRIES) {
                            anObject(value);
                            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
                        }
                        return INTERRUPTED ? fn(value, stop) : fn(value);
                    };
                    if (IS_RECORD) iterator = iterable.iterator;
                    else if (IS_ITERATOR) iterator = iterable;
                    else {
                        iterFn = getIteratorMethod(iterable);
                        if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
                        // optimisation for array iterators
                        if (isArrayIteratorMethod(iterFn)) {
                            for(index = 0, length = lengthOfArrayLike(iterable); length > index; index++){
                                result = callFn(iterable[index]);
                                if (result && isPrototypeOf(ResultPrototype, result)) return result;
                            }
                            return new Result(false);
                        }
                        iterator = getIterator(iterable, iterFn);
                    }
                    next = IS_RECORD ? iterable.next : iterator.next;
                    while(!(step = call(next, iterator)).done){
                        try {
                            result = callFn(step.value);
                        } catch (error) {
                            iteratorClose(iterator, 'throw', error);
                        }
                        if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
                    }
                    return new Result(false);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterator-close-all.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/iterator-close-all.js ***!
  \**************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var iteratorClose = __webpack_require__(/*! ../internals/iterator-close */ "./node_modules/core-js/internals/iterator-close.js");
                module1.exports = function(iters, kind, value) {
                    for(var i = iters.length - 1; i >= 0; i--){
                        if (iters[i] === undefined) continue;
                        try {
                            value = iteratorClose(iters[i].iterator, kind, value);
                        } catch (error) {
                            kind = 'throw';
                            value = error;
                        }
                    }
                    if (kind === 'throw') throw value;
                    return value;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterator-close.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/iterator-close.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var getMethod = __webpack_require__(/*! ../internals/get-method */ "./node_modules/core-js/internals/get-method.js");
                module1.exports = function(iterator, kind, value) {
                    var innerResult, innerError;
                    anObject(iterator);
                    try {
                        innerResult = getMethod(iterator, 'return');
                        if (!innerResult) {
                            if (kind === 'throw') throw value;
                            return value;
                        }
                        innerResult = call(innerResult, iterator);
                    } catch (error) {
                        innerError = true;
                        innerResult = error;
                    }
                    if (kind === 'throw') throw value;
                    if (innerError) throw innerResult;
                    anObject(innerResult);
                    return value;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterator-create-constructor.js": /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/iterator-create-constructor.js ***!
  \***********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var IteratorPrototype = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js").IteratorPrototype;
                var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
                var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
                var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
                var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
                var returnThis = function() {
                    return this;
                };
                module1.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
                    var TO_STRING_TAG = NAME + ' Iterator';
                    IteratorConstructor.prototype = create(IteratorPrototype, {
                        next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
                    });
                    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
                    Iterators[TO_STRING_TAG] = returnThis;
                    return IteratorConstructor;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterator-create-proxy.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/iterator-create-proxy.js ***!
  \*****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
                var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
                var defineBuiltIns = __webpack_require__(/*! ../internals/define-built-ins */ "./node_modules/core-js/internals/define-built-ins.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
                var getMethod = __webpack_require__(/*! ../internals/get-method */ "./node_modules/core-js/internals/get-method.js");
                var IteratorPrototype = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js").IteratorPrototype;
                var createIterResultObject = __webpack_require__(/*! ../internals/create-iter-result-object */ "./node_modules/core-js/internals/create-iter-result-object.js");
                var iteratorClose = __webpack_require__(/*! ../internals/iterator-close */ "./node_modules/core-js/internals/iterator-close.js");
                var iteratorCloseAll = __webpack_require__(/*! ../internals/iterator-close-all */ "./node_modules/core-js/internals/iterator-close-all.js");
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var ITERATOR_HELPER = 'IteratorHelper';
                var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
                var NORMAL = 'normal';
                var THROW = 'throw';
                var setInternalState = InternalStateModule.set;
                var createIteratorProxyPrototype = function(IS_ITERATOR) {
                    var getInternalState = InternalStateModule.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);
                    return defineBuiltIns(create(IteratorPrototype), {
                        next: function next() {
                            var state = getInternalState(this);
                            // for simplification:
                            //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
                            //   for `%IteratorHelperPrototype%.next` - just a value
                            if (IS_ITERATOR) return state.nextHandler();
                            if (state.done) return createIterResultObject(undefined, true);
                            try {
                                var result = state.nextHandler();
                                return state.returnHandlerResult ? result : createIterResultObject(result, state.done);
                            } catch (error) {
                                state.done = true;
                                throw error;
                            }
                        },
                        'return': function() {
                            var state = getInternalState(this);
                            var iterator = state.iterator;
                            state.done = true;
                            if (IS_ITERATOR) {
                                var returnMethod = getMethod(iterator, 'return');
                                return returnMethod ? call(returnMethod, iterator) : createIterResultObject(undefined, true);
                            }
                            if (state.inner) try {
                                iteratorClose(state.inner.iterator, NORMAL);
                            } catch (error) {
                                return iteratorClose(iterator, THROW, error);
                            }
                            if (state.openIters) try {
                                iteratorCloseAll(state.openIters, NORMAL);
                            } catch (error) {
                                return iteratorClose(iterator, THROW, error);
                            }
                            if (iterator) iteratorClose(iterator, NORMAL);
                            return createIterResultObject(undefined, true);
                        }
                    });
                };
                var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
                var IteratorHelperPrototype = createIteratorProxyPrototype(false);
                createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');
                module1.exports = function(nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
                    var IteratorProxy = function Iterator1(record, state) {
                        if (state) {
                            state.iterator = record.iterator;
                            state.next = record.next;
                        } else state = record;
                        state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
                        state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
                        state.nextHandler = nextHandler;
                        state.counter = 0;
                        state.done = false;
                        setInternalState(this, state);
                    };
                    IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
                    return IteratorProxy;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterator-define.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/iterator-define.js ***!
  \***********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var FunctionName = __webpack_require__(/*! ../internals/function-name */ "./node_modules/core-js/internals/function-name.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var createIteratorConstructor = __webpack_require__(/*! ../internals/iterator-create-constructor */ "./node_modules/core-js/internals/iterator-create-constructor.js");
                var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
                var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");
                var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
                var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
                var IteratorsCore = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js");
                var PROPER_FUNCTION_NAME = FunctionName.PROPER;
                var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
                var IteratorPrototype = IteratorsCore.IteratorPrototype;
                var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
                var ITERATOR = wellKnownSymbol('iterator');
                var KEYS = 'keys';
                var VALUES = 'values';
                var ENTRIES = 'entries';
                var returnThis = function() {
                    return this;
                };
                module1.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
                    createIteratorConstructor(IteratorConstructor, NAME, next);
                    var getIterationMethod = function(KIND) {
                        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
                        if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
                        switch(KIND){
                            case KEYS:
                                return function keys() {
                                    return new IteratorConstructor(this, KIND);
                                };
                            case VALUES:
                                return function values() {
                                    return new IteratorConstructor(this, KIND);
                                };
                            case ENTRIES:
                                return function entries() {
                                    return new IteratorConstructor(this, KIND);
                                };
                        }
                        return function() {
                            return new IteratorConstructor(this);
                        };
                    };
                    var TO_STRING_TAG = NAME + ' Iterator';
                    var INCORRECT_VALUES_NAME = false;
                    var IterablePrototype = Iterable.prototype;
                    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
                    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
                    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
                    var CurrentIteratorPrototype, methods, KEY;
                    // fix native
                    if (anyNativeIterator) {
                        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
                        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                                if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                                else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
                            }
                            // Set @@toStringTag to native iterators
                            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
                        }
                    }
                    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
                    if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
                        if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
                        else {
                            INCORRECT_VALUES_NAME = true;
                            defaultIterator = function values() {
                                return call(nativeIterator, this);
                            };
                        }
                    }
                    // export additional methods
                    if (DEFAULT) {
                        methods = {
                            values: getIterationMethod(VALUES),
                            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                            entries: getIterationMethod(ENTRIES)
                        };
                        if (FORCED) {
                            for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
                        } else $({
                            target: NAME,
                            proto: true,
                            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
                        }, methods);
                    }
                    // define iterator
                    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, {
                        name: DEFAULT
                    });
                    Iterators[NAME] = defaultIterator;
                    return methods;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterator-helper-throws-on-invalid-iterator.js": /*!**************************************************************************************!*\
  !*** ./node_modules/core-js/internals/iterator-helper-throws-on-invalid-iterator.js ***!
  \**************************************************************************************/ /***/ function(module1) {
                "use strict";
                // Should throw an error on invalid iterator
                // https://issues.chromium.org/issues/336839115
                module1.exports = function(methodName, argument) {
                    // eslint-disable-next-line es/no-iterator -- required for testing
                    var method = typeof Iterator == 'function' && Iterator.prototype[methodName];
                    if (method) try {
                        method.call({
                            next: null
                        }, argument).next();
                    } catch (error) {
                        return true;
                    }
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterator-helper-without-closing-on-early-error.js": /*!******************************************************************************************!*\
  !*** ./node_modules/core-js/internals/iterator-helper-without-closing-on-early-error.js ***!
  \******************************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                // https://github.com/tc39/ecma262/pull/3467
                module1.exports = function(METHOD_NAME, ExpectedError) {
                    var Iterator1 = globalThis1.Iterator;
                    var IteratorPrototype = Iterator1 && Iterator1.prototype;
                    var method = IteratorPrototype && IteratorPrototype[METHOD_NAME];
                    var CLOSED = false;
                    if (method) try {
                        method.call({
                            next: function() {
                                return {
                                    done: true
                                };
                            },
                            'return': function() {
                                CLOSED = true;
                            }
                        }, -1);
                    } catch (error) {
                        // https://bugs.webkit.org/show_bug.cgi?id=291195
                        if (!(error instanceof ExpectedError)) CLOSED = false;
                    }
                    if (!CLOSED) return method;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterators-core.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/iterators-core.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
                var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var ITERATOR = wellKnownSymbol('iterator');
                var BUGGY_SAFARI_ITERATORS = false;
                // `%IteratorPrototype%` object
                // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
                var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
                /* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
                    arrayIterator = [].keys();
                    // Safari 8 has buggy iterators w/o `next`
                    if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
                    else {
                        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
                        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
                    }
                }
                var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function() {
                    var test = {};
                    // FF44- legacy iterators case
                    return IteratorPrototype[ITERATOR].call(test) !== test;
                });
                if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
                else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
                // `%IteratorPrototype%[@@iterator]()` method
                // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
                if (!isCallable(IteratorPrototype[ITERATOR])) defineBuiltIn(IteratorPrototype, ITERATOR, function() {
                    return this;
                });
                module1.exports = {
                    IteratorPrototype: IteratorPrototype,
                    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/iterators.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/iterators.js ***!
  \*****************************************************/ /***/ function(module1) {
                "use strict";
                module1.exports = {};
            /***/ },
            /***/ "./node_modules/core-js/internals/length-of-array-like.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/length-of-array-like.js ***!
  \****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
                // `LengthOfArrayLike` abstract operation
                // https://tc39.es/ecma262/#sec-lengthofarraylike
                module1.exports = function(obj) {
                    return toLength(obj.length);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/make-built-in.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/make-built-in.js ***!
  \*********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(/*! ../internals/function-name */ "./node_modules/core-js/internals/function-name.js").CONFIGURABLE;
                var inspectSource = __webpack_require__(/*! ../internals/inspect-source */ "./node_modules/core-js/internals/inspect-source.js");
                var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
                var enforceInternalState = InternalStateModule.enforce;
                var getInternalState = InternalStateModule.get;
                var $String = String;
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                var defineProperty = Object.defineProperty;
                var stringSlice = uncurryThis(''.slice);
                var replace = uncurryThis(''.replace);
                var join = uncurryThis([].join);
                var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function() {
                    return defineProperty(function() {}, 'length', {
                        value: 8
                    }).length !== 8;
                });
                var TEMPLATE = String(String).split('String');
                var makeBuiltIn = module1.exports = function(value, name, options) {
                    if (stringSlice($String(name), 0, 7) === 'Symbol(') name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
                    if (options && options.getter) name = 'get ' + name;
                    if (options && options.setter) name = 'set ' + name;
                    if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
                        if (DESCRIPTORS) defineProperty(value, 'name', {
                            value: name,
                            configurable: true
                        });
                        else value.name = name;
                    }
                    if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) defineProperty(value, 'length', {
                        value: options.arity
                    });
                    try {
                        if (options && hasOwn(options, 'constructor') && options.constructor) {
                            if (DESCRIPTORS) defineProperty(value, 'prototype', {
                                writable: false
                            });
                        } else if (value.prototype) value.prototype = undefined;
                    } catch (error) {}
                    var state = enforceInternalState(value);
                    if (!hasOwn(state, 'source')) state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
                    return value;
                };
                // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
                // eslint-disable-next-line no-extend-native -- required
                Function.prototype.toString = makeBuiltIn(function toString() {
                    return isCallable(this) && getInternalState(this).source || inspectSource(this);
                }, 'toString');
            /***/ },
            /***/ "./node_modules/core-js/internals/math-trunc.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/math-trunc.js ***!
  \******************************************************/ /***/ function(module1) {
                "use strict";
                var ceil = Math.ceil;
                var floor = Math.floor;
                // `Math.trunc` method
                // https://tc39.es/ecma262/#sec-math.trunc
                // eslint-disable-next-line es/no-math-trunc -- safe
                module1.exports = Math.trunc || function trunc(x) {
                    var n = +x;
                    return (n > 0 ? floor : ceil)(n);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/microtask.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/microtask.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var safeGetBuiltIn = __webpack_require__(/*! ../internals/safe-get-built-in */ "./node_modules/core-js/internals/safe-get-built-in.js");
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var macrotask = __webpack_require__(/*! ../internals/task */ "./node_modules/core-js/internals/task.js").set;
                var Queue = __webpack_require__(/*! ../internals/queue */ "./node_modules/core-js/internals/queue.js");
                var IS_IOS = __webpack_require__(/*! ../internals/environment-is-ios */ "./node_modules/core-js/internals/environment-is-ios.js");
                var IS_IOS_PEBBLE = __webpack_require__(/*! ../internals/environment-is-ios-pebble */ "./node_modules/core-js/internals/environment-is-ios-pebble.js");
                var IS_WEBOS_WEBKIT = __webpack_require__(/*! ../internals/environment-is-webos-webkit */ "./node_modules/core-js/internals/environment-is-webos-webkit.js");
                var IS_NODE = __webpack_require__(/*! ../internals/environment-is-node */ "./node_modules/core-js/internals/environment-is-node.js");
                var MutationObserver = globalThis1.MutationObserver || globalThis1.WebKitMutationObserver;
                var document1 = globalThis1.document;
                var process = globalThis1.process;
                var Promise1 = globalThis1.Promise;
                var microtask = safeGetBuiltIn('queueMicrotask');
                var notify, toggle, node, promise, then;
                // modern engines have queueMicrotask method
                if (!microtask) {
                    var queue = new Queue();
                    var flush = function() {
                        var parent, fn;
                        if (IS_NODE && (parent = process.domain)) parent.exit();
                        while(fn = queue.get())try {
                            fn();
                        } catch (error) {
                            if (queue.head) notify();
                            throw error;
                        }
                        if (parent) parent.enter();
                    };
                    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
                    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
                    if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document1) {
                        toggle = true;
                        node = document1.createTextNode('');
                        new MutationObserver(flush).observe(node, {
                            characterData: true
                        });
                        notify = function() {
                            node.data = toggle = !toggle;
                        };
                    // environments with maybe non-completely correct, but existent Promise
                    } else if (!IS_IOS_PEBBLE && Promise1 && Promise1.resolve) {
                        // Promise.resolve without an argument throws an error in LG WebOS 2
                        promise = Promise1.resolve(undefined);
                        // workaround of WebKit ~ iOS Safari 10.1 bug
                        promise.constructor = Promise1;
                        then = bind(promise.then, promise);
                        notify = function() {
                            then(flush);
                        };
                    // Node.js without promises
                    } else if (IS_NODE) notify = function() {
                        process.nextTick(flush);
                    };
                    else {
                        // `webpack` dev server bug on IE global methods - use bind(fn, global)
                        macrotask = bind(macrotask, globalThis1);
                        notify = function() {
                            macrotask(flush);
                        };
                    }
                    microtask = function(fn) {
                        if (!queue.head) notify();
                        queue.add(fn);
                    };
                }
                module1.exports = microtask;
            /***/ },
            /***/ "./node_modules/core-js/internals/native-raw-json.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/native-raw-json.js ***!
  \***********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable es/no-json -- safe */ var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                module1.exports = !fails(function() {
                    var unsafeInt = '9007199254740993';
                    // eslint-disable-next-line es/no-nonstandard-json-properties -- feature detection
                    var raw = JSON.rawJSON(unsafeInt);
                    // eslint-disable-next-line es/no-nonstandard-json-properties -- feature detection
                    return !JSON.isRawJSON(raw) || JSON.stringify(raw) !== unsafeInt;
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/new-promise-capability.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/new-promise-capability.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var $TypeError = TypeError;
                var PromiseCapability = function(C) {
                    var resolve, reject;
                    this.promise = new C(function($$resolve, $$reject) {
                        if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
                        resolve = $$resolve;
                        reject = $$reject;
                    });
                    this.resolve = aCallable(resolve);
                    this.reject = aCallable(reject);
                };
                // `NewPromiseCapability` abstract operation
                // https://tc39.es/ecma262/#sec-newpromisecapability
                module1.exports.f = function(C) {
                    return new PromiseCapability(C);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/not-a-regexp.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/not-a-regexp.js ***!
  \********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isRegExp = __webpack_require__(/*! ../internals/is-regexp */ "./node_modules/core-js/internals/is-regexp.js");
                var $TypeError = TypeError;
                module1.exports = function(it) {
                    if (isRegExp(it)) throw new $TypeError("The method doesn't accept regular expressions");
                    return it;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/object-assign.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-assign.js ***!
  \*********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
                var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
                var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
                var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
                var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
                // eslint-disable-next-line es/no-object-assign -- safe
                var $assign = Object.assign;
                // eslint-disable-next-line es/no-object-defineproperty -- required for testing
                var defineProperty = Object.defineProperty;
                var concat = uncurryThis([].concat);
                // `Object.assign` method
                // https://tc39.es/ecma262/#sec-object.assign
                module1.exports = !$assign || fails(function() {
                    // should have correct order of operations (Edge bug)
                    if (DESCRIPTORS && $assign({
                        b: 1
                    }, $assign(defineProperty({}, 'a', {
                        enumerable: true,
                        get: function() {
                            defineProperty(this, 'b', {
                                value: 3,
                                enumerable: false
                            });
                        }
                    }), {
                        b: 2
                    })).b !== 1) return true;
                    // should work with symbols and should have deterministic property order (V8 bug)
                    var A = {};
                    var B = {};
                    // eslint-disable-next-line es/no-symbol -- safe
                    var symbol = Symbol('assign detection');
                    var alphabet = 'abcdefghijklmnopqrst';
                    A[symbol] = 7;
                    // eslint-disable-next-line es/no-array-prototype-foreach -- safe
                    alphabet.split('').forEach(function(chr) {
                        B[chr] = chr;
                    });
                    return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
                }) ? function assign(target, source) {
                    var T = toObject(target);
                    var argumentsLength = arguments.length;
                    var index = 1;
                    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                    var propertyIsEnumerable = propertyIsEnumerableModule.f;
                    while(argumentsLength > index){
                        var S = IndexedObject(arguments[index++]);
                        var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
                        var length = keys.length;
                        var j = 0;
                        var key;
                        while(length > j){
                            key = keys[j++];
                            if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
                        }
                    }
                    return T;
                } : $assign;
            /***/ },
            /***/ "./node_modules/core-js/internals/object-create.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-create.js ***!
  \*********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* global ActiveXObject -- old IE, WSH */ var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var definePropertiesModule = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/core-js/internals/object-define-properties.js");
                var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");
                var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
                var html = __webpack_require__(/*! ../internals/html */ "./node_modules/core-js/internals/html.js");
                var documentCreateElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");
                var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
                var GT = '>';
                var LT = '<';
                var PROTOTYPE = 'prototype';
                var SCRIPT = 'script';
                var IE_PROTO = sharedKey('IE_PROTO');
                var EmptyConstructor = function() {};
                var scriptTag = function(content) {
                    return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
                };
                // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
                var NullProtoObjectViaActiveX = function(activeXDocument) {
                    activeXDocument.write(scriptTag(''));
                    activeXDocument.close();
                    var temp = activeXDocument.parentWindow.Object;
                    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
                    activeXDocument = null;
                    return temp;
                };
                // Create object with fake `null` prototype: use iframe Object with cleared prototype
                var NullProtoObjectViaIFrame = function() {
                    // Thrash, waste and sodomy: IE GC bug
                    var iframe = documentCreateElement('iframe');
                    var JS = 'java' + SCRIPT + ':';
                    var iframeDocument;
                    iframe.style.display = 'none';
                    html.appendChild(iframe);
                    // https://github.com/zloirock/core-js/issues/475
                    iframe.src = String(JS);
                    iframeDocument = iframe.contentWindow.document;
                    iframeDocument.open();
                    iframeDocument.write(scriptTag('document.F=Object'));
                    iframeDocument.close();
                    return iframeDocument.F;
                };
                // Check for document.domain and active x support
                // No need to use active x approach when document.domain is not set
                // see https://github.com/es-shims/es5-shim/issues/150
                // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
                // avoid IE GC bug
                var activeXDocument;
                var NullProtoObject = function() {
                    try {
                        activeXDocument = new ActiveXObject('htmlfile');
                    } catch (error) {}
                    NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
                     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
                    var length = enumBugKeys.length;
                    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
                    return NullProtoObject();
                };
                hiddenKeys[IE_PROTO] = true;
                // `Object.create` method
                // https://tc39.es/ecma262/#sec-object.create
                // eslint-disable-next-line es/no-object-create -- safe
                module1.exports = Object.create || function create(O, Properties) {
                    var result;
                    if (O !== null) {
                        EmptyConstructor[PROTOTYPE] = anObject(O);
                        result = new EmptyConstructor();
                        EmptyConstructor[PROTOTYPE] = null;
                        // add "__proto__" for Object.getPrototypeOf polyfill
                        result[IE_PROTO] = O;
                    } else result = NullProtoObject();
                    return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/object-define-properties.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-properties.js ***!
  \********************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(/*! ../internals/v8-prototype-define-bug */ "./node_modules/core-js/internals/v8-prototype-define-bug.js");
                var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
                var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
                // `Object.defineProperties` method
                // https://tc39.es/ecma262/#sec-object.defineproperties
                // eslint-disable-next-line es/no-object-defineproperties -- safe
                exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
                    anObject(O);
                    var props = toIndexedObject(Properties);
                    var keys = objectKeys(Properties);
                    var length = keys.length;
                    var index = 0;
                    var key;
                    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
                    return O;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/object-define-property.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-property.js ***!
  \******************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js");
                var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(/*! ../internals/v8-prototype-define-bug */ "./node_modules/core-js/internals/v8-prototype-define-bug.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var toPropertyKey = __webpack_require__(/*! ../internals/to-property-key */ "./node_modules/core-js/internals/to-property-key.js");
                var $TypeError = TypeError;
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                var $defineProperty = Object.defineProperty;
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                var ENUMERABLE = 'enumerable';
                var CONFIGURABLE = 'configurable';
                var WRITABLE = 'writable';
                // `Object.defineProperty` method
                // https://tc39.es/ecma262/#sec-object.defineproperty
                exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
                    anObject(O);
                    P = toPropertyKey(P);
                    anObject(Attributes);
                    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
                        var current = $getOwnPropertyDescriptor(O, P);
                        if (current && current[WRITABLE]) {
                            O[P] = Attributes.value;
                            Attributes = {
                                configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                                writable: false
                            };
                        }
                    }
                    return $defineProperty(O, P, Attributes);
                } : $defineProperty : function defineProperty(O, P, Attributes) {
                    anObject(O);
                    P = toPropertyKey(P);
                    anObject(Attributes);
                    if (IE8_DOM_DEFINE) try {
                        return $defineProperty(O, P, Attributes);
                    } catch (error) {}
                    if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
                    if ('value' in Attributes) O[P] = Attributes.value;
                    return O;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/object-get-own-property-descriptor.js": /*!******************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-descriptor.js ***!
  \******************************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
                var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
                var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
                var toPropertyKey = __webpack_require__(/*! ../internals/to-property-key */ "./node_modules/core-js/internals/to-property-key.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js");
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                // `Object.getOwnPropertyDescriptor` method
                // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
                exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
                    O = toIndexedObject(O);
                    P = toPropertyKey(P);
                    if (IE8_DOM_DEFINE) try {
                        return $getOwnPropertyDescriptor(O, P);
                    } catch (error) {}
                    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/object-get-own-property-names-external.js": /*!**********************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names-external.js ***!
  \**********************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable es/no-object-getownpropertynames -- safe */ var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
                var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
                var $getOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js").f;
                var arraySlice = __webpack_require__(/*! ../internals/array-slice */ "./node_modules/core-js/internals/array-slice.js");
                var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                var getWindowNames = function(it) {
                    try {
                        return $getOwnPropertyNames(it);
                    } catch (error) {
                        return arraySlice(windowNames);
                    }
                };
                // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
                module1.exports.f = function getOwnPropertyNames(it) {
                    return windowNames && classof(it) === 'Window' ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/object-get-own-property-names.js": /*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names.js ***!
  \*************************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js");
                var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");
                var hiddenKeys = enumBugKeys.concat('length', 'prototype');
                // `Object.getOwnPropertyNames` method
                // https://tc39.es/ecma262/#sec-object.getownpropertynames
                // eslint-disable-next-line es/no-object-getownpropertynames -- safe
                exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                    return internalObjectKeys(O, hiddenKeys);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/object-get-own-property-symbols.js": /*!***************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-symbols.js ***!
  \***************************************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
                exports.f = Object.getOwnPropertySymbols;
            /***/ },
            /***/ "./node_modules/core-js/internals/object-get-prototype-of.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-prototype-of.js ***!
  \*******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
                var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
                var CORRECT_PROTOTYPE_GETTER = __webpack_require__(/*! ../internals/correct-prototype-getter */ "./node_modules/core-js/internals/correct-prototype-getter.js");
                var IE_PROTO = sharedKey('IE_PROTO');
                var $Object = Object;
                var ObjectPrototype = $Object.prototype;
                // `Object.getPrototypeOf` method
                // https://tc39.es/ecma262/#sec-object.getprototypeof
                // eslint-disable-next-line es/no-object-getprototypeof -- safe
                module1.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function(O) {
                    var object = toObject(O);
                    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
                    var constructor = object.constructor;
                    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
                    return object instanceof $Object ? ObjectPrototype : null;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/object-is-extensible.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/object-is-extensible.js ***!
  \****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
                var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(/*! ../internals/array-buffer-non-extensible */ "./node_modules/core-js/internals/array-buffer-non-extensible.js");
                // eslint-disable-next-line es/no-object-isextensible -- safe
                var $isExtensible = Object.isExtensible;
                var FAILS_ON_PRIMITIVES = fails(function() {
                    $isExtensible(1);
                });
                // `Object.isExtensible` method
                // https://tc39.es/ecma262/#sec-object.isextensible
                module1.exports = FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
                    if (!isObject(it)) return false;
                    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
                    return $isExtensible ? $isExtensible(it) : true;
                } : $isExtensible;
            /***/ },
            /***/ "./node_modules/core-js/internals/object-is-prototype-of.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-is-prototype-of.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                module1.exports = uncurryThis({}.isPrototypeOf);
            /***/ },
            /***/ "./node_modules/core-js/internals/object-keys-internal.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys-internal.js ***!
  \****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
                var indexOf = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js").indexOf;
                var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
                var push = uncurryThis([].push);
                module1.exports = function(object, names) {
                    var O = toIndexedObject(object);
                    var i = 0;
                    var result = [];
                    var key;
                    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
                    // Don't enum bug & hidden keys
                    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
                    return result;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/object-keys.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js");
                var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");
                // `Object.keys` method
                // https://tc39.es/ecma262/#sec-object.keys
                // eslint-disable-next-line es/no-object-keys -- safe
                module1.exports = Object.keys || function keys(O) {
                    return internalObjectKeys(O, enumBugKeys);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/object-property-is-enumerable.js": /*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-property-is-enumerable.js ***!
  \*************************************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var $propertyIsEnumerable = {}.propertyIsEnumerable;
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                // Nashorn ~ JDK8 bug
                var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
                    1: 2
                }, 1);
                // `Object.prototype.propertyIsEnumerable` method implementation
                // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
                exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
                    var descriptor = getOwnPropertyDescriptor(this, V);
                    return !!descriptor && descriptor.enumerable;
                } : $propertyIsEnumerable;
            /***/ },
            /***/ "./node_modules/core-js/internals/object-set-prototype-of.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-set-prototype-of.js ***!
  \*******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable no-proto -- safe */ var uncurryThisAccessor = __webpack_require__(/*! ../internals/function-uncurry-this-accessor */ "./node_modules/core-js/internals/function-uncurry-this-accessor.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var aPossiblePrototype = __webpack_require__(/*! ../internals/a-possible-prototype */ "./node_modules/core-js/internals/a-possible-prototype.js");
                // `Object.setPrototypeOf` method
                // https://tc39.es/ecma262/#sec-object.setprototypeof
                // Works with __proto__ only. Old v8 can't work with null proto objects.
                // eslint-disable-next-line es/no-object-setprototypeof -- safe
                module1.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
                    var CORRECT_SETTER = false;
                    var test = {};
                    var setter;
                    try {
                        setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
                        setter(test, []);
                        CORRECT_SETTER = test instanceof Array;
                    } catch (error) {}
                    return function setPrototypeOf(O, proto) {
                        requireObjectCoercible(O);
                        aPossiblePrototype(proto);
                        if (!isObject(O)) return O;
                        if (CORRECT_SETTER) setter(O, proto);
                        else O.__proto__ = proto;
                        return O;
                    };
                }() : undefined);
            /***/ },
            /***/ "./node_modules/core-js/internals/object-to-string.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/object-to-string.js ***!
  \************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js");
                var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
                // `Object.prototype.toString` method implementation
                // https://tc39.es/ecma262/#sec-object.prototype.tostring
                module1.exports = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
                    return '[object ' + classof(this) + ']';
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/ordinary-to-primitive.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/ordinary-to-primitive.js ***!
  \*****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var $TypeError = TypeError;
                // `OrdinaryToPrimitive` abstract operation
                // https://tc39.es/ecma262/#sec-ordinarytoprimitive
                module1.exports = function(input, pref) {
                    var fn, val;
                    if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
                    if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                    throw new $TypeError("Can't convert object to primitive value");
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/own-keys.js": /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/own-keys.js ***!
  \****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js");
                var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var concat = uncurryThis([].concat);
                // all object keys, includes non-enumerable and symbols
                module1.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
                    var keys = getOwnPropertyNamesModule.f(anObject(it));
                    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/parse-json-string.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/parse-json-string.js ***!
  \*************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var $SyntaxError = SyntaxError;
                var $parseInt = parseInt;
                var fromCharCode = String.fromCharCode;
                var at = uncurryThis(''.charAt);
                var slice = uncurryThis(''.slice);
                var exec = uncurryThis(/./.exec);
                var codePoints = {
                    '\\"': '"',
                    '\\\\': '\\',
                    '\\/': '/',
                    '\\b': '\b',
                    '\\f': '\f',
                    '\\n': '\n',
                    '\\r': '\r',
                    '\\t': '\t'
                };
                var IS_4_HEX_DIGITS = /^[\da-f]{4}$/i;
                // eslint-disable-next-line regexp/no-control-character -- safe
                var IS_C0_CONTROL_CODE = /^[\u0000-\u001F]$/;
                module1.exports = function(source, i) {
                    var unterminated = true;
                    var value = '';
                    while(i < source.length){
                        var chr = at(source, i);
                        if (chr === '\\') {
                            var twoChars = slice(source, i, i + 2);
                            if (hasOwn(codePoints, twoChars)) {
                                value += codePoints[twoChars];
                                i += 2;
                            } else if (twoChars === '\\u') {
                                i += 2;
                                var fourHexDigits = slice(source, i, i + 4);
                                if (!exec(IS_4_HEX_DIGITS, fourHexDigits)) throw new $SyntaxError('Bad Unicode escape at: ' + i);
                                value += fromCharCode($parseInt(fourHexDigits, 16));
                                i += 4;
                            } else throw new $SyntaxError('Unknown escape sequence: "' + twoChars + '"');
                        } else if (chr === '"') {
                            unterminated = false;
                            i++;
                            break;
                        } else {
                            if (exec(IS_C0_CONTROL_CODE, chr)) throw new $SyntaxError('Bad control character in string literal at: ' + i);
                            value += chr;
                            i++;
                        }
                    }
                    if (unterminated) throw new $SyntaxError('Unterminated string at: ' + i);
                    return {
                        value: value,
                        end: i
                    };
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/path.js": /*!************************************************!*\
  !*** ./node_modules/core-js/internals/path.js ***!
  \************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                module1.exports = globalThis1;
            /***/ },
            /***/ "./node_modules/core-js/internals/perform.js": /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/perform.js ***!
  \***************************************************/ /***/ function(module1) {
                "use strict";
                module1.exports = function(exec) {
                    try {
                        return {
                            error: false,
                            value: exec()
                        };
                    } catch (error) {
                        return {
                            error: true,
                            value: error
                        };
                    }
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/promise-constructor-detection.js": /*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/promise-constructor-detection.js ***!
  \*************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var NativePromiseConstructor = __webpack_require__(/*! ../internals/promise-native-constructor */ "./node_modules/core-js/internals/promise-native-constructor.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
                var inspectSource = __webpack_require__(/*! ../internals/inspect-source */ "./node_modules/core-js/internals/inspect-source.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var ENVIRONMENT = __webpack_require__(/*! ../internals/environment */ "./node_modules/core-js/internals/environment.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var V8_VERSION = __webpack_require__(/*! ../internals/environment-v8-version */ "./node_modules/core-js/internals/environment-v8-version.js");
                var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
                var SPECIES = wellKnownSymbol('species');
                var SUBCLASSING = false;
                var NATIVE_PROMISE_REJECTION_EVENT = isCallable(globalThis1.PromiseRejectionEvent);
                var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function() {
                    var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
                    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
                    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
                    // We can't detect it synchronously, so just check versions
                    if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
                    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
                    if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
                    // We can't use @@species feature detection in V8 since it causes
                    // deoptimization and performance degradation
                    // https://github.com/zloirock/core-js/issues/679
                    if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
                        // Detect correctness of subclassing with @@species support
                        var promise = new NativePromiseConstructor(function(resolve) {
                            resolve(1);
                        });
                        var FakePromise = function(exec) {
                            exec(function() {}, function() {});
                        };
                        var constructor = promise.constructor = {};
                        constructor[SPECIES] = FakePromise;
                        SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
                        if (!SUBCLASSING) return true;
                    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
                    }
                    return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT;
                });
                module1.exports = {
                    CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
                    REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
                    SUBCLASSING: SUBCLASSING
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/promise-native-constructor.js": /*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/promise-native-constructor.js ***!
  \**********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                module1.exports = globalThis1.Promise;
            /***/ },
            /***/ "./node_modules/core-js/internals/promise-resolve.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/promise-resolve.js ***!
  \***********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var newPromiseCapability = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js/internals/new-promise-capability.js");
                module1.exports = function(C, x) {
                    anObject(C);
                    if (isObject(x) && x.constructor === C) return x;
                    var promiseCapability = newPromiseCapability.f(C);
                    var resolve = promiseCapability.resolve;
                    resolve(x);
                    return promiseCapability.promise;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/promise-statics-incorrect-iteration.js": /*!*******************************************************************************!*\
  !*** ./node_modules/core-js/internals/promise-statics-incorrect-iteration.js ***!
  \*******************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var NativePromiseConstructor = __webpack_require__(/*! ../internals/promise-native-constructor */ "./node_modules/core-js/internals/promise-native-constructor.js");
                var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js");
                var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(/*! ../internals/promise-constructor-detection */ "./node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR;
                module1.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function(iterable) {
                    NativePromiseConstructor.all(iterable).then(undefined, function() {});
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/queue.js": /*!*************************************************!*\
  !*** ./node_modules/core-js/internals/queue.js ***!
  \*************************************************/ /***/ function(module1) {
                "use strict";
                var Queue = function() {
                    this.head = null;
                    this.tail = null;
                };
                Queue.prototype = {
                    add: function(item) {
                        var entry = {
                            item: item,
                            next: null
                        };
                        var tail = this.tail;
                        if (tail) tail.next = entry;
                        else this.head = entry;
                        this.tail = entry;
                    },
                    get: function() {
                        var entry = this.head;
                        if (entry) {
                            var next = this.head = entry.next;
                            if (next === null) this.tail = null;
                            return entry.item;
                        }
                    }
                };
                module1.exports = Queue;
            /***/ },
            /***/ "./node_modules/core-js/internals/regexp-exec-abstract.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-exec-abstract.js ***!
  \****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
                var regexpExec = __webpack_require__(/*! ../internals/regexp-exec */ "./node_modules/core-js/internals/regexp-exec.js");
                var $TypeError = TypeError;
                // `RegExpExec` abstract operation
                // https://tc39.es/ecma262/#sec-regexpexec
                module1.exports = function(R, S) {
                    var exec = R.exec;
                    if (isCallable(exec)) {
                        var result = call(exec, R, S);
                        if (result !== null) anObject(result);
                        return result;
                    }
                    if (classof(R) === 'RegExp') return call(regexpExec, R, S);
                    throw new $TypeError('RegExp#exec called on incompatible receiver');
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/regexp-exec.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-exec.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var regexpFlags = __webpack_require__(/*! ../internals/regexp-flags */ "./node_modules/core-js/internals/regexp-flags.js");
                var stickyHelpers = __webpack_require__(/*! ../internals/regexp-sticky-helpers */ "./node_modules/core-js/internals/regexp-sticky-helpers.js");
                var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
                var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
                var getInternalState = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js").get;
                var UNSUPPORTED_DOT_ALL = __webpack_require__(/*! ../internals/regexp-unsupported-dot-all */ "./node_modules/core-js/internals/regexp-unsupported-dot-all.js");
                var UNSUPPORTED_NCG = __webpack_require__(/*! ../internals/regexp-unsupported-ncg */ "./node_modules/core-js/internals/regexp-unsupported-ncg.js");
                var nativeReplace = shared('native-string-replace', String.prototype.replace);
                var nativeExec = RegExp.prototype.exec;
                var patchedExec = nativeExec;
                var charAt = uncurryThis(''.charAt);
                var indexOf = uncurryThis(''.indexOf);
                var replace = uncurryThis(''.replace);
                var stringSlice = uncurryThis(''.slice);
                var UPDATES_LAST_INDEX_WRONG = function() {
                    var re1 = /a/;
                    var re2 = /b*/g;
                    call(nativeExec, re1, 'a');
                    call(nativeExec, re2, 'a');
                    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
                }();
                var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;
                // nonparticipating capturing group, copied from es5-shim's String#split patch.
                var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
                var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
                if (PATCH) patchedExec = function exec(string) {
                    var re = this;
                    var state = getInternalState(re);
                    var str = toString(string);
                    var raw = state.raw;
                    var result, reCopy, lastIndex, match, i, object, group;
                    if (raw) {
                        raw.lastIndex = re.lastIndex;
                        result = call(patchedExec, raw, str);
                        re.lastIndex = raw.lastIndex;
                        return result;
                    }
                    var groups = state.groups;
                    var sticky = UNSUPPORTED_Y && re.sticky;
                    var flags = call(regexpFlags, re);
                    var source = re.source;
                    var charsAdded = 0;
                    var strCopy = str;
                    if (sticky) {
                        flags = replace(flags, 'y', '');
                        if (indexOf(flags, 'g') === -1) flags += 'g';
                        strCopy = stringSlice(str, re.lastIndex);
                        // Support anchored sticky behavior.
                        if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
                            source = '(?: ' + source + ')';
                            strCopy = ' ' + strCopy;
                            charsAdded++;
                        }
                        // ^(? + rx + ) is needed, in combination with some str slicing, to
                        // simulate the 'y' flag.
                        reCopy = new RegExp('^(?:' + source + ')', flags);
                    }
                    if (NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
                    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
                    match = call(nativeExec, sticky ? reCopy : re, strCopy);
                    if (sticky) {
                        if (match) {
                            match.input = stringSlice(match.input, charsAdded);
                            match[0] = stringSlice(match[0], charsAdded);
                            match.index = re.lastIndex;
                            re.lastIndex += match[0].length;
                        } else re.lastIndex = 0;
                    } else if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
                    if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
                    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
                    call(nativeReplace, match[0], reCopy, function() {
                        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
                    });
                    if (match && groups) {
                        match.groups = object = create(null);
                        for(i = 0; i < groups.length; i++){
                            group = groups[i];
                            object[group[0]] = match[group[1]];
                        }
                    }
                    return match;
                };
                module1.exports = patchedExec;
            /***/ },
            /***/ "./node_modules/core-js/internals/regexp-flags-detection.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-flags-detection.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                // babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
                var RegExp1 = globalThis1.RegExp;
                var FLAGS_GETTER_IS_CORRECT = !fails(function() {
                    var INDICES_SUPPORT = true;
                    try {
                        RegExp1('.', 'd');
                    } catch (error) {
                        INDICES_SUPPORT = false;
                    }
                    var O = {};
                    // modern V8 bug
                    var calls = '';
                    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
                    var addGetter = function(key, chr) {
                        // eslint-disable-next-line es/no-object-defineproperty -- safe
                        Object.defineProperty(O, key, {
                            get: function() {
                                calls += chr;
                                return true;
                            }
                        });
                    };
                    var pairs = {
                        dotAll: 's',
                        global: 'g',
                        ignoreCase: 'i',
                        multiline: 'm',
                        sticky: 'y'
                    };
                    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
                    for(var key in pairs)addGetter(key, pairs[key]);
                    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                    var result = Object.getOwnPropertyDescriptor(RegExp1.prototype, 'flags').get.call(O);
                    return result !== expected || calls !== expected;
                });
                module1.exports = {
                    correct: FLAGS_GETTER_IS_CORRECT
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/regexp-flags.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-flags.js ***!
  \********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                // `RegExp.prototype.flags` getter implementation
                // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
                module1.exports = function() {
                    var that = anObject(this);
                    var result = '';
                    if (that.hasIndices) result += 'd';
                    if (that.global) result += 'g';
                    if (that.ignoreCase) result += 'i';
                    if (that.multiline) result += 'm';
                    if (that.dotAll) result += 's';
                    if (that.unicode) result += 'u';
                    if (that.unicodeSets) result += 'v';
                    if (that.sticky) result += 'y';
                    return result;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/regexp-get-flags.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-get-flags.js ***!
  \************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var isPrototypeOf = __webpack_require__(/*! ../internals/object-is-prototype-of */ "./node_modules/core-js/internals/object-is-prototype-of.js");
                var regExpFlagsDetection = __webpack_require__(/*! ../internals/regexp-flags-detection */ "./node_modules/core-js/internals/regexp-flags-detection.js");
                var regExpFlagsGetterImplementation = __webpack_require__(/*! ../internals/regexp-flags */ "./node_modules/core-js/internals/regexp-flags.js");
                var RegExpPrototype = RegExp.prototype;
                module1.exports = regExpFlagsDetection.correct ? function(it) {
                    return it.flags;
                } : function(it) {
                    return !regExpFlagsDetection.correct && isPrototypeOf(RegExpPrototype, it) && !hasOwn(it, 'flags') ? call(regExpFlagsGetterImplementation, it) : it.flags;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/regexp-sticky-helpers.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-sticky-helpers.js ***!
  \*****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                // babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
                var $RegExp = globalThis1.RegExp;
                var UNSUPPORTED_Y = fails(function() {
                    var re = $RegExp('a', 'y');
                    re.lastIndex = 2;
                    return re.exec('abcd') !== null;
                });
                // UC Browser bug
                // https://github.com/zloirock/core-js/issues/1008
                var MISSED_STICKY = UNSUPPORTED_Y || fails(function() {
                    return !$RegExp('a', 'y').sticky;
                });
                var BROKEN_CARET = UNSUPPORTED_Y || fails(function() {
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
                    var re = $RegExp('^r', 'gy');
                    re.lastIndex = 2;
                    return re.exec('str') !== null;
                });
                module1.exports = {
                    BROKEN_CARET: BROKEN_CARET,
                    MISSED_STICKY: MISSED_STICKY,
                    UNSUPPORTED_Y: UNSUPPORTED_Y
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/regexp-unsupported-dot-all.js": /*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-unsupported-dot-all.js ***!
  \**********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                // babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
                var $RegExp = globalThis1.RegExp;
                module1.exports = fails(function() {
                    var re = $RegExp('.', 's');
                    return !(re.dotAll && re.test('\n') && re.flags === 's');
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/regexp-unsupported-ncg.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-unsupported-ncg.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                // babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
                var $RegExp = globalThis1.RegExp;
                module1.exports = fails(function() {
                    var re = $RegExp('(?<a>b)', 'g');
                    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/require-object-coercible.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/require-object-coercible.js ***!
  \********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isNullOrUndefined = __webpack_require__(/*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js");
                var $TypeError = TypeError;
                // `RequireObjectCoercible` abstract operation
                // https://tc39.es/ecma262/#sec-requireobjectcoercible
                module1.exports = function(it) {
                    if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
                    return it;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/safe-get-built-in.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/safe-get-built-in.js ***!
  \*************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                // Avoid NodeJS experimental warning
                module1.exports = function(name) {
                    if (!DESCRIPTORS) return globalThis1[name];
                    var descriptor = getOwnPropertyDescriptor(globalThis1, name);
                    return descriptor && descriptor.value;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/schedulers-fix.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/schedulers-fix.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var apply = __webpack_require__(/*! ../internals/function-apply */ "./node_modules/core-js/internals/function-apply.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var ENVIRONMENT = __webpack_require__(/*! ../internals/environment */ "./node_modules/core-js/internals/environment.js");
                var USER_AGENT = __webpack_require__(/*! ../internals/environment-user-agent */ "./node_modules/core-js/internals/environment-user-agent.js");
                var arraySlice = __webpack_require__(/*! ../internals/array-slice */ "./node_modules/core-js/internals/array-slice.js");
                var validateArgumentsLength = __webpack_require__(/*! ../internals/validate-arguments-length */ "./node_modules/core-js/internals/validate-arguments-length.js");
                var Function1 = globalThis1.Function;
                // dirty IE9- and Bun 0.3.0- checks
                var WRAP = /MSIE .\./.test(USER_AGENT) || ENVIRONMENT === 'BUN' && function() {
                    var version = globalThis1.Bun.version.split('.');
                    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
                }();
                // IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
                // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
                // https://github.com/oven-sh/bun/issues/1633
                module1.exports = function(scheduler, hasTimeArg) {
                    var firstParamIndex = hasTimeArg ? 2 : 1;
                    return WRAP ? function(handler, timeout /* , ...arguments */ ) {
                        var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
                        var fn = isCallable(handler) ? handler : Function1(handler);
                        var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
                        var callback = boundArgs ? function() {
                            apply(fn, this, params);
                        } : fn;
                        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
                    } : scheduler;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-clone.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/set-clone.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var SetHelpers = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js");
                var iterate = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                var Set1 = SetHelpers.Set;
                var add = SetHelpers.add;
                module1.exports = function(set) {
                    var result = new Set1();
                    iterate(set, function(it) {
                        add(result, it);
                    });
                    return result;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-difference.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/set-difference.js ***!
  \**********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var SetHelpers = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js");
                var clone = __webpack_require__(/*! ../internals/set-clone */ "./node_modules/core-js/internals/set-clone.js");
                var size = __webpack_require__(/*! ../internals/set-size */ "./node_modules/core-js/internals/set-size.js");
                var getSetRecord = __webpack_require__(/*! ../internals/get-set-record */ "./node_modules/core-js/internals/get-set-record.js");
                var iterateSet = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                var iterateSimple = __webpack_require__(/*! ../internals/iterate-simple */ "./node_modules/core-js/internals/iterate-simple.js");
                var has = SetHelpers.has;
                var remove = SetHelpers.remove;
                // `Set.prototype.difference` method
                // https://tc39.es/ecma262/#sec-set.prototype.difference
                module1.exports = function difference(other) {
                    var O = aSet(this);
                    var otherRec = getSetRecord(other);
                    var result = clone(O);
                    if (size(O) <= otherRec.size) iterateSet(O, function(e) {
                        if (otherRec.includes(e)) remove(result, e);
                    });
                    else iterateSimple(otherRec.getIterator(), function(e) {
                        if (has(result, e)) remove(result, e);
                    });
                    return result;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-helpers.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/set-helpers.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                // eslint-disable-next-line es/no-set -- safe
                var SetPrototype = Set.prototype;
                module1.exports = {
                    // eslint-disable-next-line es/no-set -- safe
                    Set: Set,
                    add: uncurryThis(SetPrototype.add),
                    has: uncurryThis(SetPrototype.has),
                    remove: uncurryThis(SetPrototype['delete']),
                    proto: SetPrototype
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-intersection.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/set-intersection.js ***!
  \************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var SetHelpers = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js");
                var size = __webpack_require__(/*! ../internals/set-size */ "./node_modules/core-js/internals/set-size.js");
                var getSetRecord = __webpack_require__(/*! ../internals/get-set-record */ "./node_modules/core-js/internals/get-set-record.js");
                var iterateSet = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                var iterateSimple = __webpack_require__(/*! ../internals/iterate-simple */ "./node_modules/core-js/internals/iterate-simple.js");
                var Set1 = SetHelpers.Set;
                var add = SetHelpers.add;
                var has = SetHelpers.has;
                // `Set.prototype.intersection` method
                // https://tc39.es/ecma262/#sec-set.prototype.intersection
                module1.exports = function intersection(other) {
                    var O = aSet(this);
                    var otherRec = getSetRecord(other);
                    var result = new Set1();
                    if (size(O) > otherRec.size) iterateSimple(otherRec.getIterator(), function(e) {
                        if (has(O, e)) add(result, e);
                    });
                    else iterateSet(O, function(e) {
                        if (otherRec.includes(e)) add(result, e);
                    });
                    return result;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-is-disjoint-from.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/set-is-disjoint-from.js ***!
  \****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var has = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js").has;
                var size = __webpack_require__(/*! ../internals/set-size */ "./node_modules/core-js/internals/set-size.js");
                var getSetRecord = __webpack_require__(/*! ../internals/get-set-record */ "./node_modules/core-js/internals/get-set-record.js");
                var iterateSet = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                var iterateSimple = __webpack_require__(/*! ../internals/iterate-simple */ "./node_modules/core-js/internals/iterate-simple.js");
                var iteratorClose = __webpack_require__(/*! ../internals/iterator-close */ "./node_modules/core-js/internals/iterator-close.js");
                // `Set.prototype.isDisjointFrom` method
                // https://tc39.es/ecma262/#sec-set.prototype.isdisjointfrom
                module1.exports = function isDisjointFrom(other) {
                    var O = aSet(this);
                    var otherRec = getSetRecord(other);
                    if (size(O) <= otherRec.size) return iterateSet(O, function(e) {
                        if (otherRec.includes(e)) return false;
                    }, true) !== false;
                    var iterator = otherRec.getIterator();
                    return iterateSimple(iterator, function(e) {
                        if (has(O, e)) return iteratorClose(iterator, 'normal', false);
                    }) !== false;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-is-subset-of.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/set-is-subset-of.js ***!
  \************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var size = __webpack_require__(/*! ../internals/set-size */ "./node_modules/core-js/internals/set-size.js");
                var iterate = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                var getSetRecord = __webpack_require__(/*! ../internals/get-set-record */ "./node_modules/core-js/internals/get-set-record.js");
                // `Set.prototype.isSubsetOf` method
                // https://tc39.es/ecma262/#sec-set.prototype.issubsetof
                module1.exports = function isSubsetOf(other) {
                    var O = aSet(this);
                    var otherRec = getSetRecord(other);
                    if (size(O) > otherRec.size) return false;
                    return iterate(O, function(e) {
                        if (!otherRec.includes(e)) return false;
                    }, true) !== false;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-is-superset-of.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/set-is-superset-of.js ***!
  \**************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var has = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js").has;
                var size = __webpack_require__(/*! ../internals/set-size */ "./node_modules/core-js/internals/set-size.js");
                var getSetRecord = __webpack_require__(/*! ../internals/get-set-record */ "./node_modules/core-js/internals/get-set-record.js");
                var iterateSimple = __webpack_require__(/*! ../internals/iterate-simple */ "./node_modules/core-js/internals/iterate-simple.js");
                var iteratorClose = __webpack_require__(/*! ../internals/iterator-close */ "./node_modules/core-js/internals/iterator-close.js");
                // `Set.prototype.isSupersetOf` method
                // https://tc39.es/ecma262/#sec-set.prototype.issupersetof
                module1.exports = function isSupersetOf(other) {
                    var O = aSet(this);
                    var otherRec = getSetRecord(other);
                    if (size(O) < otherRec.size) return false;
                    var iterator = otherRec.getIterator();
                    return iterateSimple(iterator, function(e) {
                        if (!has(O, e)) return iteratorClose(iterator, 'normal', false);
                    }) !== false;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-iterate.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/set-iterate.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var iterateSimple = __webpack_require__(/*! ../internals/iterate-simple */ "./node_modules/core-js/internals/iterate-simple.js");
                var SetHelpers = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js");
                var Set1 = SetHelpers.Set;
                var SetPrototype = SetHelpers.proto;
                var forEach = uncurryThis(SetPrototype.forEach);
                var keys = uncurryThis(SetPrototype.keys);
                var next = keys(new Set1()).next;
                module1.exports = function(set, fn, interruptible) {
                    return interruptible ? iterateSimple({
                        iterator: keys(set),
                        next: next
                    }, fn) : forEach(set, fn);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-size.js": /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/set-size.js ***!
  \****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThisAccessor = __webpack_require__(/*! ../internals/function-uncurry-this-accessor */ "./node_modules/core-js/internals/function-uncurry-this-accessor.js");
                var SetHelpers = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js");
                module1.exports = uncurryThisAccessor(SetHelpers.proto, 'size', 'get') || function(set) {
                    return set.size;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-species.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/set-species.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                var defineBuiltInAccessor = __webpack_require__(/*! ../internals/define-built-in-accessor */ "./node_modules/core-js/internals/define-built-in-accessor.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var SPECIES = wellKnownSymbol('species');
                module1.exports = function(CONSTRUCTOR_NAME) {
                    var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
                    if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) defineBuiltInAccessor(Constructor, SPECIES, {
                        configurable: true,
                        get: function() {
                            return this;
                        }
                    });
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-symmetric-difference.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/set-symmetric-difference.js ***!
  \********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var SetHelpers = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js");
                var clone = __webpack_require__(/*! ../internals/set-clone */ "./node_modules/core-js/internals/set-clone.js");
                var getSetRecord = __webpack_require__(/*! ../internals/get-set-record */ "./node_modules/core-js/internals/get-set-record.js");
                var iterateSimple = __webpack_require__(/*! ../internals/iterate-simple */ "./node_modules/core-js/internals/iterate-simple.js");
                var add = SetHelpers.add;
                var has = SetHelpers.has;
                var remove = SetHelpers.remove;
                // `Set.prototype.symmetricDifference` method
                // https://tc39.es/ecma262/#sec-set.prototype.symmetricdifference
                module1.exports = function symmetricDifference(other) {
                    var O = aSet(this);
                    var keysIter = getSetRecord(other).getIterator();
                    var result = clone(O);
                    iterateSimple(keysIter, function(e) {
                        if (has(O, e)) remove(result, e);
                        else add(result, e);
                    });
                    return result;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-to-string-tag.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/set-to-string-tag.js ***!
  \*************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                module1.exports = function(target, TAG, STATIC) {
                    if (target && !STATIC) target = target.prototype;
                    if (target && !hasOwn(target, TO_STRING_TAG)) defineProperty(target, TO_STRING_TAG, {
                        configurable: true,
                        value: TAG
                    });
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/set-union.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/set-union.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var add = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js").add;
                var clone = __webpack_require__(/*! ../internals/set-clone */ "./node_modules/core-js/internals/set-clone.js");
                var getSetRecord = __webpack_require__(/*! ../internals/get-set-record */ "./node_modules/core-js/internals/get-set-record.js");
                var iterateSimple = __webpack_require__(/*! ../internals/iterate-simple */ "./node_modules/core-js/internals/iterate-simple.js");
                // `Set.prototype.union` method
                // https://tc39.es/ecma262/#sec-set.prototype.union
                module1.exports = function union(other) {
                    var O = aSet(this);
                    var keysIter = getSetRecord(other).getIterator();
                    var result = clone(O);
                    iterateSimple(keysIter, function(it) {
                        add(result, it);
                    });
                    return result;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/shared-key.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/shared-key.js ***!
  \******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
                var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
                var keys = shared('keys');
                module1.exports = function(key) {
                    return keys[key] || (keys[key] = uid(key));
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/shared-store.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/shared-store.js ***!
  \********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var defineGlobalProperty = __webpack_require__(/*! ../internals/define-global-property */ "./node_modules/core-js/internals/define-global-property.js");
                var SHARED = '__core-js_shared__';
                var store = module1.exports = globalThis1[SHARED] || defineGlobalProperty(SHARED, {});
                (store.versions || (store.versions = [])).push({
                    version: '3.47.0',
                    mode: IS_PURE ? 'pure' : 'global',
                    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
                    license: 'https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE',
                    source: 'https://github.com/zloirock/core-js'
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/shared.js": /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/shared.js ***!
  \**************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var store = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js");
                module1.exports = function(key, value) {
                    return store[key] || (store[key] = value || {});
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/species-constructor.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/species-constructor.js ***!
  \***************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var aConstructor = __webpack_require__(/*! ../internals/a-constructor */ "./node_modules/core-js/internals/a-constructor.js");
                var isNullOrUndefined = __webpack_require__(/*! ../internals/is-null-or-undefined */ "./node_modules/core-js/internals/is-null-or-undefined.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var SPECIES = wellKnownSymbol('species');
                // `SpeciesConstructor` abstract operation
                // https://tc39.es/ecma262/#sec-speciesconstructor
                module1.exports = function(O, defaultConstructor) {
                    var C = anObject(O).constructor;
                    var S;
                    return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/string-html-forced.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/string-html-forced.js ***!
  \**************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                // check the existence of a method, lowercase
                // of a tag and escaping quotes in arguments
                module1.exports = function(METHOD_NAME) {
                    return fails(function() {
                        var test = ''[METHOD_NAME]('"');
                        return test !== test.toLowerCase() || test.split('"').length > 3;
                    });
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/string-multibyte.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/internals/string-multibyte.js ***!
  \************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var toIntegerOrInfinity = __webpack_require__(/*! ../internals/to-integer-or-infinity */ "./node_modules/core-js/internals/to-integer-or-infinity.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var charAt = uncurryThis(''.charAt);
                var charCodeAt = uncurryThis(''.charCodeAt);
                var stringSlice = uncurryThis(''.slice);
                var createMethod = function(CONVERT_TO_STRING) {
                    return function($this, pos) {
                        var S = toString(requireObjectCoercible($this));
                        var position = toIntegerOrInfinity(pos);
                        var size = S.length;
                        var first, second;
                        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
                        first = charCodeAt(S, position);
                        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
                    };
                };
                module1.exports = {
                    // `String.prototype.codePointAt` method
                    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
                    codeAt: createMethod(false),
                    // `String.prototype.at` method
                    // https://github.com/mathiasbynens/String.prototype.at
                    charAt: createMethod(true)
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/string-trim-forced.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/string-trim-forced.js ***!
  \**************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var PROPER_FUNCTION_NAME = __webpack_require__(/*! ../internals/function-name */ "./node_modules/core-js/internals/function-name.js").PROPER;
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js/internals/whitespaces.js");
                var non = '\u200B\u0085\u180E';
                // check that a method works with the correct list
                // of whitespaces and has a correct name
                module1.exports = function(METHOD_NAME) {
                    return fails(function() {
                        return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
                    });
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/string-trim.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/string-trim.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js/internals/whitespaces.js");
                var replace = uncurryThis(''.replace);
                var ltrim = RegExp('^[' + whitespaces + ']+');
                var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');
                // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
                var createMethod = function(TYPE) {
                    return function($this) {
                        var string = toString(requireObjectCoercible($this));
                        if (TYPE & 1) string = replace(string, ltrim, '');
                        if (TYPE & 2) string = replace(string, rtrim, '$1');
                        return string;
                    };
                };
                module1.exports = {
                    // `String.prototype.{ trimLeft, trimStart }` methods
                    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
                    start: createMethod(1),
                    // `String.prototype.{ trimRight, trimEnd }` methods
                    // https://tc39.es/ecma262/#sec-string.prototype.trimend
                    end: createMethod(2),
                    // `String.prototype.trim` method
                    // https://tc39.es/ecma262/#sec-string.prototype.trim
                    trim: createMethod(3)
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/symbol-constructor-detection.js": /*!************************************************************************!*\
  !*** ./node_modules/core-js/internals/symbol-constructor-detection.js ***!
  \************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = __webpack_require__(/*! ../internals/environment-v8-version */ "./node_modules/core-js/internals/environment-v8-version.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var $String = globalThis1.String;
                // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
                module1.exports = !!Object.getOwnPropertySymbols && !fails(function() {
                    var symbol = Symbol('symbol detection');
                    // Chrome 38 Symbol has incorrect toString conversion
                    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
                    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
                    // of course, fail.
                    return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
                    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/symbol-define-to-primitive.js": /*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/symbol-define-to-primitive.js ***!
  \**********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                module1.exports = function() {
                    var Symbol1 = getBuiltIn('Symbol');
                    var SymbolPrototype = Symbol1 && Symbol1.prototype;
                    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
                    var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
                    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
                    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
                    // eslint-disable-next-line no-unused-vars -- required for .length
                    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function(hint) {
                        return call(valueOf, this);
                    }, {
                        arity: 1
                    });
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/symbol-registry-detection.js": /*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/symbol-registry-detection.js ***!
  \*********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/symbol-constructor-detection */ "./node_modules/core-js/internals/symbol-constructor-detection.js");
                /* eslint-disable es/no-symbol -- safe */ module1.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;
            /***/ },
            /***/ "./node_modules/core-js/internals/task.js": /*!************************************************!*\
  !*** ./node_modules/core-js/internals/task.js ***!
  \************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var apply = __webpack_require__(/*! ../internals/function-apply */ "./node_modules/core-js/internals/function-apply.js");
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var html = __webpack_require__(/*! ../internals/html */ "./node_modules/core-js/internals/html.js");
                var arraySlice = __webpack_require__(/*! ../internals/array-slice */ "./node_modules/core-js/internals/array-slice.js");
                var createElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");
                var validateArgumentsLength = __webpack_require__(/*! ../internals/validate-arguments-length */ "./node_modules/core-js/internals/validate-arguments-length.js");
                var IS_IOS = __webpack_require__(/*! ../internals/environment-is-ios */ "./node_modules/core-js/internals/environment-is-ios.js");
                var IS_NODE = __webpack_require__(/*! ../internals/environment-is-node */ "./node_modules/core-js/internals/environment-is-node.js");
                var set = globalThis1.setImmediate;
                var clear = globalThis1.clearImmediate;
                var process = globalThis1.process;
                var Dispatch = globalThis1.Dispatch;
                var Function1 = globalThis1.Function;
                var MessageChannel = globalThis1.MessageChannel;
                var String1 = globalThis1.String;
                var counter = 0;
                var queue = {};
                var ONREADYSTATECHANGE = 'onreadystatechange';
                var $location, defer, channel, port;
                fails(function() {
                    // Deno throws a ReferenceError on `location` access without `--location` flag
                    $location = globalThis1.location;
                });
                var run = function(id) {
                    if (hasOwn(queue, id)) {
                        var fn = queue[id];
                        delete queue[id];
                        fn();
                    }
                };
                var runner = function(id) {
                    return function() {
                        run(id);
                    };
                };
                var eventListener = function(event) {
                    run(event.data);
                };
                var globalPostMessageDefer = function(id) {
                    // old engines have not location.origin
                    globalThis1.postMessage(String1(id), $location.protocol + '//' + $location.host);
                };
                // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
                if (!set || !clear) {
                    set = function setImmediate(handler) {
                        validateArgumentsLength(arguments.length, 1);
                        var fn = isCallable(handler) ? handler : Function1(handler);
                        var args = arraySlice(arguments, 1);
                        queue[++counter] = function() {
                            apply(fn, undefined, args);
                        };
                        defer(counter);
                        return counter;
                    };
                    clear = function clearImmediate(id) {
                        delete queue[id];
                    };
                    // Node.js 0.8-
                    if (IS_NODE) defer = function(id) {
                        process.nextTick(runner(id));
                    };
                    else if (Dispatch && Dispatch.now) defer = function(id) {
                        Dispatch.now(runner(id));
                    };
                    else if (MessageChannel && !IS_IOS) {
                        channel = new MessageChannel();
                        port = channel.port2;
                        channel.port1.onmessage = eventListener;
                        defer = bind(port.postMessage, port);
                    // Browsers with postMessage, skip WebWorkers
                    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
                    } else if (globalThis1.addEventListener && isCallable(globalThis1.postMessage) && !globalThis1.importScripts && $location && $location.protocol !== 'file:' && !fails(globalPostMessageDefer)) {
                        defer = globalPostMessageDefer;
                        globalThis1.addEventListener('message', eventListener, false);
                    // IE8-
                    } else if (ONREADYSTATECHANGE in createElement('script')) defer = function(id) {
                        html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function() {
                            html.removeChild(this);
                            run(id);
                        };
                    };
                    else defer = function(id) {
                        setTimeout(runner(id), 0);
                    };
                }
                module1.exports = {
                    set: set,
                    clear: clear
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/this-number-value.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/this-number-value.js ***!
  \*************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                // `thisNumberValue` abstract operation
                // https://tc39.es/ecma262/#sec-thisnumbervalue
                module1.exports = uncurryThis(1.1.valueOf);
            /***/ },
            /***/ "./node_modules/core-js/internals/to-absolute-index.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-absolute-index.js ***!
  \*************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toIntegerOrInfinity = __webpack_require__(/*! ../internals/to-integer-or-infinity */ "./node_modules/core-js/internals/to-integer-or-infinity.js");
                var max = Math.max;
                var min = Math.min;
                // Helper for a popular repeating case of the spec:
                // Let integer be ? ToInteger(index).
                // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
                module1.exports = function(index, length) {
                    var integer = toIntegerOrInfinity(index);
                    return integer < 0 ? max(integer + length, 0) : min(integer, length);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/to-indexed-object.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-indexed-object.js ***!
  \*************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // toObject with fallback for non-array-like ES3 strings
                var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                module1.exports = function(it) {
                    return IndexedObject(requireObjectCoercible(it));
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/to-integer-or-infinity.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/to-integer-or-infinity.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var trunc = __webpack_require__(/*! ../internals/math-trunc */ "./node_modules/core-js/internals/math-trunc.js");
                // `ToIntegerOrInfinity` abstract operation
                // https://tc39.es/ecma262/#sec-tointegerorinfinity
                module1.exports = function(argument) {
                    var number = +argument;
                    // eslint-disable-next-line no-self-compare -- NaN check
                    return number !== number || number === 0 ? 0 : trunc(number);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/to-length.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-length.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toIntegerOrInfinity = __webpack_require__(/*! ../internals/to-integer-or-infinity */ "./node_modules/core-js/internals/to-integer-or-infinity.js");
                var min = Math.min;
                // `ToLength` abstract operation
                // https://tc39.es/ecma262/#sec-tolength
                module1.exports = function(argument) {
                    var len = toIntegerOrInfinity(argument);
                    return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/to-object.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-object.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var $Object = Object;
                // `ToObject` abstract operation
                // https://tc39.es/ecma262/#sec-toobject
                module1.exports = function(argument) {
                    return $Object(requireObjectCoercible(argument));
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/to-primitive.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/to-primitive.js ***!
  \********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var isSymbol = __webpack_require__(/*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js");
                var getMethod = __webpack_require__(/*! ../internals/get-method */ "./node_modules/core-js/internals/get-method.js");
                var ordinaryToPrimitive = __webpack_require__(/*! ../internals/ordinary-to-primitive */ "./node_modules/core-js/internals/ordinary-to-primitive.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var $TypeError = TypeError;
                var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
                // `ToPrimitive` abstract operation
                // https://tc39.es/ecma262/#sec-toprimitive
                module1.exports = function(input, pref) {
                    if (!isObject(input) || isSymbol(input)) return input;
                    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
                    var result;
                    if (exoticToPrim) {
                        if (pref === undefined) pref = 'default';
                        result = call(exoticToPrim, input, pref);
                        if (!isObject(result) || isSymbol(result)) return result;
                        throw new $TypeError("Can't convert object to primitive value");
                    }
                    if (pref === undefined) pref = 'number';
                    return ordinaryToPrimitive(input, pref);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/to-property-key.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/to-property-key.js ***!
  \***********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
                var isSymbol = __webpack_require__(/*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js");
                // `ToPropertyKey` abstract operation
                // https://tc39.es/ecma262/#sec-topropertykey
                module1.exports = function(argument) {
                    var key = toPrimitive(argument, 'string');
                    return isSymbol(key) ? key : key + '';
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/to-set-like.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/to-set-like.js ***!
  \*******************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isIterable = __webpack_require__(/*! ../internals/is-iterable */ "./node_modules/core-js/internals/is-iterable.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var Set1 = getBuiltIn('Set');
                var isSetLike = function(it) {
                    return isObject(it) && typeof it.size == 'number' && isCallable(it.has) && isCallable(it.keys);
                };
                // fallback old -> new set methods proposal arguments
                module1.exports = function(it) {
                    if (isSetLike(it)) return it;
                    return isIterable(it) ? new Set1(it) : it;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/to-string-tag-support.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/to-string-tag-support.js ***!
  \*****************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var test = {};
                // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                test[TO_STRING_TAG] = 'z';
                module1.exports = String(test) === '[object z]';
            /***/ },
            /***/ "./node_modules/core-js/internals/to-string.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-string.js ***!
  \*****************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
                var $String = String;
                module1.exports = function(argument) {
                    if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
                    return $String(argument);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/try-to-string.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/try-to-string.js ***!
  \*********************************************************/ /***/ function(module1) {
                "use strict";
                var $String = String;
                module1.exports = function(argument) {
                    try {
                        return $String(argument);
                    } catch (error) {
                        return 'Object';
                    }
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/uid.js": /*!***********************************************!*\
  !*** ./node_modules/core-js/internals/uid.js ***!
  \***********************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var id = 0;
                var postfix = Math.random();
                var toString = uncurryThis(1.1.toString);
                module1.exports = function(key) {
                    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/use-symbol-as-uid.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/use-symbol-as-uid.js ***!
  \*************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/symbol-constructor-detection */ "./node_modules/core-js/internals/symbol-constructor-detection.js");
                module1.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';
            /***/ },
            /***/ "./node_modules/core-js/internals/v8-prototype-define-bug.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/v8-prototype-define-bug.js ***!
  \*******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                // V8 ~ Chrome 36-
                // https://bugs.chromium.org/p/v8/issues/detail?id=3334
                module1.exports = DESCRIPTORS && fails(function() {
                    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
                    return Object.defineProperty(function() {}, 'prototype', {
                        value: 42,
                        writable: false
                    }).prototype !== 42;
                });
            /***/ },
            /***/ "./node_modules/core-js/internals/validate-arguments-length.js": /*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/validate-arguments-length.js ***!
  \*********************************************************************/ /***/ function(module1) {
                "use strict";
                var $TypeError = TypeError;
                module1.exports = function(passed, required) {
                    if (passed < required) throw new $TypeError('Not enough arguments');
                    return passed;
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/weak-map-basic-detection.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/weak-map-basic-detection.js ***!
  \********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var WeakMap = globalThis1.WeakMap;
                module1.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));
            /***/ },
            /***/ "./node_modules/core-js/internals/well-known-symbol-define.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol-define.js ***!
  \********************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js/internals/path.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var wrappedWellKnownSymbolModule = __webpack_require__(/*! ../internals/well-known-symbol-wrapped */ "./node_modules/core-js/internals/well-known-symbol-wrapped.js");
                var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
                module1.exports = function(NAME) {
                    var Symbol1 = path.Symbol || (path.Symbol = {});
                    if (!hasOwn(Symbol1, NAME)) defineProperty(Symbol1, NAME, {
                        value: wrappedWellKnownSymbolModule.f(NAME)
                    });
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/well-known-symbol-wrapped.js": /*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol-wrapped.js ***!
  \*********************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                exports.f = wellKnownSymbol;
            /***/ },
            /***/ "./node_modules/core-js/internals/well-known-symbol.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol.js ***!
  \*************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
                var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/symbol-constructor-detection */ "./node_modules/core-js/internals/symbol-constructor-detection.js");
                var USE_SYMBOL_AS_UID = __webpack_require__(/*! ../internals/use-symbol-as-uid */ "./node_modules/core-js/internals/use-symbol-as-uid.js");
                var Symbol1 = globalThis1.Symbol;
                var WellKnownSymbolsStore = shared('wks');
                var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1['for'] || Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
                module1.exports = function(name) {
                    if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol1, name) ? Symbol1[name] : createWellKnownSymbol('Symbol.' + name);
                    return WellKnownSymbolsStore[name];
                };
            /***/ },
            /***/ "./node_modules/core-js/internals/whitespaces.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/whitespaces.js ***!
  \*******************************************************/ /***/ function(module1) {
                "use strict";
                // a string of all valid unicode whitespaces
                module1.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
            /***/ },
            /***/ "./node_modules/core-js/modules/es.array.concat.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.concat.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
                var lengthOfArrayLike = __webpack_require__(/*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js");
                var doesNotExceedSafeInteger = __webpack_require__(/*! ../internals/does-not-exceed-safe-integer */ "./node_modules/core-js/internals/does-not-exceed-safe-integer.js");
                var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
                var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js");
                var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var V8_VERSION = __webpack_require__(/*! ../internals/environment-v8-version */ "./node_modules/core-js/internals/environment-v8-version.js");
                var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
                // We can't use this feature detection in V8 since it causes
                // deoptimization and serious performance degradation
                // https://github.com/zloirock/core-js/issues/679
                var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function() {
                    var array = [];
                    array[IS_CONCAT_SPREADABLE] = false;
                    return array.concat()[0] !== array;
                });
                var isConcatSpreadable = function(O) {
                    if (!isObject(O)) return false;
                    var spreadable = O[IS_CONCAT_SPREADABLE];
                    return spreadable !== undefined ? !!spreadable : isArray(O);
                };
                var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');
                // `Array.prototype.concat` method
                // https://tc39.es/ecma262/#sec-array.prototype.concat
                // with adding support of @@isConcatSpreadable and @@species
                $({
                    target: 'Array',
                    proto: true,
                    arity: 1,
                    forced: FORCED
                }, {
                    // eslint-disable-next-line no-unused-vars -- required for `.length`
                    concat: function concat(arg) {
                        var O = toObject(this);
                        var A = arraySpeciesCreate(O, 0);
                        var n = 0;
                        var i, k, length, len, E;
                        for(i = -1, length = arguments.length; i < length; i++){
                            E = i === -1 ? O : arguments[i];
                            if (isConcatSpreadable(E)) {
                                len = lengthOfArrayLike(E);
                                doesNotExceedSafeInteger(n + len);
                                for(k = 0; k < len; k++, n++)if (k in E) createProperty(A, n, E[k]);
                            } else {
                                doesNotExceedSafeInteger(n + 1);
                                createProperty(A, n++, E);
                            }
                        }
                        A.length = n;
                        return A;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.array.from.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.from.js ***!
  \*******************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var from = __webpack_require__(/*! ../internals/array-from */ "./node_modules/core-js/internals/array-from.js");
                var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js");
                var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
                    // eslint-disable-next-line es/no-array-from -- required for testing
                    Array.from(iterable);
                });
                // `Array.from` method
                // https://tc39.es/ecma262/#sec-array.from
                $({
                    target: 'Array',
                    stat: true,
                    forced: INCORRECT_ITERATION
                }, {
                    from: from
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.array.index-of.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.index-of.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable es/no-array-prototype-indexof -- required for testing */ var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this-clause */ "./node_modules/core-js/internals/function-uncurry-this-clause.js");
                var $indexOf = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js").indexOf;
                var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");
                var nativeIndexOf = uncurryThis([].indexOf);
                var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([
                    1
                ], 1, -0) < 0;
                var FORCED = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');
                // `Array.prototype.indexOf` method
                // https://tc39.es/ecma262/#sec-array.prototype.indexof
                $({
                    target: 'Array',
                    proto: true,
                    forced: FORCED
                }, {
                    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
                        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
                        return NEGATIVE_ZERO ? nativeIndexOf(this, searchElement, fromIndex) || 0 : $indexOf(this, searchElement, fromIndex);
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.array.iterator.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.iterator.js ***!
  \***********************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
                var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js");
                var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
                var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
                var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
                var defineIterator = __webpack_require__(/*! ../internals/iterator-define */ "./node_modules/core-js/internals/iterator-define.js");
                var createIterResultObject = __webpack_require__(/*! ../internals/create-iter-result-object */ "./node_modules/core-js/internals/create-iter-result-object.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var ARRAY_ITERATOR = 'Array Iterator';
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
                // `Array.prototype.entries` method
                // https://tc39.es/ecma262/#sec-array.prototype.entries
                // `Array.prototype.keys` method
                // https://tc39.es/ecma262/#sec-array.prototype.keys
                // `Array.prototype.values` method
                // https://tc39.es/ecma262/#sec-array.prototype.values
                // `Array.prototype[@@iterator]` method
                // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
                // `CreateArrayIterator` internal method
                // https://tc39.es/ecma262/#sec-createarrayiterator
                module1.exports = defineIterator(Array, 'Array', function(iterated, kind) {
                    setInternalState(this, {
                        type: ARRAY_ITERATOR,
                        target: toIndexedObject(iterated),
                        index: 0,
                        kind: kind // kind
                    });
                // `%ArrayIteratorPrototype%.next` method
                // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
                }, function() {
                    var state = getInternalState(this);
                    var target = state.target;
                    var index = state.index++;
                    if (!target || index >= target.length) {
                        state.target = null;
                        return createIterResultObject(undefined, true);
                    }
                    switch(state.kind){
                        case 'keys':
                            return createIterResultObject(index, false);
                        case 'values':
                            return createIterResultObject(target[index], false);
                    }
                    return createIterResultObject([
                        index,
                        target[index]
                    ], false);
                }, 'values');
                // argumentsList[@@iterator] is %ArrayProto_values%
                // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
                // https://tc39.es/ecma262/#sec-createmappedargumentsobject
                var values = Iterators.Arguments = Iterators.Array;
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                addToUnscopables('keys');
                addToUnscopables('values');
                addToUnscopables('entries');
                // V8 ~ Chrome 45- bug
                if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
                    defineProperty(values, 'name', {
                        value: 'values'
                    });
                } catch (error) {}
            /***/ },
            /***/ "./node_modules/core-js/modules/es.array.join.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.join.js ***!
  \*******************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
                var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
                var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");
                var nativeJoin = uncurryThis([].join);
                var ES3_STRINGS = IndexedObject !== Object;
                var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');
                // `Array.prototype.join` method
                // https://tc39.es/ecma262/#sec-array.prototype.join
                $({
                    target: 'Array',
                    proto: true,
                    forced: FORCED
                }, {
                    join: function join(separator) {
                        return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.array.map.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.map.js ***!
  \******************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var $map = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").map;
                var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
                // `Array.prototype.map` method
                // https://tc39.es/ecma262/#sec-array.prototype.map
                // with adding support of @@species
                $({
                    target: 'Array',
                    proto: true,
                    forced: !HAS_SPECIES_SUPPORT
                }, {
                    map: function map(callbackfn /* , thisArg */ ) {
                        return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.array.reduce.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.reduce.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var $reduce = __webpack_require__(/*! ../internals/array-reduce */ "./node_modules/core-js/internals/array-reduce.js").left;
                var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");
                var CHROME_VERSION = __webpack_require__(/*! ../internals/environment-v8-version */ "./node_modules/core-js/internals/environment-v8-version.js");
                var IS_NODE = __webpack_require__(/*! ../internals/environment-is-node */ "./node_modules/core-js/internals/environment-is-node.js");
                // Chrome 80-82 has a critical bug
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
                var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
                var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');
                // `Array.prototype.reduce` method
                // https://tc39.es/ecma262/#sec-array.prototype.reduce
                $({
                    target: 'Array',
                    proto: true,
                    forced: FORCED
                }, {
                    reduce: function reduce(callbackfn /* , initialValue */ ) {
                        var length = arguments.length;
                        return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.array.reverse.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.reverse.js ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
                var nativeReverse = uncurryThis([].reverse);
                var test = [
                    1,
                    2
                ];
                // `Array.prototype.reverse` method
                // https://tc39.es/ecma262/#sec-array.prototype.reverse
                // fix for Safari 12.0 bug
                // https://bugs.webkit.org/show_bug.cgi?id=188794
                $({
                    target: 'Array',
                    proto: true,
                    forced: String(test) === String(test.reverse())
                }, {
                    reverse: function reverse() {
                        // eslint-disable-next-line no-self-assign -- dirty hack
                        if (isArray(this)) this.length = this.length;
                        return nativeReverse(this);
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.array.slice.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.slice.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
                var isConstructor = __webpack_require__(/*! ../internals/is-constructor */ "./node_modules/core-js/internals/is-constructor.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");
                var lengthOfArrayLike = __webpack_require__(/*! ../internals/length-of-array-like */ "./node_modules/core-js/internals/length-of-array-like.js");
                var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
                var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
                var nativeSlice = __webpack_require__(/*! ../internals/array-slice */ "./node_modules/core-js/internals/array-slice.js");
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
                var SPECIES = wellKnownSymbol('species');
                var $Array = Array;
                var max = Math.max;
                // `Array.prototype.slice` method
                // https://tc39.es/ecma262/#sec-array.prototype.slice
                // fallback for not array-like ES3 strings and DOM objects
                $({
                    target: 'Array',
                    proto: true,
                    forced: !HAS_SPECIES_SUPPORT
                }, {
                    slice: function slice(start, end) {
                        var O = toIndexedObject(this);
                        var length = lengthOfArrayLike(O);
                        var k = toAbsoluteIndex(start, length);
                        var fin = toAbsoluteIndex(end === undefined ? length : end, length);
                        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
                        var Constructor, result, n;
                        if (isArray(O)) {
                            Constructor = O.constructor;
                            // cross-realm fallback
                            if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) Constructor = undefined;
                            else if (isObject(Constructor)) {
                                Constructor = Constructor[SPECIES];
                                if (Constructor === null) Constructor = undefined;
                            }
                            if (Constructor === $Array || Constructor === undefined) return nativeSlice(O, k, fin);
                        }
                        result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
                        for(n = 0; k < fin; k++, n++)if (k in O) createProperty(result, n, O[k]);
                        result.length = n;
                        return result;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.function.name.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.function.name.js ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var FUNCTION_NAME_EXISTS = __webpack_require__(/*! ../internals/function-name */ "./node_modules/core-js/internals/function-name.js").EXISTS;
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var defineBuiltInAccessor = __webpack_require__(/*! ../internals/define-built-in-accessor */ "./node_modules/core-js/internals/define-built-in-accessor.js");
                var FunctionPrototype = Function.prototype;
                var functionToString = uncurryThis(FunctionPrototype.toString);
                var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
                var regExpExec = uncurryThis(nameRE.exec);
                var NAME = 'name';
                // Function instances `.name` property
                // https://tc39.es/ecma262/#sec-function-instances-name
                if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) defineBuiltInAccessor(FunctionPrototype, NAME, {
                    configurable: true,
                    get: function() {
                        try {
                            return regExpExec(nameRE, functionToString(this))[1];
                        } catch (error) {
                            return '';
                        }
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.iterator.constructor.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/modules/es.iterator.constructor.js ***!
  \*****************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
                var defineBuiltInAccessor = __webpack_require__(/*! ../internals/define-built-in-accessor */ "./node_modules/core-js/internals/define-built-in-accessor.js");
                var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var IteratorPrototype = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js").IteratorPrototype;
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var CONSTRUCTOR = 'constructor';
                var ITERATOR = 'Iterator';
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var $TypeError = TypeError;
                var NativeIterator = globalThis1[ITERATOR];
                // FF56- have non-standard global helper `Iterator`
                var FORCED = IS_PURE || !isCallable(NativeIterator) || NativeIterator.prototype !== IteratorPrototype || !fails(function() {
                    NativeIterator({});
                });
                var IteratorConstructor = function Iterator1() {
                    anInstance(this, IteratorPrototype);
                    if (getPrototypeOf(this) === IteratorPrototype) throw new $TypeError('Abstract class Iterator not directly constructable');
                };
                var defineIteratorPrototypeAccessor = function(key, value) {
                    if (DESCRIPTORS) defineBuiltInAccessor(IteratorPrototype, key, {
                        configurable: true,
                        get: function() {
                            return value;
                        },
                        set: function(replacement) {
                            anObject(this);
                            if (this === IteratorPrototype) throw new $TypeError("You can't redefine this property");
                            if (hasOwn(this, key)) this[key] = replacement;
                            else createProperty(this, key, replacement);
                        }
                    });
                    else IteratorPrototype[key] = value;
                };
                if (!hasOwn(IteratorPrototype, TO_STRING_TAG)) defineIteratorPrototypeAccessor(TO_STRING_TAG, ITERATOR);
                if (FORCED || !hasOwn(IteratorPrototype, CONSTRUCTOR) || IteratorPrototype[CONSTRUCTOR] === Object) defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
                IteratorConstructor.prototype = IteratorPrototype;
                // `Iterator` constructor
                // https://tc39.es/ecma262/#sec-iterator
                $({
                    global: true,
                    constructor: true,
                    forced: FORCED
                }, {
                    Iterator: IteratorConstructor
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.iterator.for-each.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/modules/es.iterator.for-each.js ***!
  \**************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var getIteratorDirect = __webpack_require__(/*! ../internals/get-iterator-direct */ "./node_modules/core-js/internals/get-iterator-direct.js");
                var iteratorClose = __webpack_require__(/*! ../internals/iterator-close */ "./node_modules/core-js/internals/iterator-close.js");
                var iteratorHelperWithoutClosingOnEarlyError = __webpack_require__(/*! ../internals/iterator-helper-without-closing-on-early-error */ "./node_modules/core-js/internals/iterator-helper-without-closing-on-early-error.js");
                var forEachWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('forEach', TypeError);
                // `Iterator.prototype.forEach` method
                // https://tc39.es/ecma262/#sec-iterator.prototype.foreach
                $({
                    target: 'Iterator',
                    proto: true,
                    real: true,
                    forced: forEachWithoutClosingOnEarlyError
                }, {
                    forEach: function forEach(fn) {
                        anObject(this);
                        try {
                            aCallable(fn);
                        } catch (error) {
                            iteratorClose(this, 'throw', error);
                        }
                        if (forEachWithoutClosingOnEarlyError) return call(forEachWithoutClosingOnEarlyError, this, fn);
                        var record = getIteratorDirect(this);
                        var counter = 0;
                        iterate(record, function(value) {
                            fn(value, counter++);
                        }, {
                            IS_RECORD: true
                        });
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.iterator.map.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.iterator.map.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var getIteratorDirect = __webpack_require__(/*! ../internals/get-iterator-direct */ "./node_modules/core-js/internals/get-iterator-direct.js");
                var createIteratorProxy = __webpack_require__(/*! ../internals/iterator-create-proxy */ "./node_modules/core-js/internals/iterator-create-proxy.js");
                var callWithSafeIterationClosing = __webpack_require__(/*! ../internals/call-with-safe-iteration-closing */ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js");
                var iteratorClose = __webpack_require__(/*! ../internals/iterator-close */ "./node_modules/core-js/internals/iterator-close.js");
                var iteratorHelperThrowsOnInvalidIterator = __webpack_require__(/*! ../internals/iterator-helper-throws-on-invalid-iterator */ "./node_modules/core-js/internals/iterator-helper-throws-on-invalid-iterator.js");
                var iteratorHelperWithoutClosingOnEarlyError = __webpack_require__(/*! ../internals/iterator-helper-without-closing-on-early-error */ "./node_modules/core-js/internals/iterator-helper-without-closing-on-early-error.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !IS_PURE && !iteratorHelperThrowsOnInvalidIterator('map', function() {});
                var mapWithoutClosingOnEarlyError = !IS_PURE && !MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('map', TypeError);
                var FORCED = IS_PURE || MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR || mapWithoutClosingOnEarlyError;
                var IteratorProxy = createIteratorProxy(function() {
                    var iterator = this.iterator;
                    var result = anObject(call(this.next, iterator));
                    var done = this.done = !!result.done;
                    if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [
                        result.value,
                        this.counter++
                    ], true);
                });
                // `Iterator.prototype.map` method
                // https://tc39.es/ecma262/#sec-iterator.prototype.map
                $({
                    target: 'Iterator',
                    proto: true,
                    real: true,
                    forced: FORCED
                }, {
                    map: function map(mapper) {
                        anObject(this);
                        try {
                            aCallable(mapper);
                        } catch (error) {
                            iteratorClose(this, 'throw', error);
                        }
                        if (mapWithoutClosingOnEarlyError) return call(mapWithoutClosingOnEarlyError, this, mapper);
                        return new IteratorProxy(getIteratorDirect(this), {
                            mapper: mapper
                        });
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.json.stringify.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.json.stringify.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                var apply = __webpack_require__(/*! ../internals/function-apply */ "./node_modules/core-js/internals/function-apply.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isRawJSON = __webpack_require__(/*! ../internals/is-raw-json */ "./node_modules/core-js/internals/is-raw-json.js");
                var isSymbol = __webpack_require__(/*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js");
                var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var arraySlice = __webpack_require__(/*! ../internals/array-slice */ "./node_modules/core-js/internals/array-slice.js");
                var parseJSONString = __webpack_require__(/*! ../internals/parse-json-string */ "./node_modules/core-js/internals/parse-json-string.js");
                var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
                var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/symbol-constructor-detection */ "./node_modules/core-js/internals/symbol-constructor-detection.js");
                var NATIVE_RAW_JSON = __webpack_require__(/*! ../internals/native-raw-json */ "./node_modules/core-js/internals/native-raw-json.js");
                var $String = String;
                var $stringify = getBuiltIn('JSON', 'stringify');
                var exec = uncurryThis(/./.exec);
                var charAt = uncurryThis(''.charAt);
                var charCodeAt = uncurryThis(''.charCodeAt);
                var replace = uncurryThis(''.replace);
                var slice = uncurryThis(''.slice);
                var push = uncurryThis([].push);
                var numberToString = uncurryThis(1.1.toString);
                var surrogates = /[\uD800-\uDFFF]/g;
                var lowSurrogates = /^[\uD800-\uDBFF]$/;
                var hiSurrogates = /^[\uDC00-\uDFFF]$/;
                var MARK = uid();
                var MARK_LENGTH = MARK.length;
                var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function() {
                    var symbol = getBuiltIn('Symbol')('stringify detection');
                    // MS Edge converts symbol values to JSON as {}
                    return $stringify([
                        symbol
                    ]) !== '[null]' || $stringify({
                        a: symbol
                    }) !== '{}' || $stringify(Object(symbol)) !== '{}';
                });
                // https://github.com/tc39/proposal-well-formed-stringify
                var ILL_FORMED_UNICODE = fails(function() {
                    return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
                });
                var stringifyWithProperSymbolsConversion = WRONG_SYMBOLS_CONVERSION ? function(it, replacer) {
                    var args = arraySlice(arguments);
                    var $replacer = getReplacerFunction(replacer);
                    if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
                    args[1] = function(key, value) {
                        // some old implementations (like WebKit) could pass numbers as keys
                        if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
                        if (!isSymbol(value)) return value;
                    };
                    return apply($stringify, null, args);
                } : $stringify;
                var fixIllFormedJSON = function(match, offset, string) {
                    var prev = charAt(string, offset - 1);
                    var next = charAt(string, offset + 1);
                    if (exec(lowSurrogates, match) && !exec(hiSurrogates, next) || exec(hiSurrogates, match) && !exec(lowSurrogates, prev)) return '\\u' + numberToString(charCodeAt(match, 0), 16);
                    return match;
                };
                var getReplacerFunction = function(replacer) {
                    if (isCallable(replacer)) return replacer;
                    if (!isArray(replacer)) return;
                    var rawLength = replacer.length;
                    var keys = [];
                    for(var i = 0; i < rawLength; i++){
                        var element = replacer[i];
                        if (typeof element == 'string') push(keys, element);
                        else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
                    }
                    var keysLength = keys.length;
                    var root = true;
                    return function(key, value) {
                        if (root) {
                            root = false;
                            return value;
                        }
                        if (isArray(this)) return value;
                        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
                    };
                };
                // `JSON.stringify` method
                // https://tc39.es/ecma262/#sec-json.stringify
                // https://github.com/tc39/proposal-json-parse-with-source
                if ($stringify) $({
                    target: 'JSON',
                    stat: true,
                    arity: 3,
                    forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE || !NATIVE_RAW_JSON
                }, {
                    stringify: function stringify(text, replacer, space) {
                        var replacerFunction = getReplacerFunction(replacer);
                        var rawStrings = [];
                        var json = stringifyWithProperSymbolsConversion(text, function(key, value) {
                            // some old implementations (like WebKit) could pass numbers as keys
                            var v = isCallable(replacerFunction) ? call(replacerFunction, this, $String(key), value) : value;
                            return !NATIVE_RAW_JSON && isRawJSON(v) ? MARK + (push(rawStrings, v.rawJSON) - 1) : v;
                        }, space);
                        if (typeof json != 'string') return json;
                        if (ILL_FORMED_UNICODE) json = replace(json, surrogates, fixIllFormedJSON);
                        if (NATIVE_RAW_JSON) return json;
                        var result = '';
                        var length = json.length;
                        for(var i = 0; i < length; i++){
                            var chr = charAt(json, i);
                            if (chr === '"') {
                                var end = parseJSONString(json, ++i).end - 1;
                                var string = slice(json, i, end);
                                result += slice(string, 0, MARK_LENGTH) === MARK ? rawStrings[slice(string, MARK_LENGTH)] : '"' + string + '"';
                                i = end;
                            } else result += chr;
                        }
                        return result;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.number.constructor.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.number.constructor.js ***!
  \***************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js/internals/path.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var inheritIfRequired = __webpack_require__(/*! ../internals/inherit-if-required */ "./node_modules/core-js/internals/inherit-if-required.js");
                var isPrototypeOf = __webpack_require__(/*! ../internals/object-is-prototype-of */ "./node_modules/core-js/internals/object-is-prototype-of.js");
                var isSymbol = __webpack_require__(/*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js");
                var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var getOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js").f;
                var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
                var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
                var thisNumberValue = __webpack_require__(/*! ../internals/this-number-value */ "./node_modules/core-js/internals/this-number-value.js");
                var trim = __webpack_require__(/*! ../internals/string-trim */ "./node_modules/core-js/internals/string-trim.js").trim;
                var NUMBER = 'Number';
                var NativeNumber = globalThis1[NUMBER];
                var PureNumberNamespace = path[NUMBER];
                var NumberPrototype = NativeNumber.prototype;
                var TypeError1 = globalThis1.TypeError;
                var stringSlice = uncurryThis(''.slice);
                var charCodeAt = uncurryThis(''.charCodeAt);
                // `ToNumeric` abstract operation
                // https://tc39.es/ecma262/#sec-tonumeric
                var toNumeric = function(value) {
                    var primValue = toPrimitive(value, 'number');
                    return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
                };
                // `ToNumber` abstract operation
                // https://tc39.es/ecma262/#sec-tonumber
                var toNumber = function(argument) {
                    var it = toPrimitive(argument, 'number');
                    var first, third, radix, maxCode, digits, length, index, code;
                    if (isSymbol(it)) throw new TypeError1('Cannot convert a Symbol value to a number');
                    if (typeof it == 'string' && it.length > 2) {
                        it = trim(it);
                        first = charCodeAt(it, 0);
                        if (first === 43 || first === 45) {
                            third = charCodeAt(it, 2);
                            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
                        } else if (first === 48) {
                            switch(charCodeAt(it, 1)){
                                // fast equal of /^0b[01]+$/i
                                case 66:
                                case 98:
                                    radix = 2;
                                    maxCode = 49;
                                    break;
                                // fast equal of /^0o[0-7]+$/i
                                case 79:
                                case 111:
                                    radix = 8;
                                    maxCode = 55;
                                    break;
                                default:
                                    return +it;
                            }
                            digits = stringSlice(it, 2);
                            length = digits.length;
                            for(index = 0; index < length; index++){
                                code = charCodeAt(digits, index);
                                // parseInt parses a string to a first unavailable symbol
                                // but ToNumber should return NaN if a string contains unavailable symbols
                                if (code < 48 || code > maxCode) return NaN;
                            }
                            return parseInt(digits, radix);
                        }
                    }
                    return +it;
                };
                var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));
                var calledWithNew = function(dummy) {
                    // includes check on 1..constructor(foo) case
                    return isPrototypeOf(NumberPrototype, dummy) && fails(function() {
                        thisNumberValue(dummy);
                    });
                };
                // `Number` constructor
                // https://tc39.es/ecma262/#sec-number-constructor
                var NumberWrapper = function Number1(value) {
                    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
                    return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
                };
                NumberWrapper.prototype = NumberPrototype;
                if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;
                $({
                    global: true,
                    constructor: true,
                    wrap: true,
                    forced: FORCED
                }, {
                    Number: NumberWrapper
                });
                // Use `internal/copy-constructor-properties` helper in `core-js@4`
                var copyConstructorProperties = function(target, source) {
                    for(var keys = DESCRIPTORS ? getOwnPropertyNames(source) : // ES3:
                    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(','), j = 0, key; keys.length > j; j++)if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                };
                if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
                if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);
            /***/ },
            /***/ "./node_modules/core-js/modules/es.object.assign.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.assign.js ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var assign = __webpack_require__(/*! ../internals/object-assign */ "./node_modules/core-js/internals/object-assign.js");
                // `Object.assign` method
                // https://tc39.es/ecma262/#sec-object.assign
                // eslint-disable-next-line es/no-object-assign -- required for testing
                $({
                    target: 'Object',
                    stat: true,
                    arity: 2,
                    forced: Object.assign !== assign
                }, {
                    assign: assign
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.object.get-own-property-symbols.js": /*!****************************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.get-own-property-symbols.js ***!
  \****************************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/symbol-constructor-detection */ "./node_modules/core-js/internals/symbol-constructor-detection.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
                var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
                // V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
                // https://bugs.chromium.org/p/v8/issues/detail?id=3443
                var FORCED = !NATIVE_SYMBOL || fails(function() {
                    getOwnPropertySymbolsModule.f(1);
                });
                // `Object.getOwnPropertySymbols` method
                // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
                $({
                    target: 'Object',
                    stat: true,
                    forced: FORCED
                }, {
                    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
                        var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                        return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.object.keys.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.keys.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
                var nativeKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var FAILS_ON_PRIMITIVES = fails(function() {
                    nativeKeys(1);
                });
                // `Object.keys` method
                // https://tc39.es/ecma262/#sec-object.keys
                $({
                    target: 'Object',
                    stat: true,
                    forced: FAILS_ON_PRIMITIVES
                }, {
                    keys: function keys(it) {
                        return nativeKeys(toObject(it));
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.object.to-string.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.to-string.js ***!
  \*************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js");
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                var toString = __webpack_require__(/*! ../internals/object-to-string */ "./node_modules/core-js/internals/object-to-string.js");
                // `Object.prototype.toString` method
                // https://tc39.es/ecma262/#sec-object.prototype.tostring
                if (!TO_STRING_TAG_SUPPORT) defineBuiltIn(Object.prototype, 'toString', toString, {
                    unsafe: true
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.promise.all.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.promise.all.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var newPromiseCapabilityModule = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js/internals/new-promise-capability.js");
                var perform = __webpack_require__(/*! ../internals/perform */ "./node_modules/core-js/internals/perform.js");
                var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
                var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(/*! ../internals/promise-statics-incorrect-iteration */ "./node_modules/core-js/internals/promise-statics-incorrect-iteration.js");
                // `Promise.all` method
                // https://tc39.es/ecma262/#sec-promise.all
                $({
                    target: 'Promise',
                    stat: true,
                    forced: PROMISE_STATICS_INCORRECT_ITERATION
                }, {
                    all: function all(iterable) {
                        var C = this;
                        var capability = newPromiseCapabilityModule.f(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var $promiseResolve = aCallable(C.resolve);
                            var values = [];
                            var counter = 0;
                            var remaining = 1;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyCalled = false;
                                remaining++;
                                call($promiseResolve, C, promise).then(function(value) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = value;
                                    --remaining || resolve(values);
                                }, reject);
                            });
                            --remaining || resolve(values);
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.promise.catch.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.promise.catch.js ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(/*! ../internals/promise-constructor-detection */ "./node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR;
                var NativePromiseConstructor = __webpack_require__(/*! ../internals/promise-native-constructor */ "./node_modules/core-js/internals/promise-native-constructor.js");
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
                // `Promise.prototype.catch` method
                // https://tc39.es/ecma262/#sec-promise.prototype.catch
                $({
                    target: 'Promise',
                    proto: true,
                    forced: FORCED_PROMISE_CONSTRUCTOR,
                    real: true
                }, {
                    'catch': function(onRejected) {
                        return this.then(undefined, onRejected);
                    }
                });
                // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
                if (!IS_PURE && isCallable(NativePromiseConstructor)) {
                    var method = getBuiltIn('Promise').prototype['catch'];
                    if (NativePromisePrototype['catch'] !== method) defineBuiltIn(NativePromisePrototype, 'catch', method, {
                        unsafe: true
                    });
                }
            /***/ },
            /***/ "./node_modules/core-js/modules/es.promise.constructor.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/modules/es.promise.constructor.js ***!
  \****************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var IS_NODE = __webpack_require__(/*! ../internals/environment-is-node */ "./node_modules/core-js/internals/environment-is-node.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js/internals/path.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");
                var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
                var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/core-js/internals/set-species.js");
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
                var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
                var task = __webpack_require__(/*! ../internals/task */ "./node_modules/core-js/internals/task.js").set;
                var microtask = __webpack_require__(/*! ../internals/microtask */ "./node_modules/core-js/internals/microtask.js");
                var hostReportErrors = __webpack_require__(/*! ../internals/host-report-errors */ "./node_modules/core-js/internals/host-report-errors.js");
                var perform = __webpack_require__(/*! ../internals/perform */ "./node_modules/core-js/internals/perform.js");
                var Queue = __webpack_require__(/*! ../internals/queue */ "./node_modules/core-js/internals/queue.js");
                var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
                var NativePromiseConstructor = __webpack_require__(/*! ../internals/promise-native-constructor */ "./node_modules/core-js/internals/promise-native-constructor.js");
                var PromiseConstructorDetection = __webpack_require__(/*! ../internals/promise-constructor-detection */ "./node_modules/core-js/internals/promise-constructor-detection.js");
                var newPromiseCapabilityModule = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js/internals/new-promise-capability.js");
                var PROMISE = 'Promise';
                var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
                var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
                var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
                var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
                var setInternalState = InternalStateModule.set;
                var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
                var PromiseConstructor = NativePromiseConstructor;
                var PromisePrototype = NativePromisePrototype;
                var TypeError1 = globalThis1.TypeError;
                var document1 = globalThis1.document;
                var process = globalThis1.process;
                var newPromiseCapability = newPromiseCapabilityModule.f;
                var newGenericPromiseCapability = newPromiseCapability;
                var DISPATCH_EVENT = !!(document1 && document1.createEvent && globalThis1.dispatchEvent);
                var UNHANDLED_REJECTION = 'unhandledrejection';
                var REJECTION_HANDLED = 'rejectionhandled';
                var PENDING = 0;
                var FULFILLED = 1;
                var REJECTED = 2;
                var HANDLED = 1;
                var UNHANDLED = 2;
                var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
                // helpers
                var isThenable = function(it) {
                    var then;
                    return isObject(it) && isCallable(then = it.then) ? then : false;
                };
                var callReaction = function(reaction, state) {
                    var value = state.value;
                    var ok = state.state === FULFILLED;
                    var handler = ok ? reaction.ok : reaction.fail;
                    var resolve = reaction.resolve;
                    var reject = reaction.reject;
                    var domain = reaction.domain;
                    var result, then, exited;
                    try {
                        if (handler) {
                            if (!ok) {
                                if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                                state.rejection = HANDLED;
                            }
                            if (handler === true) result = value;
                            else {
                                if (domain) domain.enter();
                                result = handler(value); // can throw
                                if (domain) {
                                    domain.exit();
                                    exited = true;
                                }
                            }
                            if (result === reaction.promise) reject(new TypeError1('Promise-chain cycle'));
                            else if (then = isThenable(result)) call(then, result, resolve, reject);
                            else resolve(result);
                        } else reject(value);
                    } catch (error) {
                        if (domain && !exited) domain.exit();
                        reject(error);
                    }
                };
                var notify = function(state, isReject) {
                    if (state.notified) return;
                    state.notified = true;
                    microtask(function() {
                        var reactions = state.reactions;
                        var reaction;
                        while(reaction = reactions.get())callReaction(reaction, state);
                        state.notified = false;
                        if (isReject && !state.rejection) onUnhandled(state);
                    });
                };
                var dispatchEvent = function(name, promise, reason) {
                    var event, handler;
                    if (DISPATCH_EVENT) {
                        event = document1.createEvent('Event');
                        event.promise = promise;
                        event.reason = reason;
                        event.initEvent(name, false, true);
                        globalThis1.dispatchEvent(event);
                    } else event = {
                        promise: promise,
                        reason: reason
                    };
                    if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis1['on' + name])) handler(event);
                    else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
                };
                var onUnhandled = function(state) {
                    call(task, globalThis1, function() {
                        var promise = state.facade;
                        var value = state.value;
                        var IS_UNHANDLED = isUnhandled(state);
                        var result;
                        if (IS_UNHANDLED) {
                            result = perform(function() {
                                if (IS_NODE) process.emit('unhandledRejection', value, promise);
                                else dispatchEvent(UNHANDLED_REJECTION, promise, value);
                            });
                            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
                            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
                            if (result.error) throw result.value;
                        }
                    });
                };
                var isUnhandled = function(state) {
                    return state.rejection !== HANDLED && !state.parent;
                };
                var onHandleUnhandled = function(state) {
                    call(task, globalThis1, function() {
                        var promise = state.facade;
                        if (IS_NODE) process.emit('rejectionHandled', promise);
                        else dispatchEvent(REJECTION_HANDLED, promise, state.value);
                    });
                };
                var bind = function(fn, state, unwrap) {
                    return function(value) {
                        fn(state, value, unwrap);
                    };
                };
                var internalReject = function(state, value, unwrap) {
                    if (state.done) return;
                    state.done = true;
                    if (unwrap) state = unwrap;
                    state.value = value;
                    state.state = REJECTED;
                    notify(state, true);
                };
                var internalResolve = function(state, value, unwrap) {
                    if (state.done) return;
                    state.done = true;
                    if (unwrap) state = unwrap;
                    try {
                        if (state.facade === value) throw new TypeError1("Promise can't be resolved itself");
                        var then = isThenable(value);
                        if (then) microtask(function() {
                            var wrapper = {
                                done: false
                            };
                            try {
                                call(then, value, bind(internalResolve, wrapper, state), bind(internalReject, wrapper, state));
                            } catch (error) {
                                internalReject(wrapper, error, state);
                            }
                        });
                        else {
                            state.value = value;
                            state.state = FULFILLED;
                            notify(state, false);
                        }
                    } catch (error) {
                        internalReject({
                            done: false
                        }, error, state);
                    }
                };
                // constructor polyfill
                if (FORCED_PROMISE_CONSTRUCTOR) {
                    // 25.4.3.1 Promise(executor)
                    PromiseConstructor = function Promise1(executor) {
                        anInstance(this, PromisePrototype);
                        aCallable(executor);
                        call(Internal, this);
                        var state = getInternalPromiseState(this);
                        try {
                            executor(bind(internalResolve, state), bind(internalReject, state));
                        } catch (error) {
                            internalReject(state, error);
                        }
                    };
                    PromisePrototype = PromiseConstructor.prototype;
                    // eslint-disable-next-line no-unused-vars -- required for `.length`
                    Internal = function Promise1(executor) {
                        setInternalState(this, {
                            type: PROMISE,
                            done: false,
                            notified: false,
                            parent: false,
                            reactions: new Queue(),
                            rejection: false,
                            state: PENDING,
                            value: null
                        });
                    };
                    // `Promise.prototype.then` method
                    // https://tc39.es/ecma262/#sec-promise.prototype.then
                    Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
                        var state = getInternalPromiseState(this);
                        var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
                        state.parent = true;
                        reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
                        reaction.fail = isCallable(onRejected) && onRejected;
                        reaction.domain = IS_NODE ? process.domain : undefined;
                        if (state.state === PENDING) state.reactions.add(reaction);
                        else microtask(function() {
                            callReaction(reaction, state);
                        });
                        return reaction.promise;
                    });
                    OwnPromiseCapability = function() {
                        var promise = new Internal();
                        var state = getInternalPromiseState(promise);
                        this.promise = promise;
                        this.resolve = bind(internalResolve, state);
                        this.reject = bind(internalReject, state);
                    };
                    newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
                        return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
                    };
                    if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
                        nativeThen = NativePromisePrototype.then;
                        if (!NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
                        defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
                            var that = this;
                            return new PromiseConstructor(function(resolve, reject) {
                                call(nativeThen, that, resolve, reject);
                            }).then(onFulfilled, onRejected);
                        // https://github.com/zloirock/core-js/issues/640
                        }, {
                            unsafe: true
                        });
                        // make `.constructor === Promise` work for native promise-based APIs
                        try {
                            delete NativePromisePrototype.constructor;
                        } catch (error) {}
                        // make `instanceof Promise` work for native promise-based APIs
                        if (setPrototypeOf) setPrototypeOf(NativePromisePrototype, PromisePrototype);
                    }
                }
                // `Promise` constructor
                // https://tc39.es/ecma262/#sec-promise-executor
                $({
                    global: true,
                    constructor: true,
                    wrap: true,
                    forced: FORCED_PROMISE_CONSTRUCTOR
                }, {
                    Promise: PromiseConstructor
                });
                PromiseWrapper = path.Promise;
                setToStringTag(PromiseConstructor, PROMISE, false, true);
                setSpecies(PROMISE);
            /***/ },
            /***/ "./node_modules/core-js/modules/es.promise.js": /*!****************************************************!*\
  !*** ./node_modules/core-js/modules/es.promise.js ***!
  \****************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove this module from `core-js@4` since it's split to modules listed below
                __webpack_require__(/*! ../modules/es.promise.constructor */ "./node_modules/core-js/modules/es.promise.constructor.js");
                __webpack_require__(/*! ../modules/es.promise.all */ "./node_modules/core-js/modules/es.promise.all.js");
                __webpack_require__(/*! ../modules/es.promise.catch */ "./node_modules/core-js/modules/es.promise.catch.js");
                __webpack_require__(/*! ../modules/es.promise.race */ "./node_modules/core-js/modules/es.promise.race.js");
                __webpack_require__(/*! ../modules/es.promise.reject */ "./node_modules/core-js/modules/es.promise.reject.js");
                __webpack_require__(/*! ../modules/es.promise.resolve */ "./node_modules/core-js/modules/es.promise.resolve.js");
            /***/ },
            /***/ "./node_modules/core-js/modules/es.promise.race.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.promise.race.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var newPromiseCapabilityModule = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js/internals/new-promise-capability.js");
                var perform = __webpack_require__(/*! ../internals/perform */ "./node_modules/core-js/internals/perform.js");
                var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
                var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(/*! ../internals/promise-statics-incorrect-iteration */ "./node_modules/core-js/internals/promise-statics-incorrect-iteration.js");
                // `Promise.race` method
                // https://tc39.es/ecma262/#sec-promise.race
                $({
                    target: 'Promise',
                    stat: true,
                    forced: PROMISE_STATICS_INCORRECT_ITERATION
                }, {
                    race: function race(iterable) {
                        var C = this;
                        var capability = newPromiseCapabilityModule.f(C);
                        var reject = capability.reject;
                        var result = perform(function() {
                            var $promiseResolve = aCallable(C.resolve);
                            iterate(iterable, function(promise) {
                                call($promiseResolve, C, promise).then(capability.resolve, reject);
                            });
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.promise.reject.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.promise.reject.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var newPromiseCapabilityModule = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js/internals/new-promise-capability.js");
                var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(/*! ../internals/promise-constructor-detection */ "./node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR;
                // `Promise.reject` method
                // https://tc39.es/ecma262/#sec-promise.reject
                $({
                    target: 'Promise',
                    stat: true,
                    forced: FORCED_PROMISE_CONSTRUCTOR
                }, {
                    reject: function reject(r) {
                        var capability = newPromiseCapabilityModule.f(this);
                        var capabilityReject = capability.reject;
                        capabilityReject(r);
                        return capability.promise;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.promise.resolve.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.promise.resolve.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var NativePromiseConstructor = __webpack_require__(/*! ../internals/promise-native-constructor */ "./node_modules/core-js/internals/promise-native-constructor.js");
                var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(/*! ../internals/promise-constructor-detection */ "./node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR;
                var promiseResolve = __webpack_require__(/*! ../internals/promise-resolve */ "./node_modules/core-js/internals/promise-resolve.js");
                var PromiseConstructorWrapper = getBuiltIn('Promise');
                var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;
                // `Promise.resolve` method
                // https://tc39.es/ecma262/#sec-promise.resolve
                $({
                    target: 'Promise',
                    stat: true,
                    forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR
                }, {
                    resolve: function resolve(x) {
                        return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.regexp.exec.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.regexp.exec.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var exec = __webpack_require__(/*! ../internals/regexp-exec */ "./node_modules/core-js/internals/regexp-exec.js");
                // `RegExp.prototype.exec` method
                // https://tc39.es/ecma262/#sec-regexp.prototype.exec
                $({
                    target: 'RegExp',
                    proto: true,
                    forced: /./.exec !== exec
                }, {
                    exec: exec
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.regexp.test.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.regexp.test.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove from `core-js@4` since it's moved to entry points
                __webpack_require__(/*! ../modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var DELEGATES_TO_EXEC = function() {
                    var execCalled = false;
                    var re = /[ac]/;
                    re.exec = function() {
                        execCalled = true;
                        return /./.exec.apply(this, arguments);
                    };
                    return re.test('abc') === true && execCalled;
                }();
                var nativeTest = /./.test;
                // `RegExp.prototype.test` method
                // https://tc39.es/ecma262/#sec-regexp.prototype.test
                $({
                    target: 'RegExp',
                    proto: true,
                    forced: !DELEGATES_TO_EXEC
                }, {
                    test: function(S) {
                        var R = anObject(this);
                        var string = toString(S);
                        var exec = R.exec;
                        if (!isCallable(exec)) return call(nativeTest, R, string);
                        var result = call(exec, R, string);
                        if (result === null) return false;
                        anObject(result);
                        return true;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.regexp.to-string.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.regexp.to-string.js ***!
  \*************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var PROPER_FUNCTION_NAME = __webpack_require__(/*! ../internals/function-name */ "./node_modules/core-js/internals/function-name.js").PROPER;
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var $toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var getRegExpFlags = __webpack_require__(/*! ../internals/regexp-get-flags */ "./node_modules/core-js/internals/regexp-get-flags.js");
                var TO_STRING = 'toString';
                var RegExpPrototype = RegExp.prototype;
                var nativeToString = RegExpPrototype[TO_STRING];
                var NOT_GENERIC = fails(function() {
                    return nativeToString.call({
                        source: 'a',
                        flags: 'b'
                    }) !== '/a/b';
                });
                // FF44- RegExp#toString has a wrong name
                var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;
                // `RegExp.prototype.toString` method
                // https://tc39.es/ecma262/#sec-regexp.prototype.tostring
                if (NOT_GENERIC || INCORRECT_NAME) defineBuiltIn(RegExpPrototype, TO_STRING, function toString() {
                    var R = anObject(this);
                    var pattern = $toString(R.source);
                    var flags = $toString(getRegExpFlags(R));
                    return '/' + pattern + '/' + flags;
                }, {
                    unsafe: true
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.set.constructor.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.set.constructor.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/core-js/internals/collection.js");
                var collectionStrong = __webpack_require__(/*! ../internals/collection-strong */ "./node_modules/core-js/internals/collection-strong.js");
                // `Set` constructor
                // https://tc39.es/ecma262/#sec-set-objects
                collection('Set', function(init) {
                    return function Set1() {
                        return init(this, arguments.length ? arguments[0] : undefined);
                    };
                }, collectionStrong);
            /***/ },
            /***/ "./node_modules/core-js/modules/es.set.js": /*!************************************************!*\
  !*** ./node_modules/core-js/modules/es.set.js ***!
  \************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove this module from `core-js@4` since it's replaced to module below
                __webpack_require__(/*! ../modules/es.set.constructor */ "./node_modules/core-js/modules/es.set.constructor.js");
            /***/ },
            /***/ "./node_modules/core-js/modules/es.string.ends-with.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.ends-with.js ***!
  \*************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this-clause */ "./node_modules/core-js/internals/function-uncurry-this-clause.js");
                var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
                var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js/internals/not-a-regexp.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js/internals/correct-is-regexp-logic.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var slice = uncurryThis(''.slice);
                var min = Math.min;
                var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
                // https://github.com/zloirock/core-js/pull/702
                var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
                    var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
                    return descriptor && !descriptor.writable;
                }();
                // `String.prototype.endsWith` method
                // https://tc39.es/ecma262/#sec-string.prototype.endswith
                $({
                    target: 'String',
                    proto: true,
                    forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
                }, {
                    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
                        var that = toString(requireObjectCoercible(this));
                        notARegExp(searchString);
                        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
                        var len = that.length;
                        var end = endPosition === undefined ? len : min(toLength(endPosition), len);
                        var search = toString(searchString);
                        return slice(that, end - search.length, end) === search;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.string.includes.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.includes.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js/internals/not-a-regexp.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js/internals/correct-is-regexp-logic.js");
                var stringIndexOf = uncurryThis(''.indexOf);
                // `String.prototype.includes` method
                // https://tc39.es/ecma262/#sec-string.prototype.includes
                $({
                    target: 'String',
                    proto: true,
                    forced: !correctIsRegExpLogic('includes')
                }, {
                    includes: function includes(searchString /* , position = 0 */ ) {
                        return !!~stringIndexOf(toString(requireObjectCoercible(this)), toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.string.iterator.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.iterator.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var charAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js").charAt;
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
                var defineIterator = __webpack_require__(/*! ../internals/iterator-define */ "./node_modules/core-js/internals/iterator-define.js");
                var createIterResultObject = __webpack_require__(/*! ../internals/create-iter-result-object */ "./node_modules/core-js/internals/create-iter-result-object.js");
                var STRING_ITERATOR = 'String Iterator';
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
                // `String.prototype[@@iterator]` method
                // https://tc39.es/ecma262/#sec-string.prototype-@@iterator
                defineIterator(String, 'String', function(iterated) {
                    setInternalState(this, {
                        type: STRING_ITERATOR,
                        string: toString(iterated),
                        index: 0
                    });
                // `%StringIteratorPrototype%.next` method
                // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
                }, function next() {
                    var state = getInternalState(this);
                    var string = state.string;
                    var index = state.index;
                    var point;
                    if (index >= string.length) return createIterResultObject(undefined, true);
                    point = charAt(string, index);
                    state.index += point.length;
                    return createIterResultObject(point, false);
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.string.link.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.link.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var createHTML = __webpack_require__(/*! ../internals/create-html */ "./node_modules/core-js/internals/create-html.js");
                var forcedStringHTMLMethod = __webpack_require__(/*! ../internals/string-html-forced */ "./node_modules/core-js/internals/string-html-forced.js");
                // `String.prototype.link` method
                // https://tc39.es/ecma262/#sec-string.prototype.link
                $({
                    target: 'String',
                    proto: true,
                    forced: forcedStringHTMLMethod('link')
                }, {
                    link: function link(url) {
                        return createHTML(this, 'a', 'href', url);
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.string.match.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.match.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var getMethod = __webpack_require__(/*! ../internals/get-method */ "./node_modules/core-js/internals/get-method.js");
                var advanceStringIndex = __webpack_require__(/*! ../internals/advance-string-index */ "./node_modules/core-js/internals/advance-string-index.js");
                var getRegExpFlags = __webpack_require__(/*! ../internals/regexp-get-flags */ "./node_modules/core-js/internals/regexp-get-flags.js");
                var regExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");
                var stringIndexOf = uncurryThis(''.indexOf);
                // @@match logic
                fixRegExpWellKnownSymbolLogic('match', function(MATCH, nativeMatch, maybeCallNative) {
                    return [
                        // `String.prototype.match` method
                        // https://tc39.es/ecma262/#sec-string.prototype.match
                        function match(regexp) {
                            var O = requireObjectCoercible(this);
                            var matcher = isObject(regexp) ? getMethod(regexp, MATCH) : undefined;
                            return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
                        },
                        // `RegExp.prototype[@@match]` method
                        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
                        function(string) {
                            var rx = anObject(this);
                            var S = toString(string);
                            var res = maybeCallNative(nativeMatch, rx, S);
                            if (res.done) return res.value;
                            var flags = toString(getRegExpFlags(rx));
                            if (stringIndexOf(flags, 'g') === -1) return regExpExec(rx, S);
                            var fullUnicode = stringIndexOf(flags, 'u') !== -1;
                            rx.lastIndex = 0;
                            var A = [];
                            var n = 0;
                            var result;
                            while((result = regExpExec(rx, S)) !== null){
                                var matchStr = toString(result[0]);
                                A[n] = matchStr;
                                if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                                n++;
                            }
                            return n === 0 ? null : A;
                        }
                    ];
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.string.replace.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.replace.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var apply = __webpack_require__(/*! ../internals/function-apply */ "./node_modules/core-js/internals/function-apply.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var toIntegerOrInfinity = __webpack_require__(/*! ../internals/to-integer-or-infinity */ "./node_modules/core-js/internals/to-integer-or-infinity.js");
                var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var advanceStringIndex = __webpack_require__(/*! ../internals/advance-string-index */ "./node_modules/core-js/internals/advance-string-index.js");
                var getMethod = __webpack_require__(/*! ../internals/get-method */ "./node_modules/core-js/internals/get-method.js");
                var getSubstitution = __webpack_require__(/*! ../internals/get-substitution */ "./node_modules/core-js/internals/get-substitution.js");
                var getRegExpFlags = __webpack_require__(/*! ../internals/regexp-get-flags */ "./node_modules/core-js/internals/regexp-get-flags.js");
                var regExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var REPLACE = wellKnownSymbol('replace');
                var max = Math.max;
                var min = Math.min;
                var concat = uncurryThis([].concat);
                var push = uncurryThis([].push);
                var stringIndexOf = uncurryThis(''.indexOf);
                var stringSlice = uncurryThis(''.slice);
                var maybeToString = function(it) {
                    return it === undefined ? it : String(it);
                };
                // IE <= 11 replaces $0 with the whole match, as if it was $&
                // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
                var REPLACE_KEEPS_$0 = function() {
                    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
                    return 'a'.replace(/./, '$0') === '$0';
                }();
                // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
                var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
                    if (/./[REPLACE]) return /./[REPLACE]('a', '$0') === '';
                    return false;
                }();
                var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
                    var re = /./;
                    re.exec = function() {
                        var result = [];
                        result.groups = {
                            a: '7'
                        };
                        return result;
                    };
                    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
                    return ''.replace(re, '$<a>') !== '7';
                });
                // @@replace logic
                fixRegExpWellKnownSymbolLogic('replace', function(_, nativeReplace, maybeCallNative) {
                    var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
                    return [
                        // `String.prototype.replace` method
                        // https://tc39.es/ecma262/#sec-string.prototype.replace
                        function replace(searchValue, replaceValue) {
                            var O = requireObjectCoercible(this);
                            var replacer = isObject(searchValue) ? getMethod(searchValue, REPLACE) : undefined;
                            return replacer ? call(replacer, searchValue, O, replaceValue) : call(nativeReplace, toString(O), searchValue, replaceValue);
                        },
                        // `RegExp.prototype[@@replace]` method
                        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
                        function(string, replaceValue) {
                            var rx = anObject(this);
                            var S = toString(string);
                            if (typeof replaceValue == 'string' && stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf(replaceValue, '$<') === -1) {
                                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                                if (res.done) return res.value;
                            }
                            var functionalReplace = isCallable(replaceValue);
                            if (!functionalReplace) replaceValue = toString(replaceValue);
                            var flags = toString(getRegExpFlags(rx));
                            var global = stringIndexOf(flags, 'g') !== -1;
                            var fullUnicode;
                            if (global) {
                                fullUnicode = stringIndexOf(flags, 'u') !== -1;
                                rx.lastIndex = 0;
                            }
                            var results = [];
                            var result;
                            while(true){
                                result = regExpExec(rx, S);
                                if (result === null) break;
                                push(results, result);
                                if (!global) break;
                                var matchStr = toString(result[0]);
                                if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                            }
                            var accumulatedResult = '';
                            var nextSourcePosition = 0;
                            for(var i = 0; i < results.length; i++){
                                result = results[i];
                                var matched = toString(result[0]);
                                var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
                                var captures = [];
                                var replacement;
                                // NOTE: This is equivalent to
                                //   captures = result.slice(1).map(maybeToString)
                                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                                for(var j = 1; j < result.length; j++)push(captures, maybeToString(result[j]));
                                var namedCaptures = result.groups;
                                if (functionalReplace) {
                                    var replacerArgs = concat([
                                        matched
                                    ], captures, position, S);
                                    if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
                                    replacement = toString(apply(replaceValue, undefined, replacerArgs));
                                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                                if (position >= nextSourcePosition) {
                                    accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
                                    nextSourcePosition = position + matched.length;
                                }
                            }
                            return accumulatedResult + stringSlice(S, nextSourcePosition);
                        }
                    ];
                }, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
            /***/ },
            /***/ "./node_modules/core-js/modules/es.string.split.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.split.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
                var advanceStringIndex = __webpack_require__(/*! ../internals/advance-string-index */ "./node_modules/core-js/internals/advance-string-index.js");
                var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var getMethod = __webpack_require__(/*! ../internals/get-method */ "./node_modules/core-js/internals/get-method.js");
                var regExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");
                var stickyHelpers = __webpack_require__(/*! ../internals/regexp-sticky-helpers */ "./node_modules/core-js/internals/regexp-sticky-helpers.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
                var MAX_UINT32 = 0xFFFFFFFF;
                var min = Math.min;
                var push = uncurryThis([].push);
                var stringSlice = uncurryThis(''.slice);
                // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
                // Weex JS has frozen built-in prototypes, so use try / catch wrapper
                var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
                    // eslint-disable-next-line regexp/no-empty-group -- required for testing
                    var re = /(?:)/;
                    var originalExec = re.exec;
                    re.exec = function() {
                        return originalExec.apply(this, arguments);
                    };
                    var result = 'ab'.split(re);
                    return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
                });
                var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
                'test'.split(/(?:)/, -1).length !== 4 || 'ab'.split(/(?:ab)*/).length !== 2 || '.'.split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
                '.'.split(/()()/).length > 1 || ''.split(/.?/).length;
                // @@split logic
                fixRegExpWellKnownSymbolLogic('split', function(SPLIT, nativeSplit, maybeCallNative) {
                    var internalSplit = '0'.split(undefined, 0).length ? function(separator, limit) {
                        return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
                    } : nativeSplit;
                    return [
                        // `String.prototype.split` method
                        // https://tc39.es/ecma262/#sec-string.prototype.split
                        function split(separator, limit) {
                            var O = requireObjectCoercible(this);
                            var splitter = isObject(separator) ? getMethod(separator, SPLIT) : undefined;
                            return splitter ? call(splitter, separator, O, limit) : call(internalSplit, toString(O), separator, limit);
                        },
                        // `RegExp.prototype[@@split]` method
                        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
                        //
                        // NOTE: This cannot be properly polyfilled in engines that don't support
                        // the 'y' flag.
                        function(string, limit) {
                            var rx = anObject(this);
                            var S = toString(string);
                            if (!BUGGY) {
                                var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
                                if (res.done) return res.value;
                            }
                            var C = speciesConstructor(rx, RegExp);
                            var unicodeMatching = rx.unicode;
                            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y ? 'g' : 'y');
                            // ^(? + rx + ) is needed, in combination with some S slicing, to
                            // simulate the 'y' flag.
                            var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
                            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
                            if (lim === 0) return [];
                            if (S.length === 0) return regExpExec(splitter, S) === null ? [
                                S
                            ] : [];
                            var p = 0;
                            var q = 0;
                            var A = [];
                            while(q < S.length){
                                splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
                                var z = regExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
                                var e;
                                if (z === null || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = advanceStringIndex(S, q, unicodeMatching);
                                else {
                                    push(A, stringSlice(S, p, q));
                                    if (A.length === lim) return A;
                                    for(var i = 1; i <= z.length - 1; i++){
                                        push(A, z[i]);
                                        if (A.length === lim) return A;
                                    }
                                    q = p = e;
                                }
                            }
                            push(A, stringSlice(S, p));
                            return A;
                        }
                    ];
                }, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
            /***/ },
            /***/ "./node_modules/core-js/modules/es.string.starts-with.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.starts-with.js ***!
  \***************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this-clause */ "./node_modules/core-js/internals/function-uncurry-this-clause.js");
                var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
                var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js/internals/not-a-regexp.js");
                var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
                var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js/internals/correct-is-regexp-logic.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var stringSlice = uncurryThis(''.slice);
                var min = Math.min;
                var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
                // https://github.com/zloirock/core-js/pull/702
                var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
                    var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
                    return descriptor && !descriptor.writable;
                }();
                // `String.prototype.startsWith` method
                // https://tc39.es/ecma262/#sec-string.prototype.startswith
                $({
                    target: 'String',
                    proto: true,
                    forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
                }, {
                    startsWith: function startsWith(searchString /* , position = 0 */ ) {
                        var that = toString(requireObjectCoercible(this));
                        notARegExp(searchString);
                        var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
                        var search = toString(searchString);
                        return stringSlice(that, index, index + search.length) === search;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.string.trim.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.trim.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var $trim = __webpack_require__(/*! ../internals/string-trim */ "./node_modules/core-js/internals/string-trim.js").trim;
                var forcedStringTrimMethod = __webpack_require__(/*! ../internals/string-trim-forced */ "./node_modules/core-js/internals/string-trim-forced.js");
                // `String.prototype.trim` method
                // https://tc39.es/ecma262/#sec-string.prototype.trim
                $({
                    target: 'String',
                    proto: true,
                    forced: forcedStringTrimMethod('trim')
                }, {
                    trim: function trim() {
                        return $trim(this);
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.symbol.constructor.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.constructor.js ***!
  \***************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/symbol-constructor-detection */ "./node_modules/core-js/internals/symbol-constructor-detection.js");
                var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var isPrototypeOf = __webpack_require__(/*! ../internals/object-is-prototype-of */ "./node_modules/core-js/internals/object-is-prototype-of.js");
                var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
                var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
                var toPropertyKey = __webpack_require__(/*! ../internals/to-property-key */ "./node_modules/core-js/internals/to-property-key.js");
                var $toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
                var nativeObjectCreate = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
                var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
                var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js");
                var getOwnPropertyNamesExternal = __webpack_require__(/*! ../internals/object-get-own-property-names-external */ "./node_modules/core-js/internals/object-get-own-property-names-external.js");
                var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
                var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
                var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
                var definePropertiesModule = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/core-js/internals/object-define-properties.js");
                var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
                var defineBuiltIn = __webpack_require__(/*! ../internals/define-built-in */ "./node_modules/core-js/internals/define-built-in.js");
                var defineBuiltInAccessor = __webpack_require__(/*! ../internals/define-built-in-accessor */ "./node_modules/core-js/internals/define-built-in-accessor.js");
                var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
                var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
                var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
                var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var wrappedWellKnownSymbolModule = __webpack_require__(/*! ../internals/well-known-symbol-wrapped */ "./node_modules/core-js/internals/well-known-symbol-wrapped.js");
                var defineWellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol-define */ "./node_modules/core-js/internals/well-known-symbol-define.js");
                var defineSymbolToPrimitive = __webpack_require__(/*! ../internals/symbol-define-to-primitive */ "./node_modules/core-js/internals/symbol-define-to-primitive.js");
                var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
                var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
                var $forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").forEach;
                var HIDDEN = sharedKey('hidden');
                var SYMBOL = 'Symbol';
                var PROTOTYPE = 'prototype';
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(SYMBOL);
                var ObjectPrototype = Object[PROTOTYPE];
                var $Symbol = globalThis1.Symbol;
                var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
                var RangeError1 = globalThis1.RangeError;
                var TypeError1 = globalThis1.TypeError;
                var QObject = globalThis1.QObject;
                var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                var nativeDefineProperty = definePropertyModule.f;
                var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
                var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
                var push = uncurryThis([].push);
                var AllSymbols = shared('symbols');
                var ObjectPrototypeSymbols = shared('op-symbols');
                var WellKnownSymbolsStore = shared('wks');
                // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
                var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
                // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
                var fallbackDefineProperty = function(O, P, Attributes) {
                    var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
                    if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
                    nativeDefineProperty(O, P, Attributes);
                    if (ObjectPrototypeDescriptor && O !== ObjectPrototype) nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
                };
                var setSymbolDescriptor = DESCRIPTORS && fails(function() {
                    return nativeObjectCreate(nativeDefineProperty({}, 'a', {
                        get: function() {
                            return nativeDefineProperty(this, 'a', {
                                value: 7
                            }).a;
                        }
                    })).a !== 7;
                }) ? fallbackDefineProperty : nativeDefineProperty;
                var wrap = function(tag, description) {
                    var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
                    setInternalState(symbol, {
                        type: SYMBOL,
                        tag: tag,
                        description: description
                    });
                    if (!DESCRIPTORS) symbol.description = description;
                    return symbol;
                };
                var $defineProperty = function defineProperty(O, P, Attributes) {
                    if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
                    anObject(O);
                    var key = toPropertyKey(P);
                    anObject(Attributes);
                    if (hasOwn(AllSymbols, key)) {
                        if (!Attributes.enumerable) {
                            if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, nativeObjectCreate(null)));
                            O[HIDDEN][key] = true;
                        } else {
                            if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
                            Attributes = nativeObjectCreate(Attributes, {
                                enumerable: createPropertyDescriptor(0, false)
                            });
                        }
                        return setSymbolDescriptor(O, key, Attributes);
                    }
                    return nativeDefineProperty(O, key, Attributes);
                };
                var $defineProperties = function defineProperties(O, Properties) {
                    anObject(O);
                    var properties = toIndexedObject(Properties);
                    var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
                    $forEach(keys, function(key) {
                        if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
                    });
                    return O;
                };
                var $create = function create(O, Properties) {
                    return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
                };
                var $propertyIsEnumerable = function propertyIsEnumerable(V) {
                    var P = toPropertyKey(V);
                    var enumerable = call(nativePropertyIsEnumerable, this, P);
                    if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
                    return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
                };
                var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
                    var it = toIndexedObject(O);
                    var key = toPropertyKey(P);
                    if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
                    var descriptor = nativeGetOwnPropertyDescriptor(it, key);
                    if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) descriptor.enumerable = true;
                    return descriptor;
                };
                var $getOwnPropertyNames = function getOwnPropertyNames(O) {
                    var names = nativeGetOwnPropertyNames(toIndexedObject(O));
                    var result = [];
                    $forEach(names, function(key) {
                        if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
                    });
                    return result;
                };
                var $getOwnPropertySymbols = function(O) {
                    var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
                    var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
                    var result = [];
                    $forEach(names, function(key) {
                        if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) push(result, AllSymbols[key]);
                    });
                    return result;
                };
                // `Symbol` constructor
                // https://tc39.es/ecma262/#sec-symbol-constructor
                if (!NATIVE_SYMBOL) {
                    $Symbol = function Symbol1() {
                        if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError1('Symbol is not a constructor');
                        var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
                        var tag = uid(description);
                        var setter = function(value) {
                            var $this = this === undefined ? globalThis1 : this;
                            if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
                            if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
                            var descriptor = createPropertyDescriptor(1, value);
                            try {
                                setSymbolDescriptor($this, tag, descriptor);
                            } catch (error) {
                                if (!(error instanceof RangeError1)) throw error;
                                fallbackDefineProperty($this, tag, descriptor);
                            }
                        };
                        if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
                            configurable: true,
                            set: setter
                        });
                        return wrap(tag, description);
                    };
                    SymbolPrototype = $Symbol[PROTOTYPE];
                    defineBuiltIn(SymbolPrototype, 'toString', function toString() {
                        return getInternalState(this).tag;
                    });
                    defineBuiltIn($Symbol, 'withoutSetter', function(description) {
                        return wrap(uid(description), description);
                    });
                    propertyIsEnumerableModule.f = $propertyIsEnumerable;
                    definePropertyModule.f = $defineProperty;
                    definePropertiesModule.f = $defineProperties;
                    getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
                    getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
                    getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
                    wrappedWellKnownSymbolModule.f = function(name) {
                        return wrap(wellKnownSymbol(name), name);
                    };
                    if (DESCRIPTORS) {
                        // https://tc39.es/ecma262/#sec-symbol.prototype.description
                        defineBuiltInAccessor(SymbolPrototype, 'description', {
                            configurable: true,
                            get: function description() {
                                return getInternalState(this).description;
                            }
                        });
                        if (!IS_PURE) defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, {
                            unsafe: true
                        });
                    }
                }
                $({
                    global: true,
                    constructor: true,
                    wrap: true,
                    forced: !NATIVE_SYMBOL,
                    sham: !NATIVE_SYMBOL
                }, {
                    Symbol: $Symbol
                });
                $forEach(objectKeys(WellKnownSymbolsStore), function(name) {
                    defineWellKnownSymbol(name);
                });
                $({
                    target: SYMBOL,
                    stat: true,
                    forced: !NATIVE_SYMBOL
                }, {
                    useSetter: function() {
                        USE_SETTER = true;
                    },
                    useSimple: function() {
                        USE_SETTER = false;
                    }
                });
                $({
                    target: 'Object',
                    stat: true,
                    forced: !NATIVE_SYMBOL,
                    sham: !DESCRIPTORS
                }, {
                    // `Object.create` method
                    // https://tc39.es/ecma262/#sec-object.create
                    create: $create,
                    // `Object.defineProperty` method
                    // https://tc39.es/ecma262/#sec-object.defineproperty
                    defineProperty: $defineProperty,
                    // `Object.defineProperties` method
                    // https://tc39.es/ecma262/#sec-object.defineproperties
                    defineProperties: $defineProperties,
                    // `Object.getOwnPropertyDescriptor` method
                    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
                    getOwnPropertyDescriptor: $getOwnPropertyDescriptor
                });
                $({
                    target: 'Object',
                    stat: true,
                    forced: !NATIVE_SYMBOL
                }, {
                    // `Object.getOwnPropertyNames` method
                    // https://tc39.es/ecma262/#sec-object.getownpropertynames
                    getOwnPropertyNames: $getOwnPropertyNames
                });
                // `Symbol.prototype[@@toPrimitive]` method
                // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
                defineSymbolToPrimitive();
                // `Symbol.prototype[@@toStringTag]` property
                // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
                setToStringTag($Symbol, SYMBOL);
                hiddenKeys[HIDDEN] = true;
            /***/ },
            /***/ "./node_modules/core-js/modules/es.symbol.description.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.description.js ***!
  \***************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // `Symbol.prototype.description` getter
                // https://tc39.es/ecma262/#sec-symbol.prototype.description
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var isCallable = __webpack_require__(/*! ../internals/is-callable */ "./node_modules/core-js/internals/is-callable.js");
                var isPrototypeOf = __webpack_require__(/*! ../internals/object-is-prototype-of */ "./node_modules/core-js/internals/object-is-prototype-of.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var defineBuiltInAccessor = __webpack_require__(/*! ../internals/define-built-in-accessor */ "./node_modules/core-js/internals/define-built-in-accessor.js");
                var copyConstructorProperties = __webpack_require__(/*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js");
                var NativeSymbol = globalThis1.Symbol;
                var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
                if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) || // Safari 12 bug
                NativeSymbol().description !== undefined)) {
                    var EmptyStringDescriptionStore = {};
                    // wrap Symbol constructor for correct work with undefined description
                    var SymbolWrapper = function Symbol1() {
                        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
                        var result = isPrototypeOf(SymbolPrototype, this) ? new NativeSymbol(description) : description === undefined ? NativeSymbol() : NativeSymbol(description);
                        if (description === '') EmptyStringDescriptionStore[result] = true;
                        return result;
                    };
                    copyConstructorProperties(SymbolWrapper, NativeSymbol);
                    SymbolWrapper.prototype = SymbolPrototype;
                    SymbolPrototype.constructor = SymbolWrapper;
                    var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
                    var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
                    var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
                    var regexp = /^Symbol\((.*)\)[^)]+$/;
                    var replace = uncurryThis(''.replace);
                    var stringSlice = uncurryThis(''.slice);
                    defineBuiltInAccessor(SymbolPrototype, 'description', {
                        configurable: true,
                        get: function description() {
                            var symbol = thisSymbolValue(this);
                            if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
                            var string = symbolDescriptiveString(symbol);
                            var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
                            return desc === '' ? undefined : desc;
                        }
                    });
                    $({
                        global: true,
                        constructor: true,
                        forced: true
                    }, {
                        Symbol: SymbolWrapper
                    });
                }
            /***/ },
            /***/ "./node_modules/core-js/modules/es.symbol.for.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.for.js ***!
  \*******************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
                var NATIVE_SYMBOL_REGISTRY = __webpack_require__(/*! ../internals/symbol-registry-detection */ "./node_modules/core-js/internals/symbol-registry-detection.js");
                var StringToSymbolRegistry = shared('string-to-symbol-registry');
                var SymbolToStringRegistry = shared('symbol-to-string-registry');
                // `Symbol.for` method
                // https://tc39.es/ecma262/#sec-symbol.for
                $({
                    target: 'Symbol',
                    stat: true,
                    forced: !NATIVE_SYMBOL_REGISTRY
                }, {
                    'for': function(key) {
                        var string = toString(key);
                        if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
                        var symbol = getBuiltIn('Symbol')(string);
                        StringToSymbolRegistry[string] = symbol;
                        SymbolToStringRegistry[symbol] = string;
                        return symbol;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/es.symbol.iterator.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.iterator.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var defineWellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol-define */ "./node_modules/core-js/internals/well-known-symbol-define.js");
                // `Symbol.iterator` well-known symbol
                // https://tc39.es/ecma262/#sec-symbol.iterator
                defineWellKnownSymbol('iterator');
            /***/ },
            /***/ "./node_modules/core-js/modules/es.symbol.js": /*!***************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.js ***!
  \***************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove this module from `core-js@4` since it's split to modules listed below
                __webpack_require__(/*! ../modules/es.symbol.constructor */ "./node_modules/core-js/modules/es.symbol.constructor.js");
                __webpack_require__(/*! ../modules/es.symbol.for */ "./node_modules/core-js/modules/es.symbol.for.js");
                __webpack_require__(/*! ../modules/es.symbol.key-for */ "./node_modules/core-js/modules/es.symbol.key-for.js");
                __webpack_require__(/*! ../modules/es.json.stringify */ "./node_modules/core-js/modules/es.json.stringify.js");
                __webpack_require__(/*! ../modules/es.object.get-own-property-symbols */ "./node_modules/core-js/modules/es.object.get-own-property-symbols.js");
            /***/ },
            /***/ "./node_modules/core-js/modules/es.symbol.key-for.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.key-for.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var hasOwn = __webpack_require__(/*! ../internals/has-own-property */ "./node_modules/core-js/internals/has-own-property.js");
                var isSymbol = __webpack_require__(/*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js");
                var tryToString = __webpack_require__(/*! ../internals/try-to-string */ "./node_modules/core-js/internals/try-to-string.js");
                var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
                var NATIVE_SYMBOL_REGISTRY = __webpack_require__(/*! ../internals/symbol-registry-detection */ "./node_modules/core-js/internals/symbol-registry-detection.js");
                var SymbolToStringRegistry = shared('symbol-to-string-registry');
                // `Symbol.keyFor` method
                // https://tc39.es/ecma262/#sec-symbol.keyfor
                $({
                    target: 'Symbol',
                    stat: true,
                    forced: !NATIVE_SYMBOL_REGISTRY
                }, {
                    keyFor: function keyFor(sym) {
                        if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
                        if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.iterator.constructor.js": /*!*********************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.iterator.constructor.js ***!
  \*********************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove from `core-js@4`
                __webpack_require__(/*! ../modules/es.iterator.constructor */ "./node_modules/core-js/modules/es.iterator.constructor.js");
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.iterator.for-each.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.iterator.for-each.js ***!
  \******************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove from `core-js@4`
                __webpack_require__(/*! ../modules/es.iterator.for-each */ "./node_modules/core-js/modules/es.iterator.for-each.js");
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.iterator.map.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.iterator.map.js ***!
  \*************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove from `core-js@4`
                __webpack_require__(/*! ../modules/es.iterator.map */ "./node_modules/core-js/modules/es.iterator.map.js");
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.add-all.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.add-all.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var add = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js").add;
                // `Set.prototype.addAll` method
                // https://github.com/tc39/proposal-collection-methods
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    addAll: function addAll() {
                        var set = aSet(this);
                        for(var k = 0, len = arguments.length; k < len; k++)add(set, arguments[k]);
                        return set;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.delete-all.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.delete-all.js ***!
  \***************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var remove = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js").remove;
                // `Set.prototype.deleteAll` method
                // https://github.com/tc39/proposal-collection-methods
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    deleteAll: function deleteAll() {
                        var collection = aSet(this);
                        var allDeleted = true;
                        var wasDeleted;
                        for(var k = 0, len = arguments.length; k < len; k++){
                            wasDeleted = remove(collection, arguments[k]);
                            allDeleted = allDeleted && wasDeleted;
                        }
                        return !!allDeleted;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.difference.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.difference.js ***!
  \***************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var toSetLike = __webpack_require__(/*! ../internals/to-set-like */ "./node_modules/core-js/internals/to-set-like.js");
                var $difference = __webpack_require__(/*! ../internals/set-difference */ "./node_modules/core-js/internals/set-difference.js");
                // `Set.prototype.difference` method
                // https://github.com/tc39/proposal-set-methods
                // TODO: Obsolete version, remove from `core-js@4`
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    difference: function difference(other) {
                        return call($difference, this, toSetLike(other));
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.every.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.every.js ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var iterate = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                // `Set.prototype.every` method
                // https://github.com/tc39/proposal-collection-methods
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    every: function every(callbackfn /* , thisArg */ ) {
                        var set = aSet(this);
                        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                        return iterate(set, function(value) {
                            if (!boundFunction(value, value, set)) return false;
                        }, true) !== false;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.filter.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.filter.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var SetHelpers = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js");
                var iterate = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                var Set1 = SetHelpers.Set;
                var add = SetHelpers.add;
                // `Set.prototype.filter` method
                // https://github.com/tc39/proposal-collection-methods
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    filter: function filter(callbackfn /* , thisArg */ ) {
                        var set = aSet(this);
                        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                        var newSet = new Set1();
                        iterate(set, function(value) {
                            if (boundFunction(value, value, set)) add(newSet, value);
                        });
                        return newSet;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.find.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.find.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var iterate = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                // `Set.prototype.find` method
                // https://github.com/tc39/proposal-collection-methods
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    find: function find(callbackfn /* , thisArg */ ) {
                        var set = aSet(this);
                        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                        var result = iterate(set, function(value) {
                            if (boundFunction(value, value, set)) return {
                                value: value
                            };
                        }, true);
                        return result && result.value;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.intersection.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.intersection.js ***!
  \*****************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var toSetLike = __webpack_require__(/*! ../internals/to-set-like */ "./node_modules/core-js/internals/to-set-like.js");
                var $intersection = __webpack_require__(/*! ../internals/set-intersection */ "./node_modules/core-js/internals/set-intersection.js");
                // `Set.prototype.intersection` method
                // https://github.com/tc39/proposal-set-methods
                // TODO: Obsolete version, remove from `core-js@4`
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    intersection: function intersection(other) {
                        return call($intersection, this, toSetLike(other));
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js": /*!*********************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.is-disjoint-from.js ***!
  \*********************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var toSetLike = __webpack_require__(/*! ../internals/to-set-like */ "./node_modules/core-js/internals/to-set-like.js");
                var $isDisjointFrom = __webpack_require__(/*! ../internals/set-is-disjoint-from */ "./node_modules/core-js/internals/set-is-disjoint-from.js");
                // `Set.prototype.isDisjointFrom` method
                // https://github.com/tc39/proposal-set-methods
                // TODO: Obsolete version, remove from `core-js@4`
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    isDisjointFrom: function isDisjointFrom(other) {
                        return call($isDisjointFrom, this, toSetLike(other));
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.is-subset-of.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.is-subset-of.js ***!
  \*****************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var toSetLike = __webpack_require__(/*! ../internals/to-set-like */ "./node_modules/core-js/internals/to-set-like.js");
                var $isSubsetOf = __webpack_require__(/*! ../internals/set-is-subset-of */ "./node_modules/core-js/internals/set-is-subset-of.js");
                // `Set.prototype.isSubsetOf` method
                // https://github.com/tc39/proposal-set-methods
                // TODO: Obsolete version, remove from `core-js@4`
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    isSubsetOf: function isSubsetOf(other) {
                        return call($isSubsetOf, this, toSetLike(other));
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.is-superset-of.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.is-superset-of.js ***!
  \*******************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var toSetLike = __webpack_require__(/*! ../internals/to-set-like */ "./node_modules/core-js/internals/to-set-like.js");
                var $isSupersetOf = __webpack_require__(/*! ../internals/set-is-superset-of */ "./node_modules/core-js/internals/set-is-superset-of.js");
                // `Set.prototype.isSupersetOf` method
                // https://github.com/tc39/proposal-set-methods
                // TODO: Obsolete version, remove from `core-js@4`
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    isSupersetOf: function isSupersetOf(other) {
                        return call($isSupersetOf, this, toSetLike(other));
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.join.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.join.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var uncurryThis = __webpack_require__(/*! ../internals/function-uncurry-this */ "./node_modules/core-js/internals/function-uncurry-this.js");
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var iterate = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
                var arrayJoin = uncurryThis([].join);
                var push = uncurryThis([].push);
                // `Set.prototype.join` method
                // https://github.com/tc39/proposal-collection-methods
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    join: function join(separator) {
                        var set = aSet(this);
                        var sep = separator === undefined ? ',' : toString(separator);
                        var array = [];
                        iterate(set, function(value) {
                            push(array, value);
                        });
                        return arrayJoin(array, sep);
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.map.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.map.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var SetHelpers = __webpack_require__(/*! ../internals/set-helpers */ "./node_modules/core-js/internals/set-helpers.js");
                var iterate = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                var Set1 = SetHelpers.Set;
                var add = SetHelpers.add;
                // `Set.prototype.map` method
                // https://github.com/tc39/proposal-collection-methods
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    map: function map(callbackfn /* , thisArg */ ) {
                        var set = aSet(this);
                        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                        var newSet = new Set1();
                        iterate(set, function(value) {
                            add(newSet, boundFunction(value, value, set));
                        });
                        return newSet;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.reduce.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.reduce.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var aCallable = __webpack_require__(/*! ../internals/a-callable */ "./node_modules/core-js/internals/a-callable.js");
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var iterate = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                var $TypeError = TypeError;
                // `Set.prototype.reduce` method
                // https://github.com/tc39/proposal-collection-methods
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    reduce: function reduce(callbackfn /* , initialValue */ ) {
                        var set = aSet(this);
                        var noInitial = arguments.length < 2;
                        var accumulator = noInitial ? undefined : arguments[1];
                        aCallable(callbackfn);
                        iterate(set, function(value) {
                            if (noInitial) {
                                noInitial = false;
                                accumulator = value;
                            } else accumulator = callbackfn(accumulator, value, value, set);
                        });
                        if (noInitial) throw new $TypeError('Reduce of empty set with no initial value');
                        return accumulator;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.some.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.some.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
                var aSet = __webpack_require__(/*! ../internals/a-set */ "./node_modules/core-js/internals/a-set.js");
                var iterate = __webpack_require__(/*! ../internals/set-iterate */ "./node_modules/core-js/internals/set-iterate.js");
                // `Set.prototype.some` method
                // https://github.com/tc39/proposal-collection-methods
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    some: function some(callbackfn /* , thisArg */ ) {
                        var set = aSet(this);
                        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                        return iterate(set, function(value) {
                            if (boundFunction(value, value, set)) return true;
                        }, true) === true;
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js": /*!*************************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.symmetric-difference.js ***!
  \*************************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var toSetLike = __webpack_require__(/*! ../internals/to-set-like */ "./node_modules/core-js/internals/to-set-like.js");
                var $symmetricDifference = __webpack_require__(/*! ../internals/set-symmetric-difference */ "./node_modules/core-js/internals/set-symmetric-difference.js");
                // `Set.prototype.symmetricDifference` method
                // https://github.com/tc39/proposal-set-methods
                // TODO: Obsolete version, remove from `core-js@4`
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    symmetricDifference: function symmetricDifference(other) {
                        return call($symmetricDifference, this, toSetLike(other));
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/esnext.set.union.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.union.js ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var call = __webpack_require__(/*! ../internals/function-call */ "./node_modules/core-js/internals/function-call.js");
                var toSetLike = __webpack_require__(/*! ../internals/to-set-like */ "./node_modules/core-js/internals/to-set-like.js");
                var $union = __webpack_require__(/*! ../internals/set-union */ "./node_modules/core-js/internals/set-union.js");
                // `Set.prototype.union` method
                // https://github.com/tc39/proposal-set-methods
                // TODO: Obsolete version, remove from `core-js@4`
                $({
                    target: 'Set',
                    proto: true,
                    real: true,
                    forced: true
                }, {
                    union: function union(other) {
                        return call($union, this, toSetLike(other));
                    }
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/web.dom-collections.for-each.js": /*!**********************************************************************!*\
  !*** ./node_modules/core-js/modules/web.dom-collections.for-each.js ***!
  \**********************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var DOMIterables = __webpack_require__(/*! ../internals/dom-iterables */ "./node_modules/core-js/internals/dom-iterables.js");
                var DOMTokenListPrototype = __webpack_require__(/*! ../internals/dom-token-list-prototype */ "./node_modules/core-js/internals/dom-token-list-prototype.js");
                var forEach = __webpack_require__(/*! ../internals/array-for-each */ "./node_modules/core-js/internals/array-for-each.js");
                var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
                var handlePrototype = function(CollectionPrototype) {
                    // some Chrome versions have non-configurable methods on DOMTokenList
                    if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
                        createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
                    } catch (error) {
                        CollectionPrototype.forEach = forEach;
                    }
                };
                for(var COLLECTION_NAME in DOMIterables)if (DOMIterables[COLLECTION_NAME]) handlePrototype(globalThis1[COLLECTION_NAME] && globalThis1[COLLECTION_NAME].prototype);
                handlePrototype(DOMTokenListPrototype);
            /***/ },
            /***/ "./node_modules/core-js/modules/web.dom-collections.iterator.js": /*!**********************************************************************!*\
  !*** ./node_modules/core-js/modules/web.dom-collections.iterator.js ***!
  \**********************************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var DOMIterables = __webpack_require__(/*! ../internals/dom-iterables */ "./node_modules/core-js/internals/dom-iterables.js");
                var DOMTokenListPrototype = __webpack_require__(/*! ../internals/dom-token-list-prototype */ "./node_modules/core-js/internals/dom-token-list-prototype.js");
                var ArrayIteratorMethods = __webpack_require__(/*! ../modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
                var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
                var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
                var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
                var ITERATOR = wellKnownSymbol('iterator');
                var ArrayValues = ArrayIteratorMethods.values;
                var handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
                    if (CollectionPrototype) {
                        // some Chrome versions have non-configurable methods on DOMTokenList
                        if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
                            createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
                        } catch (error) {
                            CollectionPrototype[ITERATOR] = ArrayValues;
                        }
                        setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
                        if (DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in ArrayIteratorMethods){
                            // some Chrome versions have non-configurable methods on DOMTokenList
                            if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                                createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
                            } catch (error) {
                                CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
                            }
                        }
                    }
                };
                for(var COLLECTION_NAME in DOMIterables)handlePrototype(globalThis1[COLLECTION_NAME] && globalThis1[COLLECTION_NAME].prototype, COLLECTION_NAME);
                handlePrototype(DOMTokenListPrototype, 'DOMTokenList');
            /***/ },
            /***/ "./node_modules/core-js/modules/web.set-interval.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/web.set-interval.js ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var schedulersFix = __webpack_require__(/*! ../internals/schedulers-fix */ "./node_modules/core-js/internals/schedulers-fix.js");
                var setInterval = schedulersFix(globalThis1.setInterval, true);
                // Bun / IE9- setInterval additional parameters fix
                // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
                $({
                    global: true,
                    bind: true,
                    forced: globalThis1.setInterval !== setInterval
                }, {
                    setInterval: setInterval
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/web.set-timeout.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/web.set-timeout.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
                var globalThis1 = __webpack_require__(/*! ../internals/global-this */ "./node_modules/core-js/internals/global-this.js");
                var schedulersFix = __webpack_require__(/*! ../internals/schedulers-fix */ "./node_modules/core-js/internals/schedulers-fix.js");
                var setTimeout1 = schedulersFix(globalThis1.setTimeout, true);
                // Bun / IE9- setTimeout additional parameters fix
                // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
                $({
                    global: true,
                    bind: true,
                    forced: globalThis1.setTimeout !== setTimeout1
                }, {
                    setTimeout: setTimeout1
                });
            /***/ },
            /***/ "./node_modules/core-js/modules/web.timers.js": /*!****************************************************!*\
  !*** ./node_modules/core-js/modules/web.timers.js ***!
  \****************************************************/ /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove this module from `core-js@4` since it's split to modules listed below
                __webpack_require__(/*! ../modules/web.set-interval */ "./node_modules/core-js/modules/web.set-interval.js");
                __webpack_require__(/*! ../modules/web.set-timeout */ "./node_modules/core-js/modules/web.set-timeout.js");
            /***/ },
            /***/ "./node_modules/dompurify/dist/purify.es.mjs": /*!***************************************************!*\
  !*** ./node_modules/dompurify/dist/purify.es.mjs ***!
  \***************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ purify;
                    }
                });
                /*! @license DOMPurify 3.3.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.1/LICENSE */ const { entries, setPrototypeOf, isFrozen, getPrototypeOf, getOwnPropertyDescriptor } = Object;
                let { freeze, seal, create } = Object; // eslint-disable-line import/no-mutable-exports
                let { apply, construct } = typeof Reflect !== 'undefined' && Reflect;
                if (!freeze) freeze = function freeze(x) {
                    return x;
                };
                if (!seal) seal = function seal(x) {
                    return x;
                };
                if (!apply) apply = function apply(func, thisArg) {
                    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                    return func.apply(thisArg, args);
                };
                if (!construct) construct = function construct(Func) {
                    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                    return new Func(...args);
                };
                const arrayForEach = unapply(Array.prototype.forEach);
                const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
                const arrayPop = unapply(Array.prototype.pop);
                const arrayPush = unapply(Array.prototype.push);
                const arraySplice = unapply(Array.prototype.splice);
                const stringToLowerCase = unapply(String.prototype.toLowerCase);
                const stringToString = unapply(String.prototype.toString);
                const stringMatch = unapply(String.prototype.match);
                const stringReplace = unapply(String.prototype.replace);
                const stringIndexOf = unapply(String.prototype.indexOf);
                const stringTrim = unapply(String.prototype.trim);
                const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
                const regExpTest = unapply(RegExp.prototype.test);
                const typeErrorCreate = unconstruct(TypeError);
                /**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */ function unapply(func) {
                    return function(thisArg) {
                        if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
                        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
                        return apply(func, thisArg, args);
                    };
                }
                /**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */ function unconstruct(Func) {
                    return function() {
                        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                        return construct(Func, args);
                    };
                }
                /**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */ function addToSet(set, array) {
                    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
                    if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
                    // independent of any properties defined on Object.prototype.
                    // Prevent prototype setters from intercepting set as a this value.
                    setPrototypeOf(set, null);
                    let l = array.length;
                    while(l--){
                        let element = array[l];
                        if (typeof element === 'string') {
                            const lcElement = transformCaseFunc(element);
                            if (lcElement !== element) {
                                // Config presets (e.g. tags.js, attrs.js) are immutable.
                                if (!isFrozen(array)) array[l] = lcElement;
                                element = lcElement;
                            }
                        }
                        set[element] = true;
                    }
                    return set;
                }
                /**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */ function cleanArray(array) {
                    for(let index = 0; index < array.length; index++){
                        const isPropertyExist = objectHasOwnProperty(array, index);
                        if (!isPropertyExist) array[index] = null;
                    }
                    return array;
                }
                /**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */ function clone(object) {
                    const newObject = create(null);
                    for (const [property, value] of entries(object)){
                        const isPropertyExist = objectHasOwnProperty(object, property);
                        if (isPropertyExist) {
                            if (Array.isArray(value)) newObject[property] = cleanArray(value);
                            else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                            else newObject[property] = value;
                        }
                    }
                    return newObject;
                }
                /**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */ function lookupGetter(object, prop) {
                    while(object !== null){
                        const desc = getOwnPropertyDescriptor(object, prop);
                        if (desc) {
                            if (desc.get) return unapply(desc.get);
                            if (typeof desc.value === 'function') return unapply(desc.value);
                        }
                        object = getPrototypeOf(object);
                    }
                    function fallbackValue() {
                        return null;
                    }
                    return fallbackValue;
                }
                const html$1 = freeze([
                    'a',
                    'abbr',
                    'acronym',
                    'address',
                    'area',
                    'article',
                    'aside',
                    'audio',
                    'b',
                    'bdi',
                    'bdo',
                    'big',
                    'blink',
                    'blockquote',
                    'body',
                    'br',
                    'button',
                    'canvas',
                    'caption',
                    'center',
                    'cite',
                    'code',
                    'col',
                    'colgroup',
                    'content',
                    'data',
                    'datalist',
                    'dd',
                    'decorator',
                    'del',
                    'details',
                    'dfn',
                    'dialog',
                    'dir',
                    'div',
                    'dl',
                    'dt',
                    'element',
                    'em',
                    'fieldset',
                    'figcaption',
                    'figure',
                    'font',
                    'footer',
                    'form',
                    'h1',
                    'h2',
                    'h3',
                    'h4',
                    'h5',
                    'h6',
                    'head',
                    'header',
                    'hgroup',
                    'hr',
                    'html',
                    'i',
                    'img',
                    'input',
                    'ins',
                    'kbd',
                    'label',
                    'legend',
                    'li',
                    'main',
                    'map',
                    'mark',
                    'marquee',
                    'menu',
                    'menuitem',
                    'meter',
                    'nav',
                    'nobr',
                    'ol',
                    'optgroup',
                    'option',
                    'output',
                    'p',
                    'picture',
                    'pre',
                    'progress',
                    'q',
                    'rp',
                    'rt',
                    'ruby',
                    's',
                    'samp',
                    'search',
                    'section',
                    'select',
                    'shadow',
                    'slot',
                    'small',
                    'source',
                    'spacer',
                    'span',
                    'strike',
                    'strong',
                    'style',
                    'sub',
                    'summary',
                    'sup',
                    'table',
                    'tbody',
                    'td',
                    'template',
                    'textarea',
                    'tfoot',
                    'th',
                    'thead',
                    'time',
                    'tr',
                    'track',
                    'tt',
                    'u',
                    'ul',
                    'var',
                    'video',
                    'wbr'
                ]);
                const svg$1 = freeze([
                    'svg',
                    'a',
                    'altglyph',
                    'altglyphdef',
                    'altglyphitem',
                    'animatecolor',
                    'animatemotion',
                    'animatetransform',
                    'circle',
                    'clippath',
                    'defs',
                    'desc',
                    'ellipse',
                    'enterkeyhint',
                    'exportparts',
                    'filter',
                    'font',
                    'g',
                    'glyph',
                    'glyphref',
                    'hkern',
                    'image',
                    'inputmode',
                    'line',
                    'lineargradient',
                    'marker',
                    'mask',
                    'metadata',
                    'mpath',
                    'part',
                    'path',
                    'pattern',
                    'polygon',
                    'polyline',
                    'radialgradient',
                    'rect',
                    'stop',
                    'style',
                    'switch',
                    'symbol',
                    'text',
                    'textpath',
                    'title',
                    'tref',
                    'tspan',
                    'view',
                    'vkern'
                ]);
                const svgFilters = freeze([
                    'feBlend',
                    'feColorMatrix',
                    'feComponentTransfer',
                    'feComposite',
                    'feConvolveMatrix',
                    'feDiffuseLighting',
                    'feDisplacementMap',
                    'feDistantLight',
                    'feDropShadow',
                    'feFlood',
                    'feFuncA',
                    'feFuncB',
                    'feFuncG',
                    'feFuncR',
                    'feGaussianBlur',
                    'feImage',
                    'feMerge',
                    'feMergeNode',
                    'feMorphology',
                    'feOffset',
                    'fePointLight',
                    'feSpecularLighting',
                    'feSpotLight',
                    'feTile',
                    'feTurbulence'
                ]);
                // List of SVG elements that are disallowed by default.
                // We still need to know them so that we can do namespace
                // checks properly in case one wants to add them to
                // allow-list.
                const svgDisallowed = freeze([
                    'animate',
                    'color-profile',
                    'cursor',
                    'discard',
                    'font-face',
                    'font-face-format',
                    'font-face-name',
                    'font-face-src',
                    'font-face-uri',
                    'foreignobject',
                    'hatch',
                    'hatchpath',
                    'mesh',
                    'meshgradient',
                    'meshpatch',
                    'meshrow',
                    'missing-glyph',
                    'script',
                    'set',
                    'solidcolor',
                    'unknown',
                    'use'
                ]);
                const mathMl$1 = freeze([
                    'math',
                    'menclose',
                    'merror',
                    'mfenced',
                    'mfrac',
                    'mglyph',
                    'mi',
                    'mlabeledtr',
                    'mmultiscripts',
                    'mn',
                    'mo',
                    'mover',
                    'mpadded',
                    'mphantom',
                    'mroot',
                    'mrow',
                    'ms',
                    'mspace',
                    'msqrt',
                    'mstyle',
                    'msub',
                    'msup',
                    'msubsup',
                    'mtable',
                    'mtd',
                    'mtext',
                    'mtr',
                    'munder',
                    'munderover',
                    'mprescripts'
                ]);
                // Similarly to SVG, we want to know all MathML elements,
                // even those that we disallow by default.
                const mathMlDisallowed = freeze([
                    'maction',
                    'maligngroup',
                    'malignmark',
                    'mlongdiv',
                    'mscarries',
                    'mscarry',
                    'msgroup',
                    'mstack',
                    'msline',
                    'msrow',
                    'semantics',
                    'annotation',
                    'annotation-xml',
                    'mprescripts',
                    'none'
                ]);
                const text = freeze([
                    '#text'
                ]);
                const html = freeze([
                    'accept',
                    'action',
                    'align',
                    'alt',
                    'autocapitalize',
                    'autocomplete',
                    'autopictureinpicture',
                    'autoplay',
                    'background',
                    'bgcolor',
                    'border',
                    'capture',
                    'cellpadding',
                    'cellspacing',
                    'checked',
                    'cite',
                    'class',
                    'clear',
                    'color',
                    'cols',
                    'colspan',
                    'controls',
                    'controlslist',
                    'coords',
                    'crossorigin',
                    'datetime',
                    'decoding',
                    'default',
                    'dir',
                    'disabled',
                    'disablepictureinpicture',
                    'disableremoteplayback',
                    'download',
                    'draggable',
                    'enctype',
                    'enterkeyhint',
                    'exportparts',
                    'face',
                    'for',
                    'headers',
                    'height',
                    'hidden',
                    'high',
                    'href',
                    'hreflang',
                    'id',
                    'inert',
                    'inputmode',
                    'integrity',
                    'ismap',
                    'kind',
                    'label',
                    'lang',
                    'list',
                    'loading',
                    'loop',
                    'low',
                    'max',
                    'maxlength',
                    'media',
                    'method',
                    'min',
                    'minlength',
                    'multiple',
                    'muted',
                    'name',
                    'nonce',
                    'noshade',
                    'novalidate',
                    'nowrap',
                    'open',
                    'optimum',
                    'part',
                    'pattern',
                    'placeholder',
                    'playsinline',
                    'popover',
                    'popovertarget',
                    'popovertargetaction',
                    'poster',
                    'preload',
                    'pubdate',
                    'radiogroup',
                    'readonly',
                    'rel',
                    'required',
                    'rev',
                    'reversed',
                    'role',
                    'rows',
                    'rowspan',
                    'spellcheck',
                    'scope',
                    'selected',
                    'shape',
                    'size',
                    'sizes',
                    'slot',
                    'span',
                    'srclang',
                    'start',
                    'src',
                    'srcset',
                    'step',
                    'style',
                    'summary',
                    'tabindex',
                    'title',
                    'translate',
                    'type',
                    'usemap',
                    'valign',
                    'value',
                    'width',
                    'wrap',
                    'xmlns',
                    'slot'
                ]);
                const svg = freeze([
                    'accent-height',
                    'accumulate',
                    'additive',
                    'alignment-baseline',
                    'amplitude',
                    'ascent',
                    'attributename',
                    'attributetype',
                    'azimuth',
                    'basefrequency',
                    'baseline-shift',
                    'begin',
                    'bias',
                    'by',
                    'class',
                    'clip',
                    'clippathunits',
                    'clip-path',
                    'clip-rule',
                    'color',
                    'color-interpolation',
                    'color-interpolation-filters',
                    'color-profile',
                    'color-rendering',
                    'cx',
                    'cy',
                    'd',
                    'dx',
                    'dy',
                    'diffuseconstant',
                    'direction',
                    'display',
                    'divisor',
                    'dur',
                    'edgemode',
                    'elevation',
                    'end',
                    'exponent',
                    'fill',
                    'fill-opacity',
                    'fill-rule',
                    'filter',
                    'filterunits',
                    'flood-color',
                    'flood-opacity',
                    'font-family',
                    'font-size',
                    'font-size-adjust',
                    'font-stretch',
                    'font-style',
                    'font-variant',
                    'font-weight',
                    'fx',
                    'fy',
                    'g1',
                    'g2',
                    'glyph-name',
                    'glyphref',
                    'gradientunits',
                    'gradienttransform',
                    'height',
                    'href',
                    'id',
                    'image-rendering',
                    'in',
                    'in2',
                    'intercept',
                    'k',
                    'k1',
                    'k2',
                    'k3',
                    'k4',
                    'kerning',
                    'keypoints',
                    'keysplines',
                    'keytimes',
                    'lang',
                    'lengthadjust',
                    'letter-spacing',
                    'kernelmatrix',
                    'kernelunitlength',
                    'lighting-color',
                    'local',
                    'marker-end',
                    'marker-mid',
                    'marker-start',
                    'markerheight',
                    'markerunits',
                    'markerwidth',
                    'maskcontentunits',
                    'maskunits',
                    'max',
                    'mask',
                    'mask-type',
                    'media',
                    'method',
                    'mode',
                    'min',
                    'name',
                    'numoctaves',
                    'offset',
                    'operator',
                    'opacity',
                    'order',
                    'orient',
                    'orientation',
                    'origin',
                    'overflow',
                    'paint-order',
                    'path',
                    'pathlength',
                    'patterncontentunits',
                    'patterntransform',
                    'patternunits',
                    'points',
                    'preservealpha',
                    'preserveaspectratio',
                    'primitiveunits',
                    'r',
                    'rx',
                    'ry',
                    'radius',
                    'refx',
                    'refy',
                    'repeatcount',
                    'repeatdur',
                    'restart',
                    'result',
                    'rotate',
                    'scale',
                    'seed',
                    'shape-rendering',
                    'slope',
                    'specularconstant',
                    'specularexponent',
                    'spreadmethod',
                    'startoffset',
                    'stddeviation',
                    'stitchtiles',
                    'stop-color',
                    'stop-opacity',
                    'stroke-dasharray',
                    'stroke-dashoffset',
                    'stroke-linecap',
                    'stroke-linejoin',
                    'stroke-miterlimit',
                    'stroke-opacity',
                    'stroke',
                    'stroke-width',
                    'style',
                    'surfacescale',
                    'systemlanguage',
                    'tabindex',
                    'tablevalues',
                    'targetx',
                    'targety',
                    'transform',
                    'transform-origin',
                    'text-anchor',
                    'text-decoration',
                    'text-rendering',
                    'textlength',
                    'type',
                    'u1',
                    'u2',
                    'unicode',
                    'values',
                    'viewbox',
                    'visibility',
                    'version',
                    'vert-adv-y',
                    'vert-origin-x',
                    'vert-origin-y',
                    'width',
                    'word-spacing',
                    'wrap',
                    'writing-mode',
                    'xchannelselector',
                    'ychannelselector',
                    'x',
                    'x1',
                    'x2',
                    'xmlns',
                    'y',
                    'y1',
                    'y2',
                    'z',
                    'zoomandpan'
                ]);
                const mathMl = freeze([
                    'accent',
                    'accentunder',
                    'align',
                    'bevelled',
                    'close',
                    'columnsalign',
                    'columnlines',
                    'columnspan',
                    'denomalign',
                    'depth',
                    'dir',
                    'display',
                    'displaystyle',
                    'encoding',
                    'fence',
                    'frame',
                    'height',
                    'href',
                    'id',
                    'largeop',
                    'length',
                    'linethickness',
                    'lspace',
                    'lquote',
                    'mathbackground',
                    'mathcolor',
                    'mathsize',
                    'mathvariant',
                    'maxsize',
                    'minsize',
                    'movablelimits',
                    'notation',
                    'numalign',
                    'open',
                    'rowalign',
                    'rowlines',
                    'rowspacing',
                    'rowspan',
                    'rspace',
                    'rquote',
                    'scriptlevel',
                    'scriptminsize',
                    'scriptsizemultiplier',
                    'selection',
                    'separator',
                    'separators',
                    'stretchy',
                    'subscriptshift',
                    'supscriptshift',
                    'symmetric',
                    'voffset',
                    'width',
                    'xmlns'
                ]);
                const xml = freeze([
                    'xlink:href',
                    'xml:id',
                    'xlink:title',
                    'xml:space',
                    'xmlns:xlink'
                ]);
                // eslint-disable-next-line unicorn/better-regex
                const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
                const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
                const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
                const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
                const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
                const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
                );
                const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
                const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
                );
                const DOCTYPE_NAME = seal(/^html$/i);
                const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
                var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
                    __proto__: null,
                    ARIA_ATTR: ARIA_ATTR,
                    ATTR_WHITESPACE: ATTR_WHITESPACE,
                    CUSTOM_ELEMENT: CUSTOM_ELEMENT,
                    DATA_ATTR: DATA_ATTR,
                    DOCTYPE_NAME: DOCTYPE_NAME,
                    ERB_EXPR: ERB_EXPR,
                    IS_ALLOWED_URI: IS_ALLOWED_URI,
                    IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
                    MUSTACHE_EXPR: MUSTACHE_EXPR,
                    TMPLIT_EXPR: TMPLIT_EXPR
                });
                /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
                const NODE_TYPE = {
                    element: 1,
                    attribute: 2,
                    text: 3,
                    cdataSection: 4,
                    entityReference: 5,
                    // Deprecated
                    entityNode: 6,
                    // Deprecated
                    progressingInstruction: 7,
                    comment: 8,
                    document: 9,
                    documentType: 10,
                    documentFragment: 11,
                    notation: 12 // Deprecated
                };
                const getGlobal = function getGlobal() {
                    return typeof window === 'undefined' ? null : window;
                };
                /**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
                    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
                    // Allow the callers to control the unique policy name
                    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
                    // Policy creation with duplicate names throws in Trusted Types.
                    let suffix = null;
                    const ATTR_NAME = 'data-tt-policy-suffix';
                    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
                    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
                    try {
                        return trustedTypes.createPolicy(policyName, {
                            createHTML (html) {
                                return html;
                            },
                            createScriptURL (scriptUrl) {
                                return scriptUrl;
                            }
                        });
                    } catch (_) {
                        // Policy creation failed (most likely another DOMPurify script has
                        // already run). Skip creating the policy, as this will only cause errors
                        // if TT are enforced.
                        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
                        return null;
                    }
                };
                const _createHooksMap = function _createHooksMap() {
                    return {
                        afterSanitizeAttributes: [],
                        afterSanitizeElements: [],
                        afterSanitizeShadowDOM: [],
                        beforeSanitizeAttributes: [],
                        beforeSanitizeElements: [],
                        beforeSanitizeShadowDOM: [],
                        uponSanitizeAttribute: [],
                        uponSanitizeElement: [],
                        uponSanitizeShadowNode: []
                    };
                };
                function createDOMPurify() {
                    let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
                    const DOMPurify = (root)=>createDOMPurify(root);
                    DOMPurify.version = '3.3.1';
                    DOMPurify.removed = [];
                    if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
                        // Not running in a browser, provide a factory function
                        // so that you can pass your own Window
                        DOMPurify.isSupported = false;
                        return DOMPurify;
                    }
                    let { document: document1 } = window1;
                    const originalDocument = document1;
                    const currentScript = originalDocument.currentScript;
                    const { DocumentFragment, HTMLTemplateElement, Node: Node1, Element, NodeFilter, NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement, DOMParser: DOMParser1, trustedTypes } = window1;
                    const ElementPrototype = Element.prototype;
                    const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
                    const remove = lookupGetter(ElementPrototype, 'remove');
                    const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
                    const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
                    const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
                    // As per issue #47, the web-components registry is inherited by a
                    // new document created via createHTMLDocument. As per the spec
                    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
                    // a new empty registry is used when creating a template contents owner
                    // document, so we use that as our parent document to ensure nothing
                    // is inherited.
                    if (typeof HTMLTemplateElement === 'function') {
                        const template = document1.createElement('template');
                        if (template.content && template.content.ownerDocument) document1 = template.content.ownerDocument;
                    }
                    let trustedTypesPolicy;
                    let emptyHTML = '';
                    const { implementation, createNodeIterator, createDocumentFragment, getElementsByTagName } = document1;
                    const { importNode } = originalDocument;
                    let hooks = _createHooksMap();
                    /**
   * Expose whether this browser supports running the full DOMPurify.
   */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
                    const { MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR, DATA_ATTR, ARIA_ATTR, IS_SCRIPT_OR_DATA, ATTR_WHITESPACE, CUSTOM_ELEMENT } = EXPRESSIONS;
                    let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
                    /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */ /* allowed element names */ let ALLOWED_TAGS = null;
                    const DEFAULT_ALLOWED_TAGS = addToSet({}, [
                        ...html$1,
                        ...svg$1,
                        ...svgFilters,
                        ...mathMl$1,
                        ...text
                    ]);
                    /* Allowed attribute names */ let ALLOWED_ATTR = null;
                    const DEFAULT_ALLOWED_ATTR = addToSet({}, [
                        ...html,
                        ...svg,
                        ...mathMl,
                        ...xml
                    ]);
                    /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
                        tagNameCheck: {
                            writable: true,
                            configurable: false,
                            enumerable: true,
                            value: null
                        },
                        attributeNameCheck: {
                            writable: true,
                            configurable: false,
                            enumerable: true,
                            value: null
                        },
                        allowCustomizedBuiltInElements: {
                            writable: true,
                            configurable: false,
                            enumerable: true,
                            value: false
                        }
                    }));
                    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
                    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
                    /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
                        tagCheck: {
                            writable: true,
                            configurable: false,
                            enumerable: true,
                            value: null
                        },
                        attributeCheck: {
                            writable: true,
                            configurable: false,
                            enumerable: true,
                            value: null
                        }
                    }));
                    /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
                    /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
                    /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
                    /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
                    /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */ let SAFE_FOR_TEMPLATES = false;
                    /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */ let SAFE_FOR_XML = true;
                    /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
                    /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
                    /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
                    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */ let RETURN_DOM = false;
                    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
                    /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
                    /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */ let SANITIZE_DOM = true;
                    /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */ let SANITIZE_NAMED_PROPS = false;
                    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
                    /* Keep element content when removing element? */ let KEEP_CONTENT = true;
                    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
                    /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
                    /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
                    const DEFAULT_FORBID_CONTENTS = addToSet({}, [
                        'annotation-xml',
                        'audio',
                        'colgroup',
                        'desc',
                        'foreignobject',
                        'head',
                        'iframe',
                        'math',
                        'mi',
                        'mn',
                        'mo',
                        'ms',
                        'mtext',
                        'noembed',
                        'noframes',
                        'noscript',
                        'plaintext',
                        'script',
                        'style',
                        'svg',
                        'template',
                        'thead',
                        'title',
                        'video',
                        'xmp'
                    ]);
                    /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
                    const DEFAULT_DATA_URI_TAGS = addToSet({}, [
                        'audio',
                        'video',
                        'img',
                        'source',
                        'image',
                        'track'
                    ]);
                    /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
                    const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
                        'alt',
                        'class',
                        'for',
                        'id',
                        'label',
                        'name',
                        'pattern',
                        'placeholder',
                        'role',
                        'summary',
                        'title',
                        'value',
                        'style',
                        'xmlns'
                    ]);
                    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
                    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
                    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
                    /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
                    let IS_EMPTY_INPUT = false;
                    /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
                    const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
                        MATHML_NAMESPACE,
                        SVG_NAMESPACE,
                        HTML_NAMESPACE
                    ], stringToString);
                    let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
                        'mi',
                        'mo',
                        'mn',
                        'ms',
                        'mtext'
                    ]);
                    let HTML_INTEGRATION_POINTS = addToSet({}, [
                        'annotation-xml'
                    ]);
                    // Certain elements are allowed in both SVG and HTML
                    // namespace. We need to specify them explicitly
                    // so that they don't get erroneously deleted from
                    // HTML namespace.
                    const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
                        'title',
                        'style',
                        'font',
                        'a',
                        'script'
                    ]);
                    /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
                    const SUPPORTED_PARSER_MEDIA_TYPES = [
                        'application/xhtml+xml',
                        'text/html'
                    ];
                    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
                    let transformCaseFunc = null;
                    /* Keep a reference to config to pass to hooks */ let CONFIG = null;
                    /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document1.createElement('form');
                    const isRegexOrFunction = function isRegexOrFunction(testValue) {
                        return testValue instanceof RegExp || testValue instanceof Function;
                    };
                    /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */ // eslint-disable-next-line complexity
                    const _parseConfig = function _parseConfig() {
                        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (CONFIG && CONFIG === cfg) return;
                        /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
                        /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
                        PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
                        SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
                        // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
                        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
                        /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
                        ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
                        ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
                        URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
                        DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
                        FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
                        FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
                        FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
                        USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
                        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
                        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
                        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
                        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
                        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
                        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
                        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
                        RETURN_DOM = cfg.RETURN_DOM || false; // Default false
                        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
                        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
                        FORCE_BODY = cfg.FORCE_BODY || false; // Default false
                        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
                        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
                        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
                        IN_PLACE = cfg.IN_PLACE || false; // Default false
                        IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
                        NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
                        MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
                        HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
                        CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
                        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
                        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
                        if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
                        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
                        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
                        /* Parse profile info */ if (USE_PROFILES) {
                            ALLOWED_TAGS = addToSet({}, text);
                            ALLOWED_ATTR = [];
                            if (USE_PROFILES.html === true) {
                                addToSet(ALLOWED_TAGS, html$1);
                                addToSet(ALLOWED_ATTR, html);
                            }
                            if (USE_PROFILES.svg === true) {
                                addToSet(ALLOWED_TAGS, svg$1);
                                addToSet(ALLOWED_ATTR, svg);
                                addToSet(ALLOWED_ATTR, xml);
                            }
                            if (USE_PROFILES.svgFilters === true) {
                                addToSet(ALLOWED_TAGS, svgFilters);
                                addToSet(ALLOWED_ATTR, svg);
                                addToSet(ALLOWED_ATTR, xml);
                            }
                            if (USE_PROFILES.mathMl === true) {
                                addToSet(ALLOWED_TAGS, mathMl$1);
                                addToSet(ALLOWED_ATTR, mathMl);
                                addToSet(ALLOWED_ATTR, xml);
                            }
                        }
                        /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                            if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                            else {
                                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                            }
                        }
                        if (cfg.ADD_ATTR) {
                            if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                            else {
                                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                            }
                        }
                        if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
                        if (cfg.FORBID_CONTENTS) {
                            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                            addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
                        }
                        if (cfg.ADD_FORBID_CONTENTS) {
                            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                            addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
                        }
                        /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
                        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                            'html',
                            'head',
                            'body'
                        ]);
                        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                            addToSet(ALLOWED_TAGS, [
                                'tbody'
                            ]);
                            delete FORBID_TAGS.tbody;
                        }
                        if (cfg.TRUSTED_TYPES_POLICY) {
                            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                            // Overwrite existing TrustedTypes policy.
                            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                            // Sign local variables required by `sanitize`.
                            emptyHTML = trustedTypesPolicy.createHTML('');
                        } else {
                            // Uninitialized policy, attempt to initialize the internal dompurify policy.
                            if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                            // If creating the internal policy succeeded sign internal variables.
                            if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
                        }
                        // Prevent further manipulation of configuration.
                        // Not available in IE8, Safari 5, etc.
                        if (freeze) freeze(cfg);
                        CONFIG = cfg;
                    };
                    /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
                        ...svg$1,
                        ...svgFilters,
                        ...svgDisallowed
                    ]);
                    const ALL_MATHML_TAGS = addToSet({}, [
                        ...mathMl$1,
                        ...mathMlDisallowed
                    ]);
                    /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */ const _checkValidNamespace = function _checkValidNamespace(element) {
                        let parent = getParentNode(element);
                        // In JSDOM, if we're inside shadow DOM, then parentNode
                        // can be null. We just simulate parent in this case.
                        if (!parent || !parent.tagName) parent = {
                            namespaceURI: NAMESPACE,
                            tagName: 'template'
                        };
                        const tagName = stringToLowerCase(element.tagName);
                        const parentTagName = stringToLowerCase(parent.tagName);
                        if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
                        if (element.namespaceURI === SVG_NAMESPACE) {
                            // The only way to switch from HTML namespace to SVG
                            // is via <svg>. If it happens via any other tag, then
                            // it should be killed.
                            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                            // The only way to switch from MathML to SVG is via`
                            // svg if parent is either <annotation-xml> or MathML
                            // text integration points.
                            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                            // We only allow elements that are defined in SVG
                            // spec. All others are disallowed in SVG namespace.
                            return Boolean(ALL_SVG_TAGS[tagName]);
                        }
                        if (element.namespaceURI === MATHML_NAMESPACE) {
                            // The only way to switch from HTML namespace to MathML
                            // is via <math>. If it happens via any other tag, then
                            // it should be killed.
                            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                            // The only way to switch from SVG to MathML is via
                            // <math> and HTML integration points
                            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                            // We only allow elements that are defined in MathML
                            // spec. All others are disallowed in MathML namespace.
                            return Boolean(ALL_MATHML_TAGS[tagName]);
                        }
                        if (element.namespaceURI === HTML_NAMESPACE) {
                            // The only way to switch from SVG to HTML is via
                            // HTML integration points, and from MathML to HTML
                            // is via MathML text integration points
                            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                            // We disallow tags that are specific for MathML
                            // or SVG and should never appear in HTML namespace
                            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
                        }
                        // For XHTML and XML documents that support custom namespaces
                        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
                        // The code should never reach this place (this means
                        // that the element somehow got namespace that is not
                        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
                        // Return false just in case.
                        return false;
                    };
                    /**
   * _forceRemove
   *
   * @param node a DOM node
   */ const _forceRemove = function _forceRemove(node) {
                        arrayPush(DOMPurify.removed, {
                            element: node
                        });
                        try {
                            // eslint-disable-next-line unicorn/prefer-dom-node-remove
                            getParentNode(node).removeChild(node);
                        } catch (_) {
                            remove(node);
                        }
                    };
                    /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */ const _removeAttribute = function _removeAttribute(name, element) {
                        try {
                            arrayPush(DOMPurify.removed, {
                                attribute: element.getAttributeNode(name),
                                from: element
                            });
                        } catch (_) {
                            arrayPush(DOMPurify.removed, {
                                attribute: null,
                                from: element
                            });
                        }
                        element.removeAttribute(name);
                        // We void attribute values for unremovable "is" attributes
                        if (name === 'is') {
                            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                                _forceRemove(element);
                            } catch (_) {}
                            else try {
                                element.setAttribute(name, '');
                            } catch (_) {}
                        }
                    };
                    /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */ const _initDocument = function _initDocument(dirty) {
                        /* Create a HTML document */ let doc = null;
                        let leadingWhitespace = null;
                        if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
                        else {
                            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                            leadingWhitespace = matches && matches[0];
                        }
                        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
                        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
                        const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
                        /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */ if (NAMESPACE === HTML_NAMESPACE) try {
                            doc = new DOMParser1().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
                        } catch (_) {}
                        /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                            doc = implementation.createDocument(NAMESPACE, 'template', null);
                            try {
                                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                            } catch (_) {
                            // Syntax error if dirtyPayload is invalid xml
                            }
                        }
                        const body = doc.body || doc.documentElement;
                        if (dirty && leadingWhitespace) body.insertBefore(document1.createTextNode(leadingWhitespace), body.childNodes[0] || null);
                        /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
                        return WHOLE_DOCUMENT ? doc.documentElement : body;
                    };
                    /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */ const _createNodeIterator = function _createNodeIterator(root) {
                        return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
                        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
                    };
                    /**
   * _isClobbered
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */ const _isClobbered = function _isClobbered(element) {
                        return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
                    };
                    /**
   * Checks whether the given object is a DOM node.
   *
   * @param value object to check whether it's a DOM node
   * @return true is object is a DOM node
   */ const _isNode = function _isNode(value) {
                        return typeof Node1 === 'function' && value instanceof Node1;
                    };
                    function _executeHooks(hooks, currentNode, data) {
                        arrayForEach(hooks, (hook)=>{
                            hook.call(DOMPurify, currentNode, data, CONFIG);
                        });
                    }
                    /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */ const _sanitizeElements = function _sanitizeElements(currentNode) {
                        let content = null;
                        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
                        /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                            _forceRemove(currentNode);
                            return true;
                        }
                        /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
                        /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                            tagName,
                            allowedTags: ALLOWED_TAGS
                        });
                        /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                            _forceRemove(currentNode);
                            return true;
                        }
                        /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                            _forceRemove(currentNode);
                            return true;
                        }
                        /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                            _forceRemove(currentNode);
                            return true;
                        }
                        /* Remove element if anything forbids its presence */ if (!(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName])) {
                            /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                            }
                            /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                                const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                                const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                                if (childNodes && parentNode) {
                                    const childCount = childNodes.length;
                                    for(let i = childCount - 1; i >= 0; --i){
                                        const childClone = cloneNode(childNodes[i], true);
                                        childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                                        parentNode.insertBefore(childClone, getNextSibling(currentNode));
                                    }
                                }
                            }
                            _forceRemove(currentNode);
                            return true;
                        }
                        /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                            _forceRemove(currentNode);
                            return true;
                        }
                        /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                            _forceRemove(currentNode);
                            return true;
                        }
                        /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                            /* Get the element's text content */ content = currentNode.textContent;
                            arrayForEach([
                                MUSTACHE_EXPR,
                                ERB_EXPR,
                                TMPLIT_EXPR
                            ], (expr)=>{
                                content = stringReplace(content, expr, ' ');
                            });
                            if (currentNode.textContent !== content) {
                                arrayPush(DOMPurify.removed, {
                                    element: currentNode.cloneNode()
                                });
                                currentNode.textContent = content;
                            }
                        }
                        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
                        return false;
                    };
                    /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */ // eslint-disable-next-line complexity
                    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
                        /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document1 || value in formElement)) return false;
                        /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
                        else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
                        else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ;
                        else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                            if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                            _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                            lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                            else return false;
                        /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
                        else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
                        else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
                        else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
                        else if (value) return false;
                        return true;
                    };
                    /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
                        return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
                    };
                    /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
                        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
                        const { attributes } = currentNode;
                        /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
                        const hookEvent = {
                            attrName: '',
                            attrValue: '',
                            keepAttr: true,
                            allowedAttributes: ALLOWED_ATTR,
                            forceKeepAttr: undefined
                        };
                        let l = attributes.length;
                        /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                            const attr = attributes[l];
                            const { name, namespaceURI, value: attrValue } = attr;
                            const lcName = transformCaseFunc(name);
                            const initValue = attrValue;
                            let value = name === 'value' ? initValue : stringTrim(initValue);
                            /* Execute a hook if present */ hookEvent.attrName = lcName;
                            hookEvent.attrValue = value;
                            hookEvent.keepAttr = true;
                            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                            _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                            value = hookEvent.attrValue;
                            /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                                // Remove the attribute with this value
                                _removeAttribute(name, currentNode);
                                // Prefix the value and later re-create the attribute with the sanitized value
                                value = SANITIZE_NAMED_PROPS_PREFIX + value;
                            }
                            /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title|textarea)/i, value)) {
                                _removeAttribute(name, currentNode);
                                continue;
                            }
                            /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                                _removeAttribute(name, currentNode);
                                continue;
                            }
                            /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                            /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                                _removeAttribute(name, currentNode);
                                continue;
                            }
                            /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                                _removeAttribute(name, currentNode);
                                continue;
                            }
                            /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                                MUSTACHE_EXPR,
                                ERB_EXPR,
                                TMPLIT_EXPR
                            ], (expr)=>{
                                value = stringReplace(value, expr, ' ');
                            });
                            /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                            if (!_isValidAttribute(lcTag, lcName, value)) {
                                _removeAttribute(name, currentNode);
                                continue;
                            }
                            /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                                if (namespaceURI) ;
                                else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                                    case 'TrustedHTML':
                                        value = trustedTypesPolicy.createHTML(value);
                                        break;
                                    case 'TrustedScriptURL':
                                        value = trustedTypesPolicy.createScriptURL(value);
                                        break;
                                }
                            }
                            /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                                else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                                if (_isClobbered(currentNode)) _forceRemove(currentNode);
                                else arrayPop(DOMPurify.removed);
                            } catch (_) {
                                _removeAttribute(name, currentNode);
                            }
                        }
                        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
                    };
                    /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
                        let shadowNode = null;
                        const shadowIterator = _createNodeIterator(fragment);
                        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
                        while(shadowNode = shadowIterator.nextNode()){
                            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                            /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                            /* Check attributes next */ _sanitizeAttributes(shadowNode);
                            /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                        }
                        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
                    };
                    // eslint-disable-next-line complexity
                    DOMPurify.sanitize = function(dirty) {
                        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        let body = null;
                        let importedNode = null;
                        let currentNode = null;
                        let returnNode = null;
                        /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
                        if (IS_EMPTY_INPUT) dirty = '<!-->';
                        /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                            if (typeof dirty.toString === 'function') {
                                dirty = dirty.toString();
                                if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                            } else throw typeErrorCreate('toString is not a function');
                        }
                        /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
                        /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
                        /* Clean up removed elements */ DOMPurify.removed = [];
                        /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
                        if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                            if (dirty.nodeName) {
                                const tagName = transformCaseFunc(dirty.nodeName);
                                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                            }
                        } else if (dirty instanceof Node1) {
                            /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */ body = _initDocument('<!---->');
                            importedNode = body.ownerDocument.importNode(dirty, true);
                            if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                            else if (importedNode.nodeName === 'HTML') body = importedNode;
                            else // eslint-disable-next-line unicorn/prefer-dom-node-append
                            body.appendChild(importedNode);
                        } else {
                            /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                            dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                            /* Initialize the document to work on */ body = _initDocument(dirty);
                            /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
                        }
                        /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
                        /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
                        /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                            /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                            /* Check attributes next */ _sanitizeAttributes(currentNode);
                            /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                        }
                        /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
                        /* Return sanitized string or DOM */ if (RETURN_DOM) {
                            if (RETURN_DOM_FRAGMENT) {
                                returnNode = createDocumentFragment.call(body.ownerDocument);
                                while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                                returnNode.appendChild(body.firstChild);
                            } else returnNode = body;
                            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */ returnNode = importNode.call(originalDocument, returnNode, true);
                            return returnNode;
                        }
                        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
                        /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
                        /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                            MUSTACHE_EXPR,
                            ERB_EXPR,
                            TMPLIT_EXPR
                        ], (expr)=>{
                            serializedHTML = stringReplace(serializedHTML, expr, ' ');
                        });
                        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
                    };
                    DOMPurify.setConfig = function() {
                        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        _parseConfig(cfg);
                        SET_CONFIG = true;
                    };
                    DOMPurify.clearConfig = function() {
                        CONFIG = null;
                        SET_CONFIG = false;
                    };
                    DOMPurify.isValidAttribute = function(tag, attr, value) {
                        /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
                        const lcTag = transformCaseFunc(tag);
                        const lcName = transformCaseFunc(attr);
                        return _isValidAttribute(lcTag, lcName, value);
                    };
                    DOMPurify.addHook = function(entryPoint, hookFunction) {
                        if (typeof hookFunction !== 'function') return;
                        arrayPush(hooks[entryPoint], hookFunction);
                    };
                    DOMPurify.removeHook = function(entryPoint, hookFunction) {
                        if (hookFunction !== undefined) {
                            const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                            return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
                        }
                        return arrayPop(hooks[entryPoint]);
                    };
                    DOMPurify.removeHooks = function(entryPoint) {
                        hooks[entryPoint] = [];
                    };
                    DOMPurify.removeAllHooks = function() {
                        hooks = _createHooksMap();
                    };
                    return DOMPurify;
                }
                var purify = createDOMPurify();
            //# sourceMappingURL=purify.es.mjs.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/PngDecoder.js": /*!*****************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/PngDecoder.js ***!
  \*****************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ PngDecoder;
                    }
                });
                /* harmony import */ var iobuffer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! iobuffer */ "./node_modules/iobuffer/lib-esm/IOBuffer.js");
                /* harmony import */ var pako__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pako */ "./node_modules/pako/dist/pako.esm.mjs");
                /* harmony import */ var _helpers_crc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers/crc */ "./node_modules/fast-png/lib-esm/helpers/crc.js");
                /* harmony import */ var _helpers_decodeInterlaceAdam7__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helpers/decodeInterlaceAdam7 */ "./node_modules/fast-png/lib-esm/helpers/decodeInterlaceAdam7.js");
                /* harmony import */ var _helpers_decodeInterlaceNull__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./helpers/decodeInterlaceNull */ "./node_modules/fast-png/lib-esm/helpers/decodeInterlaceNull.js");
                /* harmony import */ var _helpers_signature__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./helpers/signature */ "./node_modules/fast-png/lib-esm/helpers/signature.js");
                /* harmony import */ var _helpers_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./helpers/text */ "./node_modules/fast-png/lib-esm/helpers/text.js");
                /* harmony import */ var _internalTypes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./internalTypes */ "./node_modules/fast-png/lib-esm/internalTypes.js");
                class PngDecoder extends iobuffer__WEBPACK_IMPORTED_MODULE_0__.IOBuffer {
                    _checkCrc;
                    _inflator;
                    _png;
                    _apng;
                    _end;
                    _hasPalette;
                    _palette;
                    _hasTransparency;
                    _transparency;
                    _compressionMethod;
                    _filterMethod;
                    _interlaceMethod;
                    _colorType;
                    _isAnimated;
                    _numberOfFrames;
                    _numberOfPlays;
                    _frames;
                    _writingDataChunks;
                    constructor(data, options = {}){
                        super(data);
                        const { checkCrc = false } = options;
                        this._checkCrc = checkCrc;
                        this._inflator = new pako__WEBPACK_IMPORTED_MODULE_1__.Inflate();
                        this._png = {
                            width: -1,
                            height: -1,
                            channels: -1,
                            data: new Uint8Array(0),
                            depth: 1,
                            text: {}
                        };
                        this._apng = {
                            width: -1,
                            height: -1,
                            channels: -1,
                            depth: 1,
                            numberOfFrames: 1,
                            numberOfPlays: 0,
                            text: {},
                            frames: []
                        };
                        this._end = false;
                        this._hasPalette = false;
                        this._palette = [];
                        this._hasTransparency = false;
                        this._transparency = new Uint16Array(0);
                        this._compressionMethod = _internalTypes__WEBPACK_IMPORTED_MODULE_7__.CompressionMethod.UNKNOWN;
                        this._filterMethod = _internalTypes__WEBPACK_IMPORTED_MODULE_7__.FilterMethod.UNKNOWN;
                        this._interlaceMethod = _internalTypes__WEBPACK_IMPORTED_MODULE_7__.InterlaceMethod.UNKNOWN;
                        this._colorType = _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.UNKNOWN;
                        this._isAnimated = false;
                        this._numberOfFrames = 1;
                        this._numberOfPlays = 0;
                        this._frames = [];
                        this._writingDataChunks = false;
                        // PNG is always big endian
                        // https://www.w3.org/TR/PNG/#7Integers-and-byte-order
                        this.setBigEndian();
                    }
                    decode() {
                        (0, _helpers_signature__WEBPACK_IMPORTED_MODULE_5__.checkSignature)(this);
                        while(!this._end){
                            const length = this.readUint32();
                            const type = this.readChars(4);
                            this.decodeChunk(length, type);
                        }
                        this.decodeImage();
                        return this._png;
                    }
                    decodeApng() {
                        (0, _helpers_signature__WEBPACK_IMPORTED_MODULE_5__.checkSignature)(this);
                        while(!this._end){
                            const length = this.readUint32();
                            const type = this.readChars(4);
                            this.decodeApngChunk(length, type);
                        }
                        this.decodeApngImage();
                        return this._apng;
                    }
                    // https://www.w3.org/TR/PNG/#5Chunk-layout
                    decodeChunk(length, type) {
                        const offset = this.offset;
                        switch(type){
                            // 11.2 Critical chunks
                            case 'IHDR':
                                this.decodeIHDR();
                                break;
                            case 'PLTE':
                                this.decodePLTE(length);
                                break;
                            case 'IDAT':
                                this.decodeIDAT(length);
                                break;
                            case 'IEND':
                                this._end = true;
                                break;
                            // 11.3 Ancillary chunks
                            case 'tRNS':
                                this.decodetRNS(length);
                                break;
                            case 'iCCP':
                                this.decodeiCCP(length);
                                break;
                            case _helpers_text__WEBPACK_IMPORTED_MODULE_6__.textChunkName:
                                (0, _helpers_text__WEBPACK_IMPORTED_MODULE_6__.decodetEXt)(this._png.text, this, length);
                                break;
                            case 'pHYs':
                                this.decodepHYs();
                                break;
                            default:
                                this.skip(length);
                                break;
                        }
                        if (this.offset - offset !== length) throw new Error(`Length mismatch while decoding chunk ${type}`);
                        if (this._checkCrc) (0, _helpers_crc__WEBPACK_IMPORTED_MODULE_2__.checkCrc)(this, length + 4, type);
                        else this.skip(4);
                    }
                    decodeApngChunk(length, type) {
                        const offset = this.offset;
                        if (type !== 'fdAT' && type !== 'IDAT' && this._writingDataChunks) this.pushDataToFrame();
                        switch(type){
                            case 'acTL':
                                this.decodeACTL();
                                break;
                            case 'fcTL':
                                this.decodeFCTL();
                                break;
                            case 'fdAT':
                                this.decodeFDAT(length);
                                break;
                            default:
                                this.decodeChunk(length, type);
                                this.offset = offset + length;
                                break;
                        }
                        if (this.offset - offset !== length) throw new Error(`Length mismatch while decoding chunk ${type}`);
                        if (this._checkCrc) (0, _helpers_crc__WEBPACK_IMPORTED_MODULE_2__.checkCrc)(this, length + 4, type);
                        else this.skip(4);
                    }
                    // https://www.w3.org/TR/PNG/#11IHDR
                    decodeIHDR() {
                        const image = this._png;
                        image.width = this.readUint32();
                        image.height = this.readUint32();
                        image.depth = checkBitDepth(this.readUint8());
                        const colorType = this.readUint8();
                        this._colorType = colorType;
                        let channels;
                        switch(colorType){
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.GREYSCALE:
                                channels = 1;
                                break;
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.TRUECOLOUR:
                                channels = 3;
                                break;
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.INDEXED_COLOUR:
                                channels = 1;
                                break;
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.GREYSCALE_ALPHA:
                                channels = 2;
                                break;
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.TRUECOLOUR_ALPHA:
                                channels = 4;
                                break;
                            // Kept for exhaustiveness.
                            // eslint-disable-next-line unicorn/no-useless-switch-case
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.UNKNOWN:
                            default:
                                throw new Error(`Unknown color type: ${colorType}`);
                        }
                        this._png.channels = channels;
                        this._compressionMethod = this.readUint8();
                        if (this._compressionMethod !== _internalTypes__WEBPACK_IMPORTED_MODULE_7__.CompressionMethod.DEFLATE) throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
                        this._filterMethod = this.readUint8();
                        this._interlaceMethod = this.readUint8();
                    }
                    decodeACTL() {
                        this._numberOfFrames = this.readUint32();
                        this._numberOfPlays = this.readUint32();
                        this._isAnimated = true;
                    }
                    decodeFCTL() {
                        const image = {
                            sequenceNumber: this.readUint32(),
                            width: this.readUint32(),
                            height: this.readUint32(),
                            xOffset: this.readUint32(),
                            yOffset: this.readUint32(),
                            delayNumber: this.readUint16(),
                            delayDenominator: this.readUint16(),
                            disposeOp: this.readUint8(),
                            blendOp: this.readUint8(),
                            data: new Uint8Array(0)
                        };
                        this._frames.push(image);
                    }
                    // https://www.w3.org/TR/PNG/#11PLTE
                    decodePLTE(length) {
                        if (length % 3 !== 0) throw new RangeError(`PLTE field length must be a multiple of 3. Got ${length}`);
                        const l = length / 3;
                        this._hasPalette = true;
                        const palette = [];
                        this._palette = palette;
                        for(let i = 0; i < l; i++)palette.push([
                            this.readUint8(),
                            this.readUint8(),
                            this.readUint8()
                        ]);
                    }
                    // https://www.w3.org/TR/PNG/#11IDAT
                    decodeIDAT(length) {
                        this._writingDataChunks = true;
                        const dataLength = length;
                        const dataOffset = this.offset + this.byteOffset;
                        this._inflator.push(new Uint8Array(this.buffer, dataOffset, dataLength));
                        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
                        this.skip(length);
                    }
                    decodeFDAT(length) {
                        this._writingDataChunks = true;
                        let dataLength = length;
                        let dataOffset = this.offset + this.byteOffset;
                        dataOffset += 4;
                        dataLength -= 4;
                        this._inflator.push(new Uint8Array(this.buffer, dataOffset, dataLength));
                        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
                        this.skip(length);
                    }
                    // https://www.w3.org/TR/PNG/#11tRNS
                    decodetRNS(length) {
                        switch(this._colorType){
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.GREYSCALE:
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.TRUECOLOUR:
                                if (length % 2 !== 0) throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${length}`);
                                if (length / 2 > this._png.width * this._png.height) throw new Error(`tRNS chunk contains more alpha values than there are pixels (${length / 2} vs ${this._png.width * this._png.height})`);
                                this._hasTransparency = true;
                                this._transparency = new Uint16Array(length / 2);
                                for(let i = 0; i < length / 2; i++)this._transparency[i] = this.readUint16();
                                break;
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.INDEXED_COLOUR:
                                {
                                    if (length > this._palette.length) throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${length} vs ${this._palette.length})`);
                                    let i = 0;
                                    for(; i < length; i++){
                                        const alpha = this.readByte();
                                        this._palette[i].push(alpha);
                                    }
                                    for(; i < this._palette.length; i++)this._palette[i].push(255);
                                    break;
                                }
                            // Kept for exhaustiveness.
                            /* eslint-disable unicorn/no-useless-switch-case */ case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.UNKNOWN:
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.GREYSCALE_ALPHA:
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.ColorType.TRUECOLOUR_ALPHA:
                            default:
                                throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
                        }
                    }
                    // https://www.w3.org/TR/PNG/#11iCCP
                    decodeiCCP(length) {
                        const name = (0, _helpers_text__WEBPACK_IMPORTED_MODULE_6__.readKeyword)(this);
                        const compressionMethod = this.readUint8();
                        if (compressionMethod !== _internalTypes__WEBPACK_IMPORTED_MODULE_7__.CompressionMethod.DEFLATE) throw new Error(`Unsupported iCCP compression method: ${compressionMethod}`);
                        const compressedProfile = this.readBytes(length - name.length - 2);
                        this._png.iccEmbeddedProfile = {
                            name,
                            profile: (0, pako__WEBPACK_IMPORTED_MODULE_1__.inflate)(compressedProfile)
                        };
                    }
                    // https://www.w3.org/TR/PNG/#11pHYs
                    decodepHYs() {
                        const ppuX = this.readUint32();
                        const ppuY = this.readUint32();
                        const unitSpecifier = this.readByte();
                        this._png.resolution = {
                            x: ppuX,
                            y: ppuY,
                            unit: unitSpecifier
                        };
                    }
                    decodeApngImage() {
                        this._apng.width = this._png.width;
                        this._apng.height = this._png.height;
                        this._apng.channels = this._png.channels;
                        this._apng.depth = this._png.depth;
                        this._apng.numberOfFrames = this._numberOfFrames;
                        this._apng.numberOfPlays = this._numberOfPlays;
                        this._apng.text = this._png.text;
                        this._apng.resolution = this._png.resolution;
                        for(let i = 0; i < this._numberOfFrames; i++){
                            const newFrame = {
                                sequenceNumber: this._frames[i].sequenceNumber,
                                delayNumber: this._frames[i].delayNumber,
                                delayDenominator: this._frames[i].delayDenominator,
                                data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
                            };
                            const frame = this._frames.at(i);
                            if (frame) {
                                frame.data = (0, _helpers_decodeInterlaceNull__WEBPACK_IMPORTED_MODULE_4__.decodeInterlaceNull)({
                                    data: frame.data,
                                    width: frame.width,
                                    height: frame.height,
                                    channels: this._apng.channels,
                                    depth: this._apng.depth
                                });
                                if (this._hasPalette) this._apng.palette = this._palette;
                                if (this._hasTransparency) this._apng.transparency = this._transparency;
                                if (i === 0 || frame.xOffset === 0 && frame.yOffset === 0 && frame.width === this._png.width && frame.height === this._png.height) newFrame.data = frame.data;
                                else {
                                    const prevFrame = this._apng.frames.at(i - 1);
                                    this.disposeFrame(frame, prevFrame, newFrame);
                                    this.addFrameDataToCanvas(newFrame, frame);
                                }
                                this._apng.frames.push(newFrame);
                            }
                        }
                        return this._apng;
                    }
                    disposeFrame(frame, prevFrame, imageFrame) {
                        switch(frame.disposeOp){
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.DisposeOpType.NONE:
                                break;
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.DisposeOpType.BACKGROUND:
                                for(let row = 0; row < this._png.height; row++)for(let col = 0; col < this._png.width; col++){
                                    const index = (row * frame.width + col) * this._png.channels;
                                    for(let channel = 0; channel < this._png.channels; channel++)imageFrame.data[index + channel] = 0;
                                }
                                break;
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.DisposeOpType.PREVIOUS:
                                imageFrame.data.set(prevFrame.data);
                                break;
                            default:
                                throw new Error('Unknown disposeOp');
                        }
                    }
                    addFrameDataToCanvas(imageFrame, frame) {
                        const maxValue = 1 << this._png.depth;
                        const calculatePixelIndices = (row, col)=>{
                            const index = ((row + frame.yOffset) * this._png.width + frame.xOffset + col) * this._png.channels;
                            const frameIndex = (row * frame.width + col) * this._png.channels;
                            return {
                                index,
                                frameIndex
                            };
                        };
                        switch(frame.blendOp){
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.BlendOpType.SOURCE:
                                for(let row = 0; row < frame.height; row++)for(let col = 0; col < frame.width; col++){
                                    const { index, frameIndex } = calculatePixelIndices(row, col);
                                    for(let channel = 0; channel < this._png.channels; channel++)imageFrame.data[index + channel] = frame.data[frameIndex + channel];
                                }
                                break;
                            // https://www.w3.org/TR/png-3/#13Alpha-channel-processing
                            case _internalTypes__WEBPACK_IMPORTED_MODULE_7__.BlendOpType.OVER:
                                for(let row = 0; row < frame.height; row++)for(let col = 0; col < frame.width; col++){
                                    const { index, frameIndex } = calculatePixelIndices(row, col);
                                    for(let channel = 0; channel < this._png.channels; channel++){
                                        const sourceAlpha = frame.data[frameIndex + this._png.channels - 1] / maxValue;
                                        const foregroundValue = channel % (this._png.channels - 1) === 0 ? 1 : frame.data[frameIndex + channel];
                                        const value = Math.floor(sourceAlpha * foregroundValue + (1 - sourceAlpha) * imageFrame.data[index + channel]);
                                        imageFrame.data[index + channel] += value;
                                    }
                                }
                                break;
                            default:
                                throw new Error('Unknown blendOp');
                        }
                    }
                    decodeImage() {
                        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
                        const data = this._isAnimated ? (this._frames?.at(0)).data : this._inflator.result;
                        if (this._filterMethod !== _internalTypes__WEBPACK_IMPORTED_MODULE_7__.FilterMethod.ADAPTIVE) throw new Error(`Filter method ${this._filterMethod} not supported`);
                        if (this._interlaceMethod === _internalTypes__WEBPACK_IMPORTED_MODULE_7__.InterlaceMethod.NO_INTERLACE) this._png.data = (0, _helpers_decodeInterlaceNull__WEBPACK_IMPORTED_MODULE_4__.decodeInterlaceNull)({
                            data: data,
                            width: this._png.width,
                            height: this._png.height,
                            channels: this._png.channels,
                            depth: this._png.depth
                        });
                        else if (this._interlaceMethod === _internalTypes__WEBPACK_IMPORTED_MODULE_7__.InterlaceMethod.ADAM7) this._png.data = (0, _helpers_decodeInterlaceAdam7__WEBPACK_IMPORTED_MODULE_3__.decodeInterlaceAdam7)({
                            data: data,
                            width: this._png.width,
                            height: this._png.height,
                            channels: this._png.channels,
                            depth: this._png.depth
                        });
                        else throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
                        if (this._hasPalette) this._png.palette = this._palette;
                        if (this._hasTransparency) this._png.transparency = this._transparency;
                    }
                    pushDataToFrame() {
                        const result = this._inflator.result;
                        const lastFrame = this._frames.at(-1);
                        if (lastFrame) lastFrame.data = result;
                        else this._frames.push({
                            sequenceNumber: 0,
                            width: this._png.width,
                            height: this._png.height,
                            xOffset: 0,
                            yOffset: 0,
                            delayNumber: 0,
                            delayDenominator: 0,
                            disposeOp: _internalTypes__WEBPACK_IMPORTED_MODULE_7__.DisposeOpType.NONE,
                            blendOp: _internalTypes__WEBPACK_IMPORTED_MODULE_7__.BlendOpType.SOURCE,
                            data: result
                        });
                        this._inflator = new pako__WEBPACK_IMPORTED_MODULE_1__.Inflate();
                        this._writingDataChunks = false;
                    }
                }
                function checkBitDepth(value) {
                    if (value !== 1 && value !== 2 && value !== 4 && value !== 8 && value !== 16) throw new Error(`invalid bit depth: ${value}`);
                    return value;
                }
            //# sourceMappingURL=PngDecoder.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/PngEncoder.js": /*!*****************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/PngEncoder.js ***!
  \*****************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ PngEncoder;
                    }
                });
                /* harmony import */ var iobuffer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! iobuffer */ "./node_modules/iobuffer/lib-esm/IOBuffer.js");
                /* harmony import */ var pako__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pako */ "./node_modules/pako/dist/pako.esm.mjs");
                /* harmony import */ var _helpers_crc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers/crc */ "./node_modules/fast-png/lib-esm/helpers/crc.js");
                /* harmony import */ var _helpers_signature__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helpers/signature */ "./node_modules/fast-png/lib-esm/helpers/signature.js");
                /* harmony import */ var _helpers_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./helpers/text */ "./node_modules/fast-png/lib-esm/helpers/text.js");
                /* harmony import */ var _internalTypes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./internalTypes */ "./node_modules/fast-png/lib-esm/internalTypes.js");
                const defaultZlibOptions = {
                    level: 3
                };
                class PngEncoder extends iobuffer__WEBPACK_IMPORTED_MODULE_0__.IOBuffer {
                    _png;
                    _zlibOptions;
                    _colorType;
                    _interlaceMethod;
                    constructor(data, options = {}){
                        super();
                        this._colorType = _internalTypes__WEBPACK_IMPORTED_MODULE_5__.ColorType.UNKNOWN;
                        this._zlibOptions = {
                            ...defaultZlibOptions,
                            ...options.zlib
                        };
                        this._png = this._checkData(data);
                        this._interlaceMethod = (options.interlace === 'Adam7' ? _internalTypes__WEBPACK_IMPORTED_MODULE_5__.InterlaceMethod.ADAM7 : _internalTypes__WEBPACK_IMPORTED_MODULE_5__.InterlaceMethod.NO_INTERLACE) ?? _internalTypes__WEBPACK_IMPORTED_MODULE_5__.InterlaceMethod.NO_INTERLACE;
                        this.setBigEndian();
                    }
                    encode() {
                        (0, _helpers_signature__WEBPACK_IMPORTED_MODULE_3__.writeSignature)(this);
                        this.encodeIHDR();
                        if (this._png.palette) {
                            this.encodePLTE();
                            if (this._png.palette[0].length === 4) this.encodeTRNS();
                        }
                        this.encodeData();
                        if (this._png.text) for (const [keyword, text] of Object.entries(this._png.text))(0, _helpers_text__WEBPACK_IMPORTED_MODULE_4__.encodetEXt)(this, keyword, text);
                        this.encodeIEND();
                        return this.toArray();
                    }
                    // https://www.w3.org/TR/PNG/#11IHDR
                    encodeIHDR() {
                        this.writeUint32(13);
                        this.writeChars('IHDR');
                        this.writeUint32(this._png.width);
                        this.writeUint32(this._png.height);
                        this.writeByte(this._png.depth);
                        this.writeByte(this._colorType);
                        this.writeByte(_internalTypes__WEBPACK_IMPORTED_MODULE_5__.CompressionMethod.DEFLATE);
                        this.writeByte(_internalTypes__WEBPACK_IMPORTED_MODULE_5__.FilterMethod.ADAPTIVE);
                        this.writeByte(this._interlaceMethod);
                        (0, _helpers_crc__WEBPACK_IMPORTED_MODULE_2__.writeCrc)(this, 17);
                    }
                    // https://www.w3.org/TR/PNG/#11IEND
                    encodeIEND() {
                        this.writeUint32(0);
                        this.writeChars('IEND');
                        (0, _helpers_crc__WEBPACK_IMPORTED_MODULE_2__.writeCrc)(this, 4);
                    }
                    encodePLTE() {
                        const paletteLength = this._png.palette?.length * 3;
                        this.writeUint32(paletteLength);
                        this.writeChars('PLTE');
                        for (const color of this._png.palette){
                            this.writeByte(color[0]);
                            this.writeByte(color[1]);
                            this.writeByte(color[2]);
                        }
                        (0, _helpers_crc__WEBPACK_IMPORTED_MODULE_2__.writeCrc)(this, 4 + paletteLength);
                    }
                    encodeTRNS() {
                        const alpha = this._png.palette.filter((color)=>{
                            return color.at(-1) !== 255;
                        });
                        this.writeUint32(alpha.length);
                        this.writeChars('tRNS');
                        for (const el of alpha)this.writeByte(el.at(-1));
                        (0, _helpers_crc__WEBPACK_IMPORTED_MODULE_2__.writeCrc)(this, 4 + alpha.length);
                    }
                    // https://www.w3.org/TR/PNG/#11IDAT
                    encodeIDAT(data) {
                        this.writeUint32(data.length);
                        this.writeChars('IDAT');
                        this.writeBytes(data);
                        (0, _helpers_crc__WEBPACK_IMPORTED_MODULE_2__.writeCrc)(this, data.length + 4);
                    }
                    encodeData() {
                        const { width, height, channels, depth, data } = this._png;
                        const slotsPerLine = depth <= 8 ? Math.ceil(width * depth / 8) * channels : Math.ceil(width * depth / 8 * channels / 2);
                        const newData = new iobuffer__WEBPACK_IMPORTED_MODULE_0__.IOBuffer().setBigEndian();
                        let offset = 0;
                        if (this._interlaceMethod === _internalTypes__WEBPACK_IMPORTED_MODULE_5__.InterlaceMethod.NO_INTERLACE) for(let i = 0; i < height; i++){
                            newData.writeByte(0); // no filter
                            if (depth === 16) offset = writeDataUint16(data, newData, slotsPerLine, offset);
                            else offset = writeDataBytes(data, newData, slotsPerLine, offset);
                        }
                        else if (this._interlaceMethod === _internalTypes__WEBPACK_IMPORTED_MODULE_5__.InterlaceMethod.ADAM7) // Adam7 interlacing
                        offset = writeDataInterlaced(this._png, data, newData, offset);
                        const buffer = newData.toArray();
                        const compressed = (0, pako__WEBPACK_IMPORTED_MODULE_1__.deflate)(buffer, this._zlibOptions);
                        this.encodeIDAT(compressed);
                    }
                    _checkData(data) {
                        const { colorType, channels, depth } = getColorType(data, data.palette);
                        const png = {
                            width: checkInteger(data.width, 'width'),
                            height: checkInteger(data.height, 'height'),
                            channels,
                            data: data.data,
                            depth,
                            text: data.text,
                            palette: data.palette
                        };
                        this._colorType = colorType;
                        const expectedSize = depth < 8 ? Math.ceil(png.width * depth / 8) * png.height * channels : png.width * png.height * channels;
                        if (png.data.length !== expectedSize) throw new RangeError(`wrong data size. Found ${png.data.length}, expected ${expectedSize}`);
                        return png;
                    }
                }
                function checkInteger(value, name) {
                    if (Number.isInteger(value) && value > 0) return value;
                    throw new TypeError(`${name} must be a positive integer`);
                }
                function getColorType(data, palette) {
                    const { channels = 4, depth = 8 } = data;
                    if (channels !== 4 && channels !== 3 && channels !== 2 && channels !== 1) throw new RangeError(`unsupported number of channels: ${channels}`);
                    const returnValue = {
                        channels,
                        depth,
                        colorType: _internalTypes__WEBPACK_IMPORTED_MODULE_5__.ColorType.UNKNOWN
                    };
                    switch(channels){
                        case 4:
                            returnValue.colorType = _internalTypes__WEBPACK_IMPORTED_MODULE_5__.ColorType.TRUECOLOUR_ALPHA;
                            break;
                        case 3:
                            returnValue.colorType = _internalTypes__WEBPACK_IMPORTED_MODULE_5__.ColorType.TRUECOLOUR;
                            break;
                        case 1:
                            if (palette) returnValue.colorType = _internalTypes__WEBPACK_IMPORTED_MODULE_5__.ColorType.INDEXED_COLOUR;
                            else returnValue.colorType = _internalTypes__WEBPACK_IMPORTED_MODULE_5__.ColorType.GREYSCALE;
                            break;
                        case 2:
                            returnValue.colorType = _internalTypes__WEBPACK_IMPORTED_MODULE_5__.ColorType.GREYSCALE_ALPHA;
                            break;
                        default:
                            throw new Error('unsupported number of channels');
                    }
                    return returnValue;
                }
                function writeDataBytes(data, newData, slotsPerLine, offset) {
                    for(let j = 0; j < slotsPerLine; j++)newData.writeByte(data[offset++]);
                    return offset;
                }
                function writeDataInterlaced(imageData, data, newData, offset) {
                    const passes = [
                        {
                            x: 0,
                            y: 0,
                            xStep: 8,
                            yStep: 8
                        },
                        {
                            x: 4,
                            y: 0,
                            xStep: 8,
                            yStep: 8
                        },
                        {
                            x: 0,
                            y: 4,
                            xStep: 4,
                            yStep: 8
                        },
                        {
                            x: 2,
                            y: 0,
                            xStep: 4,
                            yStep: 4
                        },
                        {
                            x: 0,
                            y: 2,
                            xStep: 2,
                            yStep: 4
                        },
                        {
                            x: 1,
                            y: 0,
                            xStep: 2,
                            yStep: 2
                        },
                        {
                            x: 0,
                            y: 1,
                            xStep: 1,
                            yStep: 2
                        }
                    ];
                    const { width, height, channels, depth } = imageData;
                    let pixelSize = 0;
                    if (depth === 16) pixelSize = channels * depth / 8 / 2;
                    else pixelSize = channels * depth / 8;
                    // Process each pass
                    for(let passIndex = 0; passIndex < 7; passIndex++){
                        const pass = passes[passIndex];
                        const passWidth = Math.floor((width - pass.x + pass.xStep - 1) / pass.xStep);
                        const passHeight = Math.floor((height - pass.y + pass.yStep - 1) / pass.yStep);
                        if (passWidth <= 0 || passHeight <= 0) continue;
                        const passLineBytes = passWidth * pixelSize;
                        // For each scanline in this pass
                        for(let y = 0; y < passHeight; y++){
                            const imageY = pass.y + y * pass.yStep;
                            // Extract raw scanline data
                            const rawScanline = depth <= 8 ? new Uint8Array(passLineBytes) : new Uint16Array(passLineBytes);
                            let rawOffset = 0;
                            for(let x = 0; x < passWidth; x++){
                                const imageX = pass.x + x * pass.xStep;
                                if (imageX < width && imageY < height) {
                                    const srcPos = (imageY * width + imageX) * pixelSize;
                                    for(let i = 0; i < pixelSize; i++)rawScanline[rawOffset++] = data[srcPos + i];
                                }
                            }
                            newData.writeByte(0); // no filter
                            if (depth === 8) newData.writeBytes(rawScanline);
                            else if (depth === 16) for (const value of rawScanline){
                                newData.writeByte(value >> 8 & 0xff); // High byte
                                newData.writeByte(value & 0xff);
                            }
                        }
                    }
                    return offset;
                }
                function writeDataUint16(data, newData, slotsPerLine, offset) {
                    for(let j = 0; j < slotsPerLine; j++)newData.writeUint16(data[offset++]);
                    return offset;
                }
            //# sourceMappingURL=PngEncoder.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/convertIndexedToRgb.js": /*!**************************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/convertIndexedToRgb.js ***!
  \**************************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ convertIndexedToRgb: function() {
                        return /* binding */ convertIndexedToRgb;
                    }
                });
                /**
 * Converts indexed data into RGB/RGBA format
 * @param decodedImage - Image to decode data from.
 * @returns Uint8Array with RGB data.
 */ function convertIndexedToRgb(decodedImage) {
                    const palette = decodedImage.palette;
                    const depth = decodedImage.depth;
                    if (!palette) throw new Error('Color palette is undefined.');
                    checkDataSize(decodedImage);
                    const indexSize = decodedImage.width * decodedImage.height;
                    const resSize = indexSize * palette[0].length;
                    const res = new Uint8Array(resSize);
                    let indexPos = 0;
                    let offset = 0;
                    const indexes = new Uint8Array(indexSize);
                    let bit = 0xff;
                    switch(depth){
                        case 1:
                            bit = 0x80;
                            break;
                        case 2:
                            bit = 0xc0;
                            break;
                        case 4:
                            bit = 0xf0;
                            break;
                        case 8:
                            bit = 0xff;
                            break;
                        default:
                            throw new Error('Incorrect depth value');
                    }
                    for (const byte of decodedImage.data){
                        let bit2 = bit;
                        let shift = 8;
                        while(bit2){
                            shift -= depth;
                            indexes[indexPos++] = (byte & bit2) >> shift;
                            bit2 = bit2 >> depth;
                            if (indexPos % decodedImage.width === 0) break;
                        }
                    }
                    if (decodedImage.palette) for (const index of indexes){
                        const color = decodedImage.palette.at(index);
                        if (!color) throw new Error('Incorrect index of palette color');
                        res.set(color, offset);
                        offset += color.length;
                    }
                    return res;
                }
                function checkDataSize(image) {
                    const expectedSize = image.depth < 8 ? Math.ceil(image.width * image.depth / 8) * image.height * image.channels : image.width * image.height * image.channels;
                    if (image.data.length !== expectedSize) throw new RangeError(`wrong data size. Found ${image.data.length}, expected ${expectedSize}`);
                }
            //# sourceMappingURL=convertIndexedToRgb.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/helpers/applyUnfilter.js": /*!****************************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/helpers/applyUnfilter.js ***!
  \****************************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ applyUnfilter: function() {
                        return /* binding */ applyUnfilter;
                    }
                });
                /* harmony import */ var _unfilter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./unfilter */ "./node_modules/fast-png/lib-esm/helpers/unfilter.js");
                /**
 * Apllies filter on scanline based on the filter type.
 * @param filterType - The filter type to apply.
 * @param currentLine - The current line of pixel data.
 * @param newLine - The new line of pixel data.
 * @param prevLine - The previous line of pixel data.
 * @param passLineBytes - The number of bytes in the pass line.
 * @param bytesPerPixel - The number of bytes per pixel.
 */ function applyUnfilter(filterType, currentLine, newLine, prevLine, passLineBytes, bytesPerPixel) {
                    switch(filterType){
                        case 0:
                            (0, _unfilter__WEBPACK_IMPORTED_MODULE_0__.unfilterNone)(currentLine, newLine, passLineBytes);
                            break;
                        case 1:
                            (0, _unfilter__WEBPACK_IMPORTED_MODULE_0__.unfilterSub)(currentLine, newLine, passLineBytes, bytesPerPixel);
                            break;
                        case 2:
                            (0, _unfilter__WEBPACK_IMPORTED_MODULE_0__.unfilterUp)(currentLine, newLine, prevLine, passLineBytes);
                            break;
                        case 3:
                            (0, _unfilter__WEBPACK_IMPORTED_MODULE_0__.unfilterAverage)(currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
                            break;
                        case 4:
                            (0, _unfilter__WEBPACK_IMPORTED_MODULE_0__.unfilterPaeth)(currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
                            break;
                        default:
                            throw new Error(`Unsupported filter: ${filterType}`);
                    }
                }
            //# sourceMappingURL=applyUnfilter.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/helpers/crc.js": /*!******************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/helpers/crc.js ***!
  \******************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ checkCrc: function() {
                        return /* binding */ checkCrc;
                    },
                    /* harmony export */ writeCrc: function() {
                        return /* binding */ writeCrc;
                    }
                });
                const crcTable = [];
                for(let n = 0; n < 256; n++){
                    let c = n;
                    for(let k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
                    else c = c >>> 1;
                    crcTable[n] = c;
                }
                const initialCrc = 0xffffffff;
                function updateCrc(currentCrc, data, length) {
                    let c = currentCrc;
                    for(let n = 0; n < length; n++)c = crcTable[(c ^ data[n]) & 0xff] ^ c >>> 8;
                    return c;
                }
                function crc(data, length) {
                    return (updateCrc(initialCrc, data, length) ^ initialCrc) >>> 0;
                }
                function checkCrc(buffer, crcLength, chunkName) {
                    const expectedCrc = buffer.readUint32();
                    const actualCrc = crc(new Uint8Array(buffer.buffer, buffer.byteOffset + buffer.offset - crcLength - 4, crcLength), crcLength); // "- 4" because we already advanced by reading the CRC
                    if (actualCrc !== expectedCrc) throw new Error(`CRC mismatch for chunk ${chunkName}. Expected ${expectedCrc}, found ${actualCrc}`);
                }
                function writeCrc(buffer, length) {
                    buffer.writeUint32(crc(new Uint8Array(buffer.buffer, buffer.byteOffset + buffer.offset - length, length), length));
                }
            //# sourceMappingURL=crc.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/helpers/decodeInterlaceAdam7.js": /*!***********************************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/helpers/decodeInterlaceAdam7.js ***!
  \***********************************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ decodeInterlaceAdam7: function() {
                        return /* binding */ decodeInterlaceAdam7;
                    }
                });
                /* harmony import */ var _applyUnfilter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./applyUnfilter */ "./node_modules/fast-png/lib-esm/helpers/applyUnfilter.js");
                const uint16 = new Uint16Array([
                    0x00ff
                ]);
                const uint8 = new Uint8Array(uint16.buffer);
                const osIsLittleEndian = uint8[0] === 0xff;
                /**
 * Decodes the Adam7 interlaced PNG data.
 *
 * @param params - DecodeInterlaceNullParams
 * @returns - array of pixel data.
 */ function decodeInterlaceAdam7(params) {
                    const { data, width, height, channels, depth } = params;
                    // Adam7 interlacing pattern
                    const passes = [
                        {
                            x: 0,
                            y: 0,
                            xStep: 8,
                            yStep: 8
                        },
                        {
                            x: 4,
                            y: 0,
                            xStep: 8,
                            yStep: 8
                        },
                        {
                            x: 0,
                            y: 4,
                            xStep: 4,
                            yStep: 8
                        },
                        {
                            x: 2,
                            y: 0,
                            xStep: 4,
                            yStep: 4
                        },
                        {
                            x: 0,
                            y: 2,
                            xStep: 2,
                            yStep: 4
                        },
                        {
                            x: 1,
                            y: 0,
                            xStep: 2,
                            yStep: 2
                        },
                        {
                            x: 0,
                            y: 1,
                            xStep: 1,
                            yStep: 2
                        }
                    ];
                    const bytesPerPixel = Math.ceil(depth / 8) * channels;
                    const resultData = new Uint8Array(height * width * bytesPerPixel);
                    let offset = 0;
                    // Process each pass
                    for(let passIndex = 0; passIndex < 7; passIndex++){
                        const pass = passes[passIndex];
                        // Calculate pass dimensions
                        const passWidth = Math.ceil((width - pass.x) / pass.xStep);
                        const passHeight = Math.ceil((height - pass.y) / pass.yStep);
                        if (passWidth <= 0 || passHeight <= 0) continue;
                        const passLineBytes = passWidth * bytesPerPixel;
                        const prevLine = new Uint8Array(passLineBytes);
                        // Process each scanline in this pass
                        for(let y = 0; y < passHeight; y++){
                            // First byte is the filter type
                            const filterType = data[offset++];
                            const currentLine = data.subarray(offset, offset + passLineBytes);
                            offset += passLineBytes;
                            // Create a new line for the unfiltered data
                            const newLine = new Uint8Array(passLineBytes);
                            // Apply the appropriate unfilter
                            (0, _applyUnfilter__WEBPACK_IMPORTED_MODULE_0__.applyUnfilter)(filterType, currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
                            prevLine.set(newLine);
                            for(let x = 0; x < passWidth; x++){
                                const outputX = pass.x + x * pass.xStep;
                                const outputY = pass.y + y * pass.yStep;
                                if (outputX >= width || outputY >= height) continue;
                                for(let i = 0; i < bytesPerPixel; i++)resultData[(outputY * width + outputX) * bytesPerPixel + i] = newLine[x * bytesPerPixel + i];
                            }
                        }
                    }
                    if (depth === 16) {
                        const uint16Data = new Uint16Array(resultData.buffer);
                        if (osIsLittleEndian) for(let k = 0; k < uint16Data.length; k++)// PNG is always big endian. Swap the bytes.
                        uint16Data[k] = swap16(uint16Data[k]);
                        return uint16Data;
                    } else return resultData;
                }
                function swap16(val) {
                    return (val & 0xff) << 8 | val >> 8 & 0xff;
                }
            //# sourceMappingURL=decodeInterlaceAdam7.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/helpers/decodeInterlaceNull.js": /*!**********************************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/helpers/decodeInterlaceNull.js ***!
  \**********************************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ decodeInterlaceNull: function() {
                        return /* binding */ decodeInterlaceNull;
                    }
                });
                /* harmony import */ var _unfilter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./unfilter */ "./node_modules/fast-png/lib-esm/helpers/unfilter.js");
                const uint16 = new Uint16Array([
                    0x00ff
                ]);
                const uint8 = new Uint8Array(uint16.buffer);
                const osIsLittleEndian = uint8[0] === 0xff;
                const empty = new Uint8Array(0);
                function decodeInterlaceNull(params) {
                    const { data, width, height, channels, depth } = params;
                    const bytesPerPixel = Math.ceil(depth / 8) * channels;
                    const bytesPerLine = Math.ceil(depth / 8 * channels * width);
                    const newData = new Uint8Array(height * bytesPerLine);
                    let prevLine = empty;
                    let offset = 0;
                    let currentLine;
                    let newLine;
                    for(let i = 0; i < height; i++){
                        currentLine = data.subarray(offset + 1, offset + 1 + bytesPerLine);
                        newLine = newData.subarray(i * bytesPerLine, (i + 1) * bytesPerLine);
                        switch(data[offset]){
                            case 0:
                                (0, _unfilter__WEBPACK_IMPORTED_MODULE_0__.unfilterNone)(currentLine, newLine, bytesPerLine);
                                break;
                            case 1:
                                (0, _unfilter__WEBPACK_IMPORTED_MODULE_0__.unfilterSub)(currentLine, newLine, bytesPerLine, bytesPerPixel);
                                break;
                            case 2:
                                (0, _unfilter__WEBPACK_IMPORTED_MODULE_0__.unfilterUp)(currentLine, newLine, prevLine, bytesPerLine);
                                break;
                            case 3:
                                (0, _unfilter__WEBPACK_IMPORTED_MODULE_0__.unfilterAverage)(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                                break;
                            case 4:
                                (0, _unfilter__WEBPACK_IMPORTED_MODULE_0__.unfilterPaeth)(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                                break;
                            default:
                                throw new Error(`Unsupported filter: ${data[offset]}`);
                        }
                        prevLine = newLine;
                        offset += bytesPerLine + 1;
                    }
                    if (depth === 16) {
                        const uint16Data = new Uint16Array(newData.buffer);
                        if (osIsLittleEndian) for(let k = 0; k < uint16Data.length; k++)// PNG is always big endian. Swap the bytes.
                        uint16Data[k] = swap16(uint16Data[k]);
                        return uint16Data;
                    } else return newData;
                }
                function swap16(val) {
                    return (val & 0xff) << 8 | val >> 8 & 0xff;
                }
            //# sourceMappingURL=decodeInterlaceNull.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/helpers/signature.js": /*!************************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/helpers/signature.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ checkSignature: function() {
                        return /* binding */ checkSignature;
                    },
                    /* harmony export */ hasPngSignature: function() {
                        return /* binding */ hasPngSignature;
                    },
                    /* harmony export */ writeSignature: function() {
                        return /* binding */ writeSignature;
                    }
                });
                // https://www.w3.org/TR/PNG/#5PNG-file-signature
                const pngSignature = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
                function writeSignature(buffer) {
                    buffer.writeBytes(pngSignature);
                }
                function checkSignature(buffer) {
                    if (!hasPngSignature(buffer.readBytes(pngSignature.length))) throw new Error('wrong PNG signature');
                }
                function hasPngSignature(array) {
                    if (array.length < pngSignature.length) return false;
                    for(let i = 0; i < pngSignature.length; i++){
                        if (array[i] !== pngSignature[i]) return false;
                    }
                    return true;
                }
            //# sourceMappingURL=signature.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/helpers/text.js": /*!*******************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/helpers/text.js ***!
  \*******************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ decodetEXt: function() {
                        return /* binding */ decodetEXt;
                    },
                    /* harmony export */ encodetEXt: function() {
                        return /* binding */ encodetEXt;
                    },
                    /* harmony export */ readKeyword: function() {
                        return /* binding */ readKeyword;
                    },
                    /* harmony export */ readLatin1: function() {
                        return /* binding */ readLatin1;
                    },
                    /* harmony export */ textChunkName: function() {
                        return /* binding */ textChunkName;
                    }
                });
                /* harmony import */ var _crc__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./crc */ "./node_modules/fast-png/lib-esm/helpers/crc.js");
                // https://www.w3.org/TR/png/#11tEXt
                const textChunkName = 'tEXt';
                const NULL = 0;
                const latin1Decoder = new TextDecoder('latin1');
                function validateKeyword(keyword) {
                    validateLatin1(keyword);
                    if (keyword.length === 0 || keyword.length > 79) throw new Error('keyword length must be between 1 and 79');
                }
                // eslint-disable-next-line no-control-regex
                const latin1Regex = /^[\u0000-\u00FF]*$/;
                function validateLatin1(text) {
                    if (!latin1Regex.test(text)) throw new Error('invalid latin1 text');
                }
                function decodetEXt(text, buffer, length) {
                    const keyword = readKeyword(buffer);
                    text[keyword] = readLatin1(buffer, length - keyword.length - 1);
                }
                function encodetEXt(buffer, keyword, text) {
                    validateKeyword(keyword);
                    validateLatin1(text);
                    const length = keyword.length + 1 /* NULL */  + text.length;
                    buffer.writeUint32(length);
                    buffer.writeChars(textChunkName);
                    buffer.writeChars(keyword);
                    buffer.writeByte(NULL);
                    buffer.writeChars(text);
                    (0, _crc__WEBPACK_IMPORTED_MODULE_0__.writeCrc)(buffer, length + 4);
                }
                // https://www.w3.org/TR/png/#11keywords
                function readKeyword(buffer) {
                    buffer.mark();
                    while(buffer.readByte() !== NULL);
                    const end = buffer.offset;
                    buffer.reset();
                    const keyword = latin1Decoder.decode(buffer.readBytes(end - buffer.offset - 1));
                    // NULL
                    buffer.skip(1);
                    validateKeyword(keyword);
                    return keyword;
                }
                function readLatin1(buffer, length) {
                    return latin1Decoder.decode(buffer.readBytes(length));
                }
            //# sourceMappingURL=text.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/helpers/unfilter.js": /*!***********************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/helpers/unfilter.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ unfilterAverage: function() {
                        return /* binding */ unfilterAverage;
                    },
                    /* harmony export */ unfilterNone: function() {
                        return /* binding */ unfilterNone;
                    },
                    /* harmony export */ unfilterPaeth: function() {
                        return /* binding */ unfilterPaeth;
                    },
                    /* harmony export */ unfilterSub: function() {
                        return /* binding */ unfilterSub;
                    },
                    /* harmony export */ unfilterUp: function() {
                        return /* binding */ unfilterUp;
                    }
                });
                function unfilterNone(currentLine, newLine, bytesPerLine) {
                    for(let i = 0; i < bytesPerLine; i++)newLine[i] = currentLine[i];
                }
                function unfilterSub(currentLine, newLine, bytesPerLine, bytesPerPixel) {
                    let i = 0;
                    for(; i < bytesPerPixel; i++)// just copy first bytes
                    newLine[i] = currentLine[i];
                    for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + newLine[i - bytesPerPixel] & 0xff;
                }
                function unfilterUp(currentLine, newLine, prevLine, bytesPerLine) {
                    let i = 0;
                    if (prevLine.length === 0) // just copy bytes for first line
                    for(; i < bytesPerLine; i++)newLine[i] = currentLine[i];
                    else for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + prevLine[i] & 0xff;
                }
                function unfilterAverage(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
                    let i = 0;
                    if (prevLine.length === 0) {
                        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i];
                        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + (newLine[i - bytesPerPixel] >> 1) & 0xff;
                    } else {
                        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i] + (prevLine[i] >> 1) & 0xff;
                        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + (newLine[i - bytesPerPixel] + prevLine[i] >> 1) & 0xff;
                    }
                }
                function unfilterPaeth(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
                    let i = 0;
                    if (prevLine.length === 0) {
                        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i];
                        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + newLine[i - bytesPerPixel] & 0xff;
                    } else {
                        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i] + prevLine[i] & 0xff;
                        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + paethPredictor(newLine[i - bytesPerPixel], prevLine[i], prevLine[i - bytesPerPixel]) & 0xff;
                    }
                }
                function paethPredictor(a, b, c) {
                    const p = a + b - c;
                    const pa = Math.abs(p - a);
                    const pb = Math.abs(p - b);
                    const pc = Math.abs(p - c);
                    if (pa <= pb && pa <= pc) return a;
                    else if (pb <= pc) return b;
                    else return c;
                }
            //# sourceMappingURL=unfilter.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/index.js": /*!************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/index.js ***!
  \************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ ResolutionUnitSpecifier: function() {
                        return /* reexport safe */ _types__WEBPACK_IMPORTED_MODULE_3__.ResolutionUnitSpecifier;
                    },
                    /* harmony export */ convertIndexedToRgb: function() {
                        return /* reexport safe */ _convertIndexedToRgb__WEBPACK_IMPORTED_MODULE_4__.convertIndexedToRgb;
                    },
                    /* harmony export */ decode: function() {
                        return /* binding */ decodePng;
                    },
                    /* harmony export */ decodeApng: function() {
                        return /* binding */ decodeApng;
                    },
                    /* harmony export */ encode: function() {
                        return /* binding */ encodePng;
                    },
                    /* harmony export */ hasPngSignature: function() {
                        return /* reexport safe */ _helpers_signature__WEBPACK_IMPORTED_MODULE_2__.hasPngSignature;
                    }
                });
                /* harmony import */ var _PngDecoder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PngDecoder */ "./node_modules/fast-png/lib-esm/PngDecoder.js");
                /* harmony import */ var _PngEncoder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PngEncoder */ "./node_modules/fast-png/lib-esm/PngEncoder.js");
                /* harmony import */ var _helpers_signature__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers/signature */ "./node_modules/fast-png/lib-esm/helpers/signature.js");
                /* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./types */ "./node_modules/fast-png/lib-esm/types.js");
                /* harmony import */ var _convertIndexedToRgb__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./convertIndexedToRgb */ "./node_modules/fast-png/lib-esm/convertIndexedToRgb.js");
                function decodePng(data, options) {
                    const decoder = new _PngDecoder__WEBPACK_IMPORTED_MODULE_0__["default"](data, options);
                    return decoder.decode();
                }
                function encodePng(png, options) {
                    const encoder = new _PngEncoder__WEBPACK_IMPORTED_MODULE_1__["default"](png, options);
                    return encoder.encode();
                }
                function decodeApng(data, options) {
                    const decoder = new _PngDecoder__WEBPACK_IMPORTED_MODULE_0__["default"](data, options);
                    return decoder.decodeApng();
                }
            //# sourceMappingURL=index.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/internalTypes.js": /*!********************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/internalTypes.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BlendOpType: function() {
                        return /* binding */ BlendOpType;
                    },
                    /* harmony export */ ColorType: function() {
                        return /* binding */ ColorType;
                    },
                    /* harmony export */ CompressionMethod: function() {
                        return /* binding */ CompressionMethod;
                    },
                    /* harmony export */ DisposeOpType: function() {
                        return /* binding */ DisposeOpType;
                    },
                    /* harmony export */ FilterMethod: function() {
                        return /* binding */ FilterMethod;
                    },
                    /* harmony export */ InterlaceMethod: function() {
                        return /* binding */ InterlaceMethod;
                    }
                });
                const ColorType = {
                    UNKNOWN: -1,
                    GREYSCALE: 0,
                    TRUECOLOUR: 2,
                    INDEXED_COLOUR: 3,
                    GREYSCALE_ALPHA: 4,
                    TRUECOLOUR_ALPHA: 6
                };
                const CompressionMethod = {
                    UNKNOWN: -1,
                    DEFLATE: 0
                };
                const FilterMethod = {
                    UNKNOWN: -1,
                    ADAPTIVE: 0
                };
                const InterlaceMethod = {
                    UNKNOWN: -1,
                    NO_INTERLACE: 0,
                    ADAM7: 1
                };
                const DisposeOpType = {
                    NONE: 0,
                    BACKGROUND: 1,
                    PREVIOUS: 2
                };
                const BlendOpType = {
                    SOURCE: 0,
                    OVER: 1
                };
            //# sourceMappingURL=internalTypes.js.map
            /***/ },
            /***/ "./node_modules/fast-png/lib-esm/types.js": /*!************************************************!*\
  !*** ./node_modules/fast-png/lib-esm/types.js ***!
  \************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ ResolutionUnitSpecifier: function() {
                        return /* binding */ ResolutionUnitSpecifier;
                    }
                });
                var ResolutionUnitSpecifier;
                (function(ResolutionUnitSpecifier) {
                    /**
     * Unit is unknown
     */ ResolutionUnitSpecifier[ResolutionUnitSpecifier["UNKNOWN"] = 0] = "UNKNOWN";
                    /**
     * Unit is the metre
     */ ResolutionUnitSpecifier[ResolutionUnitSpecifier["METRE"] = 1] = "METRE";
                })(ResolutionUnitSpecifier || (ResolutionUnitSpecifier = {}));
            //# sourceMappingURL=types.js.map
            /***/ },
            /***/ "./node_modules/fflate/esm/browser.js": /*!********************************************!*\
  !*** ./node_modules/fflate/esm/browser.js ***!
  \********************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ AsyncCompress: function() {
                        return /* binding */ AsyncGzip;
                    },
                    /* harmony export */ AsyncDecompress: function() {
                        return /* binding */ AsyncDecompress;
                    },
                    /* harmony export */ AsyncDeflate: function() {
                        return /* binding */ AsyncDeflate;
                    },
                    /* harmony export */ AsyncGunzip: function() {
                        return /* binding */ AsyncGunzip;
                    },
                    /* harmony export */ AsyncGzip: function() {
                        return /* binding */ AsyncGzip;
                    },
                    /* harmony export */ AsyncInflate: function() {
                        return /* binding */ AsyncInflate;
                    },
                    /* harmony export */ AsyncUnzipInflate: function() {
                        return /* binding */ AsyncUnzipInflate;
                    },
                    /* harmony export */ AsyncUnzlib: function() {
                        return /* binding */ AsyncUnzlib;
                    },
                    /* harmony export */ AsyncZipDeflate: function() {
                        return /* binding */ AsyncZipDeflate;
                    },
                    /* harmony export */ AsyncZlib: function() {
                        return /* binding */ AsyncZlib;
                    },
                    /* harmony export */ Compress: function() {
                        return /* binding */ Gzip;
                    },
                    /* harmony export */ DecodeUTF8: function() {
                        return /* binding */ DecodeUTF8;
                    },
                    /* harmony export */ Decompress: function() {
                        return /* binding */ Decompress;
                    },
                    /* harmony export */ Deflate: function() {
                        return /* binding */ Deflate;
                    },
                    /* harmony export */ EncodeUTF8: function() {
                        return /* binding */ EncodeUTF8;
                    },
                    /* harmony export */ FlateErrorCode: function() {
                        return /* binding */ FlateErrorCode;
                    },
                    /* harmony export */ Gunzip: function() {
                        return /* binding */ Gunzip;
                    },
                    /* harmony export */ Gzip: function() {
                        return /* binding */ Gzip;
                    },
                    /* harmony export */ Inflate: function() {
                        return /* binding */ Inflate;
                    },
                    /* harmony export */ Unzip: function() {
                        return /* binding */ Unzip;
                    },
                    /* harmony export */ UnzipInflate: function() {
                        return /* binding */ UnzipInflate;
                    },
                    /* harmony export */ UnzipPassThrough: function() {
                        return /* binding */ UnzipPassThrough;
                    },
                    /* harmony export */ Unzlib: function() {
                        return /* binding */ Unzlib;
                    },
                    /* harmony export */ Zip: function() {
                        return /* binding */ Zip;
                    },
                    /* harmony export */ ZipDeflate: function() {
                        return /* binding */ ZipDeflate;
                    },
                    /* harmony export */ ZipPassThrough: function() {
                        return /* binding */ ZipPassThrough;
                    },
                    /* harmony export */ Zlib: function() {
                        return /* binding */ Zlib;
                    },
                    /* harmony export */ compress: function() {
                        return /* binding */ gzip;
                    },
                    /* harmony export */ compressSync: function() {
                        return /* binding */ gzipSync;
                    },
                    /* harmony export */ decompress: function() {
                        return /* binding */ decompress;
                    },
                    /* harmony export */ decompressSync: function() {
                        return /* binding */ decompressSync;
                    },
                    /* harmony export */ deflate: function() {
                        return /* binding */ deflate;
                    },
                    /* harmony export */ deflateSync: function() {
                        return /* binding */ deflateSync;
                    },
                    /* harmony export */ gunzip: function() {
                        return /* binding */ gunzip;
                    },
                    /* harmony export */ gunzipSync: function() {
                        return /* binding */ gunzipSync;
                    },
                    /* harmony export */ gzip: function() {
                        return /* binding */ gzip;
                    },
                    /* harmony export */ gzipSync: function() {
                        return /* binding */ gzipSync;
                    },
                    /* harmony export */ inflate: function() {
                        return /* binding */ inflate;
                    },
                    /* harmony export */ inflateSync: function() {
                        return /* binding */ inflateSync;
                    },
                    /* harmony export */ strFromU8: function() {
                        return /* binding */ strFromU8;
                    },
                    /* harmony export */ strToU8: function() {
                        return /* binding */ strToU8;
                    },
                    /* harmony export */ unzip: function() {
                        return /* binding */ unzip;
                    },
                    /* harmony export */ unzipSync: function() {
                        return /* binding */ unzipSync;
                    },
                    /* harmony export */ unzlib: function() {
                        return /* binding */ unzlib;
                    },
                    /* harmony export */ unzlibSync: function() {
                        return /* binding */ unzlibSync;
                    },
                    /* harmony export */ zip: function() {
                        return /* binding */ zip;
                    },
                    /* harmony export */ zipSync: function() {
                        return /* binding */ zipSync;
                    },
                    /* harmony export */ zlib: function() {
                        return /* binding */ zlib;
                    },
                    /* harmony export */ zlibSync: function() {
                        return /* binding */ zlibSync;
                    }
                });
                // DEFLATE is a complex format; to read this code, you should probably check the RFC first:
                // https://tools.ietf.org/html/rfc1951
                // You may also wish to take a look at the guide I made about this program:
                // https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
                // Some of the following code is similar to that of UZIP.js:
                // https://github.com/photopea/UZIP.js
                // However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
                // Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
                // is better for memory in most engines (I *think*).
                var ch2 = {};
                var wk = function(c, id, msg, transfer, cb) {
                    var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
                        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
                    ], {
                        type: 'text/javascript'
                    }))));
                    w.onmessage = function(e) {
                        var d = e.data, ed = d.$e$;
                        if (ed) {
                            var err = new Error(ed[0]);
                            err['code'] = ed[1];
                            err.stack = ed[2];
                            cb(err, null);
                        } else cb(null, d);
                    };
                    w.postMessage(msg, transfer);
                    return w;
                };
                // aliases for shorter compressed code (most minifers don't do this)
                var u8 = Uint8Array, u16 = Uint16Array, i32 = Int32Array;
                // fixed length extra bits
                var fleb = new u8([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0,
                    /* unused */ 0,
                    0,
                    /* impossible */ 0
                ]);
                // fixed distance extra bits
                var fdeb = new u8([
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13,
                    /* unused */ 0,
                    0
                ]);
                // code length index map
                var clim = new u8([
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ]);
                // get base, reverse index map from extra bits
                var freb = function(eb, start) {
                    var b = new u16(31);
                    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
                    // numbers here are at max 18 bits
                    var r = new i32(b[30]);
                    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
                    return {
                        b: b,
                        r: r
                    };
                };
                var _a = freb(fleb, 2), fl = _a.b, revfl = _a.r;
                // we can ignore the fact that the other numbers are wrong; they never happen anyway
                fl[28] = 258, revfl[258] = 28;
                var _b = freb(fdeb, 0), fd = _b.b, revfd = _b.r;
                // map of value to reverse (assuming 16 bits)
                var rev = new u16(32768);
                for(var i = 0; i < 32768; ++i){
                    // reverse table algorithm from SO
                    var x = (i & 0xAAAA) >> 1 | (i & 0x5555) << 1;
                    x = (x & 0xCCCC) >> 2 | (x & 0x3333) << 2;
                    x = (x & 0xF0F0) >> 4 | (x & 0x0F0F) << 4;
                    rev[i] = ((x & 0xFF00) >> 8 | (x & 0x00FF) << 8) >> 1;
                }
                // create huffman tree from u8 "map": index -> code length for code index
                // mb (max bits) must be at most 15
                // TODO: optimize/split up?
                var hMap = function(cd, mb, r) {
                    var s = cd.length;
                    // index
                    var i = 0;
                    // u16 "map": index -> # of codes with bit length = index
                    var l = new u16(mb);
                    // length of cd must be 288 (total # of codes)
                    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
                    // u16 "map": index -> minimum code for bit length = index
                    var le = new u16(mb);
                    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
                    var co;
                    if (r) {
                        // u16 "map": index -> number of actual bits, symbol for code
                        co = new u16(1 << mb);
                        // bits to remove for reverser
                        var rvb = 15 - mb;
                        for(i = 0; i < s; ++i)// ignore 0 lengths
                        if (cd[i]) {
                            // num encoding both symbol and bits read
                            var sv = i << 4 | cd[i];
                            // free bits
                            var r_1 = mb - cd[i];
                            // start value
                            var v = le[cd[i] - 1]++ << r_1;
                            // m is end value
                            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
                            co[rev[v] >> rvb] = sv;
                        }
                    } else {
                        co = new u16(s);
                        for(i = 0; i < s; ++i)if (cd[i]) co[i] = rev[le[cd[i] - 1]++] >> 15 - cd[i];
                    }
                    return co;
                };
                // fixed length tree
                var flt = new u8(288);
                for(var i = 0; i < 144; ++i)flt[i] = 8;
                for(var i = 144; i < 256; ++i)flt[i] = 9;
                for(var i = 256; i < 280; ++i)flt[i] = 7;
                for(var i = 280; i < 288; ++i)flt[i] = 8;
                // fixed distance tree
                var fdt = new u8(32);
                for(var i = 0; i < 32; ++i)fdt[i] = 5;
                // fixed length map
                var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
                // fixed distance map
                var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
                // find max of array
                var max = function(a) {
                    var m = a[0];
                    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
                    return m;
                };
                // read d, starting at bit p and mask with m
                var bits = function(d, p, m) {
                    var o = p / 8 | 0;
                    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
                };
                // read d, starting at bit p continuing for at least 16 bits
                var bits16 = function(d, p) {
                    var o = p / 8 | 0;
                    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
                };
                // get end of byte
                var shft = function(p) {
                    return (p + 7) / 8 | 0;
                };
                // typed array slice - allows garbage collector to free original reference,
                // while being more compatible than .slice
                var slc = function(v, s, e) {
                    if (s == null || s < 0) s = 0;
                    if (e == null || e > v.length) e = v.length;
                    // can't use .constructor in case user-supplied
                    return new u8(v.subarray(s, e));
                };
                /**
 * Codes for errors generated within this library
 */ var FlateErrorCode = {
                    UnexpectedEOF: 0,
                    InvalidBlockType: 1,
                    InvalidLengthLiteral: 2,
                    InvalidDistance: 3,
                    StreamFinished: 4,
                    NoStreamHandler: 5,
                    InvalidHeader: 6,
                    NoCallback: 7,
                    InvalidUTF8: 8,
                    ExtraFieldTooLong: 9,
                    InvalidDate: 10,
                    FilenameTooLong: 11,
                    StreamFinishing: 12,
                    InvalidZipData: 13,
                    UnknownCompressionMethod: 14
                };
                // error codes
                var ec = [
                    'unexpected EOF',
                    'invalid block type',
                    'invalid length/literal',
                    'invalid distance',
                    'stream finished',
                    'no stream handler',
                    ,
                    'no callback',
                    'invalid UTF-8 data',
                    'extra field too long',
                    'date not in range 1980-2099',
                    'filename too long',
                    'stream finishing',
                    'invalid zip data'
                ];
                var err = function(ind, msg, nt) {
                    var e = new Error(msg || ec[ind]);
                    e.code = ind;
                    if (Error.captureStackTrace) Error.captureStackTrace(e, err);
                    if (!nt) throw e;
                    return e;
                };
                // expands raw DEFLATE data
                var inflt = function(dat, st, buf, dict) {
                    // source length       dict length
                    var sl = dat.length, dl = dict ? dict.length : 0;
                    if (!sl || st.f && !st.l) return buf || new u8(0);
                    var noBuf = !buf;
                    // have to estimate size
                    var resize = noBuf || st.i != 2;
                    // no state
                    var noSt = st.i;
                    // Assumes roughly 33% compression ratio average
                    if (noBuf) buf = new u8(sl * 3);
                    // ensure buffer can fit at least l elements
                    var cbuf = function(l) {
                        var bl = buf.length;
                        // need to increase size to fit
                        if (l > bl) {
                            // Double or set to necessary, whichever is greater
                            var nbuf = new u8(Math.max(bl * 2, l));
                            nbuf.set(buf);
                            buf = nbuf;
                        }
                    };
                    //  last chunk         bitpos           bytes
                    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
                    // total bits
                    var tbts = sl * 8;
                    do {
                        if (!lm) {
                            // BFINAL - this is only 1 when last chunk is next
                            final = bits(dat, pos, 1);
                            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
                            var type = bits(dat, pos + 1, 3);
                            pos += 3;
                            if (!type) {
                                // go to end of byte boundary
                                var s = shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                                if (t > sl) {
                                    if (noSt) err(0);
                                    break;
                                }
                                // ensure size
                                if (resize) cbuf(bt + l);
                                // Copy over uncompressed data
                                buf.set(dat.subarray(s, t), bt);
                                // Get new bitpos, update byte count
                                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                                continue;
                            } else if (type == 1) lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
                            else if (type == 2) {
                                //  literal                            lengths
                                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                                pos += 14;
                                // length+distance tree
                                var ldt = new u8(tl);
                                // code length tree
                                var clt = new u8(19);
                                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                                clt[clim[i]] = bits(dat, pos + i * 3, 7);
                                pos += hcLen * 3;
                                // code lengths bits
                                var clb = max(clt), clbmsk = (1 << clb) - 1;
                                // code lengths map
                                var clm = hMap(clt, clb, 1);
                                for(var i = 0; i < tl;){
                                    var r = clm[bits(dat, pos, clbmsk)];
                                    // bits read
                                    pos += r & 15;
                                    // symbol
                                    var s = r >> 4;
                                    // code length to copy
                                    if (s < 16) ldt[i++] = s;
                                    else {
                                        //  copy   count
                                        var c = 0, n = 0;
                                        if (s == 16) n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                                        else if (s == 17) n = 3 + bits(dat, pos, 7), pos += 3;
                                        else if (s == 18) n = 11 + bits(dat, pos, 127), pos += 7;
                                        while(n--)ldt[i++] = c;
                                    }
                                }
                                //    length tree                 distance tree
                                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                                // max length bits
                                lbt = max(lt);
                                // max dist bits
                                dbt = max(dt);
                                lm = hMap(lt, lbt, 1);
                                dm = hMap(dt, dbt, 1);
                            } else err(1);
                            if (pos > tbts) {
                                if (noSt) err(0);
                                break;
                            }
                        }
                        // Make sure the buffer can hold this + the largest possible addition
                        // Maximum chunk size (practically, theoretically infinite) is 2^17
                        if (resize) cbuf(bt + 131072);
                        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
                        var lpos = pos;
                        for(;; lpos = pos){
                            // bits read, code
                            var c = lm[bits16(dat, pos) & lms], sym = c >> 4;
                            pos += c & 15;
                            if (pos > tbts) {
                                if (noSt) err(0);
                                break;
                            }
                            if (!c) err(2);
                            if (sym < 256) buf[bt++] = sym;
                            else if (sym == 256) {
                                lpos = pos, lm = null;
                                break;
                            } else {
                                var add = sym - 254;
                                // no extra bits needed if less
                                if (sym > 264) {
                                    // index
                                    var i = sym - 257, b = fleb[i];
                                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                                    pos += b;
                                }
                                // dist
                                var d = dm[bits16(dat, pos) & dms], dsym = d >> 4;
                                if (!d) err(3);
                                pos += d & 15;
                                var dt = fd[dsym];
                                if (dsym > 3) {
                                    var b = fdeb[dsym];
                                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                                }
                                if (pos > tbts) {
                                    if (noSt) err(0);
                                    break;
                                }
                                if (resize) cbuf(bt + 131072);
                                var end = bt + add;
                                if (bt < dt) {
                                    var shift = dl - dt, dend = Math.min(dt, end);
                                    if (shift + bt < 0) err(3);
                                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                                }
                                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
                            }
                        }
                        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
                        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
                    }while (!final);
                    // don't reallocate for streams or user buffers
                    return bt != buf.length && noBuf ? slc(buf, 0, bt) : buf.subarray(0, bt);
                };
                // starting at p, write the minimum number of bits that can hold v to d
                var wbits = function(d, p, v) {
                    v <<= p & 7;
                    var o = p / 8 | 0;
                    d[o] |= v;
                    d[o + 1] |= v >> 8;
                };
                // starting at p, write the minimum number of bits (>8) that can hold v to d
                var wbits16 = function(d, p, v) {
                    v <<= p & 7;
                    var o = p / 8 | 0;
                    d[o] |= v;
                    d[o + 1] |= v >> 8;
                    d[o + 2] |= v >> 16;
                };
                // creates code lengths from a frequency table
                var hTree = function(d, mb) {
                    // Need extra info to make a tree
                    var t = [];
                    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
                        s: i,
                        f: d[i]
                    });
                    var s = t.length;
                    var t2 = t.slice();
                    if (!s) return {
                        t: et,
                        l: 0
                    };
                    if (s == 1) {
                        var v = new u8(t[0].s + 1);
                        v[t[0].s] = 1;
                        return {
                            t: v,
                            l: 1
                        };
                    }
                    t.sort(function(a, b) {
                        return a.f - b.f;
                    });
                    // after i2 reaches last ind, will be stopped
                    // freq must be greater than largest possible number of symbols
                    t.push({
                        s: -1,
                        f: 25001
                    });
                    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
                    t[0] = {
                        s: -1,
                        f: l.f + r.f,
                        l: l,
                        r: r
                    };
                    // efficient algorithm from UZIP.js
                    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
                    // symbols that combined have high freq, will start processing i2 (high-freq,
                    // non-composite) symbols instead
                    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
                    while(i1 != s - 1){
                        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
                        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
                        t[i1++] = {
                            s: -1,
                            f: l.f + r.f,
                            l: l,
                            r: r
                        };
                    }
                    var maxSym = t2[0].s;
                    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
                    // code lengths
                    var tr = new u16(maxSym + 1);
                    // max bits in tree
                    var mbt = ln(t[i1 - 1], tr, 0);
                    if (mbt > mb) {
                        // more algorithms from UZIP.js
                        // TODO: find out how this code works (debt)
                        //  ind    debt
                        var i = 0, dt = 0;
                        //    left            cost
                        var lft = mbt - mb, cst = 1 << lft;
                        t2.sort(function(a, b) {
                            return tr[b.s] - tr[a.s] || a.f - b.f;
                        });
                        for(; i < s; ++i){
                            var i2_1 = t2[i].s;
                            if (tr[i2_1] > mb) {
                                dt += cst - (1 << mbt - tr[i2_1]);
                                tr[i2_1] = mb;
                            } else break;
                        }
                        dt >>= lft;
                        while(dt > 0){
                            var i2_2 = t2[i].s;
                            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
                            else ++i;
                        }
                        for(; i >= 0 && dt; --i){
                            var i2_3 = t2[i].s;
                            if (tr[i2_3] == mb) {
                                --tr[i2_3];
                                ++dt;
                            }
                        }
                        mbt = mb;
                    }
                    return {
                        t: new u8(tr),
                        l: mbt
                    };
                };
                // get the max length and assign length codes
                var ln = function(n, l, d) {
                    return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
                };
                // length codes generation
                var lc = function(c) {
                    var s = c.length;
                    // Note that the semicolon was intentional
                    while(s && !c[--s]);
                    var cl = new u16(++s);
                    //  ind      num         streak
                    var cli = 0, cln = c[0], cls = 1;
                    var w = function(v) {
                        cl[cli++] = v;
                    };
                    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
                    else {
                        if (!cln && cls > 2) {
                            for(; cls > 138; cls -= 138)w(32754);
                            if (cls > 2) {
                                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                                cls = 0;
                            }
                        } else if (cls > 3) {
                            w(cln), --cls;
                            for(; cls > 6; cls -= 6)w(8304);
                            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
                        }
                        while(cls--)w(cln);
                        cls = 1;
                        cln = c[i];
                    }
                    return {
                        c: cl.subarray(0, cli),
                        n: s
                    };
                };
                // calculate the length of output from tree, code lengths
                var clen = function(cf, cl) {
                    var l = 0;
                    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
                    return l;
                };
                // writes a fixed block
                // returns the new bit pos
                var wfblk = function(out, pos, dat) {
                    // no need to write 00 as type: TypedArray defaults to 0
                    var s = dat.length;
                    var o = shft(pos + 2);
                    out[o] = s & 255;
                    out[o + 1] = s >> 8;
                    out[o + 2] = out[o] ^ 255;
                    out[o + 3] = out[o + 1] ^ 255;
                    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
                    return (o + 4 + s) * 8;
                };
                // writes a block
                var wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
                    wbits(out, p++, final);
                    ++lf[256];
                    var _a = hTree(lf, 15), dlt = _a.t, mlb = _a.l;
                    var _b = hTree(df, 15), ddt = _b.t, mdb = _b.l;
                    var _c = lc(dlt), lclt = _c.c, nlc = _c.n;
                    var _d = lc(ddt), lcdt = _d.c, ndc = _d.n;
                    var lcfreq = new u16(19);
                    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
                    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
                    var _e = hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
                    var nlcc = 19;
                    for(; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
                    var flen = bl + 5 << 3;
                    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
                    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
                    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
                    var lm, ll, dm, dl;
                    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
                    if (dtlen < ftlen) {
                        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
                        var llm = hMap(lct, mlcb, 0);
                        wbits(out, p, nlc - 257);
                        wbits(out, p + 5, ndc - 1);
                        wbits(out, p + 10, nlcc - 4);
                        p += 14;
                        for(var i = 0; i < nlcc; ++i)wbits(out, p + 3 * i, lct[clim[i]]);
                        p += 3 * nlcc;
                        var lcts = [
                            lclt,
                            lcdt
                        ];
                        for(var it = 0; it < 2; ++it){
                            var clct = lcts[it];
                            for(var i = 0; i < clct.length; ++i){
                                var len = clct[i] & 31;
                                wbits(out, p, llm[len]), p += lct[len];
                                if (len > 15) wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
                            }
                        }
                    } else lm = flm, ll = flt, dm = fdm, dl = fdt;
                    for(var i = 0; i < li; ++i){
                        var sym = syms[i];
                        if (sym > 255) {
                            var len = sym >> 18 & 31;
                            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
                            if (len > 7) wbits(out, p, sym >> 23 & 31), p += fleb[len];
                            var dst = sym & 31;
                            wbits16(out, p, dm[dst]), p += dl[dst];
                            if (dst > 3) wbits16(out, p, sym >> 5 & 8191), p += fdeb[dst];
                        } else wbits16(out, p, lm[sym]), p += ll[sym];
                    }
                    wbits16(out, p, lm[256]);
                    return p + ll[256];
                };
                // deflate options (nice << 13) | chain
                var deo = /*#__PURE__*/ new i32([
                    65540,
                    131080,
                    131088,
                    131104,
                    262176,
                    1048704,
                    1048832,
                    2114560,
                    2117632
                ]);
                // empty
                var et = /*#__PURE__*/ new u8(0);
                // compresses data into a raw DEFLATE buffer
                var dflt = function(dat, lvl, plvl, pre, post, st) {
                    var s = st.z || dat.length;
                    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
                    // writing to this writes to the output buffer
                    var w = o.subarray(pre, o.length - post);
                    var lst = st.l;
                    var pos = (st.r || 0) & 7;
                    if (lvl) {
                        if (pos) w[0] = st.r >> 3;
                        var opt = deo[lvl - 1];
                        var n = opt >> 13, c = opt & 8191;
                        var msk_1 = (1 << plvl) - 1;
                        //    prev 2-byte val map    curr 2-byte val map
                        var prev = st.p || new u16(32768), head = st.h || new u16(msk_1 + 1);
                        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
                        var hsh = function(i) {
                            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
                        };
                        // 24576 is an arbitrary number of maximum symbols per block
                        // 424 buffer for last block
                        var syms = new i32(25000);
                        // length/literal freq   distance freq
                        var lf = new u16(288), df = new u16(32);
                        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
                        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
                        for(; i + 2 < s; ++i){
                            // hash value
                            var hv = hsh(i);
                            // index mod 32768    previous index mod
                            var imod = i & 32767, pimod = head[hv];
                            prev[imod] = pimod;
                            head[hv] = imod;
                            // We always should modify head and prev, but only add symbols if
                            // this data is not yet processed ("wait" for wait index)
                            if (wi <= i) {
                                // bytes remaining
                                var rem = s - i;
                                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                                    li = lc_1 = eb = 0, bs = i;
                                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                                    for(var j = 0; j < 30; ++j)df[j] = 0;
                                }
                                //  len    dist   chain
                                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                                if (rem > 2 && hv == hsh(i - dif)) {
                                    var maxn = Math.min(n, rem) - 1;
                                    var maxd = Math.min(32767, i);
                                    // max possible length
                                    // not capped at dif because decompressors implement "rolling" index population
                                    var ml = Math.min(258, rem);
                                    while(dif <= maxd && --ch_1 && imod != pimod){
                                        if (dat[i + l] == dat[i + l - dif]) {
                                            var nl = 0;
                                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                                            if (nl > l) {
                                                l = nl, d = dif;
                                                // break out early when we reach "nice" (we are satisfied enough)
                                                if (nl > maxn) break;
                                                // now, find the rarest 2-byte sequence within this
                                                // length of literals and search for that instead.
                                                // Much faster than just using the start
                                                var mmd = Math.min(dif, nl - 2);
                                                var md = 0;
                                                for(var j = 0; j < mmd; ++j){
                                                    var ti = i - dif + j & 32767;
                                                    var pti = prev[ti];
                                                    var cd = ti - pti & 32767;
                                                    if (cd > md) md = cd, pimod = ti;
                                                }
                                            }
                                        }
                                        // check the previous match
                                        imod = pimod, pimod = prev[imod];
                                        dif += imod - pimod & 32767;
                                    }
                                }
                                // d will be nonzero only when a match was found
                                if (d) {
                                    // store both dist and len data in one int32
                                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                                    syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
                                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                                    eb += fleb[lin] + fdeb[din];
                                    ++lf[257 + lin];
                                    ++df[din];
                                    wi = i + l;
                                    ++lc_1;
                                } else {
                                    syms[li++] = dat[i];
                                    ++lf[dat[i]];
                                }
                            }
                        }
                        for(i = Math.max(i, wi); i < s; ++i){
                            syms[li++] = dat[i];
                            ++lf[dat[i]];
                        }
                        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
                        if (!lst) {
                            st.r = pos & 7 | w[pos / 8 | 0] << 3;
                            // shft(pos) now 1 less if pos & 7 != 0
                            pos -= 7;
                            st.h = head, st.p = prev, st.i = i, st.w = wi;
                        }
                    } else {
                        for(var i = st.w || 0; i < s + lst; i += 65535){
                            // end
                            var e = i + 65535;
                            if (e >= s) {
                                // write final block
                                w[pos / 8 | 0] = lst;
                                e = s;
                            }
                            pos = wfblk(w, pos + 1, dat.subarray(i, e));
                        }
                        st.i = s;
                    }
                    return slc(o, 0, pre + shft(pos) + post);
                };
                // CRC32 table
                var crct = /*#__PURE__*/ function() {
                    var t = new Int32Array(256);
                    for(var i = 0; i < 256; ++i){
                        var c = i, k = 9;
                        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
                        t[i] = c;
                    }
                    return t;
                }();
                // CRC32
                var crc = function() {
                    var c = -1;
                    return {
                        p: function(d) {
                            // closures have awful performance
                            var cr = c;
                            for(var i = 0; i < d.length; ++i)cr = crct[cr & 255 ^ d[i]] ^ cr >>> 8;
                            c = cr;
                        },
                        d: function() {
                            return ~c;
                        }
                    };
                };
                // Adler32
                var adler = function() {
                    var a = 1, b = 0;
                    return {
                        p: function(d) {
                            // closures have awful performance
                            var n = a, m = b;
                            var l = d.length | 0;
                            for(var i = 0; i != l;){
                                var e = Math.min(i + 2655, l);
                                for(; i < e; ++i)m += n += d[i];
                                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
                            }
                            a = n, b = m;
                        },
                        d: function() {
                            a %= 65521, b %= 65521;
                            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
                        }
                    };
                };
                // deflate with opts
                var dopt = function(dat, opt, pre, post, st) {
                    if (!st) {
                        st = {
                            l: 1
                        };
                        if (opt.dictionary) {
                            var dict = opt.dictionary.subarray(-32768);
                            var newDat = new u8(dict.length + dat.length);
                            newDat.set(dict);
                            newDat.set(dat, dict.length);
                            dat = newDat;
                            st.w = dict.length;
                        }
                    }
                    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
                };
                // Walmart object spread
                var mrg = function(a, b) {
                    var o = {};
                    for(var k in a)o[k] = a[k];
                    for(var k in b)o[k] = b[k];
                    return o;
                };
                // worker clone
                // This is possibly the craziest part of the entire codebase, despite how simple it may seem.
                // The only parameter to this function is a closure that returns an array of variables outside of the function scope.
                // We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
                // We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
                // The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
                // This took me three weeks to figure out how to do.
                var wcln = function(fn, fnStr, td) {
                    var dt = fn();
                    var st = fn.toString();
                    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
                    for(var i = 0; i < dt.length; ++i){
                        var v = dt[i], k = ks[i];
                        if (typeof v == 'function') {
                            fnStr += ';' + k + '=';
                            var st_1 = v.toString();
                            if (v.prototype) {
                                // for global objects
                                if (st_1.indexOf('[native code]') != -1) {
                                    var spInd = st_1.indexOf(' ', 8) + 1;
                                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                                } else {
                                    fnStr += st_1;
                                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                                }
                            } else fnStr += st_1;
                        } else td[k] = v;
                    }
                    return fnStr;
                };
                var ch = [];
                // clone bufs
                var cbfs = function(v) {
                    var tl = [];
                    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
                    return tl;
                };
                // use a worker to execute code
                var wrkr = function(fns, init, id, cb) {
                    if (!ch[id]) {
                        var fnStr = '', td_1 = {}, m = fns.length - 1;
                        for(var i = 0; i < m; ++i)fnStr = wcln(fns[i], fnStr, td_1);
                        ch[id] = {
                            c: wcln(fns[m], fnStr, td_1),
                            e: td_1
                        };
                    }
                    var td = mrg({}, ch[id].e);
                    return wk(ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
                };
                // base async inflate fn
                var bInflt = function() {
                    return [
                        u8,
                        u16,
                        i32,
                        fleb,
                        fdeb,
                        clim,
                        fl,
                        fd,
                        flrm,
                        fdrm,
                        rev,
                        ec,
                        hMap,
                        max,
                        bits,
                        bits16,
                        shft,
                        slc,
                        err,
                        inflt,
                        inflateSync,
                        pbf,
                        gopt
                    ];
                };
                var bDflt = function() {
                    return [
                        u8,
                        u16,
                        i32,
                        fleb,
                        fdeb,
                        clim,
                        revfl,
                        revfd,
                        flm,
                        flt,
                        fdm,
                        fdt,
                        rev,
                        deo,
                        et,
                        hMap,
                        wbits,
                        wbits16,
                        hTree,
                        ln,
                        lc,
                        clen,
                        wfblk,
                        wblk,
                        shft,
                        slc,
                        dflt,
                        dopt,
                        deflateSync,
                        pbf
                    ];
                };
                // gzip extra
                var gze = function() {
                    return [
                        gzh,
                        gzhl,
                        wbytes,
                        crc,
                        crct
                    ];
                };
                // gunzip extra
                var guze = function() {
                    return [
                        gzs,
                        gzl
                    ];
                };
                // zlib extra
                var zle = function() {
                    return [
                        zlh,
                        wbytes,
                        adler
                    ];
                };
                // unzlib extra
                var zule = function() {
                    return [
                        zls
                    ];
                };
                // post buf
                var pbf = function(msg) {
                    return postMessage(msg, [
                        msg.buffer
                    ]);
                };
                // get opts
                var gopt = function(o) {
                    return o && {
                        out: o.size && new u8(o.size),
                        dictionary: o.dictionary
                    };
                };
                // async helper
                var cbify = function(dat, opts, fns, init, id, cb) {
                    var w = wrkr(fns, init, id, function(err, dat) {
                        w.terminate();
                        cb(err, dat);
                    });
                    w.postMessage([
                        dat,
                        opts
                    ], opts.consume ? [
                        dat.buffer
                    ] : []);
                    return function() {
                        w.terminate();
                    };
                };
                // auto stream
                var astrm = function(strm) {
                    strm.ondata = function(dat, final) {
                        return postMessage([
                            dat,
                            final
                        ], [
                            dat.buffer
                        ]);
                    };
                    return function(ev) {
                        if (ev.data.length) {
                            strm.push(ev.data[0], ev.data[1]);
                            postMessage([
                                ev.data[0].length
                            ]);
                        } else strm.flush();
                    };
                };
                // async stream attach
                var astrmify = function(fns, strm, opts, init, id, flush, ext) {
                    var t;
                    var w = wrkr(fns, init, id, function(err, dat) {
                        if (err) w.terminate(), strm.ondata.call(strm, err);
                        else if (!Array.isArray(dat)) ext(dat);
                        else if (dat.length == 1) {
                            strm.queuedSize -= dat[0];
                            if (strm.ondrain) strm.ondrain(dat[0]);
                        } else {
                            if (dat[1]) w.terminate();
                            strm.ondata.call(strm, err, dat[0], dat[1]);
                        }
                    });
                    w.postMessage(opts);
                    strm.queuedSize = 0;
                    strm.push = function(d, f) {
                        if (!strm.ondata) err(5);
                        if (t) strm.ondata(err(4, 0, 1), null, !!f);
                        strm.queuedSize += d.length;
                        w.postMessage([
                            d,
                            t = f
                        ], [
                            d.buffer
                        ]);
                    };
                    strm.terminate = function() {
                        w.terminate();
                    };
                    if (flush) strm.flush = function() {
                        w.postMessage([]);
                    };
                };
                // read 2 bytes
                var b2 = function(d, b) {
                    return d[b] | d[b + 1] << 8;
                };
                // read 4 bytes
                var b4 = function(d, b) {
                    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
                };
                var b8 = function(d, b) {
                    return b4(d, b) + b4(d, b + 4) * 4294967296;
                };
                // write bytes
                var wbytes = function(d, b, v) {
                    for(; v; ++b)d[b] = v, v >>>= 8;
                };
                // gzip header
                var gzh = function(c, o) {
                    var fn = o.filename;
                    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
                    if (o.mtime != 0) wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
                    if (fn) {
                        c[3] = 8;
                        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
                    }
                };
                // gzip footer: -8 to -4 = CRC, -4 to -0 is length
                // gzip start
                var gzs = function(d) {
                    if (d[0] != 31 || d[1] != 139 || d[2] != 8) err(6, 'invalid gzip data');
                    var flg = d[3];
                    var st = 10;
                    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
                    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
                    return st + (flg & 2);
                };
                // gzip length
                var gzl = function(d) {
                    var l = d.length;
                    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
                };
                // gzip header length
                var gzhl = function(o) {
                    return 10 + (o.filename ? o.filename.length + 1 : 0);
                };
                // zlib header
                var zlh = function(c, o) {
                    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
                    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
                    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
                    if (o.dictionary) {
                        var h = adler();
                        h.p(o.dictionary);
                        wbytes(c, 2, h.d());
                    }
                };
                // zlib start
                var zls = function(d, dict) {
                    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) err(6, 'invalid zlib data');
                    if ((d[1] >> 5 & 1) == +!dict) err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
                    return (d[1] >> 3 & 4) + 2;
                };
                function StrmOpt(opts, cb) {
                    if (typeof opts == 'function') cb = opts, opts = {};
                    this.ondata = cb;
                    return opts;
                }
                /**
 * Streaming DEFLATE compression
 */ var Deflate = /*#__PURE__*/ function() {
                    function Deflate(opts, cb) {
                        if (typeof opts == 'function') cb = opts, opts = {};
                        this.ondata = cb;
                        this.o = opts || {};
                        this.s = {
                            l: 0,
                            i: 32768,
                            w: 32768,
                            z: 32768
                        };
                        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
                        // 98304 = 32768 (lookback) + 65536 (common chunk size)
                        this.b = new u8(98304);
                        if (this.o.dictionary) {
                            var dict = this.o.dictionary.subarray(-32768);
                            this.b.set(dict, 32768 - dict.length);
                            this.s.i = 32768 - dict.length;
                        }
                    }
                    Deflate.prototype.p = function(c, f) {
                        this.ondata(dopt(c, this.o, 0, 0, this.s), f);
                    };
                    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
                        if (!this.ondata) err(5);
                        if (this.s.l) err(4);
                        var endLen = chunk.length + this.s.z;
                        if (endLen > this.b.length) {
                            if (endLen > 2 * this.b.length - 32768) {
                                var newBuf = new u8(endLen & -32768);
                                newBuf.set(this.b.subarray(0, this.s.z));
                                this.b = newBuf;
                            }
                            var split = this.b.length - this.s.z;
                            this.b.set(chunk.subarray(0, split), this.s.z);
                            this.s.z = this.b.length;
                            this.p(this.b, false);
                            this.b.set(this.b.subarray(-32768));
                            this.b.set(chunk.subarray(split), 32768);
                            this.s.z = chunk.length - split + 32768;
                            this.s.i = 32766, this.s.w = 32768;
                        } else {
                            this.b.set(chunk, this.s.z);
                            this.s.z += chunk.length;
                        }
                        this.s.l = final & 1;
                        if (this.s.z > this.s.w + 8191 || final) {
                            this.p(this.b, final || false);
                            this.s.w = this.s.i, this.s.i -= 2;
                        }
                    };
                    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
                        if (!this.ondata) err(5);
                        if (this.s.l) err(4);
                        this.p(this.b, false);
                        this.s.w = this.s.i, this.s.i -= 2;
                    };
                    return Deflate;
                }();
                /**
 * Asynchronous streaming DEFLATE compression
 */ var AsyncDeflate = /*#__PURE__*/ function() {
                    function AsyncDeflate(opts, cb) {
                        astrmify([
                            bDflt,
                            function() {
                                return [
                                    astrm,
                                    Deflate
                                ];
                            }
                        ], this, StrmOpt.call(this, opts, cb), function(ev) {
                            var strm = new Deflate(ev.data);
                            onmessage = astrm(strm);
                        }, 6, 1);
                    }
                    return AsyncDeflate;
                }();
                function deflate(data, opts, cb) {
                    if (!cb) cb = opts, opts = {};
                    if (typeof cb != 'function') err(7);
                    return cbify(data, opts, [
                        bDflt
                    ], function(ev) {
                        return pbf(deflateSync(ev.data[0], ev.data[1]));
                    }, 0, cb);
                }
                /**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */ function deflateSync(data, opts) {
                    return dopt(data, opts || {}, 0, 0);
                }
                /**
 * Streaming DEFLATE decompression
 */ var Inflate = /*#__PURE__*/ function() {
                    function Inflate(opts, cb) {
                        // no StrmOpt here to avoid adding to workerizer
                        if (typeof opts == 'function') cb = opts, opts = {};
                        this.ondata = cb;
                        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
                        this.s = {
                            i: 0,
                            b: dict ? dict.length : 0
                        };
                        this.o = new u8(32768);
                        this.p = new u8(0);
                        if (dict) this.o.set(dict);
                    }
                    Inflate.prototype.e = function(c) {
                        if (!this.ondata) err(5);
                        if (this.d) err(4);
                        if (!this.p.length) this.p = c;
                        else if (c.length) {
                            var n = new u8(this.p.length + c.length);
                            n.set(this.p), n.set(c, this.p.length), this.p = n;
                        }
                    };
                    Inflate.prototype.c = function(final) {
                        this.s.i = +(this.d = final || false);
                        var bts = this.s.b;
                        var dt = inflt(this.p, this.s, this.o);
                        this.ondata(slc(dt, bts, this.s.b), this.d);
                        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
                        this.p = slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
                    };
                    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
                        this.e(chunk), this.c(final);
                    };
                    return Inflate;
                }();
                /**
 * Asynchronous streaming DEFLATE decompression
 */ var AsyncInflate = /*#__PURE__*/ function() {
                    function AsyncInflate(opts, cb) {
                        astrmify([
                            bInflt,
                            function() {
                                return [
                                    astrm,
                                    Inflate
                                ];
                            }
                        ], this, StrmOpt.call(this, opts, cb), function(ev) {
                            var strm = new Inflate(ev.data);
                            onmessage = astrm(strm);
                        }, 7, 0);
                    }
                    return AsyncInflate;
                }();
                function inflate(data, opts, cb) {
                    if (!cb) cb = opts, opts = {};
                    if (typeof cb != 'function') err(7);
                    return cbify(data, opts, [
                        bInflt
                    ], function(ev) {
                        return pbf(inflateSync(ev.data[0], gopt(ev.data[1])));
                    }, 1, cb);
                }
                /**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ function inflateSync(data, opts) {
                    return inflt(data, {
                        i: 2
                    }, opts && opts.out, opts && opts.dictionary);
                }
                // before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
                /**
 * Streaming GZIP compression
 */ var Gzip = /*#__PURE__*/ function() {
                    function Gzip(opts, cb) {
                        this.c = crc();
                        this.l = 0;
                        this.v = 1;
                        Deflate.call(this, opts, cb);
                    }
                    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
                        this.c.p(chunk);
                        this.l += chunk.length;
                        Deflate.prototype.push.call(this, chunk, final);
                    };
                    Gzip.prototype.p = function(c, f) {
                        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, this.s);
                        if (this.v) gzh(raw, this.o), this.v = 0;
                        if (f) wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
                        this.ondata(raw, f);
                    };
                    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
                        Deflate.prototype.flush.call(this);
                    };
                    return Gzip;
                }();
                /**
 * Asynchronous streaming GZIP compression
 */ var AsyncGzip = /*#__PURE__*/ function() {
                    function AsyncGzip(opts, cb) {
                        astrmify([
                            bDflt,
                            gze,
                            function() {
                                return [
                                    astrm,
                                    Deflate,
                                    Gzip
                                ];
                            }
                        ], this, StrmOpt.call(this, opts, cb), function(ev) {
                            var strm = new Gzip(ev.data);
                            onmessage = astrm(strm);
                        }, 8, 1);
                    }
                    return AsyncGzip;
                }();
                function gzip(data, opts, cb) {
                    if (!cb) cb = opts, opts = {};
                    if (typeof cb != 'function') err(7);
                    return cbify(data, opts, [
                        bDflt,
                        gze,
                        function() {
                            return [
                                gzipSync
                            ];
                        }
                    ], function(ev) {
                        return pbf(gzipSync(ev.data[0], ev.data[1]));
                    }, 2, cb);
                }
                /**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */ function gzipSync(data, opts) {
                    if (!opts) opts = {};
                    var c = crc(), l = data.length;
                    c.p(data);
                    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
                    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
                }
                /**
 * Streaming single or multi-member GZIP decompression
 */ var Gunzip = /*#__PURE__*/ function() {
                    function Gunzip(opts, cb) {
                        this.v = 1;
                        this.r = 0;
                        Inflate.call(this, opts, cb);
                    }
                    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
                        Inflate.prototype.e.call(this, chunk);
                        this.r += chunk.length;
                        if (this.v) {
                            var p = this.p.subarray(this.v - 1);
                            var s = p.length > 3 ? gzs(p) : 4;
                            if (s > p.length) {
                                if (!final) return;
                            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
                            this.p = p.subarray(s), this.v = 0;
                        }
                        // necessary to prevent TS from using the closure value
                        // This allows for workerization to function correctly
                        Inflate.prototype.c.call(this, final);
                        // process concatenated GZIP
                        if (this.s.f && !this.s.l && !final) {
                            this.v = shft(this.s.p) + 9;
                            this.s = {
                                i: 0
                            };
                            this.o = new u8(0);
                            this.push(new u8(0), final);
                        }
                    };
                    return Gunzip;
                }();
                /**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var AsyncGunzip = /*#__PURE__*/ function() {
                    function AsyncGunzip(opts, cb) {
                        var _this = this;
                        astrmify([
                            bInflt,
                            guze,
                            function() {
                                return [
                                    astrm,
                                    Inflate,
                                    Gunzip
                                ];
                            }
                        ], this, StrmOpt.call(this, opts, cb), function(ev) {
                            var strm = new Gunzip(ev.data);
                            strm.onmember = function(offset) {
                                return postMessage(offset);
                            };
                            onmessage = astrm(strm);
                        }, 9, 0, function(offset) {
                            return _this.onmember && _this.onmember(offset);
                        });
                    }
                    return AsyncGunzip;
                }();
                function gunzip(data, opts, cb) {
                    if (!cb) cb = opts, opts = {};
                    if (typeof cb != 'function') err(7);
                    return cbify(data, opts, [
                        bInflt,
                        guze,
                        function() {
                            return [
                                gunzipSync
                            ];
                        }
                    ], function(ev) {
                        return pbf(gunzipSync(ev.data[0], ev.data[1]));
                    }, 3, cb);
                }
                /**
 * Expands GZIP data
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ function gunzipSync(data, opts) {
                    var st = gzs(data);
                    if (st + 8 > data.length) err(6, 'invalid gzip data');
                    return inflt(data.subarray(st, -8), {
                        i: 2
                    }, opts && opts.out || new u8(gzl(data)), opts && opts.dictionary);
                }
                /**
 * Streaming Zlib compression
 */ var Zlib = /*#__PURE__*/ function() {
                    function Zlib(opts, cb) {
                        this.c = adler();
                        this.v = 1;
                        Deflate.call(this, opts, cb);
                    }
                    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
                        this.c.p(chunk);
                        Deflate.prototype.push.call(this, chunk, final);
                    };
                    Zlib.prototype.p = function(c, f) {
                        var raw = dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
                        if (this.v) zlh(raw, this.o), this.v = 0;
                        if (f) wbytes(raw, raw.length - 4, this.c.d());
                        this.ondata(raw, f);
                    };
                    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
                        Deflate.prototype.flush.call(this);
                    };
                    return Zlib;
                }();
                /**
 * Asynchronous streaming Zlib compression
 */ var AsyncZlib = /*#__PURE__*/ function() {
                    function AsyncZlib(opts, cb) {
                        astrmify([
                            bDflt,
                            zle,
                            function() {
                                return [
                                    astrm,
                                    Deflate,
                                    Zlib
                                ];
                            }
                        ], this, StrmOpt.call(this, opts, cb), function(ev) {
                            var strm = new Zlib(ev.data);
                            onmessage = astrm(strm);
                        }, 10, 1);
                    }
                    return AsyncZlib;
                }();
                function zlib(data, opts, cb) {
                    if (!cb) cb = opts, opts = {};
                    if (typeof cb != 'function') err(7);
                    return cbify(data, opts, [
                        bDflt,
                        zle,
                        function() {
                            return [
                                zlibSync
                            ];
                        }
                    ], function(ev) {
                        return pbf(zlibSync(ev.data[0], ev.data[1]));
                    }, 4, cb);
                }
                /**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */ function zlibSync(data, opts) {
                    if (!opts) opts = {};
                    var a = adler();
                    a.p(data);
                    var d = dopt(data, opts, opts.dictionary ? 6 : 2, 4);
                    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
                }
                /**
 * Streaming Zlib decompression
 */ var Unzlib = /*#__PURE__*/ function() {
                    function Unzlib(opts, cb) {
                        Inflate.call(this, opts, cb);
                        this.v = opts && opts.dictionary ? 2 : 1;
                    }
                    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
                        Inflate.prototype.e.call(this, chunk);
                        if (this.v) {
                            if (this.p.length < 6 && !final) return;
                            this.p = this.p.subarray(zls(this.p, this.v - 1)), this.v = 0;
                        }
                        if (final) {
                            if (this.p.length < 4) err(6, 'invalid zlib data');
                            this.p = this.p.subarray(0, -4);
                        }
                        // necessary to prevent TS from using the closure value
                        // This allows for workerization to function correctly
                        Inflate.prototype.c.call(this, final);
                    };
                    return Unzlib;
                }();
                /**
 * Asynchronous streaming Zlib decompression
 */ var AsyncUnzlib = /*#__PURE__*/ function() {
                    function AsyncUnzlib(opts, cb) {
                        astrmify([
                            bInflt,
                            zule,
                            function() {
                                return [
                                    astrm,
                                    Inflate,
                                    Unzlib
                                ];
                            }
                        ], this, StrmOpt.call(this, opts, cb), function(ev) {
                            var strm = new Unzlib(ev.data);
                            onmessage = astrm(strm);
                        }, 11, 0);
                    }
                    return AsyncUnzlib;
                }();
                function unzlib(data, opts, cb) {
                    if (!cb) cb = opts, opts = {};
                    if (typeof cb != 'function') err(7);
                    return cbify(data, opts, [
                        bInflt,
                        zule,
                        function() {
                            return [
                                unzlibSync
                            ];
                        }
                    ], function(ev) {
                        return pbf(unzlibSync(ev.data[0], gopt(ev.data[1])));
                    }, 5, cb);
                }
                /**
 * Expands Zlib data
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ function unzlibSync(data, opts) {
                    return inflt(data.subarray(zls(data, opts && opts.dictionary), -4), {
                        i: 2
                    }, opts && opts.out, opts && opts.dictionary);
                }
                // Default algorithm for compression (used because having a known output size allows faster decompression)
                /**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var Decompress = /*#__PURE__*/ function() {
                    function Decompress(opts, cb) {
                        this.o = StrmOpt.call(this, opts, cb) || {};
                        this.G = Gunzip;
                        this.I = Inflate;
                        this.Z = Unzlib;
                    }
                    // init substream
                    // overriden by AsyncDecompress
                    Decompress.prototype.i = function() {
                        var _this = this;
                        this.s.ondata = function(dat, final) {
                            _this.ondata(dat, final);
                        };
                    };
                    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
                        if (!this.ondata) err(5);
                        if (!this.s) {
                            if (this.p && this.p.length) {
                                var n = new u8(this.p.length + chunk.length);
                                n.set(this.p), n.set(chunk, this.p.length);
                            } else this.p = chunk;
                            if (this.p.length > 2) {
                                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                                this.i();
                                this.s.push(this.p, final);
                                this.p = null;
                            }
                        } else this.s.push(chunk, final);
                    };
                    return Decompress;
                }();
                /**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var AsyncDecompress = /*#__PURE__*/ function() {
                    function AsyncDecompress(opts, cb) {
                        Decompress.call(this, opts, cb);
                        this.queuedSize = 0;
                        this.G = AsyncGunzip;
                        this.I = AsyncInflate;
                        this.Z = AsyncUnzlib;
                    }
                    AsyncDecompress.prototype.i = function() {
                        var _this = this;
                        this.s.ondata = function(err, dat, final) {
                            _this.ondata(err, dat, final);
                        };
                        this.s.ondrain = function(size) {
                            _this.queuedSize -= size;
                            if (_this.ondrain) _this.ondrain(size);
                        };
                    };
                    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
                        this.queuedSize += chunk.length;
                        Decompress.prototype.push.call(this, chunk, final);
                    };
                    return AsyncDecompress;
                }();
                function decompress(data, opts, cb) {
                    if (!cb) cb = opts, opts = {};
                    if (typeof cb != 'function') err(7);
                    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzip(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflate(data, opts, cb) : unzlib(data, opts, cb);
                }
                /**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ function decompressSync(data, opts) {
                    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzipSync(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflateSync(data, opts) : unzlibSync(data, opts);
                }
                // flatten a directory structure
                var fltn = function(d, p, t, o) {
                    for(var k in d){
                        var val = d[k], n = p + k, op = o;
                        if (Array.isArray(val)) op = mrg(o, val[1]), val = val[0];
                        if (val instanceof u8) t[n] = [
                            val,
                            op
                        ];
                        else {
                            t[n += '/'] = [
                                new u8(0),
                                op
                            ];
                            fltn(val, n, t, o);
                        }
                    }
                };
                // text encoder
                var te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
                // text decoder
                var td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
                // text decoder stream
                var tds = 0;
                try {
                    td.decode(et, {
                        stream: true
                    });
                    tds = 1;
                } catch (e) {}
                // decode UTF8
                var dutf8 = function(d) {
                    for(var r = '', i = 0;;){
                        var c = d[i++];
                        var eb = (c > 127) + (c > 223) + (c > 239);
                        if (i + eb > d.length) return {
                            s: r,
                            r: slc(d, i - 1)
                        };
                        if (!eb) r += String.fromCharCode(c);
                        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
                        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
                        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
                    }
                };
                /**
 * Streaming UTF-8 decoding
 */ var DecodeUTF8 = /*#__PURE__*/ function() {
                    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
                        this.ondata = cb;
                        if (tds) this.t = new TextDecoder();
                        else this.p = et;
                    }
                    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
                        if (!this.ondata) err(5);
                        final = !!final;
                        if (this.t) {
                            this.ondata(this.t.decode(chunk, {
                                stream: true
                            }), final);
                            if (final) {
                                if (this.t.decode().length) err(8);
                                this.t = null;
                            }
                            return;
                        }
                        if (!this.p) err(4);
                        var dat = new u8(this.p.length + chunk.length);
                        dat.set(this.p);
                        dat.set(chunk, this.p.length);
                        var _a = dutf8(dat), s = _a.s, r = _a.r;
                        if (final) {
                            if (r.length) err(8);
                            this.p = null;
                        } else this.p = r;
                        this.ondata(s, final);
                    };
                    return DecodeUTF8;
                }();
                /**
 * Streaming UTF-8 encoding
 */ var EncodeUTF8 = /*#__PURE__*/ function() {
                    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
                        this.ondata = cb;
                    }
                    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
                        if (!this.ondata) err(5);
                        if (this.d) err(4);
                        this.ondata(strToU8(chunk), this.d = final || false);
                    };
                    return EncodeUTF8;
                }();
                /**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */ function strToU8(str, latin1) {
                    if (latin1) {
                        var ar_1 = new u8(str.length);
                        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
                        return ar_1;
                    }
                    if (te) return te.encode(str);
                    var l = str.length;
                    var ar = new u8(str.length + (str.length >> 1));
                    var ai = 0;
                    var w = function(v) {
                        ar[ai++] = v;
                    };
                    for(var i = 0; i < l; ++i){
                        if (ai + 5 > ar.length) {
                            var n = new u8(ai + 8 + (l - i << 1));
                            n.set(ar);
                            ar = n;
                        }
                        var c = str.charCodeAt(i);
                        if (c < 128 || latin1) w(c);
                        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
                        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
                        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
                    }
                    return slc(ar, 0, ai);
                }
                /**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */ function strFromU8(dat, latin1) {
                    if (latin1) {
                        var r = '';
                        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
                        return r;
                    } else if (td) return td.decode(dat);
                    else {
                        var _a = dutf8(dat), s = _a.s, r = _a.r;
                        if (r.length) err(8);
                        return s;
                    }
                }
                // deflate bit flag
                var dbf = function(l) {
                    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
                };
                // skip local zip header
                var slzh = function(d, b) {
                    return b + 30 + b2(d, b + 26) + b2(d, b + 28);
                };
                // read zip header
                var zh = function(d, b, z) {
                    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
                    var _a = z && bs == 4294967295 ? z64e(d, es) : [
                        bs,
                        b4(d, b + 24),
                        b4(d, b + 42)
                    ], sc = _a[0], su = _a[1], off = _a[2];
                    return [
                        b2(d, b + 10),
                        sc,
                        su,
                        fn,
                        es + b2(d, b + 30) + b2(d, b + 32),
                        off
                    ];
                };
                // read zip64 extra field
                var z64e = function(d, b) {
                    for(; b2(d, b) != 1; b += 4 + b2(d, b + 2));
                    return [
                        b8(d, b + 12),
                        b8(d, b + 4),
                        b8(d, b + 20)
                    ];
                };
                // extra field length
                var exfl = function(ex) {
                    var le = 0;
                    if (ex) for(var k in ex){
                        var l = ex[k].length;
                        if (l > 65535) err(9);
                        le += l + 4;
                    }
                    return le;
                };
                // write zip header
                var wzh = function(d, b, f, fn, u, c, ce, co) {
                    var fl = fn.length, ex = f.extra, col = co && co.length;
                    var exl = exfl(ex);
                    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
                    if (ce != null) d[b++] = 20, d[b++] = f.os;
                    d[b] = 20, b += 2; // spec compliance? what's that?
                    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
                    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
                    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
                    if (y < 0 || y > 119) err(10);
                    wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
                    if (c != -1) {
                        wbytes(d, b, f.crc);
                        wbytes(d, b + 4, c < 0 ? -c - 2 : c);
                        wbytes(d, b + 8, f.size);
                    }
                    wbytes(d, b + 12, fl);
                    wbytes(d, b + 14, exl), b += 16;
                    if (ce != null) {
                        wbytes(d, b, col);
                        wbytes(d, b + 6, f.attrs);
                        wbytes(d, b + 10, ce), b += 14;
                    }
                    d.set(fn, b);
                    b += fl;
                    if (exl) for(var k in ex){
                        var exf = ex[k], l = exf.length;
                        wbytes(d, b, +k);
                        wbytes(d, b + 2, l);
                        d.set(exf, b + 4), b += 4 + l;
                    }
                    if (col) d.set(co, b), b += col;
                    return b;
                };
                // write zip footer (end of central directory)
                var wzf = function(o, b, c, d, e) {
                    wbytes(o, b, 0x6054B50); // skip disk
                    wbytes(o, b + 8, c);
                    wbytes(o, b + 10, c);
                    wbytes(o, b + 12, d);
                    wbytes(o, b + 16, e);
                };
                /**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var ZipPassThrough = /*#__PURE__*/ function() {
                    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
                        this.filename = filename;
                        this.c = crc();
                        this.size = 0;
                        this.compression = 0;
                    }
                    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
                        this.ondata(null, chunk, final);
                    };
                    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
                        if (!this.ondata) err(5);
                        this.c.p(chunk);
                        this.size += chunk.length;
                        if (final) this.crc = this.c.d();
                        this.process(chunk, final || false);
                    };
                    return ZipPassThrough;
                }();
                // I don't extend because TypeScript extension adds 1kB of runtime bloat
                /**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var ZipDeflate = /*#__PURE__*/ function() {
                    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
                        var _this = this;
                        if (!opts) opts = {};
                        ZipPassThrough.call(this, filename);
                        this.d = new Deflate(opts, function(dat, final) {
                            _this.ondata(null, dat, final);
                        });
                        this.compression = 8;
                        this.flag = dbf(opts.level);
                    }
                    ZipDeflate.prototype.process = function(chunk, final) {
                        try {
                            this.d.push(chunk, final);
                        } catch (e) {
                            this.ondata(e, null, final);
                        }
                    };
                    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
                        ZipPassThrough.prototype.push.call(this, chunk, final);
                    };
                    return ZipDeflate;
                }();
                /**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var AsyncZipDeflate = /*#__PURE__*/ function() {
                    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
                        var _this = this;
                        if (!opts) opts = {};
                        ZipPassThrough.call(this, filename);
                        this.d = new AsyncDeflate(opts, function(err, dat, final) {
                            _this.ondata(err, dat, final);
                        });
                        this.compression = 8;
                        this.flag = dbf(opts.level);
                        this.terminate = this.d.terminate;
                    }
                    AsyncZipDeflate.prototype.process = function(chunk, final) {
                        this.d.push(chunk, final);
                    };
                    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
                        ZipPassThrough.prototype.push.call(this, chunk, final);
                    };
                    return AsyncZipDeflate;
                }();
                // TODO: Better tree shaking
                /**
 * A zippable archive to which files can incrementally be added
 */ var Zip = /*#__PURE__*/ function() {
                    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
                        this.ondata = cb;
                        this.u = [];
                        this.d = 1;
                    }
                    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
                        var _this = this;
                        if (!this.ondata) err(5);
                        // finishing or finished
                        if (this.d & 2) this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, false);
                        else {
                            var f = strToU8(file.filename), fl_1 = f.length;
                            var com = file.comment, o = com && strToU8(com);
                            var u = fl_1 != file.filename.length || o && com.length != o.length;
                            var hl_1 = fl_1 + exfl(file.extra) + 30;
                            if (fl_1 > 65535) this.ondata(err(11, 0, 1), null, false);
                            var header = new u8(hl_1);
                            wzh(header, 0, file, f, u, -1);
                            var chks_1 = [
                                header
                            ];
                            var pAll_1 = function() {
                                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                                    var chk = chks_2[_i];
                                    _this.ondata(null, chk, false);
                                }
                                chks_1 = [];
                            };
                            var tr_1 = this.d;
                            this.d = 0;
                            var ind_1 = this.u.length;
                            var uf_1 = mrg(file, {
                                f: f,
                                u: u,
                                o: o,
                                t: function() {
                                    if (file.terminate) file.terminate();
                                },
                                r: function() {
                                    pAll_1();
                                    if (tr_1) {
                                        var nxt = _this.u[ind_1 + 1];
                                        if (nxt) nxt.r();
                                        else _this.d = 1;
                                    }
                                    tr_1 = 1;
                                }
                            });
                            var cl_1 = 0;
                            file.ondata = function(err, dat, final) {
                                if (err) {
                                    _this.ondata(err, dat, final);
                                    _this.terminate();
                                } else {
                                    cl_1 += dat.length;
                                    chks_1.push(dat);
                                    if (final) {
                                        var dd = new u8(16);
                                        wbytes(dd, 0, 0x8074B50);
                                        wbytes(dd, 4, file.crc);
                                        wbytes(dd, 8, cl_1);
                                        wbytes(dd, 12, file.size);
                                        chks_1.push(dd);
                                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                                        if (tr_1) uf_1.r();
                                        tr_1 = 1;
                                    } else if (tr_1) pAll_1();
                                }
                            };
                            this.u.push(uf_1);
                        }
                    };
                    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
                        var _this = this;
                        if (this.d & 2) {
                            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, true);
                            return;
                        }
                        if (this.d) this.e();
                        else this.u.push({
                            r: function() {
                                if (!(_this.d & 1)) return;
                                _this.u.splice(-1, 1);
                                _this.e();
                            },
                            t: function() {}
                        });
                        this.d = 3;
                    };
                    Zip.prototype.e = function() {
                        var bt = 0, l = 0, tl = 0;
                        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
                            var f = _a[_i];
                            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
                        }
                        var out = new u8(tl + 22);
                        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
                            var f = _c[_b];
                            wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
                            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
                        }
                        wzf(out, bt, this.u.length, tl, l);
                        this.ondata(null, out, true);
                        this.d = 2;
                    };
                    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
                        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
                            var f = _a[_i];
                            f.t();
                        }
                        this.d = 2;
                    };
                    return Zip;
                }();
                function zip(data, opts, cb) {
                    if (!cb) cb = opts, opts = {};
                    if (typeof cb != 'function') err(7);
                    var r = {};
                    fltn(data, '', r, opts);
                    var k = Object.keys(r);
                    var lft = k.length, o = 0, tot = 0;
                    var slft = lft, files = new Array(lft);
                    var term = [];
                    var tAll = function() {
                        for(var i = 0; i < term.length; ++i)term[i]();
                    };
                    var cbd = function(a, b) {
                        mt(function() {
                            cb(a, b);
                        });
                    };
                    mt(function() {
                        cbd = cb;
                    });
                    var cbf = function() {
                        var out = new u8(tot + 22), oe = o, cdl = tot - o;
                        tot = 0;
                        for(var i = 0; i < slft; ++i){
                            var f = files[i];
                            try {
                                var l = f.c.length;
                                wzh(out, tot, f, f.f, f.u, l);
                                var badd = 30 + f.f.length + exfl(f.extra);
                                var loc = tot + badd;
                                out.set(f.c, loc);
                                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
                            } catch (e) {
                                return cbd(e, null);
                            }
                        }
                        wzf(out, o, files.length, cdl, oe);
                        cbd(null, out);
                    };
                    if (!lft) cbf();
                    var _loop_1 = function(i) {
                        var fn = k[i];
                        var _a = r[fn], file = _a[0], p = _a[1];
                        var c = crc(), size = file.length;
                        c.p(file);
                        var f = strToU8(fn), s = f.length;
                        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
                        var exl = exfl(p.extra);
                        var compression = p.level == 0 ? 0 : 8;
                        var cbl = function(e, d) {
                            if (e) {
                                tAll();
                                cbd(e, null);
                            } else {
                                var l = d.length;
                                files[i] = mrg(p, {
                                    size: size,
                                    crc: c.d(),
                                    c: d,
                                    f: f,
                                    m: m,
                                    u: s != fn.length || m && com.length != ms,
                                    compression: compression
                                });
                                o += 30 + s + exl + l;
                                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                                if (!--lft) cbf();
                            }
                        };
                        if (s > 65535) cbl(err(11, 0, 1), null);
                        if (!compression) cbl(null, file);
                        else if (size < 160000) try {
                            cbl(null, deflateSync(file, p));
                        } catch (e) {
                            cbl(e, null);
                        }
                        else term.push(deflate(file, p, cbl));
                    };
                    // Cannot use lft because it can decrease
                    for(var i = 0; i < slft; ++i)_loop_1(i);
                    return tAll;
                }
                /**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */ function zipSync(data, opts) {
                    if (!opts) opts = {};
                    var r = {};
                    var files = [];
                    fltn(data, '', r, opts);
                    var o = 0;
                    var tot = 0;
                    for(var fn in r){
                        var _a = r[fn], file = _a[0], p = _a[1];
                        var compression = p.level == 0 ? 0 : 8;
                        var f = strToU8(fn), s = f.length;
                        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
                        var exl = exfl(p.extra);
                        if (s > 65535) err(11);
                        var d = compression ? deflateSync(file, p) : file, l = d.length;
                        var c = crc();
                        c.p(file);
                        files.push(mrg(p, {
                            size: file.length,
                            crc: c.d(),
                            c: d,
                            f: f,
                            m: m,
                            u: s != fn.length || m && com.length != ms,
                            o: o,
                            compression: compression
                        }));
                        o += 30 + s + exl + l;
                        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                    }
                    var out = new u8(tot + 22), oe = o, cdl = tot - o;
                    for(var i = 0; i < files.length; ++i){
                        var f = files[i];
                        wzh(out, f.o, f, f.f, f.u, f.c.length);
                        var badd = 30 + f.f.length + exfl(f.extra);
                        out.set(f.c, f.o + badd);
                        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
                    }
                    wzf(out, o, files.length, cdl, oe);
                    return out;
                }
                /**
 * Streaming pass-through decompression for ZIP archives
 */ var UnzipPassThrough = /*#__PURE__*/ function() {
                    function UnzipPassThrough() {}
                    UnzipPassThrough.prototype.push = function(data, final) {
                        this.ondata(null, data, final);
                    };
                    UnzipPassThrough.compression = 0;
                    return UnzipPassThrough;
                }();
                /**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var UnzipInflate = /*#__PURE__*/ function() {
                    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
                        var _this = this;
                        this.i = new Inflate(function(dat, final) {
                            _this.ondata(null, dat, final);
                        });
                    }
                    UnzipInflate.prototype.push = function(data, final) {
                        try {
                            this.i.push(data, final);
                        } catch (e) {
                            this.ondata(e, null, final);
                        }
                    };
                    UnzipInflate.compression = 8;
                    return UnzipInflate;
                }();
                /**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var AsyncUnzipInflate = /*#__PURE__*/ function() {
                    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
                        var _this = this;
                        if (sz < 320000) this.i = new Inflate(function(dat, final) {
                            _this.ondata(null, dat, final);
                        });
                        else {
                            this.i = new AsyncInflate(function(err, dat, final) {
                                _this.ondata(err, dat, final);
                            });
                            this.terminate = this.i.terminate;
                        }
                    }
                    AsyncUnzipInflate.prototype.push = function(data, final) {
                        if (this.i.terminate) data = slc(data, 0);
                        this.i.push(data, final);
                    };
                    AsyncUnzipInflate.compression = 8;
                    return AsyncUnzipInflate;
                }();
                /**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var Unzip = /*#__PURE__*/ function() {
                    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
                        this.onfile = cb;
                        this.k = [];
                        this.o = {
                            0: UnzipPassThrough
                        };
                        this.p = et;
                    }
                    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
                        var _this = this;
                        if (!this.onfile) err(5);
                        if (!this.p) err(4);
                        if (this.c > 0) {
                            var len = Math.min(this.c, chunk.length);
                            var toAdd = chunk.subarray(0, len);
                            this.c -= len;
                            if (this.d) this.d.push(toAdd, !this.c);
                            else this.k[0].push(toAdd);
                            chunk = chunk.subarray(len);
                            if (chunk.length) return this.push(chunk, final);
                        } else {
                            var f = 0, i = 0, is = void 0, buf = void 0;
                            if (!this.p.length) buf = chunk;
                            else if (!chunk.length) buf = this.p;
                            else {
                                buf = new u8(this.p.length + chunk.length);
                                buf.set(this.p), buf.set(chunk, this.p.length);
                            }
                            var l = buf.length, oc = this.c, add = oc && this.d;
                            var _loop_2 = function() {
                                var _a;
                                var sig = b4(buf, i);
                                if (sig == 0x4034B50) {
                                    f = 1, is = i;
                                    this_1.d = null;
                                    this_1.c = 0;
                                    var bf = b2(buf, i + 6), cmp_1 = b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = b2(buf, i + 26), es = b2(buf, i + 28);
                                    if (l > i + 30 + fnl + es) {
                                        var chks_3 = [];
                                        this_1.k.unshift(chks_3);
                                        f = 2;
                                        var sc_1 = b4(buf, i + 18), su_1 = b4(buf, i + 22);
                                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                                        if (sc_1 == 4294967295) _a = dd ? [
                                            -2
                                        ] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                                        else if (dd) sc_1 = -1;
                                        i += es;
                                        this_1.c = sc_1;
                                        var d_1;
                                        var file_1 = {
                                            name: fn_1,
                                            compression: cmp_1,
                                            start: function() {
                                                if (!file_1.ondata) err(5);
                                                if (!sc_1) file_1.ondata(null, et, true);
                                                else {
                                                    var ctr = _this.o[cmp_1];
                                                    if (!ctr) file_1.ondata(err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                                    d_1.ondata = function(err, dat, final) {
                                                        file_1.ondata(err, dat, final);
                                                    };
                                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                                        var dat = chks_4[_i];
                                                        d_1.push(dat, false);
                                                    }
                                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                                    else d_1.push(et, true);
                                                }
                                            },
                                            terminate: function() {
                                                if (d_1 && d_1.terminate) d_1.terminate();
                                            }
                                        };
                                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                                        this_1.onfile(file_1);
                                    }
                                    return "break";
                                } else if (oc) {
                                    if (sig == 0x8074B50) {
                                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                                        return "break";
                                    } else if (sig == 0x2014B50) {
                                        is = i -= 4, f = 3, this_1.c = 0;
                                        return "break";
                                    }
                                }
                            };
                            var this_1 = this;
                            for(; i < l - 4; ++i){
                                var state_1 = _loop_2();
                                if (state_1 === "break") break;
                            }
                            this.p = et;
                            if (oc < 0) {
                                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                                if (add) add.push(dat, !!f);
                                else this.k[+(f == 2)].push(dat);
                            }
                            if (f & 2) return this.push(buf.subarray(i), final);
                            this.p = buf.subarray(i);
                        }
                        if (final) {
                            if (this.c) err(13);
                            this.p = null;
                        }
                    };
                    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
                        this.o[decoder.compression] = decoder;
                    };
                    return Unzip;
                }();
                var mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
                    fn();
                };
                function unzip(data, opts, cb) {
                    if (!cb) cb = opts, opts = {};
                    if (typeof cb != 'function') err(7);
                    var term = [];
                    var tAll = function() {
                        for(var i = 0; i < term.length; ++i)term[i]();
                    };
                    var files = {};
                    var cbd = function(a, b) {
                        mt(function() {
                            cb(a, b);
                        });
                    };
                    mt(function() {
                        cbd = cb;
                    });
                    var e = data.length - 22;
                    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
                        cbd(err(13, 0, 1), null);
                        return tAll;
                    }
                    var lft = b2(data, e + 8);
                    if (lft) {
                        var c = lft;
                        var o = b4(data, e + 16);
                        var z = o == 4294967295 || c == 65535;
                        if (z) {
                            var ze = b4(data, e - 12);
                            z = b4(data, ze) == 0x6064B50;
                            if (z) {
                                c = lft = b4(data, ze + 32);
                                o = b4(data, ze + 48);
                            }
                        }
                        var fltr = opts && opts.filter;
                        var _loop_3 = function(i) {
                            var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
                            o = no;
                            var cbl = function(e, d) {
                                if (e) {
                                    tAll();
                                    cbd(e, null);
                                } else {
                                    if (d) files[fn] = d;
                                    if (!--lft) cbd(null, files);
                                }
                            };
                            if (!fltr || fltr({
                                name: fn,
                                size: sc,
                                originalSize: su,
                                compression: c_1
                            })) {
                                if (!c_1) cbl(null, slc(data, b, b + sc));
                                else if (c_1 == 8) {
                                    var infl = data.subarray(b, b + sc);
                                    // Synchronously decompress under 512KB, or barely-compressed data
                                    if (su < 524288 || sc > 0.8 * su) try {
                                        cbl(null, inflateSync(infl, {
                                            out: new u8(su)
                                        }));
                                    } catch (e) {
                                        cbl(e, null);
                                    }
                                    else term.push(inflate(infl, {
                                        size: su
                                    }, cbl));
                                } else cbl(err(14, 'unknown compression type ' + c_1, 1), null);
                            } else cbl(null, null);
                        };
                        for(var i = 0; i < c; ++i)_loop_3(i);
                    } else cbd(null, {});
                    return tAll;
                }
                /**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @param opts The ZIP extraction options
 * @returns The decompressed files
 */ function unzipSync(data, opts) {
                    var files = {};
                    var e = data.length - 22;
                    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) err(13);
                    var c = b2(data, e + 8);
                    if (!c) return {};
                    var o = b4(data, e + 16);
                    var z = o == 4294967295 || c == 65535;
                    if (z) {
                        var ze = b4(data, e - 12);
                        z = b4(data, ze) == 0x6064B50;
                        if (z) {
                            c = b4(data, ze + 32);
                            o = b4(data, ze + 48);
                        }
                    }
                    var fltr = opts && opts.filter;
                    for(var i = 0; i < c; ++i){
                        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
                        o = no;
                        if (!fltr || fltr({
                            name: fn,
                            size: sc,
                            originalSize: su,
                            compression: c_2
                        })) {
                            if (!c_2) files[fn] = slc(data, b, b + sc);
                            else if (c_2 == 8) files[fn] = inflateSync(data.subarray(b, b + sc), {
                                out: new u8(su)
                            });
                            else err(14, 'unknown compression type ' + c_2);
                        }
                    }
                    return files;
                }
            /***/ },
            /***/ "./node_modules/iobuffer/lib-esm/IOBuffer.js": /*!***************************************************!*\
  !*** ./node_modules/iobuffer/lib-esm/IOBuffer.js ***!
  \***************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ IOBuffer: function() {
                        return /* binding */ IOBuffer;
                    }
                });
                /* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./text */ "./node_modules/iobuffer/lib-esm/text.js");
                const defaultByteLength = 8192;
                const hostBigEndian = (()=>{
                    const array = new Uint8Array(4);
                    const view = new Uint32Array(array.buffer);
                    return !((view[0] = 1) & array[0]);
                })();
                const typedArrays = {
                    int8: globalThis.Int8Array,
                    uint8: globalThis.Uint8Array,
                    int16: globalThis.Int16Array,
                    uint16: globalThis.Uint16Array,
                    int32: globalThis.Int32Array,
                    uint32: globalThis.Uint32Array,
                    uint64: globalThis.BigUint64Array,
                    int64: globalThis.BigInt64Array,
                    float32: globalThis.Float32Array,
                    float64: globalThis.Float64Array
                };
                class IOBuffer {
                    /**
     * Reference to the internal ArrayBuffer object.
     */ buffer;
                    /**
     * Byte length of the internal ArrayBuffer.
     */ byteLength;
                    /**
     * Byte offset of the internal ArrayBuffer.
     */ byteOffset;
                    /**
     * Byte length of the internal ArrayBuffer.
     */ length;
                    /**
     * The current offset of the buffer's pointer.
     */ offset;
                    lastWrittenByte;
                    littleEndian;
                    _data;
                    _mark;
                    _marks;
                    /**
     * Create a new IOBuffer.
     * @param data - The data to construct the IOBuffer with.
     * If data is a number, it will be the new buffer's length<br>
     * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
     * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
     * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
     * @param options - An object for the options.
     * @returns A new IOBuffer instance.
     */ constructor(data = defaultByteLength, options = {}){
                        let dataIsGiven = false;
                        if (typeof data === 'number') data = new ArrayBuffer(data);
                        else {
                            dataIsGiven = true;
                            this.lastWrittenByte = data.byteLength;
                        }
                        const offset = options.offset ? options.offset >>> 0 : 0;
                        const byteLength = data.byteLength - offset;
                        let dvOffset = offset;
                        if (ArrayBuffer.isView(data) || data instanceof IOBuffer) {
                            if (data.byteLength !== data.buffer.byteLength) dvOffset = data.byteOffset + offset;
                            data = data.buffer;
                        }
                        if (dataIsGiven) this.lastWrittenByte = byteLength;
                        else this.lastWrittenByte = 0;
                        this.buffer = data;
                        this.length = byteLength;
                        this.byteLength = byteLength;
                        this.byteOffset = dvOffset;
                        this.offset = 0;
                        this.littleEndian = true;
                        this._data = new DataView(this.buffer, dvOffset, byteLength);
                        this._mark = 0;
                        this._marks = [];
                    }
                    /**
     * Checks if the memory allocated to the buffer is sufficient to store more
     * bytes after the offset.
     * @param byteLength - The needed memory in bytes.
     * @returns `true` if there is sufficient space and `false` otherwise.
     */ available(byteLength = 1) {
                        return this.offset + byteLength <= this.length;
                    }
                    /**
     * Check if little-endian mode is used for reading and writing multi-byte
     * values.
     * @returns `true` if little-endian mode is used, `false` otherwise.
     */ isLittleEndian() {
                        return this.littleEndian;
                    }
                    /**
     * Set little-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setLittleEndian() {
                        this.littleEndian = true;
                        return this;
                    }
                    /**
     * Check if big-endian mode is used for reading and writing multi-byte values.
     * @returns `true` if big-endian mode is used, `false` otherwise.
     */ isBigEndian() {
                        return !this.littleEndian;
                    }
                    /**
     * Switches to big-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setBigEndian() {
                        this.littleEndian = false;
                        return this;
                    }
                    /**
     * Move the pointer n bytes forward.
     * @param n - Number of bytes to skip.
     * @returns This.
     */ skip(n = 1) {
                        this.offset += n;
                        return this;
                    }
                    /**
     * Move the pointer n bytes backward.
     * @param n - Number of bytes to move back.
     * @returns This.
     */ back(n = 1) {
                        this.offset -= n;
                        return this;
                    }
                    /**
     * Move the pointer to the given offset.
     * @param offset - The offset to move to.
     * @returns This.
     */ seek(offset) {
                        this.offset = offset;
                        return this;
                    }
                    /**
     * Store the current pointer offset.
     * @see {@link IOBuffer#reset}
     * @returns This.
     */ mark() {
                        this._mark = this.offset;
                        return this;
                    }
                    /**
     * Move the pointer back to the last pointer offset set by mark.
     * @see {@link IOBuffer#mark}
     * @returns This.
     */ reset() {
                        this.offset = this._mark;
                        return this;
                    }
                    /**
     * Push the current pointer offset to the mark stack.
     * @see {@link IOBuffer#popMark}
     * @returns This.
     */ pushMark() {
                        this._marks.push(this.offset);
                        return this;
                    }
                    /**
     * Pop the last pointer offset from the mark stack, and set the current
     * pointer offset to the popped value.
     * @see {@link IOBuffer#pushMark}
     * @returns This.
     */ popMark() {
                        const offset = this._marks.pop();
                        if (offset === undefined) throw new Error('Mark stack empty');
                        this.seek(offset);
                        return this;
                    }
                    /**
     * Move the pointer offset back to 0.
     * @returns This.
     */ rewind() {
                        this.offset = 0;
                        return this;
                    }
                    /**
     * Make sure the buffer has sufficient memory to write a given byteLength at
     * the current pointer offset.
     * If the buffer's memory is insufficient, this method will create a new
     * buffer (a copy) with a length that is twice (byteLength + current offset).
     * @param byteLength - The needed memory in bytes.
     * @returns This.
     */ ensureAvailable(byteLength = 1) {
                        if (!this.available(byteLength)) {
                            const lengthNeeded = this.offset + byteLength;
                            const newLength = lengthNeeded * 2;
                            const newArray = new Uint8Array(newLength);
                            newArray.set(new Uint8Array(this.buffer));
                            this.buffer = newArray.buffer;
                            this.length = newLength;
                            this.byteLength = newLength;
                            this._data = new DataView(this.buffer);
                        }
                        return this;
                    }
                    /**
     * Read a byte and return false if the byte's value is 0, or true otherwise.
     * Moves pointer forward by one byte.
     * @returns The read boolean.
     */ readBoolean() {
                        return this.readUint8() !== 0;
                    }
                    /**
     * Read a signed 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readInt8() {
                        return this._data.getInt8(this.offset++);
                    }
                    /**
     * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readUint8() {
                        return this._data.getUint8(this.offset++);
                    }
                    /**
     * Alias for {@link IOBuffer#readUint8}.
     * @returns The read byte.
     */ readByte() {
                        return this.readUint8();
                    }
                    /**
     * Read `n` bytes and move pointer forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The read bytes.
     */ readBytes(n = 1) {
                        return this.readArray(n, 'uint8');
                    }
                    /**
     * Creates an array of corresponding to the type `type` and size `size`.
     * For example type `uint8` will create a `Uint8Array`.
     * @param size - size of the resulting array
     * @param type - number type of elements to read
     * @returns The read array.
     */ readArray(size, type) {
                        const bytes = typedArrays[type].BYTES_PER_ELEMENT * size;
                        const offset = this.byteOffset + this.offset;
                        const slice = this.buffer.slice(offset, offset + bytes);
                        if (this.littleEndian === hostBigEndian && type !== 'uint8' && type !== 'int8') {
                            const slice = new Uint8Array(this.buffer.slice(offset, offset + bytes));
                            slice.reverse();
                            const returnArray = new typedArrays[type](slice.buffer);
                            this.offset += bytes;
                            returnArray.reverse();
                            return returnArray;
                        }
                        const returnArray = new typedArrays[type](slice);
                        this.offset += bytes;
                        return returnArray;
                    }
                    /**
     * Read a 16-bit signed integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readInt16() {
                        const value = this._data.getInt16(this.offset, this.littleEndian);
                        this.offset += 2;
                        return value;
                    }
                    /**
     * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readUint16() {
                        const value = this._data.getUint16(this.offset, this.littleEndian);
                        this.offset += 2;
                        return value;
                    }
                    /**
     * Read a 32-bit signed integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readInt32() {
                        const value = this._data.getInt32(this.offset, this.littleEndian);
                        this.offset += 4;
                        return value;
                    }
                    /**
     * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readUint32() {
                        const value = this._data.getUint32(this.offset, this.littleEndian);
                        this.offset += 4;
                        return value;
                    }
                    /**
     * Read a 32-bit floating number and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readFloat32() {
                        const value = this._data.getFloat32(this.offset, this.littleEndian);
                        this.offset += 4;
                        return value;
                    }
                    /**
     * Read a 64-bit floating number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readFloat64() {
                        const value = this._data.getFloat64(this.offset, this.littleEndian);
                        this.offset += 8;
                        return value;
                    }
                    /**
     * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigInt64() {
                        const value = this._data.getBigInt64(this.offset, this.littleEndian);
                        this.offset += 8;
                        return value;
                    }
                    /**
     * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigUint64() {
                        const value = this._data.getBigUint64(this.offset, this.littleEndian);
                        this.offset += 8;
                        return value;
                    }
                    /**
     * Read a 1-byte ASCII character and move pointer forward by 1 byte.
     * @returns The read character.
     */ readChar() {
                        // eslint-disable-next-line unicorn/prefer-code-point
                        return String.fromCharCode(this.readInt8());
                    }
                    /**
     * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
     * @param n - Number of characters to read.
     * @returns The read characters.
     */ readChars(n = 1) {
                        let result = '';
                        for(let i = 0; i < n; i++)result += this.readChar();
                        return result;
                    }
                    /**
     * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
     * forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The decoded string.
     */ readUtf8(n = 1) {
                        return (0, _text__WEBPACK_IMPORTED_MODULE_0__.decode)(this.readBytes(n));
                    }
                    /**
     * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
     * forward by `n` bytes.
     * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
     * @param n - Number of bytes to read.
     * @param encoding - The encoding to use. Default is 'utf8'.
     * @returns The decoded string.
     */ decodeText(n = 1, encoding = 'utf8') {
                        return (0, _text__WEBPACK_IMPORTED_MODULE_0__.decode)(this.readBytes(n), encoding);
                    }
                    /**
     * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
     * forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeBoolean(value) {
                        this.writeUint8(value ? 0xff : 0x00);
                        return this;
                    }
                    /**
     * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeInt8(value) {
                        this.ensureAvailable(1);
                        this._data.setInt8(this.offset++, value);
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
     * byte.
     * @param value - The value to write.
     * @returns This.
     */ writeUint8(value) {
                        this.ensureAvailable(1);
                        this._data.setUint8(this.offset++, value);
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * An alias for {@link IOBuffer#writeUint8}.
     * @param value - The value to write.
     * @returns This.
     */ writeByte(value) {
                        return this.writeUint8(value);
                    }
                    /**
     * Write all elements of `bytes` as uint8 values and move pointer forward by
     * `bytes.length` bytes.
     * @param bytes - The array of bytes to write.
     * @returns This.
     */ writeBytes(bytes) {
                        this.ensureAvailable(bytes.length);
                        // eslint-disable-next-line @typescript-eslint/prefer-for-of
                        for(let i = 0; i < bytes.length; i++)this._data.setUint8(this.offset++, bytes[i]);
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * Write `value` as a 16-bit signed integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt16(value) {
                        this.ensureAvailable(2);
                        this._data.setInt16(this.offset, value, this.littleEndian);
                        this.offset += 2;
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint16(value) {
                        this.ensureAvailable(2);
                        this._data.setUint16(this.offset, value, this.littleEndian);
                        this.offset += 2;
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * Write `value` as a 32-bit signed integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt32(value) {
                        this.ensureAvailable(4);
                        this._data.setInt32(this.offset, value, this.littleEndian);
                        this.offset += 4;
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint32(value) {
                        this.ensureAvailable(4);
                        this._data.setUint32(this.offset, value, this.littleEndian);
                        this.offset += 4;
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * Write `value` as a 32-bit floating number and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat32(value) {
                        this.ensureAvailable(4);
                        this._data.setFloat32(this.offset, value, this.littleEndian);
                        this.offset += 4;
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * Write `value` as a 64-bit floating number and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat64(value) {
                        this.ensureAvailable(8);
                        this._data.setFloat64(this.offset, value, this.littleEndian);
                        this.offset += 8;
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * Write `value` as a 64-bit signed bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigInt64(value) {
                        this.ensureAvailable(8);
                        this._data.setBigInt64(this.offset, value, this.littleEndian);
                        this.offset += 8;
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigUint64(value) {
                        this.ensureAvailable(8);
                        this._data.setBigUint64(this.offset, value, this.littleEndian);
                        this.offset += 8;
                        this._updateLastWrittenByte();
                        return this;
                    }
                    /**
     * Write the charCode of `str`'s first character as an 8-bit unsigned integer
     * and move pointer forward by 1 byte.
     * @param str - The character to write.
     * @returns This.
     */ writeChar(str) {
                        // eslint-disable-next-line unicorn/prefer-code-point
                        return this.writeUint8(str.charCodeAt(0));
                    }
                    /**
     * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
     * and move pointer forward by `str.length` bytes.
     * @param str - The characters to write.
     * @returns This.
     */ writeChars(str) {
                        for(let i = 0; i < str.length; i++)// eslint-disable-next-line unicorn/prefer-code-point
                        this.writeUint8(str.charCodeAt(i));
                        return this;
                    }
                    /**
     * UTF-8 encode and write `str` to the current pointer offset and move pointer
     * forward according to the encoded length.
     * @param str - The string to write.
     * @returns This.
     */ writeUtf8(str) {
                        return this.writeBytes((0, _text__WEBPACK_IMPORTED_MODULE_0__.encode)(str));
                    }
                    /**
     * Export a Uint8Array view of the internal buffer.
     * The view starts at the byte offset and its length
     * is calculated to stop at the last written byte or the original length.
     * @returns A new Uint8Array view.
     */ toArray() {
                        return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
                    }
                    /**
     *  Get the total number of bytes written so far, regardless of the current offset.
     * @returns - Total number of bytes.
     */ getWrittenByteLength() {
                        return this.lastWrittenByte - this.byteOffset;
                    }
                    /**
     * Update the last written byte offset
     * @private
     */ _updateLastWrittenByte() {
                        if (this.offset > this.lastWrittenByte) this.lastWrittenByte = this.offset;
                    }
                }
            //# sourceMappingURL=IOBuffer.js.map
            /***/ },
            /***/ "./node_modules/iobuffer/lib-esm/text.js": /*!***********************************************!*\
  !*** ./node_modules/iobuffer/lib-esm/text.js ***!
  \***********************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ decode: function() {
                        return /* binding */ decode;
                    },
                    /* harmony export */ encode: function() {
                        return /* binding */ encode;
                    }
                });
                function decode(bytes, encoding = 'utf8') {
                    const decoder = new TextDecoder(encoding);
                    return decoder.decode(bytes);
                }
                const encoder = new TextEncoder();
                function encode(str) {
                    return encoder.encode(str);
                }
            //# sourceMappingURL=text.js.map
            /***/ },
            /***/ "./node_modules/jspdf/dist/jspdf.es.min.js": /*!*************************************************!*\
  !*** ./node_modules/jspdf/dist/jspdf.es.min.js ***!
  \*************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ AcroForm: function() {
                        return /* binding */ St;
                    },
                    /* harmony export */ AcroFormAppearance: function() {
                        return /* binding */ xt;
                    },
                    /* harmony export */ AcroFormButton: function() {
                        return /* binding */ mt;
                    },
                    /* harmony export */ AcroFormCheckBox: function() {
                        return /* binding */ wt;
                    },
                    /* harmony export */ AcroFormChoiceField: function() {
                        return /* binding */ ft;
                    },
                    /* harmony export */ AcroFormComboBox: function() {
                        return /* binding */ pt;
                    },
                    /* harmony export */ AcroFormEditBox: function() {
                        return /* binding */ gt;
                    },
                    /* harmony export */ AcroFormListBox: function() {
                        return /* binding */ dt;
                    },
                    /* harmony export */ AcroFormPasswordField: function() {
                        return /* binding */ Lt;
                    },
                    /* harmony export */ AcroFormPushButton: function() {
                        return /* binding */ vt;
                    },
                    /* harmony export */ AcroFormRadioButton: function() {
                        return /* binding */ bt;
                    },
                    /* harmony export */ AcroFormTextField: function() {
                        return /* binding */ Nt;
                    },
                    /* harmony export */ GState: function() {
                        return /* binding */ O;
                    },
                    /* harmony export */ ShadingPattern: function() {
                        return /* binding */ M;
                    },
                    /* harmony export */ TilingPattern: function() {
                        return /* binding */ q;
                    },
                    /* harmony export */ "default": function() {
                        return /* binding */ E;
                    },
                    /* harmony export */ jsPDF: function() {
                        return /* binding */ E;
                    }
                });
                /* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/esm/typeof.js");
                /* harmony import */ var fflate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! fflate */ "./node_modules/fflate/esm/browser.js");
                /* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
                /* harmony import */ var fast_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! fast-png */ "./node_modules/fast-png/lib-esm/index.js");
                /** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 4.0.0 Built on 2025-12-18T10:27:09.425Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2025 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2025 yWorks GmbH, http://www.yworks.com
 *               2015-2025 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ var i = function() {
                    return "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this;
                }();
                function a() {
                    i.console && "function" == typeof i.console.log && i.console.log.apply(i.console, arguments);
                }
                var o = {
                    log: a,
                    warn: function(t) {
                        i.console && ("function" == typeof i.console.warn ? i.console.warn.apply(i.console, arguments) : a.call(null, arguments));
                    },
                    error: function(t) {
                        i.console && ("function" == typeof i.console.error ? i.console.error.apply(i.console, arguments) : a(t));
                    }
                };
                function s(t, e, n) {
                    var r = new XMLHttpRequest;
                    r.open("GET", t), r.responseType = "blob", r.onload = function() {
                        l(r.response, e, n);
                    }, r.onerror = function() {
                        o.error("could not download file");
                    }, r.send();
                }
                function u(t) {
                    var e = new XMLHttpRequest;
                    e.open("HEAD", t, !1);
                    try {
                        e.send();
                    } catch (n) {}
                    return e.status >= 200 && e.status <= 299;
                }
                function c(t) {
                    try {
                        t.dispatchEvent(new MouseEvent("click"));
                    } catch (n) {
                        var e = document.createEvent("MouseEvents");
                        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
                    }
                }
                var l = i.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(window)) || window !== i ? function() {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function(t, e, n) {
                    var r = i.URL || i.webkitURL, a = document.createElement("a");
                    e = e || t.name || "download", a.download = e, a.rel = "noopener", "string" == typeof t ? (a.href = t, a.origin !== location.origin ? u(a.href) ? s(t, e, n) : c(a, a.target = "_blank") : c(a)) : (a.href = r.createObjectURL(t), setTimeout(function() {
                        r.revokeObjectURL(a.href);
                    }, 4e4), setTimeout(function() {
                        c(a);
                    }, 0));
                } : "msSaveOrOpenBlob" in navigator ? function(e, n, r) {
                    if (n = n || e.name || "download", "string" == typeof e) {
                        if (u(e)) s(e, n, r);
                        else {
                            var i = document.createElement("a");
                            i.href = e, i.target = "_blank", setTimeout(function() {
                                c(i);
                            });
                        }
                    } else navigator.msSaveOrOpenBlob(function(e, n) {
                        return void 0 === n ? n = {
                            autoBom: !1
                        } : "object" !== (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(n) && (o.warn("Deprecated: Expected third argument to be a object"), n = {
                            autoBom: !n
                        }), n.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
                            String.fromCharCode(65279),
                            e
                        ], {
                            type: e.type
                        }) : e;
                    }(e, r), n);
                } : function(e, n, r, a) {
                    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return s(e, n, r);
                    var o = "application/octet-stream" === e.type, u = /constructor/i.test(i.HTMLElement) || i.safari, c = /CriOS\/[\d]+/.test(navigator.userAgent);
                    if ((c || o && u) && "object" === ("undefined" == typeof FileReader ? "undefined" : (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(FileReader))) {
                        var l = new FileReader;
                        l.onloadend = function() {
                            var t = l.result;
                            t = c ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = t : location = t, a = null;
                        }, l.readAsDataURL(e);
                    } else {
                        var h = i.URL || i.webkitURL, f = h.createObjectURL(e);
                        a ? a.location = f : location.href = f, a = null, setTimeout(function() {
                            h.revokeObjectURL(f);
                        }, 4e4);
                    }
                });
                /**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function h(t) {
                    var e;
                    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = ({
                        aliceblue: "f0f8ff",
                        antiquewhite: "faebd7",
                        aqua: "00ffff",
                        aquamarine: "7fffd4",
                        azure: "f0ffff",
                        beige: "f5f5dc",
                        bisque: "ffe4c4",
                        black: "000000",
                        blanchedalmond: "ffebcd",
                        blue: "0000ff",
                        blueviolet: "8a2be2",
                        brown: "a52a2a",
                        burlywood: "deb887",
                        cadetblue: "5f9ea0",
                        chartreuse: "7fff00",
                        chocolate: "d2691e",
                        coral: "ff7f50",
                        cornflowerblue: "6495ed",
                        cornsilk: "fff8dc",
                        crimson: "dc143c",
                        cyan: "00ffff",
                        darkblue: "00008b",
                        darkcyan: "008b8b",
                        darkgoldenrod: "b8860b",
                        darkgray: "a9a9a9",
                        darkgreen: "006400",
                        darkkhaki: "bdb76b",
                        darkmagenta: "8b008b",
                        darkolivegreen: "556b2f",
                        darkorange: "ff8c00",
                        darkorchid: "9932cc",
                        darkred: "8b0000",
                        darksalmon: "e9967a",
                        darkseagreen: "8fbc8f",
                        darkslateblue: "483d8b",
                        darkslategray: "2f4f4f",
                        darkturquoise: "00ced1",
                        darkviolet: "9400d3",
                        deeppink: "ff1493",
                        deepskyblue: "00bfff",
                        dimgray: "696969",
                        dodgerblue: "1e90ff",
                        feldspar: "d19275",
                        firebrick: "b22222",
                        floralwhite: "fffaf0",
                        forestgreen: "228b22",
                        fuchsia: "ff00ff",
                        gainsboro: "dcdcdc",
                        ghostwhite: "f8f8ff",
                        gold: "ffd700",
                        goldenrod: "daa520",
                        gray: "808080",
                        green: "008000",
                        greenyellow: "adff2f",
                        honeydew: "f0fff0",
                        hotpink: "ff69b4",
                        indianred: "cd5c5c",
                        indigo: "4b0082",
                        ivory: "fffff0",
                        khaki: "f0e68c",
                        lavender: "e6e6fa",
                        lavenderblush: "fff0f5",
                        lawngreen: "7cfc00",
                        lemonchiffon: "fffacd",
                        lightblue: "add8e6",
                        lightcoral: "f08080",
                        lightcyan: "e0ffff",
                        lightgoldenrodyellow: "fafad2",
                        lightgrey: "d3d3d3",
                        lightgreen: "90ee90",
                        lightpink: "ffb6c1",
                        lightsalmon: "ffa07a",
                        lightseagreen: "20b2aa",
                        lightskyblue: "87cefa",
                        lightslateblue: "8470ff",
                        lightslategray: "778899",
                        lightsteelblue: "b0c4de",
                        lightyellow: "ffffe0",
                        lime: "00ff00",
                        limegreen: "32cd32",
                        linen: "faf0e6",
                        magenta: "ff00ff",
                        maroon: "800000",
                        mediumaquamarine: "66cdaa",
                        mediumblue: "0000cd",
                        mediumorchid: "ba55d3",
                        mediumpurple: "9370d8",
                        mediumseagreen: "3cb371",
                        mediumslateblue: "7b68ee",
                        mediumspringgreen: "00fa9a",
                        mediumturquoise: "48d1cc",
                        mediumvioletred: "c71585",
                        midnightblue: "191970",
                        mintcream: "f5fffa",
                        mistyrose: "ffe4e1",
                        moccasin: "ffe4b5",
                        navajowhite: "ffdead",
                        navy: "000080",
                        oldlace: "fdf5e6",
                        olive: "808000",
                        olivedrab: "6b8e23",
                        orange: "ffa500",
                        orangered: "ff4500",
                        orchid: "da70d6",
                        palegoldenrod: "eee8aa",
                        palegreen: "98fb98",
                        paleturquoise: "afeeee",
                        palevioletred: "d87093",
                        papayawhip: "ffefd5",
                        peachpuff: "ffdab9",
                        peru: "cd853f",
                        pink: "ffc0cb",
                        plum: "dda0dd",
                        powderblue: "b0e0e6",
                        purple: "800080",
                        red: "ff0000",
                        rosybrown: "bc8f8f",
                        royalblue: "4169e1",
                        saddlebrown: "8b4513",
                        salmon: "fa8072",
                        sandybrown: "f4a460",
                        seagreen: "2e8b57",
                        seashell: "fff5ee",
                        sienna: "a0522d",
                        silver: "c0c0c0",
                        skyblue: "87ceeb",
                        slateblue: "6a5acd",
                        slategray: "708090",
                        snow: "fffafa",
                        springgreen: "00ff7f",
                        steelblue: "4682b4",
                        tan: "d2b48c",
                        teal: "008080",
                        thistle: "d8bfd8",
                        tomato: "ff6347",
                        turquoise: "40e0d0",
                        violet: "ee82ee",
                        violetred: "d02090",
                        wheat: "f5deb3",
                        white: "ffffff",
                        whitesmoke: "f5f5f5",
                        yellow: "ffff00",
                        yellowgreen: "9acd32"
                    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
                    for(var n = [
                        {
                            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                            example: [
                                "rgb(123, 234, 45)",
                                "rgb(255,234,245)"
                            ],
                            process: function(t) {
                                return [
                                    parseInt(t[1]),
                                    parseInt(t[2]),
                                    parseInt(t[3])
                                ];
                            }
                        },
                        {
                            re: /^(\w{2})(\w{2})(\w{2})$/,
                            example: [
                                "#00ff00",
                                "336699"
                            ],
                            process: function(t) {
                                return [
                                    parseInt(t[1], 16),
                                    parseInt(t[2], 16),
                                    parseInt(t[3], 16)
                                ];
                            }
                        },
                        {
                            re: /^(\w{1})(\w{1})(\w{1})$/,
                            example: [
                                "#fb0",
                                "f0f"
                            ],
                            process: function(t) {
                                return [
                                    parseInt(t[1] + t[1], 16),
                                    parseInt(t[2] + t[2], 16),
                                    parseInt(t[3] + t[3], 16)
                                ];
                            }
                        }
                    ], r = 0; r < n.length; r++){
                        var i = n[r].re, a = n[r].process, o = i.exec(t);
                        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
                    }
                    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
                        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
                    }, this.toHex = function() {
                        var t = this.r.toString(16), e = this.g.toString(16), n = this.b.toString(16);
                        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + t + e + n;
                    };
                }
                var f = i.atob.bind(i), d = i.btoa.bind(i);
                /**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */ function p(t, e) {
                    var n = t[0], r = t[1], i = t[2], a = t[3];
                    n = m(n, r, i, a, e[0], 7, -680876936), a = m(a, n, r, i, e[1], 12, -389564586), i = m(i, a, n, r, e[2], 17, 606105819), r = m(r, i, a, n, e[3], 22, -1044525330), n = m(n, r, i, a, e[4], 7, -176418897), a = m(a, n, r, i, e[5], 12, 1200080426), i = m(i, a, n, r, e[6], 17, -1473231341), r = m(r, i, a, n, e[7], 22, -45705983), n = m(n, r, i, a, e[8], 7, 1770035416), a = m(a, n, r, i, e[9], 12, -1958414417), i = m(i, a, n, r, e[10], 17, -42063), r = m(r, i, a, n, e[11], 22, -1990404162), n = m(n, r, i, a, e[12], 7, 1804603682), a = m(a, n, r, i, e[13], 12, -40341101), i = m(i, a, n, r, e[14], 17, -1502002290), n = v(n, r = m(r, i, a, n, e[15], 22, 1236535329), i, a, e[1], 5, -165796510), a = v(a, n, r, i, e[6], 9, -1069501632), i = v(i, a, n, r, e[11], 14, 643717713), r = v(r, i, a, n, e[0], 20, -373897302), n = v(n, r, i, a, e[5], 5, -701558691), a = v(a, n, r, i, e[10], 9, 38016083), i = v(i, a, n, r, e[15], 14, -660478335), r = v(r, i, a, n, e[4], 20, -405537848), n = v(n, r, i, a, e[9], 5, 568446438), a = v(a, n, r, i, e[14], 9, -1019803690), i = v(i, a, n, r, e[3], 14, -187363961), r = v(r, i, a, n, e[8], 20, 1163531501), n = v(n, r, i, a, e[13], 5, -1444681467), a = v(a, n, r, i, e[2], 9, -51403784), i = v(i, a, n, r, e[7], 14, 1735328473), n = b(n, r = v(r, i, a, n, e[12], 20, -1926607734), i, a, e[5], 4, -378558), a = b(a, n, r, i, e[8], 11, -2022574463), i = b(i, a, n, r, e[11], 16, 1839030562), r = b(r, i, a, n, e[14], 23, -35309556), n = b(n, r, i, a, e[1], 4, -1530992060), a = b(a, n, r, i, e[4], 11, 1272893353), i = b(i, a, n, r, e[7], 16, -155497632), r = b(r, i, a, n, e[10], 23, -1094730640), n = b(n, r, i, a, e[13], 4, 681279174), a = b(a, n, r, i, e[0], 11, -358537222), i = b(i, a, n, r, e[3], 16, -722521979), r = b(r, i, a, n, e[6], 23, 76029189), n = b(n, r, i, a, e[9], 4, -640364487), a = b(a, n, r, i, e[12], 11, -421815835), i = b(i, a, n, r, e[15], 16, 530742520), n = y(n, r = b(r, i, a, n, e[2], 23, -995338651), i, a, e[0], 6, -198630844), a = y(a, n, r, i, e[7], 10, 1126891415), i = y(i, a, n, r, e[14], 15, -1416354905), r = y(r, i, a, n, e[5], 21, -57434055), n = y(n, r, i, a, e[12], 6, 1700485571), a = y(a, n, r, i, e[3], 10, -1894986606), i = y(i, a, n, r, e[10], 15, -1051523), r = y(r, i, a, n, e[1], 21, -2054922799), n = y(n, r, i, a, e[8], 6, 1873313359), a = y(a, n, r, i, e[15], 10, -30611744), i = y(i, a, n, r, e[6], 15, -1560198380), r = y(r, i, a, n, e[13], 21, 1309151649), n = y(n, r, i, a, e[4], 6, -145523070), a = y(a, n, r, i, e[11], 10, -1120210379), i = y(i, a, n, r, e[2], 15, 718787259), r = y(r, i, a, n, e[9], 21, -343485551), t[0] = P(n, t[0]), t[1] = P(r, t[1]), t[2] = P(i, t[2]), t[3] = P(a, t[3]);
                }
                function g(t, e, n, r, i, a) {
                    return e = P(P(e, t), P(r, a)), P(e << i | e >>> 32 - i, n);
                }
                function m(t, e, n, r, i, a, o) {
                    return g(e & n | ~e & r, t, e, i, a, o);
                }
                function v(t, e, n, r, i, a, o) {
                    return g(e & r | n & ~r, t, e, i, a, o);
                }
                function b(t, e, n, r, i, a, o) {
                    return g(e ^ n ^ r, t, e, i, a, o);
                }
                function y(t, e, n, r, i, a, o) {
                    return g(n ^ (e | ~r), t, e, i, a, o);
                }
                function w(t) {
                    var e, n = t.length, r = [
                        1732584193,
                        -271733879,
                        -1732584194,
                        271733878
                    ];
                    for(e = 64; e <= t.length; e += 64)p(r, N(t.substring(e - 64, e)));
                    t = t.substring(e - 64);
                    var i = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    for(e = 0; e < t.length; e++)i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
                    if (i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for(p(r, i), e = 0; e < 16; e++)i[e] = 0;
                    return i[14] = 8 * n, p(r, i), r;
                }
                function N(t) {
                    var e, n = [];
                    for(e = 0; e < 64; e += 4)n[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
                    return n;
                }
                var L = "0123456789abcdef".split("");
                function x(t) {
                    for(var e = "", n = 0; n < 4; n++)e += L[t >> 8 * n + 4 & 15] + L[t >> 8 * n & 15];
                    return e;
                }
                function A(t) {
                    return String.fromCharCode(255 & t, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
                }
                function S(t) {
                    return w(t).map(A).join("");
                }
                var _ = "5d41402abc4b2a76b9719d911017c592" != function(t) {
                    for(var e = 0; e < t.length; e++)t[e] = x(t[e]);
                    return t.join("");
                }(w("hello"));
                function P(t, e) {
                    if (_) {
                        var n = (65535 & t) + (65535 & e);
                        return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    return t + e & 4294967295;
                }
                /**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */ function k(t, e) {
                    var n, r, i, a;
                    if (t !== n) {
                        for(var o = (i = t, a = 1 + (256 / t.length | 0), new Array(a + 1).join(i)), s = [], u = 0; u < 256; u++)s[u] = u;
                        var c = 0;
                        for(u = 0; u < 256; u++){
                            var l = s[u];
                            c = (c + l + o.charCodeAt(u)) % 256, s[u] = s[c], s[c] = l;
                        }
                        n = t, r = s;
                    } else s = r;
                    var h = e.length, f = 0, d = 0, p = "";
                    for(u = 0; u < h; u++)d = (d + (l = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = l, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(u) ^ o);
                    return p;
                }
                /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */ var F = {
                    print: 4,
                    modify: 8,
                    copy: 16,
                    "annot-forms": 32
                };
                function I(t, e, n, r) {
                    this.v = 1, this.r = 2;
                    var i = 192;
                    t.forEach(function(t) {
                        if (void 0 !== F.perm) throw new Error("Invalid permission: " + t);
                        i += F[t];
                    }), this.padding = "(\xbfN^Nu\x8aAd\0NV\xff\xfa\x01\b..\0\xb6\xd0h>\x80/\f\xa9\xfedSiz";
                    var a = (e + this.padding).substr(0, 32), o = (n + this.padding).substr(0, 32);
                    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = S(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(r)).substr(0, 5), this.U = k(this.encryptionKey, this.padding);
                }
                function j(t) {
                    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
                    for(var e = "", n = t.length, r = 0; r < n; r++){
                        var i = t.charCodeAt(r);
                        e += i < 33 || 35 === i || 37 === i || 40 === i || 41 === i || 47 === i || 60 === i || 62 === i || 91 === i || 93 === i || 123 === i || 125 === i || i > 126 ? "#" + ("0" + i.toString(16)).slice(-2) : t[r];
                    }
                    return e;
                }
                function C(e) {
                    if ("object" !== (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
                    var n = {};
                    this.subscribe = function(t, e, r) {
                        if (r = r || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof r) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
                        n.hasOwnProperty(t) || (n[t] = {});
                        var i = Math.random().toString(35);
                        return n[t][i] = [
                            e,
                            !!r
                        ], i;
                    }, this.unsubscribe = function(t) {
                        for(var e in n)if (n[e][t]) return delete n[e][t], 0 === Object.keys(n[e]).length && delete n[e], !0;
                        return !1;
                    }, this.publish = function(t) {
                        if (n.hasOwnProperty(t)) {
                            var r = Array.prototype.slice.call(arguments, 1), a = [];
                            for(var s in n[t]){
                                var u = n[t][s];
                                try {
                                    u[0].apply(e, r);
                                } catch (c) {
                                    i.console && o.error("jsPDF PubSub Error", c.message, c);
                                }
                                u[1] && a.push(s);
                            }
                            a.length && a.forEach(this.unsubscribe);
                        }
                    }, this.getTopics = function() {
                        return n;
                    };
                }
                function O(t) {
                    if (!(this instanceof O)) return new O(t);
                    var e = "opacity,stroke-opacity".split(",");
                    for(var n in t)t.hasOwnProperty(n) && e.indexOf(n) >= 0 && (this[n] = t[n]);
                    this.id = "", this.objectNumber = -1;
                }
                function B(t, e) {
                    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
                }
                function M(t, e, n, r, i) {
                    if (!(this instanceof M)) return new M(t, e, n, r, i);
                    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = n, B.call(this, r, i);
                }
                function q(t, e, n, r, i) {
                    if (!(this instanceof q)) return new q(t, e, n, r, i);
                    this.boundingBox = t, this.xStep = e, this.yStep = n, this.stream = "", this.cloneIndex = 0, B.call(this, r, i);
                }
                function E(e) {
                    var n, r = "string" == typeof arguments[0] ? arguments[0] : "p", a = arguments[1], s = arguments[2], u = arguments[3], c = [], f = 1, p = 16, g = "S", m = null;
                    "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e = e || {}) && (r = e.orientation, a = e.unit || a, s = e.format || s, u = e.compress || e.compressPdf || u, null !== (m = e.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), f = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (n = e.precision), void 0 !== e.floatPrecision && (p = e.floatPrecision), g = e.defaultPathOperation || "S"), c = e.filters || (!0 === u ? [
                        "FlateEncode"
                    ] : c), a = a || "mm", r = ("" + (r || "P")).toLowerCase();
                    var v = e.putOnlyUsedFonts || !1, b = {}, y = {
                        internal: {},
                        __private__: {}
                    };
                    y.__private__.PubSub = C;
                    var w = "1.3", N = y.__private__.getPdfVersion = function() {
                        return w;
                    };
                    y.__private__.setPdfVersion = function(t) {
                        w = t;
                    };
                    var L = {
                        a0: [
                            2383.94,
                            3370.39
                        ],
                        a1: [
                            1683.78,
                            2383.94
                        ],
                        a2: [
                            1190.55,
                            1683.78
                        ],
                        a3: [
                            841.89,
                            1190.55
                        ],
                        a4: [
                            595.28,
                            841.89
                        ],
                        a5: [
                            419.53,
                            595.28
                        ],
                        a6: [
                            297.64,
                            419.53
                        ],
                        a7: [
                            209.76,
                            297.64
                        ],
                        a8: [
                            147.4,
                            209.76
                        ],
                        a9: [
                            104.88,
                            147.4
                        ],
                        a10: [
                            73.7,
                            104.88
                        ],
                        b0: [
                            2834.65,
                            4008.19
                        ],
                        b1: [
                            2004.09,
                            2834.65
                        ],
                        b2: [
                            1417.32,
                            2004.09
                        ],
                        b3: [
                            1000.63,
                            1417.32
                        ],
                        b4: [
                            708.66,
                            1000.63
                        ],
                        b5: [
                            498.9,
                            708.66
                        ],
                        b6: [
                            354.33,
                            498.9
                        ],
                        b7: [
                            249.45,
                            354.33
                        ],
                        b8: [
                            175.75,
                            249.45
                        ],
                        b9: [
                            124.72,
                            175.75
                        ],
                        b10: [
                            87.87,
                            124.72
                        ],
                        c0: [
                            2599.37,
                            3676.54
                        ],
                        c1: [
                            1836.85,
                            2599.37
                        ],
                        c2: [
                            1298.27,
                            1836.85
                        ],
                        c3: [
                            918.43,
                            1298.27
                        ],
                        c4: [
                            649.13,
                            918.43
                        ],
                        c5: [
                            459.21,
                            649.13
                        ],
                        c6: [
                            323.15,
                            459.21
                        ],
                        c7: [
                            229.61,
                            323.15
                        ],
                        c8: [
                            161.57,
                            229.61
                        ],
                        c9: [
                            113.39,
                            161.57
                        ],
                        c10: [
                            79.37,
                            113.39
                        ],
                        dl: [
                            311.81,
                            623.62
                        ],
                        letter: [
                            612,
                            792
                        ],
                        "government-letter": [
                            576,
                            756
                        ],
                        legal: [
                            612,
                            1008
                        ],
                        "junior-legal": [
                            576,
                            360
                        ],
                        ledger: [
                            1224,
                            792
                        ],
                        tabloid: [
                            792,
                            1224
                        ],
                        "credit-card": [
                            153,
                            243
                        ]
                    };
                    y.__private__.getPageFormats = function() {
                        return L;
                    };
                    var x = y.__private__.getPageFormat = function(t) {
                        return L[t];
                    };
                    s = s || "a4";
                    var A = "compat", S = "advanced", _ = A;
                    function P() {
                        this.saveGraphicsState(), lt(new Wt(St, 0, 0, -St, 0, _n() * St).toString() + " cm"), this.setFontSize(this.getFontSize() / St), g = "n", _ = S;
                    }
                    function k() {
                        this.restoreGraphicsState(), g = "S", _ = A;
                    }
                    var F = y.__private__.combineFontStyleAndFontWeight = function(t, e) {
                        if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
                        return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
                    };
                    y.advancedAPI = function(t) {
                        var e = _ === A;
                        return e && P.call(this), "function" != typeof t || (t(this), e && k.call(this)), this;
                    }, y.compatAPI = function(t) {
                        var e = _ === S;
                        return e && k.call(this), "function" != typeof t || (t(this), e && P.call(this)), this;
                    }, y.isAdvancedAPI = function() {
                        return _ === S;
                    };
                    var B, R = function(t) {
                        if (_ !== S) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
                    }, D = y.roundToPrecision = y.__private__.roundToPrecision = function(t, e) {
                        var r = n || e;
                        if (isNaN(t) || isNaN(r)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
                        return t.toFixed(r).replace(/0+$/, "");
                    };
                    B = y.hpf = y.__private__.hpf = "number" == typeof p ? function(t) {
                        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
                        return D(t, p);
                    } : "smart" === p ? function(t) {
                        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
                        return D(t, t > -1 && t < 1 ? 16 : 5);
                    } : function(t) {
                        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
                        return D(t, 16);
                    };
                    var T = y.f2 = y.__private__.f2 = function(t) {
                        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
                        return D(t, 2);
                    }, z = y.__private__.f3 = function(t) {
                        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
                        return D(t, 3);
                    }, U = y.scale = y.__private__.scale = function(t) {
                        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
                        return _ === A ? t * St : _ === S ? t : void 0;
                    }, H = function(t) {
                        return U(function(t) {
                            return _ === A ? _n() - t : _ === S ? t : void 0;
                        }(t));
                    };
                    y.__private__.setPrecision = y.setPrecision = function(t) {
                        "number" == typeof parseInt(t, 10) && (n = parseInt(t, 10));
                    };
                    var W, V = "00000000000000000000000000000000", G = y.__private__.getFileId = function() {
                        return V;
                    }, Y = y.__private__.setFileId = function(t) {
                        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function() {
                            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
                        }).join(""), null !== m && (je = new I(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
                    };
                    y.setFileId = function(t) {
                        return Y(t), this;
                    }, y.getFileId = function() {
                        return G();
                    };
                    var J = y.__private__.convertDateToPDFDate = function(t) {
                        var e = t.getTimezoneOffset(), n = e < 0 ? "+" : "-", r = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), a = [
                            n,
                            Q(r),
                            "'",
                            Q(i),
                            "'"
                        ].join("");
                        return [
                            "D:",
                            t.getFullYear(),
                            Q(t.getMonth() + 1),
                            Q(t.getDate()),
                            Q(t.getHours()),
                            Q(t.getMinutes()),
                            Q(t.getSeconds()),
                            a
                        ].join("");
                    }, X = y.__private__.convertPDFDateToDate = function(t) {
                        var e = parseInt(t.substr(2, 4), 10), n = parseInt(t.substr(6, 2), 10) - 1, r = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
                        return new Date(e, n, r, i, a, o, 0);
                    }, K = y.__private__.setCreationDate = function(t) {
                        var e;
                        if (void 0 === t && (t = new Date), t instanceof Date) e = J(t);
                        else {
                            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
                            e = t;
                        }
                        return W = e;
                    }, Z = y.__private__.getCreationDate = function(t) {
                        var e = W;
                        return "jsDate" === t && (e = X(W)), e;
                    };
                    y.setCreationDate = function(t) {
                        return K(t), this;
                    }, y.getCreationDate = function(t) {
                        return Z(t);
                    };
                    var $, Q = y.__private__.padd2 = function(t) {
                        return ("0" + parseInt(t)).slice(-2);
                    }, tt = y.__private__.padd2Hex = function(t) {
                        return ("00" + (t = t.toString())).substr(t.length);
                    }, et = 0, nt = [], rt = [], it = 0, at = [], ot = [], st = !1, ut = rt;
                    y.__private__.setCustomOutputDestination = function(t) {
                        st = !0, ut = t;
                    };
                    var ct = function(t) {
                        st || (ut = t);
                    };
                    y.__private__.resetCustomOutputDestination = function() {
                        st = !1, ut = rt;
                    };
                    var lt = y.__private__.out = function(t) {
                        return t = t.toString(), it += t.length + 1, ut.push(t), ut;
                    }, ht = y.__private__.write = function(t) {
                        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
                    }, ft = y.__private__.getArrayBuffer = function(t) {
                        for(var e = t.length, n = new ArrayBuffer(e), r = new Uint8Array(n); e--;)r[e] = t.charCodeAt(e);
                        return n;
                    }, dt = [
                        [
                            "Helvetica",
                            "helvetica",
                            "normal",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Helvetica-Bold",
                            "helvetica",
                            "bold",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Helvetica-Oblique",
                            "helvetica",
                            "italic",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Helvetica-BoldOblique",
                            "helvetica",
                            "bolditalic",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Courier",
                            "courier",
                            "normal",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Courier-Bold",
                            "courier",
                            "bold",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Courier-Oblique",
                            "courier",
                            "italic",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Courier-BoldOblique",
                            "courier",
                            "bolditalic",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Times-Roman",
                            "times",
                            "normal",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Times-Bold",
                            "times",
                            "bold",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Times-Italic",
                            "times",
                            "italic",
                            "WinAnsiEncoding"
                        ],
                        [
                            "Times-BoldItalic",
                            "times",
                            "bolditalic",
                            "WinAnsiEncoding"
                        ],
                        [
                            "ZapfDingbats",
                            "zapfdingbats",
                            "normal",
                            null
                        ],
                        [
                            "Symbol",
                            "symbol",
                            "normal",
                            null
                        ]
                    ];
                    y.__private__.getStandardFonts = function() {
                        return dt;
                    };
                    var pt = e.fontSize || 16;
                    y.__private__.setFontSize = y.setFontSize = function(t) {
                        return pt = _ === S ? t / St : t, this;
                    };
                    var gt, mt = y.__private__.getFontSize = y.getFontSize = function() {
                        return _ === A ? pt : pt * St;
                    }, vt = e.R2L || !1;
                    y.__private__.setR2L = y.setR2L = function(t) {
                        return vt = t, this;
                    }, y.__private__.getR2L = y.getR2L = function() {
                        return vt;
                    };
                    var bt, yt = y.__private__.setZoomMode = function(t) {
                        if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) gt = t;
                        else if (isNaN(t)) {
                            if (-1 === [
                                void 0,
                                null,
                                "fullwidth",
                                "fullheight",
                                "fullpage",
                                "original"
                            ].indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
                            gt = t;
                        } else gt = parseInt(t, 10);
                    };
                    y.__private__.getZoomMode = function() {
                        return gt;
                    };
                    var wt, Nt = y.__private__.setPageMode = function(t) {
                        if (-1 == [
                            void 0,
                            null,
                            "UseNone",
                            "UseOutlines",
                            "UseThumbs",
                            "FullScreen"
                        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
                        bt = t;
                    };
                    y.__private__.getPageMode = function() {
                        return bt;
                    };
                    var Lt = y.__private__.setLayoutMode = function(t) {
                        if (-1 == [
                            void 0,
                            null,
                            "continuous",
                            "single",
                            "twoleft",
                            "tworight",
                            "two"
                        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
                        wt = t;
                    };
                    y.__private__.getLayoutMode = function() {
                        return wt;
                    }, y.__private__.setDisplayMode = y.setDisplayMode = function(t, e, n) {
                        return yt(t), Lt(e), Nt(n), this;
                    };
                    var xt = {
                        title: "",
                        subject: "",
                        author: "",
                        keywords: "",
                        creator: ""
                    };
                    y.__private__.getDocumentProperty = function(t) {
                        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
                        return xt[t];
                    }, y.__private__.getDocumentProperties = function() {
                        return xt;
                    }, y.__private__.setDocumentProperties = y.setProperties = y.setDocumentProperties = function(t) {
                        for(var e in xt)xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
                        return this;
                    }, y.__private__.setDocumentProperty = function(t, e) {
                        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
                        return xt[t] = e;
                    };
                    var At, St, _t, Pt, kt, Ft = {}, It = {}, jt = [], Ct = {}, Ot = {}, Bt = {}, Mt = {}, qt = null, Et = 0, Rt = [], Dt = new C(y), Tt = e.hotfixes || [], zt = {}, Ut = {}, Ht = [], Wt = function t(e, n, r, i, a, o) {
                        if (!(this instanceof t)) return new t(e, n, r, i, a, o);
                        isNaN(e) && (e = 1), isNaN(n) && (n = 0), isNaN(r) && (r = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
                            e,
                            n,
                            r,
                            i,
                            a,
                            o
                        ];
                    };
                    Object.defineProperty(Wt.prototype, "sx", {
                        get: function() {
                            return this._matrix[0];
                        },
                        set: function(t) {
                            this._matrix[0] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "shy", {
                        get: function() {
                            return this._matrix[1];
                        },
                        set: function(t) {
                            this._matrix[1] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "shx", {
                        get: function() {
                            return this._matrix[2];
                        },
                        set: function(t) {
                            this._matrix[2] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "sy", {
                        get: function() {
                            return this._matrix[3];
                        },
                        set: function(t) {
                            this._matrix[3] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "tx", {
                        get: function() {
                            return this._matrix[4];
                        },
                        set: function(t) {
                            this._matrix[4] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "ty", {
                        get: function() {
                            return this._matrix[5];
                        },
                        set: function(t) {
                            this._matrix[5] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "a", {
                        get: function() {
                            return this._matrix[0];
                        },
                        set: function(t) {
                            this._matrix[0] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "b", {
                        get: function() {
                            return this._matrix[1];
                        },
                        set: function(t) {
                            this._matrix[1] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "c", {
                        get: function() {
                            return this._matrix[2];
                        },
                        set: function(t) {
                            this._matrix[2] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "d", {
                        get: function() {
                            return this._matrix[3];
                        },
                        set: function(t) {
                            this._matrix[3] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "e", {
                        get: function() {
                            return this._matrix[4];
                        },
                        set: function(t) {
                            this._matrix[4] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "f", {
                        get: function() {
                            return this._matrix[5];
                        },
                        set: function(t) {
                            this._matrix[5] = t;
                        }
                    }), Object.defineProperty(Wt.prototype, "rotation", {
                        get: function() {
                            return Math.atan2(this.shx, this.sx);
                        }
                    }), Object.defineProperty(Wt.prototype, "scaleX", {
                        get: function() {
                            return this.decompose().scale.sx;
                        }
                    }), Object.defineProperty(Wt.prototype, "scaleY", {
                        get: function() {
                            return this.decompose().scale.sy;
                        }
                    }), Object.defineProperty(Wt.prototype, "isIdentity", {
                        get: function() {
                            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
                        }
                    }), Wt.prototype.join = function(t) {
                        return [
                            this.sx,
                            this.shy,
                            this.shx,
                            this.sy,
                            this.tx,
                            this.ty
                        ].map(B).join(t);
                    }, Wt.prototype.multiply = function(t) {
                        var e = t.sx * this.sx + t.shy * this.shx, n = t.sx * this.shy + t.shy * this.sy, r = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
                        return new Wt(e, n, r, i, a, o);
                    }, Wt.prototype.decompose = function() {
                        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(t * t + e * e), s = (t /= o) * n + (e /= o) * r;
                        n -= t * s, r -= e * s;
                        var u = Math.sqrt(n * n + r * r);
                        return s /= u, t * (r /= u) < e * (n /= u) && (t = -t, e = -e, s = -s, o = -o), {
                            scale: new Wt(o, 0, 0, u, 0, 0),
                            translate: new Wt(1, 0, 0, 1, i, a),
                            rotate: new Wt(t, e, -e, t, 0, 0),
                            skew: new Wt(1, 0, s, 1, 0, 0)
                        };
                    }, Wt.prototype.toString = function(t) {
                        return this.join(" ");
                    }, Wt.prototype.inversed = function() {
                        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = 1 / (t * r - e * n), s = r * o, u = -e * o, c = -n * o, l = t * o;
                        return new Wt(s, u, c, l, -s * i - c * a, -u * i - l * a);
                    }, Wt.prototype.applyToPoint = function(t) {
                        var e = t.x * this.sx + t.y * this.shx + this.tx, n = t.x * this.shy + t.y * this.sy + this.ty;
                        return new gn(e, n);
                    }, Wt.prototype.applyToRectangle = function(t) {
                        var e = this.applyToPoint(t), n = this.applyToPoint(new gn(t.x + t.w, t.y + t.h));
                        return new mn(e.x, e.y, n.x - e.x, n.y - e.y);
                    }, Wt.prototype.clone = function() {
                        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty;
                        return new Wt(t, e, n, r, i, a);
                    }, y.Matrix = Wt;
                    var Vt = y.matrixMult = function(t, e) {
                        return e.multiply(t);
                    }, Gt = new Wt(1, 0, 0, 1, 0, 0);
                    y.unitMatrix = y.identityMatrix = Gt;
                    var Yt = function(t, e) {
                        if (!Ot[t]) {
                            var n = (e instanceof M ? "Sh" : "P") + (Object.keys(Ct).length + 1).toString(10);
                            e.id = n, Ot[t] = n, Ct[n] = e, Dt.publish("addPattern", e);
                        }
                    };
                    y.ShadingPattern = M, y.TilingPattern = q, y.addShadingPattern = function(t, e) {
                        return R("addShadingPattern()"), Yt(t, e), this;
                    }, y.beginTilingPattern = function(t) {
                        R("beginTilingPattern()"), bn(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
                    }, y.endTilingPattern = function(t, e) {
                        R("endTilingPattern()"), e.stream = ot[$].join("\n"), Yt(t, e), Dt.publish("endTilingPattern", e), Ht.pop().restore();
                    };
                    var Jt, Xt = y.__private__.newObject = function() {
                        var t = Kt();
                        return Zt(t, !0), t;
                    }, Kt = y.__private__.newObjectDeferred = function() {
                        return et++, nt[et] = function() {
                            return it;
                        }, et;
                    }, Zt = function(t, e) {
                        return e = "boolean" == typeof e && e, nt[t] = it, e && lt(t + " 0 obj"), t;
                    }, $t = y.__private__.newAdditionalObject = function() {
                        var t = {
                            objId: Kt(),
                            content: ""
                        };
                        return at.push(t), t;
                    }, Qt = Kt(), te = Kt(), ee = y.__private__.decodeColorString = function(t) {
                        var e = t.split(" ");
                        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) 5 !== e.length || "k" !== e[4] && "K" !== e[4] || (e = [
                            (1 - e[0]) * (1 - e[3]),
                            (1 - e[1]) * (1 - e[3]),
                            (1 - e[2]) * (1 - e[3]),
                            "r"
                        ]);
                        else {
                            var n = parseFloat(e[0]);
                            e = [
                                n,
                                n,
                                n,
                                "r"
                            ];
                        }
                        for(var r = "#", i = 0; i < 3; i++)r += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
                        return r;
                    }, ne = y.__private__.encodeColorString = function(e) {
                        var n;
                        "string" == typeof e && (e = {
                            ch1: e
                        });
                        var r = e.ch1, i = e.ch2, a = e.ch3, o = e.ch4, s = "draw" === e.pdfColorType ? [
                            "G",
                            "RG",
                            "K"
                        ] : [
                            "g",
                            "rg",
                            "k"
                        ];
                        if ("string" == typeof r && "#" !== r.charAt(0)) {
                            var u = new h(r);
                            if (u.ok) r = u.toHex();
                            else if (!/^\d*\.?\d*$/.test(r)) throw new Error('Invalid color "' + r + '" passed to jsPDF.encodeColorString.');
                        }
                        if ("string" == typeof r && /^#[0-9A-Fa-f]{3}$/.test(r) && (r = "#" + r[1] + r[1] + r[2] + r[2] + r[3] + r[3]), "string" == typeof r && /^#[0-9A-Fa-f]{6}$/.test(r)) {
                            var c = parseInt(r.substr(1), 16);
                            r = c >> 16 & 255, i = c >> 8 & 255, a = 255 & c;
                        }
                        if (void 0 === i || void 0 === o && r === i && i === a) n = "string" == typeof r ? r + " " + s[0] : 2 === e.precision ? T(r / 255) + " " + s[0] : z(r / 255) + " " + s[0];
                        else if (void 0 === o || "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(o)) {
                            if (o && !isNaN(o.a) && 0 === o.a) return [
                                "1.",
                                "1.",
                                "1.",
                                s[1]
                            ].join(" ");
                            n = "string" == typeof r ? [
                                r,
                                i,
                                a,
                                s[1]
                            ].join(" ") : 2 === e.precision ? [
                                T(r / 255),
                                T(i / 255),
                                T(a / 255),
                                s[1]
                            ].join(" ") : [
                                z(r / 255),
                                z(i / 255),
                                z(a / 255),
                                s[1]
                            ].join(" ");
                        } else n = "string" == typeof r ? [
                            r,
                            i,
                            a,
                            o,
                            s[2]
                        ].join(" ") : 2 === e.precision ? [
                            T(r),
                            T(i),
                            T(a),
                            T(o),
                            s[2]
                        ].join(" ") : [
                            z(r),
                            z(i),
                            z(a),
                            z(o),
                            s[2]
                        ].join(" ");
                        return n;
                    }, re = y.__private__.getFilters = function() {
                        return c;
                    }, ie = y.__private__.putStream = function(t) {
                        var e = (t = t || {}).data || "", n = t.filters || re(), r = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, a = e.length, o = t.objectId, s = function(t) {
                            return t;
                        };
                        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
                        null !== m && (s = je.encryptor(o, 0));
                        var u = {};
                        !0 === n && (n = [
                            "FlateEncode"
                        ]);
                        var c = t.additionalKeyValues || [], l = (u = void 0 !== E.API.processDataByFilters ? E.API.processDataByFilters(e, n) : {
                            data: e,
                            reverseChain: []
                        }).reverseChain + (Array.isArray(r) ? r.join(" ") : r.toString());
                        if (0 !== u.data.length && (c.push({
                            key: "Length",
                            value: u.data.length
                        }), !0 === i && c.push({
                            key: "Length1",
                            value: a
                        })), 0 != l.length) {
                            if (l.split("/").length - 1 == 1) c.push({
                                key: "Filter",
                                value: l
                            });
                            else {
                                c.push({
                                    key: "Filter",
                                    value: "[" + l + "]"
                                });
                                for(var h = 0; h < c.length; h += 1)if ("DecodeParms" === c[h].key) {
                                    for(var f = [], d = 0; d < u.reverseChain.split("/").length - 1; d += 1)f.push("null");
                                    f.push(c[h].value), c[h].value = "[" + f.join(" ") + "]";
                                }
                            }
                        }
                        lt("<<");
                        for(var p = 0; p < c.length; p++)lt("/" + c[p].key + " " + c[p].value);
                        lt(">>"), 0 !== u.data.length && (lt("stream"), lt(s(u.data)), lt("endstream"));
                    }, ae = y.__private__.putPage = function(t) {
                        var e = t.number, n = t.data, r = t.objId, i = t.contentsObjId;
                        Zt(r, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(B(t.mediaBox.bottomLeftX)) + " " + parseFloat(B(t.mediaBox.bottomLeftY)) + " " + B(t.mediaBox.topRightX) + " " + B(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + B(t.cropBox.bottomLeftX) + " " + B(t.cropBox.bottomLeftY) + " " + B(t.cropBox.topRightX) + " " + B(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + B(t.bleedBox.bottomLeftX) + " " + B(t.bleedBox.bottomLeftY) + " " + B(t.bleedBox.topRightX) + " " + B(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + B(t.trimBox.bottomLeftX) + " " + B(t.trimBox.bottomLeftY) + " " + B(t.trimBox.topRightX) + " " + B(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + B(t.artBox.bottomLeftX) + " " + B(t.artBox.bottomLeftY) + " " + B(t.artBox.topRightX) + " " + B(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Dt.publish("putPage", {
                            objId: r,
                            pageContext: Rt[e],
                            pageNumber: e,
                            page: n
                        }), lt("/Contents " + i + " 0 R"), lt(">>"), lt("endobj");
                        var a = n.join("\n");
                        return _ === S && (a += "\nQ"), Zt(i, !0), ie({
                            data: a,
                            filters: re(),
                            objectId: i
                        }), lt("endobj"), r;
                    }, oe = y.__private__.putPages = function() {
                        var t, e, n = [];
                        for(t = 1; t <= Et; t++)Rt[t].objId = Kt(), Rt[t].contentsObjId = Kt();
                        for(t = 1; t <= Et; t++)n.push(ae({
                            number: t,
                            data: ot[t],
                            objId: Rt[t].objId,
                            contentsObjId: Rt[t].contentsObjId,
                            mediaBox: Rt[t].mediaBox,
                            cropBox: Rt[t].cropBox,
                            bleedBox: Rt[t].bleedBox,
                            trimBox: Rt[t].trimBox,
                            artBox: Rt[t].artBox,
                            userUnit: Rt[t].userUnit,
                            rootDictionaryObjId: Qt,
                            resourceDictionaryObjId: te
                        }));
                        Zt(Qt, !0), lt("<</Type /Pages");
                        var r = "/Kids [";
                        for(e = 0; e < Et; e++)r += n[e] + " 0 R ";
                        lt(r + "]"), lt("/Count " + Et), lt(">>"), lt("endobj"), Dt.publish("postPutPages");
                    }, se = function(t) {
                        Dt.publish("putFont", {
                            font: t,
                            out: lt,
                            newObject: Xt,
                            putStream: ie
                        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + j(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
                    }, ue = function(t) {
                        t.objectNumber = Xt();
                        var e = [];
                        e.push({
                            key: "Type",
                            value: "/XObject"
                        }), e.push({
                            key: "Subtype",
                            value: "/Form"
                        }), e.push({
                            key: "BBox",
                            value: "[" + [
                                B(t.x),
                                B(t.y),
                                B(t.x + t.width),
                                B(t.y + t.height)
                            ].join(" ") + "]"
                        }), e.push({
                            key: "Matrix",
                            value: "[" + t.matrix.toString() + "]"
                        });
                        var n = t.pages[1].join("\n");
                        ie({
                            data: n,
                            additionalKeyValues: e,
                            objectId: t.objectNumber
                        }), lt("endobj");
                    }, ce = function(t, e) {
                        e || (e = 21);
                        var n = Xt(), r = function(t, e) {
                            var n, r = [], i = 1 / (e - 1);
                            for(n = 0; n < 1; n += i)r.push(n);
                            if (r.push(1), 0 != t[0].offset) {
                                var a = {
                                    offset: 0,
                                    color: t[0].color
                                };
                                t.unshift(a);
                            }
                            if (1 != t[t.length - 1].offset) {
                                var o = {
                                    offset: 1,
                                    color: t[t.length - 1].color
                                };
                                t.push(o);
                            }
                            for(var s = "", u = 0, c = 0; c < r.length; c++){
                                for(n = r[c]; n > t[u + 1].offset;)u++;
                                var l = t[u].offset, h = (n - l) / (t[u + 1].offset - l), f = t[u].color, d = t[u + 1].color;
                                s += tt(Math.round((1 - h) * f[0] + h * d[0]).toString(16)) + tt(Math.round((1 - h) * f[1] + h * d[1]).toString(16)) + tt(Math.round((1 - h) * f[2] + h * d[2]).toString(16));
                            }
                            return s.trim();
                        }(t.colors, e), i = [];
                        i.push({
                            key: "FunctionType",
                            value: "0"
                        }), i.push({
                            key: "Domain",
                            value: "[0.0 1.0]"
                        }), i.push({
                            key: "Size",
                            value: "[" + e + "]"
                        }), i.push({
                            key: "BitsPerSample",
                            value: "8"
                        }), i.push({
                            key: "Range",
                            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
                        }), i.push({
                            key: "Decode",
                            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
                        }), ie({
                            data: r,
                            additionalKeyValues: i,
                            alreadyAppliedFilters: [
                                "/ASCIIHexDecode"
                            ],
                            objectId: n
                        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
                        var a = "/Coords [" + B(parseFloat(t.coords[0])) + " " + B(parseFloat(t.coords[1])) + " ";
                        2 === t.type ? a += B(parseFloat(t.coords[2])) + " " + B(parseFloat(t.coords[3])) : a += B(parseFloat(t.coords[2])) + " " + B(parseFloat(t.coords[3])) + " " + B(parseFloat(t.coords[4])) + " " + B(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + n + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
                    }, le = function(t, e) {
                        var n = Kt(), r = Xt();
                        e.push({
                            resourcesOid: n,
                            objectOid: r
                        }), t.objectNumber = r;
                        var i = [];
                        i.push({
                            key: "Type",
                            value: "/Pattern"
                        }), i.push({
                            key: "PatternType",
                            value: "1"
                        }), i.push({
                            key: "PaintType",
                            value: "1"
                        }), i.push({
                            key: "TilingType",
                            value: "1"
                        }), i.push({
                            key: "BBox",
                            value: "[" + t.boundingBox.map(B).join(" ") + "]"
                        }), i.push({
                            key: "XStep",
                            value: B(t.xStep)
                        }), i.push({
                            key: "YStep",
                            value: B(t.yStep)
                        }), i.push({
                            key: "Resources",
                            value: n + " 0 R"
                        }), t.matrix && i.push({
                            key: "Matrix",
                            value: "[" + t.matrix.toString() + "]"
                        }), ie({
                            data: t.stream,
                            additionalKeyValues: i,
                            objectId: t.objectNumber
                        }), lt("endobj");
                    }, he = function(t) {
                        for(var e in t.objectNumber = Xt(), lt("<<"), t)switch(e){
                            case "opacity":
                                lt("/ca " + T(t[e]));
                                break;
                            case "stroke-opacity":
                                lt("/CA " + T(t[e]));
                        }
                        lt(">>"), lt("endobj");
                    }, fe = function(t) {
                        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), function() {
                            for(var t in lt("/Font <<"), Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && lt("/" + t + " " + Ft[t].objectNumber + " 0 R");
                            lt(">>");
                        }(), function() {
                            if (Object.keys(Ct).length > 0) {
                                for(var t in lt("/Shading <<"), Ct)Ct.hasOwnProperty(t) && Ct[t] instanceof M && Ct[t].objectNumber >= 0 && lt("/" + t + " " + Ct[t].objectNumber + " 0 R");
                                Dt.publish("putShadingPatternDict"), lt(">>");
                            }
                        }(), function(t) {
                            if (Object.keys(Ct).length > 0) {
                                for(var e in lt("/Pattern <<"), Ct)Ct.hasOwnProperty(e) && Ct[e] instanceof y.TilingPattern && Ct[e].objectNumber >= 0 && Ct[e].objectNumber < t && lt("/" + e + " " + Ct[e].objectNumber + " 0 R");
                                Dt.publish("putTilingPatternDict"), lt(">>");
                            }
                        }(t.objectOid), function() {
                            if (Object.keys(Bt).length > 0) {
                                var t;
                                for(t in lt("/ExtGState <<"), Bt)Bt.hasOwnProperty(t) && Bt[t].objectNumber >= 0 && lt("/" + t + " " + Bt[t].objectNumber + " 0 R");
                                Dt.publish("putGStateDict"), lt(">>");
                            }
                        }(), function() {
                            for(var t in lt("/XObject <<"), zt)zt.hasOwnProperty(t) && zt[t].objectNumber >= 0 && lt("/" + t + " " + zt[t].objectNumber + " 0 R");
                            Dt.publish("putXobjectDict"), lt(">>");
                        }(), lt(">>"), lt("endobj");
                    }, de = function(t) {
                        It[t.fontName] = It[t.fontName] || {}, It[t.fontName][t.fontStyle] = t.id;
                    }, pe = function(t, e, n, r, i) {
                        var a = {
                            id: "F" + (Object.keys(Ft).length + 1).toString(10),
                            postScriptName: t,
                            fontName: e,
                            fontStyle: n,
                            encoding: r,
                            isStandardFont: i || !1,
                            metadata: {}
                        };
                        return Dt.publish("addFont", {
                            font: a,
                            instance: this
                        }), Ft[a.id] = a, de(a), a.id;
                    }, ge = y.__private__.pdfEscape = y.pdfEscape = function(t, e) {
                        return (function(t, e) {
                            var n, r, i, a, o, s, u, c, l;
                            if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && Ft[At].metadata && Ft[At].metadata[i] && Ft[At].metadata[i].encoding && (a = Ft[At].metadata[i].encoding, !o && Ft[At].encoding && (o = Ft[At].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
                                for(u = !1, s = [], n = 0, r = t.length; n < r; n++)(c = o[t.charCodeAt(n)]) ? s.push(String.fromCharCode(c)) : s.push(t[n]), s[n].charCodeAt(0) >> 8 && (u = !0);
                                t = s.join("");
                            }
                            for(n = t.length; void 0 === u && 0 !== n;)t.charCodeAt(n - 1) >> 8 && (u = !0), n--;
                            if (!u) return t;
                            for(s = e.noBOM ? [] : [
                                254,
                                255
                            ], n = 0, r = t.length; n < r; n++){
                                if ((l = (c = t.charCodeAt(n)) >> 8) >> 8) throw new Error("Character at position " + n + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                                s.push(l), s.push(c - (l << 8));
                            }
                            return String.fromCharCode.apply(void 0, s);
                        })(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
                    }, me = y.__private__.beginPage = function(t) {
                        ot[++Et] = [], Rt[Et] = {
                            objId: 0,
                            contentsObjId: 0,
                            userUnit: Number(f),
                            artBox: null,
                            bleedBox: null,
                            cropBox: null,
                            trimBox: null,
                            mediaBox: {
                                bottomLeftX: 0,
                                bottomLeftY: 0,
                                topRightX: Number(t[0]),
                                topRightY: Number(t[1])
                            }
                        }, ye(Et), ct(ot[$]);
                    }, ve = function(t, e) {
                        var n, i, a;
                        switch(r = e || r, "string" == typeof t && (n = x(t.toLowerCase()), Array.isArray(n) && (i = n[0], a = n[1])), Array.isArray(t) && (i = t[0] * St, a = t[1] * St), isNaN(i) && (i = s[0], a = s[1]), (i > 14400 || a > 14400) && (o.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), i = Math.min(14400, i), a = Math.min(14400, a)), s = [
                            i,
                            a
                        ], r.substr(0, 1)){
                            case "l":
                                a > i && (s = [
                                    a,
                                    i
                                ]);
                                break;
                            case "p":
                                i > a && (s = [
                                    a,
                                    i
                                ]);
                        }
                        me(s), Ze(Xe), lt(on), 0 !== fn && lt(fn + " J"), 0 !== dn && lt(dn + " j"), Dt.publish("addPage", {
                            pageNumber: Et
                        });
                    }, be = function(t) {
                        t > 0 && t <= Et && (ot.splice(t, 1), Rt.splice(t, 1), Et--, $ > Et && ($ = Et), this.setPage($));
                    }, ye = function(t) {
                        t > 0 && t <= Et && ($ = t);
                    }, we = y.__private__.getNumberOfPages = y.getNumberOfPages = function() {
                        return ot.length - 1;
                    }, Ne = function(t, e, n) {
                        var r, i = void 0;
                        return n = n || {}, t = void 0 !== t ? t : Ft[At].fontName, e = void 0 !== e ? e : Ft[At].fontStyle, r = t.toLowerCase(), void 0 !== It[r] && void 0 !== It[r][e] ? i = It[r][e] : void 0 !== It[t] && void 0 !== It[t][e] ? i = It[t][e] : !1 === n.disableWarning && o.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || n.noFallback || null == (i = It.times[e]) && (i = It.times.normal), i;
                    }, Le = y.__private__.putInfo = function() {
                        var t = Xt(), e = function(t) {
                            return t;
                        };
                        for(var n in null !== m && (e = je.encryptor(t, 0)), lt("<<"), lt("/Producer (" + ge(e("jsPDF " + E.version)) + ")"), xt)xt.hasOwnProperty(n) && xt[n] && lt("/" + n.substr(0, 1).toUpperCase() + n.substr(1) + " (" + ge(e(xt[n])) + ")");
                        lt("/CreationDate (" + ge(e(W)) + ")"), lt(">>"), lt("endobj");
                    }, xe = y.__private__.putCatalog = function(t) {
                        var e = (t = t || {}).rootDictionaryObjId || Qt;
                        switch(Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + e + " 0 R"), gt || (gt = "fullwidth"), gt){
                            case "fullwidth":
                                lt("/OpenAction [3 0 R /FitH null]");
                                break;
                            case "fullheight":
                                lt("/OpenAction [3 0 R /FitV null]");
                                break;
                            case "fullpage":
                                lt("/OpenAction [3 0 R /Fit]");
                                break;
                            case "original":
                                lt("/OpenAction [3 0 R /XYZ null null 1]");
                                break;
                            default:
                                var n = "" + gt;
                                "%" === n.substr(n.length - 1) && (gt = parseInt(gt) / 100), "number" == typeof gt && lt("/OpenAction [3 0 R /XYZ null null " + T(gt) + "]");
                        }
                        switch(wt || (wt = "continuous"), wt){
                            case "continuous":
                                lt("/PageLayout /OneColumn");
                                break;
                            case "single":
                                lt("/PageLayout /SinglePage");
                                break;
                            case "two":
                            case "twoleft":
                                lt("/PageLayout /TwoColumnLeft");
                                break;
                            case "tworight":
                                lt("/PageLayout /TwoColumnRight");
                        }
                        bt && lt("/PageMode /" + bt), Dt.publish("putCatalog"), lt(">>"), lt("endobj");
                    }, Ae = y.__private__.putTrailer = function() {
                        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + je.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
                    }, Se = y.__private__.putHeader = function() {
                        lt("%PDF-" + w), lt("%\xba\xdf\xac\xe0");
                    }, _e = y.__private__.putXRef = function() {
                        var t = "0000000000";
                        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
                        for(var e = 1; e <= et; e++)"function" == typeof nt[e] ? lt((t + nt[e]()).slice(-10) + " 00000 n ") : void 0 !== nt[e] ? lt((t + nt[e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
                    }, Pe = y.__private__.buildDocument = function() {
                        var t;
                        et = 0, it = 0, rt = [], nt = [], at = [], Qt = Kt(), te = Kt(), ct(rt), Dt.publish("buildDocument"), Se(), oe(), function() {
                            Dt.publish("putAdditionalObjects");
                            for(var t = 0; t < at.length; t++){
                                var e = at[t];
                                Zt(e.objId, !0), lt(e.content), lt("endobj");
                            }
                            Dt.publish("postPutAdditionalObjects");
                        }(), t = [], function() {
                            for(var t in Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && se(Ft[t]);
                        }(), function() {
                            var t;
                            for(t in Bt)Bt.hasOwnProperty(t) && he(Bt[t]);
                        }(), function() {
                            for(var t in zt)zt.hasOwnProperty(t) && ue(zt[t]);
                        }(), function(t) {
                            var e;
                            for(e in Ct)Ct.hasOwnProperty(e) && (Ct[e] instanceof M ? ce(Ct[e]) : Ct[e] instanceof q && le(Ct[e], t));
                        }(t), Dt.publish("putResources"), t.forEach(fe), fe({
                            resourcesOid: te,
                            objectOid: Number.MAX_SAFE_INTEGER
                        }), Dt.publish("postPutResources"), null !== m && (je.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + je.v), lt("/R " + je.r), lt("/U <" + je.toHexString(je.U) + ">"), lt("/O <" + je.toHexString(je.O) + ">"), lt("/P " + je.P), lt(">>"), lt("endobj")), Le(), xe();
                        var e = it;
                        return _e(), Ae(), lt("startxref"), lt("" + e), lt("%%EOF"), ct(ot[$]), rt.join("\n");
                    }, ke = y.__private__.getBlob = function(t) {
                        return new Blob([
                            ft(t)
                        ], {
                            type: "application/pdf"
                        });
                    }, Fe = y.output = y.__private__.output = (Jt = function(t, e) {
                        switch("string" == typeof (e = e || {}) ? e = {
                            filename: e
                        } : e.filename = e.filename || "generated.pdf", t){
                            case void 0:
                                return Pe();
                            case "save":
                                y.save(e.filename);
                                break;
                            case "arraybuffer":
                                return ft(Pe());
                            case "blob":
                                return ke(Pe());
                            case "bloburi":
                            case "bloburl":
                                if (void 0 !== i.URL && "function" == typeof i.URL.createObjectURL) return i.URL && i.URL.createObjectURL(ke(Pe())) || void 0;
                                o.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                                break;
                            case "datauristring":
                            case "dataurlstring":
                                var n = "", r = Pe();
                                try {
                                    n = d(r);
                                } catch (m) {
                                    n = d(unescape(encodeURIComponent(r)));
                                }
                                return "data:application/pdf;filename=" + e.filename + ";base64," + n;
                            case "pdfobjectnewwindow":
                                if ("[object Window]" === Object.prototype.toString.call(i)) {
                                    var a = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", s = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
                                    e.pdfObjectUrl && (a = e.pdfObjectUrl, s = "");
                                    var u = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + a + '"' + s + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e) + ");<\/script></body></html>", c = i.open();
                                    return null !== c && c.document.write(u), c;
                                }
                                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
                            case "pdfjsnewwindow":
                                if ("[object Window]" === Object.prototype.toString.call(i)) {
                                    var l = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e.filename + '" width="500px" height="400px" /></body></html>', h = i.open();
                                    if (null !== h) {
                                        h.document.write(l);
                                        var f = this;
                                        h.document.documentElement.querySelector("#pdfViewer").onload = function() {
                                            h.document.title = e.filename, h.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(f.output("bloburl"));
                                        };
                                    }
                                    return h;
                                }
                                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
                            case "dataurlnewwindow":
                                if ("[object Window]" !== Object.prototype.toString.call(i)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                                var p = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e) + '"></iframe></body></html>', g = i.open();
                                if (null !== g && (g.document.write(p), g.document.title = e.filename), g || "undefined" == typeof safari) return g;
                                break;
                            case "datauri":
                            case "dataurl":
                                return i.document.location.href = this.output("datauristring", e);
                            default:
                                return null;
                        }
                    }, Jt.foo = function() {
                        try {
                            return Jt.apply(this, arguments);
                        } catch (n) {
                            var t = n.stack || "";
                            ~t.indexOf(" at ") && (t = t.split(" at ")[1]);
                            var e = "Error in function " + t.split("\n")[0].split("<")[0] + ": " + n.message;
                            if (!i.console) throw new Error(e);
                            i.console.error(e, n), i.alert && alert(e);
                        }
                    }, Jt.foo.bar = Jt, Jt.foo), Ie = function(t) {
                        return !0 === Array.isArray(Tt) && Tt.indexOf(t) > -1;
                    };
                    switch(a){
                        case "pt":
                            St = 1;
                            break;
                        case "mm":
                            St = 72 / 25.4;
                            break;
                        case "cm":
                            St = 72 / 2.54;
                            break;
                        case "in":
                            St = 72;
                            break;
                        case "px":
                            St = 1 == Ie("px_scaling") ? .75 : 96 / 72;
                            break;
                        case "pc":
                        case "em":
                            St = 12;
                            break;
                        case "ex":
                            St = 6;
                            break;
                        default:
                            if ("number" != typeof a) throw new Error("Invalid unit: " + a);
                            St = a;
                    }
                    var je = null;
                    K(), Y();
                    var Ce = y.__private__.getPageInfo = y.getPageInfo = function(t) {
                        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
                        return {
                            objId: Rt[t].objId,
                            pageNumber: t,
                            pageContext: Rt[t]
                        };
                    }, Oe = y.__private__.getPageInfoByObjId = function(t) {
                        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
                        for(var e in Rt)if (Rt[e].objId === t) break;
                        return Ce(e);
                    }, Be = y.__private__.getCurrentPageInfo = y.getCurrentPageInfo = function() {
                        return {
                            objId: Rt[$].objId,
                            pageNumber: $,
                            pageContext: Rt[$]
                        };
                    };
                    y.addPage = function() {
                        return ve.apply(this, arguments), this;
                    }, y.setPage = function() {
                        return ye.apply(this, arguments), ct.call(this, ot[$]), this;
                    }, y.insertPage = function(t) {
                        return this.addPage(), this.movePage($, t), this;
                    }, y.movePage = function(t, e) {
                        var n, r;
                        if (t > e) {
                            n = ot[t], r = Rt[t];
                            for(var i = t; i > e; i--)ot[i] = ot[i - 1], Rt[i] = Rt[i - 1];
                            ot[e] = n, Rt[e] = r, this.setPage(e);
                        } else if (t < e) {
                            n = ot[t], r = Rt[t];
                            for(var a = t; a < e; a++)ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
                            ot[e] = n, Rt[e] = r, this.setPage(e);
                        }
                        return this;
                    }, y.deletePage = function() {
                        return be.apply(this, arguments), this;
                    }, y.__private__.text = y.text = function(e, n, r, i, a) {
                        var o, s, u, c, l, h, f, d, p, g = (i = i || {}).scope || this;
                        if ("number" == typeof e && "number" == typeof n && ("string" == typeof r || Array.isArray(r))) {
                            var m = r;
                            r = n, n = e, e = m;
                        }
                        if (arguments[3] instanceof Wt == 0 ? (u = arguments[4], c = arguments[5], "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(f = arguments[3]) && null !== f || ("string" == typeof u && (c = u, u = null), "string" == typeof f && (c = f, f = null), "number" == typeof f && (u = f, f = null), i = {
                            flags: f,
                            angle: u,
                            align: c
                        })) : (R("The transform parameter of text() with a Matrix value"), p = a), isNaN(n) || isNaN(r) || null == e) throw new Error("Invalid arguments passed to jsPDF.text");
                        if (0 === e.length) return g;
                        var v, y = "", w = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : Je, N = g.internal.scaleFactor;
                        function L(t) {
                            return t = t.split("\t").join(Array(i.TabLen || 9).join(" ")), ge(t, f);
                        }
                        function x(t) {
                            for(var e, n = t.concat(), r = [], i = n.length; i--;)"string" == typeof (e = n.shift()) ? r.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? r.push(e[0]) : r.push([
                                e[0],
                                e[1],
                                e[2]
                            ]);
                            return r;
                        }
                        function A(t, e) {
                            var n;
                            if ("string" == typeof t) n = e(t)[0];
                            else if (Array.isArray(t)) {
                                for(var r, i, a = t.concat(), o = [], s = a.length; s--;)"string" == typeof (r = a.shift()) ? o.push(e(r)[0]) : Array.isArray(r) && "string" == typeof r[0] && (i = e(r[0], r[1], r[2]), o.push([
                                    i[0],
                                    i[1],
                                    i[2]
                                ]));
                                n = o;
                            }
                            return n;
                        }
                        var P = !1, k = !0;
                        if ("string" == typeof e) P = !0;
                        else if (Array.isArray(e)) {
                            var F = e.concat();
                            s = [];
                            for(var I, j = F.length; j--;)("string" != typeof (I = F.shift()) || Array.isArray(I) && "string" != typeof I[0]) && (k = !1);
                            P = k;
                        }
                        if (!1 === P) throw new Error('Type of text must be string or Array. "' + e + '" is not recognized.');
                        "string" == typeof e && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [
                            e
                        ]);
                        var C = pt / g.internal.scaleFactor, O = C * (w - 1);
                        switch(i.baseline){
                            case "bottom":
                                r -= O;
                                break;
                            case "top":
                                r += C - O;
                                break;
                            case "hanging":
                                r += C - 2 * O;
                                break;
                            case "middle":
                                r += C / 2 - O;
                        }
                        if ((h = i.maxWidth || 0) > 0 && ("string" == typeof e ? e = g.splitTextToSize(e, h) : "[object Array]" === Object.prototype.toString.call(e) && (e = e.reduce(function(t, e) {
                            return t.concat(g.splitTextToSize(e, h));
                        }, []))), o = {
                            text: e,
                            x: n,
                            y: r,
                            options: i,
                            mutex: {
                                pdfEscape: ge,
                                activeFontKey: At,
                                fonts: Ft,
                                activeFontSize: pt
                            }
                        }, Dt.publish("preProcessText", o), e = o.text, u = (i = o.options).angle, p instanceof Wt == 0 && u && "number" == typeof u) {
                            u *= Math.PI / 180, 0 === i.rotationDirection && (u = -u), _ === S && (u = -u);
                            var M = Math.cos(u), q = Math.sin(u);
                            p = new Wt(M, q, -q, M, 0, 0);
                        } else u && u instanceof Wt && (p = u);
                        _ !== S || p || (p = Gt), void 0 !== (l = i.charSpace || ln) && (y += B(U(l)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), void 0 !== (d = i.horizontalScale) && (y += B(100 * d) + " Tz\n"), i.lang;
                        var E = -1, D = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, T = g.internal.getCurrentPageInfo().pageContext;
                        switch(D){
                            case 0:
                            case !1:
                            case "fill":
                                E = 0;
                                break;
                            case 1:
                            case !0:
                            case "stroke":
                                E = 1;
                                break;
                            case 2:
                            case "fillThenStroke":
                                E = 2;
                                break;
                            case 3:
                            case "invisible":
                                E = 3;
                                break;
                            case 4:
                            case "fillAndAddForClipping":
                                E = 4;
                                break;
                            case 5:
                            case "strokeAndAddPathForClipping":
                                E = 5;
                                break;
                            case 6:
                            case "fillThenStrokeAndAddToPathForClipping":
                                E = 6;
                                break;
                            case 7:
                            case "addToPathForClipping":
                                E = 7;
                        }
                        var z = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
                        -1 !== E ? y += E + " Tr\n" : -1 !== z && (y += "0 Tr\n"), -1 !== E && (T.usedRenderingMode = E), c = i.align || "left";
                        var H, W = pt * w, V = g.internal.pageSize.getWidth(), G = Ft[At];
                        l = i.charSpace || ln, h = i.maxWidth || 0, f = Object.assign({
                            autoencode: !0,
                            noBOM: !0
                        }, i.flags);
                        var Y = [], J = function(t) {
                            return g.getStringUnitWidth(t, {
                                font: G,
                                charSpace: l,
                                fontSize: pt,
                                doKerning: !1
                            }) * pt / N;
                        };
                        if ("[object Array]" === Object.prototype.toString.call(e)) {
                            var X;
                            s = x(e), "left" !== c && (H = s.map(J));
                            var K, Z = 0;
                            if ("right" === c) {
                                n -= H[0], e = [], j = s.length;
                                for(var $ = 0; $ < j; $++)0 === $ ? (K = en(n), X = nn(r)) : (K = U(Z - H[$]), X = -W), e.push([
                                    s[$],
                                    K,
                                    X
                                ]), Z = H[$];
                            } else if ("center" === c) {
                                n -= H[0] / 2, e = [], j = s.length;
                                for(var Q = 0; Q < j; Q++)0 === Q ? (K = en(n), X = nn(r)) : (K = U((Z - H[Q]) / 2), X = -W), e.push([
                                    s[Q],
                                    K,
                                    X
                                ]), Z = H[Q];
                            } else if ("left" === c) {
                                e = [], j = s.length;
                                for(var tt = 0; tt < j; tt++)e.push(s[tt]);
                            } else if ("justify" === c && "Identity-H" === G.encoding) {
                                e = [], j = s.length, h = 0 !== h ? h : V;
                                for(var et = 0, nt = 0; nt < j; nt++)if (X = 0 === nt ? nn(r) : -W, K = 0 === nt ? en(n) : et, nt < j - 1) {
                                    var rt = U((h - H[nt]) / (s[nt].split(" ").length - 1)), it = s[nt].split(" ");
                                    e.push([
                                        it[0] + " ",
                                        K,
                                        X
                                    ]), et = 0;
                                    for(var at = 1; at < it.length; at++){
                                        var ot = (J(it[at - 1] + " " + it[at]) - J(it[at])) * N + rt;
                                        at == it.length - 1 ? e.push([
                                            it[at],
                                            ot,
                                            0
                                        ]) : e.push([
                                            it[at] + " ",
                                            ot,
                                            0
                                        ]), et -= ot;
                                    }
                                } else e.push([
                                    s[nt],
                                    K,
                                    X
                                ]);
                                e.push([
                                    "",
                                    et,
                                    0
                                ]);
                            } else {
                                if ("justify" !== c) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                                for(e = [], j = s.length, h = 0 !== h ? h : V, nt = 0; nt < j; nt++){
                                    X = 0 === nt ? nn(r) : -W, K = 0 === nt ? en(n) : 0;
                                    var st = s[nt].split(" ").length - 1, ut = st > 0 ? (h - H[nt]) / st : 0;
                                    nt < j - 1 ? Y.push(B(U(ut))) : Y.push(0), e.push([
                                        s[nt],
                                        K,
                                        X
                                    ]);
                                }
                            }
                        }
                        !0 === ("boolean" == typeof i.R2L ? i.R2L : vt) && (e = A(e, function(t, e, n) {
                            return [
                                t.split("").reverse().join(""),
                                e,
                                n
                            ];
                        })), o = {
                            text: e,
                            x: n,
                            y: r,
                            options: i,
                            mutex: {
                                pdfEscape: ge,
                                activeFontKey: At,
                                fonts: Ft,
                                activeFontSize: pt
                            }
                        }, Dt.publish("postProcessText", o), e = o.text, v = o.mutex.isHex || !1;
                        var ct = Ft[At].encoding;
                        "WinAnsiEncoding" !== ct && "StandardEncoding" !== ct || (e = A(e, function(t, e, n) {
                            return [
                                L(t),
                                e,
                                n
                            ];
                        })), s = x(e), e = [];
                        for(var ht, ft, dt, gt = Array.isArray(s[0]) ? 1 : 0, mt = "", bt = function(t, e, n) {
                            var r = "";
                            return n instanceof Wt ? (n = "number" == typeof i.angle ? Vt(n, new Wt(1, 0, 0, 1, t, e)) : Vt(new Wt(1, 0, 0, 1, t, e), n), _ === S && (n = Vt(new Wt(1, 0, 0, -1, 0, 0), n)), r = n.join(" ") + " Tm\n") : r = B(t) + " " + B(e) + " Td\n", r;
                        }, yt = 0; yt < s.length; yt++){
                            switch(mt = "", gt){
                                case 1:
                                    dt = (v ? "<" : "(") + s[yt][0] + (v ? ">" : ")"), ht = parseFloat(s[yt][1]), ft = parseFloat(s[yt][2]);
                                    break;
                                case 0:
                                    dt = (v ? "<" : "(") + s[yt] + (v ? ">" : ")"), ht = en(n), ft = nn(r);
                            }
                            void 0 !== Y && void 0 !== Y[yt] && (mt = Y[yt] + " Tw\n"), 0 === yt ? e.push(mt + bt(ht, ft, p) + dt) : 0 === gt ? e.push(mt + dt) : 1 === gt && e.push(mt + bt(ht, ft, p) + dt);
                        }
                        e = 0 === gt ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
                        var wt = "BT\n/";
                        return wt += At + " " + pt + " Tf\n", wt += B(pt * w) + " TL\n", wt += un + "\n", wt += y, wt += e, lt(wt += "ET"), b[At] = !0, g;
                    };
                    var Me = y.__private__.clip = y.clip = function(t) {
                        return lt("evenodd" === t ? "W*" : "W"), this;
                    };
                    y.clipEvenOdd = function() {
                        return Me("evenodd");
                    }, y.__private__.discardPath = y.discardPath = function() {
                        return lt("n"), this;
                    };
                    var qe = y.__private__.isValidStyle = function(t) {
                        var e = !1;
                        return -1 !== [
                            void 0,
                            null,
                            "S",
                            "D",
                            "F",
                            "DF",
                            "FD",
                            "f",
                            "f*",
                            "B",
                            "B*",
                            "n"
                        ].indexOf(t) && (e = !0), e;
                    };
                    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation = function(t) {
                        return qe(t) && (g = t), this;
                    };
                    var Ee = y.__private__.getStyle = y.getStyle = function(t) {
                        var e = g;
                        switch(t){
                            case "D":
                            case "S":
                                e = "S";
                                break;
                            case "F":
                                e = "f";
                                break;
                            case "FD":
                            case "DF":
                                e = "B";
                                break;
                            case "f":
                            case "f*":
                            case "B":
                            case "B*":
                                e = t;
                        }
                        return e;
                    }, Re = y.close = function() {
                        return lt("h"), this;
                    };
                    y.stroke = function() {
                        return lt("S"), this;
                    }, y.fill = function(t) {
                        return De("f", t), this;
                    }, y.fillEvenOdd = function(t) {
                        return De("f*", t), this;
                    }, y.fillStroke = function(t) {
                        return De("B", t), this;
                    }, y.fillStrokeEvenOdd = function(t) {
                        return De("B*", t), this;
                    };
                    var De = function(e, n) {
                        "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(n) ? Ue(n, e) : lt(e);
                    }, Te = function(t) {
                        null === t || _ === S && void 0 === t || (t = Ee(t), lt(t));
                    };
                    function ze(t, e, n, r, i) {
                        var a = new q(e || this.boundingBox, n || this.xStep, r || this.yStep, this.gState, i || this.matrix);
                        a.stream = this.stream;
                        var o = t + "$$" + this.cloneIndex++ + "$$";
                        return Yt(o, a), a;
                    }
                    var Ue = function(t, e) {
                        var n = Ot[t.key], r = Ct[n];
                        if (r instanceof M) lt("q"), lt(He(e)), r.gState && y.setGState(r.gState), lt(t.matrix.toString() + " cm"), lt("/" + n + " sh"), lt("Q");
                        else if (r instanceof q) {
                            var i = new Wt(1, 0, 0, -1, 0, _n());
                            t.matrix && (i = i.multiply(t.matrix || Gt), n = ze.call(r, t.key, t.boundingBox, t.xStep, t.yStep, i).id), lt("q"), lt("/Pattern cs"), lt("/" + n + " scn"), r.gState && y.setGState(r.gState), lt(e), lt("Q");
                        }
                    }, He = function(t) {
                        switch(t){
                            case "f":
                            case "F":
                            case "n":
                                return "W n";
                            case "f*":
                                return "W* n";
                            case "B":
                            case "S":
                                return "W S";
                            case "B*":
                                return "W* S";
                        }
                    }, We = y.moveTo = function(t, e) {
                        return lt(B(U(t)) + " " + B(H(e)) + " m"), this;
                    }, Ve = y.lineTo = function(t, e) {
                        return lt(B(U(t)) + " " + B(H(e)) + " l"), this;
                    }, Ge = y.curveTo = function(t, e, n, r, i, a) {
                        return lt([
                            B(U(t)),
                            B(H(e)),
                            B(U(n)),
                            B(H(r)),
                            B(U(i)),
                            B(H(a)),
                            "c"
                        ].join(" ")), this;
                    };
                    y.__private__.line = y.line = function(t, e, n, r, i) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.line");
                        return _ === A ? this.lines([
                            [
                                n - t,
                                r - e
                            ]
                        ], t, e, [
                            1,
                            1
                        ], i || "S") : this.lines([
                            [
                                n - t,
                                r - e
                            ]
                        ], t, e, [
                            1,
                            1
                        ]).stroke();
                    }, y.__private__.lines = y.lines = function(t, e, n, r, i, a) {
                        var o, s, u, c, l, h, f, d, p, g, m, v;
                        if ("number" == typeof t && (v = n, n = e, e = t, t = v), r = r || [
                            1,
                            1
                        ], a = a || !1, isNaN(e) || isNaN(n) || !Array.isArray(t) || !Array.isArray(r) || !qe(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
                        for(We(e, n), o = r[0], s = r[1], c = t.length, g = e, m = n, u = 0; u < c; u++)2 === (l = t[u]).length ? (g = l[0] * o + g, m = l[1] * s + m, Ve(g, m)) : (h = l[0] * o + g, f = l[1] * s + m, d = l[2] * o + g, p = l[3] * s + m, g = l[4] * o + g, m = l[5] * s + m, Ge(h, f, d, p, g, m));
                        return a && Re(), Te(i), this;
                    }, y.path = function(t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e], r = n.c;
                            switch(n.op){
                                case "m":
                                    We(r[0], r[1]);
                                    break;
                                case "l":
                                    Ve(r[0], r[1]);
                                    break;
                                case "c":
                                    Ge.apply(this, r);
                                    break;
                                case "h":
                                    Re();
                            }
                        }
                        return this;
                    }, y.__private__.rect = y.rect = function(t, e, n, r, i) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
                        return _ === A && (r = -r), lt([
                            B(U(t)),
                            B(H(e)),
                            B(U(n)),
                            B(U(r)),
                            "re"
                        ].join(" ")), Te(i), this;
                    }, y.__private__.triangle = y.triangle = function(t, e, n, r, i, a, o) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !qe(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
                        return this.lines([
                            [
                                n - t,
                                r - e
                            ],
                            [
                                i - n,
                                a - r
                            ],
                            [
                                t - i,
                                e - a
                            ]
                        ], t, e, [
                            1,
                            1
                        ], o, !0), this;
                    }, y.__private__.roundedRect = y.roundedRect = function(t, e, n, r, i, a, o) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !qe(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
                        var s = 4 / 3 * (Math.SQRT2 - 1);
                        return i = Math.min(i, .5 * n), a = Math.min(a, .5 * r), this.lines([
                            [
                                n - 2 * i,
                                0
                            ],
                            [
                                i * s,
                                0,
                                i,
                                a - a * s,
                                i,
                                a
                            ],
                            [
                                0,
                                r - 2 * a
                            ],
                            [
                                0,
                                a * s,
                                -i * s,
                                a,
                                -i,
                                a
                            ],
                            [
                                2 * i - n,
                                0
                            ],
                            [
                                -i * s,
                                0,
                                -i,
                                -a * s,
                                -i,
                                -a
                            ],
                            [
                                0,
                                2 * a - r
                            ],
                            [
                                0,
                                -a * s,
                                i * s,
                                -a,
                                i,
                                -a
                            ]
                        ], t + i, e, [
                            1,
                            1
                        ], o, !0), this;
                    }, y.__private__.ellipse = y.ellipse = function(t, e, n, r, i) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
                        var a = 4 / 3 * (Math.SQRT2 - 1) * n, o = 4 / 3 * (Math.SQRT2 - 1) * r;
                        return We(t + n, e), Ge(t + n, e - o, t + a, e - r, t, e - r), Ge(t - a, e - r, t - n, e - o, t - n, e), Ge(t - n, e + o, t - a, e + r, t, e + r), Ge(t + a, e + r, t + n, e + o, t + n, e), Te(i), this;
                    }, y.__private__.circle = y.circle = function(t, e, n, r) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || !qe(r)) throw new Error("Invalid arguments passed to jsPDF.circle");
                        return this.ellipse(t, e, n, n, r);
                    }, y.setFont = function(t, e, n) {
                        return n && (e = F(e, n)), At = Ne(t, e, {
                            disableWarning: !1
                        }), this;
                    };
                    var Ye = y.__private__.getFont = y.getFont = function() {
                        return Ft[Ne.apply(y, arguments)];
                    };
                    y.__private__.getFontList = y.getFontList = function() {
                        var t, e, n = {};
                        for(t in It)if (It.hasOwnProperty(t)) for(e in n[t] = [], It[t])It[t].hasOwnProperty(e) && n[t].push(e);
                        return n;
                    }, y.addFont = function(t, e, n, r, i) {
                        var a = [
                            "StandardEncoding",
                            "MacRomanEncoding",
                            "Identity-H",
                            "WinAnsiEncoding"
                        ];
                        return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (n = F(n, r)), pe.call(this, t, e, n, i = i || "Identity-H");
                    };
                    var Je, Xe = e.lineWidth || .200025, Ke = y.__private__.getLineWidth = y.getLineWidth = function() {
                        return Xe;
                    }, Ze = y.__private__.setLineWidth = y.setLineWidth = function(t) {
                        return Xe = t, lt(B(U(t)) + " w"), this;
                    };
                    y.__private__.setLineDash = E.API.setLineDash = E.API.setLineDashPattern = function(t, e) {
                        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
                        return t = t.map(function(t) {
                            return B(U(t));
                        }).join(" "), e = B(U(e)), lt("[" + t + "] " + e + " d"), this;
                    };
                    var $e = y.__private__.getLineHeight = y.getLineHeight = function() {
                        return pt * Je;
                    };
                    y.__private__.getLineHeight = y.getLineHeight = function() {
                        return pt * Je;
                    };
                    var Qe = y.__private__.setLineHeightFactor = y.setLineHeightFactor = function(t) {
                        return "number" == typeof (t = t || 1.15) && (Je = t), this;
                    }, tn = y.__private__.getLineHeightFactor = y.getLineHeightFactor = function() {
                        return Je;
                    };
                    Qe(e.lineHeight);
                    var en = y.__private__.getHorizontalCoordinate = function(t) {
                        return U(t);
                    }, nn = y.__private__.getVerticalCoordinate = function(t) {
                        return _ === S ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
                    }, rn = y.__private__.getHorizontalCoordinateString = y.getHorizontalCoordinateString = function(t) {
                        return B(en(t));
                    }, an = y.__private__.getVerticalCoordinateString = y.getVerticalCoordinateString = function(t) {
                        return B(nn(t));
                    }, on = e.strokeColor || "0 G";
                    y.__private__.getStrokeColor = y.getDrawColor = function() {
                        return ee(on);
                    }, y.__private__.setStrokeColor = y.setDrawColor = function(t, e, n, r) {
                        return on = ne({
                            ch1: t,
                            ch2: e,
                            ch3: n,
                            ch4: r,
                            pdfColorType: "draw",
                            precision: 2
                        }), lt(on), this;
                    };
                    var sn = e.fillColor || "0 g";
                    y.__private__.getFillColor = y.getFillColor = function() {
                        return ee(sn);
                    }, y.__private__.setFillColor = y.setFillColor = function(t, e, n, r) {
                        return sn = ne({
                            ch1: t,
                            ch2: e,
                            ch3: n,
                            ch4: r,
                            pdfColorType: "fill",
                            precision: 2
                        }), lt(sn), this;
                    };
                    var un = e.textColor || "0 g", cn = y.__private__.getTextColor = y.getTextColor = function() {
                        return ee(un);
                    };
                    y.__private__.setTextColor = y.setTextColor = function(t, e, n, r) {
                        return un = ne({
                            ch1: t,
                            ch2: e,
                            ch3: n,
                            ch4: r,
                            pdfColorType: "text",
                            precision: 3
                        }), this;
                    };
                    var ln = e.charSpace, hn = y.__private__.getCharSpace = y.getCharSpace = function() {
                        return parseFloat(ln || 0);
                    };
                    y.__private__.setCharSpace = y.setCharSpace = function(t) {
                        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
                        return ln = t, this;
                    };
                    var fn = 0;
                    y.CapJoinStyles = {
                        0: 0,
                        butt: 0,
                        but: 0,
                        miter: 0,
                        1: 1,
                        round: 1,
                        rounded: 1,
                        circle: 1,
                        2: 2,
                        projecting: 2,
                        project: 2,
                        square: 2,
                        bevel: 2
                    }, y.__private__.setLineCap = y.setLineCap = function(t) {
                        var e = y.CapJoinStyles[t];
                        if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                        return fn = e, lt(e + " J"), this;
                    };
                    var dn = 0;
                    y.__private__.setLineJoin = y.setLineJoin = function(t) {
                        var e = y.CapJoinStyles[t];
                        if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                        return dn = e, lt(e + " j"), this;
                    }, y.__private__.setLineMiterLimit = y.__private__.setMiterLimit = y.setLineMiterLimit = y.setMiterLimit = function(t) {
                        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
                        return lt(B(U(t)) + " M"), this;
                    }, y.GState = O, y.setGState = function(t) {
                        (t = "string" == typeof t ? Bt[Mt[t]] : pn(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
                    };
                    var pn = function(t, e) {
                        if (!t || !Mt[t]) {
                            var n = !1;
                            for(var r in Bt)if (Bt.hasOwnProperty(r) && Bt[r].equals(e)) {
                                n = !0;
                                break;
                            }
                            if (n) e = Bt[r];
                            else {
                                var i = "GS" + (Object.keys(Bt).length + 1).toString(10);
                                Bt[i] = e, e.id = i;
                            }
                            return t && (Mt[t] = e.id), Dt.publish("addGState", e), e;
                        }
                    };
                    y.addGState = function(t, e) {
                        return pn(t, e), this;
                    }, y.saveGraphicsState = function() {
                        return lt("q"), jt.push({
                            key: At,
                            size: pt,
                            color: un
                        }), this;
                    }, y.restoreGraphicsState = function() {
                        lt("Q");
                        var t = jt.pop();
                        return At = t.key, pt = t.size, un = t.color, qt = null, this;
                    }, y.setCurrentTransformationMatrix = function(t) {
                        return lt(t.toString() + " cm"), this;
                    }, y.comment = function(t) {
                        return lt("#" + t), this;
                    };
                    var gn = function(t, e) {
                        var n = t || 0;
                        Object.defineProperty(this, "x", {
                            enumerable: !0,
                            get: function() {
                                return n;
                            },
                            set: function(t) {
                                isNaN(t) || (n = parseFloat(t));
                            }
                        });
                        var r = e || 0;
                        Object.defineProperty(this, "y", {
                            enumerable: !0,
                            get: function() {
                                return r;
                            },
                            set: function(t) {
                                isNaN(t) || (r = parseFloat(t));
                            }
                        });
                        var i = "pt";
                        return Object.defineProperty(this, "type", {
                            enumerable: !0,
                            get: function() {
                                return i;
                            },
                            set: function(t) {
                                i = t.toString();
                            }
                        }), this;
                    }, mn = function(t, e, n, r) {
                        gn.call(this, t, e), this.type = "rect";
                        var i = n || 0;
                        Object.defineProperty(this, "w", {
                            enumerable: !0,
                            get: function() {
                                return i;
                            },
                            set: function(t) {
                                isNaN(t) || (i = parseFloat(t));
                            }
                        });
                        var a = r || 0;
                        return Object.defineProperty(this, "h", {
                            enumerable: !0,
                            get: function() {
                                return a;
                            },
                            set: function(t) {
                                isNaN(t) || (a = parseFloat(t));
                            }
                        }), this;
                    }, vn = function() {
                        this.page = Et, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = _t, this.y = Pt, this.matrix = kt, this.width = wn($), this.height = Ln($), this.outputDestination = ut, this.id = "", this.objectNumber = -1;
                    };
                    vn.prototype.restore = function() {
                        Et = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, _t = this.x, Pt = this.y, kt = this.matrix, Nn($, this.width), xn($, this.height), ut = this.outputDestination;
                    };
                    var bn = function(t, e, n, r, i) {
                        Ht.push(new vn), Et = $ = 0, ot = [], _t = t, Pt = e, kt = i, me([
                            n,
                            r
                        ]);
                    };
                    for(var yn in y.beginFormObject = function(t, e, n, r, i) {
                        return bn(t, e, n, r, i), this;
                    }, y.endFormObject = function(t) {
                        return function(t) {
                            if (Ut[t]) Ht.pop().restore();
                            else {
                                var e = new vn, n = "Xo" + (Object.keys(zt).length + 1).toString(10);
                                e.id = n, Ut[t] = n, zt[n] = e, Dt.publish("addFormObject", e), Ht.pop().restore();
                            }
                        }(t), this;
                    }, y.doFormObject = function(t, e) {
                        var n = zt[Ut[t]];
                        return lt("q"), lt(e.toString() + " cm"), lt("/" + n.id + " Do"), lt("Q"), this;
                    }, y.getFormObject = function(t) {
                        var e = zt[Ut[t]];
                        return {
                            x: e.x,
                            y: e.y,
                            width: e.width,
                            height: e.height,
                            matrix: e.matrix
                        };
                    }, y.save = function(t, e) {
                        return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? (l(ke(Pe()), t), "function" == typeof l.unload && i.setTimeout && setTimeout(l.unload, 911), this) : new Promise(function(e, n) {
                            try {
                                var r = l(ke(Pe()), t);
                                "function" == typeof l.unload && i.setTimeout && setTimeout(l.unload, 911), e(r);
                            } catch (a) {
                                n(a.message);
                            }
                        });
                    }, E.API)E.API.hasOwnProperty(yn) && ("events" === yn && E.API.events.length ? function(t, e) {
                        var n, r, i;
                        for(i = e.length - 1; -1 !== i; i--)n = e[i][0], r = e[i][1], t.subscribe.apply(t, [
                            n
                        ].concat("function" == typeof r ? [
                            r
                        ] : r));
                    }(Dt, E.API.events) : y[yn] = E.API[yn]);
                    function wn(t) {
                        return Rt[t].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX;
                    }
                    function Nn(t, e) {
                        Rt[t].mediaBox.topRightX = e + Rt[t].mediaBox.bottomLeftX;
                    }
                    function Ln(t) {
                        return Rt[t].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY;
                    }
                    function xn(t, e) {
                        Rt[t].mediaBox.topRightY = e + Rt[t].mediaBox.bottomLeftY;
                    }
                    var An = y.getPageWidth = function(t) {
                        return wn(t = t || $) / St;
                    }, Sn = y.setPageWidth = function(t, e) {
                        Nn(t, e * St);
                    }, _n = y.getPageHeight = function(t) {
                        return Ln(t = t || $) / St;
                    }, Pn = y.setPageHeight = function(t, e) {
                        xn(t, e * St);
                    };
                    return y.internal = {
                        pdfEscape: ge,
                        getStyle: Ee,
                        getFont: Ye,
                        getFontSize: mt,
                        getCharSpace: hn,
                        getTextColor: cn,
                        getLineHeight: $e,
                        getLineHeightFactor: tn,
                        getLineWidth: Ke,
                        write: ht,
                        getHorizontalCoordinate: en,
                        getVerticalCoordinate: nn,
                        getCoordinateString: rn,
                        getVerticalCoordinateString: an,
                        collections: {},
                        newObject: Xt,
                        newAdditionalObject: $t,
                        newObjectDeferred: Kt,
                        newObjectDeferredBegin: Zt,
                        getFilters: re,
                        putStream: ie,
                        events: Dt,
                        scaleFactor: St,
                        pageSize: {
                            getWidth: function() {
                                return An($);
                            },
                            setWidth: function(t) {
                                Sn($, t);
                            },
                            getHeight: function() {
                                return _n($);
                            },
                            setHeight: function(t) {
                                Pn($, t);
                            }
                        },
                        encryptionOptions: m,
                        encryption: je,
                        getEncryptor: function(t) {
                            return null !== m ? je.encryptor(t, 0) : function(t) {
                                return t;
                            };
                        },
                        output: Fe,
                        getNumberOfPages: we,
                        get pages () {
                            return ot;
                        },
                        out: lt,
                        f2: T,
                        f3: z,
                        getPageInfo: Ce,
                        getPageInfoByObjId: Oe,
                        getCurrentPageInfo: Be,
                        getPDFVersion: N,
                        Point: gn,
                        Rectangle: mn,
                        Matrix: Wt,
                        hasHotfix: Ie
                    }, Object.defineProperty(y.internal.pageSize, "width", {
                        get: function() {
                            return An($);
                        },
                        set: function(t) {
                            Sn($, t);
                        },
                        enumerable: !0,
                        configurable: !0
                    }), Object.defineProperty(y.internal.pageSize, "height", {
                        get: function() {
                            return _n($);
                        },
                        set: function(t) {
                            Pn($, t);
                        },
                        enumerable: !0,
                        configurable: !0
                    }), (function(t) {
                        for(var e = 0, n = dt.length; e < n; e++){
                            var r = pe.call(this, t[e][0], t[e][1], t[e][2], dt[e][3], !0);
                            !1 === v && (b[r] = !0);
                            var i = t[e][0].split("-");
                            de({
                                id: r,
                                fontName: i[0],
                                fontStyle: i[1] || ""
                            });
                        }
                        Dt.publish("addFonts", {
                            fonts: Ft,
                            dictionary: It
                        });
                    }).call(y, dt), At = "F1", ve(s, r), Dt.publish("initialized"), y;
                }
                I.prototype.lsbFirstWord = function(t) {
                    return String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
                }, I.prototype.toHexString = function(t) {
                    return t.split("").map(function(t) {
                        return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
                    }).join("");
                }, I.prototype.hexToBytes = function(t) {
                    for(var e = [], n = 0; n < t.length; n += 2)e.push(String.fromCharCode(parseInt(t.substr(n, 2), 16)));
                    return e.join("");
                }, I.prototype.processOwnerPassword = function(t, e) {
                    return k(S(e).substr(0, 5), t);
                }, I.prototype.encryptor = function(t, e) {
                    var n = S(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
                    return function(t) {
                        return k(n, t);
                    };
                }, O.prototype.equals = function(e) {
                    var n, r = "id,objectNumber,equals";
                    if (!e || (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e) !== (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(this)) return !1;
                    var i = 0;
                    for(n in this)if (!(r.indexOf(n) >= 0)) {
                        if (this.hasOwnProperty(n) && !e.hasOwnProperty(n)) return !1;
                        if (this[n] !== e[n]) return !1;
                        i++;
                    }
                    for(n in e)e.hasOwnProperty(n) && r.indexOf(n) < 0 && i--;
                    return 0 === i;
                }, E.API = {
                    events: []
                }, E.version = "4.0.0";
                var R = E.API, D = 1, T = function(t) {
                    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
                }, z = function(t) {
                    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
                }, U = function(t) {
                    return t.toFixed(2);
                }, H = function(t) {
                    return t.toFixed(5);
                };
                R.__acroform__ = {};
                var W = function(t, e) {
                    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
                }, V = function(t) {
                    return t * D;
                }, G = function(t) {
                    var e = new ct, n = xt.internal.getHeight(t) || 0, r = xt.internal.getWidth(t) || 0;
                    return e.BBox = [
                        0,
                        0,
                        Number(U(r)),
                        Number(U(n))
                    ], e;
                }, Y = R.__acroform__.setBit = function(t, e) {
                    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
                    return t | 1 << e;
                }, J = R.__acroform__.clearBit = function(t, e) {
                    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
                    return t & ~(1 << e);
                }, X = R.__acroform__.getBit = function(t, e) {
                    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
                    return t & 1 << e ? 1 : 0;
                }, K = R.__acroform__.getBitForPdf = function(t, e) {
                    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
                    return X(t, e - 1);
                }, Z = R.__acroform__.setBitForPdf = function(t, e) {
                    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
                    return Y(t, e - 1);
                }, $ = R.__acroform__.clearBitForPdf = function(t, e) {
                    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
                    return J(t, e - 1);
                }, Q = R.__acroform__.calculateCoordinates = function(t, e) {
                    var n = e.internal.getHorizontalCoordinate, r = e.internal.getVerticalCoordinate, i = t[0], a = t[1], o = t[2], s = t[3], u = {};
                    return u.lowerLeft_X = n(i) || 0, u.lowerLeft_Y = r(a + s) || 0, u.upperRight_X = n(i + o) || 0, u.upperRight_Y = r(a) || 0, [
                        Number(U(u.lowerLeft_X)),
                        Number(U(u.lowerLeft_Y)),
                        Number(U(u.upperRight_X)),
                        Number(U(u.upperRight_Y))
                    ];
                }, tt = function(t) {
                    if (t.appearanceStreamContent) return t.appearanceStreamContent;
                    if (t.V || t.DV) {
                        var e = [], n = t._V || t.DV, r = et(t, n), i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
                        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + i + " " + U(r.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
                        var a = G(t);
                        return a.scope = t.scope, a.stream = e.join("\n"), a;
                    }
                }, et = function(t, e) {
                    var n = 0 === t.fontSize ? t.maxFontSize : t.fontSize, r = {
                        text: "",
                        fontSize: ""
                    }, i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" ");
                    i = t.multiline ? i.map(function(t) {
                        return t.split("\n");
                    }) : i.map(function(t) {
                        return [
                            t
                        ];
                    });
                    var a = n, o = xt.internal.getHeight(t) || 0;
                    o = o < 0 ? -o : o;
                    var s = xt.internal.getWidth(t) || 0;
                    s = s < 0 ? -s : s;
                    var u = function(e, n, r) {
                        if (e + 1 < i.length) {
                            var a = n + " " + i[e + 1][0];
                            return nt(a, t, r).width <= s - 4;
                        }
                        return !1;
                    };
                    a++;
                    t: for(; a > 0;){
                        e = "", a--;
                        var c, l, h = nt("3", t, a).height, f = t.multiline ? o - a : (o - h) / 2, d = f += 2, p = 0, g = 0, m = 0;
                        if (a <= 0) {
                            e = "(...) Tj\n", e += "% Width of Text: " + nt(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
                            break;
                        }
                        for(var v = "", b = 0, y = 0; y < i.length; y++)if (i.hasOwnProperty(y)) {
                            var w = !1;
                            if (1 !== i[y].length && m !== i[y].length - 1) {
                                if ((h + 2) * (b + 2) + 2 > o) continue t;
                                v += i[y][m], w = !0, g = y, y--;
                            } else {
                                v = " " == (v += i[y][m] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                                var N = parseInt(y), L = u(N, v, a), x = y >= i.length - 1;
                                if (L && !x) {
                                    v += " ", m = 0;
                                    continue;
                                }
                                if (L || x) {
                                    if (x) g = N;
                                    else if (t.multiline && (h + 2) * (b + 2) + 2 > o) continue t;
                                } else {
                                    if (!t.multiline) continue t;
                                    if ((h + 2) * (b + 2) + 2 > o) continue t;
                                    g = N;
                                }
                            }
                            for(var A = "", S = p; S <= g; S++){
                                var _ = i[S];
                                if (t.multiline) {
                                    if (S === g) {
                                        A += _[m] + " ", m = (m + 1) % _.length;
                                        continue;
                                    }
                                    if (S === p) {
                                        A += _[_.length - 1] + " ";
                                        continue;
                                    }
                                }
                                A += _[0] + " ";
                            }
                            switch(A = " " == A.substr(A.length - 1) ? A.substr(0, A.length - 1) : A, l = nt(A, t, a).width, t.textAlign){
                                case "right":
                                    c = s - l - 2;
                                    break;
                                case "center":
                                    c = (s - l) / 2;
                                    break;
                                default:
                                    c = 2;
                            }
                            e += U(c) + " " + U(d) + " Td\n", e += "(" + T(A) + ") Tj\n", e += -U(c) + " 0 Td\n", d = -(a + 2), l = 0, p = w ? g : g + 1, b++, v = "";
                        }
                        break;
                    }
                    return r.text = e, r.fontSize = a, r;
                }, nt = function(t, e, n) {
                    var r = e.scope.internal.getFont(e.fontName, e.fontStyle), i = e.scope.getStringUnitWidth(t, {
                        font: r,
                        fontSize: parseFloat(n),
                        charSpace: 0
                    }) * parseFloat(n);
                    return {
                        height: e.scope.getStringUnitWidth("3", {
                            font: r,
                            fontSize: parseFloat(n),
                            charSpace: 0
                        }) * parseFloat(n) * 1.5,
                        width: i
                    };
                }, rt = {
                    fields: [],
                    xForms: [],
                    acroFormDictionaryRoot: null,
                    printedOut: !1,
                    internal: null,
                    isInitialized: !1
                }, it = function(t, e) {
                    var n = {
                        type: "reference",
                        object: t
                    };
                    void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
                        return t.type === n.type && t.object === n.object;
                    }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(n);
                }, at = function(e, n) {
                    if (n.scope = e, void 0 !== e.internal && (void 0 === e.internal.acroformPlugin || !1 === e.internal.acroformPlugin.isInitialized)) {
                        if (ht.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify(rt)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
                        D = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new lt, e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
                            !function(t) {
                                t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
                            }(e);
                        }), e.internal.events.subscribe("buildDocument", function() {
                            !function(t) {
                                t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
                                var e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
                                for(var n in e)if (e.hasOwnProperty(n)) {
                                    var r = e[n];
                                    r.objId = void 0, r.hasAnnotation && it(r, t);
                                }
                            }(e);
                        }), e.internal.events.subscribe("putCatalog", function() {
                            !function(t) {
                                if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
                                t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
                            }(e);
                        }), e.internal.events.subscribe("postPutPages", function(n) {
                            !function(e, n) {
                                var r = !e;
                                for(var i in e || (n.internal.newObjectDeferredBegin(n.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), n.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e = e || n.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (e.hasOwnProperty(i)) {
                                    var a = e[i], o = [], s = a.Rect;
                                    if (a.Rect && (a.Rect = Q(a.Rect, n)), n.internal.newObjectDeferredBegin(a.objId, !0), a.DA = xt.createDefaultAppearanceStream(a), "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                                        var u = tt(a);
                                        o.push({
                                            key: "AP",
                                            value: "<</N " + u + ">>"
                                        }), n.internal.acroformPlugin.xForms.push(u);
                                    }
                                    if (a.appearanceStreamContent) {
                                        var c = "";
                                        for(var l in a.appearanceStreamContent)if (a.appearanceStreamContent.hasOwnProperty(l)) {
                                            var h = a.appearanceStreamContent[l];
                                            if (c += "/" + l + " ", c += "<<", Object.keys(h).length >= 1 || Array.isArray(h)) {
                                                for(var i in h)if (h.hasOwnProperty(i)) {
                                                    var f = h[i];
                                                    "function" == typeof f && (f = f.call(n, a)), c += "/" + i + " " + f + " ", n.internal.acroformPlugin.xForms.indexOf(f) >= 0 || n.internal.acroformPlugin.xForms.push(f);
                                                }
                                            } else "function" == typeof (f = h) && (f = f.call(n, a)), c += "/" + i + " " + f, n.internal.acroformPlugin.xForms.indexOf(f) >= 0 || n.internal.acroformPlugin.xForms.push(f);
                                            c += ">>";
                                        }
                                        o.push({
                                            key: "AP",
                                            value: "<<\n" + c + ">>"
                                        });
                                    }
                                    n.internal.putStream({
                                        additionalKeyValues: o,
                                        objectId: a.objId
                                    }), n.internal.out("endobj");
                                }
                                r && function(e, n) {
                                    for(var r in e)if (e.hasOwnProperty(r)) {
                                        var i = r, a = e[r];
                                        n.internal.newObjectDeferredBegin(a.objId, !0), "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(a) && "function" == typeof a.putStream && a.putStream(), delete e[i];
                                    }
                                }(n.internal.acroformPlugin.xForms, n);
                            }(n, e);
                        }), e.internal.acroformPlugin.isInitialized = !0;
                    }
                }, ot = R.__acroform__.arrayToPdfArray = function(e, n, r) {
                    var i = function(t) {
                        return t;
                    };
                    if (Array.isArray(e)) {
                        for(var a = "[", o = 0; o < e.length; o++)switch(0 !== o && (a += " "), (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e[o])){
                            case "boolean":
                            case "number":
                            case "object":
                                a += e[o].toString();
                                break;
                            case "string":
                                "/" !== e[o].substr(0, 1) ? (void 0 !== n && r && (i = r.internal.getEncryptor(n)), a += "(" + T(i(e[o].toString())) + ")") : a += e[o].toString();
                        }
                        return a + "]";
                    }
                    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
                }, st = function(t, e, n) {
                    var r = function(t) {
                        return t;
                    };
                    return void 0 !== e && n && (r = n.internal.getEncryptor(e)), (t = t || "").toString(), "(" + T(r(t)) + ")";
                }, ut = function() {
                    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
                        get: function() {
                            if (void 0 === this._objId) {
                                if (void 0 === this.scope) return;
                                this._objId = this.scope.internal.newObjectDeferred();
                            }
                            return this._objId;
                        },
                        set: function(t) {
                            this._objId = t;
                        }
                    }), Object.defineProperty(this, "scope", {
                        value: this._scope,
                        writable: !0
                    });
                };
                ut.prototype.toString = function() {
                    return this.objId + " 0 R";
                }, ut.prototype.putStream = function() {
                    var t = this.getKeyValueListForStream();
                    this.scope.internal.putStream({
                        data: this.stream,
                        additionalKeyValues: t,
                        objectId: this.objId
                    }), this.scope.internal.out("endobj");
                }, ut.prototype.getKeyValueListForStream = function() {
                    var t = [], e = Object.getOwnPropertyNames(this).filter(function(t) {
                        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
                    });
                    for(var n in e)if (!1 === Object.getOwnPropertyDescriptor(this, e[n]).configurable) {
                        var r = e[n], i = this[r];
                        i && (Array.isArray(i) ? t.push({
                            key: r,
                            value: ot(i, this.objId, this.scope)
                        }) : i instanceof ut ? (i.scope = this.scope, t.push({
                            key: r,
                            value: i.objId + " 0 R"
                        })) : "function" != typeof i && t.push({
                            key: r,
                            value: i
                        }));
                    }
                    return t;
                };
                var ct = function() {
                    ut.call(this), Object.defineProperty(this, "Type", {
                        value: "/XObject",
                        configurable: !1,
                        writable: !0
                    }), Object.defineProperty(this, "Subtype", {
                        value: "/Form",
                        configurable: !1,
                        writable: !0
                    }), Object.defineProperty(this, "FormType", {
                        value: 1,
                        configurable: !1,
                        writable: !0
                    });
                    var t, e = [];
                    Object.defineProperty(this, "BBox", {
                        configurable: !1,
                        get: function() {
                            return e;
                        },
                        set: function(t) {
                            e = t;
                        }
                    }), Object.defineProperty(this, "Resources", {
                        value: "2 0 R",
                        configurable: !1,
                        writable: !0
                    }), Object.defineProperty(this, "stream", {
                        enumerable: !1,
                        configurable: !0,
                        set: function(e) {
                            t = e.trim();
                        },
                        get: function() {
                            return t || null;
                        }
                    });
                };
                W(ct, ut);
                var lt = function() {
                    ut.call(this);
                    var t, e = [];
                    Object.defineProperty(this, "Kids", {
                        enumerable: !1,
                        configurable: !0,
                        get: function() {
                            return e.length > 0 ? e : void 0;
                        }
                    }), Object.defineProperty(this, "Fields", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            return e;
                        }
                    }), Object.defineProperty(this, "DA", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            if (t) {
                                var e = function(t) {
                                    return t;
                                };
                                return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + T(e(t)) + ")";
                            }
                        },
                        set: function(e) {
                            t = e;
                        }
                    });
                };
                W(lt, ut);
                var ht = function t() {
                    ut.call(this);
                    var e = 4;
                    Object.defineProperty(this, "F", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            return e;
                        },
                        set: function(t) {
                            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
                            e = t;
                        }
                    }), Object.defineProperty(this, "showWhenPrinted", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(e, 3));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.F = Z(e, 3) : this.F = $(e, 3);
                        }
                    });
                    var n = 0;
                    Object.defineProperty(this, "Ff", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            return n;
                        },
                        set: function(t) {
                            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
                            n = t;
                        }
                    });
                    var r = [];
                    Object.defineProperty(this, "Rect", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            if (0 !== r.length) return r;
                        },
                        set: function(t) {
                            r = void 0 !== t ? t : [];
                        }
                    }), Object.defineProperty(this, "x", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return !r || isNaN(r[0]) ? 0 : r[0];
                        },
                        set: function(t) {
                            r[0] = t;
                        }
                    }), Object.defineProperty(this, "y", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return !r || isNaN(r[1]) ? 0 : r[1];
                        },
                        set: function(t) {
                            r[1] = t;
                        }
                    }), Object.defineProperty(this, "width", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return !r || isNaN(r[2]) ? 0 : r[2];
                        },
                        set: function(t) {
                            r[2] = t;
                        }
                    }), Object.defineProperty(this, "height", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return !r || isNaN(r[3]) ? 0 : r[3];
                        },
                        set: function(t) {
                            r[3] = t;
                        }
                    });
                    var i = "";
                    Object.defineProperty(this, "FT", {
                        enumerable: !0,
                        configurable: !1,
                        get: function() {
                            return i;
                        },
                        set: function(t) {
                            switch(t){
                                case "/Btn":
                                case "/Tx":
                                case "/Ch":
                                case "/Sig":
                                    i = t;
                                    break;
                                default:
                                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
                            }
                        }
                    });
                    var a = null;
                    Object.defineProperty(this, "T", {
                        enumerable: !0,
                        configurable: !1,
                        get: function() {
                            if (!a || a.length < 1) {
                                if (this instanceof yt) return;
                                a = "FieldObject" + t.FieldNum++;
                            }
                            var e = function(t) {
                                return t;
                            };
                            return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + T(e(a)) + ")";
                        },
                        set: function(t) {
                            a = t.toString();
                        }
                    }), Object.defineProperty(this, "fieldName", {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            return a;
                        },
                        set: function(t) {
                            a = t;
                        }
                    });
                    var o = "helvetica";
                    Object.defineProperty(this, "fontName", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return o;
                        },
                        set: function(t) {
                            o = t;
                        }
                    });
                    var s = "normal";
                    Object.defineProperty(this, "fontStyle", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return s;
                        },
                        set: function(t) {
                            s = t;
                        }
                    });
                    var u = 0;
                    Object.defineProperty(this, "fontSize", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return u;
                        },
                        set: function(t) {
                            u = t;
                        }
                    });
                    var c = void 0;
                    Object.defineProperty(this, "maxFontSize", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return void 0 === c ? 50 / D : c;
                        },
                        set: function(t) {
                            c = t;
                        }
                    });
                    var l = "black";
                    Object.defineProperty(this, "color", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return l;
                        },
                        set: function(t) {
                            l = t;
                        }
                    });
                    var h = "/F1 0 Tf 0 g";
                    Object.defineProperty(this, "DA", {
                        enumerable: !0,
                        configurable: !1,
                        get: function() {
                            if (!(!h || this instanceof yt || this instanceof Nt)) return st(h, this.objId, this.scope);
                        },
                        set: function(t) {
                            t = t.toString(), h = t;
                        }
                    });
                    var f = null;
                    Object.defineProperty(this, "DV", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            if (f) return this instanceof mt == 0 ? st(f, this.objId, this.scope) : f;
                        },
                        set: function(t) {
                            t = t.toString(), f = this instanceof mt == 0 ? "(" === t.substr(0, 1) ? z(t.substr(1, t.length - 2)) : z(t) : t;
                        }
                    }), Object.defineProperty(this, "defaultValue", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return this instanceof mt == 1 ? z(f.substr(1, f.length - 1)) : f;
                        },
                        set: function(t) {
                            t = t.toString(), f = this instanceof mt == 1 ? "/" + t : t;
                        }
                    });
                    var d = null;
                    Object.defineProperty(this, "_V", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            if (d) return d;
                        },
                        set: function(t) {
                            this.V = t;
                        }
                    }), Object.defineProperty(this, "V", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            if (d) return this instanceof mt == 0 ? st(d, this.objId, this.scope) : d;
                        },
                        set: function(t) {
                            t = t.toString(), d = this instanceof mt == 0 ? "(" === t.substr(0, 1) ? z(t.substr(1, t.length - 2)) : z(t) : t;
                        }
                    }), Object.defineProperty(this, "value", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return this instanceof mt == 1 ? z(d.substr(1, d.length - 1)) : d;
                        },
                        set: function(t) {
                            t = t.toString(), d = this instanceof mt == 1 ? "/" + t : t;
                        }
                    }), Object.defineProperty(this, "hasAnnotation", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return this.Rect;
                        }
                    }), Object.defineProperty(this, "Type", {
                        enumerable: !0,
                        configurable: !1,
                        get: function() {
                            return this.hasAnnotation ? "/Annot" : null;
                        }
                    }), Object.defineProperty(this, "Subtype", {
                        enumerable: !0,
                        configurable: !1,
                        get: function() {
                            return this.hasAnnotation ? "/Widget" : null;
                        }
                    });
                    var p, g = !1;
                    Object.defineProperty(this, "hasAppearanceStream", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return g;
                        },
                        set: function(t) {
                            t = Boolean(t), g = t;
                        }
                    }), Object.defineProperty(this, "page", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            if (p) return p;
                        },
                        set: function(t) {
                            p = t;
                        }
                    }), Object.defineProperty(this, "readOnly", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 1));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 1) : this.Ff = $(this.Ff, 1);
                        }
                    }), Object.defineProperty(this, "required", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 2));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 2) : this.Ff = $(this.Ff, 2);
                        }
                    }), Object.defineProperty(this, "noExport", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 3));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 3) : this.Ff = $(this.Ff, 3);
                        }
                    });
                    var m = null;
                    Object.defineProperty(this, "Q", {
                        enumerable: !0,
                        configurable: !1,
                        get: function() {
                            if (null !== m) return m;
                        },
                        set: function(t) {
                            if (-1 === [
                                0,
                                1,
                                2
                            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
                            m = t;
                        }
                    }), Object.defineProperty(this, "textAlign", {
                        get: function() {
                            var t;
                            switch(m){
                                case 0:
                                default:
                                    t = "left";
                                    break;
                                case 1:
                                    t = "center";
                                    break;
                                case 2:
                                    t = "right";
                            }
                            return t;
                        },
                        configurable: !0,
                        enumerable: !0,
                        set: function(t) {
                            switch(t){
                                case "right":
                                case 2:
                                    m = 2;
                                    break;
                                case "center":
                                case 1:
                                    m = 1;
                                    break;
                                default:
                                    m = 0;
                            }
                        }
                    });
                };
                W(ht, ut);
                var ft = function() {
                    ht.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
                    var t = 0;
                    Object.defineProperty(this, "TI", {
                        enumerable: !0,
                        configurable: !1,
                        get: function() {
                            return t;
                        },
                        set: function(e) {
                            t = e;
                        }
                    }), Object.defineProperty(this, "topIndex", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return t;
                        },
                        set: function(e) {
                            t = e;
                        }
                    });
                    var e = [];
                    Object.defineProperty(this, "Opt", {
                        enumerable: !0,
                        configurable: !1,
                        get: function() {
                            return ot(e, this.objId, this.scope);
                        },
                        set: function(t) {
                            var n, r;
                            r = [], "string" == typeof (n = t) && (r = function(t, e, n) {
                                n || (n = 1);
                                for(var r, i = []; r = e.exec(t);)i.push(r[n]);
                                return i;
                            }(n, /\((.*?)\)/g)), e = r;
                        }
                    }), this.getOptions = function() {
                        return e;
                    }, this.setOptions = function(t) {
                        e = t, this.sort && e.sort();
                    }, this.addOption = function(t) {
                        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
                    }, this.removeOption = function(t, n) {
                        for(n = n || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== n););
                    }, Object.defineProperty(this, "combo", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 18));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 18) : this.Ff = $(this.Ff, 18);
                        }
                    }), Object.defineProperty(this, "edit", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 19));
                        },
                        set: function(t) {
                            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = Z(this.Ff, 19) : this.Ff = $(this.Ff, 19));
                        }
                    }), Object.defineProperty(this, "sort", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 20));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? (this.Ff = Z(this.Ff, 20), e.sort()) : this.Ff = $(this.Ff, 20);
                        }
                    }), Object.defineProperty(this, "multiSelect", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 22));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 22) : this.Ff = $(this.Ff, 22);
                        }
                    }), Object.defineProperty(this, "doNotSpellCheck", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 23));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 23) : this.Ff = $(this.Ff, 23);
                        }
                    }), Object.defineProperty(this, "commitOnSelChange", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 27));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 27) : this.Ff = $(this.Ff, 27);
                        }
                    }), this.hasAppearanceStream = !1;
                };
                W(ft, ht);
                var dt = function() {
                    ft.call(this), this.fontName = "helvetica", this.combo = !1;
                };
                W(dt, ft);
                var pt = function() {
                    dt.call(this), this.combo = !0;
                };
                W(pt, dt);
                var gt = function() {
                    pt.call(this), this.edit = !0;
                };
                W(gt, pt);
                var mt = function() {
                    ht.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 15));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 15) : this.Ff = $(this.Ff, 15);
                        }
                    }), Object.defineProperty(this, "radio", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 16));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 16) : this.Ff = $(this.Ff, 16);
                        }
                    }), Object.defineProperty(this, "pushButton", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 17));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 17) : this.Ff = $(this.Ff, 17);
                        }
                    }), Object.defineProperty(this, "radioIsUnison", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 26));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 26) : this.Ff = $(this.Ff, 26);
                        }
                    });
                    var e, n = {};
                    Object.defineProperty(this, "MK", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            var t = function(t) {
                                return t;
                            };
                            if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(n).length) {
                                var e, r = [];
                                for(e in r.push("<<"), n)r.push("/" + e + " (" + T(t(n[e])) + ")");
                                return r.push(">>"), r.join("\n");
                            }
                        },
                        set: function(e) {
                            "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e) && (n = e);
                        }
                    }), Object.defineProperty(this, "caption", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return n.CA || "";
                        },
                        set: function(t) {
                            "string" == typeof t && (n.CA = t);
                        }
                    }), Object.defineProperty(this, "AS", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            return e;
                        },
                        set: function(t) {
                            e = t;
                        }
                    }), Object.defineProperty(this, "appearanceState", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return e.substr(1, e.length - 1);
                        },
                        set: function(t) {
                            e = "/" + t;
                        }
                    });
                };
                W(mt, ht);
                var vt = function() {
                    mt.call(this), this.pushButton = !0;
                };
                W(vt, mt);
                var bt = function() {
                    mt.call(this), this.radio = !0, this.pushButton = !1;
                    var t = [];
                    Object.defineProperty(this, "Kids", {
                        enumerable: !0,
                        configurable: !1,
                        get: function() {
                            return t;
                        },
                        set: function(e) {
                            t = void 0 !== e ? e : [];
                        }
                    });
                };
                W(bt, mt);
                var yt = function() {
                    var e, n;
                    ht.call(this), Object.defineProperty(this, "Parent", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            return e;
                        },
                        set: function(t) {
                            e = t;
                        }
                    }), Object.defineProperty(this, "optionName", {
                        enumerable: !1,
                        configurable: !0,
                        get: function() {
                            return n;
                        },
                        set: function(t) {
                            n = t;
                        }
                    });
                    var r, i = {};
                    Object.defineProperty(this, "MK", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            var t = function(t) {
                                return t;
                            };
                            this.scope && (t = this.scope.internal.getEncryptor(this.objId));
                            var e, n = [];
                            for(e in n.push("<<"), i)n.push("/" + e + " (" + T(t(i[e])) + ")");
                            return n.push(">>"), n.join("\n");
                        },
                        set: function(e) {
                            "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e) && (i = e);
                        }
                    }), Object.defineProperty(this, "caption", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return i.CA || "";
                        },
                        set: function(t) {
                            "string" == typeof t && (i.CA = t);
                        }
                    }), Object.defineProperty(this, "AS", {
                        enumerable: !1,
                        configurable: !1,
                        get: function() {
                            return r;
                        },
                        set: function(t) {
                            r = t;
                        }
                    }), Object.defineProperty(this, "appearanceState", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return r.substr(1, r.length - 1);
                        },
                        set: function(t) {
                            r = "/" + t;
                        }
                    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = xt.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
                };
                W(yt, ht), bt.prototype.setAppearance = function(t) {
                    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
                    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
                        var n = this.Kids[e];
                        n.appearanceStreamContent = t.createAppearanceStream(n.optionName), n.caption = t.getCA();
                    }
                }, bt.prototype.createOption = function(t) {
                    var e = new yt;
                    return e.Parent = this, e.optionName = t, this.Kids.push(e), At.call(this.scope, e), e;
                };
                var wt = function() {
                    mt.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = xt.CheckBox.createAppearanceStream();
                };
                W(wt, mt);
                var Nt = function() {
                    ht.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 13));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 13) : this.Ff = $(this.Ff, 13);
                        }
                    }), Object.defineProperty(this, "fileSelect", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 21));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 21) : this.Ff = $(this.Ff, 21);
                        }
                    }), Object.defineProperty(this, "doNotSpellCheck", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 23));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 23) : this.Ff = $(this.Ff, 23);
                        }
                    }), Object.defineProperty(this, "doNotScroll", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 24));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 24) : this.Ff = $(this.Ff, 24);
                        }
                    }), Object.defineProperty(this, "comb", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 25));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 25) : this.Ff = $(this.Ff, 25);
                        }
                    }), Object.defineProperty(this, "richText", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 26));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 26) : this.Ff = $(this.Ff, 26);
                        }
                    });
                    var t = null;
                    Object.defineProperty(this, "MaxLen", {
                        enumerable: !0,
                        configurable: !1,
                        get: function() {
                            return t;
                        },
                        set: function(e) {
                            t = e;
                        }
                    }), Object.defineProperty(this, "maxLength", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return t;
                        },
                        set: function(e) {
                            Number.isInteger(e) && (t = e);
                        }
                    }), Object.defineProperty(this, "hasAppearanceStream", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return this.V || this.DV;
                        }
                    });
                };
                W(Nt, ht);
                var Lt = function() {
                    Nt.call(this), Object.defineProperty(this, "password", {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return Boolean(K(this.Ff, 14));
                        },
                        set: function(t) {
                            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 14) : this.Ff = $(this.Ff, 14);
                        }
                    }), this.password = !0;
                };
                W(Lt, Nt);
                var xt = {
                    CheckBox: {
                        createAppearanceStream: function() {
                            return {
                                N: {
                                    On: xt.CheckBox.YesNormal
                                },
                                D: {
                                    On: xt.CheckBox.YesPushDown,
                                    Off: xt.CheckBox.OffPushDown
                                }
                            };
                        },
                        YesPushDown: function(t) {
                            var e = G(t);
                            e.scope = t.scope;
                            var n = [], r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, i = t.scope.__private__.encodeColorString(t.color), a = et(t, t.caption);
                            return n.push("0.749023 g"), n.push("0 0 " + U(xt.internal.getWidth(t)) + " " + U(xt.internal.getHeight(t)) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + U(a.fontSize) + " Tf " + i), n.push("BT"), n.push(a.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join("\n"), e;
                        },
                        YesNormal: function(t) {
                            var e = G(t);
                            e.scope = t.scope;
                            var n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color), i = [], a = xt.internal.getHeight(t), o = xt.internal.getWidth(t), s = et(t, t.caption);
                            return i.push("1 g"), i.push("0 0 " + U(o) + " " + U(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + U(o - 1) + " " + U(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + n + " " + U(s.fontSize) + " Tf " + r), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
                        },
                        OffPushDown: function(t) {
                            var e = G(t);
                            e.scope = t.scope;
                            var n = [];
                            return n.push("0.749023 g"), n.push("0 0 " + U(xt.internal.getWidth(t)) + " " + U(xt.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
                        }
                    },
                    RadioButton: {
                        Circle: {
                            createAppearanceStream: function(t) {
                                var e = {
                                    D: {
                                        Off: xt.RadioButton.Circle.OffPushDown
                                    },
                                    N: {}
                                };
                                return e.N[t] = xt.RadioButton.Circle.YesNormal, e.D[t] = xt.RadioButton.Circle.YesPushDown, e;
                            },
                            getCA: function() {
                                return "l";
                            },
                            YesNormal: function(t) {
                                var e = G(t);
                                e.scope = t.scope;
                                var n = [], r = xt.internal.getWidth(t) <= xt.internal.getHeight(t) ? xt.internal.getWidth(t) / 4 : xt.internal.getHeight(t) / 4;
                                r = Number((.9 * r).toFixed(5));
                                var i = xt.internal.Bezier_C, a = Number((r * i).toFixed(5));
                                return n.push("q"), n.push("1 0 0 1 " + H(xt.internal.getWidth(t) / 2) + " " + H(xt.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                            },
                            YesPushDown: function(t) {
                                var e = G(t);
                                e.scope = t.scope;
                                var n = [], r = xt.internal.getWidth(t) <= xt.internal.getHeight(t) ? xt.internal.getWidth(t) / 4 : xt.internal.getHeight(t) / 4;
                                r = Number((.9 * r).toFixed(5));
                                var i = Number((2 * r).toFixed(5)), a = Number((i * xt.internal.Bezier_C).toFixed(5)), o = Number((r * xt.internal.Bezier_C).toFixed(5));
                                return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + H(xt.internal.getWidth(t) / 2) + " " + H(xt.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + H(xt.internal.getWidth(t) / 2) + " " + H(xt.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + o + " " + o + " " + r + " 0 " + r + " c"), n.push("-" + o + " " + r + " -" + r + " " + o + " -" + r + " 0 c"), n.push("-" + r + " -" + o + " -" + o + " -" + r + " 0 -" + r + " c"), n.push(o + " -" + r + " " + r + " -" + o + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                            },
                            OffPushDown: function(t) {
                                var e = G(t);
                                e.scope = t.scope;
                                var n = [], r = xt.internal.getWidth(t) <= xt.internal.getHeight(t) ? xt.internal.getWidth(t) / 4 : xt.internal.getHeight(t) / 4;
                                r = Number((.9 * r).toFixed(5));
                                var i = Number((2 * r).toFixed(5)), a = Number((i * xt.internal.Bezier_C).toFixed(5));
                                return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + H(xt.internal.getWidth(t) / 2) + " " + H(xt.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                            }
                        },
                        Cross: {
                            createAppearanceStream: function(t) {
                                var e = {
                                    D: {
                                        Off: xt.RadioButton.Cross.OffPushDown
                                    },
                                    N: {}
                                };
                                return e.N[t] = xt.RadioButton.Cross.YesNormal, e.D[t] = xt.RadioButton.Cross.YesPushDown, e;
                            },
                            getCA: function() {
                                return "8";
                            },
                            YesNormal: function(t) {
                                var e = G(t);
                                e.scope = t.scope;
                                var n = [], r = xt.internal.calculateCross(t);
                                return n.push("q"), n.push("1 1 " + U(xt.internal.getWidth(t) - 2) + " " + U(xt.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push(U(r.x1.x) + " " + U(r.x1.y) + " m"), n.push(U(r.x2.x) + " " + U(r.x2.y) + " l"), n.push(U(r.x4.x) + " " + U(r.x4.y) + " m"), n.push(U(r.x3.x) + " " + U(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
                            },
                            YesPushDown: function(t) {
                                var e = G(t);
                                e.scope = t.scope;
                                var n = xt.internal.calculateCross(t), r = [];
                                return r.push("0.749023 g"), r.push("0 0 " + U(xt.internal.getWidth(t)) + " " + U(xt.internal.getHeight(t)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + U(xt.internal.getWidth(t) - 2) + " " + U(xt.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push(U(n.x1.x) + " " + U(n.x1.y) + " m"), r.push(U(n.x2.x) + " " + U(n.x2.y) + " l"), r.push(U(n.x4.x) + " " + U(n.x4.y) + " m"), r.push(U(n.x3.x) + " " + U(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
                            },
                            OffPushDown: function(t) {
                                var e = G(t);
                                e.scope = t.scope;
                                var n = [];
                                return n.push("0.749023 g"), n.push("0 0 " + U(xt.internal.getWidth(t)) + " " + U(xt.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
                            }
                        }
                    },
                    createDefaultAppearanceStream: function(t) {
                        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color);
                        return "/" + e + " " + t.fontSize + " Tf " + n;
                    }
                };
                xt.internal = {
                    Bezier_C: .551915024494,
                    calculateCross: function(t) {
                        var e = xt.internal.getWidth(t), n = xt.internal.getHeight(t), r = Math.min(e, n);
                        return {
                            x1: {
                                x: (e - r) / 2,
                                y: (n - r) / 2 + r
                            },
                            x2: {
                                x: (e - r) / 2 + r,
                                y: (n - r) / 2
                            },
                            x3: {
                                x: (e - r) / 2,
                                y: (n - r) / 2
                            },
                            x4: {
                                x: (e - r) / 2 + r,
                                y: (n - r) / 2 + r
                            }
                        };
                    }
                }, xt.internal.getWidth = function(e) {
                    var n = 0;
                    return "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e) && (n = V(e.Rect[2])), n;
                }, xt.internal.getHeight = function(e) {
                    var n = 0;
                    return "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e) && (n = V(e.Rect[3])), n;
                };
                var At = R.addField = function(t) {
                    if (at(this, t), !(t instanceof ht)) throw new Error("Invalid argument passed to jsPDF.addField.");
                    var e;
                    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
                };
                R.AcroFormChoiceField = ft, R.AcroFormListBox = dt, R.AcroFormComboBox = pt, R.AcroFormEditBox = gt, R.AcroFormButton = mt, R.AcroFormPushButton = vt, R.AcroFormRadioButton = bt, R.AcroFormCheckBox = wt, R.AcroFormTextField = Nt, R.AcroFormPasswordField = Lt, R.AcroFormAppearance = xt, R.AcroForm = {
                    ChoiceField: ft,
                    ListBox: dt,
                    ComboBox: pt,
                    EditBox: gt,
                    Button: mt,
                    PushButton: vt,
                    RadioButton: bt,
                    CheckBox: wt,
                    TextField: Nt,
                    PasswordField: Lt,
                    Appearance: xt
                }, E.AcroForm = {
                    ChoiceField: ft,
                    ListBox: dt,
                    ComboBox: pt,
                    EditBox: gt,
                    Button: mt,
                    PushButton: vt,
                    RadioButton: bt,
                    CheckBox: wt,
                    TextField: Nt,
                    PasswordField: Lt,
                    Appearance: xt
                };
                var St = E.AcroForm;
                function _t(t) {
                    return t.reduce(function(t, e, n) {
                        return t[e] = n, t;
                    }, {});
                }
                !function(e) {
                    var n = "addImage_";
                    e.__addimage__ = {};
                    var r = "UNKNOWN", i = {
                        PNG: [
                            [
                                137,
                                80,
                                78,
                                71
                            ]
                        ],
                        TIFF: [
                            [
                                77,
                                77,
                                0,
                                42
                            ],
                            [
                                73,
                                73,
                                42,
                                0
                            ]
                        ],
                        JPEG: [
                            [
                                255,
                                216,
                                255,
                                224,
                                void 0,
                                void 0,
                                74,
                                70,
                                73,
                                70,
                                0
                            ],
                            [
                                255,
                                216,
                                255,
                                225,
                                void 0,
                                void 0,
                                69,
                                120,
                                105,
                                102,
                                0,
                                0
                            ],
                            [
                                255,
                                216,
                                255,
                                219
                            ],
                            [
                                255,
                                216,
                                255,
                                238
                            ]
                        ],
                        JPEG2000: [
                            [
                                0,
                                0,
                                0,
                                12,
                                106,
                                80,
                                32,
                                32
                            ]
                        ],
                        GIF87a: [
                            [
                                71,
                                73,
                                70,
                                56,
                                55,
                                97
                            ]
                        ],
                        GIF89a: [
                            [
                                71,
                                73,
                                70,
                                56,
                                57,
                                97
                            ]
                        ],
                        WEBP: [
                            [
                                82,
                                73,
                                70,
                                70,
                                void 0,
                                void 0,
                                void 0,
                                void 0,
                                87,
                                69,
                                66,
                                80
                            ]
                        ],
                        BMP: [
                            [
                                66,
                                77
                            ],
                            [
                                66,
                                65
                            ],
                            [
                                67,
                                73
                            ],
                            [
                                67,
                                80
                            ],
                            [
                                73,
                                67
                            ],
                            [
                                80,
                                84
                            ]
                        ]
                    }, a = e.__addimage__.getImageFileTypeByImageData = function(t, e) {
                        var n, a, o, s, u, c = r;
                        if ("RGBA" === (e = e || r) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
                        if (A(t)) for(u in i)for(o = i[u], n = 0; n < o.length; n += 1){
                            for(s = !0, a = 0; a < o[n].length; a += 1)if (void 0 !== o[n][a] && o[n][a] !== t[a]) {
                                s = !1;
                                break;
                            }
                            if (!0 === s) {
                                c = u;
                                break;
                            }
                        }
                        else for(u in i)for(o = i[u], n = 0; n < o.length; n += 1){
                            for(s = !0, a = 0; a < o[n].length; a += 1)if (void 0 !== o[n][a] && o[n][a] !== t.charCodeAt(a)) {
                                s = !1;
                                break;
                            }
                            if (!0 === s) {
                                c = u;
                                break;
                            }
                        }
                        return c === r && e !== r && (c = e), c;
                    }, o = function t(e) {
                        for(var n = this.internal.write, r = this.internal.putStream, i = (0, this.internal.getFilters)(); -1 !== i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"), 1);
                        e.objectId = this.internal.newObject();
                        var a = [];
                        if (a.push({
                            key: "Type",
                            value: "/XObject"
                        }), a.push({
                            key: "Subtype",
                            value: "/Image"
                        }), a.push({
                            key: "Width",
                            value: e.width
                        }), a.push({
                            key: "Height",
                            value: e.height
                        }), e.colorSpace === y.INDEXED ? a.push({
                            key: "ColorSpace",
                            value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
                        }) : (a.push({
                            key: "ColorSpace",
                            value: "/" + e.colorSpace
                        }), e.colorSpace === y.DEVICE_CMYK && a.push({
                            key: "Decode",
                            value: "[1 0 1 0 1 0 1 0]"
                        })), a.push({
                            key: "BitsPerComponent",
                            value: e.bitsPerComponent
                        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
                            key: "DecodeParms",
                            value: "<<" + e.decodeParameters + ">>"
                        }), "transparency" in e && Array.isArray(e.transparency) && e.transparency.length > 0) {
                            for(var o = "", s = 0, u = e.transparency.length; s < u; s++)o += e.transparency[s] + " " + e.transparency[s] + " ";
                            a.push({
                                key: "Mask",
                                value: "[" + o + "]"
                            });
                        }
                        void 0 !== e.sMask && a.push({
                            key: "SMask",
                            value: e.objectId + 1 + " 0 R"
                        });
                        var c = void 0 !== e.filter ? [
                            "/" + e.filter
                        ] : void 0;
                        if (r({
                            data: e.data,
                            additionalKeyValues: a,
                            alreadyAppliedFilters: c,
                            objectId: e.objectId
                        }), n("endobj"), "sMask" in e && void 0 !== e.sMask) {
                            var l, h = null !== (l = e.sMaskBitsPerComponent) && void 0 !== l ? l : e.bitsPerComponent, f = {
                                width: e.width,
                                height: e.height,
                                colorSpace: "DeviceGray",
                                bitsPerComponent: h,
                                data: e.sMask
                            };
                            "filter" in e && (f.decodeParameters = "/Predictor ".concat(e.predictor, " /Colors 1 /BitsPerComponent ").concat(h, " /Columns ").concat(e.width), f.filter = e.filter), t.call(this, f);
                        }
                        if (e.colorSpace === y.INDEXED) {
                            var d = this.internal.newObject();
                            r({
                                data: _(new Uint8Array(e.palette)),
                                objectId: d
                            }), n("endobj");
                        }
                    }, s = function() {
                        var t = this.internal.collections[n + "images"];
                        for(var e in t)o.call(this, t[e]);
                    }, u = function() {
                        var t, e = this.internal.collections[n + "images"], r = this.internal.write;
                        for(var i in e)r("/I" + (t = e[i]).index, t.objectId, "0", "R");
                    }, c = function() {
                        this.internal.collections[n + "images"] || (this.internal.collections[n + "images"] = {}, this.internal.events.subscribe("putResources", s), this.internal.events.subscribe("putXobjectDict", u));
                    }, l = function() {
                        var t = this.internal.collections[n + "images"];
                        return c.call(this), t;
                    }, h = function() {
                        return Object.keys(this.internal.collections[n + "images"]).length;
                    }, d = function(t) {
                        return "function" == typeof e["process" + t.toUpperCase()];
                    }, p = function(e) {
                        return "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e) && 1 === e.nodeType;
                    }, g = function(t, n) {
                        if ("IMG" === t.nodeName && t.hasAttribute("src")) {
                            var r = "" + t.getAttribute("src");
                            if (0 === r.indexOf("data:image/")) return f(unescape(r).split("base64,").pop());
                            var i = e.loadFile(r, !0);
                            if (void 0 !== i) return i;
                        }
                        if ("CANVAS" === t.nodeName) {
                            if (0 === t.width || 0 === t.height) throw new Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
                            var a;
                            switch(n){
                                case "PNG":
                                    a = "image/png";
                                    break;
                                case "WEBP":
                                    a = "image/webp";
                                    break;
                                default:
                                    a = "image/jpeg";
                            }
                            return f(t.toDataURL(a, 1).split("base64,").pop());
                        }
                    }, m = function(t) {
                        var e = this.internal.collections[n + "images"];
                        if (e) {
                            for(var r in e)if (t === e[r].alias) return e[r];
                        }
                    }, v = function(t, e, n) {
                        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * n.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * n.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * n.width / n.height), 0 === e && (e = t * n.height / n.width), [
                            t,
                            e
                        ];
                    }, b = function(t, e, n, r, i, a) {
                        var o = v.call(this, n, r, i), s = this.internal.getCoordinateString, u = this.internal.getVerticalCoordinateString, c = l.call(this);
                        if (n = o[0], r = o[1], c[i.index] = i, a) {
                            a *= Math.PI / 180;
                            var h = Math.cos(a), f = Math.sin(a), d = function(t) {
                                return t.toFixed(4);
                            }, p = [
                                d(h),
                                d(f),
                                d(-1 * f),
                                d(h),
                                0,
                                0,
                                "cm"
                            ];
                        }
                        this.internal.write("q"), a ? (this.internal.write([
                            1,
                            "0",
                            "0",
                            1,
                            s(t),
                            u(e + r),
                            "cm"
                        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
                            s(n),
                            "0",
                            "0",
                            s(r),
                            "0",
                            "0",
                            "cm"
                        ].join(" "))) : this.internal.write([
                            s(n),
                            "0",
                            "0",
                            s(r),
                            s(t),
                            u(e + r),
                            "cm"
                        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
                            1,
                            0,
                            0,
                            -1,
                            0,
                            0,
                            "cm"
                        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
                    }, y = e.color_spaces = {
                        DEVICE_RGB: "DeviceRGB",
                        DEVICE_GRAY: "DeviceGray",
                        DEVICE_CMYK: "DeviceCMYK",
                        CAL_GREY: "CalGray",
                        CAL_RGB: "CalRGB",
                        LAB: "Lab",
                        ICC_BASED: "ICCBased",
                        INDEXED: "Indexed",
                        PATTERN: "Pattern",
                        SEPARATION: "Separation",
                        DEVICE_N: "DeviceN"
                    };
                    e.decode = {
                        DCT_DECODE: "DCTDecode",
                        FLATE_DECODE: "FlateDecode",
                        LZW_DECODE: "LZWDecode",
                        JPX_DECODE: "JPXDecode",
                        JBIG2_DECODE: "JBIG2Decode",
                        ASCII85_DECODE: "ASCII85Decode",
                        ASCII_HEX_DECODE: "ASCIIHexDecode",
                        RUN_LENGTH_DECODE: "RunLengthDecode",
                        CCITT_FAX_DECODE: "CCITTFaxDecode"
                    };
                    var w = e.image_compression = {
                        NONE: "NONE",
                        FAST: "FAST",
                        MEDIUM: "MEDIUM",
                        SLOW: "SLOW"
                    }, N = e.__addimage__.sHashCode = function(t) {
                        var e, n, r = 0;
                        if ("string" == typeof t) for(n = t.length, e = 0; e < n; e++)r = (r << 5) - r + t.charCodeAt(e), r |= 0;
                        else if (A(t)) for(n = t.byteLength / 2, e = 0; e < n; e++)r = (r << 5) - r + t[e], r |= 0;
                        return r;
                    }, L = e.__addimage__.validateStringAsBase64 = function(t) {
                        (t = t || "").toString().trim();
                        var e = !0;
                        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
                    }, x = e.__addimage__.extractImageFromDataUrl = function(t) {
                        if (null == t) return null;
                        if (!(t = t.trim()).startsWith("data:")) return null;
                        var e = t.indexOf(",");
                        return e < 0 ? null : t.substring(0, e).trim().endsWith("base64") ? t.substring(e + 1) : null;
                    };
                    e.__addimage__.isArrayBuffer = function(t) {
                        return t instanceof ArrayBuffer;
                    };
                    var A = e.__addimage__.isArrayBufferView = function(t) {
                        return t instanceof Int8Array || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array;
                    }, S = e.__addimage__.binaryStringToUint8Array = function(t) {
                        for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
                        return n;
                    }, _ = e.__addimage__.arrayBufferToBinaryString = function(t) {
                        for(var e = "", n = A(t) ? t : new Uint8Array(t), r = 0; r < n.length; r += 8192)e += String.fromCharCode.apply(null, n.subarray(r, r + 8192));
                        return e;
                    };
                    e.addImage = function() {
                        var e, n, i, a, o, s, u, l, h;
                        if ("number" == typeof arguments[1] ? (n = r, i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], u = arguments[5], l = arguments[6], h = arguments[7]) : (n = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], l = arguments[7], h = arguments[8]), "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e = arguments[0]) && !p(e) && "imageData" in e) {
                            var f = e;
                            e = f.imageData, n = f.format || n || r, i = f.x || i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, u = f.alias || u, l = f.compression || l, h = f.rotation || f.angle || h;
                        }
                        var d = this.internal.getFilters();
                        if (void 0 === l && -1 !== d.indexOf("FlateEncode") && (l = "SLOW"), isNaN(i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
                        c.call(this);
                        var g = P.call(this, e, n, u, l);
                        return b.call(this, i, a, o, s, g, h), this;
                    };
                    var P = function(t, n, i, o) {
                        var s, u, c;
                        if ("string" == typeof t && a(t) === r) {
                            t = unescape(t);
                            var l = k(t, !1);
                            ("" !== l || void 0 !== (l = e.loadFile(t, !0))) && (t = l);
                        }
                        if (p(t) && (t = g(t, n)), n = a(t, n), !d(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
                        if ((null == (c = i) || 0 === c.length) && (i = function(t) {
                            return "string" == typeof t || A(t) ? N(t) : A(t.data) ? N(t.data) : null;
                        }(t)), (s = m.call(this, i)) || (t instanceof Uint8Array || "RGBA" === n || (u = t, t = S(t)), s = this["process" + n.toUpperCase()](t, h.call(this), i, function(t) {
                            return t && "string" == typeof t && (t = t.toUpperCase()), t in e.image_compression ? t : w.NONE;
                        }(o), u)), !s) throw new Error("An unknown error occurred whilst processing the image.");
                        return s;
                    }, k = e.__addimage__.convertBase64ToBinaryString = function(t, e) {
                        e = "boolean" != typeof e || e;
                        var n, r = "";
                        if ("string" == typeof t) {
                            var i;
                            n = null !== (i = x(t)) && void 0 !== i ? i : t;
                            try {
                                r = f(n);
                            } catch (a) {
                                if (e) throw L(n) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + a.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
                            }
                        }
                        return r;
                    };
                    e.getImageProperties = function(t) {
                        var n, i, o = "";
                        if (p(t) && (t = g(t)), "string" == typeof t && a(t) === r && ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), t = o), i = a(t), !d(i)) throw new Error("addImage does not support files of type '" + i + "', please ensure that a plugin for '" + i + "' support is added.");
                        if (t instanceof Uint8Array || (t = S(t)), !(n = this["process" + i.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
                        return n.fileType = i, n;
                    };
                }(E.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    var e = function(t) {
                        if (void 0 !== t && "" != t) return !0;
                    };
                    E.API.events.push([
                        "addPage",
                        function(t) {
                            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
                        }
                    ]), t.events.push([
                        "putPage",
                        function(t) {
                            for(var n, r, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), u = t.pageContext.annotations, c = !1, l = 0; l < u.length && !c; l++)switch((n = u[l]).type){
                                case "link":
                                    (e(n.options.url) || e(n.options.pageNumber)) && (c = !0);
                                    break;
                                case "reference":
                                case "text":
                                case "freetext":
                                    c = !0;
                            }
                            if (0 != c) {
                                this.internal.write("/Annots [");
                                for(var h = 0; h < u.length; h++){
                                    n = u[h];
                                    var f = this.internal.pdfEscape, d = this.internal.getEncryptor(t.objId);
                                    switch(n.type){
                                        case "reference":
                                            this.internal.write(" " + n.object.objId + " 0 R ");
                                            break;
                                        case "text":
                                            var p = this.internal.newAdditionalObject(), g = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(p.objId), v = n.title || "Note";
                                            i = "<</Type /Annot /Subtype /Text " + (r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y) + "] ") + "/Contents (" + f(m(n.contents)) + ")", i += " /Popup " + g.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(m(v)) + ") >>", p.content = i;
                                            var b = p.objId + " 0 R";
                                            i = "<</Type /Annot /Subtype /Popup " + (r = "/Rect [" + a(n.bounds.x + 30) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w + 30) + " " + o(n.bounds.y) + "] ") + " /Parent " + b, n.open && (i += " /Open true"), i += " >>", g.content = i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
                                            break;
                                        case "freetext":
                                            r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y + n.bounds.h) + "] ";
                                            var y = n.color || "#000000";
                                            i = "<</Type /Annot /Subtype /FreeText " + r + "/Contents (" + f(d(n.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + y + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
                                            break;
                                        case "link":
                                            if (n.options.name) {
                                                var w = this.annotations._nameMap[n.options.name];
                                                n.options.pageNumber = w.page, n.options.top = w.y;
                                            } else n.options.top || (n.options.top = 0);
                                            if (r = "/Rect [" + n.finalBounds.x + " " + n.finalBounds.y + " " + n.finalBounds.w + " " + n.finalBounds.h + "] ", i = "", n.options.url) i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(n.options.url)) + ") >>";
                                            else if (n.options.pageNumber) switch(i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(n.options.pageNumber).objId + " 0 R", n.options.magFactor = n.options.magFactor || "XYZ", n.options.magFactor){
                                                case "Fit":
                                                    i += " /Fit]";
                                                    break;
                                                case "FitH":
                                                    i += " /FitH " + n.options.top + "]";
                                                    break;
                                                case "FitV":
                                                    n.options.left = n.options.left || 0, i += " /FitV " + n.options.left + "]";
                                                    break;
                                                default:
                                                    var N = o(n.options.top);
                                                    n.options.left = n.options.left || 0, void 0 === n.options.zoom && (n.options.zoom = 0), i += " /XYZ " + n.options.left + " " + N + " " + n.options.zoom + "]";
                                            }
                                            "" != i && (i += " >>", this.internal.write(i));
                                    }
                                }
                                this.internal.write("]");
                            }
                        }
                    ]), t.createAnnotation = function(t) {
                        var e = this.internal.getCurrentPageInfo();
                        switch(t.type){
                            case "link":
                                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                                break;
                            case "text":
                            case "freetext":
                                e.pageContext.annotations.push(t);
                        }
                    }, t.link = function(t, e, n, r, i) {
                        var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
                        a.pageContext.annotations.push({
                            finalBounds: {
                                x: o(t),
                                y: s(e),
                                w: o(t + n),
                                h: s(e + r)
                            },
                            options: i,
                            type: "link"
                        });
                    }, t.textWithLink = function(t, e, n, r) {
                        var i, a, o = this.getTextWidth(t), s = this.internal.getLineHeight() / this.internal.scaleFactor;
                        if (void 0 !== r.maxWidth) {
                            a = r.maxWidth;
                            var u = this.splitTextToSize(t, a).length;
                            i = Math.ceil(s * u);
                        } else a = o, i = s;
                        return this.text(t, e, n, r), n += .2 * s, "center" === r.align && (e -= o / 2), "right" === r.align && (e -= o), this.link(e, n - s, a, i, r), o;
                    }, t.getTextWidth = function(t) {
                        var e = this.internal.getFontSize();
                        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
                    };
                }(E.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    var e = {
                        1569: [
                            65152
                        ],
                        1570: [
                            65153,
                            65154
                        ],
                        1571: [
                            65155,
                            65156
                        ],
                        1572: [
                            65157,
                            65158
                        ],
                        1573: [
                            65159,
                            65160
                        ],
                        1574: [
                            65161,
                            65162,
                            65163,
                            65164
                        ],
                        1575: [
                            65165,
                            65166
                        ],
                        1576: [
                            65167,
                            65168,
                            65169,
                            65170
                        ],
                        1577: [
                            65171,
                            65172
                        ],
                        1578: [
                            65173,
                            65174,
                            65175,
                            65176
                        ],
                        1579: [
                            65177,
                            65178,
                            65179,
                            65180
                        ],
                        1580: [
                            65181,
                            65182,
                            65183,
                            65184
                        ],
                        1581: [
                            65185,
                            65186,
                            65187,
                            65188
                        ],
                        1582: [
                            65189,
                            65190,
                            65191,
                            65192
                        ],
                        1583: [
                            65193,
                            65194
                        ],
                        1584: [
                            65195,
                            65196
                        ],
                        1585: [
                            65197,
                            65198
                        ],
                        1586: [
                            65199,
                            65200
                        ],
                        1587: [
                            65201,
                            65202,
                            65203,
                            65204
                        ],
                        1588: [
                            65205,
                            65206,
                            65207,
                            65208
                        ],
                        1589: [
                            65209,
                            65210,
                            65211,
                            65212
                        ],
                        1590: [
                            65213,
                            65214,
                            65215,
                            65216
                        ],
                        1591: [
                            65217,
                            65218,
                            65219,
                            65220
                        ],
                        1592: [
                            65221,
                            65222,
                            65223,
                            65224
                        ],
                        1593: [
                            65225,
                            65226,
                            65227,
                            65228
                        ],
                        1594: [
                            65229,
                            65230,
                            65231,
                            65232
                        ],
                        1601: [
                            65233,
                            65234,
                            65235,
                            65236
                        ],
                        1602: [
                            65237,
                            65238,
                            65239,
                            65240
                        ],
                        1603: [
                            65241,
                            65242,
                            65243,
                            65244
                        ],
                        1604: [
                            65245,
                            65246,
                            65247,
                            65248
                        ],
                        1605: [
                            65249,
                            65250,
                            65251,
                            65252
                        ],
                        1606: [
                            65253,
                            65254,
                            65255,
                            65256
                        ],
                        1607: [
                            65257,
                            65258,
                            65259,
                            65260
                        ],
                        1608: [
                            65261,
                            65262
                        ],
                        1609: [
                            65263,
                            65264,
                            64488,
                            64489
                        ],
                        1610: [
                            65265,
                            65266,
                            65267,
                            65268
                        ],
                        1649: [
                            64336,
                            64337
                        ],
                        1655: [
                            64477
                        ],
                        1657: [
                            64358,
                            64359,
                            64360,
                            64361
                        ],
                        1658: [
                            64350,
                            64351,
                            64352,
                            64353
                        ],
                        1659: [
                            64338,
                            64339,
                            64340,
                            64341
                        ],
                        1662: [
                            64342,
                            64343,
                            64344,
                            64345
                        ],
                        1663: [
                            64354,
                            64355,
                            64356,
                            64357
                        ],
                        1664: [
                            64346,
                            64347,
                            64348,
                            64349
                        ],
                        1667: [
                            64374,
                            64375,
                            64376,
                            64377
                        ],
                        1668: [
                            64370,
                            64371,
                            64372,
                            64373
                        ],
                        1670: [
                            64378,
                            64379,
                            64380,
                            64381
                        ],
                        1671: [
                            64382,
                            64383,
                            64384,
                            64385
                        ],
                        1672: [
                            64392,
                            64393
                        ],
                        1676: [
                            64388,
                            64389
                        ],
                        1677: [
                            64386,
                            64387
                        ],
                        1678: [
                            64390,
                            64391
                        ],
                        1681: [
                            64396,
                            64397
                        ],
                        1688: [
                            64394,
                            64395
                        ],
                        1700: [
                            64362,
                            64363,
                            64364,
                            64365
                        ],
                        1702: [
                            64366,
                            64367,
                            64368,
                            64369
                        ],
                        1705: [
                            64398,
                            64399,
                            64400,
                            64401
                        ],
                        1709: [
                            64467,
                            64468,
                            64469,
                            64470
                        ],
                        1711: [
                            64402,
                            64403,
                            64404,
                            64405
                        ],
                        1713: [
                            64410,
                            64411,
                            64412,
                            64413
                        ],
                        1715: [
                            64406,
                            64407,
                            64408,
                            64409
                        ],
                        1722: [
                            64414,
                            64415
                        ],
                        1723: [
                            64416,
                            64417,
                            64418,
                            64419
                        ],
                        1726: [
                            64426,
                            64427,
                            64428,
                            64429
                        ],
                        1728: [
                            64420,
                            64421
                        ],
                        1729: [
                            64422,
                            64423,
                            64424,
                            64425
                        ],
                        1733: [
                            64480,
                            64481
                        ],
                        1734: [
                            64473,
                            64474
                        ],
                        1735: [
                            64471,
                            64472
                        ],
                        1736: [
                            64475,
                            64476
                        ],
                        1737: [
                            64482,
                            64483
                        ],
                        1739: [
                            64478,
                            64479
                        ],
                        1740: [
                            64508,
                            64509,
                            64510,
                            64511
                        ],
                        1744: [
                            64484,
                            64485,
                            64486,
                            64487
                        ],
                        1746: [
                            64430,
                            64431
                        ],
                        1747: [
                            64432,
                            64433
                        ]
                    }, n = {
                        65247: {
                            65154: 65269,
                            65156: 65271,
                            65160: 65273,
                            65166: 65275
                        },
                        65248: {
                            65154: 65270,
                            65156: 65272,
                            65160: 65274,
                            65166: 65276
                        },
                        65165: {
                            65247: {
                                65248: {
                                    65258: 65010
                                }
                            }
                        },
                        1617: {
                            1612: 64606,
                            1613: 64607,
                            1614: 64608,
                            1615: 64609,
                            1616: 64610
                        }
                    }, r = {
                        1612: 64606,
                        1613: 64607,
                        1614: 64608,
                        1615: 64609,
                        1616: 64610
                    }, i = [
                        1570,
                        1571,
                        1573,
                        1575
                    ];
                    t.__arabicParser__ = {};
                    var a = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
                        return void 0 !== e[t.charCodeAt(0)];
                    }, o = t.__arabicParser__.isArabicLetter = function(t) {
                        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
                    }, s = t.__arabicParser__.isArabicEndLetter = function(t) {
                        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
                    }, u = t.__arabicParser__.isArabicAlfLetter = function(t) {
                        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
                    };
                    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
                        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
                    };
                    var c = t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
                        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
                    };
                    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
                        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
                    };
                    var l = t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
                        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
                    }, h = t.__arabicParser__.resolveLigatures = function(t) {
                        var e = 0, r = n, i = "", a = 0;
                        for(e = 0; e < t.length; e += 1)void 0 !== r[t.charCodeAt(e)] ? (a++, "number" == typeof (r = r[t.charCodeAt(e)]) && (i += String.fromCharCode(r), r = n, a = 0), e === t.length - 1 && (r = n, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (r = n, i += t.charAt(e - a), e -= a, a = 0);
                        return i;
                    };
                    t.__arabicParser__.isArabicDiacritic = function(t) {
                        return void 0 !== t && void 0 !== r[t.charCodeAt(0)];
                    };
                    var f = t.__arabicParser__.getCorrectForm = function(t, e, n) {
                        return o(t) ? !1 === a(t) ? -1 : !c(t) || !o(e) && !o(n) || !o(n) && s(e) || s(t) && !o(e) || s(t) && u(e) || s(t) && s(e) ? 0 : l(t) && o(e) && !s(e) && o(n) && c(n) ? 3 : s(t) || !o(n) ? 1 : 2 : -1;
                    }, d = function(t) {
                        var n = 0, r = 0, i = 0, a = "", s = "", u = "", c = (t = t || "").split("\\s+"), l = [];
                        for(n = 0; n < c.length; n += 1){
                            for(l.push(""), r = 0; r < c[n].length; r += 1)a = c[n][r], s = c[n][r - 1], u = c[n][r + 1], o(a) ? (i = f(a, s, u), l[n] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : l[n] += a;
                            l[n] = h(l[n]);
                        }
                        return l.join(" ");
                    }, p = t.__arabicParser__.processArabic = t.processArabic = function() {
                        var t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, n = [];
                        if (Array.isArray(e)) {
                            var r = 0;
                            for(n = [], r = 0; r < e.length; r += 1)Array.isArray(e[r]) ? n.push([
                                d(e[r][0]),
                                e[r][1],
                                e[r][2]
                            ]) : n.push([
                                d(e[r])
                            ]);
                            t = n;
                        } else t = d(e);
                        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
                    };
                    t.events.push([
                        "preProcessText",
                        p
                    ]);
                }(E.API), E.API.autoPrint = function(t) {
                    var e;
                    return (t = t || {}).variant = t.variant || "non-conform", "javascript" === t.variant ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
                        e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
                    }), this.internal.events.subscribe("putCatalog", function() {
                        this.internal.out("/OpenAction " + e + " 0 R");
                    })), this;
                }, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    var e = function() {
                        var t = void 0;
                        Object.defineProperty(this, "pdf", {
                            get: function() {
                                return t;
                            },
                            set: function(e) {
                                t = e;
                            }
                        });
                        var e = 150;
                        Object.defineProperty(this, "width", {
                            get: function() {
                                return e;
                            },
                            set: function(t) {
                                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
                            }
                        });
                        var n = 300;
                        Object.defineProperty(this, "height", {
                            get: function() {
                                return n;
                            },
                            set: function(t) {
                                n = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
                            }
                        });
                        var r = [];
                        Object.defineProperty(this, "childNodes", {
                            get: function() {
                                return r;
                            },
                            set: function(t) {
                                r = t;
                            }
                        });
                        var i = {};
                        Object.defineProperty(this, "style", {
                            get: function() {
                                return i;
                            },
                            set: function(t) {
                                i = t;
                            }
                        }), Object.defineProperty(this, "parentNode", {});
                    };
                    e.prototype.getContext = function(t, e) {
                        var n;
                        if ("2d" !== (t = t || "2d")) return null;
                        for(n in e)this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = e[n]);
                        return this.pdf.context2d._canvas = this, this.pdf.context2d;
                    }, e.prototype.toDataURL = function() {
                        throw new Error("toDataURL is not implemented.");
                    }, t.events.push([
                        "initialized",
                        function() {
                            this.canvas = new e, this.canvas.pdf = this;
                        }
                    ]);
                }(E.API), function(e) {
                    var n = {
                        left: 0,
                        top: 0,
                        bottom: 0,
                        right: 0
                    }, r = !1, i = function() {
                        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, n), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
                    }, a = function() {
                        this.internal.__cell__.lastCell = new o, this.internal.__cell__.pages = 1;
                    }, o = function() {
                        var t = arguments[0];
                        Object.defineProperty(this, "x", {
                            enumerable: !0,
                            get: function() {
                                return t;
                            },
                            set: function(e) {
                                t = e;
                            }
                        });
                        var e = arguments[1];
                        Object.defineProperty(this, "y", {
                            enumerable: !0,
                            get: function() {
                                return e;
                            },
                            set: function(t) {
                                e = t;
                            }
                        });
                        var n = arguments[2];
                        Object.defineProperty(this, "width", {
                            enumerable: !0,
                            get: function() {
                                return n;
                            },
                            set: function(t) {
                                n = t;
                            }
                        });
                        var r = arguments[3];
                        Object.defineProperty(this, "height", {
                            enumerable: !0,
                            get: function() {
                                return r;
                            },
                            set: function(t) {
                                r = t;
                            }
                        });
                        var i = arguments[4];
                        Object.defineProperty(this, "text", {
                            enumerable: !0,
                            get: function() {
                                return i;
                            },
                            set: function(t) {
                                i = t;
                            }
                        });
                        var a = arguments[5];
                        Object.defineProperty(this, "lineNumber", {
                            enumerable: !0,
                            get: function() {
                                return a;
                            },
                            set: function(t) {
                                a = t;
                            }
                        });
                        var o = arguments[6];
                        return Object.defineProperty(this, "align", {
                            enumerable: !0,
                            get: function() {
                                return o;
                            },
                            set: function(t) {
                                o = t;
                            }
                        }), this;
                    };
                    o.prototype.clone = function() {
                        return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
                    }, o.prototype.toArray = function() {
                        return [
                            this.x,
                            this.y,
                            this.width,
                            this.height,
                            this.text,
                            this.lineNumber,
                            this.align
                        ];
                    }, e.setHeaderFunction = function(t) {
                        return i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
                    }, e.getTextDimensions = function(t, e) {
                        i.call(this);
                        var n = (e = e || {}).fontSize || this.getFontSize(), r = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, u = 0, c = this;
                        if (!Array.isArray(t) && "string" != typeof t) {
                            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
                            t = String(t);
                        }
                        var l = e.maxWidth;
                        l > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, l) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function(t, e) {
                            return t.concat(c.splitTextToSize(e, l));
                        }, [])) : t = Array.isArray(t) ? t : [
                            t
                        ];
                        for(var h = 0; h < t.length; h++)o < (u = this.getStringUnitWidth(t[h], {
                            font: r
                        }) * n) && (o = u);
                        return 0 !== o && (s = t.length), {
                            w: o /= a,
                            h: Math.max((s * n * this.getLineHeightFactor() - n * (this.getLineHeightFactor() - 1)) / a, 0)
                        };
                    }, e.cellAddPage = function() {
                        i.call(this), this.addPage();
                        var t = this.internal.__cell__.margins || n;
                        return this.internal.__cell__.lastCell = new o(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
                    };
                    var s = e.cell = function() {
                        var t;
                        t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]), i.call(this);
                        var e = this.internal.__cell__.lastCell, a = this.internal.__cell__.padding, s = this.internal.__cell__.margins || n, u = this.internal.__cell__.tableHeaderRow, c = this.internal.__cell__.printHeaders;
                        return void 0 !== e.lineNumber && (e.lineNumber === t.lineNumber ? (t.x = (e.x || 0) + (e.width || 0), t.y = e.y || 0) : e.y + e.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, c && u && (this.printHeaderRow(t.lineNumber, !0), t.y += u[0].height)) : t.y = e.y + e.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === r ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - a, t.y + a, {
                            align: "right",
                            baseline: "top"
                        }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + a, {
                            align: "center",
                            baseline: "top",
                            maxWidth: t.width - a - a
                        }) : this.text(t.text, t.x + a, t.y + a, {
                            align: "left",
                            baseline: "top",
                            maxWidth: t.width - a - a
                        })), this.internal.__cell__.lastCell = t, this;
                    };
                    e.table = function(e, r, c, l, h) {
                        if (i.call(this), !c) throw new Error("No data for PDF table.");
                        var f, d, p, g, m = [], v = [], b = [], y = {}, w = {}, N = [], L = [], x = (h = h || {}).autoSize || !1, A = !1 !== h.printHeaders, S = h.css && void 0 !== h.css["font-size"] ? 16 * h.css["font-size"] : h.fontSize || 12, _ = h.margins || Object.assign({
                            width: this.getPageWidth()
                        }, n), P = "number" == typeof h.padding ? h.padding : 3, k = h.headerBackgroundColor || "#c8c8c8", F = h.headerTextColor || "#000";
                        if (a.call(this), this.internal.__cell__.printHeaders = A, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = F, this.setFontSize(S), null == l) v = m = Object.keys(c[0]), b = m.map(function() {
                            return "left";
                        });
                        else if (Array.isArray(l) && "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(l[0])) for(m = l.map(function(t) {
                            return t.name;
                        }), v = l.map(function(t) {
                            return t.prompt || t.name || "";
                        }), b = l.map(function(t) {
                            return t.align || "left";
                        }), f = 0; f < l.length; f += 1)w[l[f].name] = .7499990551181103 * l[f].width;
                        else Array.isArray(l) && "string" == typeof l[0] && (v = m = l, b = m.map(function() {
                            return "left";
                        }));
                        if (x || Array.isArray(l) && "string" == typeof l[0]) for(f = 0; f < m.length; f += 1){
                            for(y[g = m[f]] = c.map(function(t) {
                                return t[g];
                            }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
                                fontSize: this.internal.__cell__.table_font_size,
                                scaleFactor: this.internal.scaleFactor
                            }).w), d = y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1)N.push(this.getTextDimensions(d[p], {
                                fontSize: this.internal.__cell__.table_font_size,
                                scaleFactor: this.internal.scaleFactor
                            }).w);
                            w[g] = Math.max.apply(null, N) + P + P, N = [];
                        }
                        if (A) {
                            var I = {};
                            for(f = 0; f < m.length; f += 1)I[m[f]] = {}, I[m[f]].text = v[f], I[m[f]].align = b[f];
                            var j = u.call(this, I, w);
                            L = m.map(function(t) {
                                return new o(e, r, w[t], j, I[t].text, void 0, I[t].align);
                            }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
                        }
                        var C = l.reduce(function(t, e) {
                            return t[e.name] = e.align, t;
                        }, {});
                        for(f = 0; f < c.length; f += 1){
                            "rowStart" in h && h.rowStart instanceof Function && h.rowStart({
                                row: f,
                                data: c[f]
                            }, this);
                            var O = u.call(this, c[f], w);
                            for(p = 0; p < m.length; p += 1){
                                var B = c[f][m[p]];
                                "cellStart" in h && h.cellStart instanceof Function && h.cellStart({
                                    row: f,
                                    col: p,
                                    data: B
                                }, this), s.call(this, new o(e, r, w[m[p]], O, B, f + 2, C[m[p]]));
                            }
                        }
                        return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = r, this;
                    };
                    var u = function(t, e) {
                        var n = this.internal.__cell__.padding, r = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
                        return Object.keys(t).map(function(r) {
                            var i = t[r];
                            return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, e[r] - n - n);
                        }, this).map(function(t) {
                            return this.getLineHeightFactor() * t.length * r / i + n + n;
                        }, this).reduce(function(t, e) {
                            return Math.max(t, e);
                        }, 0);
                    };
                    e.setTableHeaderRow = function(t) {
                        i.call(this), this.internal.__cell__.tableHeaderRow = t;
                    }, e.printHeaderRow = function(t, e) {
                        if (i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
                        var n;
                        if (r = !0, "function" == typeof this.internal.__cell__.headerFunction) {
                            var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
                            this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
                        }
                        this.setFont(void 0, "bold");
                        for(var u = [], c = 0; c < this.internal.__cell__.tableHeaderRow.length; c += 1){
                            n = this.internal.__cell__.tableHeaderRow[c].clone(), e && (n.y = this.internal.__cell__.margins.top || 0, u.push(n)), n.lineNumber = t;
                            var l = this.getTextColor();
                            this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, n), this.setTextColor(l);
                        }
                        u.length > 0 && this.setTableHeaderRow(u), this.setFont(void 0, "normal"), r = !1;
                    };
                }(E.API);
                var Pt = {
                    italic: [
                        "italic",
                        "oblique",
                        "normal"
                    ],
                    oblique: [
                        "oblique",
                        "italic",
                        "normal"
                    ],
                    normal: [
                        "normal",
                        "oblique",
                        "italic"
                    ]
                }, kt = [
                    "ultra-condensed",
                    "extra-condensed",
                    "condensed",
                    "semi-condensed",
                    "normal",
                    "semi-expanded",
                    "expanded",
                    "extra-expanded",
                    "ultra-expanded"
                ], Ft = _t(kt), It = [
                    100,
                    200,
                    300,
                    400,
                    500,
                    600,
                    700,
                    800,
                    900
                ], jt = _t(It);
                function Ct(t) {
                    var e = t.family.replace(/"|'/g, "").toLowerCase(), n = function(t) {
                        return Pt[t = t || "normal"] ? t : "normal";
                    }(t.style), r = function(t) {
                        return t ? "number" == typeof t ? t >= 100 && t <= 900 && t % 100 == 0 ? t : 400 : /^\d00$/.test(t) ? parseInt(t) : "bold" === t ? 700 : 400 : 400;
                    }(t.weight), i = function(t) {
                        return "number" == typeof Ft[t = t || "normal"] ? t : "normal";
                    }(t.stretch);
                    return {
                        family: e,
                        style: n,
                        weight: r,
                        stretch: i,
                        src: t.src || [],
                        ref: t.ref || {
                            name: e,
                            style: [
                                i,
                                n,
                                r
                            ].join(" ")
                        }
                    };
                }
                function Ot(t, e, n, r) {
                    var i;
                    for(i = n; i >= 0 && i < e.length; i += r)if (t[e[i]]) return t[e[i]];
                    for(i = n; i >= 0 && i < e.length; i -= r)if (t[e[i]]) return t[e[i]];
                }
                var Bt = {
                    "sans-serif": "helvetica",
                    fixed: "courier",
                    monospace: "courier",
                    terminal: "courier",
                    cursive: "times",
                    fantasy: "times",
                    serif: "times"
                }, Mt = {
                    caption: "times",
                    icon: "times",
                    menu: "times",
                    "message-box": "times",
                    "small-caption": "times",
                    "status-bar": "times"
                };
                function qt(t) {
                    return [
                        t.stretch,
                        t.style,
                        t.weight,
                        t.family
                    ].join(" ");
                }
                function Et(t) {
                    return t.trimLeft();
                }
                function Rt(t, e) {
                    for(var n = 0; n < t.length;){
                        if (t.charAt(n) === e) return [
                            t.substring(0, n),
                            t.substring(n + 1)
                        ];
                        n += 1;
                    }
                    return null;
                }
                function Dt(t) {
                    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
                    return null === e ? null : [
                        e[0],
                        t.substring(e[0].length)
                    ];
                }
                var Tt, zt, Ut, Ht, Wt, Vt, Gt, Yt, Jt = [
                    "times"
                ];
                function Xt(t, n, r, i, a) {
                    var o = 4, s = $t;
                    switch(a){
                        case E.API.image_compression.FAST:
                            o = 1, s = Zt;
                            break;
                        case E.API.image_compression.MEDIUM:
                            o = 6, s = Qt;
                            break;
                        case E.API.image_compression.SLOW:
                            o = 9, s = te;
                    }
                    t = function(t, e, n, r) {
                        for(var i, a = t.length / e, o = new Uint8Array(t.length + a), s = [
                            Kt,
                            Zt,
                            $t,
                            Qt,
                            te
                        ], u = 0; u < a; u += 1){
                            var c = u * e, l = t.subarray(c, c + e);
                            if (r) o.set(r(l, n, i), c + u);
                            else {
                                for(var h = s.length, f = [], d = 0; d < h; d += 1)f[d] = s[d](l, n, i);
                                var p = ne(f.concat());
                                o.set(f[p], c + u);
                            }
                            i = l;
                        }
                        return o;
                    }(t, n, Math.ceil(r * i / 8), s);
                    var u = (0, fflate__WEBPACK_IMPORTED_MODULE_1__.zlibSync)(t, {
                        level: o
                    });
                    return E.API.__addimage__.arrayBufferToBinaryString(u);
                }
                function Kt(t) {
                    var e = Array.apply([], t);
                    return e.unshift(0), e;
                }
                function Zt(t, e) {
                    var n = t.length, r = [];
                    r[0] = 1;
                    for(var i = 0; i < n; i += 1){
                        var a = t[i - e] || 0;
                        r[i + 1] = t[i] - a + 256 & 255;
                    }
                    return r;
                }
                function $t(t, e, n) {
                    var r = t.length, i = [];
                    i[0] = 2;
                    for(var a = 0; a < r; a += 1){
                        var o = n && n[a] || 0;
                        i[a + 1] = t[a] - o + 256 & 255;
                    }
                    return i;
                }
                function Qt(t, e, n) {
                    var r = t.length, i = [];
                    i[0] = 3;
                    for(var a = 0; a < r; a += 1){
                        var o = t[a - e] || 0, s = n && n[a] || 0;
                        i[a + 1] = t[a] + 256 - (o + s >>> 1) & 255;
                    }
                    return i;
                }
                function te(t, e, n) {
                    var r = t.length, i = [];
                    i[0] = 4;
                    for(var a = 0; a < r; a += 1){
                        var o = ee(t[a - e] || 0, n && n[a] || 0, n && n[a - e] || 0);
                        i[a + 1] = t[a] - o + 256 & 255;
                    }
                    return i;
                }
                function ee(t, e, n) {
                    if (t === e && e === n) return t;
                    var r = Math.abs(e - n), i = Math.abs(t - n), a = Math.abs(t + e - n - n);
                    return r <= i && r <= a ? t : i <= a ? e : n;
                }
                function ne(t) {
                    var e = t.map(function(t) {
                        return t.reduce(function(t, e) {
                            return t + Math.abs(e);
                        }, 0);
                    });
                    return e.indexOf(Math.min.apply(null, e));
                }
                function re(t, e, n) {
                    var r = e * n, i = Math.floor(r / 8), a = 16 - (r - 8 * i + n), o = (1 << n) - 1;
                    return ae(t, i) >> a & o;
                }
                function ie(t, e, n, r) {
                    var i = n * r, a = Math.floor(i / 8), o = 16 - (i - 8 * a + r), s = (1 << r) - 1, u = (e & s) << o;
                    !function(t, e, n) {
                        if (e + 1 < t.byteLength) t.setUint16(e, n, !1);
                        else {
                            var r = n >> 8 & 255;
                            t.setUint8(e, r);
                        }
                    }(t, a, ae(t, a) & ~(s << o) & 65535 | u);
                }
                function ae(t, e) {
                    return e + 1 < t.byteLength ? t.getUint16(e, !1) : t.getUint8(e) << 8;
                }
                function oe(t) {
                    var e = 0;
                    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
                    var n = t[e++] | t[e++] << 8, r = t[e++] | t[e++] << 8, i = t[e++], a = i >> 7, o = 1 << 1 + (7 & i);
                    t[e++], t[e++];
                    var s = null, u = null;
                    a && (s = e, u = o, e += 3 * o);
                    var c = !0, l = [], h = 0, f = null, d = 0, p = null;
                    for(this.width = n, this.height = r; c && e < t.length;)switch(t[e++]){
                        case 33:
                            switch(t[e++]){
                                case 255:
                                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                                    else for(e += 12;;){
                                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                                        if (0 === P) break;
                                        e += P;
                                    }
                                    break;
                                case 249:
                                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                                    var g = t[e++];
                                    h = t[e++] | t[e++] << 8, f = t[e++], 1 & g || (f = null), d = g >> 2 & 7, e++;
                                    break;
                                case 254:
                                    for(;;){
                                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                                        if (0 === P) break;
                                        e += P;
                                    }
                                    break;
                                default:
                                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
                            }
                            break;
                        case 44:
                            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << 1 + (7 & w), x = s, A = u, S = !1;
                            w >> 7 && (S = !0, x = e, A = L, e += 3 * L);
                            var _ = e;
                            for(e++;;){
                                var P;
                                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                                if (0 === P) break;
                                e += P;
                            }
                            l.push({
                                x: m,
                                y: v,
                                width: b,
                                height: y,
                                has_local_palette: S,
                                palette_offset: x,
                                palette_size: A,
                                data_offset: _,
                                data_length: e - _,
                                transparent_index: f,
                                interlaced: !!N,
                                delay: h,
                                disposal: d
                            });
                            break;
                        case 59:
                            c = !1;
                            break;
                        default:
                            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
                    }
                    this.numFrames = function() {
                        return l.length;
                    }, this.loopCount = function() {
                        return p;
                    }, this.frameInfo = function(t) {
                        if (t < 0 || t >= l.length) throw new Error("Frame index out of range.");
                        return l[t];
                    }, this.decodeAndBlitFrameBGRA = function(e, r) {
                        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
                        se(t, i.data_offset, o, a);
                        var s = i.palette_offset, u = i.transparent_index;
                        null === u && (u = 256);
                        var c = i.width, l = n - c, h = c, f = 4 * (i.y * n + i.x), d = 4 * ((i.y + i.height) * n + i.x), p = f, g = 4 * l;
                        !0 === i.interlaced && (g += 4 * n * 7);
                        for(var m = 8, v = 0, b = o.length; v < b; ++v){
                            var y = o[v];
                            if (0 === h && (h = c, (p += g) >= d && (g = 4 * l + 4 * n * (m - 1), p = f + (c + l) * (m << 1), m >>= 1)), y === u) p += 4;
                            else {
                                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                                r[p++] = L, r[p++] = N, r[p++] = w, r[p++] = 255;
                            }
                            --h;
                        }
                    }, this.decodeAndBlitFrameRGBA = function(e, r) {
                        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
                        se(t, i.data_offset, o, a);
                        var s = i.palette_offset, u = i.transparent_index;
                        null === u && (u = 256);
                        var c = i.width, l = n - c, h = c, f = 4 * (i.y * n + i.x), d = 4 * ((i.y + i.height) * n + i.x), p = f, g = 4 * l;
                        !0 === i.interlaced && (g += 4 * n * 7);
                        for(var m = 8, v = 0, b = o.length; v < b; ++v){
                            var y = o[v];
                            if (0 === h && (h = c, (p += g) >= d && (g = 4 * l + 4 * n * (m - 1), p = f + (c + l) * (m << 1), m >>= 1)), y === u) p += 4;
                            else {
                                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                                r[p++] = w, r[p++] = N, r[p++] = L, r[p++] = 255;
                            }
                            --h;
                        }
                    };
                }
                function se(t, e, n, r) {
                    for(var i = t[e++], a = 1 << i, s = a + 1, u = s + 1, c = i + 1, l = (1 << c) - 1, h = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
                        for(; h < 16 && 0 !== p;)f |= t[e++] << h, h += 8, 1 === p ? p = t[e++] : --p;
                        if (h < c) break;
                        var v = f & l;
                        if (f >>= c, h -= c, v !== a) {
                            if (v === s) break;
                            for(var b = v < u ? v : m, y = 0, w = b; w > a;)w = g[w] >> 8, ++y;
                            var N = w;
                            if (d + y + (b !== v ? 1 : 0) > r) return void o.log("Warning, gif stream longer than expected.");
                            n[d++] = N;
                            var L = d += y;
                            for(b !== v && (n[d++] = N), w = b; y--;)w = g[w], n[--L] = 255 & w, w >>= 8;
                            null !== m && u < 4096 && (g[u++] = m << 8 | N, u >= l + 1 && c < 12 && (++c, l = l << 1 | 1)), m = v;
                        } else u = s + 1, l = (1 << (c = i + 1)) - 1, m = null;
                    }
                    return d !== r && o.log("Warning, gif stream shorter than expected."), n;
                }
                /**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function ue(t) {
                    var e, n, r, i, a, o = Math.floor, s = new Array(64), u = new Array(64), c = new Array(64), l = new Array(64), h = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), x = [
                        0,
                        1,
                        5,
                        6,
                        14,
                        15,
                        27,
                        28,
                        2,
                        4,
                        7,
                        13,
                        16,
                        26,
                        29,
                        42,
                        3,
                        8,
                        12,
                        17,
                        25,
                        30,
                        41,
                        43,
                        9,
                        11,
                        18,
                        24,
                        31,
                        40,
                        44,
                        53,
                        10,
                        19,
                        23,
                        32,
                        39,
                        45,
                        52,
                        54,
                        20,
                        22,
                        33,
                        38,
                        46,
                        51,
                        55,
                        60,
                        21,
                        34,
                        37,
                        47,
                        50,
                        56,
                        59,
                        61,
                        35,
                        36,
                        48,
                        49,
                        57,
                        58,
                        62,
                        63
                    ], A = [
                        0,
                        0,
                        1,
                        5,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], S = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ], _ = [
                        0,
                        0,
                        2,
                        1,
                        3,
                        3,
                        2,
                        4,
                        3,
                        5,
                        5,
                        4,
                        4,
                        0,
                        0,
                        1,
                        125
                    ], P = [
                        1,
                        2,
                        3,
                        0,
                        4,
                        17,
                        5,
                        18,
                        33,
                        49,
                        65,
                        6,
                        19,
                        81,
                        97,
                        7,
                        34,
                        113,
                        20,
                        50,
                        129,
                        145,
                        161,
                        8,
                        35,
                        66,
                        177,
                        193,
                        21,
                        82,
                        209,
                        240,
                        36,
                        51,
                        98,
                        114,
                        130,
                        9,
                        10,
                        22,
                        23,
                        24,
                        25,
                        26,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42,
                        52,
                        53,
                        54,
                        55,
                        56,
                        57,
                        58,
                        67,
                        68,
                        69,
                        70,
                        71,
                        72,
                        73,
                        74,
                        83,
                        84,
                        85,
                        86,
                        87,
                        88,
                        89,
                        90,
                        99,
                        100,
                        101,
                        102,
                        103,
                        104,
                        105,
                        106,
                        115,
                        116,
                        117,
                        118,
                        119,
                        120,
                        121,
                        122,
                        131,
                        132,
                        133,
                        134,
                        135,
                        136,
                        137,
                        138,
                        146,
                        147,
                        148,
                        149,
                        150,
                        151,
                        152,
                        153,
                        154,
                        162,
                        163,
                        164,
                        165,
                        166,
                        167,
                        168,
                        169,
                        170,
                        178,
                        179,
                        180,
                        181,
                        182,
                        183,
                        184,
                        185,
                        186,
                        194,
                        195,
                        196,
                        197,
                        198,
                        199,
                        200,
                        201,
                        202,
                        210,
                        211,
                        212,
                        213,
                        214,
                        215,
                        216,
                        217,
                        218,
                        225,
                        226,
                        227,
                        228,
                        229,
                        230,
                        231,
                        232,
                        233,
                        234,
                        241,
                        242,
                        243,
                        244,
                        245,
                        246,
                        247,
                        248,
                        249,
                        250
                    ], k = [
                        0,
                        0,
                        3,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], F = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ], I = [
                        0,
                        0,
                        2,
                        1,
                        2,
                        4,
                        4,
                        3,
                        4,
                        7,
                        5,
                        4,
                        4,
                        0,
                        1,
                        2,
                        119
                    ], j = [
                        0,
                        1,
                        2,
                        3,
                        17,
                        4,
                        5,
                        33,
                        49,
                        6,
                        18,
                        65,
                        81,
                        7,
                        97,
                        113,
                        19,
                        34,
                        50,
                        129,
                        8,
                        20,
                        66,
                        145,
                        161,
                        177,
                        193,
                        9,
                        35,
                        51,
                        82,
                        240,
                        21,
                        98,
                        114,
                        209,
                        10,
                        22,
                        36,
                        52,
                        225,
                        37,
                        241,
                        23,
                        24,
                        25,
                        26,
                        38,
                        39,
                        40,
                        41,
                        42,
                        53,
                        54,
                        55,
                        56,
                        57,
                        58,
                        67,
                        68,
                        69,
                        70,
                        71,
                        72,
                        73,
                        74,
                        83,
                        84,
                        85,
                        86,
                        87,
                        88,
                        89,
                        90,
                        99,
                        100,
                        101,
                        102,
                        103,
                        104,
                        105,
                        106,
                        115,
                        116,
                        117,
                        118,
                        119,
                        120,
                        121,
                        122,
                        130,
                        131,
                        132,
                        133,
                        134,
                        135,
                        136,
                        137,
                        138,
                        146,
                        147,
                        148,
                        149,
                        150,
                        151,
                        152,
                        153,
                        154,
                        162,
                        163,
                        164,
                        165,
                        166,
                        167,
                        168,
                        169,
                        170,
                        178,
                        179,
                        180,
                        181,
                        182,
                        183,
                        184,
                        185,
                        186,
                        194,
                        195,
                        196,
                        197,
                        198,
                        199,
                        200,
                        201,
                        202,
                        210,
                        211,
                        212,
                        213,
                        214,
                        215,
                        216,
                        217,
                        218,
                        226,
                        227,
                        228,
                        229,
                        230,
                        231,
                        232,
                        233,
                        234,
                        242,
                        243,
                        244,
                        245,
                        246,
                        247,
                        248,
                        249,
                        250
                    ];
                    function C(t, e) {
                        for(var n = 0, r = 0, i = new Array, a = 1; a <= 16; a++){
                            for(var o = 1; o <= t[a]; o++)i[e[r]] = [], i[e[r]][0] = n, i[e[r]][1] = a, r++, n++;
                            n *= 2;
                        }
                        return i;
                    }
                    function O(t) {
                        for(var e = t[0], n = t[1] - 1; n >= 0;)e & 1 << n && (m |= 1 << v), n--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
                    }
                    function B(t) {
                        g.push(t);
                    }
                    function M(t) {
                        B(t >> 8 & 255), B(255 & t);
                    }
                    function q(t, e, n, r, i) {
                        for(var a, o = i[0], s = i[240], u = function(t, e) {
                            var n, r, i, a, o, s, u, c, l, h, f = 0;
                            for(l = 0; l < 8; ++l){
                                n = t[f], r = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], u = t[f + 6];
                                var p = n + (c = t[f + 7]), g = n - c, m = r + u, v = r - u, b = i + s, y = i - s, w = a + o, N = a - o, L = p + w, x = p - w, A = m + b, S = m - b;
                                t[f] = L + A, t[f + 4] = L - A;
                                var _ = .707106781 * (S + x);
                                t[f + 2] = x + _, t[f + 6] = x - _;
                                var P = .382683433 * ((L = N + y) - (S = v + g)), k = .5411961 * L + P, F = 1.306562965 * S + P, I = .707106781 * (A = y + v), j = g + I, C = g - I;
                                t[f + 5] = C + k, t[f + 3] = C - k, t[f + 1] = j + F, t[f + 7] = j - F, f += 8;
                            }
                            for(f = 0, l = 0; l < 8; ++l){
                                n = t[f], r = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], u = t[f + 48];
                                var O = n + (c = t[f + 56]), B = n - c, M = r + u, q = r - u, E = i + s, R = i - s, D = a + o, T = a - o, z = O + D, U = O - D, H = M + E, W = M - E;
                                t[f] = z + H, t[f + 32] = z - H;
                                var V = .707106781 * (W + U);
                                t[f + 16] = U + V, t[f + 48] = U - V;
                                var G = .382683433 * ((z = T + R) - (W = q + B)), Y = .5411961 * z + G, J = 1.306562965 * W + G, X = .707106781 * (H = R + q), K = B + X, Z = B - X;
                                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
                            }
                            for(l = 0; l < 64; ++l)h = t[l] * e[l], d[l] = h > 0 ? h + .5 | 0 : h - .5 | 0;
                            return d;
                        }(t, e), c = 0; c < 64; ++c)p[x[c]] = u[c];
                        var l = p[0] - n;
                        n = p[0], 0 == l ? O(r[0]) : (O(r[f[a = 32767 + l]]), O(h[a]));
                        for(var g = 63; g > 0 && 0 == p[g];)g--;
                        if (0 == g) return O(o), n;
                        for(var m, v = 1; v <= g;){
                            for(var b = v; 0 == p[v] && v <= g;)++v;
                            var y = v - b;
                            if (y >= 16) {
                                m = y >> 4;
                                for(var w = 1; w <= m; ++w)O(s);
                                y &= 15;
                            }
                            a = 32767 + p[v], O(i[(y << 4) + f[a]]), O(h[a]), v++;
                        }
                        return 63 != g && O(o), n;
                    }
                    function E(t) {
                        t = Math.min(Math.max(t, 1), 100), a != t && (function(t) {
                            for(var e = [
                                16,
                                11,
                                10,
                                16,
                                24,
                                40,
                                51,
                                61,
                                12,
                                12,
                                14,
                                19,
                                26,
                                58,
                                60,
                                55,
                                14,
                                13,
                                16,
                                24,
                                40,
                                57,
                                69,
                                56,
                                14,
                                17,
                                22,
                                29,
                                51,
                                87,
                                80,
                                62,
                                18,
                                22,
                                37,
                                56,
                                68,
                                109,
                                103,
                                77,
                                24,
                                35,
                                55,
                                64,
                                81,
                                104,
                                113,
                                92,
                                49,
                                64,
                                78,
                                87,
                                103,
                                121,
                                120,
                                101,
                                72,
                                92,
                                95,
                                98,
                                112,
                                100,
                                103,
                                99
                            ], n = 0; n < 64; n++){
                                var r = o((e[n] * t + 50) / 100);
                                r = Math.min(Math.max(r, 1), 255), s[x[n]] = r;
                            }
                            for(var i = [
                                17,
                                18,
                                24,
                                47,
                                99,
                                99,
                                99,
                                99,
                                18,
                                21,
                                26,
                                66,
                                99,
                                99,
                                99,
                                99,
                                24,
                                26,
                                56,
                                99,
                                99,
                                99,
                                99,
                                99,
                                47,
                                66,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99,
                                99
                            ], a = 0; a < 64; a++){
                                var h = o((i[a] * t + 50) / 100);
                                h = Math.min(Math.max(h, 1), 255), u[x[a]] = h;
                            }
                            for(var f = [
                                1,
                                1.387039845,
                                1.306562965,
                                1.175875602,
                                1,
                                .785694958,
                                .5411961,
                                .275899379
                            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)c[d] = 1 / (s[x[d]] * f[p] * f[g] * 8), l[d] = 1 / (u[x[d]] * f[p] * f[g] * 8), d++;
                        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
                    }
                    this.encode = function(t, a) {
                        a && E(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function() {
                            M(65499), M(132), B(0);
                            for(var t = 0; t < 64; t++)B(s[t]);
                            B(1);
                            for(var e = 0; e < 64; e++)B(u[e]);
                        }(), function(t, e) {
                            M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
                        }(t.width, t.height), function() {
                            M(65476), M(418), B(0);
                            for(var t = 0; t < 16; t++)B(A[t + 1]);
                            for(var e = 0; e <= 11; e++)B(S[e]);
                            B(16);
                            for(var n = 0; n < 16; n++)B(_[n + 1]);
                            for(var r = 0; r <= 161; r++)B(P[r]);
                            B(1);
                            for(var i = 0; i < 16; i++)B(k[i + 1]);
                            for(var a = 0; a <= 11; a++)B(F[a]);
                            B(17);
                            for(var o = 0; o < 16; o++)B(I[o + 1]);
                            for(var s = 0; s <= 161; s++)B(j[s]);
                        }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
                        var o = 0, h = 0, f = 0;
                        m = 0, v = 7, this.encode.displayName = "_encode_";
                        for(var d, p, N, x, C, R, D, T, z, U = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
                            for(d = 0; d < V;){
                                for(C = V * G + d, D = -1, T = 0, z = 0; z < 64; z++)R = C + (T = z >> 3) * V + (D = 4 * (7 & z)), G + T >= W && (R -= V * (G + 1 + T - W)), d + D >= V && (R -= d + D - V + 4), p = U[R++], N = U[R++], x = U[R++], b[z] = (L[p] + L[N + 256 | 0] + L[x + 512 | 0] >> 16) - 128, y[z] = (L[p + 768 | 0] + L[N + 1024 | 0] + L[x + 1280 | 0] >> 16) - 128, w[z] = (L[p + 1280 | 0] + L[N + 1536 | 0] + L[x + 1792 | 0] >> 16) - 128;
                                o = q(b, c, o, e, r), h = q(y, l, h, n, i), f = q(w, l, f, n, i), d += 32;
                            }
                            G += 8;
                        }
                        if (v >= 0) {
                            var Y = [];
                            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
                        }
                        return M(65497), new Uint8Array(g);
                    }, t = t || 50, function() {
                        for(var t = String.fromCharCode, e = 0; e < 256; e++)N[e] = t(e);
                    }(), e = C(A, S), n = C(k, F), r = C(_, P), i = C(I, j), function() {
                        for(var t = 1, e = 2, n = 1; n <= 15; n++){
                            for(var r = t; r < e; r++)f[32767 + r] = n, h[32767 + r] = [], h[32767 + r][1] = n, h[32767 + r][0] = r;
                            for(var i = -(e - 1); i <= -t; i++)f[32767 + i] = n, h[32767 + i] = [], h[32767 + i][1] = n, h[32767 + i][0] = e - 1 + i;
                            t <<= 1, e <<= 1;
                        }
                    }(), function() {
                        for(var t = 0; t < 256; t++)L[t] = 19595 * t, L[t + 256 | 0] = 38470 * t, L[t + 512 | 0] = 7471 * t + 32768, L[t + 768 | 0] = -11059 * t, L[t + 1024 | 0] = -21709 * t, L[t + 1280 | 0] = 32768 * t + 8421375, L[t + 1536 | 0] = -27439 * t, L[t + 1792 | 0] = -5329 * t;
                    }(), E(t);
                }
                /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function ce(t, e) {
                    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
                        "BM",
                        "BA",
                        "CI",
                        "CP",
                        "IC",
                        "PT"
                    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
                    this.parseHeader(), this.parseBGR();
                }
                function le(t) {
                    function e(t) {
                        if (!t) throw Error("assert :P");
                    }
                    function n(t, e, n) {
                        for(var r = 0; 4 > r; r++)if (t[e + r] != n.charCodeAt(r)) return !0;
                        return !1;
                    }
                    function r(t, e, n, r, i) {
                        for(var a = 0; a < i; a++)t[e + a] = n[r + a];
                    }
                    function i(t, e, n, r) {
                        for(var i = 0; i < r; i++)t[e + i] = n;
                    }
                    function a(t) {
                        return new Int32Array(t);
                    }
                    function o(t, e) {
                        for(var n = [], r = 0; r < t; r++)n.push(new e);
                        return n;
                    }
                    function s(t, e) {
                        var n = [];
                        return function t(n, r, i) {
                            for(var a = i[r], o = 0; o < a && (n.push(i.length > r + 1 ? [] : new e), !(i.length < r + 1)); o++)t(n[o], r + 1, i);
                        }(n, 0, t), n;
                    }
                    var u = function() {
                        var t = this;
                        function u(t, e) {
                            for(var n = 1 << e - 1 >>> 0; t & n;)n >>>= 1;
                            return n ? (t & n - 1) + n : t;
                        }
                        function c(t, n, r, i, a) {
                            e(!(i % r));
                            do t[n + (i -= r)] = a;
                            while (0 < i);
                        }
                        function l(t, n, r, i, o) {
                            if (e(2328 >= o), 512 >= o) var s = a(512);
                            else if (null == (s = a(o))) return 0;
                            return function(t, n, r, i, o, s) {
                                var l, f, d = n, p = 1 << r, g = a(16), m = a(16);
                                for(e(0 != o), e(null != i), e(null != t), e(0 < r), f = 0; f < o; ++f){
                                    if (15 < i[f]) return 0;
                                    ++g[i[f]];
                                }
                                if (g[0] == o) return 0;
                                for(m[1] = 0, l = 1; 15 > l; ++l){
                                    if (g[l] > 1 << l) return 0;
                                    m[l + 1] = m[l] + g[l];
                                }
                                for(f = 0; f < o; ++f)l = i[f], 0 < i[f] && (s[m[l]++] = f);
                                if (1 == m[15]) return (i = new h).g = 0, i.value = s[0], c(t, d, 1, p, i), p;
                                var v, b = -1, y = p - 1, w = 0, N = 1, L = 1, x = 1 << r;
                                for(f = 0, l = 1, o = 2; l <= r; ++l, o <<= 1){
                                    if (N += L <<= 1, 0 > (L -= g[l])) return 0;
                                    for(; 0 < g[l]; --g[l])(i = new h).g = l, i.value = s[f++], c(t, d + w, o, x, i), w = u(w, l);
                                }
                                for(l = r + 1, o = 2; 15 >= l; ++l, o <<= 1){
                                    if (N += L <<= 1, 0 > (L -= g[l])) return 0;
                                    for(; 0 < g[l]; --g[l]){
                                        if (i = new h, (w & y) != b) {
                                            for(d += x, v = 1 << (b = l) - r; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                                            p += x = 1 << (v = b - r), t[n + (b = w & y)].g = v + r, t[n + b].value = d - n - b;
                                        }
                                        i.g = l - r, i.value = s[f++], c(t, d + (w >> r), o, x, i), w = u(w, l);
                                    }
                                }
                                return N != 2 * m[15] - 1 ? 0 : p;
                            }(t, n, r, i, o, s);
                        }
                        function h() {
                            this.value = this.g = 0;
                        }
                        function f() {
                            this.value = this.g = 0;
                        }
                        function d() {
                            this.G = o(5, h), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Rn, f);
                        }
                        function p(t, n, r, i) {
                            e(null != t), e(null != n), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = n, t.pa = r, t.Jd = n, t.Yc = r + i, t.Zc = 4 <= i ? r + i - 4 + 1 : r, _(t);
                        }
                        function g(t, e) {
                            for(var n = 0; 0 < e--;)n |= k(t, 128) << e;
                            return n;
                        }
                        function m(t, e) {
                            var n = g(t, e);
                            return P(t) ? -n : n;
                        }
                        function v(t, n, r, i) {
                            var a, o = 0;
                            for(e(null != t), e(null != n), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += n[r + a] << 8 * a;
                            t.Ra = o, t.bb = i, t.oa = n, t.pa = r;
                        }
                        function b(t) {
                            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << zn - 8 >>> 0, ++t.bb, t.u -= 8;
                            x(t) && (t.h = 1, t.u = 0);
                        }
                        function y(t, n) {
                            if (e(0 <= n), !t.h && n <= Tn) {
                                var r = L(t) & Dn[n];
                                return t.u += n, b(t), r;
                            }
                            return t.h = 1, t.u = 0;
                        }
                        function w() {
                            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
                        }
                        function N() {
                            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
                        }
                        function L(t) {
                            return t.Ra >>> (t.u & zn - 1) >>> 0;
                        }
                        function x(t) {
                            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > zn;
                        }
                        function A(t, e) {
                            t.u = e, t.h = x(t);
                        }
                        function S(t) {
                            t.u >= Un && (e(t.u >= Un), b(t));
                        }
                        function _(t) {
                            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
                        }
                        function P(t) {
                            return g(t, 1);
                        }
                        function k(t, e) {
                            var n = t.Ca;
                            0 > t.b && _(t);
                            var r = t.b, i = n * e >>> 8, a = (t.I >>> r > i) + 0;
                            for(a ? (n -= i, t.I -= i + 1 << r >>> 0) : n = i + 1, r = n, i = 0; 256 <= r;)i += 8, r >>= 8;
                            return r = 7 ^ i + Hn[r], t.b -= r, t.Ca = (n << r) - 1, a;
                        }
                        function F(t, e, n) {
                            t[e + 0] = n >> 24 & 255, t[e + 1] = n >> 16 & 255, t[e + 2] = n >> 8 & 255, t[e + 3] = 255 & n;
                        }
                        function I(t, e) {
                            return t[e + 0] | t[e + 1] << 8;
                        }
                        function j(t, e) {
                            return I(t, e) | t[e + 2] << 16;
                        }
                        function C(t, e) {
                            return I(t, e) | I(t, e + 2) << 16;
                        }
                        function O(t, n) {
                            var r = 1 << n;
                            return e(null != t), e(0 < n), t.X = a(r), null == t.X ? 0 : (t.Mb = 32 - n, t.Xa = n, 1);
                        }
                        function B(t, n) {
                            e(null != t), e(null != n), e(t.Xa == n.Xa), r(n.X, 0, t.X, 0, 1 << n.Xa);
                        }
                        function M() {
                            this.X = [], this.Xa = this.Mb = 0;
                        }
                        function q(t, n, r, i) {
                            e(null != r), e(null != i);
                            var a = r[0], o = i[0];
                            return 0 == a && (a = (t * o + n / 2) / n), 0 == o && (o = (n * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (r[0] = a, i[0] = o, 1);
                        }
                        function E(t, e) {
                            return t + (1 << e) - 1 >>> e;
                        }
                        function R(t, e) {
                            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
                        }
                        function D(e, n) {
                            t[n] = function(n, r, i, a, o, s, u) {
                                var c;
                                for(c = 0; c < o; ++c){
                                    var l = t[e](s[u + c - 1], i, a + c);
                                    s[u + c] = R(n[r + c], l);
                                }
                            };
                        }
                        function T() {
                            this.ud = this.hd = this.jd = 0;
                        }
                        function z(t, e) {
                            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
                        }
                        function U(t) {
                            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
                        }
                        function H(t, e) {
                            return U(t + (t - e + .5 >> 1));
                        }
                        function W(t, e, n) {
                            return Math.abs(e - n) - Math.abs(t - n);
                        }
                        function V(t, e, n, r, i, a, o) {
                            for(r = a[o - 1], n = 0; n < i; ++n)a[o + n] = r = R(t[e + n], r);
                        }
                        function G(t, e, n, r, i) {
                            var a;
                            for(a = 0; a < n; ++a){
                                var o = t[e + a], s = o >> 8 & 255, u = 16711935 & (u = (u = 16711935 & o) + ((s << 16) + s));
                                r[i + a] = (4278255360 & o) + u >>> 0;
                            }
                        }
                        function Y(t, e) {
                            e.jd = 255 & t, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
                        }
                        function J(t, e, n, r, i, a) {
                            var o;
                            for(o = 0; o < r; ++o){
                                var s = e[n + o], u = s >>> 8, c = s, l = 255 & (l = (l = s >>> 16) + ((t.jd << 24 >> 24) * (u << 24 >> 24) >>> 5));
                                c = 255 & (c = (c += (t.hd << 24 >> 24) * (u << 24 >> 24) >>> 5) + ((t.ud << 24 >> 24) * (l << 24 >> 24) >>> 5)), i[a + o] = (4278255360 & s) + (l << 16) + c;
                            }
                        }
                        function X(e, n, r, i, a) {
                            t[n] = function(t, e, n, r, o, s, u, c, l) {
                                for(r = u; r < c; ++r)for(u = 0; u < l; ++u)o[s++] = a(n[i(t[e++])]);
                            }, t[e] = function(e, n, o, s, u, c, l) {
                                var h = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                                if (8 > h) for(e = (1 << e.b) - 1, p = (1 << h) - 1; n < o; ++n){
                                    var g, m = 0;
                                    for(g = 0; g < f; ++g)g & e || (m = i(s[u++])), c[l++] = a(d[m & p]), m >>= h;
                                }
                                else t["VP8LMapColor" + r](s, u, d, p, c, l, n, o, f);
                            };
                        }
                        function K(t, e, n, r, i) {
                            for(n = e + n; e < n;){
                                var a = t[e++];
                                r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = 255 & a;
                            }
                        }
                        function Z(t, e, n, r, i) {
                            for(n = e + n; e < n;){
                                var a = t[e++];
                                r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = 255 & a, r[i++] = a >> 24 & 255;
                            }
                        }
                        function $(t, e, n, r, i) {
                            for(n = e + n; e < n;){
                                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = 240 & o | o >> 28 & 15;
                                r[i++] = a, r[i++] = o;
                            }
                        }
                        function Q(t, e, n, r, i) {
                            for(n = e + n; e < n;){
                                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                                r[i++] = a, r[i++] = o;
                            }
                        }
                        function tt(t, e, n, r, i) {
                            for(n = e + n; e < n;){
                                var a = t[e++];
                                r[i++] = 255 & a, r[i++] = a >> 8 & 255, r[i++] = a >> 16 & 255;
                            }
                        }
                        function et(t, e, n, i, a, o) {
                            if (0 == o) for(n = e + n; e < n;)F(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
                            else r(i, a, t, e, n);
                        }
                        function nt(e, n) {
                            t[n][0] = t[e + "0"], t[n][1] = t[e + "1"], t[n][2] = t[e + "2"], t[n][3] = t[e + "3"], t[n][4] = t[e + "4"], t[n][5] = t[e + "5"], t[n][6] = t[e + "6"], t[n][7] = t[e + "7"], t[n][8] = t[e + "8"], t[n][9] = t[e + "9"], t[n][10] = t[e + "10"], t[n][11] = t[e + "11"], t[n][12] = t[e + "12"], t[n][13] = t[e + "13"], t[n][14] = t[e + "0"], t[n][15] = t[e + "0"];
                        }
                        function rt(t) {
                            return t == Ur || t == Hr || t == Wr || t == Vr;
                        }
                        function it() {
                            this.eb = [], this.size = this.A = this.fb = 0;
                        }
                        function at() {
                            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
                        }
                        function ot() {
                            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
                        }
                        function st() {
                            this.width = [
                                0
                            ], this.height = [
                                0
                            ], this.Pd = [
                                0
                            ], this.Qd = [
                                0
                            ], this.format = [
                                0
                            ];
                        }
                        function ut() {
                            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
                        }
                        function ct(t) {
                            return alert("todo:WebPSamplerProcessPlane"), t.T;
                        }
                        function lt(t, e) {
                            var n = t.T, i = e.ba.f.RGBA, a = i.eb, o = i.fb + t.ka * i.A, s = mi[e.ba.S], u = t.y, c = t.O, l = t.f, h = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
                            for(0 == b ? s(u, c, null, null, l, h, f, d, l, h, f, d, a, o, null, null, w) : (s(e.ec, e.fc, u, c, p, g, m, v, l, h, f, d, a, o - i.A, a, o, w), ++n); b + 2 < y; b += 2)p = l, g = h, m = f, v = d, h += t.Rc, d += t.Rc, o += 2 * i.A, s(u, (c += 2 * t.fa) - t.fa, u, c, p, g, m, v, l, h, f, d, a, o - i.A, a, o, w);
                            return c += t.fa, t.j + y < t.o ? (r(e.ec, e.fc, u, c, w), r(e.cc, e.dc, l, h, N), r(e.Mc, e.Nc, f, d, N), n--) : 1 & y || s(u, c, null, null, l, h, f, d, l, h, f, d, a, o + i.A, null, null, w), n;
                        }
                        function ht(t, n, r) {
                            var i = t.F, a = [
                                t.J
                            ];
                            if (null != i) {
                                var o = t.U, s = n.ba.S, u = s == Dr || s == Wr;
                                n = n.ba.f.RGBA;
                                var c = [
                                    0
                                ], l = t.ka;
                                c[0] = t.T, t.Kb && (0 == l ? --c[0] : (--l, a[0] -= t.width), t.j + t.ka + t.T == t.o && (c[0] = t.o - t.j - l));
                                var h = n.eb;
                                l = n.fb + l * n.A, t = Ar(i, a[0], t.width, o, c, h, l + (u ? 0 : 3), n.A), e(r == c), t && rt(s) && Lr(h, l, u, o, c, n.A);
                            }
                            return 0;
                        }
                        function ft(t) {
                            var e = t.ma, n = e.ba.S, r = 11 > n, i = n == qr || n == Rr || n == Dr || n == Tr || 12 == n || rt(n);
                            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Mn(e.Oa, t, i ? 11 : 12)) return 0;
                            if (i && rt(n) && bn(), t.da) alert("todo:use_scaling");
                            else {
                                if (r) {
                                    if (e.Ib = ct, t.Kb) {
                                        if (n = t.U + 1 >> 1, e.memory = a(t.U + 2 * n), null == e.memory) return 0;
                                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + n, e.Ib = lt, bn();
                                    }
                                } else alert("todo:EmitYUV");
                                i && (e.Jb = ht, r && mn());
                            }
                            if (r && !Ii) {
                                for(t = 0; 256 > t; ++t)ji[t] = 89858 * (t - 128) + Si >> Ai, Bi[t] = -22014 * (t - 128) + Si, Oi[t] = -45773 * (t - 128), Ci[t] = 113618 * (t - 128) + Si >> Ai;
                                for(t = _i; t < Pi; ++t)e = 76283 * (t - 16) + Si >> Ai, Mi[t - _i] = Vt(e, 255), qi[t - _i] = Vt(e + 8 >> 4, 15);
                                Ii = 1;
                            }
                            return 1;
                        }
                        function dt(t) {
                            var n = t.ma, r = t.U, i = t.T;
                            return e(!(1 & t.ka)), 0 >= r || 0 >= i ? 0 : (r = n.Ib(t, n), null != n.Jb && n.Jb(t, n, r), n.Dc += r, 1);
                        }
                        function pt(t) {
                            t.ma.memory = null;
                        }
                        function gt(t, e, n, r) {
                            return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, n[0] = y(t, 14) + 1, r[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
                        }
                        function mt(t, e) {
                            if (4 > t) return t + 1;
                            var n = t - 2 >> 1;
                            return (2 + (1 & t) << n) + y(e, n) + 1;
                        }
                        function vt(t, e) {
                            var n;
                            return 120 < e ? e - 120 : 1 <= (n = ((n = Zr[e - 1]) >> 4) * t + (8 - (15 & n))) ? n : 1; // removed by dead control flow
                        }
                        function bt(t, e, n) {
                            var r = L(n), i = t[e += 255 & r].g - 8;
                            return 0 < i && (A(n, n.u + 8), r = L(n), e += t[e].value, e += r & (1 << i) - 1), A(n, n.u + t[e].g), t[e].value;
                        }
                        function yt(t, n, r) {
                            return r.g += t.g, r.value += t.value << n >>> 0, e(8 >= r.g), t.g;
                        }
                        function wt(t, n, r) {
                            var i = t.xc;
                            return e((n = 0 == i ? 0 : t.vc[t.md * (r >> i) + (n >> i)]) < t.Wb), t.Ya[n];
                        }
                        function Nt(t, n, i, a) {
                            var o = t.ab, s = t.c * n, u = t.C;
                            n = u + n;
                            var c = i, l = a;
                            for(a = t.Ta, i = t.Ua; 0 < o--;){
                                var h = t.gc[o], f = u, d = n, p = c, g = l, m = (l = a, c = i, h.Ea);
                                switch(e(f < d), e(d <= h.nc), h.hc){
                                    case 2:
                                        Gn(p, g, (d - f) * m, l, c);
                                        break;
                                    case 0:
                                        var v = f, b = d, y = l, w = c, N = (_ = h).Ea;
                                        0 == v && (Wn(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
                                        for(var L = 1 << _.b, x = L - 1, A = E(N, _.b), S = _.K, _ = _.w + (v >> _.b) * A; v < b;){
                                            var P = S, k = _, F = 1;
                                            for(Vn(p, g, y, w - N, 1, y, w); F < N;){
                                                var I = (F & ~x) + L;
                                                I > N && (I = N), (0, Zn[P[k++] >> 8 & 15])(p, g + +F, y, w + F - N, I - F, y, w + F), F = I;
                                            }
                                            g += N, w += N, ++v & x || (_ += A);
                                        }
                                        d != h.nc && r(l, c - m, l, c + (d - f - 1) * m, m);
                                        break;
                                    case 1:
                                        for(m = p, b = g, N = (p = h.Ea) - (w = p & ~(y = (g = 1 << h.b) - 1)), v = E(p, h.b), L = h.K, h = h.w + (f >> h.b) * v; f < d;){
                                            for(x = L, A = h, S = new T, _ = b + w, P = b + p; b < _;)Y(x[A++], S), $n(S, m, b, g, l, c), b += g, c += g;
                                            b < P && (Y(x[A++], S), $n(S, m, b, N, l, c), b += N, c += N), ++f & y || (h += v);
                                        }
                                        break;
                                    case 3:
                                        if (p == l && g == c && 0 < h.b) {
                                            for(b = l, p = m = c + (d - f) * m - (w = (d - f) * E(h.Ea, h.b)), g = l, y = c, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[y + w];
                                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                                            Yn(h, f, d, l, m, l, c);
                                        } else Yn(h, f, d, p, g, l, c);
                                }
                                c = a, l = i;
                            }
                            l != i && r(a, i, c, l, s);
                        }
                        function Lt(t, n) {
                            var r = t.V, i = t.Ba + t.c * t.C, a = n - t.C;
                            if (e(n <= t.l.o), e(16 >= a), 0 < a) {
                                var o = t.l, s = t.Ta, u = t.Ua, c = o.width;
                                if (Nt(t, a, r, i), a = u = [
                                    u
                                ], e((r = t.C) < (i = n)), e(o.v < o.va), i > o.o && (i = o.o), r < o.j) {
                                    var l = o.j - r;
                                    r = o.j, a[0] += l * c;
                                }
                                if (r >= i ? r = 0 : (a[0] += 4 * o.v, o.ka = r - o.j, o.U = o.va - o.v, o.T = i - r, r = 1), r) {
                                    if (u = u[0], 11 > (r = t.ca).S) {
                                        var h = r.f.RGBA, f = (i = r.S, a = o.U, o = o.T, l = h.eb, h.A), d = o;
                                        for(h = h.fb + t.Ma * h.A; 0 < d--;){
                                            var p = s, g = u, m = a, v = l, b = h;
                                            switch(i){
                                                case Mr:
                                                    Qn(p, g, m, v, b);
                                                    break;
                                                case qr:
                                                    tr(p, g, m, v, b);
                                                    break;
                                                case Ur:
                                                    tr(p, g, m, v, b), Lr(v, b, 0, m, 1, 0);
                                                    break;
                                                case Er:
                                                    rr(p, g, m, v, b);
                                                    break;
                                                case Rr:
                                                    et(p, g, m, v, b, 1);
                                                    break;
                                                case Hr:
                                                    et(p, g, m, v, b, 1), Lr(v, b, 0, m, 1, 0);
                                                    break;
                                                case Dr:
                                                    et(p, g, m, v, b, 0);
                                                    break;
                                                case Wr:
                                                    et(p, g, m, v, b, 0), Lr(v, b, 1, m, 1, 0);
                                                    break;
                                                case Tr:
                                                    er(p, g, m, v, b);
                                                    break;
                                                case Vr:
                                                    er(p, g, m, v, b), xr(v, b, m, 1, 0);
                                                    break;
                                                case zr:
                                                    nr(p, g, m, v, b);
                                                    break;
                                                default:
                                                    e(0);
                                            }
                                            u += c, h += f;
                                        }
                                        t.Ma += o;
                                    } else alert("todo:EmitRescaledRowsYUVA");
                                    e(t.Ma <= r.height);
                                }
                            }
                            t.C = n, e(t.C <= t.i);
                        }
                        function xt(t) {
                            var e;
                            if (0 < t.ua) return 0;
                            for(e = 0; e < t.Wb; ++e){
                                var n = t.Ya[e].G, r = t.Ya[e].H;
                                if (0 < n[1][r[1] + 0].g || 0 < n[2][r[2] + 0].g || 0 < n[3][r[3] + 0].g) return 0;
                            }
                            return 1;
                        }
                        function At(t, n, r, i, a, o) {
                            if (0 != t.Z) {
                                var s = t.qd, u = t.rd;
                                for(e(null != gi[t.Z]); n < r; ++n)gi[t.Z](s, u, i, a, i, a, o), s = i, u = a, a += o;
                                t.qd = s, t.rd = u;
                            }
                        }
                        function St(t, n) {
                            var r = t.l.ma, i = 0 == r.Z || 1 == r.Z ? t.l.j : t.C;
                            if (i = t.C < i ? i : t.C, e(n <= t.l.o), n > i) {
                                var a = t.l.width, o = r.ca, s = r.tb + a * i, u = t.V, c = t.Ba + t.c * i, l = t.gc;
                                e(1 == t.ab), e(3 == l[0].hc), Xn(l[0], i, n, u, c, o, s), At(r, i, n, o, s, a);
                            }
                            t.C = t.Ma = n;
                        }
                        function _t(t, n, r, i, a, o, s) {
                            var u = t.$ / i, c = t.$ % i, l = t.m, h = t.s, f = r + t.$, d = f;
                            a = r + i * a;
                            var p = r + i * o, g = 280 + h.ua, m = t.Pb ? u : 16777216, v = 0 < h.ua ? h.Wa : null, b = h.wc, y = f < p ? wt(h, c, u) : null;
                            e(t.C < o), e(p <= a);
                            var w = !1;
                            t: for(;;){
                                for(; w || f < p;){
                                    var N = 0;
                                    if (u >= m) {
                                        var _ = f - r;
                                        e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = u + Qr;
                                    }
                                    if (c & b || (y = wt(h, c, u)), e(null != y), y.Qb && (n[f] = y.qb, w = !0), !w) {
                                        if (S(l), y.jc) {
                                            N = l, _ = n;
                                            var P = f, k = y.pd[L(N) & Rn - 1];
                                            e(y.jc), 256 > k.g ? (A(N, N.u + k.g), _[P] = k.value, N = 0) : (A(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                                        } else N = bt(y.G[0], y.H[0], l);
                                    }
                                    if (l.h) break;
                                    if (w || 256 > N) {
                                        if (!w) {
                                            if (y.nd) n[f] = (y.qb | N << 8) >>> 0;
                                            else {
                                                if (S(l), w = bt(y.G[1], y.H[1], l), S(l), _ = bt(y.G[2], y.H[2], l), P = bt(y.G[3], y.H[3], l), l.h) break;
                                                n[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
                                            }
                                        }
                                        if (w = !1, ++f, ++c >= i && (c = 0, ++u, null != s && u <= o && !(u % 16) && s(t, u), null != v)) for(; d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                                    } else if (280 > N) {
                                        if (N = mt(N - 256, l), _ = bt(y.G[4], y.H[4], l), S(l), _ = vt(i, _ = mt(_, l)), l.h) break;
                                        if (f - r < _ || a - f < N) break t;
                                        for(P = 0; P < N; ++P)n[f + P] = n[f + P - _];
                                        for(f += N, c += N; c >= i;)c -= i, ++u, null != s && u <= o && !(u % 16) && s(t, u);
                                        if (e(f <= a), c & b && (y = wt(h, c, u)), null != v) for(; d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                                    } else {
                                        if (!(N < g)) break t;
                                        for(w = N - 280, e(null != v); d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                                        N = f, e(!(w >>> (_ = v).Xa)), n[N] = _.X[w], w = !0;
                                    }
                                    w || e(l.h == x(l));
                                }
                                if (t.Pb && l.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);
                                else {
                                    if (l.h) break t;
                                    null != s && s(t, u > o ? o : u), t.a = 0, t.$ = f - r;
                                }
                                return 1;
                            }
                            return t.a = 3, 0;
                        }
                        function Pt(t) {
                            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
                            var n = t.Wa;
                            null != n && (n.X = null), t.vb = null, e(null != t);
                        }
                        function kt() {
                            var e = new on;
                            return null == e ? null : (e.a = 0, e.xb = pi, nt("Predictor", "VP8LPredictors"), nt("Predictor", "VP8LPredictors_C"), nt("PredictorAdd", "VP8LPredictorsAdd"), nt("PredictorAdd", "VP8LPredictorsAdd_C"), Gn = G, $n = J, Qn = K, tr = Z, er = $, nr = Q, rr = tt, t.VP8LMapColor32b = Jn, t.VP8LMapColor8b = Kn, e);
                        }
                        function Ft(t, n, r, s, u) {
                            var c = 1, f = [
                                t
                            ], p = [
                                n
                            ], g = s.m, m = s.s, v = null, b = 0;
                            t: for(;;){
                                if (r) for(; c && y(g, 1);){
                                    var w = f, N = p, x = s, _ = 1, P = x.m, k = x.gc[x.ab], F = y(P, 2);
                                    if (x.Oc & 1 << F) c = 0;
                                    else {
                                        switch(x.Oc |= 1 << F, k.hc = F, k.Ea = w[0], k.nc = N[0], k.K = [
                                            null
                                        ], ++x.ab, e(4 >= x.ab), F){
                                            case 0:
                                            case 1:
                                                k.b = y(P, 3) + 2, _ = Ft(E(k.Ea, k.b), E(k.nc, k.b), 0, x, k.K), k.K = k.K[0];
                                                break;
                                            case 3:
                                                var I, j = y(P, 8) + 1, C = 16 < j ? 0 : 4 < j ? 1 : 2 < j ? 2 : 3;
                                                if (w[0] = E(k.Ea, C), k.b = C, I = _ = Ft(j, 1, 0, x, k.K)) {
                                                    var B, M = j, q = k, D = 1 << (8 >> q.b), T = a(D);
                                                    if (null == T) I = 0;
                                                    else {
                                                        var z = q.K[0], U = q.w;
                                                        for(T[0] = q.K[0][0], B = 1; B < 1 * M; ++B)T[B] = R(z[U + B], T[B - 1]);
                                                        for(; B < 4 * D; ++B)T[B] = 0;
                                                        q.K[0] = null, q.K[0] = T, I = 1;
                                                    }
                                                }
                                                _ = I;
                                                break;
                                            case 2:
                                                break;
                                            default:
                                                e(0);
                                        }
                                        c = _;
                                    }
                                }
                                if (f = f[0], p = p[0], c && y(g, 1) && !(c = 1 <= (b = y(g, 4)) && 11 >= b)) {
                                    s.a = 3;
                                    break t;
                                }
                                var H;
                                if (H = c) e: {
                                    var W, V, G, Y = s, J = f, X = p, K = b, Z = r, $ = Y.m, Q = Y.s, tt = [
                                        null
                                    ], et = 1, nt = 0, rt = $r[K];
                                    n: for(;;){
                                        if (Z && y($, 1)) {
                                            var it = y($, 3) + 2, at = E(J, it), ot = E(X, it), st = at * ot;
                                            if (!Ft(at, ot, 0, Y, tt)) break n;
                                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                                var ut = tt[W] >> 8 & 65535;
                                                tt[W] = ut, ut >= et && (et = ut + 1);
                                            }
                                        }
                                        if ($.h) break n;
                                        for(V = 0; 5 > V; ++V){
                                            var ct = Jr[V];
                                            !V && 0 < K && (ct += 1 << K), nt < ct && (nt = ct);
                                        }
                                        var lt = o(et * rt, h), ht = et, ft = o(ht, d);
                                        if (null == ft) var dt = null;
                                        else e(65536 >= ht), dt = ft;
                                        var pt = a(nt);
                                        if (null == dt || null == pt || null == lt) {
                                            Y.a = 1;
                                            break n;
                                        }
                                        var gt = lt;
                                        for(W = G = 0; W < et; ++W){
                                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                                            for(V = 0; 5 > V; ++V){
                                                ct = Jr[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ct += 1 << K);
                                                r: {
                                                    var xt, At = ct, St = Y, kt = pt, It = gt, jt = G, Ct = 0, Ot = St.m, Bt = y(Ot, 1);
                                                    if (i(kt, 0, 0, At), Bt) {
                                                        var Mt = y(Ot, 1) + 1, qt = y(Ot, 1), Et = y(Ot, 0 == qt ? 1 : 8);
                                                        kt[Et] = 1, 2 == Mt && (kt[Et = y(Ot, 8)] = 1);
                                                        var Rt = 1;
                                                    } else {
                                                        var Dt = a(19), Tt = y(Ot, 4) + 4;
                                                        if (19 < Tt) {
                                                            St.a = 3;
                                                            var zt = 0;
                                                            break r;
                                                        }
                                                        for(xt = 0; xt < Tt; ++xt)Dt[Kr[xt]] = y(Ot, 3);
                                                        var Ut = void 0, Ht = void 0, Wt = St, Vt = Dt, Gt = At, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, h);
                                                        i: for(; l(Zt, 0, 7, Vt, 19);){
                                                            if (y(Xt, 1)) {
                                                                var $t = 2 + 2 * y(Xt, 3);
                                                                if ((Ut = 2 + y(Xt, $t)) > Gt) break i;
                                                            } else Ut = Gt;
                                                            for(Ht = 0; Ht < Gt && Ut--;){
                                                                S(Xt);
                                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                                A(Xt, Xt.u + Qt.g);
                                                                var te = Qt.value;
                                                                if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);
                                                                else {
                                                                    var ee = 16 == te, ne = te - 16, re = Yr[ne], ie = y(Xt, Gr[ne]) + re;
                                                                    if (Ht + ie > Gt) break i;
                                                                    for(var ae = ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                                }
                                                            }
                                                            Jt = 1;
                                                            break i;
                                                        }
                                                        Jt || (Wt.a = 3), Rt = Jt;
                                                    }
                                                    (Rt = Rt && !Ot.h) && (Ct = l(It, jt, 8, kt, At)), Rt && 0 != Ct ? zt = Ct : (St.a = 3, zt = 0);
                                                }
                                                if (0 == zt) break n;
                                                if (Nt && 1 == Xr[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += zt, 3 >= V) {
                                                    var oe, se = pt[0];
                                                    for(oe = 1; oe < ct; ++oe)pt[oe] > se && (se = pt[oe]);
                                                    Lt += se;
                                                }
                                            }
                                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                                var ue, ce = mt;
                                                for(ue = 0; ue < Rn; ++ue){
                                                    var le = ue, he = ce.pd[le], fe = ce.G[0][ce.H[0] + le];
                                                    256 <= fe.value ? (he.g = fe.g + 256, he.value = fe.value) : (he.g = 0, he.value = 0, le >>= yt(fe, 8, he), le >>= yt(ce.G[1][ce.H[1] + le], 16, he), le >>= yt(ce.G[2][ce.H[2] + le], 0, he), yt(ce.G[3][ce.H[3] + le], 24, he));
                                                }
                                            }
                                        }
                                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = lt, H = 1;
                                        break e;
                                    }
                                    H = 0;
                                }
                                if (!(c = H)) {
                                    s.a = 3;
                                    break t;
                                }
                                if (0 < b) {
                                    if (m.ua = 1 << b, !O(m.Wa, b)) {
                                        s.a = 1, c = 0;
                                        break t;
                                    }
                                } else m.ua = 0;
                                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                                if (de.c = pe, de.i = ge, me.md = E(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, r) {
                                    s.xb = di;
                                    break t;
                                }
                                if (null == (v = a(f * p))) {
                                    s.a = 1, c = 0;
                                    break t;
                                }
                                c = (c = _t(s, v, 0, f, p, p, null)) && !g.h;
                                break t;
                            }
                            return c ? (null != u ? u[0] = v : (e(null == v), e(r)), s.$ = 0, r || Pt(m)) : Pt(m), c;
                        }
                        function It(t, n) {
                            var r = t.c * t.i, i = r + n + 16 * n;
                            return e(t.c <= n), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + r + n, 1);
                        }
                        function jt(t, n) {
                            var r = t.C, i = n - r, a = t.V, o = t.Ba + t.c * r;
                            for(e(n <= t.l.o); 0 < i;){
                                var s = 16 < i ? 16 : i, u = t.l.ma, c = t.l.width, l = c * s, h = u.ca, f = u.tb + c * r, d = t.Ta, p = t.Ua;
                                Nt(t, s, a, o), Sr(d, p, h, f, l), At(u, r, r + s, h, f, c), i -= s, a += s * t.c, r += s;
                            }
                            e(r == n), t.C = t.Ma = n;
                        }
                        function Ct() {
                            this.ub = this.yd = this.td = this.Rb = 0;
                        }
                        function Ot() {
                            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
                        }
                        function Bt() {
                            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
                        }
                        function Mt() {
                            this.Yb = function() {
                                var t = [];
                                return function t(e, n, r) {
                                    for(var i = r[n], a = 0; a < i && (e.push(r.length > n + 1 ? [] : 0), !(r.length < n + 1)); a++)t(e[a], n + 1, r);
                                }(t, 0, [
                                    3,
                                    11
                                ]), t;
                            }();
                        }
                        function qt() {
                            this.jb = a(3), this.Wc = s([
                                4,
                                8
                            ], Mt), this.Xc = s([
                                4,
                                17
                            ], Mt);
                        }
                        function Et() {
                            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
                        }
                        function Rt() {
                            this.ld = this.La = this.dd = this.tc = 0;
                        }
                        function Dt() {
                            this.Na = this.la = 0;
                        }
                        function Tt() {
                            this.Sc = [
                                0,
                                0
                            ], this.Eb = [
                                0,
                                0
                            ], this.Qc = [
                                0,
                                0
                            ], this.ia = this.lc = 0;
                        }
                        function zt() {
                            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
                        }
                        function Ut() {
                            this.uc = this.M = this.Nb = 0, this.wa = Array(new Rt), this.Y = 0, this.ya = Array(new zt), this.aa = 0, this.l = new Gt;
                        }
                        function Ht() {
                            this.y = a(16), this.f = a(8), this.ea = a(8);
                        }
                        function Wt() {
                            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new Ct, this.Kc = new Ot, this.ed = new Et, this.Qa = new Bt, this.Ic = this.$c = this.Aa = 0, this.D = new Ut, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new qt, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                                0,
                                0,
                                0,
                                0
                            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Dt), this.sb = 0, this.wa = Array(new Rt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new zt), this.L = this.aa = 0, this.gd = s([
                                4,
                                2
                            ], Rt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
                        }
                        function Vt(t, e) {
                            return 0 > t ? 0 : t > e ? e : t;
                        }
                        function Gt() {
                            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
                        }
                        function Yt() {
                            var t = new Wt;
                            return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ni || (ni = Zt)), t;
                        }
                        function Jt(t, e, n) {
                            return 0 == t.a && (t.a = e, t.sc = n, t.cb = 0), 0;
                        }
                        function Xt(t, e, n) {
                            return 3 <= n && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
                        }
                        function Kt(t, n) {
                            if (null == t) return 0;
                            if (t.a = 0, t.sc = "OK", null == n) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
                            var r = n.data, a = n.w, o = n.ha;
                            if (4 > o) return Jt(t, 7, "Truncated header.");
                            var s = r[a + 0] | r[a + 1] << 8 | r[a + 2] << 16, u = t.Od;
                            if (u.Rb = !(1 & s), u.td = s >> 1 & 7, u.yd = s >> 4 & 1, u.ub = s >> 5, 3 < u.td) return Jt(t, 3, "Incorrect keyframe parameters.");
                            if (!u.yd) return Jt(t, 4, "Frame not displayable.");
                            a += 3, o -= 3;
                            var c = t.Kc;
                            if (u.Rb) {
                                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                                if (!Xt(r, a, o)) return Jt(t, 3, "Bad code word");
                                c.c = 16383 & (r[a + 4] << 8 | r[a + 3]), c.Td = r[a + 4] >> 6, c.i = 16383 & (r[a + 6] << 8 | r[a + 5]), c.Ud = r[a + 6] >> 6, a += 7, o -= 7, t.za = c.c + 15 >> 4, t.Ub = c.i + 15 >> 4, n.width = c.c, n.height = c.i, n.Da = 0, n.j = 0, n.v = 0, n.va = n.width, n.o = n.height, n.da = 0, n.ib = n.width, n.hb = n.height, n.U = n.width, n.T = n.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
                            }
                            if (u.ub > o) return Jt(t, 7, "bad partition length");
                            p(s = t.m, r, a, u.ub), a += u.ub, o -= u.ub, u.Rb && (c.Ld = P(s), c.Kd = P(s)), c = t.Qa;
                            var l, h = t.Pa;
                            if (e(null != s), e(null != c), c.Cb = P(s), c.Cb) {
                                if (c.Bb = P(s), P(s)) {
                                    for(c.Fb = P(s), l = 0; 4 > l; ++l)c.Zb[l] = P(s) ? m(s, 7) : 0;
                                    for(l = 0; 4 > l; ++l)c.Lb[l] = P(s) ? m(s, 6) : 0;
                                }
                                if (c.Bb) for(l = 0; 3 > l; ++l)h.jb[l] = P(s) ? g(s, 8) : 255;
                            } else c.Bb = 0;
                            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
                            if ((c = t.ed).zd = P(s), c.Tb = g(s, 6), c.wb = g(s, 3), c.Pc = P(s), c.Pc && P(s)) {
                                for(h = 0; 4 > h; ++h)P(s) && (c.vd[h] = m(s, 6));
                                for(h = 0; 4 > h; ++h)P(s) && (c.od[h] = m(s, 6));
                            }
                            if (t.L = 0 == c.Tb ? 0 : c.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
                            var f = o;
                            if (o = l = a, a = l + f, c = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (h = t.Xb)) r = 7;
                            else {
                                for(l += 3 * h, c -= 3 * h, f = 0; f < h; ++f){
                                    var d = r[o + 0] | r[o + 1] << 8 | r[o + 2] << 16;
                                    d > c && (d = c), p(t.Jc[+f], r, l, d), l += d, c -= d, o += 3;
                                }
                                p(t.Jc[+h], r, l, c), r = l < a ? 0 : 5;
                            }
                            if (0 != r) return Jt(t, r, "cannot parse partitions");
                            for(r = g(l = t.m, 7), o = P(l) ? m(l, 4) : 0, a = P(l) ? m(l, 4) : 0, c = P(l) ? m(l, 4) : 0, h = P(l) ? m(l, 4) : 0, l = P(l) ? m(l, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                                if (f.Cb) {
                                    var v = f.Zb[d];
                                    f.Fb || (v += r);
                                } else {
                                    if (0 < d) {
                                        t.pb[d] = t.pb[0];
                                        continue;
                                    }
                                    v = r;
                                }
                                var b = t.pb[d];
                                b.Sc[0] = ti[Vt(v + o, 127)], b.Sc[1] = ei[Vt(v + 0, 127)], b.Eb[0] = 2 * ti[Vt(v + a, 127)], b.Eb[1] = 101581 * ei[Vt(v + c, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ti[Vt(v + h, 117)], b.Qc[1] = ei[Vt(v + l, 127)], b.lc = v + l;
                            }
                            if (!u.Rb) return Jt(t, 4, "Not a key frame.");
                            for(P(s), u = t.Pa, r = 0; 4 > r; ++r){
                                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(c = 0; 11 > c; ++c)h = k(s, ui[r][o][a][c]) ? g(s, 8) : oi[r][o][a][c], u.Wc[r][o].Yb[a][c] = h;
                                for(o = 0; 17 > o; ++o)u.Xc[r][o] = u.Wc[r][ci[o]];
                            }
                            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
                        }
                        function Zt(t, e, n, r, i, a, o) {
                            var s = e[i].Yb[n];
                            for(n = 0; 16 > i; ++i){
                                if (!k(t, s[n + 0])) return i;
                                for(; !k(t, s[n + 1]);)if (s = e[++i].Yb[0], n = 0, 16 == i) return 16;
                                var u = e[i + 1].Yb;
                                if (k(t, s[n + 2])) {
                                    var c = t, l = 0;
                                    if (k(c, (f = s)[(h = n) + 3])) {
                                        if (k(c, f[h + 6])) {
                                            for(s = 0, h = 2 * (l = k(c, f[h + 8])) + (f = k(c, f[h + 9 + l])), l = 0, f = ri[h]; f[s]; ++s)l += l + k(c, f[s]);
                                            l += 3 + (8 << h);
                                        } else k(c, f[h + 7]) ? (l = 7 + 2 * k(c, 165), l += k(c, 145)) : l = 5 + k(c, 159);
                                    } else l = k(c, f[h + 4]) ? 3 + k(c, f[h + 5]) : 2;
                                    s = u[2];
                                } else l = 1, s = u[1];
                                u = o + ii[i], 0 > (c = t).b && _(c);
                                var h, f = c.b, d = (h = c.Ca >> 1) - (c.I >> f) >> 31;
                                --c.b, c.Ca += d, c.Ca |= 1, c.I -= (h + 1 & d) << f, a[u] = ((l ^ d) - d) * r[(0 < i) + 0];
                            }
                            return 16;
                        }
                        function $t(t) {
                            var e = t.rb[t.sb - 1];
                            e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
                        }
                        function Qt(t, e, n, r, i) {
                            i = t[e + n + 32 * r] + (i >> 3), t[e + n + 32 * r] = -256 & i ? 0 > i ? 0 : 255 : i;
                        }
                        function te(t, e, n, r, i, a) {
                            Qt(t, e, 0, n, r + i), Qt(t, e, 1, n, r + a), Qt(t, e, 2, n, r - a), Qt(t, e, 3, n, r - i);
                        }
                        function ee(t) {
                            return (20091 * t >> 16) + t;
                        }
                        function ne(t, e, n, r) {
                            var i, o = 0, s = a(16);
                            for(i = 0; 4 > i; ++i){
                                var u = t[e + 0] + t[e + 8], c = t[e + 0] - t[e + 8], l = (35468 * t[e + 4] >> 16) - ee(t[e + 12]), h = ee(t[e + 4]) + (35468 * t[e + 12] >> 16);
                                s[o + 0] = u + h, s[o + 1] = c + l, s[o + 2] = c - l, s[o + 3] = u - h, o += 4, e++;
                            }
                            for(i = o = 0; 4 > i; ++i)u = (t = s[o + 0] + 4) + s[o + 8], c = t - s[o + 8], l = (35468 * s[o + 4] >> 16) - ee(s[o + 12]), Qt(n, r, 0, 0, u + (h = ee(s[o + 4]) + (35468 * s[o + 12] >> 16))), Qt(n, r, 1, 0, c + l), Qt(n, r, 2, 0, c - l), Qt(n, r, 3, 0, u - h), o++, r += 32;
                        }
                        function re(t, e, n, r) {
                            var i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = ee(t[e + 4]), s = 35468 * t[e + 1] >> 16;
                            te(n, r, 0, i + o, t = ee(t[e + 1]), s), te(n, r, 1, i + a, t, s), te(n, r, 2, i - a, t, s), te(n, r, 3, i - o, t, s);
                        }
                        function ie(t, e, n, r, i) {
                            ne(t, e, n, r), i && ne(t, e + 16, n, r + 4);
                        }
                        function ae(t, e, n, r) {
                            ar(t, e + 0, n, r, 1), ar(t, e + 32, n, r + 128, 1);
                        }
                        function oe(t, e, n, r) {
                            var i;
                            for(t = t[e + 0] + 4, i = 0; 4 > i; ++i)for(e = 0; 4 > e; ++e)Qt(n, r, e, i, t);
                        }
                        function se(t, e, n, r) {
                            t[e + 0] && ur(t, e + 0, n, r), t[e + 16] && ur(t, e + 16, n, r + 4), t[e + 32] && ur(t, e + 32, n, r + 128), t[e + 48] && ur(t, e + 48, n, r + 128 + 4);
                        }
                        function ue(t, e, n, r) {
                            var i, o = a(16);
                            for(i = 0; 4 > i; ++i){
                                var s = t[e + 0 + i] + t[e + 12 + i], u = t[e + 4 + i] + t[e + 8 + i], c = t[e + 4 + i] - t[e + 8 + i], l = t[e + 0 + i] - t[e + 12 + i];
                                o[0 + i] = s + u, o[8 + i] = s - u, o[4 + i] = l + c, o[12 + i] = l - c;
                            }
                            for(i = 0; 4 > i; ++i)s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], u = o[1 + 4 * i] + o[2 + 4 * i], c = o[1 + 4 * i] - o[2 + 4 * i], l = t - o[3 + 4 * i], n[r + 0] = s + u >> 3, n[r + 16] = l + c >> 3, n[r + 32] = s - u >> 3, n[r + 48] = l - c >> 3, r += 64;
                        }
                        function ce(t, e, n) {
                            var r, i = e - 32, a = Or, o = 255 - t[i - 1];
                            for(r = 0; r < n; ++r){
                                var s, u = a, c = o + t[e - 1];
                                for(s = 0; s < n; ++s)t[e + s] = u[c + t[i + s]];
                                e += 32;
                            }
                        }
                        function le(t, e) {
                            ce(t, e, 4);
                        }
                        function he(t, e) {
                            ce(t, e, 8);
                        }
                        function fe(t, e) {
                            ce(t, e, 16);
                        }
                        function de(t, e) {
                            var n;
                            for(n = 0; 16 > n; ++n)r(t, e + 32 * n, t, e - 32, 16);
                        }
                        function pe(t, e) {
                            var n;
                            for(n = 16; 0 < n; --n)i(t, e, t[e - 1], 16), e += 32;
                        }
                        function ge(t, e, n) {
                            var r;
                            for(r = 0; 16 > r; ++r)i(e, n + 32 * r, t, 16);
                        }
                        function me(t, e) {
                            var n, r = 16;
                            for(n = 0; 16 > n; ++n)r += t[e - 1 + 32 * n] + t[e + n - 32];
                            ge(r >> 5, t, e);
                        }
                        function ve(t, e) {
                            var n, r = 8;
                            for(n = 0; 16 > n; ++n)r += t[e - 1 + 32 * n];
                            ge(r >> 4, t, e);
                        }
                        function be(t, e) {
                            var n, r = 8;
                            for(n = 0; 16 > n; ++n)r += t[e + n - 32];
                            ge(r >> 4, t, e);
                        }
                        function ye(t, e) {
                            ge(128, t, e);
                        }
                        function we(t, e, n) {
                            return t + 2 * e + n + 2 >> 2;
                        }
                        function Ne(t, e) {
                            var n, i = e - 32;
                            for(i = new Uint8Array([
                                we(t[i - 1], t[i + 0], t[i + 1]),
                                we(t[i + 0], t[i + 1], t[i + 2]),
                                we(t[i + 1], t[i + 2], t[i + 3]),
                                we(t[i + 2], t[i + 3], t[i + 4])
                            ]), n = 0; 4 > n; ++n)r(t, e + 32 * n, i, 0, i.length);
                        }
                        function Le(t, e) {
                            var n = t[e - 1], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
                            F(t, e + 0, 16843009 * we(t[e - 1 - 32], n, r)), F(t, e + 32, 16843009 * we(n, r, i)), F(t, e + 64, 16843009 * we(r, i, a)), F(t, e + 96, 16843009 * we(i, a, a));
                        }
                        function xe(t, e) {
                            var n, r = 4;
                            for(n = 0; 4 > n; ++n)r += t[e + n - 32] + t[e - 1 + 32 * n];
                            for(r >>= 3, n = 0; 4 > n; ++n)i(t, e + 32 * n, r, 4);
                        }
                        function Ae(t, e) {
                            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
                            t[e + 0 + 96] = we(r, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = we(n, r, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = we(a, n, r), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = we(o, a, n), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = we(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = we(u, s, o), t[e + 3 + 0] = we(c, u, s);
                        }
                        function Se(t, e) {
                            var n = t[e + 1 - 32], r = t[e + 2 - 32], i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], u = t[e + 7 - 32];
                            t[e + 0 + 0] = we(t[e + 0 - 32], n, r), t[e + 1 + 0] = t[e + 0 + 32] = we(n, r, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = we(r, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = we(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = we(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = we(o, s, u), t[e + 3 + 96] = we(s, u, u);
                        }
                        function _e(t, e) {
                            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
                            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + u + 1 >> 1, t[e + 3 + 0] = u + c + 1 >> 1, t[e + 0 + 96] = we(i, r, n), t[e + 0 + 64] = we(r, n, a), t[e + 0 + 32] = t[e + 1 + 96] = we(n, a, o), t[e + 1 + 32] = t[e + 2 + 96] = we(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = we(o, s, u), t[e + 3 + 32] = we(s, u, c);
                        }
                        function Pe(t, e) {
                            var n = t[e + 0 - 32], r = t[e + 1 - 32], i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], u = t[e + 6 - 32], c = t[e + 7 - 32];
                            t[e + 0 + 0] = n + r + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = r + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = we(n, r, i), t[e + 1 + 32] = t[e + 0 + 96] = we(r, i, a), t[e + 2 + 32] = t[e + 1 + 96] = we(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = we(a, o, s), t[e + 3 + 64] = we(o, s, u), t[e + 3 + 96] = we(s, u, c);
                        }
                        function ke(t, e) {
                            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
                            t[e + 0 + 0] = n + r + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = r + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = we(n, r, i), t[e + 3 + 0] = t[e + 1 + 32] = we(r, i, a), t[e + 3 + 32] = t[e + 1 + 64] = we(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
                        }
                        function Fe(t, e) {
                            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], u = t[e + 1 - 32], c = t[e + 2 - 32];
                            t[e + 0 + 0] = t[e + 2 + 32] = n + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = r + n + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + r + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = we(s, u, c), t[e + 2 + 0] = we(o, s, u), t[e + 1 + 0] = t[e + 3 + 32] = we(n, o, s), t[e + 1 + 32] = t[e + 3 + 64] = we(r, n, o), t[e + 1 + 64] = t[e + 3 + 96] = we(i, r, n), t[e + 1 + 96] = we(a, i, r);
                        }
                        function Ie(t, e) {
                            var n;
                            for(n = 0; 8 > n; ++n)r(t, e + 32 * n, t, e - 32, 8);
                        }
                        function je(t, e) {
                            var n;
                            for(n = 0; 8 > n; ++n)i(t, e, t[e - 1], 8), e += 32;
                        }
                        function Ce(t, e, n) {
                            var r;
                            for(r = 0; 8 > r; ++r)i(e, n + 32 * r, t, 8);
                        }
                        function Oe(t, e) {
                            var n, r = 8;
                            for(n = 0; 8 > n; ++n)r += t[e + n - 32] + t[e - 1 + 32 * n];
                            Ce(r >> 4, t, e);
                        }
                        function Be(t, e) {
                            var n, r = 4;
                            for(n = 0; 8 > n; ++n)r += t[e + n - 32];
                            Ce(r >> 3, t, e);
                        }
                        function Me(t, e) {
                            var n, r = 4;
                            for(n = 0; 8 > n; ++n)r += t[e - 1 + 32 * n];
                            Ce(r >> 3, t, e);
                        }
                        function qe(t, e) {
                            Ce(128, t, e);
                        }
                        function Ee(t, e, n) {
                            var r = t[e - n], i = t[e + 0], a = 3 * (i - r) + jr[1020 + t[e - 2 * n] - t[e + n]], o = Cr[112 + (a + 4 >> 3)];
                            t[e - n] = Or[255 + r + Cr[112 + (a + 3 >> 3)]], t[e + 0] = Or[255 + i - o];
                        }
                        function Re(t, e, n, r) {
                            var i = t[e + 0], a = t[e + n];
                            return Br[255 + t[e - 2 * n] - t[e - n]] > r || Br[255 + a - i] > r;
                        }
                        function De(t, e, n, r) {
                            return 4 * Br[255 + t[e - n] - t[e + 0]] + Br[255 + t[e - 2 * n] - t[e + n]] <= r;
                        }
                        function Te(t, e, n, r, i) {
                            var a = t[e - 3 * n], o = t[e - 2 * n], s = t[e - n], u = t[e + 0], c = t[e + n], l = t[e + 2 * n], h = t[e + 3 * n];
                            return 4 * Br[255 + s - u] + Br[255 + o - c] > r ? 0 : Br[255 + t[e - 4 * n] - a] <= i && Br[255 + a - o] <= i && Br[255 + o - s] <= i && Br[255 + h - l] <= i && Br[255 + l - c] <= i && Br[255 + c - u] <= i;
                        }
                        function ze(t, e, n, r) {
                            var i = 2 * r + 1;
                            for(r = 0; 16 > r; ++r)De(t, e + r, n, i) && Ee(t, e + r, n);
                        }
                        function Ue(t, e, n, r) {
                            var i = 2 * r + 1;
                            for(r = 0; 16 > r; ++r)De(t, e + r * n, 1, i) && Ee(t, e + r * n, 1);
                        }
                        function He(t, e, n, r) {
                            var i;
                            for(i = 3; 0 < i; --i)ze(t, e += 4 * n, n, r);
                        }
                        function We(t, e, n, r) {
                            var i;
                            for(i = 3; 0 < i; --i)Ue(t, e += 4, n, r);
                        }
                        function Ve(t, e, n, r, i, a, o, s) {
                            for(a = 2 * a + 1; 0 < i--;){
                                if (Te(t, e, n, a, o)) {
                                    if (Re(t, e, n, s)) Ee(t, e, n);
                                    else {
                                        var u = t, c = e, l = n, h = u[c - 2 * l], f = u[c - l], d = u[c + 0], p = u[c + l], g = u[c + 2 * l], m = 27 * (b = jr[1020 + 3 * (d - f) + jr[1020 + h - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                                        u[c - 3 * l] = Or[255 + u[c - 3 * l] + b], u[c - 2 * l] = Or[255 + h + v], u[c - l] = Or[255 + f + m], u[c + 0] = Or[255 + d - m], u[c + l] = Or[255 + p - v], u[c + 2 * l] = Or[255 + g - b];
                                    }
                                }
                                e += r;
                            }
                        }
                        function Ge(t, e, n, r, i, a, o, s) {
                            for(a = 2 * a + 1; 0 < i--;){
                                if (Te(t, e, n, a, o)) {
                                    if (Re(t, e, n, s)) Ee(t, e, n);
                                    else {
                                        var u = t, c = e, l = n, h = u[c - l], f = u[c + 0], d = u[c + l], p = Cr[112 + (4 + (g = 3 * (f - h)) >> 3)], g = Cr[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                                        u[c - 2 * l] = Or[255 + u[c - 2 * l] + m], u[c - l] = Or[255 + h + g], u[c + 0] = Or[255 + f - p], u[c + l] = Or[255 + d - m];
                                    }
                                }
                                e += r;
                            }
                        }
                        function Ye(t, e, n, r, i, a) {
                            Ve(t, e, n, 1, 16, r, i, a);
                        }
                        function Je(t, e, n, r, i, a) {
                            Ve(t, e, 1, n, 16, r, i, a);
                        }
                        function Xe(t, e, n, r, i, a) {
                            var o;
                            for(o = 3; 0 < o; --o)Ge(t, e += 4 * n, n, 1, 16, r, i, a);
                        }
                        function Ke(t, e, n, r, i, a) {
                            var o;
                            for(o = 3; 0 < o; --o)Ge(t, e += 4, 1, n, 16, r, i, a);
                        }
                        function Ze(t, e, n, r, i, a, o, s) {
                            Ve(t, e, i, 1, 8, a, o, s), Ve(n, r, i, 1, 8, a, o, s);
                        }
                        function $e(t, e, n, r, i, a, o, s) {
                            Ve(t, e, 1, i, 8, a, o, s), Ve(n, r, 1, i, 8, a, o, s);
                        }
                        function Qe(t, e, n, r, i, a, o, s) {
                            Ge(t, e + 4 * i, i, 1, 8, a, o, s), Ge(n, r + 4 * i, i, 1, 8, a, o, s);
                        }
                        function tn(t, e, n, r, i, a, o, s) {
                            Ge(t, e + 4, 1, i, 8, a, o, s), Ge(n, r + 4, 1, i, 8, a, o, s);
                        }
                        function en() {
                            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ut, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
                        }
                        function nn() {
                            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
                        }
                        function rn() {
                            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
                        }
                        function an() {
                            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new h;
                        }
                        function on() {
                            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new an, this.ab = 0, this.gc = o(4, rn), this.Oc = 0;
                        }
                        function sn() {
                            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
                        }
                        function un(t, e, n, r, i, a, o) {
                            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + n[r + e] & 255, t = i[a + e];
                        }
                        function cn(t, e, n, r, i, a, o) {
                            var s;
                            if (null == t) un(null, null, n, r, i, a, o);
                            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + n[r + s] & 255;
                        }
                        function ln(t, e, n, r, i, a, o) {
                            if (null == t) un(null, null, n, r, i, a, o);
                            else {
                                var s, u = t[e + 0], c = u, l = u;
                                for(s = 0; s < o; ++s)c = l + (u = t[e + s]) - c, l = n[r + s] + (-256 & c ? 0 > c ? 0 : 255 : c) & 255, c = u, i[a + s] = l;
                            }
                        }
                        function hn(t, n, i, o) {
                            var s = n.width, u = n.o;
                            if (e(null != t && null != n), 0 > i || 0 >= o || i + o > u) return null;
                            if (!t.Cc) {
                                if (null == t.ga) {
                                    var c;
                                    if (t.ga = new sn, (c = null == t.ga) || (c = n.width * n.o, e(0 == t.Gb.length), t.Gb = a(c), t.Uc = 0, null == t.Gb ? c = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, c = 1), c = !c), !c) {
                                        c = t.ga;
                                        var l = t.Fa, h = t.P, f = t.qc, d = t.mb, p = t.nb, g = h + 1, m = f - 1, b = c.l;
                                        if (e(null != l && null != d && null != n), gi[0] = null, gi[1] = un, gi[2] = cn, gi[3] = ln, c.ca = d, c.tb = p, c.c = n.width, c.i = n.height, e(0 < c.c && 0 < c.i), 1 >= f) n = 0;
                                        else if (c.$a = 3 & l[h + 0], c.Z = l[h + 0] >> 2 & 3, c.Lc = l[h + 0] >> 4 & 3, h = l[h + 0] >> 6 & 3, 0 > c.$a || 1 < c.$a || 4 <= c.Z || 1 < c.Lc || h) n = 0;
                                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = c, b.width = n.width, b.height = n.height, b.Da = n.Da, b.v = n.v, b.va = n.va, b.j = n.j, b.o = n.o, c.$a) t: {
                                            e(1 == c.$a), n = kt();
                                            e: for(;;){
                                                if (null == n) {
                                                    n = 0;
                                                    break t;
                                                }
                                                if (e(null != c), c.mc = n, n.c = c.c, n.i = c.i, n.l = c.l, n.l.ma = c, n.l.width = c.c, n.l.height = c.i, n.a = 0, v(n.m, l, g, m), !Ft(c.c, c.i, 1, n, null)) break e;
                                                if (1 == n.ab && 3 == n.gc[0].hc && xt(n.s) ? (c.ic = 1, l = n.c * n.i, n.Ta = null, n.Ua = 0, n.V = a(l), n.Ba = 0, null == n.V ? (n.a = 1, n = 0) : n = 1) : (c.ic = 0, n = It(n, c.c)), !n) break e;
                                                n = 1;
                                                break t;
                                            }
                                            c.mc = null, n = 0;
                                        }
                                        else n = m >= c.c * c.i;
                                        c = !n;
                                    }
                                    if (c) return null;
                                    1 != t.ga.Lc ? t.Ga = 0 : o = u - i;
                                }
                                e(null != t.ga), e(i + o <= u);
                                t: {
                                    if (n = (l = t.ga).c, u = l.l.o, 0 == l.$a) {
                                        if (g = t.rc, m = t.Vc, b = t.Fa, h = t.P + 1 + i * n, f = t.mb, d = t.nb + i * n, e(h <= t.P + t.qc), 0 != l.Z) for(e(null != gi[l.Z]), c = 0; c < o; ++c)gi[l.Z](g, m, b, h, f, d, n), g = f, m = d, d += n, h += n;
                                        else for(c = 0; c < o; ++c)r(f, d, b, h, n), g = f, m = d, d += n, h += n;
                                        t.rc = g, t.Vc = m;
                                    } else {
                                        if (e(null != l.mc), n = i + o, e(null != (c = l.mc)), e(n <= c.i), c.C >= n) n = 1;
                                        else if (l.ic || mn(), l.ic) {
                                            l = c.V, g = c.Ba, m = c.c;
                                            var y = c.i, w = (b = 1, h = c.$ / m, f = c.$ % m, d = c.m, p = c.s, c.$), N = m * y, L = m * n, A = p.wc, _ = w < L ? wt(p, f, h) : null;
                                            e(w <= N), e(n <= y), e(xt(p));
                                            e: for(;;){
                                                for(; !d.h && w < L;){
                                                    if (f & A || (_ = wt(p, f, h)), e(null != _), S(d), 256 > (y = bt(_.G[0], _.H[0], d))) l[g + w] = y, ++w, ++f >= m && (f = 0, ++h <= n && !(h % 16) && St(c, h));
                                                    else {
                                                        if (!(280 > y)) {
                                                            b = 0;
                                                            break e;
                                                        }
                                                        y = mt(y - 256, d);
                                                        var P, k = bt(_.G[4], _.H[4], d);
                                                        if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                                                            b = 0;
                                                            break e;
                                                        }
                                                        for(P = 0; P < y; ++P)l[g + w + P] = l[g + w + P - k];
                                                        for(w += y, f += y; f >= m;)f -= m, ++h <= n && !(h % 16) && St(c, h);
                                                        w < L && f & A && (_ = wt(p, f, h));
                                                    }
                                                    e(d.h == x(d));
                                                }
                                                St(c, h > n ? n : h);
                                                break e;
                                            }
                                            !b || d.h && w < N ? (b = 0, c.a = d.h ? 5 : 3) : c.$ = w, n = b;
                                        } else n = _t(c, c.V, c.Ba, c.c, c.i, n, jt);
                                        if (!n) {
                                            o = 0;
                                            break t;
                                        }
                                    }
                                    i + o >= u && (t.Cc = 1), o = 1;
                                }
                                if (!o) return null;
                                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
                            }
                            return t.nb + i * s;
                        }
                        function fn(t, e, n, r, i, a) {
                            for(; 0 < i--;){
                                var o, s = t, u = e + (n ? 1 : 0), c = t, l = e + (n ? 0 : 3);
                                for(o = 0; o < r; ++o){
                                    var h = c[l + 4 * o];
                                    255 != h && (h *= 32897, s[u + 4 * o + 0] = s[u + 4 * o + 0] * h >> 23, s[u + 4 * o + 1] = s[u + 4 * o + 1] * h >> 23, s[u + 4 * o + 2] = s[u + 4 * o + 2] * h >> 23);
                                }
                                e += a;
                            }
                        }
                        function dn(t, e, n, r, i) {
                            for(; 0 < r--;){
                                var a;
                                for(a = 0; a < n; ++a){
                                    var o = t[e + 2 * a + 0], s = 15 & (c = t[e + 2 * a + 1]), u = 4369 * s, c = (240 & c | c >> 4) * u >> 16;
                                    t[e + 2 * a + 0] = (240 & o | o >> 4) * u >> 16 & 240 | (15 & o | o << 4) * u >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & c | s;
                                }
                                e += i;
                            }
                        }
                        function pn(t, e, n, r, i, a, o, s) {
                            var u, c, l = 255;
                            for(c = 0; c < i; ++c){
                                for(u = 0; u < r; ++u){
                                    var h = t[e + u];
                                    a[o + 4 * u] = h, l &= h;
                                }
                                e += n, o += s;
                            }
                            return 255 != l;
                        }
                        function gn(t, e, n, r, i) {
                            var a;
                            for(a = 0; a < i; ++a)n[r + a] = t[e + a] >> 8;
                        }
                        function mn() {
                            Lr = fn, xr = dn, Ar = pn, Sr = gn;
                        }
                        function vn(n, r, i) {
                            t[n] = function(t, n, a, o, s, u, c, l, h, f, d, p, g, m, v, b, y) {
                                var w, N = y - 1 >> 1, L = s[u + 0] | c[l + 0] << 16, x = h[f + 0] | d[p + 0] << 16;
                                e(null != t);
                                var A = 3 * L + x + 131074 >> 2;
                                for(r(t[n + 0], 255 & A, A >> 16, g, m), null != a && (A = 3 * x + L + 131074 >> 2, r(a[o + 0], 255 & A, A >> 16, v, b)), w = 1; w <= N; ++w){
                                    var S = s[u + w] | c[l + w] << 16, _ = h[f + w] | d[p + w] << 16, P = L + S + x + _ + 524296, k = P + 2 * (S + x) >> 3;
                                    A = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, r(t[n + 2 * w - 1], 255 & A, A >> 16, g, m + (2 * w - 1) * i), r(t[n + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (A = P + x >> 1, L = k + _ >> 1, r(a[o + 2 * w - 1], 255 & A, A >> 16, v, b + (2 * w - 1) * i), r(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, x = _;
                                }
                                1 & y || (A = 3 * L + x + 131074 >> 2, r(t[n + y - 1], 255 & A, A >> 16, g, m + (y - 1) * i), null != a && (A = 3 * x + L + 131074 >> 2, r(a[o + y - 1], 255 & A, A >> 16, v, b + (y - 1) * i)));
                            };
                        }
                        function bn() {
                            mi[Mr] = vi, mi[qr] = yi, mi[Er] = bi, mi[Rr] = wi, mi[Dr] = Ni, mi[Tr] = Li, mi[zr] = xi, mi[Ur] = yi, mi[Hr] = wi, mi[Wr] = Ni, mi[Vr] = Li;
                        }
                        function yn(t) {
                            return t & ~Fi ? 0 > t ? 0 : 255 : t >> ki;
                        }
                        function wn(t, e) {
                            return yn((19077 * t >> 8) + (26149 * e >> 8) - 14234);
                        }
                        function Nn(t, e, n) {
                            return yn((19077 * t >> 8) - (6419 * e >> 8) - (13320 * n >> 8) + 8708);
                        }
                        function Ln(t, e) {
                            return yn((19077 * t >> 8) + (33050 * e >> 8) - 17685);
                        }
                        function xn(t, e, n, r, i) {
                            r[i + 0] = wn(t, n), r[i + 1] = Nn(t, e, n), r[i + 2] = Ln(t, e);
                        }
                        function An(t, e, n, r, i) {
                            r[i + 0] = Ln(t, e), r[i + 1] = Nn(t, e, n), r[i + 2] = wn(t, n);
                        }
                        function Sn(t, e, n, r, i) {
                            var a = Nn(t, e, n);
                            e = a << 3 & 224 | Ln(t, e) >> 3, r[i + 0] = 248 & wn(t, n) | a >> 5, r[i + 1] = e;
                        }
                        function _n(t, e, n, r, i) {
                            var a = 240 & Ln(t, e) | 15;
                            r[i + 0] = 240 & wn(t, n) | Nn(t, e, n) >> 4, r[i + 1] = a;
                        }
                        function Pn(t, e, n, r, i) {
                            r[i + 0] = 255, xn(t, e, n, r, i + 1);
                        }
                        function kn(t, e, n, r, i) {
                            An(t, e, n, r, i), r[i + 3] = 255;
                        }
                        function Fn(t, e, n, r, i) {
                            xn(t, e, n, r, i), r[i + 3] = 255;
                        }
                        function In(e, n, r) {
                            t[e] = function(t, e, i, a, o, s, u, c, l) {
                                for(var h = c + (-2 & l) * r; c != h;)n(t[e + 0], i[a + 0], o[s + 0], u, c), n(t[e + 1], i[a + 0], o[s + 0], u, c + r), e += 2, ++a, ++s, c += 2 * r;
                                1 & l && n(t[e + 0], i[a + 0], o[s + 0], u, c);
                            };
                        }
                        function jn(t, e, n) {
                            return 0 == n ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : n;
                        }
                        function Cn(t, e, n, r, i) {
                            switch(t >>> 30){
                                case 3:
                                    ar(e, n, r, i, 0);
                                    break;
                                case 2:
                                    or(e, n, r, i);
                                    break;
                                case 1:
                                    ur(e, n, r, i);
                            }
                        }
                        function On(t, e) {
                            var n, a, o = e.M, s = e.Nb, u = t.oc, c = t.pc + 40, l = t.oc, h = t.pc + 584, f = t.oc, d = t.pc + 600;
                            for(n = 0; 16 > n; ++n)u[c + 32 * n - 1] = 129;
                            for(n = 0; 8 > n; ++n)l[h + 32 * n - 1] = 129, f[d + 32 * n - 1] = 129;
                            for(0 < o ? u[c - 1 - 32] = l[h - 1 - 32] = f[d - 1 - 32] = 129 : (i(u, c - 32 - 1, 127, 21), i(l, h - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                                var p = e.ya[e.aa + a];
                                if (0 < a) {
                                    for(n = -1; 16 > n; ++n)r(u, c + 32 * n - 4, u, c + 32 * n + 12, 4);
                                    for(n = -1; 8 > n; ++n)r(l, h + 32 * n - 4, l, h + 32 * n + 4, 4), r(f, d + 32 * n - 4, f, d + 32 * n + 4, 4);
                                }
                                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                                if (0 < o && (r(u, c - 32, g[m].y, 0, 16), r(l, h - 32, g[m].f, 0, 8), r(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                                    var y = u, w = c - 32 + 16;
                                    for(0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : r(y, w, g[m + 1].y, 0, 4)), n = 0; 4 > n; n++)y[w + 128 + n] = y[w + 256 + n] = y[w + 384 + n] = y[w + 0 + n];
                                    for(n = 0; 16 > n; ++n, b <<= 2)y = u, w = c + Ei[n], hi[p.Ob[n]](y, w), Cn(b, v, 16 * +n, y, w);
                                } else if (y = jn(a, o, p.Ob[0]), li[y](u, c), 0 != b) for(n = 0; 16 > n; ++n, b <<= 2)Cn(b, v, 16 * +n, u, c + Ei[n]);
                                for(n = p.Gc, y = jn(a, o, p.Dd), fi[y](l, h), fi[y](f, d), b = v, y = l, w = h, 255 & (p = 0 | n) && (170 & p ? sr(b, 256, y, w) : cr(b, 256, y, w)), p = f, b = d, 255 & (n >>= 8) && (170 & n ? sr(v, 320, p, b) : cr(v, 320, p, b)), o < t.Ub - 1 && (r(g[m].y, 0, u, c + 480, 16), r(g[m].f, 0, l, h + 224, 8), r(g[m].ea, 0, f, d + 224, 8)), n = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + n, b = t.Ha, y = t.Ia + 8 * a + n, n = 0; 16 > n; ++n)r(g, m + n * t.R, u, c + 32 * n, 16);
                                for(n = 0; 8 > n; ++n)r(v, p + n * t.B, l, h + 32 * n, 8), r(b, y + n * t.B, f, d + 32 * n, 8);
                            }
                        }
                        function Bn(t, r, i, a, o, s, u, c, l) {
                            var h = [
                                0
                            ], f = [
                                0
                            ], d = 0, p = null != l ? l.kd : 0, g = null != l ? l : new nn;
                            if (null == t || 12 > i) return 7;
                            g.data = t, g.w = r, g.ha = i, r = [
                                r
                            ], i = [
                                i
                            ], g.gb = [
                                g.gb
                            ];
                            t: {
                                var m = r, b = i, y = g.gb;
                                if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !n(t, m[0], "RIFF")) {
                                    if (n(t, m[0] + 8, "WEBP")) {
                                        y = 3;
                                        break t;
                                    }
                                    var w = C(t, m[0] + 4);
                                    if (12 > w || 4294967286 < w) {
                                        y = 3;
                                        break t;
                                    }
                                    if (p && w > b[0] - 8) {
                                        y = 7;
                                        break t;
                                    }
                                    y[0] = w, m[0] += 12, b[0] -= 12;
                                }
                                y = 0;
                            }
                            if (0 != y) return y;
                            for(w = 0 < g.gb[0], i = i[0];;){
                                t: {
                                    var L = t;
                                    b = r, y = i;
                                    var x = h, A = f, S = m = [
                                        0
                                    ];
                                    if ((k = d = [
                                        d
                                    ])[0] = 0, 8 > y[0]) y = 7;
                                    else {
                                        if (!n(L, b[0], "VP8X")) {
                                            if (10 != C(L, b[0] + 4)) {
                                                y = 3;
                                                break t;
                                            }
                                            if (18 > y[0]) {
                                                y = 7;
                                                break t;
                                            }
                                            var _ = C(L, b[0] + 8), P = 1 + j(L, b[0] + 12);
                                            if (2147483648 <= P * (L = 1 + j(L, b[0] + 15))) {
                                                y = 3;
                                                break t;
                                            }
                                            null != S && (S[0] = _), null != x && (x[0] = P), null != A && (A[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
                                        }
                                        y = 0;
                                    }
                                }
                                if (d = d[0], m = m[0], 0 != y) return y;
                                if (b = !!(2 & m), !w && d) return 3;
                                if (null != s && (s[0] = !!(16 & m)), null != u && (u[0] = b), null != c && (c[0] = 0), u = h[0], m = f[0], d && b && null == l) {
                                    y = 0;
                                    break;
                                }
                                if (4 > i) {
                                    y = 7;
                                    break;
                                }
                                if (w && d || !w && !d && !n(t, r[0], "ALPH")) {
                                    i = [
                                        i
                                    ], g.na = [
                                        g.na
                                    ], g.P = [
                                        g.P
                                    ], g.Sa = [
                                        g.Sa
                                    ];
                                    t: {
                                        _ = t, y = r, w = i;
                                        var k = g.gb;
                                        x = g.na, A = g.P, S = g.Sa, P = 22, e(null != _), e(null != w), L = y[0];
                                        var F = w[0];
                                        for(e(null != x), e(null != S), x[0] = null, A[0] = null, S[0] = 0;;){
                                            if (y[0] = L, w[0] = F, 8 > F) {
                                                y = 7;
                                                break t;
                                            }
                                            var I = C(_, L + 4);
                                            if (4294967286 < I) {
                                                y = 3;
                                                break t;
                                            }
                                            var O = 8 + I + 1 & -2;
                                            if (P += O, 0 < k && P > k) {
                                                y = 3;
                                                break t;
                                            }
                                            if (!n(_, L, "VP8 ") || !n(_, L, "VP8L")) {
                                                y = 0;
                                                break t;
                                            }
                                            if (F[0] < O) {
                                                y = 7;
                                                break t;
                                            }
                                            n(_, L, "ALPH") || (x[0] = _, A[0] = L + 8, S[0] = I), L += O, F -= O;
                                        }
                                    }
                                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
                                }
                                i = [
                                    i
                                ], g.Ja = [
                                    g.Ja
                                ], g.xa = [
                                    g.xa
                                ];
                                t: if (k = t, y = r, w = i, x = g.gb[0], A = g.Ja, S = g.xa, _ = y[0], L = !n(k, _, "VP8 "), P = !n(k, _, "VP8L"), e(null != k), e(null != w), e(null != A), e(null != S), 8 > w[0]) y = 7;
                                else {
                                    if (L || P) {
                                        if (k = C(k, _ + 4), 12 <= x && k > x - 12) {
                                            y = 3;
                                            break t;
                                        }
                                        if (p && k > w[0] - 8) {
                                            y = 7;
                                            break t;
                                        }
                                        A[0] = k, y[0] += 8, w[0] -= 8, S[0] = P;
                                    } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), A[0] = w[0];
                                    y = 0;
                                }
                                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], r = r[0], 0 != y) break;
                                if (4294967286 < g.Ja) return 3;
                                if (null == c || b || (c[0] = g.xa ? 2 : 1), u = [
                                    u
                                ], m = [
                                    m
                                ], g.xa) {
                                    if (5 > i) {
                                        y = 7;
                                        break;
                                    }
                                    c = u, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[r + 0] && !(t[r + 4] >> 5) ? (w = [
                                        0
                                    ], k = [
                                        0
                                    ], x = [
                                        0
                                    ], v(A = new N, t, r, i), gt(A, w, k, x) ? (null != c && (c[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = x[0]), t = 1) : t = 0) : t = 0;
                                } else {
                                    if (10 > i) {
                                        y = 7;
                                        break;
                                    }
                                    c = m, null == t || 10 > i || !Xt(t, r + 3, i - 3) ? t = 0 : (p = t[r + 0] | t[r + 1] << 8 | t[r + 2] << 16, b = 16383 & (t[r + 7] << 8 | t[r + 6]), t = 16383 & (t[r + 9] << 8 | t[r + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (u && (u[0] = b), c && (c[0] = t), t = 1));
                                }
                                if (!t) return 3;
                                if (u = u[0], m = m[0], d && (h[0] != u || f[0] != m)) return 3;
                                null != l && (l[0] = g, l.offset = r - l.w, e(4294967286 > r - l.w), e(l.offset == l.ha - i));
                                break;
                            }
                            return 0 == y || 7 == y && d && null == l ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = u), null != o && (o[0] = m), 0) : y;
                        }
                        function Mn(t, e, n) {
                            var r = e.width, i = e.height, a = 0, o = 0, s = r, u = i;
                            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, u = t.bd, a = t.v, o = t.j, 11 > n || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= u || a + s > r || o + u > i)) return 0;
                            if (e.v = a, e.j = o, e.va = a + s, e.o = o + u, e.U = s, e.T = u, e.da = null != t && 0 < t.da, e.da) {
                                if (!q(s, u, n = [
                                    t.ib
                                ], a = [
                                    t.hb
                                ])) return 0;
                                e.ib = n[0], e.hb = a[0];
                            }
                            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * r / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
                        }
                        function qn(t) {
                            if (null == t) return 2;
                            if (11 > t.S) {
                                var e = t.f.RGBA;
                                e.fb += (t.height - 1) * e.A, e.A = -e.A;
                            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
                            return 0;
                        }
                        function En(t, e, n, r) {
                            if (null == r || 0 >= t || 0 >= e) return 2;
                            if (null != n) {
                                if (n.Da) {
                                    var i = n.cd, o = n.bd, s = -2 & n.v, u = -2 & n.j;
                                    if (0 > s || 0 > u || 0 >= i || 0 >= o || s + i > t || u + o > e) return 2;
                                    t = i, e = o;
                                }
                                if (n.da) {
                                    if (!q(t, e, i = [
                                        n.ib
                                    ], o = [
                                        n.hb
                                    ])) return 2;
                                    t = i[0], e = o[0];
                                }
                            }
                            r.width = t, r.height = e;
                            t: {
                                var c = r.width, l = r.height;
                                if (t = r.S, 0 >= c || 0 >= l || !(t >= Mr && 13 > t)) t = 2;
                                else {
                                    if (0 >= r.Rd && null == r.sd) {
                                        s = o = i = e = 0;
                                        var h = (u = c * zi[t]) * l;
                                        if (11 > t || (o = (l + 1) / 2 * (e = (c + 1) / 2), 12 == t && (s = (i = c) * l)), null == (l = a(h + 2 * o + s))) {
                                            t = 1;
                                            break t;
                                        }
                                        r.sd = l, 11 > t ? ((c = r.f.RGBA).eb = l, c.fb = 0, c.A = u, c.size = h) : ((c = r.f.kb).y = l, c.O = 0, c.fa = u, c.Fd = h, c.f = l, c.N = 0 + h, c.Ab = e, c.Cd = o, c.ea = l, c.W = 0 + h + o, c.Db = e, c.Ed = o, 12 == t && (c.F = l, c.J = 0 + h + 2 * o), c.Tc = s, c.lb = i);
                                    }
                                    if (e = 1, i = r.S, o = r.width, s = r.height, i >= Mr && 13 > i) {
                                        if (11 > i) t = r.f.RGBA, e &= (u = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= u >= o * zi[i], e &= null != t.eb;
                                        else {
                                            t = r.f.kb, u = (o + 1) / 2, h = (s + 1) / 2, c = Math.abs(t.fa), l = Math.abs(t.Ab);
                                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                                            e &= c * (s - 1) + o <= t.Fd, e &= l * (h - 1) + u <= t.Cd, e = (e &= f * (h - 1) + u <= t.Ed) & c >= o & l >= u & f >= u, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                                        }
                                    } else e = 0;
                                    t = e ? 0 : 2;
                                }
                            }
                            return 0 != t || null != n && n.fd && (t = qn(r)), t;
                        }
                        var Rn = 64, Dn = [
                            0,
                            1,
                            3,
                            7,
                            15,
                            31,
                            63,
                            127,
                            255,
                            511,
                            1023,
                            2047,
                            4095,
                            8191,
                            16383,
                            32767,
                            65535,
                            131071,
                            262143,
                            524287,
                            1048575,
                            2097151,
                            4194303,
                            8388607,
                            16777215
                        ], Tn = 24, zn = 32, Un = 8, Hn = [
                            0,
                            0,
                            1,
                            1,
                            2,
                            2,
                            2,
                            2,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7,
                            7
                        ];
                        D("Predictor0", "PredictorAdd0"), t.Predictor0 = function() {
                            return 4278190080;
                        }, t.Predictor1 = function(t) {
                            return t;
                        }, t.Predictor2 = function(t, e, n) {
                            return e[n + 0];
                        }, t.Predictor3 = function(t, e, n) {
                            return e[n + 1];
                        }, t.Predictor4 = function(t, e, n) {
                            return e[n - 1];
                        }, t.Predictor5 = function(t, e, n) {
                            return z(z(t, e[n + 1]), e[n + 0]);
                        }, t.Predictor6 = function(t, e, n) {
                            return z(t, e[n - 1]);
                        }, t.Predictor7 = function(t, e, n) {
                            return z(t, e[n + 0]);
                        }, t.Predictor8 = function(t, e, n) {
                            return z(e[n - 1], e[n + 0]);
                        }, t.Predictor9 = function(t, e, n) {
                            return z(e[n + 0], e[n + 1]);
                        }, t.Predictor10 = function(t, e, n) {
                            return z(z(t, e[n - 1]), z(e[n + 0], e[n + 1]));
                        }, t.Predictor11 = function(t, e, n) {
                            var r = e[n + 0];
                            return 0 >= W(r >> 24 & 255, t >> 24 & 255, (e = e[n - 1]) >> 24 & 255) + W(r >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(r >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & r, 255 & t, 255 & e) ? r : t;
                        }, t.Predictor12 = function(t, e, n) {
                            var r = e[n + 0];
                            return (U((t >> 24 & 255) + (r >> 24 & 255) - ((e = e[n - 1]) >> 24 & 255)) << 24 | U((t >> 16 & 255) + (r >> 16 & 255) - (e >> 16 & 255)) << 16 | U((t >> 8 & 255) + (r >> 8 & 255) - (e >> 8 & 255)) << 8 | U((255 & t) + (255 & r) - (255 & e))) >>> 0;
                        }, t.Predictor13 = function(t, e, n) {
                            var r = e[n - 1];
                            return (H((t = z(t, e[n + 0])) >> 24 & 255, r >> 24 & 255) << 24 | H(t >> 16 & 255, r >> 16 & 255) << 16 | H(t >> 8 & 255, r >> 8 & 255) << 8 | H(255 & t, 255 & r)) >>> 0;
                        };
                        var Wn = t.PredictorAdd0;
                        t.PredictorAdd1 = V, D("Predictor2", "PredictorAdd2"), D("Predictor3", "PredictorAdd3"), D("Predictor4", "PredictorAdd4"), D("Predictor5", "PredictorAdd5"), D("Predictor6", "PredictorAdd6"), D("Predictor7", "PredictorAdd7"), D("Predictor8", "PredictorAdd8"), D("Predictor9", "PredictorAdd9"), D("Predictor10", "PredictorAdd10"), D("Predictor11", "PredictorAdd11"), D("Predictor12", "PredictorAdd12"), D("Predictor13", "PredictorAdd13");
                        var Vn = t.PredictorAdd2;
                        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
                            return t >> 8 & 255;
                        }, function(t) {
                            return t;
                        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
                            return t;
                        }, function(t) {
                            return t >> 8 & 255;
                        });
                        var Gn, Yn = t.ColorIndexInverseTransform, Jn = t.MapARGB, Xn = t.VP8LColorIndexInverseTransformAlpha, Kn = t.MapAlpha, Zn = t.VP8LPredictorsAdd = [];
                        Zn.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
                        var $n, Qn, tr, er, nr, rr, ir, ar, or, sr, ur, cr, lr, hr, fr, dr, pr, gr, mr, vr, br, yr, wr, Nr, Lr, xr, Ar, Sr, _r = a(511), Pr = a(2041), kr = a(225), Fr = a(767), Ir = 0, jr = Pr, Cr = kr, Or = Fr, Br = _r, Mr = 0, qr = 1, Er = 2, Rr = 3, Dr = 4, Tr = 5, zr = 6, Ur = 7, Hr = 8, Wr = 9, Vr = 10, Gr = [
                            2,
                            3,
                            7
                        ], Yr = [
                            3,
                            3,
                            11
                        ], Jr = [
                            280,
                            256,
                            256,
                            256,
                            40
                        ], Xr = [
                            0,
                            1,
                            1,
                            1,
                            0
                        ], Kr = [
                            17,
                            18,
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            16,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14,
                            15
                        ], Zr = [
                            24,
                            7,
                            23,
                            25,
                            40,
                            6,
                            39,
                            41,
                            22,
                            26,
                            38,
                            42,
                            56,
                            5,
                            55,
                            57,
                            21,
                            27,
                            54,
                            58,
                            37,
                            43,
                            72,
                            4,
                            71,
                            73,
                            20,
                            28,
                            53,
                            59,
                            70,
                            74,
                            36,
                            44,
                            88,
                            69,
                            75,
                            52,
                            60,
                            3,
                            87,
                            89,
                            19,
                            29,
                            86,
                            90,
                            35,
                            45,
                            68,
                            76,
                            85,
                            91,
                            51,
                            61,
                            104,
                            2,
                            103,
                            105,
                            18,
                            30,
                            102,
                            106,
                            34,
                            46,
                            84,
                            92,
                            67,
                            77,
                            101,
                            107,
                            50,
                            62,
                            120,
                            1,
                            119,
                            121,
                            83,
                            93,
                            17,
                            31,
                            100,
                            108,
                            66,
                            78,
                            118,
                            122,
                            33,
                            47,
                            117,
                            123,
                            49,
                            63,
                            99,
                            109,
                            82,
                            94,
                            0,
                            116,
                            124,
                            65,
                            79,
                            16,
                            32,
                            98,
                            110,
                            48,
                            115,
                            125,
                            81,
                            95,
                            64,
                            114,
                            126,
                            97,
                            111,
                            80,
                            113,
                            127,
                            96,
                            112
                        ], $r = [
                            2954,
                            2956,
                            2958,
                            2962,
                            2970,
                            2986,
                            3018,
                            3082,
                            3212,
                            3468,
                            3980,
                            5004
                        ], Qr = 8, ti = [
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            10,
                            11,
                            12,
                            13,
                            14,
                            15,
                            16,
                            17,
                            17,
                            18,
                            19,
                            20,
                            20,
                            21,
                            21,
                            22,
                            22,
                            23,
                            23,
                            24,
                            25,
                            25,
                            26,
                            27,
                            28,
                            29,
                            30,
                            31,
                            32,
                            33,
                            34,
                            35,
                            36,
                            37,
                            37,
                            38,
                            39,
                            40,
                            41,
                            42,
                            43,
                            44,
                            45,
                            46,
                            46,
                            47,
                            48,
                            49,
                            50,
                            51,
                            52,
                            53,
                            54,
                            55,
                            56,
                            57,
                            58,
                            59,
                            60,
                            61,
                            62,
                            63,
                            64,
                            65,
                            66,
                            67,
                            68,
                            69,
                            70,
                            71,
                            72,
                            73,
                            74,
                            75,
                            76,
                            76,
                            77,
                            78,
                            79,
                            80,
                            81,
                            82,
                            83,
                            84,
                            85,
                            86,
                            87,
                            88,
                            89,
                            91,
                            93,
                            95,
                            96,
                            98,
                            100,
                            101,
                            102,
                            104,
                            106,
                            108,
                            110,
                            112,
                            114,
                            116,
                            118,
                            122,
                            124,
                            126,
                            128,
                            130,
                            132,
                            134,
                            136,
                            138,
                            140,
                            143,
                            145,
                            148,
                            151,
                            154,
                            157
                        ], ei = [
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14,
                            15,
                            16,
                            17,
                            18,
                            19,
                            20,
                            21,
                            22,
                            23,
                            24,
                            25,
                            26,
                            27,
                            28,
                            29,
                            30,
                            31,
                            32,
                            33,
                            34,
                            35,
                            36,
                            37,
                            38,
                            39,
                            40,
                            41,
                            42,
                            43,
                            44,
                            45,
                            46,
                            47,
                            48,
                            49,
                            50,
                            51,
                            52,
                            53,
                            54,
                            55,
                            56,
                            57,
                            58,
                            60,
                            62,
                            64,
                            66,
                            68,
                            70,
                            72,
                            74,
                            76,
                            78,
                            80,
                            82,
                            84,
                            86,
                            88,
                            90,
                            92,
                            94,
                            96,
                            98,
                            100,
                            102,
                            104,
                            106,
                            108,
                            110,
                            112,
                            114,
                            116,
                            119,
                            122,
                            125,
                            128,
                            131,
                            134,
                            137,
                            140,
                            143,
                            146,
                            149,
                            152,
                            155,
                            158,
                            161,
                            164,
                            167,
                            170,
                            173,
                            177,
                            181,
                            185,
                            189,
                            193,
                            197,
                            201,
                            205,
                            209,
                            213,
                            217,
                            221,
                            225,
                            229,
                            234,
                            239,
                            245,
                            249,
                            254,
                            259,
                            264,
                            269,
                            274,
                            279,
                            284
                        ], ni = null, ri = [
                            [
                                173,
                                148,
                                140,
                                0
                            ],
                            [
                                176,
                                155,
                                140,
                                135,
                                0
                            ],
                            [
                                180,
                                157,
                                141,
                                134,
                                130,
                                0
                            ],
                            [
                                254,
                                254,
                                243,
                                230,
                                196,
                                177,
                                153,
                                140,
                                133,
                                130,
                                129,
                                0
                            ]
                        ], ii = [
                            0,
                            1,
                            4,
                            8,
                            5,
                            2,
                            3,
                            6,
                            9,
                            12,
                            13,
                            10,
                            7,
                            11,
                            14,
                            15
                        ], ai = [
                            -0,
                            1,
                            -1,
                            2,
                            -2,
                            3,
                            4,
                            6,
                            -3,
                            5,
                            -4,
                            -5,
                            -6,
                            7,
                            -7,
                            8,
                            -8,
                            -9
                        ], oi = [
                            [
                                [
                                    [
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        253,
                                        136,
                                        254,
                                        255,
                                        228,
                                        219,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        189,
                                        129,
                                        242,
                                        255,
                                        227,
                                        213,
                                        255,
                                        219,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        106,
                                        126,
                                        227,
                                        252,
                                        214,
                                        209,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        98,
                                        248,
                                        255,
                                        236,
                                        226,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        181,
                                        133,
                                        238,
                                        254,
                                        221,
                                        234,
                                        255,
                                        154,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        78,
                                        134,
                                        202,
                                        247,
                                        198,
                                        180,
                                        255,
                                        219,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        185,
                                        249,
                                        255,
                                        243,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        184,
                                        150,
                                        247,
                                        255,
                                        236,
                                        224,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        77,
                                        110,
                                        216,
                                        255,
                                        236,
                                        230,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        101,
                                        251,
                                        255,
                                        241,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        170,
                                        139,
                                        241,
                                        252,
                                        236,
                                        209,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        37,
                                        116,
                                        196,
                                        243,
                                        228,
                                        255,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        204,
                                        254,
                                        255,
                                        245,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        207,
                                        160,
                                        250,
                                        255,
                                        238,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        102,
                                        103,
                                        231,
                                        255,
                                        211,
                                        171,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        152,
                                        252,
                                        255,
                                        240,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        177,
                                        135,
                                        243,
                                        255,
                                        234,
                                        225,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        80,
                                        129,
                                        211,
                                        255,
                                        194,
                                        224,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        1,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        246,
                                        1,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ]
                            ],
                            [
                                [
                                    [
                                        198,
                                        35,
                                        237,
                                        223,
                                        193,
                                        187,
                                        162,
                                        160,
                                        145,
                                        155,
                                        62
                                    ],
                                    [
                                        131,
                                        45,
                                        198,
                                        221,
                                        172,
                                        176,
                                        220,
                                        157,
                                        252,
                                        221,
                                        1
                                    ],
                                    [
                                        68,
                                        47,
                                        146,
                                        208,
                                        149,
                                        167,
                                        221,
                                        162,
                                        255,
                                        223,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        149,
                                        241,
                                        255,
                                        221,
                                        224,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        184,
                                        141,
                                        234,
                                        253,
                                        222,
                                        220,
                                        255,
                                        199,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        81,
                                        99,
                                        181,
                                        242,
                                        176,
                                        190,
                                        249,
                                        202,
                                        255,
                                        255,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        129,
                                        232,
                                        253,
                                        214,
                                        197,
                                        242,
                                        196,
                                        255,
                                        255,
                                        128
                                    ],
                                    [
                                        99,
                                        121,
                                        210,
                                        250,
                                        201,
                                        198,
                                        255,
                                        202,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        23,
                                        91,
                                        163,
                                        242,
                                        170,
                                        187,
                                        247,
                                        210,
                                        255,
                                        255,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        200,
                                        246,
                                        255,
                                        234,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        109,
                                        178,
                                        241,
                                        255,
                                        231,
                                        245,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        44,
                                        130,
                                        201,
                                        253,
                                        205,
                                        192,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        132,
                                        239,
                                        251,
                                        219,
                                        209,
                                        255,
                                        165,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        94,
                                        136,
                                        225,
                                        251,
                                        218,
                                        190,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        22,
                                        100,
                                        174,
                                        245,
                                        186,
                                        161,
                                        255,
                                        199,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        182,
                                        249,
                                        255,
                                        232,
                                        235,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        124,
                                        143,
                                        241,
                                        255,
                                        227,
                                        234,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        35,
                                        77,
                                        181,
                                        251,
                                        193,
                                        211,
                                        255,
                                        205,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        157,
                                        247,
                                        255,
                                        236,
                                        231,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        121,
                                        141,
                                        235,
                                        255,
                                        225,
                                        227,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        45,
                                        99,
                                        188,
                                        251,
                                        195,
                                        217,
                                        255,
                                        224,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        1,
                                        251,
                                        255,
                                        213,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        203,
                                        1,
                                        248,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        137,
                                        1,
                                        177,
                                        255,
                                        224,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ]
                            ],
                            [
                                [
                                    [
                                        253,
                                        9,
                                        248,
                                        251,
                                        207,
                                        208,
                                        255,
                                        192,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        175,
                                        13,
                                        224,
                                        243,
                                        193,
                                        185,
                                        249,
                                        198,
                                        255,
                                        255,
                                        128
                                    ],
                                    [
                                        73,
                                        17,
                                        171,
                                        221,
                                        161,
                                        179,
                                        236,
                                        167,
                                        255,
                                        234,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        95,
                                        247,
                                        253,
                                        212,
                                        183,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        239,
                                        90,
                                        244,
                                        250,
                                        211,
                                        209,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        155,
                                        77,
                                        195,
                                        248,
                                        188,
                                        195,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        24,
                                        239,
                                        251,
                                        218,
                                        219,
                                        255,
                                        205,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        201,
                                        51,
                                        219,
                                        255,
                                        196,
                                        186,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        69,
                                        46,
                                        190,
                                        239,
                                        201,
                                        218,
                                        255,
                                        228,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        191,
                                        251,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        223,
                                        165,
                                        249,
                                        255,
                                        213,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        141,
                                        124,
                                        248,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        16,
                                        248,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        190,
                                        36,
                                        230,
                                        255,
                                        236,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        149,
                                        1,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        226,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        247,
                                        192,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        240,
                                        128,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        134,
                                        252,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        213,
                                        62,
                                        250,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        55,
                                        93,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ]
                            ],
                            [
                                [
                                    [
                                        202,
                                        24,
                                        213,
                                        235,
                                        186,
                                        191,
                                        220,
                                        160,
                                        240,
                                        175,
                                        255
                                    ],
                                    [
                                        126,
                                        38,
                                        182,
                                        232,
                                        169,
                                        184,
                                        228,
                                        174,
                                        255,
                                        187,
                                        128
                                    ],
                                    [
                                        61,
                                        46,
                                        138,
                                        219,
                                        151,
                                        178,
                                        240,
                                        170,
                                        255,
                                        216,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        112,
                                        230,
                                        250,
                                        199,
                                        191,
                                        247,
                                        159,
                                        255,
                                        255,
                                        128
                                    ],
                                    [
                                        166,
                                        109,
                                        228,
                                        252,
                                        211,
                                        215,
                                        255,
                                        174,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        39,
                                        77,
                                        162,
                                        232,
                                        172,
                                        180,
                                        245,
                                        178,
                                        255,
                                        255,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        52,
                                        220,
                                        246,
                                        198,
                                        199,
                                        249,
                                        220,
                                        255,
                                        255,
                                        128
                                    ],
                                    [
                                        124,
                                        74,
                                        191,
                                        243,
                                        183,
                                        193,
                                        250,
                                        221,
                                        255,
                                        255,
                                        128
                                    ],
                                    [
                                        24,
                                        71,
                                        130,
                                        219,
                                        154,
                                        170,
                                        243,
                                        182,
                                        255,
                                        255,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        182,
                                        225,
                                        249,
                                        219,
                                        240,
                                        255,
                                        224,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        149,
                                        150,
                                        226,
                                        252,
                                        216,
                                        205,
                                        255,
                                        171,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        28,
                                        108,
                                        170,
                                        242,
                                        183,
                                        194,
                                        254,
                                        223,
                                        255,
                                        255,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        81,
                                        230,
                                        252,
                                        204,
                                        203,
                                        255,
                                        192,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        123,
                                        102,
                                        209,
                                        247,
                                        188,
                                        196,
                                        255,
                                        233,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        20,
                                        95,
                                        153,
                                        243,
                                        164,
                                        173,
                                        255,
                                        203,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        222,
                                        248,
                                        255,
                                        216,
                                        213,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        168,
                                        175,
                                        246,
                                        252,
                                        235,
                                        205,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        47,
                                        116,
                                        215,
                                        255,
                                        211,
                                        212,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        121,
                                        236,
                                        253,
                                        212,
                                        214,
                                        255,
                                        255,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        141,
                                        84,
                                        213,
                                        252,
                                        201,
                                        202,
                                        255,
                                        219,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        42,
                                        80,
                                        160,
                                        240,
                                        162,
                                        185,
                                        255,
                                        205,
                                        128,
                                        128,
                                        128
                                    ]
                                ],
                                [
                                    [
                                        1,
                                        1,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        244,
                                        1,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ],
                                    [
                                        238,
                                        1,
                                        255,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128,
                                        128
                                    ]
                                ]
                            ]
                        ], si = [
                            [
                                [
                                    231,
                                    120,
                                    48,
                                    89,
                                    115,
                                    113,
                                    120,
                                    152,
                                    112
                                ],
                                [
                                    152,
                                    179,
                                    64,
                                    126,
                                    170,
                                    118,
                                    46,
                                    70,
                                    95
                                ],
                                [
                                    175,
                                    69,
                                    143,
                                    80,
                                    85,
                                    82,
                                    72,
                                    155,
                                    103
                                ],
                                [
                                    56,
                                    58,
                                    10,
                                    171,
                                    218,
                                    189,
                                    17,
                                    13,
                                    152
                                ],
                                [
                                    114,
                                    26,
                                    17,
                                    163,
                                    44,
                                    195,
                                    21,
                                    10,
                                    173
                                ],
                                [
                                    121,
                                    24,
                                    80,
                                    195,
                                    26,
                                    62,
                                    44,
                                    64,
                                    85
                                ],
                                [
                                    144,
                                    71,
                                    10,
                                    38,
                                    171,
                                    213,
                                    144,
                                    34,
                                    26
                                ],
                                [
                                    170,
                                    46,
                                    55,
                                    19,
                                    136,
                                    160,
                                    33,
                                    206,
                                    71
                                ],
                                [
                                    63,
                                    20,
                                    8,
                                    114,
                                    114,
                                    208,
                                    12,
                                    9,
                                    226
                                ],
                                [
                                    81,
                                    40,
                                    11,
                                    96,
                                    182,
                                    84,
                                    29,
                                    16,
                                    36
                                ]
                            ],
                            [
                                [
                                    134,
                                    183,
                                    89,
                                    137,
                                    98,
                                    101,
                                    106,
                                    165,
                                    148
                                ],
                                [
                                    72,
                                    187,
                                    100,
                                    130,
                                    157,
                                    111,
                                    32,
                                    75,
                                    80
                                ],
                                [
                                    66,
                                    102,
                                    167,
                                    99,
                                    74,
                                    62,
                                    40,
                                    234,
                                    128
                                ],
                                [
                                    41,
                                    53,
                                    9,
                                    178,
                                    241,
                                    141,
                                    26,
                                    8,
                                    107
                                ],
                                [
                                    74,
                                    43,
                                    26,
                                    146,
                                    73,
                                    166,
                                    49,
                                    23,
                                    157
                                ],
                                [
                                    65,
                                    38,
                                    105,
                                    160,
                                    51,
                                    52,
                                    31,
                                    115,
                                    128
                                ],
                                [
                                    104,
                                    79,
                                    12,
                                    27,
                                    217,
                                    255,
                                    87,
                                    17,
                                    7
                                ],
                                [
                                    87,
                                    68,
                                    71,
                                    44,
                                    114,
                                    51,
                                    15,
                                    186,
                                    23
                                ],
                                [
                                    47,
                                    41,
                                    14,
                                    110,
                                    182,
                                    183,
                                    21,
                                    17,
                                    194
                                ],
                                [
                                    66,
                                    45,
                                    25,
                                    102,
                                    197,
                                    189,
                                    23,
                                    18,
                                    22
                                ]
                            ],
                            [
                                [
                                    88,
                                    88,
                                    147,
                                    150,
                                    42,
                                    46,
                                    45,
                                    196,
                                    205
                                ],
                                [
                                    43,
                                    97,
                                    183,
                                    117,
                                    85,
                                    38,
                                    35,
                                    179,
                                    61
                                ],
                                [
                                    39,
                                    53,
                                    200,
                                    87,
                                    26,
                                    21,
                                    43,
                                    232,
                                    171
                                ],
                                [
                                    56,
                                    34,
                                    51,
                                    104,
                                    114,
                                    102,
                                    29,
                                    93,
                                    77
                                ],
                                [
                                    39,
                                    28,
                                    85,
                                    171,
                                    58,
                                    165,
                                    90,
                                    98,
                                    64
                                ],
                                [
                                    34,
                                    22,
                                    116,
                                    206,
                                    23,
                                    34,
                                    43,
                                    166,
                                    73
                                ],
                                [
                                    107,
                                    54,
                                    32,
                                    26,
                                    51,
                                    1,
                                    81,
                                    43,
                                    31
                                ],
                                [
                                    68,
                                    25,
                                    106,
                                    22,
                                    64,
                                    171,
                                    36,
                                    225,
                                    114
                                ],
                                [
                                    34,
                                    19,
                                    21,
                                    102,
                                    132,
                                    188,
                                    16,
                                    76,
                                    124
                                ],
                                [
                                    62,
                                    18,
                                    78,
                                    95,
                                    85,
                                    57,
                                    50,
                                    48,
                                    51
                                ]
                            ],
                            [
                                [
                                    193,
                                    101,
                                    35,
                                    159,
                                    215,
                                    111,
                                    89,
                                    46,
                                    111
                                ],
                                [
                                    60,
                                    148,
                                    31,
                                    172,
                                    219,
                                    228,
                                    21,
                                    18,
                                    111
                                ],
                                [
                                    112,
                                    113,
                                    77,
                                    85,
                                    179,
                                    255,
                                    38,
                                    120,
                                    114
                                ],
                                [
                                    40,
                                    42,
                                    1,
                                    196,
                                    245,
                                    209,
                                    10,
                                    25,
                                    109
                                ],
                                [
                                    88,
                                    43,
                                    29,
                                    140,
                                    166,
                                    213,
                                    37,
                                    43,
                                    154
                                ],
                                [
                                    61,
                                    63,
                                    30,
                                    155,
                                    67,
                                    45,
                                    68,
                                    1,
                                    209
                                ],
                                [
                                    100,
                                    80,
                                    8,
                                    43,
                                    154,
                                    1,
                                    51,
                                    26,
                                    71
                                ],
                                [
                                    142,
                                    78,
                                    78,
                                    16,
                                    255,
                                    128,
                                    34,
                                    197,
                                    171
                                ],
                                [
                                    41,
                                    40,
                                    5,
                                    102,
                                    211,
                                    183,
                                    4,
                                    1,
                                    221
                                ],
                                [
                                    51,
                                    50,
                                    17,
                                    168,
                                    209,
                                    192,
                                    23,
                                    25,
                                    82
                                ]
                            ],
                            [
                                [
                                    138,
                                    31,
                                    36,
                                    171,
                                    27,
                                    166,
                                    38,
                                    44,
                                    229
                                ],
                                [
                                    67,
                                    87,
                                    58,
                                    169,
                                    82,
                                    115,
                                    26,
                                    59,
                                    179
                                ],
                                [
                                    63,
                                    59,
                                    90,
                                    180,
                                    59,
                                    166,
                                    93,
                                    73,
                                    154
                                ],
                                [
                                    40,
                                    40,
                                    21,
                                    116,
                                    143,
                                    209,
                                    34,
                                    39,
                                    175
                                ],
                                [
                                    47,
                                    15,
                                    16,
                                    183,
                                    34,
                                    223,
                                    49,
                                    45,
                                    183
                                ],
                                [
                                    46,
                                    17,
                                    33,
                                    183,
                                    6,
                                    98,
                                    15,
                                    32,
                                    183
                                ],
                                [
                                    57,
                                    46,
                                    22,
                                    24,
                                    128,
                                    1,
                                    54,
                                    17,
                                    37
                                ],
                                [
                                    65,
                                    32,
                                    73,
                                    115,
                                    28,
                                    128,
                                    23,
                                    128,
                                    205
                                ],
                                [
                                    40,
                                    3,
                                    9,
                                    115,
                                    51,
                                    192,
                                    18,
                                    6,
                                    223
                                ],
                                [
                                    87,
                                    37,
                                    9,
                                    115,
                                    59,
                                    77,
                                    64,
                                    21,
                                    47
                                ]
                            ],
                            [
                                [
                                    104,
                                    55,
                                    44,
                                    218,
                                    9,
                                    54,
                                    53,
                                    130,
                                    226
                                ],
                                [
                                    64,
                                    90,
                                    70,
                                    205,
                                    40,
                                    41,
                                    23,
                                    26,
                                    57
                                ],
                                [
                                    54,
                                    57,
                                    112,
                                    184,
                                    5,
                                    41,
                                    38,
                                    166,
                                    213
                                ],
                                [
                                    30,
                                    34,
                                    26,
                                    133,
                                    152,
                                    116,
                                    10,
                                    32,
                                    134
                                ],
                                [
                                    39,
                                    19,
                                    53,
                                    221,
                                    26,
                                    114,
                                    32,
                                    73,
                                    255
                                ],
                                [
                                    31,
                                    9,
                                    65,
                                    234,
                                    2,
                                    15,
                                    1,
                                    118,
                                    73
                                ],
                                [
                                    75,
                                    32,
                                    12,
                                    51,
                                    192,
                                    255,
                                    160,
                                    43,
                                    51
                                ],
                                [
                                    88,
                                    31,
                                    35,
                                    67,
                                    102,
                                    85,
                                    55,
                                    186,
                                    85
                                ],
                                [
                                    56,
                                    21,
                                    23,
                                    111,
                                    59,
                                    205,
                                    45,
                                    37,
                                    192
                                ],
                                [
                                    55,
                                    38,
                                    70,
                                    124,
                                    73,
                                    102,
                                    1,
                                    34,
                                    98
                                ]
                            ],
                            [
                                [
                                    125,
                                    98,
                                    42,
                                    88,
                                    104,
                                    85,
                                    117,
                                    175,
                                    82
                                ],
                                [
                                    95,
                                    84,
                                    53,
                                    89,
                                    128,
                                    100,
                                    113,
                                    101,
                                    45
                                ],
                                [
                                    75,
                                    79,
                                    123,
                                    47,
                                    51,
                                    128,
                                    81,
                                    171,
                                    1
                                ],
                                [
                                    57,
                                    17,
                                    5,
                                    71,
                                    102,
                                    57,
                                    53,
                                    41,
                                    49
                                ],
                                [
                                    38,
                                    33,
                                    13,
                                    121,
                                    57,
                                    73,
                                    26,
                                    1,
                                    85
                                ],
                                [
                                    41,
                                    10,
                                    67,
                                    138,
                                    77,
                                    110,
                                    90,
                                    47,
                                    114
                                ],
                                [
                                    115,
                                    21,
                                    2,
                                    10,
                                    102,
                                    255,
                                    166,
                                    23,
                                    6
                                ],
                                [
                                    101,
                                    29,
                                    16,
                                    10,
                                    85,
                                    128,
                                    101,
                                    196,
                                    26
                                ],
                                [
                                    57,
                                    18,
                                    10,
                                    102,
                                    102,
                                    213,
                                    34,
                                    20,
                                    43
                                ],
                                [
                                    117,
                                    20,
                                    15,
                                    36,
                                    163,
                                    128,
                                    68,
                                    1,
                                    26
                                ]
                            ],
                            [
                                [
                                    102,
                                    61,
                                    71,
                                    37,
                                    34,
                                    53,
                                    31,
                                    243,
                                    192
                                ],
                                [
                                    69,
                                    60,
                                    71,
                                    38,
                                    73,
                                    119,
                                    28,
                                    222,
                                    37
                                ],
                                [
                                    68,
                                    45,
                                    128,
                                    34,
                                    1,
                                    47,
                                    11,
                                    245,
                                    171
                                ],
                                [
                                    62,
                                    17,
                                    19,
                                    70,
                                    146,
                                    85,
                                    55,
                                    62,
                                    70
                                ],
                                [
                                    37,
                                    43,
                                    37,
                                    154,
                                    100,
                                    163,
                                    85,
                                    160,
                                    1
                                ],
                                [
                                    63,
                                    9,
                                    92,
                                    136,
                                    28,
                                    64,
                                    32,
                                    201,
                                    85
                                ],
                                [
                                    75,
                                    15,
                                    9,
                                    9,
                                    64,
                                    255,
                                    184,
                                    119,
                                    16
                                ],
                                [
                                    86,
                                    6,
                                    28,
                                    5,
                                    64,
                                    255,
                                    25,
                                    248,
                                    1
                                ],
                                [
                                    56,
                                    8,
                                    17,
                                    132,
                                    137,
                                    255,
                                    55,
                                    116,
                                    128
                                ],
                                [
                                    58,
                                    15,
                                    20,
                                    82,
                                    135,
                                    57,
                                    26,
                                    121,
                                    40
                                ]
                            ],
                            [
                                [
                                    164,
                                    50,
                                    31,
                                    137,
                                    154,
                                    133,
                                    25,
                                    35,
                                    218
                                ],
                                [
                                    51,
                                    103,
                                    44,
                                    131,
                                    131,
                                    123,
                                    31,
                                    6,
                                    158
                                ],
                                [
                                    86,
                                    40,
                                    64,
                                    135,
                                    148,
                                    224,
                                    45,
                                    183,
                                    128
                                ],
                                [
                                    22,
                                    26,
                                    17,
                                    131,
                                    240,
                                    154,
                                    14,
                                    1,
                                    209
                                ],
                                [
                                    45,
                                    16,
                                    21,
                                    91,
                                    64,
                                    222,
                                    7,
                                    1,
                                    197
                                ],
                                [
                                    56,
                                    21,
                                    39,
                                    155,
                                    60,
                                    138,
                                    23,
                                    102,
                                    213
                                ],
                                [
                                    83,
                                    12,
                                    13,
                                    54,
                                    192,
                                    255,
                                    68,
                                    47,
                                    28
                                ],
                                [
                                    85,
                                    26,
                                    85,
                                    85,
                                    128,
                                    128,
                                    32,
                                    146,
                                    171
                                ],
                                [
                                    18,
                                    11,
                                    7,
                                    63,
                                    144,
                                    171,
                                    4,
                                    4,
                                    246
                                ],
                                [
                                    35,
                                    27,
                                    10,
                                    146,
                                    174,
                                    171,
                                    12,
                                    26,
                                    128
                                ]
                            ],
                            [
                                [
                                    190,
                                    80,
                                    35,
                                    99,
                                    180,
                                    80,
                                    126,
                                    54,
                                    45
                                ],
                                [
                                    85,
                                    126,
                                    47,
                                    87,
                                    176,
                                    51,
                                    41,
                                    20,
                                    32
                                ],
                                [
                                    101,
                                    75,
                                    128,
                                    139,
                                    118,
                                    146,
                                    116,
                                    128,
                                    85
                                ],
                                [
                                    56,
                                    41,
                                    15,
                                    176,
                                    236,
                                    85,
                                    37,
                                    9,
                                    62
                                ],
                                [
                                    71,
                                    30,
                                    17,
                                    119,
                                    118,
                                    255,
                                    17,
                                    18,
                                    138
                                ],
                                [
                                    101,
                                    38,
                                    60,
                                    138,
                                    55,
                                    70,
                                    43,
                                    26,
                                    142
                                ],
                                [
                                    146,
                                    36,
                                    19,
                                    30,
                                    171,
                                    255,
                                    97,
                                    27,
                                    20
                                ],
                                [
                                    138,
                                    45,
                                    61,
                                    62,
                                    219,
                                    1,
                                    81,
                                    188,
                                    64
                                ],
                                [
                                    32,
                                    41,
                                    20,
                                    117,
                                    151,
                                    142,
                                    20,
                                    21,
                                    163
                                ],
                                [
                                    112,
                                    19,
                                    12,
                                    61,
                                    195,
                                    128,
                                    48,
                                    4,
                                    24
                                ]
                            ]
                        ], ui = [
                            [
                                [
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        176,
                                        246,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        223,
                                        241,
                                        252,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        249,
                                        253,
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        244,
                                        252,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        234,
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        246,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        239,
                                        253,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        254,
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        248,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        251,
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        253,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        251,
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        254,
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        254,
                                        253,
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        250,
                                        255,
                                        254,
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ]
                            ],
                            [
                                [
                                    [
                                        217,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        225,
                                        252,
                                        241,
                                        253,
                                        255,
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        234,
                                        250,
                                        241,
                                        250,
                                        253,
                                        255,
                                        253,
                                        254,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        223,
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        238,
                                        253,
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        248,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        249,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        247,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        253,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        252,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        254,
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        250,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ]
                            ],
                            [
                                [
                                    [
                                        186,
                                        251,
                                        250,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        234,
                                        251,
                                        244,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        251,
                                        251,
                                        243,
                                        253,
                                        254,
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        253,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        236,
                                        253,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        251,
                                        253,
                                        253,
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        254,
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ]
                            ],
                            [
                                [
                                    [
                                        248,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        250,
                                        254,
                                        252,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        248,
                                        254,
                                        249,
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        253,
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        246,
                                        253,
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        252,
                                        254,
                                        251,
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        254,
                                        252,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        248,
                                        254,
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        253,
                                        255,
                                        254,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        251,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        245,
                                        251,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        253,
                                        253,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        251,
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        252,
                                        253,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        252,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        249,
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        255,
                                        253,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        250,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ],
                                [
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        254,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    [
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                ]
                            ]
                        ], ci = [
                            0,
                            1,
                            2,
                            3,
                            6,
                            4,
                            5,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            6,
                            7,
                            0
                        ], li = [], hi = [], fi = [], di = 1, pi = 2, gi = [], mi = [];
                        vn("UpsampleRgbLinePair", xn, 3), vn("UpsampleBgrLinePair", An, 3), vn("UpsampleRgbaLinePair", Fn, 4), vn("UpsampleBgraLinePair", kn, 4), vn("UpsampleArgbLinePair", Pn, 4), vn("UpsampleRgba4444LinePair", _n, 2), vn("UpsampleRgb565LinePair", Sn, 2);
                        var vi = t.UpsampleRgbLinePair, bi = t.UpsampleBgrLinePair, yi = t.UpsampleRgbaLinePair, wi = t.UpsampleBgraLinePair, Ni = t.UpsampleArgbLinePair, Li = t.UpsampleRgba4444LinePair, xi = t.UpsampleRgb565LinePair, Ai = 16, Si = 1 << Ai - 1, _i = -227, Pi = 482, ki = 6, Fi = (256 << ki) - 1, Ii = 0, ji = a(256), Ci = a(256), Oi = a(256), Bi = a(256), Mi = a(Pi - _i), qi = a(Pi - _i);
                        In("YuvToRgbRow", xn, 3), In("YuvToBgrRow", An, 3), In("YuvToRgbaRow", Fn, 4), In("YuvToBgraRow", kn, 4), In("YuvToArgbRow", Pn, 4), In("YuvToRgba4444Row", _n, 2), In("YuvToRgb565Row", Sn, 2);
                        var Ei = [
                            0,
                            4,
                            8,
                            12,
                            128,
                            132,
                            136,
                            140,
                            256,
                            260,
                            264,
                            268,
                            384,
                            388,
                            392,
                            396
                        ], Ri = [
                            0,
                            2,
                            8
                        ], Di = [
                            8,
                            7,
                            6,
                            4,
                            4,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1
                        ], Ti = 1;
                        this.WebPDecodeRGBA = function(t, n, s, u, c) {
                            var l = qr, h = new en, f = new ot;
                            h.ba = f, f.S = l, f.width = [
                                f.width
                            ], f.height = [
                                f.height
                            ];
                            var d = f.width, p = f.height, g = new st;
                            if (null == g || null == t) var m = 2;
                            else e(null != g), m = Bn(t, n, s, g.width, g.height, g.Pd, g.Qd, g.format, null);
                            if (0 != m ? d = 0 : (null != d && (d[0] = g.width[0]), null != p && (p[0] = g.height[0]), d = 1), d) {
                                f.width = f.width[0], f.height = f.height[0], null != u && (u[0] = f.width), null != c && (c[0] = f.height);
                                t: {
                                    if (u = new Gt, (c = new nn).data = t, c.w = n, c.ha = s, c.kd = 1, n = [
                                        0
                                    ], e(null != c), (0 == (t = Bn(c.data, c.w, c.ha, null, null, null, n, null, c)) || 7 == t) && n[0] && (t = 4), 0 == (n = t)) {
                                        if (e(null != h), u.data = c.data, u.w = c.w + c.offset, u.ha = c.ha - c.offset, u.put = dt, u.ac = ft, u.bc = pt, u.ma = h, c.xa) {
                                            if (null == (t = kt())) {
                                                h = 1;
                                                break t;
                                            }
                                            if (function(t, n) {
                                                var r = [
                                                    0
                                                ], i = [
                                                    0
                                                ], a = [
                                                    0
                                                ];
                                                e: for(;;){
                                                    if (null == t) return 0;
                                                    if (null == n) return t.a = 2, 0;
                                                    if (t.l = n, t.a = 0, v(t.m, n.data, n.w, n.ha), !gt(t.m, r, i, a)) {
                                                        t.a = 3;
                                                        break e;
                                                    }
                                                    if (t.xb = pi, n.width = r[0], n.height = i[0], !Ft(r[0], i[0], 1, t, null)) break e;
                                                    return 1;
                                                }
                                                return e(0 != t.a), 0;
                                            }(t, u)) {
                                                if (u = 0 == (n = En(u.width, u.height, h.Oa, h.ba))) {
                                                    e: {
                                                        u = t;
                                                        n: for(;;){
                                                            if (null == u) {
                                                                u = 0;
                                                                break e;
                                                            }
                                                            if (e(null != u.s.yc), e(null != u.s.Ya), e(0 < u.s.Wb), e(null != (s = u.l)), e(null != (c = s.ma)), 0 != u.xb) {
                                                                if (u.ca = c.ba, u.tb = c.tb, e(null != u.ca), !Mn(c.Oa, s, Rr)) {
                                                                    u.a = 2;
                                                                    break n;
                                                                }
                                                                if (!It(u, s.width)) break n;
                                                                if (s.da) break n;
                                                                if ((s.da || rt(u.ca.S)) && mn(), 11 > u.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != u.ca.f.kb.F && mn()), u.Pb && 0 < u.s.ua && null == u.s.vb.X && !O(u.s.vb, u.s.Wa.Xa)) {
                                                                    u.a = 1;
                                                                    break n;
                                                                }
                                                                u.xb = 0;
                                                            }
                                                            if (!_t(u, u.V, u.Ba, u.c, u.i, s.o, Lt)) break n;
                                                            c.Dc = u.Ma, u = 1;
                                                            break e;
                                                        }
                                                        e(0 != u.a), u = 0;
                                                    }
                                                    u = !u;
                                                }
                                                u && (n = t.a);
                                            } else n = t.a;
                                        } else {
                                            t = new Yt;
                                            if (t.Fa = c.na, t.P = c.P, t.qc = c.Sa, Kt(t, u)) {
                                                if (0 == (n = En(u.width, u.height, h.Oa, h.ba))) {
                                                    if (t.Aa = 0, s = h.Oa, e(null != (c = t)), null != s) {
                                                        if (0 < (d = 0 > (d = s.Md) ? 0 : 100 < d ? 255 : 255 * d / 100)) {
                                                            for(p = g = 0; 4 > p; ++p)12 > (m = c.pb[p]).lc && (m.ia = d * Di[0 > m.lc ? 0 : m.lc] >> 3), g |= m.ia;
                                                            g && (alert("todo:VP8InitRandom"), c.ia = 1);
                                                        }
                                                        c.Ga = s.Id, 100 < c.Ga ? c.Ga = 100 : 0 > c.Ga && (c.Ga = 0);
                                                    }
                                                    (function(t, n) {
                                                        if (null == t) return 0;
                                                        if (null == n) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
                                                        if (!t.cb && !Kt(t, n)) return 0;
                                                        if (e(t.cb), null == n.ac || n.ac(n)) {
                                                            n.ob && (t.L = 0);
                                                            var s = Ri[t.L];
                                                            if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = n.v - s >> 4, t.zb = n.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = n.o + 15 + s >> 4, t.Hb = n.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                                                                var u = t.ed;
                                                                for(s = 0; 4 > s; ++s){
                                                                    var c;
                                                                    if (t.Qa.Cb) {
                                                                        var l = t.Qa.Lb[s];
                                                                        t.Qa.Fb || (l += u.Tb);
                                                                    } else l = u.Tb;
                                                                    for(c = 0; 1 >= c; ++c){
                                                                        var h = t.gd[s][c], f = l;
                                                                        if (u.Pc && (f += u.vd[0], c && (f += u.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                                                            var d = f;
                                                                            0 < u.wb && (d = 4 < u.wb ? d >> 2 : d >> 1) > 9 - u.wb && (d = 9 - u.wb), 1 > d && (d = 1), h.dd = d, h.tc = 2 * f + d, h.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                                                                        } else h.tc = 0;
                                                                        h.La = c;
                                                                    }
                                                                }
                                                            }
                                                            s = 0;
                                                        } else Jt(t, 6, "Frame setup failed"), s = t.a;
                                                        if (s = 0 == s) {
                                                            if (s) {
                                                                t.$c = 0, 0 < t.Aa || (t.Ic = Ti);
                                                                e: {
                                                                    s = t.Ic, u = 4 * (d = t.za);
                                                                    var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                                                                    if ((h = u + 832 + (c = 3 * (16 * s + Ri[t.L]) / 2 * p) + (l = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != h) s = 0;
                                                                    else {
                                                                        if (h > t.Vb) {
                                                                            if (t.Vb = 0, t.Ec = a(h), t.Fc = 0, null == t.Ec) {
                                                                                s = Jt(t, 1, "no memory during frame initialization.");
                                                                                break e;
                                                                            }
                                                                            t.Vb = h;
                                                                        }
                                                                        h = t.Ec, f = t.Fc, t.Ac = h, t.Bc = f, f += u, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Dt), t.sb = 1, t.wa = m ? o(m, Rt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = h, t.pc = f, f += 832, t.ya = o(v, zt), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = h, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += c, t.mb = l ? h : null, t.nb = l ? f : null, e(f + l <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, u), s = 1;
                                                                    }
                                                                }
                                                                if (s) {
                                                                    if (n.ka = 0, n.y = t.sa, n.O = t.ta, n.f = t.qa, n.N = t.ra, n.ea = t.Ha, n.Vd = t.Ia, n.fa = t.R, n.Rc = t.B, n.F = null, n.J = 0, !Ir) {
                                                                        for(s = -255; 255 >= s; ++s)_r[255 + s] = 0 > s ? -s : s;
                                                                        for(s = -1020; 1020 >= s; ++s)Pr[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                                                                        for(s = -112; 112 >= s; ++s)kr[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                                                                        for(s = -255; 510 >= s; ++s)Fr[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                                                                        Ir = 1;
                                                                    }
                                                                    ir = ue, ar = ie, sr = ae, ur = oe, cr = se, or = re, lr = Ye, hr = Je, fr = Ze, dr = $e, pr = Xe, gr = Ke, mr = Qe, vr = tn, br = ze, yr = Ue, wr = He, Nr = We, hi[0] = xe, hi[1] = le, hi[2] = Ne, hi[3] = Le, hi[4] = Ae, hi[5] = _e, hi[6] = Se, hi[7] = Pe, hi[8] = Fe, hi[9] = ke, li[0] = me, li[1] = fe, li[2] = de, li[3] = pe, li[4] = ve, li[5] = be, li[6] = ye, fi[0] = Oe, fi[1] = he, fi[2] = Ie, fi[3] = je, fi[4] = Me, fi[5] = Be, fi[6] = qe, s = 1;
                                                                } else s = 0;
                                                            }
                                                            s && (s = function(t, n) {
                                                                for(t.M = 0; t.M < t.Va; ++t.M){
                                                                    var o, s = t.Jc[t.M & t.Xb], u = t.m, c = t;
                                                                    for(o = 0; o < c.za; ++o){
                                                                        var l = u, h = c, f = h.Ac, d = h.Bc + 4 * o, p = h.zc, g = h.ya[h.aa + o];
                                                                        if (h.Qa.Bb ? g.$b = k(l, h.Pa.jb[0]) ? 2 + k(l, h.Pa.jb[2]) : k(l, h.Pa.jb[1]) : g.$b = 0, h.kc && (g.Ad = k(l, h.Bd)), g.Za = !k(l, 145) + 0, g.Za) {
                                                                            var m = g.Ob, v = 0;
                                                                            for(h = 0; 4 > h; ++h){
                                                                                var b, y = p[0 + h];
                                                                                for(b = 0; 4 > b; ++b){
                                                                                    y = si[f[d + b]][y];
                                                                                    for(var w = ai[k(l, y[0])]; 0 < w;)w = ai[2 * w + k(l, y[w])];
                                                                                    y = -w, f[d + b] = y;
                                                                                }
                                                                                r(m, v, f, d, 4), v += 4, p[0 + h] = y;
                                                                            }
                                                                        } else y = k(l, 156) ? k(l, 128) ? 1 : 3 : k(l, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                                                                        g.Dd = k(l, 142) ? k(l, 114) ? k(l, 183) ? 1 : 3 : 2 : 0;
                                                                    }
                                                                    if (c.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                                                                    for(; t.ja < t.za; ++t.ja){
                                                                        if (c = s, l = (u = t).rb[u.sb - 1], f = u.rb[u.sb + u.ja], o = u.ya[u.aa + u.ja], d = u.kc ? o.Ad : 0) l.la = f.la = 0, o.Za || (l.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                                                                        else {
                                                                            var N, L;
                                                                            if (l = f, f = c, d = u.Pa.Xc, p = u.ya[u.aa + u.ja], g = u.pb[p.$b], h = p.ad, m = 0, v = u.rb[u.sb - 1], y = b = 0, i(h, m, 0, 384), p.Za) var x = 0, A = d[3];
                                                                            else {
                                                                                w = a(16);
                                                                                var S = l.Na + v.Na;
                                                                                if (S = ni(f, d[1], S, g.Eb, 0, w, 0), l.Na = v.Na = (0 < S) + 0, 1 < S) ir(w, 0, h, m);
                                                                                else {
                                                                                    var _ = w[0] + 3 >> 3;
                                                                                    for(w = 0; 256 > w; w += 16)h[m + w] = _;
                                                                                }
                                                                                x = 1, A = d[0];
                                                                            }
                                                                            var P = 15 & l.la, F = 15 & v.la;
                                                                            for(w = 0; 4 > w; ++w){
                                                                                var I = 1 & F;
                                                                                for(_ = L = 0; 4 > _; ++_)P = P >> 1 | (I = (S = ni(f, A, S = I + (1 & P), g.Sc, x, h, m)) > x) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != h[m + 0]), m += 16;
                                                                                P >>= 4, F = F >> 1 | I << 7, b = (b << 8 | L) >>> 0;
                                                                            }
                                                                            for(A = P, x = F >> 4, N = 0; 4 > N; N += 2){
                                                                                for(L = 0, P = l.la >> 4 + N, F = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                                                                    for(I = 1 & F, _ = 0; 2 > _; ++_)S = I + (1 & P), P = P >> 1 | (I = 0 < (S = ni(f, d[2], S, g.Qc, 0, h, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != h[m + 0]), m += 16;
                                                                                    P >>= 2, F = F >> 1 | I << 5;
                                                                                }
                                                                                y |= L << 4 * N, A |= P << 4 << N, x |= (240 & F) << N;
                                                                            }
                                                                            l.la = A, v.la = x, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                                                                        }
                                                                        if (0 < u.L && (u.wa[u.Y + u.ja] = u.gd[o.$b][o.Za], u.wa[u.Y + u.ja].La |= !d), c.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                                                                    }
                                                                    if ($t(t), u = n, c = 1, o = (s = t).D, l = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) e: {
                                                                        if (o.M = s.M, o.uc = l, On(s, o), c = 1, o = (L = s.D).Nb, l = (y = Ri[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - l + w, g = s.qa, h = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, F = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && On(s, L), L.uc) for(I = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L){
                                                                            x = L, A = I;
                                                                            var j = (C = (z = S).D).Nb;
                                                                            N = z.R;
                                                                            var C = C.wa[C.Y + x], O = z.sa, B = z.ta + 16 * j * N + 16 * x, M = C.dd, q = C.tc;
                                                                            if (0 != q) {
                                                                                if (e(3 <= q), 1 == z.L) 0 < x && yr(O, B, N, q + 4), C.La && Nr(O, B, N, q), 0 < A && br(O, B, N, q + 4), C.La && wr(O, B, N, q);
                                                                                else {
                                                                                    var E = z.B, R = z.qa, D = z.ra + 8 * j * E + 8 * x, T = z.Ha, z = z.Ia + 8 * j * E + 8 * x;
                                                                                    j = C.ld, 0 < x && (hr(O, B, N, q + 4, M, j), dr(R, D, T, z, E, q + 4, M, j)), C.La && (gr(O, B, N, q, M, j), vr(R, D, T, z, E, q, M, j)), 0 < A && (lr(O, B, N, q + 4, M, j), fr(R, D, T, z, E, q + 4, M, j)), C.La && (pr(O, B, N, q, M, j), mr(R, D, T, z, E, q, M, j));
                                                                                }
                                                                            }
                                                                        }
                                                                        if (s.ia && alert("todo:DitherRow"), null != u.put) {
                                                                            if (L = 16 * P, P = 16 * (P + 1), F ? (u.y = s.sa, u.O = s.ta + w, u.f = s.qa, u.N = s.ra + _, u.ea = s.Ha, u.W = s.Ia + _) : (L -= y, u.y = d, u.O = p, u.f = g, u.N = h, u.ea = m, u.W = v), b || (P -= y), P > u.o && (P = u.o), u.F = null, u.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (u.J = hn(s, u, L, P - L), u.F = s.mb, null == u.F && 0 == u.F.length)) {
                                                                                c = Jt(s, 3, "Could not decode alpha data.");
                                                                                break e;
                                                                            }
                                                                            L < u.j && (y = u.j - L, L = u.j, e(!(1 & y)), u.O += s.R * y, u.N += s.B * (y >> 1), u.W += s.B * (y >> 1), null != u.F && (u.J += u.width * y)), L < P && (u.O += u.v, u.N += u.v >> 1, u.W += u.v >> 1, null != u.F && (u.J += u.v), u.ka = L - u.j, u.U = u.va - u.v, u.T = P - L, c = u.put(u));
                                                                        }
                                                                        o + 1 != s.Ic || b || (r(s.sa, s.ta - l, d, p + 16 * s.R, l), r(s.qa, s.ra - f, g, h + 8 * s.B, f), r(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                                                                    }
                                                                    if (!c) return Jt(t, 6, "Output aborted.");
                                                                }
                                                                return 1;
                                                            }(t, n)), null != n.bc && n.bc(n), s &= 1;
                                                        }
                                                        return s ? (t.cb = 0, s) : 0;
                                                    })(t, u) || (n = t.a);
                                                }
                                            } else n = t.a;
                                        }
                                        0 == n && null != h.Oa && h.Oa.fd && (n = qn(h.ba));
                                    }
                                    h = n;
                                }
                                l = 0 != h ? null : 11 > l ? f.f.RGBA.eb : f.f.kb.y;
                            } else l = null;
                            return l;
                        };
                        var zi = [
                            3,
                            4,
                            3,
                            4,
                            4,
                            2,
                            2,
                            4,
                            4,
                            4,
                            2,
                            1,
                            1
                        ];
                    };
                    function c(t, e) {
                        for(var n = "", r = 0; r < 4; r++)n += String.fromCharCode(t[e++]);
                        return n;
                    }
                    function l(t, e) {
                        return t[e + 0] | t[e + 1] << 8;
                    }
                    function h(t, e) {
                        return (t[e + 0] | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
                    }
                    function f(t, e) {
                        return (t[e + 0] | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
                    }
                    new u;
                    var d = [
                        0
                    ], p = [
                        0
                    ], g = [], m = new u, v = t, b = function(t, e) {
                        var n = {}, r = 0, i = !1, a = 0, o = 0;
                        if (n.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */ function(t, e) {
                            for(var n = 0; n < 4; n++)if (t[e + n] != "RIFF".charCodeAt(n)) return !0;
                            return !1;
                        }(t, e)) {
                            for(f(t, e += 4), e += 8; e < t.length;){
                                var s = c(t, e), u = f(t, e += 4);
                                e += 4;
                                var d = u + (1 & u);
                                switch(s){
                                    case "VP8 ":
                                    case "VP8L":
                                        void 0 === n.frames[r] && (n.frames[r] = {}), (m = n.frames[r]).src_off = i ? o : e - 8, m.src_size = a + u + 8, r++, i && (i = !1, a = 0, o = 0);
                                        break;
                                    case "VP8X":
                                        (m = n.header = {}).feature_flags = t[e];
                                        var p = e + 4;
                                        m.canvas_width = 1 + h(t, p), p += 3, m.canvas_height = 1 + h(t, p), p += 3;
                                        break;
                                    case "ALPH":
                                        i = !0, a = d + 8, o = e - 8;
                                        break;
                                    case "ANIM":
                                        (m = n.header).bgcolor = f(t, e), p = e + 4, m.loop_count = l(t, p), p += 2;
                                        break;
                                    case "ANMF":
                                        var g, m;
                                        (m = n.frames[r] = {}).offset_x = 2 * h(t, e), e += 3, m.offset_y = 2 * h(t, e), e += 3, m.width = 1 + h(t, e), e += 3, m.height = 1 + h(t, e), e += 3, m.duration = h(t, e), e += 3, g = t[e++], m.dispose = 1 & g, m.blend = g >> 1 & 1;
                                }
                                "ANMF" != s && (e += d);
                            }
                            return n;
                        }
                    }(v, 0);
                    b.response = v, b.rgbaoutput = !0, b.dataurl = !1;
                    var y = b.header ? b.header : null, w = b.frames ? b.frames : null;
                    if (y) {
                        y.loop_counter = y.loop_count, d = [
                            y.canvas_height
                        ], p = [
                            y.canvas_width
                        ];
                        for(var N = 0; N < w.length && 0 != w[N].blend; N++);
                    }
                    var L = w[0], x = m.WebPDecodeRGBA(v, L.src_off, L.src_size, p, d);
                    L.rgba = x, L.imgwidth = p[0], L.imgheight = d[0];
                    for(var A = 0; A < p[0] * d[0] * 4; A++)g[A] = x[A];
                    return this.width = p, this.height = d, this.data = g, this;
                }
                !function(e) {
                    var n, r, i, a, s, u, c, l, f, d = function(t) {
                        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new l, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new u, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new u, this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [
                            0,
                            0,
                            0,
                            0
                        ], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
                    };
                    e.events.push([
                        "initialized",
                        function() {
                            this.context2d = new p(this), n = this.internal.f2, r = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, a = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, u = this.internal.Point, c = this.internal.Rectangle, l = this.internal.Matrix, f = new d;
                        }
                    ]);
                    var p = function(t) {
                        Object.defineProperty(this, "canvas", {
                            get: function() {
                                return {
                                    parentNode: !1,
                                    style: !1
                                };
                            }
                        });
                        var e = t;
                        Object.defineProperty(this, "pdf", {
                            get: function() {
                                return e;
                            }
                        });
                        var n = !1;
                        Object.defineProperty(this, "pageWrapXEnabled", {
                            get: function() {
                                return n;
                            },
                            set: function(t) {
                                n = Boolean(t);
                            }
                        });
                        var r = !1;
                        Object.defineProperty(this, "pageWrapYEnabled", {
                            get: function() {
                                return r;
                            },
                            set: function(t) {
                                r = Boolean(t);
                            }
                        });
                        var i = 0;
                        Object.defineProperty(this, "posX", {
                            get: function() {
                                return i;
                            },
                            set: function(t) {
                                isNaN(t) || (i = t);
                            }
                        });
                        var a = 0;
                        Object.defineProperty(this, "posY", {
                            get: function() {
                                return a;
                            },
                            set: function(t) {
                                isNaN(t) || (a = t);
                            }
                        }), Object.defineProperty(this, "margin", {
                            get: function() {
                                return f.margin;
                            },
                            set: function(t) {
                                var e;
                                "number" == typeof t ? e = [
                                    t,
                                    t,
                                    t,
                                    t
                                ] : ((e = new Array(4))[0] = t[0], e[1] = t.length >= 2 ? t[1] : e[0], e[2] = t.length >= 3 ? t[2] : e[0], e[3] = t.length >= 4 ? t[3] : e[1]), f.margin = e;
                            }
                        });
                        var o = !1;
                        Object.defineProperty(this, "autoPaging", {
                            get: function() {
                                return o;
                            },
                            set: function(t) {
                                o = t;
                            }
                        });
                        var s = 0;
                        Object.defineProperty(this, "lastBreak", {
                            get: function() {
                                return s;
                            },
                            set: function(t) {
                                s = t;
                            }
                        });
                        var u = [];
                        Object.defineProperty(this, "pageBreaks", {
                            get: function() {
                                return u;
                            },
                            set: function(t) {
                                u = t;
                            }
                        }), Object.defineProperty(this, "ctx", {
                            get: function() {
                                return f;
                            },
                            set: function(t) {
                                t instanceof d && (f = t);
                            }
                        }), Object.defineProperty(this, "path", {
                            get: function() {
                                return f.path;
                            },
                            set: function(t) {
                                f.path = t;
                            }
                        });
                        var c = [];
                        Object.defineProperty(this, "ctxStack", {
                            get: function() {
                                return c;
                            },
                            set: function(t) {
                                c = t;
                            }
                        }), Object.defineProperty(this, "fillStyle", {
                            get: function() {
                                return this.ctx.fillStyle;
                            },
                            set: function(t) {
                                var e;
                                e = g(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                                    a: e.a
                                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                                    a: e.a
                                });
                            }
                        }), Object.defineProperty(this, "strokeStyle", {
                            get: function() {
                                return this.ctx.strokeStyle;
                            },
                            set: function(t) {
                                var e = g(t);
                                this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
                            }
                        }), Object.defineProperty(this, "lineCap", {
                            get: function() {
                                return this.ctx.lineCap;
                            },
                            set: function(t) {
                                -1 !== [
                                    "butt",
                                    "round",
                                    "square"
                                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
                            }
                        }), Object.defineProperty(this, "lineWidth", {
                            get: function() {
                                return this.ctx.lineWidth;
                            },
                            set: function(t) {
                                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
                            }
                        }), Object.defineProperty(this, "lineJoin", {
                            get: function() {
                                return this.ctx.lineJoin;
                            },
                            set: function(t) {
                                -1 !== [
                                    "bevel",
                                    "round",
                                    "miter"
                                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
                            }
                        }), Object.defineProperty(this, "miterLimit", {
                            get: function() {
                                return this.ctx.miterLimit;
                            },
                            set: function(t) {
                                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
                            }
                        }), Object.defineProperty(this, "textBaseline", {
                            get: function() {
                                return this.ctx.textBaseline;
                            },
                            set: function(t) {
                                this.ctx.textBaseline = t;
                            }
                        }), Object.defineProperty(this, "textAlign", {
                            get: function() {
                                return this.ctx.textAlign;
                            },
                            set: function(t) {
                                -1 !== [
                                    "right",
                                    "end",
                                    "center",
                                    "left",
                                    "start"
                                ].indexOf(t) && (this.ctx.textAlign = t);
                            }
                        });
                        var l = null, h = null;
                        var p = null;
                        Object.defineProperty(this, "fontFaces", {
                            get: function() {
                                return p;
                            },
                            set: function(t) {
                                l = null, h = null, p = t;
                            }
                        }), Object.defineProperty(this, "font", {
                            get: function() {
                                return this.ctx.font;
                            },
                            set: function(t) {
                                var e;
                                if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z0-9]+?)\s*$/i.exec(t))) {
                                    var n = e[1];
                                    e[2];
                                    var r = e[3], i = e[4];
                                    e[5];
                                    var a = e[6], o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
                                    i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
                                    var s = function(t) {
                                        var e, n, r = [], i = t.trim();
                                        if ("" === i) return Jt;
                                        if (i in Mt) return [
                                            Mt[i]
                                        ];
                                        for(; "" !== i;){
                                            switch(n = null, e = (i = Et(i)).charAt(0)){
                                                case '"':
                                                case "'":
                                                    n = Rt(i.substring(1), e);
                                                    break;
                                                default:
                                                    n = Dt(i);
                                            }
                                            if (null === n) return Jt;
                                            if (r.push(n[0]), "" !== (i = Et(n[1])) && "," !== i.charAt(0)) return Jt;
                                            i = i.replace(/^,/, "");
                                        }
                                        return r;
                                    }(a);
                                    if (this.fontFaces) {
                                        var u = function(t, e) {
                                            var n = t.getFontList(), r = JSON.stringify(n);
                                            if (null === l || h !== r) {
                                                var i = function(t) {
                                                    var e = [];
                                                    return Object.keys(t).forEach(function(n) {
                                                        t[n].forEach(function(t) {
                                                            var r = null;
                                                            switch(t){
                                                                case "bold":
                                                                    r = {
                                                                        family: n,
                                                                        weight: "bold"
                                                                    };
                                                                    break;
                                                                case "italic":
                                                                    r = {
                                                                        family: n,
                                                                        style: "italic"
                                                                    };
                                                                    break;
                                                                case "bolditalic":
                                                                    r = {
                                                                        family: n,
                                                                        weight: "bold",
                                                                        style: "italic"
                                                                    };
                                                                    break;
                                                                case "":
                                                                case "normal":
                                                                    r = {
                                                                        family: n
                                                                    };
                                                            }
                                                            null !== r && (r.ref = {
                                                                name: n,
                                                                style: t
                                                            }, e.push(r));
                                                        });
                                                    }), e;
                                                }(n);
                                                l = function(t) {
                                                    for(var e = {}, n = 0; n < t.length; ++n){
                                                        var r = Ct(t[n]), i = r.family, a = r.stretch, o = r.style, s = r.weight;
                                                        e[i] = e[i] || {}, e[i][a] = e[i][a] || {}, e[i][a][o] = e[i][a][o] || {}, e[i][a][o][s] = r;
                                                    }
                                                    return e;
                                                }(i.concat(e)), h = r;
                                            }
                                            return l;
                                        }(this.pdf, this.fontFaces), c = s.map(function(t) {
                                            return {
                                                family: t,
                                                stretch: "normal",
                                                weight: r,
                                                style: n
                                            };
                                        }), f = function(t, e, n) {
                                            for(var r = (n = n || {}).defaultFontFamily || "times", i = Object.assign({}, Bt, n.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s)if (i[(a = Ct(e[s])).family] && (a.family = i[a.family]), t.hasOwnProperty(a.family)) {
                                                o = t[a.family];
                                                break;
                                            }
                                            if (!(o = o || t[r])) throw new Error("Could not find a font-family for the rule '" + qt(a) + "' and default family '" + r + "'.");
                                            if (o = function(t, e) {
                                                if (e[t]) return e[t];
                                                var n = Ft[t], r = n <= Ft.normal ? -1 : 1, i = Ot(e, kt, n, r);
                                                if (!i) throw new Error("Could not find a matching font-stretch value for " + t);
                                                return i;
                                            }(a.stretch, o), o = function(t, e) {
                                                if (e[t]) return e[t];
                                                for(var n = Pt[t], r = 0; r < n.length; ++r)if (e[n[r]]) return e[n[r]];
                                                throw new Error("Could not find a matching font-style for " + t);
                                            }(a.style, o), !(o = function(t, e) {
                                                if (e[t]) return e[t];
                                                if (400 === t && e[500]) return e[500];
                                                if (500 === t && e[400]) return e[400];
                                                var n = jt[t], r = Ot(e, It, n, t < 400 ? -1 : 1);
                                                if (!r) throw new Error("Could not find a matching font-weight for value " + t);
                                                return r;
                                            }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + qt(a) + "'.");
                                            return o;
                                        }(u, c);
                                        this.pdf.setFont(f.ref.name, f.ref.style);
                                    } else {
                                        var d = "";
                                        ("bold" === r || parseInt(r, 10) >= 700 || "bold" === n) && (d = "bold"), "italic" === n && (d += "italic"), 0 === d.length && (d = "normal");
                                        for(var p = "", g = {
                                            arial: "Helvetica",
                                            Arial: "Helvetica",
                                            verdana: "Helvetica",
                                            Verdana: "Helvetica",
                                            helvetica: "Helvetica",
                                            Helvetica: "Helvetica",
                                            "sans-serif": "Helvetica",
                                            fixed: "Courier",
                                            monospace: "Courier",
                                            terminal: "Courier",
                                            cursive: "Times",
                                            fantasy: "Times",
                                            serif: "Times"
                                        }, m = 0; m < s.length; m++){
                                            if (void 0 !== this.pdf.internal.getFont(s[m], d, {
                                                noFallback: !0,
                                                disableWarning: !0
                                            })) {
                                                p = s[m];
                                                break;
                                            }
                                            if ("bolditalic" === d && void 0 !== this.pdf.internal.getFont(s[m], "bold", {
                                                noFallback: !0,
                                                disableWarning: !0
                                            })) p = s[m], d = "bold";
                                            else if (void 0 !== this.pdf.internal.getFont(s[m], "normal", {
                                                noFallback: !0,
                                                disableWarning: !0
                                            })) {
                                                p = s[m], d = "normal";
                                                break;
                                            }
                                        }
                                        if ("" === p) {
                                            for(var v = 0; v < s.length; v++)if (g[s[v]]) {
                                                p = g[s[v]];
                                                break;
                                            }
                                        }
                                        p = "" === p ? "Times" : p, this.pdf.setFont(p, d);
                                    }
                                }
                            }
                        }), Object.defineProperty(this, "globalCompositeOperation", {
                            get: function() {
                                return this.ctx.globalCompositeOperation;
                            },
                            set: function(t) {
                                this.ctx.globalCompositeOperation = t;
                            }
                        }), Object.defineProperty(this, "globalAlpha", {
                            get: function() {
                                return this.ctx.globalAlpha;
                            },
                            set: function(t) {
                                this.ctx.globalAlpha = t;
                            }
                        }), Object.defineProperty(this, "lineDashOffset", {
                            get: function() {
                                return this.ctx.lineDashOffset;
                            },
                            set: function(t) {
                                this.ctx.lineDashOffset = t, T.call(this);
                            }
                        }), Object.defineProperty(this, "lineDash", {
                            get: function() {
                                return this.ctx.lineDash;
                            },
                            set: function(t) {
                                this.ctx.lineDash = t, T.call(this);
                            }
                        }), Object.defineProperty(this, "ignoreClearRect", {
                            get: function() {
                                return this.ctx.ignoreClearRect;
                            },
                            set: function(t) {
                                this.ctx.ignoreClearRect = Boolean(t);
                            }
                        });
                    };
                    p.prototype.setLineDash = function(t) {
                        this.lineDash = t;
                    }, p.prototype.getLineDash = function() {
                        return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
                    }, p.prototype.fill = function() {
                        x.call(this, "fill", !1);
                    }, p.prototype.stroke = function() {
                        x.call(this, "stroke", !1);
                    }, p.prototype.beginPath = function() {
                        this.path = [
                            {
                                type: "begin"
                            }
                        ];
                    }, p.prototype.moveTo = function(t, e) {
                        if (isNaN(t) || isNaN(e)) throw o.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
                        var n = this.ctx.transform.applyToPoint(new u(t, e));
                        this.path.push({
                            type: "mt",
                            x: n.x,
                            y: n.y
                        }), this.ctx.lastPoint = new u(t, e);
                    }, p.prototype.closePath = function() {
                        var e = new u(0, 0), n = 0;
                        for(n = this.path.length - 1; -1 !== n; n--)if ("begin" === this.path[n].type && "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(this.path[n + 1]) && "number" == typeof this.path[n + 1].x) {
                            e = new u(this.path[n + 1].x, this.path[n + 1].y);
                            break;
                        }
                        this.path.push({
                            type: "close"
                        }), this.ctx.lastPoint = new u(e.x, e.y);
                    }, p.prototype.lineTo = function(t, e) {
                        if (isNaN(t) || isNaN(e)) throw o.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
                        var n = this.ctx.transform.applyToPoint(new u(t, e));
                        this.path.push({
                            type: "lt",
                            x: n.x,
                            y: n.y
                        }), this.ctx.lastPoint = new u(n.x, n.y);
                    }, p.prototype.clip = function() {
                        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), x.call(this, null, !0);
                    }, p.prototype.quadraticCurveTo = function(t, e, n, r) {
                        if (isNaN(n) || isNaN(r) || isNaN(t) || isNaN(e)) throw o.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
                        var i = this.ctx.transform.applyToPoint(new u(n, r)), a = this.ctx.transform.applyToPoint(new u(t, e));
                        this.path.push({
                            type: "qct",
                            x1: a.x,
                            y1: a.y,
                            x: i.x,
                            y: i.y
                        }), this.ctx.lastPoint = new u(i.x, i.y);
                    }, p.prototype.bezierCurveTo = function(t, e, n, r, i, a) {
                        if (isNaN(i) || isNaN(a) || isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw o.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
                        var s = this.ctx.transform.applyToPoint(new u(i, a)), c = this.ctx.transform.applyToPoint(new u(t, e)), l = this.ctx.transform.applyToPoint(new u(n, r));
                        this.path.push({
                            type: "bct",
                            x1: c.x,
                            y1: c.y,
                            x2: l.x,
                            y2: l.y,
                            x: s.x,
                            y: s.y
                        }), this.ctx.lastPoint = new u(s.x, s.y);
                    }, p.prototype.arc = function(t, e, n, r, i, a) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i)) throw o.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
                        if (a = Boolean(a), !this.ctx.transform.isIdentity) {
                            var s = this.ctx.transform.applyToPoint(new u(t, e));
                            t = s.x, e = s.y;
                            var c = this.ctx.transform.applyToPoint(new u(0, n)), l = this.ctx.transform.applyToPoint(new u(0, 0));
                            n = Math.sqrt(Math.pow(c.x - l.x, 2) + Math.pow(c.y - l.y, 2));
                        }
                        Math.abs(i - r) >= 2 * Math.PI && (r = 0, i = 2 * Math.PI), this.path.push({
                            type: "arc",
                            x: t,
                            y: e,
                            radius: n,
                            startAngle: r,
                            endAngle: i,
                            counterclockwise: a
                        });
                    }, p.prototype.arcTo = function(t, e, n, r, i) {
                        throw new Error("arcTo not implemented.");
                    }, p.prototype.rect = function(t, e, n, r) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw o.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
                        this.moveTo(t, e), this.lineTo(t + n, e), this.lineTo(t + n, e + r), this.lineTo(t, e + r), this.lineTo(t, e), this.lineTo(t + n, e), this.lineTo(t, e);
                    }, p.prototype.fillRect = function(t, e, n, r) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw o.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
                        if (!m.call(this)) {
                            var i = {};
                            "butt" !== this.lineCap && (i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, n, r), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
                        }
                    }, p.prototype.strokeRect = function(t, e, n, r) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw o.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
                        v.call(this) || (this.beginPath(), this.rect(t, e, n, r), this.stroke());
                    }, p.prototype.clearRect = function(t, e, n, r) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw o.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
                        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, n, r));
                    }, p.prototype.save = function(t) {
                        t = "boolean" != typeof t || t;
                        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("q");
                        if (this.pdf.setPage(e), t) {
                            this.ctx.fontSize = this.pdf.internal.getFontSize();
                            var r = new d(this.ctx);
                            this.ctxStack.push(this.ctx), this.ctx = r;
                        }
                    }, p.prototype.restore = function(t) {
                        t = "boolean" != typeof t || t;
                        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("Q");
                        this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
                    }, p.prototype.toDataURL = function() {
                        throw new Error("toDataUrl not implemented.");
                    };
                    var g = function(t) {
                        var e, n, r, i;
                        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 0,
                            style: t
                        };
                        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, n = 0, r = 0, i = 0;
                        else {
                            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
                            if (null !== a) e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = 1;
                            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = parseFloat(a[4]);
                            else {
                                if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                                    var o = new h(t);
                                    t = o.ok ? o.toHex() : "#000000";
                                }
                                4 === t.length ? (e = t.substring(1, 2), e += e, n = t.substring(2, 3), n += n, r = t.substring(3, 4), r += r) : (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7)), e = parseInt(e, 16), n = parseInt(n, 16), r = parseInt(r, 16);
                            }
                        }
                        return {
                            r: e,
                            g: n,
                            b: r,
                            a: i,
                            style: t
                        };
                    }, m = function() {
                        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
                    }, v = function() {
                        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
                    };
                    p.prototype.fillText = function(t, e, n, r) {
                        if (isNaN(e) || isNaN(n) || "string" != typeof t) throw o.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
                        if (r = isNaN(r) ? void 0 : r, !m.call(this)) {
                            var i = E(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
                            j.call(this, {
                                text: t,
                                x: e,
                                y: n,
                                scale: a,
                                angle: i,
                                align: this.textAlign,
                                maxWidth: r
                            });
                        }
                    }, p.prototype.strokeText = function(t, e, n, r) {
                        if (isNaN(e) || isNaN(n) || "string" != typeof t) throw o.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
                        if (!v.call(this)) {
                            r = isNaN(r) ? void 0 : r;
                            var i = E(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
                            j.call(this, {
                                text: t,
                                x: e,
                                y: n,
                                scale: a,
                                renderingMode: "stroke",
                                angle: i,
                                align: this.textAlign,
                                maxWidth: r
                            });
                        }
                    }, p.prototype.measureText = function(t) {
                        if ("string" != typeof t) throw o.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
                        var e = this.pdf, n = this.pdf.internal.scaleFactor, r = e.internal.getFontSize(), i = e.getStringUnitWidth(t) * r / e.internal.scaleFactor;
                        return new function(t) {
                            var e = (t = t || {}).width || 0;
                            return Object.defineProperty(this, "width", {
                                get: function() {
                                    return e;
                                }
                            }), this;
                        }({
                            width: i *= Math.round(96 * n / 72 * 1e4) / 1e4
                        });
                    }, p.prototype.scale = function(t, e) {
                        if (isNaN(t) || isNaN(e)) throw o.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
                        var n = new l(t, 0, 0, e, 0, 0);
                        this.ctx.transform = this.ctx.transform.multiply(n);
                    }, p.prototype.rotate = function(t) {
                        if (isNaN(t)) throw o.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
                        var e = new l(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
                        this.ctx.transform = this.ctx.transform.multiply(e);
                    }, p.prototype.translate = function(t, e) {
                        if (isNaN(t) || isNaN(e)) throw o.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
                        var n = new l(1, 0, 0, 1, t, e);
                        this.ctx.transform = this.ctx.transform.multiply(n);
                    }, p.prototype.transform = function(t, e, n, r, i, a) {
                        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a)) throw o.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
                        var s = new l(t, e, n, r, i, a);
                        this.ctx.transform = this.ctx.transform.multiply(s);
                    }, p.prototype.setTransform = function(t, e, n, r, i, a) {
                        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, n = isNaN(n) ? 0 : n, r = isNaN(r) ? 1 : r, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new l(t, e, n, r, i, a);
                    };
                    var b = function() {
                        return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
                    };
                    p.prototype.drawImage = function(t, e, n, r, i, a, o, s, u) {
                        var h = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
                        void 0 !== r && void 0 !== s && (p = s / r, g = u / i, f = h.width / r * s / r, d = h.height / i * u / i), void 0 === a && (a = e, o = n, e = 0, n = 0), void 0 !== r && void 0 === s && (s = r, u = i), void 0 === r && void 0 === s && (s = h.width, u = h.height);
                        var m = this.ctx.transform.decompose(), v = E(m.rotate.shx), w = new l, x = (w = (w = (w = w.multiply(m.translate)).multiply(m.skew)).multiply(m.scale)).applyToRectangle(new c(a - e * p, o - n * g, r * f, i * d));
                        if (this.autoPaging) {
                            for(var S, _ = y.call(this, x), P = [], k = 0; k < _.length; k += 1)-1 === P.indexOf(_[k]) && P.push(_[k]);
                            L(P);
                            for(var F = P[0], I = P[P.length - 1], j = F; j < I + 1; j++){
                                this.pdf.setPage(j);
                                var C = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O = 1 === j ? this.posY + this.margin[0] : this.margin[0], B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], q = 1 === j ? 0 : B + (j - 2) * M;
                                if (0 !== this.ctx.clip_path.length) {
                                    var R = this.path;
                                    S = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(S, this.posX + this.margin[3], -q + O + this.ctx.prevPageLastElemOffset), A.call(this, "fill", !0), this.path = R;
                                }
                                var D = JSON.parse(JSON.stringify(x));
                                D = N([
                                    D
                                ], this.posX + this.margin[3], -q + O + this.ctx.prevPageLastElemOffset)[0];
                                var T = (j > F || j < I) && b.call(this);
                                T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], C, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", D.x, D.y, D.w, D.h, null, null, v), T && this.pdf.restoreGraphicsState();
                            }
                        } else this.pdf.addImage(t, "JPEG", x.x, x.y, x.w, x.h, null, null, v);
                    };
                    var y = function(t, e, n) {
                        var r = [];
                        e = e || this.pdf.internal.pageSize.width, n = n || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
                        var i = this.posY + this.ctx.prevPageLastElemOffset;
                        switch(t.type){
                            default:
                            case "mt":
                            case "lt":
                                r.push(Math.floor((t.y + i) / n) + 1);
                                break;
                            case "arc":
                                r.push(Math.floor((t.y + i - t.radius) / n) + 1), r.push(Math.floor((t.y + i + t.radius) / n) + 1);
                                break;
                            case "qct":
                                var a = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                                r.push(Math.floor((a.y + i) / n) + 1), r.push(Math.floor((a.y + a.h + i) / n) + 1);
                                break;
                            case "bct":
                                var o = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                                r.push(Math.floor((o.y + i) / n) + 1), r.push(Math.floor((o.y + o.h + i) / n) + 1);
                                break;
                            case "rect":
                                r.push(Math.floor((t.y + i) / n) + 1), r.push(Math.floor((t.y + t.h + i) / n) + 1);
                        }
                        for(var s = 0; s < r.length; s += 1)for(; this.pdf.internal.getNumberOfPages() < r[s];)w.call(this);
                        return r;
                    }, w = function() {
                        var t = this.fillStyle, e = this.strokeStyle, n = this.font, r = this.lineCap, i = this.lineWidth, a = this.lineJoin;
                        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = n, this.lineCap = r, this.lineWidth = i, this.lineJoin = a;
                    }, N = function(t, e, n) {
                        for(var r = 0; r < t.length; r++)switch(t[r].type){
                            case "bct":
                                t[r].x2 += e, t[r].y2 += n;
                            case "qct":
                                t[r].x1 += e, t[r].y1 += n;
                            default:
                                t[r].x += e, t[r].y += n;
                        }
                        return t;
                    }, L = function(t) {
                        return t.sort(function(t, e) {
                            return t - e;
                        });
                    }, x = function(t, e) {
                        var n = this.fillStyle, r = this.strokeStyle, i = this.lineCap, a = this.lineWidth, o = Math.abs(a * this.ctx.transform.scaleX), s = this.lineJoin;
                        if (this.autoPaging) {
                            for(var u, c, l = JSON.parse(JSON.stringify(this.path)), h = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < h.length; d++)if (void 0 !== h[d].x) for(var p = y.call(this, h[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
                            for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)w.call(this);
                            L(f);
                            for(var v = f[0], x = f[f.length - 1], S = v; S < x + 1; S++){
                                this.pdf.setPage(S), this.fillStyle = n, this.strokeStyle = r, this.lineCap = i, this.lineWidth = o, this.lineJoin = s;
                                var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P = 1 === S ? this.posY + this.margin[0] : this.margin[0], k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], F = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], I = 1 === S ? 0 : k + (S - 2) * F;
                                if (0 !== this.ctx.clip_path.length) {
                                    var j = this.path;
                                    u = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(u, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), A.call(this, t, !0), this.path = j;
                                }
                                if (c = JSON.parse(JSON.stringify(l)), this.path = N(c, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
                                    var C = (S > v || S < x) && b.call(this);
                                    C && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, F, null).clip().discardPath()), A.call(this, t, e), C && this.pdf.restoreGraphicsState();
                                }
                                this.lineWidth = a;
                            }
                            this.path = l;
                        } else this.lineWidth = o, A.call(this, t, e), this.lineWidth = a;
                    }, A = function(t, e) {
                        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
                            for(var n, r, i = [], a = this.path, o = 0; o < a.length; o++){
                                var s = a[o];
                                switch(s.type){
                                    case "begin":
                                        i.push({
                                            begin: !0
                                        });
                                        break;
                                    case "close":
                                        i.push({
                                            close: !0
                                        });
                                        break;
                                    case "mt":
                                        i.push({
                                            start: s,
                                            deltas: [],
                                            abs: []
                                        });
                                        break;
                                    case "lt":
                                        var u = i.length;
                                        if (a[o - 1] && !isNaN(a[o - 1].x) && (n = [
                                            s.x - a[o - 1].x,
                                            s.y - a[o - 1].y
                                        ], u > 0)) {
                                            for(; u >= 0; u--)if (!0 !== i[u - 1].close && !0 !== i[u - 1].begin) {
                                                i[u - 1].deltas.push(n), i[u - 1].abs.push(s);
                                                break;
                                            }
                                        }
                                        break;
                                    case "bct":
                                        n = [
                                            s.x1 - a[o - 1].x,
                                            s.y1 - a[o - 1].y,
                                            s.x2 - a[o - 1].x,
                                            s.y2 - a[o - 1].y,
                                            s.x - a[o - 1].x,
                                            s.y - a[o - 1].y
                                        ], i[i.length - 1].deltas.push(n);
                                        break;
                                    case "qct":
                                        var c = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), l = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), h = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                                        n = [
                                            c - a[o - 1].x,
                                            l - a[o - 1].y,
                                            h - a[o - 1].x,
                                            f - a[o - 1].y,
                                            d - a[o - 1].x,
                                            p - a[o - 1].y
                                        ], i[i.length - 1].deltas.push(n);
                                        break;
                                    case "arc":
                                        i.push({
                                            deltas: [],
                                            abs: [],
                                            arc: !0
                                        }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
                                }
                            }
                            r = e ? null : "stroke" === t ? "stroke" : "fill";
                            for(var g = !1, b = 0; b < i.length; b++)if (i[b].arc) for(var y = i[b].abs, w = 0; w < y.length; w++){
                                var N = y[w];
                                "arc" === N.type ? P.call(this, N.x, N.y, N.radius, N.startAngle, N.endAngle, N.counterclockwise, void 0, e, !g) : C.call(this, N.x, N.y), g = !0;
                            }
                            else if (!0 === i[b].close) this.pdf.internal.out("h"), g = !1;
                            else if (!0 !== i[b].begin) {
                                var L = i[b].start.x, x = i[b].start.y;
                                O.call(this, i[b].deltas, L, x), g = !0;
                            }
                            r && k.call(this, r), e && F.call(this);
                        }
                    }, S = function(t) {
                        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, n = e * (this.pdf.internal.getLineHeightFactor() - 1);
                        switch(this.ctx.textBaseline){
                            case "bottom":
                                return t - n;
                            case "top":
                                return t + e - n;
                            case "hanging":
                                return t + e - 2 * n;
                            case "middle":
                                return t + e / 2 - n;
                            default:
                                return t;
                        }
                    }, _ = function(t) {
                        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
                    };
                    p.prototype.createLinearGradient = function() {
                        var t = function() {};
                        return t.colorStops = [], t.addColorStop = function(t, e) {
                            this.colorStops.push([
                                t,
                                e
                            ]);
                        }, t.getColor = function() {
                            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
                        }, t.isCanvasGradient = !0, t;
                    }, p.prototype.createPattern = function() {
                        return this.createLinearGradient();
                    }, p.prototype.createRadialGradient = function() {
                        return this.createLinearGradient();
                    };
                    var P = function(t, e, n, r, i, a, o, s, u) {
                        for(var c = M.call(this, n, r, i, a), l = 0; l < c.length; l++){
                            var h = c[l];
                            0 === l && (u ? I.call(this, h.x1 + t, h.y1 + e) : C.call(this, h.x1 + t, h.y1 + e)), B.call(this, t, e, h.x2, h.y2, h.x3, h.y3, h.x4, h.y4);
                        }
                        s ? F.call(this) : k.call(this, o);
                    }, k = function(t) {
                        switch(t){
                            case "stroke":
                                this.pdf.internal.out("S");
                                break;
                            case "fill":
                                this.pdf.internal.out("f");
                        }
                    }, F = function() {
                        this.pdf.clip(), this.pdf.discardPath();
                    }, I = function(t, e) {
                        this.pdf.internal.out(r(t) + " " + i(e) + " m");
                    }, j = function(t) {
                        var e;
                        switch(t.align){
                            case "right":
                            case "end":
                                e = "right";
                                break;
                            case "center":
                                e = "center";
                                break;
                            default:
                                e = "left";
                        }
                        var n, r, i, a = this.pdf.getTextDimensions(t.text), o = S.call(this, t.y), s = _.call(this, o) - a.h, h = this.ctx.transform.applyToPoint(new u(t.x, o));
                        if (this.autoPaging) {
                            var f = this.ctx.transform.decompose(), d = new l;
                            d = (d = (d = d.multiply(f.translate)).multiply(f.skew)).multiply(f.scale);
                            for(var p = this.ctx.transform.applyToRectangle(new c(t.x, o, a.w, a.h)), g = d.applyToRectangle(new c(t.x, s, a.w, a.h)), m = y.call(this, g), v = [], w = 0; w < m.length; w += 1)-1 === v.indexOf(m[w]) && v.push(m[w]);
                            L(v);
                            for(var x = v[0], P = v[v.length - 1], k = x; k < P + 1; k++){
                                this.pdf.setPage(k);
                                var F = 1 === k ? this.posY + this.margin[0] : this.margin[0], I = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], j = this.pdf.internal.pageSize.height - this.margin[2], C = j - this.margin[0], O = this.pdf.internal.pageSize.width - this.margin[1], B = O - this.margin[3], M = 1 === k ? 0 : I + (k - 2) * C;
                                if (0 !== this.ctx.clip_path.length) {
                                    var q = this.path;
                                    n = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(n, this.posX + this.margin[3], -1 * M + F), A.call(this, "fill", !0), this.path = q;
                                }
                                var E = N([
                                    JSON.parse(JSON.stringify(g))
                                ], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0];
                                t.scale >= .01 && (r = this.pdf.internal.getFontSize(), this.pdf.setFontSize(r * t.scale), i = this.lineWidth, this.lineWidth = i * t.scale);
                                var R = "text" !== this.autoPaging;
                                if (R || E.y + E.h <= j) {
                                    if (R || E.y >= F && E.x <= O) {
                                        var D = R ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - E.x)[0], T = N([
                                            JSON.parse(JSON.stringify(p))
                                        ], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0], z = R && (k > x || k < P) && b.call(this);
                                        z && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, C, null).clip().discardPath()), this.pdf.text(D, T.x, T.y, {
                                            angle: t.angle,
                                            align: e,
                                            renderingMode: t.renderingMode
                                        }), z && this.pdf.restoreGraphicsState();
                                    }
                                } else E.y < j && (this.ctx.prevPageLastElemOffset += j - E.y);
                                t.scale >= .01 && (this.pdf.setFontSize(r), this.lineWidth = i);
                            }
                        } else t.scale >= .01 && (r = this.pdf.internal.getFontSize(), this.pdf.setFontSize(r * t.scale), i = this.lineWidth, this.lineWidth = i * t.scale), this.pdf.text(t.text, h.x + this.posX, h.y + this.posY, {
                            angle: t.angle,
                            align: e,
                            renderingMode: t.renderingMode,
                            maxWidth: t.maxWidth
                        }), t.scale >= .01 && (this.pdf.setFontSize(r), this.lineWidth = i);
                    }, C = function(t, e, n, a) {
                        n = n || 0, a = a || 0, this.pdf.internal.out(r(t + n) + " " + i(e + a) + " l");
                    }, O = function(t, e, n) {
                        return this.pdf.lines(t, e, n, null, null);
                    }, B = function(t, e, r, i, o, u, c, l) {
                        this.pdf.internal.out([
                            n(a(r + t)),
                            n(s(i + e)),
                            n(a(o + t)),
                            n(s(u + e)),
                            n(a(c + t)),
                            n(s(l + e)),
                            "c"
                        ].join(" "));
                    }, M = function(t, e, n, r) {
                        for(var i = 2 * Math.PI, a = Math.PI / 2; e > n;)e -= i;
                        var o = Math.abs(n - e);
                        o < i && r && (o = i - o);
                        for(var s = [], u = r ? -1 : 1, c = e; o > 1e-5;){
                            var l = c + u * Math.min(o, a);
                            s.push(q.call(this, t, c, l)), o -= Math.abs(l - c), c = l;
                        }
                        return s;
                    }, q = function(t, e, n) {
                        var r = (n - e) / 2, i = t * Math.cos(r), a = t * Math.sin(r), o = i, s = -a, u = o * o + s * s, c = u + o * i + s * a, l = 4 / 3 * (Math.sqrt(2 * u * c) - c) / (o * a - s * i), h = o - l * s, f = s + l * o, d = h, p = -f, g = r + e, m = Math.cos(g), v = Math.sin(g);
                        return {
                            x1: t * Math.cos(e),
                            y1: t * Math.sin(e),
                            x2: h * m - f * v,
                            y2: h * v + f * m,
                            x3: d * m - p * v,
                            y3: d * v + p * m,
                            x4: t * Math.cos(n),
                            y4: t * Math.sin(n)
                        };
                    }, E = function(t) {
                        return 180 * t / Math.PI;
                    }, R = function(t, e, n, r, i, a) {
                        var o = t + .5 * (n - t), s = e + .5 * (r - e), u = i + .5 * (n - i), l = a + .5 * (r - a), h = Math.min(t, i, o, u), f = Math.max(t, i, o, u), d = Math.min(e, a, s, l), p = Math.max(e, a, s, l);
                        return new c(h, d, f - h, p - d);
                    }, D = function(t, e, n, r, i, a, o, s) {
                        var u, l, h, f, d, p, g, m, v, b, y, w, N, L, x = n - t, A = r - e, S = i - n, _ = a - r, P = o - i, k = s - a;
                        for(l = 0; l < 41; l++)v = (g = (h = t + (u = l / 40) * x) + u * ((d = n + u * S) - h)) + u * (d + u * (i + u * P - d) - g), b = (m = (f = e + u * A) + u * ((p = r + u * _) - f)) + u * (p + u * (a + u * k - p) - m), 0 == l ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
                        return new c(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
                    }, T = function() {
                        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
                            var t, e, n = (t = this.ctx.lineDash, e = this.ctx.lineDashOffset, JSON.stringify({
                                lineDash: t,
                                lineDashOffset: e
                            }));
                            this.prevLineDash !== n && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = n);
                        }
                    };
                }(E.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    var n = function(t) {
                        var e, n, r, i, a, o, s, u, c, l;
                        for(/[^\x00-\xFF]/.test(t), n = [], r = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > r; r += 4)0 !== (a = (t.charCodeAt(r) << 24) + (t.charCodeAt(r + 1) << 16) + (t.charCodeAt(r + 2) << 8) + t.charCodeAt(r + 3)) ? (o = (a = ((a = ((a = ((a = (a - (l = a % 85)) / 85) - (c = a % 85)) / 85) - (u = a % 85)) / 85) - (s = a % 85)) / 85) % 85, n.push(o + 33, s + 33, u + 33, c + 33, l + 33)) : n.push(122);
                        return function(t, e) {
                            for(var n = e; n > 0; n--)t.pop();
                        }(n, e.length), String.fromCharCode.apply(String, n) + "~>";
                    }, r = function(t) {
                        var e, n, r, i, a, o = String, s = "length", u = 255, c = "charCodeAt", l = "slice", h = "replace";
                        for(t[l](-2), t = t[l](0, -2)[h](/\s/g, "")[h]("z", "!!!!!"), r = [], i = 0, a = (t += e = "uuuuu"[l](t[s] % 5 || 5))[s]; a > i; i += 5)n = 52200625 * (t[c](i) - 33) + 614125 * (t[c](i + 1) - 33) + 7225 * (t[c](i + 2) - 33) + 85 * (t[c](i + 3) - 33) + (t[c](i + 4) - 33), r.push(u & n >> 24, u & n >> 16, u & n >> 8, u & n);
                        return function(t, e) {
                            for(var n = e; n > 0; n--)t.pop();
                        }(r, e[s]), o.fromCharCode.apply(o, r);
                    }, i = function(t) {
                        return t.split("").map(function(t) {
                            return ("0" + t.charCodeAt().toString(16)).slice(-2);
                        }).join("") + ">";
                    }, a = function(t) {
                        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
                        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
                        for(var n = "", r = 0; r < t.length; r += 2)n += String.fromCharCode("0x" + (t[r] + t[r + 1]));
                        return n;
                    }, o = function(t) {
                        for(var n = new Uint8Array(t.length), r = t.length; r--;)n[r] = t.charCodeAt(r);
                        return (n = (0, fflate__WEBPACK_IMPORTED_MODULE_1__.zlibSync)(n)).reduce(function(t, e) {
                            return t + String.fromCharCode(e);
                        }, "");
                    };
                    t.processDataByFilters = function(t, e) {
                        var s = 0, u = t || "", c = [];
                        for("string" == typeof (e = e || []) && (e = [
                            e
                        ]), s = 0; s < e.length; s += 1)switch(e[s]){
                            case "ASCII85Decode":
                            case "/ASCII85Decode":
                                u = r(u), c.push("/ASCII85Encode");
                                break;
                            case "ASCII85Encode":
                            case "/ASCII85Encode":
                                u = n(u), c.push("/ASCII85Decode");
                                break;
                            case "ASCIIHexDecode":
                            case "/ASCIIHexDecode":
                                u = a(u), c.push("/ASCIIHexEncode");
                                break;
                            case "ASCIIHexEncode":
                            case "/ASCIIHexEncode":
                                u = i(u), c.push("/ASCIIHexDecode");
                                break;
                            case "FlateEncode":
                            case "/FlateEncode":
                                u = o(u), c.push("/FlateDecode");
                                break;
                            default:
                                throw new Error('The filter: "' + e[s] + '" is not implemented');
                        }
                        return {
                            data: u,
                            reverseChain: c.reverse().join(" ")
                        };
                    };
                }(E.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    t.loadFile = function(t, e, n) {
                        return function(t, e, n) {
                            e = !1 !== e, n = "function" == typeof n ? n : function() {};
                            var r = void 0;
                            try {
                                r = function(t, e, n) {
                                    var r = new XMLHttpRequest, i = 0, a = function(t) {
                                        var e = t.length, n = [], r = String.fromCharCode;
                                        for(i = 0; i < e; i += 1)n.push(r(255 & t.charCodeAt(i)));
                                        return n.join("");
                                    };
                                    if (r.open("GET", t, !e), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (r.onload = function() {
                                        200 === r.status ? n(a(this.responseText)) : n(void 0);
                                    }), r.send(null), e && 200 === r.status) return a(r.responseText);
                                }(t, e, n);
                            } catch (i) {}
                            return r;
                        }(t, e, n);
                    }, t.allowFsRead = void 0, t.loadImageFile = t.loadFile;
                }(E.API), function(e) {
                    function n() {
                        return (i.html2canvas ? Promise.resolve(i.html2canvas) : Promise.resolve().then(__webpack_require__.t.bind(__webpack_require__, /*! html2canvas */ "html2canvas", 23))).catch(function(t) {
                            return Promise.reject(new Error("Could not load html2canvas: " + t));
                        }).then(function(t) {
                            return t.default ? t.default : t;
                        });
                    }
                    function r() {
                        return (i.DOMPurify ? Promise.resolve(i.DOMPurify) : Promise.resolve().then(__webpack_require__.bind(__webpack_require__, /*! dompurify */ "./node_modules/dompurify/dist/purify.es.mjs"))).catch(function(t) {
                            return Promise.reject(new Error("Could not load dompurify: " + t));
                        }).then(function(t) {
                            return t.default ? t.default : t;
                        });
                    }
                    var a = function(e) {
                        var n = (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e);
                        return "undefined" === n ? "undefined" : "string" === n || e instanceof String ? "string" : "number" === n || e instanceof Number ? "number" : "function" === n || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && 1 === e.nodeType ? "element" : "object" === n ? "object" : "unknown";
                    }, o = function(t, e) {
                        var n = document.createElement(t);
                        for(var r in e.className && (n.className = e.className), e.innerHTML && e.dompurify && (n.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)n.style[r] = e.style[r];
                        return n;
                    }, s = function t(e, n) {
                        for(var r = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling)!0 !== n && 1 === i.nodeType && "SCRIPT" === i.nodeName || r.appendChild(t(i, n));
                        return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (r.width = e.width, r.height = e.height, r.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (r.value = e.value), r.addEventListener("load", function() {
                            r.scrollTop = e.scrollTop, r.scrollLeft = e.scrollLeft;
                        }, !0)), r;
                    }, u = function t(e) {
                        var n = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), r = t.convert(Promise.resolve(), n);
                        return (r = r.setProgress(1, t, 1, [
                            t
                        ])).set(e);
                    };
                    (u.prototype = Object.create(Promise.prototype)).constructor = u, u.convert = function(t, e) {
                        return t.__proto__ = e || u.prototype, t;
                    }, u.template = {
                        prop: {
                            src: null,
                            container: null,
                            overlay: null,
                            canvas: null,
                            img: null,
                            pdf: null,
                            pageSize: null,
                            callback: function() {}
                        },
                        progress: {
                            val: 0,
                            state: null,
                            n: 0,
                            stack: []
                        },
                        opt: {
                            filename: "file.pdf",
                            margin: [
                                0,
                                0,
                                0,
                                0
                            ],
                            enableLinks: !0,
                            x: 0,
                            y: 0,
                            html2canvas: {},
                            jsPDF: {},
                            backgroundColor: "transparent"
                        }
                    }, u.prototype.from = function(t, e) {
                        return this.then(function() {
                            switch(e = e || function(t) {
                                switch(a(t)){
                                    case "string":
                                        return "string";
                                    case "element":
                                        return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
                                    default:
                                        return "unknown";
                                }
                            }(t), e){
                                case "string":
                                    return this.then(r).then(function(e) {
                                        return this.set({
                                            src: o("div", {
                                                innerHTML: t,
                                                dompurify: e
                                            })
                                        });
                                    });
                                case "element":
                                    return this.set({
                                        src: t
                                    });
                                case "canvas":
                                    return this.set({
                                        canvas: t
                                    });
                                case "img":
                                    return this.set({
                                        img: t
                                    });
                                default:
                                    return this.error("Unknown source type.");
                            }
                        });
                    }, u.prototype.to = function(t) {
                        switch(t){
                            case "container":
                                return this.toContainer();
                            case "canvas":
                                return this.toCanvas();
                            case "img":
                                return this.toImg();
                            case "pdf":
                                return this.toPdf();
                            default:
                                return this.error("Invalid target.");
                        }
                    }, u.prototype.toContainer = function() {
                        return this.thenList([
                            function() {
                                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
                            },
                            function() {
                                return this.prop.pageSize || this.setPageSize();
                            }
                        ]).then(function() {
                            var t = {
                                position: "relative",
                                display: "inline-block",
                                width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
                                left: 0,
                                right: 0,
                                top: 0,
                                margin: "auto",
                                backgroundColor: this.opt.backgroundColor
                            }, e = s(this.prop.src, this.opt.html2canvas.javascriptEnabled);
                            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o("div", {
                                className: "html2pdf__overlay",
                                style: {
                                    position: "fixed",
                                    overflow: "hidden",
                                    zIndex: 1e3,
                                    left: "-100000px",
                                    right: 0,
                                    bottom: 0,
                                    top: 0
                                }
                            }), this.prop.container = o("div", {
                                className: "html2pdf__container",
                                style: t
                            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(o("div", {
                                style: {
                                    clear: "both",
                                    border: "0 none transparent",
                                    margin: 0,
                                    padding: 0,
                                    height: 0
                                }
                            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
                        });
                    }, u.prototype.toCanvas = function() {
                        var t = [
                            function() {
                                return document.body.contains(this.prop.container) || this.toContainer();
                            }
                        ];
                        return this.thenList(t).then(n).then(function(t) {
                            var e = Object.assign({}, this.opt.html2canvas);
                            return delete e.onrendered, t(this.prop.container, e);
                        }).then(function(t) {
                            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
                        });
                    }, u.prototype.toContext2d = function() {
                        var t = [
                            function() {
                                return document.body.contains(this.prop.container) || this.toContainer();
                            }
                        ];
                        return this.thenList(t).then(n).then(function(t) {
                            var e = this.opt.jsPDF, n = this.opt.fontFaces, r = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i = Object.assign({
                                async: !0,
                                allowTaint: !0,
                                scale: r,
                                scrollX: this.opt.scrollX || 0,
                                scrollY: this.opt.scrollY || 0,
                                backgroundColor: "#ffffff",
                                imageTimeout: 15e3,
                                logging: !0,
                                proxy: null,
                                removeContainer: !0,
                                foreignObjectRendering: !1,
                                useCORS: !1
                            }, this.opt.html2canvas);
                            if (delete i.onrendered, e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, e.context2d.margin = this.opt.margin, e.context2d.fontFaces = n, n) for(var a = 0; a < n.length; ++a){
                                var o = n[a], s = o.src.find(function(t) {
                                    return "truetype" === t.format;
                                });
                                s && e.addFont(s.url, o.ref.name, o.ref.style);
                            }
                            return i.windowHeight = i.windowHeight || 0, i.windowHeight = 0 == i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, e.context2d.save(!0), t(this.prop.container, i);
                        }).then(function(t) {
                            this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
                        });
                    }, u.prototype.toImg = function() {
                        return this.thenList([
                            function() {
                                return this.prop.canvas || this.toCanvas();
                            }
                        ]).then(function() {
                            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
                            this.prop.img = document.createElement("img"), this.prop.img.src = t;
                        });
                    }, u.prototype.toPdf = function() {
                        return this.thenList([
                            function() {
                                return this.toContext2d();
                            }
                        ]).then(function() {
                            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
                        });
                    }, u.prototype.output = function(t, e, n) {
                        return "img" === (n = n || "pdf").toLowerCase() || "image" === n.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
                    }, u.prototype.outputPdf = function(t, e) {
                        return this.thenList([
                            function() {
                                return this.prop.pdf || this.toPdf();
                            }
                        ]).then(function() {
                            return this.prop.pdf.output(t, e);
                        });
                    }, u.prototype.outputImg = function(t) {
                        return this.thenList([
                            function() {
                                return this.prop.img || this.toImg();
                            }
                        ]).then(function() {
                            switch(t){
                                case void 0:
                                case "img":
                                    return this.prop.img;
                                case "datauristring":
                                case "dataurlstring":
                                    return this.prop.img.src;
                                case "datauri":
                                case "dataurl":
                                    return document.location.href = this.prop.img.src;
                                default:
                                    throw 'Image output type "' + t + '" is not supported.';
                            }
                        });
                    }, u.prototype.save = function(t) {
                        return this.thenList([
                            function() {
                                return this.prop.pdf || this.toPdf();
                            }
                        ]).set(t ? {
                            filename: t
                        } : null).then(function() {
                            this.prop.pdf.save(this.opt.filename);
                        });
                    }, u.prototype.doCallback = function() {
                        return this.thenList([
                            function() {
                                return this.prop.pdf || this.toPdf();
                            }
                        ]).then(function() {
                            this.prop.callback(this.prop.pdf);
                        });
                    }, u.prototype.set = function(t) {
                        if ("object" !== a(t)) return this;
                        var e = Object.keys(t || {}).map(function(e) {
                            if (e in u.template.prop) return function() {
                                this.prop[e] = t[e];
                            };
                            switch(e){
                                case "margin":
                                    return this.setMargin.bind(this, t.margin);
                                case "jsPDF":
                                    return function() {
                                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                                    };
                                case "pageSize":
                                    return this.setPageSize.bind(this, t.pageSize);
                                default:
                                    return function() {
                                        this.opt[e] = t[e];
                                    };
                            }
                        }, this);
                        return this.then(function() {
                            return this.thenList(e);
                        });
                    }, u.prototype.get = function(t, e) {
                        return this.then(function() {
                            var n = t in u.template.prop ? this.prop[t] : this.opt[t];
                            return e ? e(n) : n;
                        });
                    }, u.prototype.setMargin = function(t) {
                        return this.then(function() {
                            switch(a(t)){
                                case "number":
                                    t = [
                                        t,
                                        t,
                                        t,
                                        t
                                    ];
                                case "array":
                                    if (2 === t.length && (t = [
                                        t[0],
                                        t[1],
                                        t[0],
                                        t[1]
                                    ]), 4 === t.length) break;
                                default:
                                    return this.error("Invalid margin array.");
                            }
                            this.opt.margin = t;
                        }).then(this.setPageSize);
                    }, u.prototype.setPageSize = function(t) {
                        function e(t, e) {
                            return Math.floor(t * e / 72 * 96);
                        }
                        return this.then(function() {
                            (t = t || E.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                                height: t.height - this.opt.margin[0] - this.opt.margin[2]
                            }, t.inner.px = {
                                width: e(t.inner.width, t.k),
                                height: e(t.inner.height, t.k)
                            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
                        });
                    }, u.prototype.setProgress = function(t, e, n, r) {
                        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != n && (this.progress.n = n), null != r && (this.progress.stack = r), this.progress.ratio = this.progress.val / this.progress.state, this;
                    }, u.prototype.updateProgress = function(t, e, n, r) {
                        return this.setProgress(t ? this.progress.val + t : null, e || null, n ? this.progress.n + n : null, r ? this.progress.stack.concat(r) : null);
                    }, u.prototype.then = function(t, e) {
                        var n = this;
                        return this.thenCore(t, e, function(t, e) {
                            return n.updateProgress(null, null, 1, [
                                t
                            ]), Promise.prototype.then.call(this, function(e) {
                                return n.updateProgress(null, t), e;
                            }).then(t, e).then(function(t) {
                                return n.updateProgress(1), t;
                            });
                        });
                    }, u.prototype.thenCore = function(t, e, n) {
                        n = n || Promise.prototype.then;
                        var r = this;
                        t && (t = t.bind(r)), e && (e = e.bind(r));
                        var i = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? r : u.convert(Object.assign({}, r), Promise.prototype), a = n.call(i, t, e);
                        return u.convert(a, r.__proto__);
                    }, u.prototype.thenExternal = function(t, e) {
                        return Promise.prototype.then.call(this, t, e);
                    }, u.prototype.thenList = function(t) {
                        var e = this;
                        return t.forEach(function(t) {
                            e = e.thenCore(t);
                        }), e;
                    }, u.prototype.catch = function(t) {
                        t && (t = t.bind(this));
                        var e = Promise.prototype.catch.call(this, t);
                        return u.convert(e, this);
                    }, u.prototype.catchExternal = function(t) {
                        return Promise.prototype.catch.call(this, t);
                    }, u.prototype.error = function(t) {
                        return this.then(function() {
                            throw new Error(t);
                        });
                    }, u.prototype.using = u.prototype.set, u.prototype.saveAs = u.prototype.save, u.prototype.export = u.prototype.output, u.prototype.run = u.prototype.then, E.getPageSize = function(e, n, r) {
                        if ("object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e)) {
                            var i = e;
                            e = i.orientation, n = i.unit || n, r = i.format || r;
                        }
                        n = n || "mm", r = r || "a4", e = ("" + (e || "P")).toLowerCase();
                        var a, o = ("" + r).toLowerCase(), s = {
                            a0: [
                                2383.94,
                                3370.39
                            ],
                            a1: [
                                1683.78,
                                2383.94
                            ],
                            a2: [
                                1190.55,
                                1683.78
                            ],
                            a3: [
                                841.89,
                                1190.55
                            ],
                            a4: [
                                595.28,
                                841.89
                            ],
                            a5: [
                                419.53,
                                595.28
                            ],
                            a6: [
                                297.64,
                                419.53
                            ],
                            a7: [
                                209.76,
                                297.64
                            ],
                            a8: [
                                147.4,
                                209.76
                            ],
                            a9: [
                                104.88,
                                147.4
                            ],
                            a10: [
                                73.7,
                                104.88
                            ],
                            b0: [
                                2834.65,
                                4008.19
                            ],
                            b1: [
                                2004.09,
                                2834.65
                            ],
                            b2: [
                                1417.32,
                                2004.09
                            ],
                            b3: [
                                1000.63,
                                1417.32
                            ],
                            b4: [
                                708.66,
                                1000.63
                            ],
                            b5: [
                                498.9,
                                708.66
                            ],
                            b6: [
                                354.33,
                                498.9
                            ],
                            b7: [
                                249.45,
                                354.33
                            ],
                            b8: [
                                175.75,
                                249.45
                            ],
                            b9: [
                                124.72,
                                175.75
                            ],
                            b10: [
                                87.87,
                                124.72
                            ],
                            c0: [
                                2599.37,
                                3676.54
                            ],
                            c1: [
                                1836.85,
                                2599.37
                            ],
                            c2: [
                                1298.27,
                                1836.85
                            ],
                            c3: [
                                918.43,
                                1298.27
                            ],
                            c4: [
                                649.13,
                                918.43
                            ],
                            c5: [
                                459.21,
                                649.13
                            ],
                            c6: [
                                323.15,
                                459.21
                            ],
                            c7: [
                                229.61,
                                323.15
                            ],
                            c8: [
                                161.57,
                                229.61
                            ],
                            c9: [
                                113.39,
                                161.57
                            ],
                            c10: [
                                79.37,
                                113.39
                            ],
                            dl: [
                                311.81,
                                623.62
                            ],
                            letter: [
                                612,
                                792
                            ],
                            "government-letter": [
                                576,
                                756
                            ],
                            legal: [
                                612,
                                1008
                            ],
                            "junior-legal": [
                                576,
                                360
                            ],
                            ledger: [
                                1224,
                                792
                            ],
                            tabloid: [
                                792,
                                1224
                            ],
                            "credit-card": [
                                153,
                                243
                            ]
                        };
                        switch(n){
                            case "pt":
                                a = 1;
                                break;
                            case "mm":
                                a = 72 / 25.4;
                                break;
                            case "cm":
                                a = 72 / 2.54;
                                break;
                            case "in":
                                a = 72;
                                break;
                            case "px":
                                a = .75;
                                break;
                            case "pc":
                            case "em":
                                a = 12;
                                break;
                            case "ex":
                                a = 6;
                                break;
                            default:
                                throw "Invalid unit: " + n;
                        }
                        var u, c = 0, l = 0;
                        if (s.hasOwnProperty(o)) c = s[o][1] / a, l = s[o][0] / a;
                        else try {
                            c = r[1], l = r[0];
                        } catch (h) {
                            throw new Error("Invalid format: " + r);
                        }
                        if ("p" === e || "portrait" === e) e = "p", l > c && (u = l, l = c, c = u);
                        else {
                            if ("l" !== e && "landscape" !== e) throw "Invalid orientation: " + e;
                            e = "l", c > l && (u = l, l = c, c = u);
                        }
                        return {
                            width: l,
                            height: c,
                            unit: n,
                            k: a,
                            orientation: e
                        };
                    }, e.html = function(t, e) {
                        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map(Ct) : null;
                        var n = new u(e);
                        return e.worker ? n : n.from(t).doCallback();
                    };
                }(E.API), E.API.addJS = function(t) {
                    return Ut = t, this.internal.events.subscribe("postPutResources", function() {
                        Tt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (Tt + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), zt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + Ut + ")"), this.internal.out(">>"), this.internal.out("endobj");
                    }), this.internal.events.subscribe("putCatalog", function() {
                        void 0 !== Tt && void 0 !== zt && this.internal.out("/Names <</JavaScript " + Tt + " 0 R>>");
                    }), this;
                }, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    var e;
                    t.events.push([
                        "postPutResources",
                        function() {
                            var t = this, n = /^(\d+) 0 obj$/;
                            if (this.outline.root.children.length > 0) for(var r = t.outline.render().split(/\r\n/), i = 0; i < r.length; i++){
                                var a = r[i], o = n.exec(a);
                                if (null != o) {
                                    var s = o[1];
                                    t.internal.newObjectDeferredBegin(s, !1);
                                }
                                t.internal.write(a);
                            }
                            if (this.outline.createNamedDestinations) {
                                var u = this.internal.pages.length, c = [];
                                for(i = 0; i < u; i++){
                                    var l = t.internal.newObject();
                                    c.push(l);
                                    var h = t.internal.getPageInfo(i + 1);
                                    t.internal.write("<< /D[" + h.objId + " 0 R /XYZ null null null]>> endobj");
                                }
                                var f = t.internal.newObject();
                                for(t.internal.write("<< /Names [ "), i = 0; i < c.length; i++)t.internal.write("(page_" + (i + 1) + ")" + c[i] + " 0 R");
                                t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
                            }
                        }
                    ]), t.events.push([
                        "putCatalog",
                        function() {
                            var t = this;
                            t.outline.root.children.length > 0 && (t.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && t.internal.write("/Names " + e + " 0 R"));
                        }
                    ]), t.events.push([
                        "initialized",
                        function() {
                            var t = this;
                            t.outline = {
                                createNamedDestinations: !1,
                                root: {
                                    children: []
                                }
                            }, t.outline.add = function(t, e, n) {
                                var r = {
                                    title: e,
                                    options: n,
                                    children: []
                                };
                                return null == t && (t = this.root), t.children.push(r), r;
                            }, t.outline.render = function() {
                                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
                            }, t.outline.genIds_r = function(e) {
                                e.id = t.internal.newObjectDeferred();
                                for(var n = 0; n < e.children.length; n++)this.genIds_r(e.children[n]);
                            }, t.outline.renderRoot = function(t) {
                                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                                    count: 0
                                }, t)), this.objEnd();
                            }, t.outline.renderItems = function(e) {
                                for(var n = this.ctx.pdf.internal.getVerticalCoordinateString, r = 0; r < e.children.length; r++){
                                    var i = e.children[r];
                                    this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), r > 0 && this.line("/Prev " + this.makeRef(e.children[r - 1])), r < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[r + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
                                    var a = this.count = this.count_r({
                                        count: 0
                                    }, i);
                                    if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
                                        var o = t.internal.getPageInfo(i.options.pageNumber);
                                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
                                    }
                                    this.objEnd();
                                }
                                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
                            }, t.outline.line = function(t) {
                                this.ctx.val += t + "\r\n";
                            }, t.outline.makeRef = function(t) {
                                return t.id + " 0 R";
                            }, t.outline.makeString = function(e) {
                                return "(" + t.internal.pdfEscape(e) + ")";
                            }, t.outline.objStart = function(t) {
                                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
                            }, t.outline.objEnd = function() {
                                this.ctx.val += ">> \r\nendobj\r\n";
                            }, t.outline.count_r = function(t, e) {
                                for(var n = 0; n < e.children.length; n++)t.count++, this.count_r(t, e.children[n]);
                                return t.count;
                            };
                        }
                    ]);
                }(E.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    var e = [
                        192,
                        193,
                        194,
                        195,
                        196,
                        197,
                        198,
                        199
                    ];
                    t.processJPEG = function(t, n, r, i, a, o) {
                        var s, u = this.decode.DCT_DECODE, c = null;
                        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
                            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, s = function(t) {
                                for(var n, r = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
                                    width: 0,
                                    height: 0,
                                    numcomponents: 1
                                }, o = 4; o < i; o += 2){
                                    if (o += r, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
                                        n = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                                            width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                                            height: n,
                                            numcomponents: t.charCodeAt(o + 9)
                                        };
                                        break;
                                    }
                                    r = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                                }
                                return a;
                            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t), s.numcomponents){
                                case 1:
                                    o = this.color_spaces.DEVICE_GRAY;
                                    break;
                                case 4:
                                    o = this.color_spaces.DEVICE_CMYK;
                                    break;
                                case 3:
                                    o = this.color_spaces.DEVICE_RGB;
                            }
                            c = {
                                data: t,
                                width: s.width,
                                height: s.height,
                                colorSpace: o,
                                bitsPerComponent: 8,
                                filter: u,
                                index: n,
                                alias: r
                            };
                        }
                        return c;
                    };
                }(E.API), E.API.processPNG = function(t, i, a, o) {
                    if (this.__addimage__.isArrayBuffer(t) && (t = new Uint8Array(t)), this.__addimage__.isArrayBufferView(t)) {
                        var s, u = (0, fast_png__WEBPACK_IMPORTED_MODULE_3__.decode)(t, {
                            checkCrc: !0
                        }), c = u.width, l = u.height, h = u.channels, f = u.palette, d = u.depth;
                        s = f && 1 === h ? function(t) {
                            for(var e = t.width, r = t.height, i = t.data, a = t.palette, o = t.depth, s = !1, u = [], c = [], l = void 0, h = !1, f = 0, d = 0; d < a.length; d++){
                                var p = (0, _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__["default"])(a[d], 4), g = p[0], m = p[1], v = p[2], b = p[3];
                                u.push(g, m, v), null != b && (0 === b ? (f++, c.length < 1 && c.push(d)) : b < 255 && (h = !0));
                            }
                            if (h || f > 1) {
                                s = !0, c = void 0;
                                var y = e * r;
                                l = new Uint8Array(y);
                                for(var w = new DataView(i.buffer), N = 0; N < y; N++){
                                    var L = re(w, N, o), x = (0, _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__["default"])(a[L], 4)[3];
                                    l[N] = x;
                                }
                            } else 0 === f && (c = void 0);
                            return {
                                colorSpace: "Indexed",
                                colorsPerPixel: 1,
                                sMaskBitsPerComponent: s ? 8 : void 0,
                                colorBytes: i,
                                alphaBytes: l,
                                needSMask: s,
                                palette: u,
                                mask: c
                            };
                        }(u) : 2 === h || 4 === h ? function(t) {
                            for(var e = t.data, n = t.width, r = t.height, i = t.channels, a = t.depth, o = 2 === i ? "DeviceGray" : "DeviceRGB", s = i - 1, u = n * r, c = s, l = u * c, h = 1 * u, f = Math.ceil(l * a / 8), d = Math.ceil(h * a / 8), p = new Uint8Array(f), g = new Uint8Array(d), m = new DataView(e.buffer), v = new DataView(p.buffer), b = new DataView(g.buffer), y = !1, w = 0; w < u; w++){
                                for(var N = w * i, L = 0; L < c; L++)ie(v, re(m, N + L, a), w * c + L, a);
                                var x = re(m, N + c, a);
                                x < (1 << a) - 1 && (y = !0), ie(b, x, 1 * w, a);
                            }
                            return {
                                colorSpace: o,
                                colorsPerPixel: s,
                                sMaskBitsPerComponent: y ? a : void 0,
                                colorBytes: p,
                                alphaBytes: g,
                                needSMask: y
                            };
                        }(u) : function(t) {
                            var e = t.data, n = 1 === t.channels ? "DeviceGray" : "DeviceRGB";
                            return {
                                colorSpace: n,
                                colorsPerPixel: "DeviceGray" === n ? 1 : 3,
                                colorBytes: e instanceof Uint16Array ? function(t) {
                                    for(var e = t.length, n = new Uint8Array(2 * e), r = new DataView(n.buffer, n.byteOffset, n.byteLength), i = 0; i < e; i++)r.setUint16(2 * i, t[i], !1);
                                    return n;
                                }(e) : e,
                                needSMask: !1
                            };
                        }(u);
                        var p, g, m, v = s, b = v.colorSpace, y = v.colorsPerPixel, w = v.sMaskBitsPerComponent, N = v.colorBytes, L = v.alphaBytes, x = v.needSMask, A = v.palette, S = v.mask, _ = null;
                        return o !== E.API.image_compression.NONE && "function" == typeof fflate__WEBPACK_IMPORTED_MODULE_1__.zlibSync ? (_ = function(t) {
                            var e;
                            switch(t){
                                case E.API.image_compression.FAST:
                                    e = 11;
                                    break;
                                case E.API.image_compression.MEDIUM:
                                    e = 13;
                                    break;
                                case E.API.image_compression.SLOW:
                                    e = 14;
                                    break;
                                default:
                                    e = 12;
                            }
                            return e;
                        }(o), p = this.decode.FLATE_DECODE, g = "/Predictor ".concat(_, " /Colors ").concat(y, " /BitsPerComponent ").concat(d, " /Columns ").concat(c), t = Xt(N, Math.ceil(c * y * d / 8), y, d, o), x && (m = Xt(L, Math.ceil(c * w / 8), 1, w, o))) : (p = void 0, g = void 0, t = N, x && (m = L)), (this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) && (t = this.__addimage__.arrayBufferToBinaryString(t)), (m && this.__addimage__.isArrayBuffer(m) || this.__addimage__.isArrayBufferView(m)) && (m = this.__addimage__.arrayBufferToBinaryString(m)), {
                            alias: a,
                            data: t,
                            index: i,
                            filter: p,
                            decodeParameters: g,
                            transparency: S,
                            palette: A,
                            sMask: m,
                            predictor: _,
                            width: c,
                            height: l,
                            bitsPerComponent: d,
                            sMaskBitsPerComponent: w,
                            colorSpace: b
                        };
                    }
                }, function(t) {
                    t.processGIF89A = function(e, n, r, i) {
                        var a = new oe(e), o = a.width, s = a.height, u = [];
                        a.decodeAndBlitFrameRGBA(0, u);
                        var c = {
                            data: u,
                            width: o,
                            height: s
                        }, l = new ue(100).encode(c, 100);
                        return t.processJPEG.call(this, l, n, r, i);
                    }, t.processGIF87A = t.processGIF89A;
                }(E.API), ce.prototype.parseHeader = function() {
                    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
                        var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
                        this.palette = new Array(t);
                        for(var e = 0; e < t; e++){
                            var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
                            this.palette[e] = {
                                red: i,
                                green: r,
                                blue: n,
                                quad: a
                            };
                        }
                    }
                    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
                }, ce.prototype.parseBGR = function() {
                    this.pos = this.offset;
                    try {
                        var t = "bit" + this.bitPP, e = this.width * this.height * 4;
                        this.data = new Uint8Array(e), this[t]();
                    } catch (n) {
                        o.log("bit decode error:" + n);
                    }
                }, ce.prototype.bit1 = function() {
                    var t, e = Math.ceil(this.width / 8), n = e % 4;
                    for(t = this.height - 1; t >= 0; t--){
                        for(var r = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++)for(var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
                            var u = this.palette[a >> 7 - s & 1];
                            this.data[o + 4 * s] = u.blue, this.data[o + 4 * s + 1] = u.green, this.data[o + 4 * s + 2] = u.red, this.data[o + 4 * s + 3] = 255;
                        }
                        0 !== n && (this.pos += 4 - n);
                    }
                }, ce.prototype.bit4 = function() {
                    for(var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; n >= 0; n--){
                        for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++){
                            var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 2 * i * 4, s = a >> 4, u = 15 & a, c = this.palette[s];
                            if (this.data[o] = c.blue, this.data[o + 1] = c.green, this.data[o + 2] = c.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
                            c = this.palette[u], this.data[o + 4] = c.blue, this.data[o + 4 + 1] = c.green, this.data[o + 4 + 2] = c.red, this.data[o + 4 + 3] = 255;
                        }
                        0 !== e && (this.pos += 4 - e);
                    }
                }, ce.prototype.bit8 = function() {
                    for(var t = this.width % 4, e = this.height - 1; e >= 0; e--){
                        for(var n = this.bottom_up ? e : this.height - 1 - e, r = 0; r < this.width; r++){
                            var i = this.datav.getUint8(this.pos++, !0), a = n * this.width * 4 + 4 * r;
                            if (i < this.palette.length) {
                                var o = this.palette[i];
                                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
                            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
                        }
                        0 !== t && (this.pos += 4 - t);
                    }
                }, ce.prototype.bit15 = function() {
                    for(var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; n >= 0; n--){
                        for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++){
                            var a = this.datav.getUint16(this.pos, !0);
                            this.pos += 2;
                            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, u = (a >> 10 & e) / e * 255 | 0, c = a >> 15 ? 255 : 0, l = r * this.width * 4 + 4 * i;
                            this.data[l] = u, this.data[l + 1] = s, this.data[l + 2] = o, this.data[l + 3] = c;
                        }
                        this.pos += t;
                    }
                }, ce.prototype.bit16 = function() {
                    for(var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; r >= 0; r--){
                        for(var i = this.bottom_up ? r : this.height - 1 - r, a = 0; a < this.width; a++){
                            var o = this.datav.getUint16(this.pos, !0);
                            this.pos += 2;
                            var s = (o & e) / e * 255 | 0, u = (o >> 5 & n) / n * 255 | 0, c = (o >> 11) / e * 255 | 0, l = i * this.width * 4 + 4 * a;
                            this.data[l] = c, this.data[l + 1] = u, this.data[l + 2] = s, this.data[l + 3] = 255;
                        }
                        this.pos += t;
                    }
                }, ce.prototype.bit24 = function() {
                    for(var t = this.height - 1; t >= 0; t--){
                        for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
                            var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * n;
                            this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = r, this.data[o + 3] = 255;
                        }
                        this.pos += this.width % 4;
                    }
                }, ce.prototype.bit32 = function() {
                    for(var t = this.height - 1; t >= 0; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
                        var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
                        this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = o;
                    }
                }, ce.prototype.getData = function() {
                    return this.data;
                }, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    t.processBMP = function(e, n, r, i) {
                        var a = new ce(e, !1), o = a.width, s = a.height, u = {
                            data: a.getData(),
                            width: o,
                            height: s
                        }, c = new ue(100).encode(u, 100);
                        return t.processJPEG.call(this, c, n, r, i);
                    };
                }(E.API), le.prototype.getData = function() {
                    return this.data;
                }, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    t.processWEBP = function(e, n, r, i) {
                        var a = new le(e), o = a.width, s = a.height, u = {
                            data: a.getData(),
                            width: o,
                            height: s
                        }, c = new ue(100).encode(u, 100);
                        return t.processJPEG.call(this, c, n, r, i);
                    };
                }(E.API), E.API.processRGBA = function(t, e, n) {
                    for(var r = t.data, i = r.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, u = 0, c = 0; c < i; c += 4){
                        var l = r[c], h = r[c + 1], f = r[c + 2], d = r[c + 3];
                        a[s++] = l, a[s++] = h, a[s++] = f, o[u++] = d;
                    }
                    var p = this.__addimage__.arrayBufferToBinaryString(a);
                    return {
                        alpha: this.__addimage__.arrayBufferToBinaryString(o),
                        data: p,
                        index: e,
                        alias: n,
                        colorSpace: "DeviceRGB",
                        bitsPerComponent: 8,
                        width: t.width,
                        height: t.height
                    };
                }, E.API.setLanguage = function(t) {
                    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
                        af: "Afrikaans",
                        sq: "Albanian",
                        ar: "Arabic (Standard)",
                        "ar-DZ": "Arabic (Algeria)",
                        "ar-BH": "Arabic (Bahrain)",
                        "ar-EG": "Arabic (Egypt)",
                        "ar-IQ": "Arabic (Iraq)",
                        "ar-JO": "Arabic (Jordan)",
                        "ar-KW": "Arabic (Kuwait)",
                        "ar-LB": "Arabic (Lebanon)",
                        "ar-LY": "Arabic (Libya)",
                        "ar-MA": "Arabic (Morocco)",
                        "ar-OM": "Arabic (Oman)",
                        "ar-QA": "Arabic (Qatar)",
                        "ar-SA": "Arabic (Saudi Arabia)",
                        "ar-SY": "Arabic (Syria)",
                        "ar-TN": "Arabic (Tunisia)",
                        "ar-AE": "Arabic (U.A.E.)",
                        "ar-YE": "Arabic (Yemen)",
                        an: "Aragonese",
                        hy: "Armenian",
                        as: "Assamese",
                        ast: "Asturian",
                        az: "Azerbaijani",
                        eu: "Basque",
                        be: "Belarusian",
                        bn: "Bengali",
                        bs: "Bosnian",
                        br: "Breton",
                        bg: "Bulgarian",
                        my: "Burmese",
                        ca: "Catalan",
                        ch: "Chamorro",
                        ce: "Chechen",
                        zh: "Chinese",
                        "zh-HK": "Chinese (Hong Kong)",
                        "zh-CN": "Chinese (PRC)",
                        "zh-SG": "Chinese (Singapore)",
                        "zh-TW": "Chinese (Taiwan)",
                        cv: "Chuvash",
                        co: "Corsican",
                        cr: "Cree",
                        hr: "Croatian",
                        cs: "Czech",
                        da: "Danish",
                        nl: "Dutch (Standard)",
                        "nl-BE": "Dutch (Belgian)",
                        en: "English",
                        "en-AU": "English (Australia)",
                        "en-BZ": "English (Belize)",
                        "en-CA": "English (Canada)",
                        "en-IE": "English (Ireland)",
                        "en-JM": "English (Jamaica)",
                        "en-NZ": "English (New Zealand)",
                        "en-PH": "English (Philippines)",
                        "en-ZA": "English (South Africa)",
                        "en-TT": "English (Trinidad & Tobago)",
                        "en-GB": "English (United Kingdom)",
                        "en-US": "English (United States)",
                        "en-ZW": "English (Zimbabwe)",
                        eo: "Esperanto",
                        et: "Estonian",
                        fo: "Faeroese",
                        fj: "Fijian",
                        fi: "Finnish",
                        fr: "French (Standard)",
                        "fr-BE": "French (Belgium)",
                        "fr-CA": "French (Canada)",
                        "fr-FR": "French (France)",
                        "fr-LU": "French (Luxembourg)",
                        "fr-MC": "French (Monaco)",
                        "fr-CH": "French (Switzerland)",
                        fy: "Frisian",
                        fur: "Friulian",
                        gd: "Gaelic (Scots)",
                        "gd-IE": "Gaelic (Irish)",
                        gl: "Galacian",
                        ka: "Georgian",
                        de: "German (Standard)",
                        "de-AT": "German (Austria)",
                        "de-DE": "German (Germany)",
                        "de-LI": "German (Liechtenstein)",
                        "de-LU": "German (Luxembourg)",
                        "de-CH": "German (Switzerland)",
                        el: "Greek",
                        gu: "Gujurati",
                        ht: "Haitian",
                        he: "Hebrew",
                        hi: "Hindi",
                        hu: "Hungarian",
                        is: "Icelandic",
                        id: "Indonesian",
                        iu: "Inuktitut",
                        ga: "Irish",
                        it: "Italian (Standard)",
                        "it-CH": "Italian (Switzerland)",
                        ja: "Japanese",
                        kn: "Kannada",
                        ks: "Kashmiri",
                        kk: "Kazakh",
                        km: "Khmer",
                        ky: "Kirghiz",
                        tlh: "Klingon",
                        ko: "Korean",
                        "ko-KP": "Korean (North Korea)",
                        "ko-KR": "Korean (South Korea)",
                        la: "Latin",
                        lv: "Latvian",
                        lt: "Lithuanian",
                        lb: "Luxembourgish",
                        mk: "North Macedonia",
                        ms: "Malay",
                        ml: "Malayalam",
                        mt: "Maltese",
                        mi: "Maori",
                        mr: "Marathi",
                        mo: "Moldavian",
                        nv: "Navajo",
                        ng: "Ndonga",
                        ne: "Nepali",
                        no: "Norwegian",
                        nb: "Norwegian (Bokmal)",
                        nn: "Norwegian (Nynorsk)",
                        oc: "Occitan",
                        or: "Oriya",
                        om: "Oromo",
                        fa: "Persian",
                        "fa-IR": "Persian/Iran",
                        pl: "Polish",
                        pt: "Portuguese",
                        "pt-BR": "Portuguese (Brazil)",
                        pa: "Punjabi",
                        "pa-IN": "Punjabi (India)",
                        "pa-PK": "Punjabi (Pakistan)",
                        qu: "Quechua",
                        rm: "Rhaeto-Romanic",
                        ro: "Romanian",
                        "ro-MO": "Romanian (Moldavia)",
                        ru: "Russian",
                        "ru-MO": "Russian (Moldavia)",
                        sz: "Sami (Lappish)",
                        sg: "Sango",
                        sa: "Sanskrit",
                        sc: "Sardinian",
                        sd: "Sindhi",
                        si: "Singhalese",
                        sr: "Serbian",
                        sk: "Slovak",
                        sl: "Slovenian",
                        so: "Somani",
                        sb: "Sorbian",
                        es: "Spanish",
                        "es-AR": "Spanish (Argentina)",
                        "es-BO": "Spanish (Bolivia)",
                        "es-CL": "Spanish (Chile)",
                        "es-CO": "Spanish (Colombia)",
                        "es-CR": "Spanish (Costa Rica)",
                        "es-DO": "Spanish (Dominican Republic)",
                        "es-EC": "Spanish (Ecuador)",
                        "es-SV": "Spanish (El Salvador)",
                        "es-GT": "Spanish (Guatemala)",
                        "es-HN": "Spanish (Honduras)",
                        "es-MX": "Spanish (Mexico)",
                        "es-NI": "Spanish (Nicaragua)",
                        "es-PA": "Spanish (Panama)",
                        "es-PY": "Spanish (Paraguay)",
                        "es-PE": "Spanish (Peru)",
                        "es-PR": "Spanish (Puerto Rico)",
                        "es-ES": "Spanish (Spain)",
                        "es-UY": "Spanish (Uruguay)",
                        "es-VE": "Spanish (Venezuela)",
                        sx: "Sutu",
                        sw: "Swahili",
                        sv: "Swedish",
                        "sv-FI": "Swedish (Finland)",
                        "sv-SV": "Swedish (Sweden)",
                        ta: "Tamil",
                        tt: "Tatar",
                        te: "Teluga",
                        th: "Thai",
                        tig: "Tigre",
                        ts: "Tsonga",
                        tn: "Tswana",
                        tr: "Turkish",
                        tk: "Turkmen",
                        uk: "Ukrainian",
                        hsb: "Upper Sorbian",
                        ur: "Urdu",
                        ve: "Venda",
                        vi: "Vietnamese",
                        vo: "Volapuk",
                        wa: "Walloon",
                        cy: "Welsh",
                        xh: "Xhosa",
                        ji: "Yiddish",
                        zu: "Zulu"
                    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
                        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
                    }), this.internal.languageSettings.isSubscribed = !0)), this;
                }, Ht = E.API, Wt = Ht.getCharWidthsArray = function(e, n) {
                    var r, i, a = (n = n || {}).font || this.internal.getFont(), o = n.fontSize || this.internal.getFontSize(), s = n.charSpace || this.internal.getCharSpace(), u = n.widths ? n.widths : a.metadata.Unicode.widths, c = u.fof ? u.fof : 1, l = n.kerning ? n.kerning : a.metadata.Unicode.kerning, h = l.fof ? l.fof : 1, f = !1 !== n.doKerning, d = 0, p = e.length, g = 0, m = u[0] || c, v = [];
                    for(r = 0; r < p; r++)i = e.charCodeAt(r), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(l[i]) && !isNaN(parseInt(l[i][g], 10)) ? l[i][g] / h : 0, v.push((u[i] || m) / c + d)), g = i;
                    return v;
                }, Vt = Ht.getStringUnitWidth = function(t, e) {
                    var n = (e = e || {}).fontSize || this.internal.getFontSize(), r = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
                    return Ht.processArabic && (t = Ht.processArabic(t)), "function" == typeof r.metadata.widthOfString ? r.metadata.widthOfString(t, n, i) / n : Wt.apply(this, arguments).reduce(function(t, e) {
                        return t + e;
                    }, 0);
                }, Gt = function(t, e, n, r) {
                    for(var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < n;)s += e[a], a++;
                    i.push(t.slice(0, a));
                    var u = a;
                    for(s = 0; a !== o;)s + e[a] > r && (i.push(t.slice(u, a)), s = 0, u = a), s += e[a], a++;
                    return u !== a && i.push(t.slice(u, a)), i;
                }, Yt = function(t, e, n) {
                    n || (n = {});
                    var r, i, a, o, s, u, c, l = [], h = [
                        l
                    ], f = n.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = Wt.apply(this, [
                        " ",
                        n
                    ])[0];
                    if (u = -1 === n.lineIndent ? g[0].length + 2 : n.lineIndent || 0) {
                        var v = Array(u).join(" "), b = [];
                        g.map(function(t) {
                            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                                return (e && t.length ? "\n" : "") + t;
                            })) : b.push(t[0]);
                        }), g = b, u = Vt.apply(this, [
                            v,
                            n
                        ]);
                    }
                    for(a = 0, o = g.length; a < o; a++){
                        var y = 0;
                        if (r = g[a], u && "\n" == r[0] && (r = r.substr(1), y = 1), f + d + (p = (i = Wt.apply(this, [
                            r,
                            n
                        ])).reduce(function(t, e) {
                            return t + e;
                        }, 0)) > e || y) {
                            if (p > e) {
                                for(s = Gt.apply(this, [
                                    r,
                                    i,
                                    e - (f + d),
                                    e
                                ]), l.push(s.shift()), l = [
                                    s.pop()
                                ]; s.length;)h.push([
                                    s.shift()
                                ]);
                                p = i.slice(r.length - (l[0] ? l[0].length : 0)).reduce(function(t, e) {
                                    return t + e;
                                }, 0);
                            } else l = [
                                r
                            ];
                            h.push(l), f = p + u, d = m;
                        } else l.push(r), f += d + p, d = m;
                    }
                    return c = u ? function(t, e) {
                        return (e ? v : "") + t.join(" ");
                    } : function(t) {
                        return t.join(" ");
                    }, h.map(c);
                }, Ht.splitTextToSize = function(t, e, n) {
                    var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
                        if (t.widths && t.kerning) return {
                            widths: t.widths,
                            kerning: t.kerning
                        };
                        var e = this.internal.getFont(t.fontName, t.fontStyle), n = "Unicode";
                        return e.metadata[n] ? {
                            widths: e.metadata[n].widths || {
                                0: 1
                            },
                            kerning: e.metadata[n].kerning || {}
                        } : {
                            font: e.metadata,
                            fontSize: this.internal.getFontSize(),
                            charSpace: this.internal.getCharSpace()
                        };
                    }).call(this, n);
                    r = Array.isArray(t) ? t : String(t).split(/\r?\n/);
                    var o = 1 * this.internal.scaleFactor * e / i;
                    a.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = n.lineIndent;
                    var s, u, c = [];
                    for(s = 0, u = r.length; s < u; s++)c = c.concat(Yt.apply(this, [
                        r[s],
                        o,
                        a
                    ]));
                    return c;
                }, function(e) {
                    e.__fontmetrics__ = e.__fontmetrics__ || {};
                    for(var n = "0123456789abcdef", r = "klmnopqrstuvwxyz", i = {}, a = {}, o = 0; o < 16; o++)i[r[o]] = n[o], a[n[o]] = r[o];
                    var s = function(t) {
                        return "0x" + parseInt(t, 10).toString(16);
                    }, u = e.__fontmetrics__.compress = function(e) {
                        var n, r, i, o, c = [
                            "{"
                        ];
                        for(var l in e){
                            if (n = e[l], isNaN(parseInt(l, 10)) ? r = "'" + l + "'" : (l = parseInt(l, 10), r = (r = s(l).slice(2)).slice(0, -1) + a[r.slice(-1)]), "number" == typeof n) n < 0 ? (i = s(n).slice(3), o = "-") : (i = s(n).slice(2), o = ""), i = o + i.slice(0, -1) + a[i.slice(-1)];
                            else {
                                if ("object" !== (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(n)) throw new Error("Don't know what to do with value type " + (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(n) + ".");
                                i = u(n);
                            }
                            c.push(r + i);
                        }
                        return c.push("}"), c.join("");
                    }, c = e.__fontmetrics__.uncompress = function(t) {
                        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
                        for(var e, n, r, a, o = {}, s = 1, u = o, c = [], l = "", h = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? e ? (r = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (c.push([
                            u,
                            r
                        ]), u = {}, r = void 0) : "}" == a ? ((n = c.pop())[0][n[1]] = u, r = void 0, u = n[0]) : "-" == a ? s = -1 : void 0 === r ? i.hasOwnProperty(a) ? (l += i[a], r = parseInt(l, 16) * s, s = 1, l = "") : l += a : i.hasOwnProperty(a) ? (h += i[a], u[r] = parseInt(h, 16) * s, s = 1, r = void 0, h = "") : h += a;
                        return o;
                    }, l = {
                        codePages: [
                            "WinAnsiEncoding"
                        ],
                        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
                    }, h = {
                        Unicode: {
                            Courier: l,
                            "Courier-Bold": l,
                            "Courier-BoldOblique": l,
                            "Courier-Oblique": l,
                            Helvetica: l,
                            "Helvetica-Bold": l,
                            "Helvetica-BoldOblique": l,
                            "Helvetica-Oblique": l,
                            "Times-Roman": l,
                            "Times-Bold": l,
                            "Times-BoldItalic": l,
                            "Times-Italic": l
                        }
                    }, f = {
                        Unicode: {
                            "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
                            "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
                            "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
                            Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
                            "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
                            "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
                            Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
                            Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
                            "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
                            ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
                            "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
                            "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
                            "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
                            "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
                        }
                    };
                    e.events.push([
                        "addFont",
                        function(t) {
                            var e = t.font, n = f.Unicode[e.postScriptName];
                            n && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = n.widths, e.metadata.Unicode.kerning = n.kerning);
                            var r = h.Unicode[e.postScriptName];
                            r && (e.metadata.Unicode.encoding = r, e.encoding = r.codePages[0]);
                        }
                    ]);
                }(E.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    var e = function(t) {
                        for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
                        return n;
                    };
                    t.API.events.push([
                        "addFont",
                        function(n) {
                            var r = void 0, i = n.font, a = n.instance;
                            if (!i.isStandardFont) {
                                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                                if ("string" != typeof (r = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                                !function(n, r) {
                                    r = /^\x00\x01\x00\x00/.test(r) ? e(r) : e(f(r)), n.metadata = t.API.TTFFont.open(r), n.metadata.Unicode = n.metadata.Unicode || {
                                        encoding: {},
                                        kerning: {},
                                        widths: []
                                    }, n.metadata.glyIdsUsed = [
                                        0
                                    ];
                                }(i, r);
                            }
                        }
                    ]);
                }(E), E.API.addSvgAsImage = function(t, e, n, r, a, s, u, c) {
                    if (isNaN(e) || isNaN(n)) throw o.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
                    if (isNaN(r) || isNaN(a)) throw o.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
                    var l = document.createElement("canvas");
                    l.width = r, l.height = a;
                    var h = l.getContext("2d");
                    h.fillStyle = "#fff", h.fillRect(0, 0, l.width, l.height);
                    var f = {
                        ignoreMouse: !0,
                        ignoreAnimation: !0,
                        ignoreDimensions: !0
                    }, d = this;
                    return (i.canvg ? Promise.resolve(i.canvg) : Promise.resolve().then(__webpack_require__.bind(__webpack_require__, /*! canvg */ "./node_modules/canvg/lib/index.es.js"))).catch(function(t) {
                        return Promise.reject(new Error("Could not load canvg: " + t));
                    }).then(function(t) {
                        return t.default ? t.default : t;
                    }).then(function(e) {
                        return e.fromString(h, t, f);
                    }, function() {
                        return Promise.reject(new Error("Could not load canvg."));
                    }).then(function(t) {
                        return t.render(f);
                    }).then(function() {
                        d.addImage(l.toDataURL("image/jpeg", 1), e, n, r, a, u, c);
                    });
                }, E.API.putTotalPages = function(t) {
                    var e, n = 0;
                    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), n = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), n = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
                    for(var r = 1; r <= this.internal.getNumberOfPages(); r++)for(var i = 0; i < this.internal.pages[r].length; i++)this.internal.pages[r][i] = this.internal.pages[r][i].replace(e, n);
                    return this;
                }, E.API.viewerPreferences = function(e, n) {
                    var r;
                    e = e || {}, n = n || !1;
                    var i, a, o, s = {
                        HideToolbar: {
                            defaultValue: !1,
                            value: !1,
                            type: "boolean",
                            explicitSet: !1,
                            valueSet: [
                                !0,
                                !1
                            ],
                            pdfVersion: 1.3
                        },
                        HideMenubar: {
                            defaultValue: !1,
                            value: !1,
                            type: "boolean",
                            explicitSet: !1,
                            valueSet: [
                                !0,
                                !1
                            ],
                            pdfVersion: 1.3
                        },
                        HideWindowUI: {
                            defaultValue: !1,
                            value: !1,
                            type: "boolean",
                            explicitSet: !1,
                            valueSet: [
                                !0,
                                !1
                            ],
                            pdfVersion: 1.3
                        },
                        FitWindow: {
                            defaultValue: !1,
                            value: !1,
                            type: "boolean",
                            explicitSet: !1,
                            valueSet: [
                                !0,
                                !1
                            ],
                            pdfVersion: 1.3
                        },
                        CenterWindow: {
                            defaultValue: !1,
                            value: !1,
                            type: "boolean",
                            explicitSet: !1,
                            valueSet: [
                                !0,
                                !1
                            ],
                            pdfVersion: 1.3
                        },
                        DisplayDocTitle: {
                            defaultValue: !1,
                            value: !1,
                            type: "boolean",
                            explicitSet: !1,
                            valueSet: [
                                !0,
                                !1
                            ],
                            pdfVersion: 1.4
                        },
                        NonFullScreenPageMode: {
                            defaultValue: "UseNone",
                            value: "UseNone",
                            type: "name",
                            explicitSet: !1,
                            valueSet: [
                                "UseNone",
                                "UseOutlines",
                                "UseThumbs",
                                "UseOC"
                            ],
                            pdfVersion: 1.3
                        },
                        Direction: {
                            defaultValue: "L2R",
                            value: "L2R",
                            type: "name",
                            explicitSet: !1,
                            valueSet: [
                                "L2R",
                                "R2L"
                            ],
                            pdfVersion: 1.3
                        },
                        ViewArea: {
                            defaultValue: "CropBox",
                            value: "CropBox",
                            type: "name",
                            explicitSet: !1,
                            valueSet: [
                                "MediaBox",
                                "CropBox",
                                "TrimBox",
                                "BleedBox",
                                "ArtBox"
                            ],
                            pdfVersion: 1.4
                        },
                        ViewClip: {
                            defaultValue: "CropBox",
                            value: "CropBox",
                            type: "name",
                            explicitSet: !1,
                            valueSet: [
                                "MediaBox",
                                "CropBox",
                                "TrimBox",
                                "BleedBox",
                                "ArtBox"
                            ],
                            pdfVersion: 1.4
                        },
                        PrintArea: {
                            defaultValue: "CropBox",
                            value: "CropBox",
                            type: "name",
                            explicitSet: !1,
                            valueSet: [
                                "MediaBox",
                                "CropBox",
                                "TrimBox",
                                "BleedBox",
                                "ArtBox"
                            ],
                            pdfVersion: 1.4
                        },
                        PrintClip: {
                            defaultValue: "CropBox",
                            value: "CropBox",
                            type: "name",
                            explicitSet: !1,
                            valueSet: [
                                "MediaBox",
                                "CropBox",
                                "TrimBox",
                                "BleedBox",
                                "ArtBox"
                            ],
                            pdfVersion: 1.4
                        },
                        PrintScaling: {
                            defaultValue: "AppDefault",
                            value: "AppDefault",
                            type: "name",
                            explicitSet: !1,
                            valueSet: [
                                "AppDefault",
                                "None"
                            ],
                            pdfVersion: 1.6
                        },
                        Duplex: {
                            defaultValue: "",
                            value: "none",
                            type: "name",
                            explicitSet: !1,
                            valueSet: [
                                "Simplex",
                                "DuplexFlipShortEdge",
                                "DuplexFlipLongEdge",
                                "none"
                            ],
                            pdfVersion: 1.7
                        },
                        PickTrayByPDFSize: {
                            defaultValue: !1,
                            value: !1,
                            type: "boolean",
                            explicitSet: !1,
                            valueSet: [
                                !0,
                                !1
                            ],
                            pdfVersion: 1.7
                        },
                        PrintPageRange: {
                            defaultValue: "",
                            value: "",
                            type: "array",
                            explicitSet: !1,
                            valueSet: null,
                            pdfVersion: 1.7
                        },
                        NumCopies: {
                            defaultValue: 1,
                            value: 1,
                            type: "integer",
                            explicitSet: !1,
                            valueSet: null,
                            pdfVersion: 1.7
                        }
                    }, u = Object.keys(s), c = [], l = 0, h = 0, f = 0;
                    function d(t, e) {
                        var n, r = !1;
                        for(n = 0; n < t.length; n += 1)t[n] === e && (r = !0);
                        return r;
                    }
                    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), r = this.internal.viewerpreferences.configuration, "reset" === e || !0 === n) {
                        var p = u.length;
                        for(f = 0; f < p; f += 1)r[u[f]].value = r[u[f]].defaultValue, r[u[f]].explicitSet = !1;
                    }
                    if ("object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(e)) {
                        for(a in e)if (o = e[a], d(u, a) && void 0 !== o) {
                            if ("boolean" === r[a].type && "boolean" == typeof o) r[a].value = o;
                            else if ("name" === r[a].type && d(r[a].valueSet, o)) r[a].value = o;
                            else if ("integer" === r[a].type && Number.isInteger(o)) r[a].value = o;
                            else if ("array" === r[a].type) {
                                for(l = 0; l < o.length; l += 1)if (i = !0, 1 === o[l].length && "number" == typeof o[l][0]) c.push(String(o[l] - 1));
                                else if (o[l].length > 1) {
                                    for(h = 0; h < o[l].length; h += 1)"number" != typeof o[l][h] && (i = !1);
                                    !0 === i && c.push([
                                        o[l][0] - 1,
                                        o[l][1] - 1
                                    ].join(" "));
                                }
                                r[a].value = "[" + c.join(" ") + "]";
                            } else r[a].value = r[a].defaultValue;
                            r[a].explicitSet = !0;
                        }
                    }
                    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
                        var t, e = [];
                        for(t in r)!0 === r[t].explicitSet && ("name" === r[t].type ? e.push("/" + t + " /" + r[t].value) : e.push("/" + t + " " + r[t].value));
                        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
                    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = r, this;
                }, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
                    var e = function() {
                        var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), n = unescape(encodeURIComponent(t)), r = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a = unescape(encodeURIComponent("</x:xmpmeta>")), o = n.length + r.length + i.length + e.length + a.length;
                        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + n + r + i + a), this.internal.write("endstream"), this.internal.write("endobj");
                    }, n = function() {
                        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
                    };
                    t.addMetadata = function(t, r) {
                        return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
                            metadata: t,
                            namespaceuri: r || "http://jspdf.default.namespaceuri/"
                        }, this.internal.events.subscribe("putCatalog", n), this.internal.events.subscribe("postPutResources", e)), this;
                    };
                }(E.API), function(t) {
                    var e = t.API, n = e.pdfEscape16 = function(t, e) {
                        for(var n, r = e.metadata.Unicode.widths, i = [
                            "",
                            "0",
                            "00",
                            "000",
                            "0000"
                        ], a = [
                            ""
                        ], o = 0, s = t.length; o < s; ++o){
                            if (n = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(n), e.metadata.toUnicode[n] = t.charCodeAt(o), -1 == r.indexOf(n) && (r.push(n), r.push([
                                parseInt(e.metadata.widthOfGlyph(n), 10)
                            ])), "0" == n) return a.join("");
                            n = n.toString(16), a.push(i[4 - n.length], n);
                        }
                        return a.join("");
                    }, r = function(t) {
                        var e, n, r, i, a, o, s;
                        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", r = [], o = 0, s = (n = Object.keys(t).sort(function(t, e) {
                            return t - e;
                        })).length; o < s; o++)e = n[o], r.length >= 100 && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar", r = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), r.push("<" + e + "><" + i + ">"));
                        return r.length && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar\n"), a + "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
                    };
                    e.events.push([
                        "putFont",
                        function(e) {
                            !function(e) {
                                var n = e.font, i = e.out, a = e.newObject, o = e.putStream;
                                if (n.metadata instanceof t.API.TTFFont && "Identity-H" === n.encoding) {
                                    for(var s = n.metadata.Unicode.widths, u = n.metadata.subset.encode(n.metadata.glyIdsUsed, 1), c = "", l = 0; l < u.length; l++)c += String.fromCharCode(u[l]);
                                    var h = a();
                                    o({
                                        data: c,
                                        addLength1: !0,
                                        objectId: h
                                    }), i("endobj");
                                    var f = a();
                                    o({
                                        data: r(n.metadata.toUnicode),
                                        addLength1: !0,
                                        objectId: f
                                    }), i("endobj");
                                    var d = a();
                                    i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + j(n.fontName)), i("/FontFile2 " + h + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(n.metadata.bbox)), i("/Flags " + n.metadata.flags), i("/StemV " + n.metadata.stemV), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i(">>"), i("endobj");
                                    var p = a();
                                    i("<<"), i("/Type /Font"), i("/BaseFont /" + j(n.fontName)), i("/FontDescriptor " + d + " 0 R"), i("/W " + t.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + n.encoding + ")"), i(">>"), i(">>"), i("endobj"), n.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + j(n.fontName)), i("/Encoding /" + n.encoding), i("/DescendantFonts [" + p + " 0 R]"), i(">>"), i("endobj"), n.isAlreadyPutted = !0;
                                }
                            }(e);
                        }
                    ]), e.events.push([
                        "putFont",
                        function(e) {
                            !function(e) {
                                var n = e.font, i = e.out, a = e.newObject, o = e.putStream;
                                if (n.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === n.encoding) {
                                    for(var s = n.metadata.rawData, u = "", c = 0; c < s.length; c++)u += String.fromCharCode(s[c]);
                                    var l = a();
                                    o({
                                        data: u,
                                        addLength1: !0,
                                        objectId: l
                                    }), i("endobj");
                                    var h = a();
                                    o({
                                        data: r(n.metadata.toUnicode),
                                        addLength1: !0,
                                        objectId: h
                                    }), i("endobj");
                                    var f = a();
                                    i("<<"), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i("/StemV " + n.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + l + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(n.metadata.bbox)), i("/FontName /" + j(n.fontName)), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i(">>"), i("endobj"), n.objectNumber = a();
                                    for(var d = 0; d < n.metadata.hmtx.widths.length; d++)n.metadata.hmtx.widths[d] = parseInt(n.metadata.hmtx.widths[d] * (1e3 / n.metadata.head.unitsPerEm));
                                    i("<</Subtype/TrueType/Type/Font/ToUnicode " + h + " 0 R/BaseFont/" + j(n.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + n.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(n.metadata.hmtx.widths) + ">>"), i("endobj"), n.isAlreadyPutted = !0;
                                }
                            }(e);
                        }
                    ]);
                    var i = function(t) {
                        var e, r = t.text || "", i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, u = s.pdfEscape, c = s.activeFontKey, l = s.fonts, h = c, f = "", d = 0, p = "", g = l[h].encoding;
                        if ("Identity-H" !== l[h].encoding) return {
                            text: r,
                            x: i,
                            y: a,
                            options: o,
                            mutex: s
                        };
                        for(p = r, h = c, Array.isArray(r) && (p = r[0]), d = 0; d < p.length; d += 1)l[h].metadata.hasOwnProperty("cmap") && (e = l[h].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && l[h].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
                        var m = "";
                        return parseInt(h.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = u(f, h).split("").map(function(t) {
                            return t.charCodeAt(0).toString(16);
                        }).join("") : "Identity-H" === g && (m = n(f, l[h])), s.isHex = !0, {
                            text: m,
                            x: i,
                            y: a,
                            options: o,
                            mutex: s
                        };
                    };
                    e.events.push([
                        "postProcessText",
                        function(t) {
                            var e = t.text || "", n = [], r = {
                                text: e,
                                x: t.x,
                                y: t.y,
                                options: t.options,
                                mutex: t.mutex
                            };
                            if (Array.isArray(e)) {
                                var a = 0;
                                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? n.push([
                                    i(Object.assign({}, r, {
                                        text: e[a][0]
                                    })).text,
                                    e[a][1],
                                    e[a][2]
                                ]) : n.push(i(Object.assign({}, r, {
                                    text: e[a]
                                })).text);
                                t.text = n;
                            } else t.text = i(Object.assign({}, r, {
                                text: e
                            })).text;
                        }
                    ]);
                }(E), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
                    var e = function() {
                        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
                    };
                    t.existsFileInVFS = function(t) {
                        return e.call(this), void 0 !== this.internal.vFS[t];
                    }, t.addFileToVFS = function(t, n) {
                        return e.call(this), this.internal.vFS[t] = n, this;
                    }, t.getFileFromVFS = function(t) {
                        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
                    };
                }(E.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
                    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
                        var n, r, i, a, o, s, u, c = e, l = [
                            [
                                0,
                                3,
                                0,
                                1,
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                3,
                                0,
                                1,
                                2,
                                2,
                                0
                            ],
                            [
                                0,
                                3,
                                0,
                                17,
                                2,
                                0,
                                1
                            ],
                            [
                                0,
                                3,
                                5,
                                5,
                                4,
                                1,
                                0
                            ],
                            [
                                0,
                                3,
                                21,
                                21,
                                4,
                                0,
                                1
                            ],
                            [
                                0,
                                3,
                                5,
                                5,
                                4,
                                2,
                                0
                            ]
                        ], h = [
                            [
                                2,
                                0,
                                1,
                                1,
                                0,
                                1,
                                0
                            ],
                            [
                                2,
                                0,
                                1,
                                1,
                                0,
                                2,
                                0
                            ],
                            [
                                2,
                                0,
                                2,
                                1,
                                3,
                                2,
                                0
                            ],
                            [
                                2,
                                0,
                                2,
                                33,
                                3,
                                1,
                                1
                            ]
                        ], f = {
                            L: 0,
                            R: 1,
                            EN: 2,
                            AN: 3,
                            N: 4,
                            B: 5,
                            S: 6
                        }, d = {
                            0: 0,
                            5: 1,
                            6: 2,
                            7: 3,
                            32: 4,
                            251: 5,
                            254: 6,
                            255: 7
                        }, p = [
                            "(",
                            ")",
                            "(",
                            "<",
                            ">",
                            "<",
                            "[",
                            "]",
                            "[",
                            "{",
                            "}",
                            "{",
                            "\xab",
                            "\xbb",
                            "\xab",
                            "\u2039",
                            "\u203A",
                            "\u2039",
                            "\u2045",
                            "\u2046",
                            "\u2045",
                            "\u207D",
                            "\u207E",
                            "\u207D",
                            "\u208D",
                            "\u208E",
                            "\u208D",
                            "\u2264",
                            "\u2265",
                            "\u2264",
                            "\u2329",
                            "\u232A",
                            "\u2329",
                            "\uFE59",
                            "\uFE5A",
                            "\uFE59",
                            "\uFE5B",
                            "\uFE5C",
                            "\uFE5B",
                            "\uFE5D",
                            "\uFE5E",
                            "\uFE5D",
                            "\uFE64",
                            "\uFE65",
                            "\uFE64"
                        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
                        this.__bidiEngine__ = {};
                        var b = function(t) {
                            var e = t.charCodeAt(), n = e >> 8, r = d[n];
                            return void 0 !== r ? c[256 * r + (255 & e)] : 252 === n || 253 === n ? "AL" : g.test(n) ? "L" : 8 === n ? "R" : "N";
                        }, y = function(t) {
                            for(var e, n = 0; n < t.length; n++){
                                if ("L" === (e = b(t.charAt(n)))) return !1;
                                if ("R" === e) return !0;
                            }
                            return !1;
                        }, w = function(t, e, o, s) {
                            var u, c, l, h, f = e[s];
                            switch(f){
                                case "L":
                                case "R":
                                case "LRE":
                                case "RLE":
                                case "LRO":
                                case "RLO":
                                case "PDF":
                                    m = !1;
                                    break;
                                case "N":
                                case "AN":
                                    break;
                                case "EN":
                                    m && (f = "AN");
                                    break;
                                case "AL":
                                    m = !0, f = "R";
                                    break;
                                case "WS":
                                case "BN":
                                    f = "N";
                                    break;
                                case "CS":
                                    s < 1 || s + 1 >= e.length || "EN" !== (u = o[s - 1]) && "AN" !== u || "EN" !== (c = e[s + 1]) && "AN" !== c ? f = "N" : m && (c = "AN"), f = c === u ? c : "N";
                                    break;
                                case "ES":
                                    f = "EN" === (u = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                                    break;
                                case "ET":
                                    if (s > 0 && "EN" === o[s - 1]) {
                                        f = "EN";
                                        break;
                                    }
                                    if (m) {
                                        f = "N";
                                        break;
                                    }
                                    for(l = s + 1, h = e.length; l < h && "ET" === e[l];)l++;
                                    f = l < h && "EN" === e[l] ? "EN" : "N";
                                    break;
                                case "NSM":
                                    if (i && !a) {
                                        for(h = e.length, l = s + 1; l < h && "NSM" === e[l];)l++;
                                        if (l < h) {
                                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                                            if (u = e[l], p && ("R" === u || "AL" === u)) {
                                                f = "R";
                                                break;
                                            }
                                        }
                                    }
                                    f = s < 1 || "B" === (u = e[s - 1]) ? "N" : o[s - 1];
                                    break;
                                case "B":
                                    m = !1, n = !0, f = v;
                                    break;
                                case "S":
                                    r = !0, f = "N";
                            }
                            return f;
                        }, N = function(t, e, n) {
                            var r = t.split("");
                            return n && L(r, n, {
                                hiLevel: v
                            }), r.reverse(), e && e.reverse(), r.join("");
                        }, L = function(t, e, i) {
                            var a, o, s, u, c, d = -1, p = t.length, g = 0, y = [], N = v ? h : l, L = [];
                            for(m = !1, n = !1, r = !1, o = 0; o < p; o++)L[o] = b(t[o]);
                            for(s = 0; s < p; s++){
                                if (c = g, y[s] = w(t, L, y, s), a = 240 & (g = N[c][f[y[s]]]), g &= 15, e[s] = u = N[g][5], a > 0) {
                                    if (16 === a) {
                                        for(o = d; o < s; o++)e[o] = 1;
                                        d = -1;
                                    } else d = -1;
                                }
                                if (N[g][6]) -1 === d && (d = s);
                                else if (d > -1) {
                                    for(o = d; o < s; o++)e[o] = u;
                                    d = -1;
                                }
                                "B" === L[s] && (e[s] = 0), i.hiLevel |= u;
                            }
                            r && function(t, e, n) {
                                for(var r = 0; r < n; r++)if ("S" === t[r]) {
                                    e[r] = v;
                                    for(var i = r - 1; i >= 0 && "WS" === t[i]; i--)e[i] = v;
                                }
                            }(L, e, p);
                        }, x = function(t, e, r, i, a) {
                            if (!(a.hiLevel < t)) {
                                if (1 === t && 1 === v && !n) return e.reverse(), void (r && r.reverse());
                                for(var o, s, u, c, l = e.length, h = 0; h < l;){
                                    if (i[h] >= t) {
                                        for(u = h + 1; u < l && i[u] >= t;)u++;
                                        for(c = h, s = u - 1; c < s; c++, s--)o = e[c], e[c] = e[s], e[s] = o, r && (o = r[c], r[c] = r[s], r[s] = o);
                                        h = u;
                                    }
                                    h++;
                                }
                            }
                        }, A = function(t, e, n) {
                            var r = t.split(""), i = {
                                hiLevel: v
                            };
                            return n || (n = []), L(r, n, i), function(t, e, n) {
                                if (0 !== n.hiLevel && u) for(var r, i = 0; i < t.length; i++)1 === e[i] && (r = p.indexOf(t[i])) >= 0 && (t[i] = p[r + 1]);
                            }(r, n, i), x(2, r, e, n, i), x(1, r, e, n, i), r.join("");
                        };
                        return this.__bidiEngine__.doBidiReorder = function(t, e, n) {
                            if (function(t, e) {
                                if (e) for(var n = 0; n < t.length; n++)e[n] = n;
                                void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
                            }(t, e), i || !o || s) {
                                if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, n);
                                else if (!i && o && s) v = a ? 1 : 0, t = A(t, e, n), t = N(t, e);
                                else if (!i || a || o || s) {
                                    if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = A(t, e, n)) : (v = 1, t = A(t, e, n), t = N(t, e));
                                    else if (i && a && !o && s) v = 1, t = A(t, e, n), t = N(t, e);
                                    else if (!i && !o && a ^ s) {
                                        var r = u;
                                        a ? (v = 1, t = A(t, e, n), v = 0, u = !1, t = A(t, e, n), u = r) : (v = 0, t = A(t, e, n), t = N(t, e), v = 1, u = !1, t = A(t, e, n), u = r, t = N(t, e));
                                    }
                                } else v = 0, t = A(t, e, n);
                            } else v = a ? 1 : 0, t = A(t, e, n);
                            return t;
                        }, this.__bidiEngine__.setOptions = function(t) {
                            t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, u = t.isSymmetricSwapping);
                        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
                    };
                    var e = [
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "S",
                        "B",
                        "S",
                        "WS",
                        "B",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "B",
                        "B",
                        "B",
                        "S",
                        "WS",
                        "N",
                        "N",
                        "ET",
                        "ET",
                        "ET",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "ES",
                        "CS",
                        "ES",
                        "CS",
                        "CS",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "CS",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "N",
                        "N",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "B",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "CS",
                        "N",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "N",
                        "N",
                        "N",
                        "N",
                        "L",
                        "N",
                        "N",
                        "BN",
                        "N",
                        "N",
                        "ET",
                        "ET",
                        "EN",
                        "EN",
                        "N",
                        "L",
                        "N",
                        "N",
                        "N",
                        "EN",
                        "L",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "L",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "ET",
                        "N",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "R",
                        "NSM",
                        "R",
                        "NSM",
                        "NSM",
                        "R",
                        "NSM",
                        "NSM",
                        "R",
                        "NSM",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "AN",
                        "AN",
                        "AN",
                        "AN",
                        "AN",
                        "AN",
                        "N",
                        "N",
                        "AL",
                        "ET",
                        "ET",
                        "AL",
                        "CS",
                        "AL",
                        "N",
                        "N",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "AL",
                        "AL",
                        "N",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "AN",
                        "AN",
                        "AN",
                        "AN",
                        "AN",
                        "AN",
                        "AN",
                        "AN",
                        "AN",
                        "AN",
                        "ET",
                        "AN",
                        "AN",
                        "AL",
                        "AL",
                        "AL",
                        "NSM",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "AN",
                        "N",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "AL",
                        "AL",
                        "NSM",
                        "NSM",
                        "N",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "AL",
                        "AL",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "N",
                        "AL",
                        "AL",
                        "NSM",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "N",
                        "N",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "AL",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "R",
                        "R",
                        "N",
                        "N",
                        "N",
                        "N",
                        "R",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "WS",
                        "WS",
                        "WS",
                        "WS",
                        "WS",
                        "WS",
                        "WS",
                        "WS",
                        "WS",
                        "WS",
                        "WS",
                        "BN",
                        "BN",
                        "BN",
                        "L",
                        "R",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "WS",
                        "B",
                        "LRE",
                        "RLE",
                        "PDF",
                        "LRO",
                        "RLO",
                        "CS",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "CS",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "WS",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "N",
                        "LRI",
                        "RLI",
                        "FSI",
                        "PDI",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "BN",
                        "EN",
                        "L",
                        "N",
                        "N",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "ES",
                        "ES",
                        "N",
                        "N",
                        "N",
                        "L",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "ES",
                        "ES",
                        "N",
                        "N",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "N",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "ET",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "R",
                        "NSM",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "ES",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "N",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "N",
                        "R",
                        "N",
                        "R",
                        "R",
                        "N",
                        "R",
                        "R",
                        "N",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "R",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "NSM",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "CS",
                        "N",
                        "CS",
                        "N",
                        "N",
                        "CS",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "ET",
                        "N",
                        "N",
                        "ES",
                        "ES",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "ET",
                        "ET",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "N",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "AL",
                        "N",
                        "N",
                        "BN",
                        "N",
                        "N",
                        "N",
                        "ET",
                        "ET",
                        "ET",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "ES",
                        "CS",
                        "ES",
                        "CS",
                        "CS",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "EN",
                        "CS",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "L",
                        "L",
                        "L",
                        "N",
                        "N",
                        "N",
                        "ET",
                        "ET",
                        "N",
                        "N",
                        "N",
                        "ET",
                        "ET",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N",
                        "N"
                    ], n = new t.__bidiEngine__({
                        isInputVisual: !0
                    });
                    t.API.events.push([
                        "postProcessText",
                        function(t) {
                            var e = t.text;
                            t.x, t.y;
                            var r = t.options || {};
                            t.mutex, r.lang;
                            var i = [];
                            if (r.isInputVisual = "boolean" != typeof r.isInputVisual || r.isInputVisual, n.setOptions(r), "[object Array]" === Object.prototype.toString.call(e)) {
                                var a = 0;
                                for(i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([
                                    n.doBidiReorder(e[a][0]),
                                    e[a][1],
                                    e[a][2]
                                ]) : i.push([
                                    n.doBidiReorder(e[a])
                                ]);
                                t.text = i;
                            } else t.text = n.doBidiReorder(e);
                            n.setOptions({
                                isInputVisual: !0
                            });
                        }
                    ]);
                }(E), E.API.TTFFont = function() {
                    function t(t) {
                        var e;
                        if (this.rawData = t, e = this.contents = new fe(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
                        e.pos = 0, this.parse(), this.subset = new je(this), this.registerTTF();
                    }
                    return t.open = function(e) {
                        return new t(e);
                    }, t.prototype.parse = function() {
                        return this.directory = new de(this.contents), this.head = new me(this), this.name = new xe(this), this.cmap = new be(this), this.toUnicode = {}, this.hhea = new ye(this), this.maxp = new Ae(this), this.hmtx = new Se(this), this.post = new Ne(this), this.os2 = new we(this), this.loca = new Ie(this), this.glyf = new Pe(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
                            this.head.xMin,
                            this.head.yMin,
                            this.head.xMax,
                            this.head.yMax
                        ];
                    }, t.prototype.registerTTF = function() {
                        var t, e, n, r, i;
                        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
                            var e, n, r, i;
                            for(i = [], e = 0, n = (r = this.bbox).length; e < n; e++)t = r[e], i.push(Math.round(t * this.scaleFactor));
                            return i;
                        }).call(this), this.stemV = 0, this.post.exists ? (n = 255 & (r = this.post.italic_angle), 32768 & (e = r >> 16) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + n)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
                    }, t.prototype.characterToGlyph = function(t) {
                        var e;
                        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
                    }, t.prototype.widthOfGlyph = function(t) {
                        var e;
                        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
                    }, t.prototype.widthOfString = function(t, e, n) {
                        var r, i, a, o;
                        for(a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i)r = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(r)) + n * (1e3 / e) || 0;
                        return a * (e / 1e3);
                    }, t.prototype.lineHeight = function(t, e) {
                        var n;
                        return null == e && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
                    }, t;
                }();
                var he, fe = function() {
                    function t(t) {
                        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
                    }
                    return t.prototype.readByte = function() {
                        return this.data[this.pos++];
                    }, t.prototype.writeByte = function(t) {
                        return this.data[this.pos++] = t;
                    }, t.prototype.readUInt32 = function() {
                        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
                    }, t.prototype.writeUInt32 = function(t) {
                        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
                    }, t.prototype.readInt32 = function() {
                        var t;
                        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
                    }, t.prototype.writeInt32 = function(t) {
                        return t < 0 && (t += 4294967296), this.writeUInt32(t);
                    }, t.prototype.readUInt16 = function() {
                        return this.readByte() << 8 | this.readByte();
                    }, t.prototype.writeUInt16 = function(t) {
                        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
                    }, t.prototype.readInt16 = function() {
                        var t;
                        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
                    }, t.prototype.writeInt16 = function(t) {
                        return t < 0 && (t += 65536), this.writeUInt16(t);
                    }, t.prototype.readString = function(t) {
                        var e, n;
                        for(n = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)n[e] = String.fromCharCode(this.readByte());
                        return n.join("");
                    }, t.prototype.writeString = function(t) {
                        var e, n, r;
                        for(r = [], e = 0, n = t.length; 0 <= n ? e < n : e > n; e = 0 <= n ? ++e : --e)r.push(this.writeByte(t.charCodeAt(e)));
                        return r;
                    }, t.prototype.readShort = function() {
                        return this.readInt16();
                    }, t.prototype.writeShort = function(t) {
                        return this.writeInt16(t);
                    }, t.prototype.readLongLong = function() {
                        var t, e, n, r, i, a, o, s;
                        return t = this.readByte(), e = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * a + 256 * o + s;
                    }, t.prototype.writeLongLong = function(t) {
                        var e, n;
                        return e = Math.floor(t / 4294967296), n = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n);
                    }, t.prototype.readInt = function() {
                        return this.readInt32();
                    }, t.prototype.writeInt = function(t) {
                        return this.writeInt32(t);
                    }, t.prototype.read = function(t) {
                        var e, n;
                        for(e = [], n = 0; 0 <= t ? n < t : n > t; n = 0 <= t ? ++n : --n)e.push(this.readByte());
                        return e;
                    }, t.prototype.write = function(t) {
                        var e, n, r, i;
                        for(i = [], n = 0, r = t.length; n < r; n++)e = t[n], i.push(this.writeByte(e));
                        return i;
                    }, t;
                }(), de = function() {
                    var t;
                    function e(t) {
                        var e, n, r;
                        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n)e = {
                            tag: t.readString(4),
                            checksum: t.readInt(),
                            offset: t.readInt(),
                            length: t.readInt()
                        }, this.tables[e.tag] = e;
                    }
                    return e.prototype.encode = function(e) {
                        var n, r, i, a, o, s, u, c, l, h, f, d, p;
                        for(p in f = Object.keys(e).length, s = Math.log(2), l = 16 * Math.floor(Math.log(f) / s), a = Math.floor(l / s), c = 16 * f - l, (r = new fe).writeInt(this.scalarType), r.writeShort(f), r.writeShort(l), r.writeShort(a), r.writeShort(c), i = 16 * f, u = r.pos + i, o = null, d = [], e)for(h = e[p], r.writeString(p), r.writeInt(t(h)), r.writeInt(u), r.writeInt(h.length), d = d.concat(h), "head" === p && (o = u), u += h.length; u % 4;)d.push(0), u++;
                        return r.write(d), n = 2981146554 - t(r.data), r.pos = o + 8, r.writeUInt32(n), r.data;
                    }, t = function(t) {
                        var e, n, r, i;
                        for(t = _e.call(t); t.length % 4;)t.push(0);
                        for(r = new fe(t), n = 0, e = 0, i = t.length; e < i; e = e += 4)n += r.readUInt32();
                        return 4294967295 & n;
                    }, e;
                }(), pe = {}.hasOwnProperty, ge = function(t, e) {
                    for(var n in e)pe.call(e, n) && (t[n] = e[n]);
                    function r() {
                        this.constructor = t;
                    }
                    return r.prototype = e.prototype, t.prototype = new r, t.__super__ = e.prototype, t;
                };
                he = function() {
                    function t(t) {
                        var e;
                        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
                    }
                    return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
                        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
                    }, t;
                }();
                var me = function() {
                    function t() {
                        return t.__super__.constructor.apply(this, arguments);
                    }
                    return ge(t, he), t.prototype.tag = "head", t.prototype.parse = function(t) {
                        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
                    }, t.prototype.encode = function(t) {
                        var e;
                        return (e = new fe).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
                    }, t;
                }(), ve = function() {
                    function t(t, e) {
                        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m, v, b;
                        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), l = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
                            case 0:
                                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                                break;
                            case 4:
                                for(f = t.readUInt16(), h = f / 2, t.pos += 6, i = function() {
                                    var e, n;
                                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                                    return n;
                                }(), t.pos += 2, p = function() {
                                    var e, n;
                                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                                    return n;
                                }(), u = function() {
                                    var e, n;
                                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                                    return n;
                                }(), c = function() {
                                    var e, n;
                                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                                    return n;
                                }(), r = (this.length - t.pos + this.offset) / 2, o = function() {
                                    var e, n;
                                    for(n = [], s = e = 0; 0 <= r ? e < r : e > r; s = 0 <= r ? ++e : --e)n.push(t.readUInt16());
                                    return n;
                                }(), s = m = 0, b = i.length; m < b; s = ++m)for(g = i[s], n = v = d = p[s]; d <= g ? v <= g : v >= g; n = d <= g ? ++v : --v)0 === c[s] ? a = n + u[s] : 0 !== (a = o[c[s] / 2 + (n - d) - (h - s)] || 0) && (a += u[s]), this.codeMap[n] = 65535 & a;
                        }
                        t.pos = l;
                    }
                    return t.encode = function(t, e) {
                        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m, v, b, y, w, N, L, x, A, S, _, P, k, F, I, j, C, O, B, M, q, E, R, D, T, z, U, H, W, V, G, Y;
                        switch(F = new fe, a = Object.keys(t).sort(function(t, e) {
                            return t - e;
                        }), e){
                            case "macroman":
                                for(p = 0, g = function() {
                                    var t = [];
                                    for(d = 0; d < 256; ++d)t.push(0);
                                    return t;
                                }(), v = {
                                    0: 0
                                }, i = {}, I = 0, B = a.length; I < B; I++)null == v[W = t[r = a[I]]] && (v[W] = ++p), i[r] = {
                                    old: t[r],
                                    new: v[t[r]]
                                }, g[r] = v[t[r]];
                                return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
                                    charMap: i,
                                    subtable: F.data,
                                    maxGlyphID: p + 1
                                };
                            case "unicode":
                                for(P = [], l = [], b = 0, v = {}, n = {}, m = u = null, j = 0, M = a.length; j < M; j++)null == v[w = t[r = a[j]]] && (v[w] = ++b), n[r] = {
                                    old: w,
                                    new: v[w]
                                }, o = v[w] - r, null != m && o === u || (m && l.push(m), P.push(r), u = o), m = r;
                                for(m && l.push(m), l.push(65535), P.push(65535), S = 2 * (A = P.length), x = 2 * Math.pow(Math.log(A) / Math.LN2, 2), h = Math.log(x / 2) / Math.LN2, L = 2 * A - x, s = [], N = [], f = [], d = C = 0, q = P.length; C < q; d = ++C){
                                    if (_ = P[d], c = l[d], 65535 === _) {
                                        s.push(0), N.push(0);
                                        break;
                                    }
                                    if (_ - (k = n[_].new) >= 32768) for(s.push(0), N.push(2 * (f.length + A - d)), r = O = _; _ <= c ? O <= c : O >= c; r = _ <= c ? ++O : --O)f.push(n[r].new);
                                    else s.push(k - _), N.push(0);
                                }
                                for(F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * A + 2 * f.length), F.writeUInt16(0), F.writeUInt16(S), F.writeUInt16(x), F.writeUInt16(h), F.writeUInt16(L), U = 0, E = l.length; U < E; U++)r = l[U], F.writeUInt16(r);
                                for(F.writeUInt16(0), H = 0, R = P.length; H < R; H++)r = P[H], F.writeUInt16(r);
                                for(V = 0, D = s.length; V < D; V++)o = s[V], F.writeUInt16(o);
                                for(G = 0, T = N.length; G < T; G++)y = N[G], F.writeUInt16(y);
                                for(Y = 0, z = f.length; Y < z; Y++)p = f[Y], F.writeUInt16(p);
                                return {
                                    charMap: n,
                                    subtable: F.data,
                                    maxGlyphID: b + 1
                                };
                        }
                    }, t;
                }(), be = function() {
                    function t() {
                        return t.__super__.constructor.apply(this, arguments);
                    }
                    return ge(t, he), t.prototype.tag = "cmap", t.prototype.parse = function(t) {
                        var e, n, r;
                        for(t.pos = this.offset, this.version = t.readUInt16(), r = t.readUInt16(), this.tables = [], this.unicode = null, n = 0; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n)e = new ve(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
                        return !0;
                    }, t.encode = function(t, e) {
                        var n, r;
                        return null == e && (e = "macroman"), n = ve.encode(t, e), (r = new fe).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
                    }, t;
                }(), ye = function() {
                    function t() {
                        return t.__super__.constructor.apply(this, arguments);
                    }
                    return ge(t, he), t.prototype.tag = "hhea", t.prototype.parse = function(t) {
                        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
                    }, t;
                }(), we = function() {
                    function t() {
                        return t.__super__.constructor.apply(this, arguments);
                    }
                    return ge(t, he), t.prototype.tag = "OS/2", t.prototype.parse = function(t) {
                        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
                            var e, n;
                            for(n = [], e = 0; e < 10; ++e)n.push(t.readByte());
                            return n;
                        }(), this.charRange = function() {
                            var e, n;
                            for(n = [], e = 0; e < 4; ++e)n.push(t.readInt());
                            return n;
                        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
                            var e, n;
                            for(n = [], e = 0; e < 2; e = ++e)n.push(t.readInt());
                            return n;
                        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
                    }, t;
                }(), Ne = function() {
                    function t() {
                        return t.__super__.constructor.apply(this, arguments);
                    }
                    return ge(t, he), t.prototype.tag = "post", t.prototype.parse = function(t) {
                        var e, n, r;
                        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
                            case 65536:
                            case 196608:
                                break;
                            case 131072:
                                var i;
                                for(n = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= n ? i < n : i > n; i = 0 <= n ? ++i : --i)this.glyphNameIndex.push(t.readUInt16());
                                for(this.names = [], r = []; t.pos < this.offset + this.length;)e = t.readByte(), r.push(this.names.push(t.readString(e)));
                                return r;
                            case 151552:
                                return n = t.readUInt16(), this.offsets = t.read(n);
                            case 262144:
                                return this.map = (function() {
                                    var e, n, r;
                                    for(r = [], i = e = 0, n = this.file.maxp.numGlyphs; 0 <= n ? e < n : e > n; i = 0 <= n ? ++e : --e)r.push(t.readUInt32());
                                    return r;
                                }).call(this);
                        }
                    }, t;
                }(), Le = function(t, e) {
                    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
                }, xe = function() {
                    function t() {
                        return t.__super__.constructor.apply(this, arguments);
                    }
                    return ge(t, he), t.prototype.tag = "name", t.prototype.parse = function(t) {
                        var e, n, r, i, a, o, s, u, c, l, h;
                        for(t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), n = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)n.push({
                            platformID: t.readShort(),
                            encodingID: t.readShort(),
                            languageID: t.readShort(),
                            nameID: t.readShort(),
                            length: t.readShort(),
                            offset: this.offset + o + t.readShort()
                        });
                        for(s = {}, i = c = 0, l = n.length; c < l; i = ++c)r = n[i], t.pos = r.offset, u = t.readString(r.length), a = new Le(u, r), null == s[h = r.nameID] && (s[h] = []), s[r.nameID].push(a);
                        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
                        try {
                            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
                        } catch (f) {
                            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
                        }
                        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
                    }, t;
                }(), Ae = function() {
                    function t() {
                        return t.__super__.constructor.apply(this, arguments);
                    }
                    return ge(t, he), t.prototype.tag = "maxp", t.prototype.parse = function(t) {
                        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
                    }, t;
                }(), Se = function() {
                    function t() {
                        return t.__super__.constructor.apply(this, arguments);
                    }
                    return ge(t, he), t.prototype.tag = "hmtx", t.prototype.parse = function(t) {
                        var e, n, r, i, a, o, s;
                        for(t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e)this.metrics.push({
                            advance: t.readUInt16(),
                            lsb: t.readInt16()
                        });
                        for(r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
                            var n, i;
                            for(i = [], e = n = 0; 0 <= r ? n < r : n > r; e = 0 <= r ? ++n : --n)i.push(t.readInt16());
                            return i;
                        }(), this.widths = (function() {
                            var t, e, n, r;
                            for(r = [], t = 0, e = (n = this.metrics).length; t < e; t++)i = n[t], r.push(i.advance);
                            return r;
                        }).call(this), n = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= r ? a < r : a > r; e = 0 <= r ? ++a : --a)s.push(this.widths.push(n));
                        return s;
                    }, t.prototype.forGlyph = function(t) {
                        return t in this.metrics ? this.metrics[t] : {
                            advance: this.metrics[this.metrics.length - 1].advance,
                            lsb: this.leftSideBearings[t - this.metrics.length]
                        };
                    }, t;
                }(), _e = [].slice, Pe = function() {
                    function t() {
                        return t.__super__.constructor.apply(this, arguments);
                    }
                    return ge(t, he), t.prototype.tag = "glyf", t.prototype.parse = function() {
                        return this.cache = {};
                    }, t.prototype.glyphFor = function(t) {
                        var e, n, r, i, a, o, s, u, c, l;
                        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, n = i.indexOf(t), 0 === (r = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + n, a = (o = new fe(e.read(r))).readShort(), u = o.readShort(), l = o.readShort(), s = o.readShort(), c = o.readShort(), this.cache[t] = -1 === a ? new Fe(o, u, l, s, c) : new ke(o, a, u, l, s, c), this.cache[t]));
                    }, t.prototype.encode = function(t, e, n) {
                        var r, i, a, o, s;
                        for(a = [], i = [], o = 0, s = e.length; o < s; o++)r = t[e[o]], i.push(a.length), r && (a = a.concat(r.encode(n)));
                        return i.push(a.length), {
                            table: a,
                            offsets: i
                        };
                    }, t;
                }(), ke = function() {
                    function t(t, e, n, r, i, a) {
                        this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = a, this.compound = !1;
                    }
                    return t.prototype.encode = function() {
                        return this.raw.data;
                    }, t;
                }(), Fe = function() {
                    function t(t, e, n, r, i) {
                        var a, o;
                        for(this.raw = t, this.xMin = e, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
                    }
                    return t.prototype.encode = function() {
                        var t, e, n;
                        for(e = new fe(_e.call(this.raw.data)), t = 0, n = this.glyphIDs.length; t < n; ++t)e.pos = this.glyphOffsets[t];
                        return e.data;
                    }, t;
                }(), Ie = function() {
                    function t() {
                        return t.__super__.constructor.apply(this, arguments);
                    }
                    return ge(t, he), t.prototype.tag = "loca", t.prototype.parse = function(t) {
                        var e, n;
                        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? (function() {
                            var e, r;
                            for(r = [], n = 0, e = this.length; n < e; n += 2)r.push(2 * t.readUInt16());
                            return r;
                        }).call(this) : (function() {
                            var e, r;
                            for(r = [], n = 0, e = this.length; n < e; n += 4)r.push(t.readUInt32());
                            return r;
                        }).call(this);
                    }, t.prototype.indexOf = function(t) {
                        return this.offsets[t];
                    }, t.prototype.lengthOf = function(t) {
                        return this.offsets[t + 1] - this.offsets[t];
                    }, t.prototype.encode = function(t, e) {
                        for(var n = new Uint32Array(this.offsets.length), r = 0, i = 0, a = 0; a < n.length; ++a)if (n[a] = r, i < e.length && e[i] == a) {
                            ++i, n[a] = r;
                            var o = this.offsets[a], s = this.offsets[a + 1] - o;
                            s > 0 && (r += s);
                        }
                        for(var u = new Array(4 * n.length), c = 0; c < n.length; ++c)u[4 * c + 3] = 255 & n[c], u[4 * c + 2] = (65280 & n[c]) >> 8, u[4 * c + 1] = (16711680 & n[c]) >> 16, u[4 * c] = (4278190080 & n[c]) >> 24;
                        return u;
                    }, t;
                }(), je = function() {
                    function t(t) {
                        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
                    }
                    return t.prototype.generateCmap = function() {
                        var t, e, n, r, i;
                        for(e in r = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)n = i[e], t[e] = r[n];
                        return t;
                    }, t.prototype.glyphsFor = function(t) {
                        var e, n, r, i, a, o, s;
                        for(r = {}, a = 0, o = t.length; a < o; a++)r[i = t[a]] = this.font.glyf.glyphFor(i);
                        for(i in e = [], r)(null != (n = r[i]) ? n.compound : void 0) && e.push.apply(e, n.glyphIDs);
                        if (e.length > 0) for(i in s = this.glyphsFor(e))n = s[i], r[i] = n;
                        return r;
                    }, t.prototype.encode = function(t, e) {
                        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m;
                        for(r in n = be.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
                            0: 0
                        }, m = n.charMap)f[(s = m[r]).old] = s.new;
                        for(d in h = n.maxGlyphID, a)d in f || (f[d] = h++);
                        return c = function(t) {
                            var e, n;
                            for(e in n = {}, t)n[t[e]] = e;
                            return n;
                        }(f), l = Object.keys(c).sort(function(t, e) {
                            return t - e;
                        }), p = function() {
                            var t, e, n;
                            for(n = [], t = 0, e = l.length; t < e; t++)o = l[t], n.push(c[o]);
                            return n;
                        }(), i = this.font.glyf.encode(a, p, f), u = this.font.loca.encode(i.offsets, p), g = {
                            cmap: this.font.cmap.raw(),
                            glyf: i.table,
                            loca: u,
                            hmtx: this.font.hmtx.raw(),
                            hhea: this.font.hhea.raw(),
                            maxp: this.font.maxp.raw(),
                            post: this.font.post.raw(),
                            name: this.font.name.raw(),
                            head: this.font.head.encode(e)
                        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
                    }, t;
                }();
                E.API.PDFObject = function() {
                    var t;
                    function e() {}
                    return t = function(t, e) {
                        return (Array(e + 1).join("0") + t).slice(-e);
                    }, e.convert = function(n) {
                        var r, i, a, o;
                        if (Array.isArray(n)) return "[" + (function() {
                            var t, i, a;
                            for(a = [], t = 0, i = n.length; t < i; t++)r = n[t], a.push(e.convert(r));
                            return a;
                        })().join(" ") + "]";
                        if ("string" == typeof n) return "/" + n;
                        if (null != n ? n.isString : void 0) return "(" + n + ")";
                        if (n instanceof Date) return "(D:" + t(n.getUTCFullYear(), 4) + t(n.getUTCMonth(), 2) + t(n.getUTCDate(), 2) + t(n.getUTCHours(), 2) + t(n.getUTCMinutes(), 2) + t(n.getUTCSeconds(), 2) + "Z)";
                        if ("[object Object]" === ({}).toString.call(n)) {
                            for(i in a = [
                                "<<"
                            ], n)o = n[i], a.push("/" + i + " " + e.convert(o));
                            return a.push(">>"), a.join("\n");
                        }
                        return "" + n;
                    }, e;
                }();
            //# sourceMappingURL=jspdf.es.min.js.map
            /***/ },
            /***/ "./node_modules/pako/dist/pako.esm.mjs": /*!*********************************************!*\
  !*** ./node_modules/pako/dist/pako.esm.mjs ***!
  \*********************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Deflate: function() {
                        return /* binding */ Deflate_1;
                    },
                    /* harmony export */ Inflate: function() {
                        return /* binding */ Inflate_1;
                    },
                    /* harmony export */ constants: function() {
                        return /* binding */ constants_1;
                    },
                    /* harmony export */ "default": function() {
                        return /* binding */ pako;
                    },
                    /* harmony export */ deflate: function() {
                        return /* binding */ deflate_1;
                    },
                    /* harmony export */ deflateRaw: function() {
                        return /* binding */ deflateRaw_1;
                    },
                    /* harmony export */ gzip: function() {
                        return /* binding */ gzip_1;
                    },
                    /* harmony export */ inflate: function() {
                        return /* binding */ inflate_1;
                    },
                    /* harmony export */ inflateRaw: function() {
                        return /* binding */ inflateRaw_1;
                    },
                    /* harmony export */ ungzip: function() {
                        return /* binding */ ungzip_1;
                    }
                });
                /*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                /* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
                //const Z_HUFFMAN_ONLY      = 2;
                //const Z_RLE               = 3;
                const Z_FIXED$1 = 4;
                //const Z_DEFAULT_STRATEGY  = 0;
                /* Possible values of the data_type field (though see inflate()) */ const Z_BINARY = 0;
                const Z_TEXT = 1;
                //const Z_ASCII             = 1; // = Z_TEXT
                const Z_UNKNOWN$1 = 2;
                /*============================================================================*/ function zero$1(buf) {
                    let len = buf.length;
                    while(--len >= 0)buf[len] = 0;
                }
                // From zutil.h
                const STORED_BLOCK = 0;
                const STATIC_TREES = 1;
                const DYN_TREES = 2;
                /* The three kinds of block type */ const MIN_MATCH$1 = 3;
                const MAX_MATCH$1 = 258;
                /* The minimum and maximum match lengths */ // From deflate.h
                /* ===========================================================================
 * Internal compression state.
 */ const LENGTH_CODES$1 = 29;
                /* number of length codes, not counting the special END_BLOCK code */ const LITERALS$1 = 256;
                /* number of literal bytes 0..255 */ const L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
                /* number of Literal or Length codes, including the END_BLOCK code */ const D_CODES$1 = 30;
                /* number of distance codes */ const BL_CODES$1 = 19;
                /* number of codes used to transfer the bit lengths */ const HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
                /* maximum heap size */ const MAX_BITS$1 = 15;
                /* All codes must not exceed MAX_BITS bits */ const Buf_size = 16;
                /* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const MAX_BL_BITS = 7;
                /* Bit length codes must not exceed MAX_BL_BITS bits */ const END_BLOCK = 256;
                /* end of block literal code */ const REP_3_6 = 16;
                /* repeat previous bit length 3-6 times (2 bits of repeat count) */ const REPZ_3_10 = 17;
                /* repeat a zero length 3-10 times  (3 bits of repeat count) */ const REPZ_11_138 = 18;
                /* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const extra_lbits = /* extra bits for each length code */ new Uint8Array([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ]);
                const extra_dbits = /* extra bits for each distance code */ new Uint8Array([
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ]);
                const extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ]);
                const bl_order = new Uint8Array([
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ]);
                /* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
                const DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
                // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
                const static_ltree = new Array((L_CODES$1 + 2) * 2);
                zero$1(static_ltree);
                /* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const static_dtree = new Array(D_CODES$1 * 2);
                zero$1(static_dtree);
                /* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const _dist_code = new Array(DIST_CODE_LEN);
                zero$1(_dist_code);
                /* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
                zero$1(_length_code);
                /* length code for each normalized match length (0 == MIN_MATCH) */ const base_length = new Array(LENGTH_CODES$1);
                zero$1(base_length);
                /* First normalized length for each code (0 = MIN_MATCH) */ const base_dist = new Array(D_CODES$1);
                zero$1(base_dist);
                /* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
                    this.static_tree = static_tree; /* static tree or NULL */ 
                    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
                    this.extra_base = extra_base; /* base index for extra_bits */ 
                    this.elems = elems; /* max number of elements in the tree */ 
                    this.max_length = max_length; /* max bit length for the codes */ 
                    // show if `static_tree` has data or dummy - needed for monomorphic objects
                    this.has_stree = static_tree && static_tree.length;
                }
                let static_l_desc;
                let static_d_desc;
                let static_bl_desc;
                function TreeDesc(dyn_tree, stat_desc) {
                    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
                    this.max_code = 0; /* largest code with non zero frequency */ 
                    this.stat_desc = stat_desc; /* the corresponding static tree */ 
                }
                const d_code = (dist)=>{
                    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
                };
                /* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const put_short = (s, w)=>{
                    //    put_byte(s, (uch)((w) & 0xff));
                    //    put_byte(s, (uch)((ush)(w) >> 8));
                    s.pending_buf[s.pending++] = w & 0xff;
                    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
                };
                /* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const send_bits = (s, value, length)=>{
                    if (s.bi_valid > Buf_size - length) {
                        s.bi_buf |= value << s.bi_valid & 0xffff;
                        put_short(s, s.bi_buf);
                        s.bi_buf = value >> Buf_size - s.bi_valid;
                        s.bi_valid += length - Buf_size;
                    } else {
                        s.bi_buf |= value << s.bi_valid & 0xffff;
                        s.bi_valid += length;
                    }
                };
                const send_code = (s, c, tree)=>{
                    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
                };
                /* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const bi_reverse = (code, len)=>{
                    let res = 0;
                    do {
                        res |= code & 1;
                        code >>>= 1;
                        res <<= 1;
                    }while (--len > 0);
                    return res >>> 1;
                };
                /* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const bi_flush = (s)=>{
                    if (s.bi_valid === 16) {
                        put_short(s, s.bi_buf);
                        s.bi_buf = 0;
                        s.bi_valid = 0;
                    } else if (s.bi_valid >= 8) {
                        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                        s.bi_buf >>= 8;
                        s.bi_valid -= 8;
                    }
                };
                /* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const gen_bitlen = (s, desc)=>{
                    //    deflate_state *s;
                    //    tree_desc *desc;    /* the tree descriptor */
                    const tree = desc.dyn_tree;
                    const max_code = desc.max_code;
                    const stree = desc.stat_desc.static_tree;
                    const has_stree = desc.stat_desc.has_stree;
                    const extra = desc.stat_desc.extra_bits;
                    const base = desc.stat_desc.extra_base;
                    const max_length = desc.stat_desc.max_length;
                    let h; /* heap index */ 
                    let n, m; /* iterate over the tree elements */ 
                    let bits; /* bit length */ 
                    let xbits; /* extra bits */ 
                    let f; /* frequency */ 
                    let overflow = 0; /* number of elements with bit length too large */ 
                    for(bits = 0; bits <= MAX_BITS$1; bits++)s.bl_count[bits] = 0;
                    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
                    for(h = s.heap_max + 1; h < HEAP_SIZE$1; h++){
                        n = s.heap[h];
                        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
                        if (bits > max_length) {
                            bits = max_length;
                            overflow++;
                        }
                        tree[n * 2 + 1] = bits;
                        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
                         /* not a leaf node */ 
                        s.bl_count[bits]++;
                        xbits = 0;
                        if (n >= base) xbits = extra[n - base];
                        f = tree[n * 2] /*.Freq*/ ;
                        s.opt_len += f * (bits + xbits);
                        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
                    }
                    if (overflow === 0) return;
                    // Tracev((stderr,"\nbit length overflow\n"));
                    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
                        bits = max_length - 1;
                        while(s.bl_count[bits] === 0)bits--;
                        s.bl_count[bits]--; /* move one leaf down the tree */ 
                        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
                        s.bl_count[max_length]--;
                        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
                    }while (overflow > 0);
                    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
                        n = s.bl_count[bits];
                        while(n !== 0){
                            m = s.heap[--h];
                            if (m > max_code) continue;
                            if (tree[m * 2 + 1] !== bits) {
                                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                                tree[m * 2 + 1] = bits;
                            }
                            n--;
                        }
                    }
                };
                /* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const gen_codes = (tree, max_code, bl_count)=>{
                    //    ct_data *tree;             /* the tree to decorate */
                    //    int max_code;              /* largest code with non zero frequency */
                    //    ushf *bl_count;            /* number of codes at each bit length */
                    const next_code = new Array(MAX_BITS$1 + 1); /* next code value for each bit length */ 
                    let code = 0; /* running code value */ 
                    let bits; /* bit index */ 
                    let n; /* code index */ 
                    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS$1; bits++){
                        code = code + bl_count[bits - 1] << 1;
                        next_code[bits] = code;
                    }
                    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
                    //        "inconsistent bit counts");
                    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
                    for(n = 0; n <= max_code; n++){
                        let len = tree[n * 2 + 1] /*.Len*/ ;
                        if (len === 0) continue;
                        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
                    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
                    }
                };
                /* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const tr_static_init = ()=>{
                    let n; /* iterates over tree elements */ 
                    let bits; /* bit counter */ 
                    let length; /* length value */ 
                    let code; /* code value */ 
                    let dist; /* distance index */ 
                    const bl_count = new Array(MAX_BITS$1 + 1);
                    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
                    //if (static_init_done) return;
                    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
                    for(code = 0; code < LENGTH_CODES$1 - 1; code++){
                        base_length[code] = length;
                        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
                    }
                    //Assert (length == 256, "tr_static_init: length != 256");
                    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
                    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
                    for(code = 0; code < 16; code++){
                        base_dist[code] = dist;
                        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
                    }
                    //Assert (dist == 256, "tr_static_init: dist != 256");
                    dist >>= 7; /* from now on, all distances are divided by 128 */ 
                    for(; code < D_CODES$1; code++){
                        base_dist[code] = dist << 7;
                        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
                    }
                    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
                    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS$1; bits++)bl_count[bits] = 0;
                    n = 0;
                    while(n <= 143){
                        static_ltree[n * 2 + 1] = 8;
                        n++;
                        bl_count[8]++;
                    }
                    while(n <= 255){
                        static_ltree[n * 2 + 1] = 9;
                        n++;
                        bl_count[9]++;
                    }
                    while(n <= 279){
                        static_ltree[n * 2 + 1] = 7;
                        n++;
                        bl_count[7]++;
                    }
                    while(n <= 287){
                        static_ltree[n * 2 + 1] = 8;
                        n++;
                        bl_count[8]++;
                    }
                    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES$1 + 1, bl_count);
                    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES$1; n++){
                        static_dtree[n * 2 + 1] = 5;
                        static_dtree[n * 2] = bi_reverse(n, 5);
                    }
                    // Now data ready and we can init static trees
                    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
                    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1);
                    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
                //static_init_done = true;
                };
                /* ===========================================================================
 * Initialize a new block.
 */ const init_block = (s)=>{
                    let n; /* iterates over tree elements */ 
                    /* Initialize the trees. */ for(n = 0; n < L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
                    for(n = 0; n < D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
                    for(n = 0; n < BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
                    s.dyn_ltree[END_BLOCK * 2] = 1;
                    s.opt_len = s.static_len = 0;
                    s.sym_next = s.matches = 0;
                };
                /* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const bi_windup = (s)=>{
                    if (s.bi_valid > 8) put_short(s, s.bi_buf);
                    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
                    s.pending_buf[s.pending++] = s.bi_buf;
                    s.bi_buf = 0;
                    s.bi_valid = 0;
                };
                /* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const smaller = (tree, n, m, depth)=>{
                    const _n2 = n * 2;
                    const _m2 = m * 2;
                    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
                };
                /* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const pqdownheap = (s, tree, k)=>{
                    //    deflate_state *s;
                    //    ct_data *tree;  /* the tree to restore */
                    //    int k;               /* node to move down */
                    const v = s.heap[k];
                    let j = k << 1; /* left son of k */ 
                    while(j <= s.heap_len){
                        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
                        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
                        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
                        k = j;
                        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
                    }
                    s.heap[k] = v;
                };
                // inlined manually
                // const SMALLEST = 1;
                /* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const compress_block = (s, ltree, dtree)=>{
                    //    deflate_state *s;
                    //    const ct_data *ltree; /* literal tree */
                    //    const ct_data *dtree; /* distance tree */
                    let dist; /* distance of matched string */ 
                    let lc; /* match length or unmatched char (if dist == 0) */ 
                    let sx = 0; /* running index in sym_buf */ 
                    let code; /* the code to send */ 
                    let extra; /* number of extra bits to send */ 
                    if (s.sym_next !== 0) do {
                        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
                        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
                        lc = s.pending_buf[s.sym_buf + sx++];
                        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
                        else {
                            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
                            send_code(s, code + LITERALS$1 + 1, ltree); /* send the length code */ 
                            extra = extra_lbits[code];
                            if (extra !== 0) {
                                lc -= base_length[code];
                                send_bits(s, lc, extra); /* send the extra length bits */ 
                            }
                            dist--; /* dist is now the match distance - 1 */ 
                            code = d_code(dist);
                            //Assert (code < D_CODES, "bad d_code");
                            send_code(s, code, dtree); /* send the distance code */ 
                            extra = extra_dbits[code];
                            if (extra !== 0) {
                                dist -= base_dist[code];
                                send_bits(s, dist, extra); /* send the extra distance bits */ 
                            }
                        } /* literal or match pair ? */ 
                    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
                    }while (sx < s.sym_next);
                    send_code(s, END_BLOCK, ltree);
                };
                /* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const build_tree = (s, desc)=>{
                    //    deflate_state *s;
                    //    tree_desc *desc; /* the tree descriptor */
                    const tree = desc.dyn_tree;
                    const stree = desc.stat_desc.static_tree;
                    const has_stree = desc.stat_desc.has_stree;
                    const elems = desc.stat_desc.elems;
                    let n, m; /* iterate over heap elements */ 
                    let max_code = -1; /* largest code with non zero frequency */ 
                    let node; /* new node being created */ 
                    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
                    s.heap_max = HEAP_SIZE$1;
                    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
                        s.heap[++s.heap_len] = max_code = n;
                        s.depth[n] = 0;
                    } else tree[n * 2 + 1] = 0;
                    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
                        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                        tree[node * 2] = 1;
                        s.depth[node] = 0;
                        s.opt_len--;
                        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
                    /* node is 0 or 1 so it does not have extra bits */ }
                    desc.max_code = max_code;
                    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
                    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
                    do {
                        //pqremove(s, tree, n);  /* n = node of least frequency */
                        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
                        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
                        pqdownheap(s, tree, 1 /*SMALLEST*/ );
                        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
                        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
                        s.heap[--s.heap_max] = m;
                        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
                        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
                        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
                        pqdownheap(s, tree, 1 /*SMALLEST*/ );
                    }while (s.heap_len >= 2);
                    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
                    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
                    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
                };
                /* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const scan_tree = (s, tree, max_code)=>{
                    //    deflate_state *s;
                    //    ct_data *tree;   /* the tree to be scanned */
                    //    int max_code;    /* and its largest code of non zero frequency */
                    let n; /* iterates over all tree elements */ 
                    let prevlen = -1; /* last emitted length */ 
                    let curlen; /* length of current code */ 
                    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
                    let count = 0; /* repeat count of the current code */ 
                    let max_count = 7; /* max repeat count */ 
                    let min_count = 4; /* min repeat count */ 
                    if (nextlen === 0) {
                        max_count = 138;
                        min_count = 3;
                    }
                    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
                    for(n = 0; n <= max_code; n++){
                        curlen = nextlen;
                        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
                        if (++count < max_count && curlen === nextlen) continue;
                        else if (count < min_count) s.bl_tree[curlen * 2] += count;
                        else if (curlen !== 0) {
                            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
                            s.bl_tree[REP_3_6 * 2]++;
                        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
                        else s.bl_tree[REPZ_11_138 * 2]++;
                        count = 0;
                        prevlen = curlen;
                        if (nextlen === 0) {
                            max_count = 138;
                            min_count = 3;
                        } else if (curlen === nextlen) {
                            max_count = 6;
                            min_count = 3;
                        } else {
                            max_count = 7;
                            min_count = 4;
                        }
                    }
                };
                /* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const send_tree = (s, tree, max_code)=>{
                    //    deflate_state *s;
                    //    ct_data *tree; /* the tree to be scanned */
                    //    int max_code;       /* and its largest code of non zero frequency */
                    let n; /* iterates over all tree elements */ 
                    let prevlen = -1; /* last emitted length */ 
                    let curlen; /* length of current code */ 
                    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
                    let count = 0; /* repeat count of the current code */ 
                    let max_count = 7; /* max repeat count */ 
                    let min_count = 4; /* min repeat count */ 
                    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
                        max_count = 138;
                        min_count = 3;
                    }
                    for(n = 0; n <= max_code; n++){
                        curlen = nextlen;
                        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
                        if (++count < max_count && curlen === nextlen) continue;
                        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
                        while (--count !== 0);
                        else if (curlen !== 0) {
                            if (curlen !== prevlen) {
                                send_code(s, curlen, s.bl_tree);
                                count--;
                            }
                            //Assert(count >= 3 && count <= 6, " 3_6?");
                            send_code(s, REP_3_6, s.bl_tree);
                            send_bits(s, count - 3, 2);
                        } else if (count <= 10) {
                            send_code(s, REPZ_3_10, s.bl_tree);
                            send_bits(s, count - 3, 3);
                        } else {
                            send_code(s, REPZ_11_138, s.bl_tree);
                            send_bits(s, count - 11, 7);
                        }
                        count = 0;
                        prevlen = curlen;
                        if (nextlen === 0) {
                            max_count = 138;
                            min_count = 3;
                        } else if (curlen === nextlen) {
                            max_count = 6;
                            min_count = 3;
                        } else {
                            max_count = 7;
                            min_count = 4;
                        }
                    }
                };
                /* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const build_bl_tree = (s)=>{
                    let max_blindex; /* index of last bit length code of non zero freq */ 
                    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
                    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
                    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
                    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
                        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
                    }
                    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
                    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
                    //        s->opt_len, s->static_len));
                    return max_blindex;
                };
                /* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const send_all_trees = (s, lcodes, dcodes, blcodes)=>{
                    //    deflate_state *s;
                    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
                    let rank; /* index in bl_order */ 
                    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
                    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
                    //        "too many codes");
                    //Tracev((stderr, "\nbl counts: "));
                    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
                    send_bits(s, dcodes - 1, 5);
                    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
                    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
                    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
                    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
                    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
                    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
                //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
                };
                /* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const detect_data_type = (s)=>{
                    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
                    let n;
                    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
                        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
                    }
                    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
                    for(n = 32; n < LITERALS$1; n++){
                        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
                    }
                    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
                };
                let static_init_done = false;
                /* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const _tr_init$1 = (s)=>{
                    if (!static_init_done) {
                        tr_static_init();
                        static_init_done = true;
                    }
                    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
                    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
                    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
                    s.bi_buf = 0;
                    s.bi_valid = 0;
                    /* Initialize the first block of the first file: */ init_block(s);
                };
                /* ===========================================================================
 * Send a stored block
 */ const _tr_stored_block$1 = (s, buf, stored_len, last)=>{
                    //DeflateState *s;
                    //charf *buf;       /* input block */
                    //ulg stored_len;   /* length of input block */
                    //int last;         /* one if this is the last block for a file */
                    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
                    bi_windup(s); /* align on byte boundary */ 
                    put_short(s, stored_len);
                    put_short(s, ~stored_len);
                    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
                    s.pending += stored_len;
                };
                /* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const _tr_align$1 = (s)=>{
                    send_bits(s, STATIC_TREES << 1, 3);
                    send_code(s, END_BLOCK, static_ltree);
                    bi_flush(s);
                };
                /* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const _tr_flush_block$1 = (s, buf, stored_len, last)=>{
                    //DeflateState *s;
                    //charf *buf;       /* input block, or NULL if too old */
                    //ulg stored_len;   /* length of input block */
                    //int last;         /* one if this is the last block for a file */
                    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
                    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
                    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
                        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN$1) s.strm.data_type = detect_data_type(s);
                        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
                        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                        //        s->static_len));
                        build_tree(s, s.d_desc);
                        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                        //        s->static_len));
                        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
                        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
                        static_lenb = s.static_len + 3 + 7 >>> 3;
                        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                        //        s->sym_next / 3));
                        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
                    } else // Assert(buf != (char*)0, "lost buf");
                    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
                    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block$1(s, buf, stored_len, last);
                    else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {
                        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                        compress_block(s, static_ltree, static_dtree);
                    } else {
                        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                        compress_block(s, s.dyn_ltree, s.dyn_dtree);
                    }
                    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
                    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
                    if (last) bi_windup(s);
                // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
                //       s->compressed_len-7*last));
                };
                /* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const _tr_tally$1 = (s, dist, lc)=>{
                    //    deflate_state *s;
                    //    unsigned dist;  /* distance of matched string */
                    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
                    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
                    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
                    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
                    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
                    else {
                        s.matches++;
                        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
                        //Assert((ush)dist < (ush)MAX_DIST(s) &&
                        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                        s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]++;
                        s.dyn_dtree[d_code(dist) * 2]++;
                    }
                    return s.sym_next === s.sym_end;
                };
                var _tr_init_1 = _tr_init$1;
                var _tr_stored_block_1 = _tr_stored_block$1;
                var _tr_flush_block_1 = _tr_flush_block$1;
                var _tr_tally_1 = _tr_tally$1;
                var _tr_align_1 = _tr_align$1;
                var trees = {
                    _tr_init: _tr_init_1,
                    _tr_stored_block: _tr_stored_block_1,
                    _tr_flush_block: _tr_flush_block_1,
                    _tr_tally: _tr_tally_1,
                    _tr_align: _tr_align_1
                };
                // Note: adler32 takes 12% for level 0 and 2% for level 6.
                // It isn't worth it to make additional optimizations as in original.
                // Small size is preferable.
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                const adler32 = (adler, buf, len, pos)=>{
                    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
                    while(len !== 0){
                        // Set limit ~ twice less than 5552, to keep
                        // s2 in 31-bits, because we force signed ints.
                        // in other case %= will fail.
                        n = len > 2000 ? 2000 : len;
                        len -= n;
                        do {
                            s1 = s1 + buf[pos++] | 0;
                            s2 = s2 + s1 | 0;
                        }while (--n);
                        s1 %= 65521;
                        s2 %= 65521;
                    }
                    return s1 | s2 << 16 | 0;
                };
                var adler32_1 = adler32;
                // Note: we can't get significant speed boost here.
                // So write code to minimize size - no pregenerated tables
                // and array tools dependencies.
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                // Use ordinary array, since untyped makes no boost here
                const makeTable = ()=>{
                    let c, table = [];
                    for(var n = 0; n < 256; n++){
                        c = n;
                        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
                        table[n] = c;
                    }
                    return table;
                };
                // Create table on load. Just 255 signed longs. Not a problem.
                const crcTable = new Uint32Array(makeTable());
                const crc32 = (crc, buf, len, pos)=>{
                    const t = crcTable;
                    const end = pos + len;
                    crc ^= -1;
                    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
                    return crc ^ -1; // >>> 0;
                };
                var crc32_1 = crc32;
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                var messages = {
                    2: 'need dictionary',
                    /* Z_NEED_DICT       2  */ 1: 'stream end',
                    /* Z_STREAM_END      1  */ 0: '',
                    /* Z_OK              0  */ '-1': 'file error',
                    /* Z_ERRNO         (-1) */ '-2': 'stream error',
                    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
                    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
                    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
                    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
                };
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                var constants$2 = {
                    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_MEM_ERROR: -4,
                    Z_BUF_ERROR: -5,
                    //Z_VERSION_ERROR: -6,
                    /* compression levels */ Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
                    Z_TEXT: 1,
                    //Z_ASCII:                1, // = Z_TEXT (deprecated)
                    Z_UNKNOWN: 2,
                    /* The deflate compression method */ Z_DEFLATED: 8
                };
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees;
                /* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: Z_NO_FLUSH$2, Z_PARTIAL_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH$1, Z_FINISH: Z_FINISH$3, Z_BLOCK: Z_BLOCK$1, Z_OK: Z_OK$3, Z_STREAM_END: Z_STREAM_END$3, Z_STREAM_ERROR: Z_STREAM_ERROR$2, Z_DATA_ERROR: Z_DATA_ERROR$2, Z_BUF_ERROR: Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1, Z_FILTERED, Z_HUFFMAN_ONLY, Z_RLE, Z_FIXED, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1, Z_UNKNOWN, Z_DEFLATED: Z_DEFLATED$2 } = constants$2;
                /*============================================================================*/ const MAX_MEM_LEVEL = 9;
                /* Maximum value for memLevel in deflateInit2 */ const MAX_WBITS$1 = 15;
                /* 32K LZ77 window */ const DEF_MEM_LEVEL = 8;
                const LENGTH_CODES = 29;
                /* number of length codes, not counting the special END_BLOCK code */ const LITERALS = 256;
                /* number of literal bytes 0..255 */ const L_CODES = LITERALS + 1 + LENGTH_CODES;
                /* number of Literal or Length codes, including the END_BLOCK code */ const D_CODES = 30;
                /* number of distance codes */ const BL_CODES = 19;
                /* number of codes used to transfer the bit lengths */ const HEAP_SIZE = 2 * L_CODES + 1;
                /* maximum heap size */ const MAX_BITS = 15;
                /* All codes must not exceed MAX_BITS bits */ const MIN_MATCH = 3;
                const MAX_MATCH = 258;
                const MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
                const PRESET_DICT = 0x20;
                const INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
                //#ifdef GZIP
                const GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
                //#endif
                const EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
                const NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
                const COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
                const HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
                const BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
                const FINISH_STATE = 666; /* stream complete */ 
                const BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
                const BS_BLOCK_DONE = 2; /* block flush performed */ 
                const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
                const BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
                const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
                const err = (strm, errorCode)=>{
                    strm.msg = messages[errorCode];
                    return errorCode;
                };
                const rank = (f)=>{
                    return f * 2 - (f > 4 ? 9 : 0);
                };
                const zero = (buf)=>{
                    let len = buf.length;
                    while(--len >= 0)buf[len] = 0;
                };
                /* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const slide_hash = (s)=>{
                    let n, m;
                    let p;
                    let wsize = s.w_size;
                    n = s.hash_size;
                    p = n;
                    do {
                        m = s.head[--p];
                        s.head[p] = m >= wsize ? m - wsize : 0;
                    }while (--n);
                    n = wsize;
                    //#ifndef FASTEST
                    p = n;
                    do {
                        m = s.prev[--p];
                        s.prev[p] = m >= wsize ? m - wsize : 0;
                    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
                //#endif
                };
                /* eslint-disable new-cap */ let HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
                // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
                // But breaks binary compatibility
                //let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
                let HASH = HASH_ZLIB;
                /* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const flush_pending = (strm)=>{
                    const s = strm.state;
                    //_tr_flush_bits(s);
                    let len = s.pending;
                    if (len > strm.avail_out) len = strm.avail_out;
                    if (len === 0) return;
                    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
                    strm.next_out += len;
                    s.pending_out += len;
                    strm.total_out += len;
                    strm.avail_out -= len;
                    s.pending -= len;
                    if (s.pending === 0) s.pending_out = 0;
                };
                const flush_block_only = (s, last)=>{
                    _tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
                    s.block_start = s.strstart;
                    flush_pending(s.strm);
                };
                const put_byte = (s, b)=>{
                    s.pending_buf[s.pending++] = b;
                };
                /* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const putShortMSB = (s, b)=>{
                    //  put_byte(s, (Byte)(b >> 8));
                    //  put_byte(s, (Byte)(b & 0xff));
                    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
                    s.pending_buf[s.pending++] = b & 0xff;
                };
                /* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const read_buf = (strm, buf, start, size)=>{
                    let len = strm.avail_in;
                    if (len > size) len = size;
                    if (len === 0) return 0;
                    strm.avail_in -= len;
                    // zmemcpy(buf, strm->next_in, len);
                    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
                    if (strm.state.wrap === 1) strm.adler = adler32_1(strm.adler, buf, len, start);
                    else if (strm.state.wrap === 2) strm.adler = crc32_1(strm.adler, buf, len, start);
                    strm.next_in += len;
                    strm.total_in += len;
                    return len;
                };
                /* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const longest_match = (s, cur_match)=>{
                    let chain_length = s.max_chain_length; /* max hash chain length */ 
                    let scan = s.strstart; /* current string */ 
                    let match; /* matched string */ 
                    let len; /* length of current match */ 
                    let best_len = s.prev_length; /* best match length so far */ 
                    let nice_match = s.nice_match; /* stop if match long enough */ 
                    const limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
                    const _win = s.window; // shortcut
                    const wmask = s.w_mask;
                    const prev = s.prev;
                    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + MAX_MATCH;
                    let scan_end1 = _win[scan + best_len - 1];
                    let scan_end = _win[scan + best_len];
                    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
                    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
                    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
                    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
                    do {
                        // Assert(cur_match < s->strstart, "no future");
                        match = cur_match;
                        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
                        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
                        match++;
                        // Assert(*scan == *match, "match[2]?");
                        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
                        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
                        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                        len = MAX_MATCH - (strend - scan);
                        scan = strend - MAX_MATCH;
                        if (len > best_len) {
                            s.match_start = cur_match;
                            best_len = len;
                            if (len >= nice_match) break;
                            scan_end1 = _win[scan + best_len - 1];
                            scan_end = _win[scan + best_len];
                        }
                    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
                    if (best_len <= s.lookahead) return best_len;
                    return s.lookahead;
                };
                /* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const fill_window = (s)=>{
                    const _w_size = s.w_size;
                    let n, more, str;
                    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
                    do {
                        more = s.window_size - s.lookahead - s.strstart;
                        // JS ints have 32 bit, block below not needed
                        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
                        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                        //        more = wsize;
                        //
                        //  } else if (more == (unsigned)(-1)) {
                        //        /* Very unlikely, but possible on 16 bit machine if
                        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                        //         */
                        //        more--;
                        //    }
                        //}
                        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
                            s.match_start -= _w_size;
                            s.strstart -= _w_size;
                            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
                            if (s.insert > s.strstart) s.insert = s.strstart;
                            slide_hash(s);
                            more += _w_size;
                        }
                        if (s.strm.avail_in === 0) break;
                        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
                        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                        s.lookahead += n;
                        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
                            str = s.strstart - s.insert;
                            s.ins_h = s.window[str];
                            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
                            //#if MIN_MATCH != 3
                            //        Call update_hash() MIN_MATCH-3 more times
                            //#endif
                            while(s.insert){
                                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);
                                s.prev[str & s.w_mask] = s.head[s.ins_h];
                                s.head[s.ins_h] = str;
                                str++;
                                s.insert--;
                                if (s.lookahead + s.insert < MIN_MATCH) break;
                            }
                        }
                    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
                /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
                //    const curr = s.strstart + s.lookahead;
                //    let init = 0;
                //
                //    if (s.high_water < curr) {
                //      /* Previous high water mark below current data -- zero WIN_INIT
                //       * bytes or up to end of window, whichever is less.
                //       */
                //      init = s.window_size - curr;
                //      if (init > WIN_INIT)
                //        init = WIN_INIT;
                //      zmemzero(s->window + curr, (unsigned)init);
                //      s->high_water = curr + init;
                //    }
                //    else if (s->high_water < (ulg)curr + WIN_INIT) {
                //      /* High water mark at or above current data, but below current data
                //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
                //       * to end of window, whichever is less.
                //       */
                //      init = (ulg)curr + WIN_INIT - s->high_water;
                //      if (init > s->window_size - s->high_water)
                //        init = s->window_size - s->high_water;
                //      zmemzero(s->window + s->high_water, (unsigned)init);
                //      s->high_water += init;
                //    }
                //  }
                //
                //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
                //    "not enough room for search");
                };
                /* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const deflate_stored = (s, flush)=>{
                    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
                    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
                    let used = s.strm.avail_in;
                    do {
                        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
                        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
                        if (s.strm.avail_out < have) break;
                        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
                        left = s.strstart - s.block_start; /* bytes left in window */ 
                        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
                        if (len > have) len = have; /* limit len to the output */ 
                        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== Z_FINISH$3 || flush === Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
                        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
                        _tr_stored_block(s, 0, 0, last);
                        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
                        s.pending_buf[s.pending - 3] = len >> 8;
                        s.pending_buf[s.pending - 2] = ~len;
                        s.pending_buf[s.pending - 1] = ~len >> 8;
                        /* Write the stored block header bytes. */ flush_pending(s.strm);
                        //#ifdef ZLIB_DEBUG
                        //    /* Update debugging counts for the data about to be copied. */
                        //    s->compressed_len += len << 3;
                        //    s->bits_sent += len << 3;
                        //#endif
                        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
                            if (left > len) left = len;
                            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
                            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
                            s.strm.next_out += left;
                            s.strm.avail_out -= left;
                            s.strm.total_out += left;
                            s.block_start += left;
                            len -= left;
                        }
                        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
                            read_buf(s.strm, s.strm.output, s.strm.next_out, len);
                            s.strm.next_out += len;
                            s.strm.avail_out -= len;
                            s.strm.total_out += len;
                        }
                    }while (last === 0);
                    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
                    if (used) {
                        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
                            s.matches = 2; /* clear hash */ 
                            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
                            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
                            s.strstart = s.w_size;
                            s.insert = s.strstart;
                        } else {
                            if (s.window_size - s.strstart <= used) {
                                /* Slide the window down. */ s.strstart -= s.w_size;
                                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                                if (s.insert > s.strstart) s.insert = s.strstart;
                            }
                            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
                            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
                            s.strstart += used;
                            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
                        }
                        s.block_start = s.strstart;
                    }
                    if (s.high_water < s.strstart) s.high_water = s.strstart;
                    /* If the last block was written to next_out, then done. */ if (last) return BS_FINISH_DONE;
                    /* If flushing and all input has been consumed, then done. */ if (flush !== Z_NO_FLUSH$2 && flush !== Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return BS_BLOCK_DONE;
                    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
                    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
                        /* Slide the window down. */ s.block_start -= s.w_size;
                        s.strstart -= s.w_size;
                        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                        have += s.w_size; /* more space now */ 
                        if (s.insert > s.strstart) s.insert = s.strstart;
                    }
                    if (have > s.strm.avail_in) have = s.strm.avail_in;
                    if (have) {
                        read_buf(s.strm, s.window, s.strstart, have);
                        s.strstart += have;
                        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
                    }
                    if (s.high_water < s.strstart) s.high_water = s.strstart;
                    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
                    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
                    min_block = have > s.w_size ? s.w_size : have;
                    left = s.strstart - s.block_start;
                    if (left >= min_block || (left || flush === Z_FINISH$3) && flush !== Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
                        len = left > have ? have : left;
                        last = flush === Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
                        _tr_stored_block(s, s.block_start, len, last);
                        s.block_start += len;
                        flush_pending(s.strm);
                    }
                    /* We've done all we can with the available input and output. */ return last ? BS_FINISH_STARTED : BS_NEED_MORE;
                };
                /* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const deflate_fast = (s, flush)=>{
                    let hash_head; /* head of the hash chain */ 
                    let bflush; /* set if current block must be flushed */ 
                    for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
                            fill_window(s);
                            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) return BS_NEED_MORE;
                            if (s.lookahead === 0) break; /* flush the current block */ 
                        }
                        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
                        if (s.lookahead >= MIN_MATCH) {
                            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                        /***/ }
                        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
                        if (s.match_length >= MIN_MATCH) {
                            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
                            s.lookahead -= s.match_length;
                            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                                s.match_length--; /* string at strstart already in table */ 
                                do {
                                    s.strstart++;
                                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
                                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                                    s.head[s.ins_h] = s.strstart;
                                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                                s.strstart++;
                            } else {
                                s.strstart += s.match_length;
                                s.match_length = 0;
                                s.ins_h = s.window[s.strstart];
                                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);
                            //#if MIN_MATCH != 3
                            //                Call UPDATE_HASH() MIN_MATCH-3 more times
                            //#endif
                            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
                        } else {
                            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
                            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart]);
                            s.lookahead--;
                            s.strstart++;
                        }
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
                    if (flush === Z_FINISH$3) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.sym_next) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                };
                /* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const deflate_slow = (s, flush)=>{
                    let hash_head; /* head of hash chain */ 
                    let bflush; /* set if current block must be flushed */ 
                    let max_insert;
                    /* Process the input block. */ for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
                            fill_window(s);
                            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                             /* flush the current block */ 
                        }
                        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
                        if (s.lookahead >= MIN_MATCH) {
                            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                        /***/ }
                        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
                        s.prev_match = s.match_start;
                        s.match_length = MIN_MATCH - 1;
                        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
                            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
                        }
                        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
                            max_insert = s.strstart + s.lookahead - MIN_MATCH;
                            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
                            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
                            s.prev_length -= 2;
                            do if (++s.strstart <= max_insert) {
                                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
                                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                                s.head[s.ins_h] = s.strstart;
                            /***/ }
                            while (--s.prev_length !== 0);
                            s.match_available = 0;
                            s.match_length = MIN_MATCH - 1;
                            s.strstart++;
                            if (bflush) {
                                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                                if (s.strm.avail_out === 0) return BS_NEED_MORE;
                            /***/ }
                        } else if (s.match_available) {
                            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);
                            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
                            s.strstart++;
                            s.lookahead--;
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        } else {
                            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
                            s.strstart++;
                            s.lookahead--;
                        }
                    }
                    //Assert (flush != Z_NO_FLUSH, "no flush?");
                    if (s.match_available) {
                        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);
                        s.match_available = 0;
                    }
                    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
                    if (flush === Z_FINISH$3) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.sym_next) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                };
                /* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const deflate_rle = (s, flush)=>{
                    let bflush; /* set if current block must be flushed */ 
                    let prev; /* byte at distance one to match */ 
                    let scan, strend; /* scan goes up to strend for length of run */ 
                    const _win = s.window;
                    for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
                            fill_window(s);
                            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$2) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                             /* flush the current block */ 
                        }
                        /* See how many times the previous byte repeats */ s.match_length = 0;
                        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
                            scan = s.strstart - 1;
                            prev = _win[scan];
                            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                                strend = s.strstart + MAX_MATCH;
                                do ;
                                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                                s.match_length = MAX_MATCH - (strend - scan);
                                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
                            }
                        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                        }
                        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
                            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
                            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);
                            s.lookahead -= s.match_length;
                            s.strstart += s.match_length;
                            s.match_length = 0;
                        } else {
                            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
                            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart]);
                            s.lookahead--;
                            s.strstart++;
                        }
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH$3) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.sym_next) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                };
                /* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const deflate_huff = (s, flush)=>{
                    let bflush; /* set if current block must be flushed */ 
                    for(;;){
                        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
                            fill_window(s);
                            if (s.lookahead === 0) {
                                if (flush === Z_NO_FLUSH$2) return BS_NEED_MORE;
                                break; /* flush the current block */ 
                            }
                        }
                        /* Output a literal byte */ s.match_length = 0;
                        //Tracevv((stderr,"%c", s->window[s->strstart]));
                        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart]);
                        s.lookahead--;
                        s.strstart++;
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH$3) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.sym_next) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                };
                /* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
                    this.good_length = good_length;
                    this.max_lazy = max_lazy;
                    this.nice_length = nice_length;
                    this.max_chain = max_chain;
                    this.func = func;
                }
                const configuration_table = [
                    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
                    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
                    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
                    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
                    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
                    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
                    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
                    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
                    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
                    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
                ];
                /* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const lm_init = (s)=>{
                    s.window_size = 2 * s.w_size;
                    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
                    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
                    s.good_match = configuration_table[s.level].good_length;
                    s.nice_match = configuration_table[s.level].nice_length;
                    s.max_chain_length = configuration_table[s.level].max_chain;
                    s.strstart = 0;
                    s.block_start = 0;
                    s.lookahead = 0;
                    s.insert = 0;
                    s.match_length = s.prev_length = MIN_MATCH - 1;
                    s.match_available = 0;
                    s.ins_h = 0;
                };
                function DeflateState() {
                    this.strm = null; /* pointer back to this zlib stream */ 
                    this.status = 0; /* as the name implies */ 
                    this.pending_buf = null; /* output still pending */ 
                    this.pending_buf_size = 0; /* size of pending_buf */ 
                    this.pending_out = 0; /* next pending byte to output to the stream */ 
                    this.pending = 0; /* nb of bytes in the pending buffer */ 
                    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
                    this.gzhead = null; /* gzip header information to write */ 
                    this.gzindex = 0; /* where in extra, name, or comment */ 
                    this.method = Z_DEFLATED$2; /* can only be DEFLATED */ 
                    this.last_flush = -1; /* value of flush param for previous deflate call */ 
                    this.w_size = 0; /* LZ77 window size (32K by default) */ 
                    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
                    this.w_mask = 0; /* w_size - 1 */ 
                    this.window = null;
                    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
                    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
                    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
                    this.ins_h = 0; /* hash index of string to be inserted */ 
                    this.hash_size = 0; /* number of elements in hash table */ 
                    this.hash_bits = 0; /* log2(hash_size) */ 
                    this.hash_mask = 0; /* hash_size-1 */ 
                    this.hash_shift = 0;
                    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
                    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
                    this.prev_match = 0; /* previous match */ 
                    this.match_available = 0; /* set if previous match exists */ 
                    this.strstart = 0; /* start of string to insert */ 
                    this.match_start = 0; /* start of matching string */ 
                    this.lookahead = 0; /* number of valid bytes ahead in window */ 
                    this.prev_length = 0;
                    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
                    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
                    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
                    //this.max_insert_length = 0;
                    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
                    this.strategy = 0; /* favor or force Huffman coding*/ 
                    this.good_match = 0;
                    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
                    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
                    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
                    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
                    // Use flat array of DOUBLE size, with interleaved fata,
                    // because JS does not support effective
                    this.dyn_ltree = new Uint16Array(HEAP_SIZE * 2);
                    this.dyn_dtree = new Uint16Array((2 * D_CODES + 1) * 2);
                    this.bl_tree = new Uint16Array((2 * BL_CODES + 1) * 2);
                    zero(this.dyn_ltree);
                    zero(this.dyn_dtree);
                    zero(this.bl_tree);
                    this.l_desc = null; /* desc. for literal tree */ 
                    this.d_desc = null; /* desc. for distance tree */ 
                    this.bl_desc = null; /* desc. for bit length tree */ 
                    //ush bl_count[MAX_BITS+1];
                    this.bl_count = new Uint16Array(MAX_BITS + 1);
                    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
                    this.heap = new Uint16Array(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
                    zero(this.heap);
                    this.heap_len = 0; /* number of elements in the heap */ 
                    this.heap_max = 0; /* element of largest frequency */ 
                    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
                    zero(this.depth);
                    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
                    this.lit_bufsize = 0;
                    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
                    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
                    this.opt_len = 0; /* bit length of current block with optimal trees */ 
                    this.static_len = 0; /* bit length of current block with static trees */ 
                    this.matches = 0; /* number of string matches in current block */ 
                    this.insert = 0; /* bytes at end of window left to insert */ 
                    this.bi_buf = 0;
                    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
                /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
                // sense only for pointers and memory check tools.
                //this.high_water = 0;
                /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
                /* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const deflateStateCheck = (strm)=>{
                    if (!strm) return 1;
                    const s = strm.state;
                    if (!s || s.strm !== strm || s.status !== INIT_STATE && //#ifdef GZIP
                    s.status !== GZIP_STATE && //#endif
                    s.status !== EXTRA_STATE && s.status !== NAME_STATE && s.status !== COMMENT_STATE && s.status !== HCRC_STATE && s.status !== BUSY_STATE && s.status !== FINISH_STATE) return 1;
                    return 0;
                };
                const deflateResetKeep = (strm)=>{
                    if (deflateStateCheck(strm)) return err(strm, Z_STREAM_ERROR$2);
                    strm.total_in = strm.total_out = 0;
                    strm.data_type = Z_UNKNOWN;
                    const s = strm.state;
                    s.pending = 0;
                    s.pending_out = 0;
                    if (s.wrap < 0) s.wrap = -s.wrap;
                    s.status = //#ifdef GZIP
                    s.wrap === 2 ? GZIP_STATE : //#endif
                    s.wrap ? INIT_STATE : BUSY_STATE;
                    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
                     : 1; // adler32(0, Z_NULL, 0)
                    s.last_flush = -2;
                    _tr_init(s);
                    return Z_OK$3;
                };
                const deflateReset = (strm)=>{
                    const ret = deflateResetKeep(strm);
                    if (ret === Z_OK$3) lm_init(strm.state);
                    return ret;
                };
                const deflateSetHeader = (strm, head)=>{
                    if (deflateStateCheck(strm) || strm.state.wrap !== 2) return Z_STREAM_ERROR$2;
                    strm.state.gzhead = head;
                    return Z_OK$3;
                };
                const deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
                    if (!strm) return Z_STREAM_ERROR$2;
                    let wrap = 1;
                    if (level === Z_DEFAULT_COMPRESSION$1) level = 6;
                    if (windowBits < 0) {
                        wrap = 0;
                        windowBits = -windowBits;
                    } else if (windowBits > 15) {
                        wrap = 2; /* write gzip wrapper instead */ 
                        windowBits -= 16;
                    }
                    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED || windowBits === 8 && wrap !== 1) return err(strm, Z_STREAM_ERROR$2);
                    if (windowBits === 8) windowBits = 9;
                    /* until 256-byte window bug fixed */ const s = new DeflateState();
                    strm.state = s;
                    s.strm = strm;
                    s.status = INIT_STATE; /* to pass state test in deflateReset() */ 
                    s.wrap = wrap;
                    s.gzhead = null;
                    s.w_bits = windowBits;
                    s.w_size = 1 << s.w_bits;
                    s.w_mask = s.w_size - 1;
                    s.hash_bits = memLevel + 7;
                    s.hash_size = 1 << s.hash_bits;
                    s.hash_mask = s.hash_size - 1;
                    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
                    s.window = new Uint8Array(s.w_size * 2);
                    s.head = new Uint16Array(s.hash_size);
                    s.prev = new Uint16Array(s.w_size);
                    // Don't need mem init magic for JS.
                    //s.high_water = 0;  /* nothing written to s->window yet */
                    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
                    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
                    s.pending_buf = new Uint8Array(s.pending_buf_size);
                    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
                    //s->sym_buf = s->pending_buf + s->lit_bufsize;
                    s.sym_buf = s.lit_bufsize;
                    //s->sym_end = (s->lit_bufsize - 1) * 3;
                    s.sym_end = (s.lit_bufsize - 1) * 3;
                    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
                    s.strategy = strategy;
                    s.method = method;
                    return deflateReset(strm);
                };
                const deflateInit = (strm, level)=>{
                    return deflateInit2(strm, level, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
                };
                /* ========================================================================= */ const deflate$2 = (strm, flush)=>{
                    if (deflateStateCheck(strm) || flush > Z_BLOCK$1 || flush < 0) return strm ? err(strm, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
                    const s = strm.state;
                    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === FINISH_STATE && flush !== Z_FINISH$3) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
                    const old_flush = s.last_flush;
                    s.last_flush = flush;
                    /* Flush as much pending output as possible */ if (s.pending !== 0) {
                        flush_pending(strm);
                        if (strm.avail_out === 0) {
                            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
                            return Z_OK$3;
                        }
                    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH$3) return err(strm, Z_BUF_ERROR$1);
                    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR$1);
                    /* Write the header */ if (s.status === INIT_STATE && s.wrap === 0) s.status = BUSY_STATE;
                    if (s.status === INIT_STATE) {
                        /* zlib header */ let header = Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
                        let level_flags = -1;
                        if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
                        else if (s.level < 6) level_flags = 1;
                        else if (s.level === 6) level_flags = 2;
                        else level_flags = 3;
                        header |= level_flags << 6;
                        if (s.strstart !== 0) header |= PRESET_DICT;
                        header += 31 - header % 31;
                        putShortMSB(s, header);
                        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                            putShortMSB(s, strm.adler >>> 16);
                            putShortMSB(s, strm.adler & 0xffff);
                        }
                        strm.adler = 1; // adler32(0L, Z_NULL, 0);
                        s.status = BUSY_STATE;
                        /* Compression must start with an empty pending buffer */ flush_pending(strm);
                        if (s.pending !== 0) {
                            s.last_flush = -1;
                            return Z_OK$3;
                        }
                    }
                    //#ifdef GZIP
                    if (s.status === GZIP_STATE) {
                        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
                        put_byte(s, 31);
                        put_byte(s, 139);
                        put_byte(s, 8);
                        if (!s.gzhead) {
                            put_byte(s, 0);
                            put_byte(s, 0);
                            put_byte(s, 0);
                            put_byte(s, 0);
                            put_byte(s, 0);
                            put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                            put_byte(s, OS_CODE);
                            s.status = BUSY_STATE;
                            /* Compression must start with an empty pending buffer */ flush_pending(strm);
                            if (s.pending !== 0) {
                                s.last_flush = -1;
                                return Z_OK$3;
                            }
                        } else {
                            put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                            put_byte(s, s.gzhead.time & 0xff);
                            put_byte(s, s.gzhead.time >> 8 & 0xff);
                            put_byte(s, s.gzhead.time >> 16 & 0xff);
                            put_byte(s, s.gzhead.time >> 24 & 0xff);
                            put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                            put_byte(s, s.gzhead.os & 0xff);
                            if (s.gzhead.extra && s.gzhead.extra.length) {
                                put_byte(s, s.gzhead.extra.length & 0xff);
                                put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                            }
                            if (s.gzhead.hcrc) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
                            s.gzindex = 0;
                            s.status = EXTRA_STATE;
                        }
                    }
                    if (s.status === EXTRA_STATE) {
                        if (s.gzhead.extra /* != Z_NULL*/ ) {
                            let beg = s.pending; /* start of bytes to update crc */ 
                            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
                            while(s.pending + left > s.pending_buf_size){
                                let copy = s.pending_buf_size - s.pending;
                                // zmemcpy(s.pending_buf + s.pending,
                                //    s.gzhead.extra + s.gzindex, copy);
                                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                                s.pending = s.pending_buf_size;
                                //--- HCRC_UPDATE(beg) ---//
                                if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                                //---//
                                s.gzindex += copy;
                                flush_pending(strm);
                                if (s.pending !== 0) {
                                    s.last_flush = -1;
                                    return Z_OK$3;
                                }
                                beg = 0;
                                left -= copy;
                            }
                            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
                            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
                            let gzhead_extra = new Uint8Array(s.gzhead.extra);
                            // zmemcpy(s->pending_buf + s->pending,
                            //     s->gzhead->extra + s->gzindex, left);
                            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
                            s.pending += left;
                            //--- HCRC_UPDATE(beg) ---//
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            //---//
                            s.gzindex = 0;
                        }
                        s.status = NAME_STATE;
                    }
                    if (s.status === NAME_STATE) {
                        if (s.gzhead.name /* != Z_NULL*/ ) {
                            let beg = s.pending; /* start of bytes to update crc */ 
                            let val;
                            do {
                                if (s.pending === s.pending_buf_size) {
                                    //--- HCRC_UPDATE(beg) ---//
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    //---//
                                    flush_pending(strm);
                                    if (s.pending !== 0) {
                                        s.last_flush = -1;
                                        return Z_OK$3;
                                    }
                                    beg = 0;
                                }
                                // JS specific: little magic to add zero terminator to end of string
                                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                                else val = 0;
                                put_byte(s, val);
                            }while (val !== 0);
                            //--- HCRC_UPDATE(beg) ---//
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            //---//
                            s.gzindex = 0;
                        }
                        s.status = COMMENT_STATE;
                    }
                    if (s.status === COMMENT_STATE) {
                        if (s.gzhead.comment /* != Z_NULL*/ ) {
                            let beg = s.pending; /* start of bytes to update crc */ 
                            let val;
                            do {
                                if (s.pending === s.pending_buf_size) {
                                    //--- HCRC_UPDATE(beg) ---//
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    //---//
                                    flush_pending(strm);
                                    if (s.pending !== 0) {
                                        s.last_flush = -1;
                                        return Z_OK$3;
                                    }
                                    beg = 0;
                                }
                                // JS specific: little magic to add zero terminator to end of string
                                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                                else val = 0;
                                put_byte(s, val);
                            }while (val !== 0);
                            //--- HCRC_UPDATE(beg) ---//
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                        //---//
                        }
                        s.status = HCRC_STATE;
                    }
                    if (s.status === HCRC_STATE) {
                        if (s.gzhead.hcrc) {
                            if (s.pending + 2 > s.pending_buf_size) {
                                flush_pending(strm);
                                if (s.pending !== 0) {
                                    s.last_flush = -1;
                                    return Z_OK$3;
                                }
                            }
                            put_byte(s, strm.adler & 0xff);
                            put_byte(s, strm.adler >> 8 & 0xff);
                            strm.adler = 0; //crc32(0L, Z_NULL, 0);
                        }
                        s.status = BUSY_STATE;
                        /* Compression must start with an empty pending buffer */ flush_pending(strm);
                        if (s.pending !== 0) {
                            s.last_flush = -1;
                            return Z_OK$3;
                        }
                    }
                    //#endif
                    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH$2 && s.status !== FINISH_STATE) {
                        let bstate = s.level === 0 ? deflate_stored(s, flush) : s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
                        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
                        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                            if (strm.avail_out === 0) s.last_flush = -1;
                            return Z_OK$3;
                        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
                        if (bstate === BS_BLOCK_DONE) {
                            if (flush === Z_PARTIAL_FLUSH) _tr_align(s);
                            else if (flush !== Z_BLOCK$1) {
                                _tr_stored_block(s, 0, 0, false);
                                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH$1) {
                                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                                    if (s.lookahead === 0) {
                                        s.strstart = 0;
                                        s.block_start = 0;
                                        s.insert = 0;
                                    }
                                }
                            }
                            flush_pending(strm);
                            if (strm.avail_out === 0) {
                                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                                return Z_OK$3;
                            }
                        }
                    }
                    if (flush !== Z_FINISH$3) return Z_OK$3;
                    if (s.wrap <= 0) return Z_STREAM_END$3;
                    /* Write the trailer */ if (s.wrap === 2) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, strm.adler >> 8 & 0xff);
                        put_byte(s, strm.adler >> 16 & 0xff);
                        put_byte(s, strm.adler >> 24 & 0xff);
                        put_byte(s, strm.total_in & 0xff);
                        put_byte(s, strm.total_in >> 8 & 0xff);
                        put_byte(s, strm.total_in >> 16 & 0xff);
                        put_byte(s, strm.total_in >> 24 & 0xff);
                    } else {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    flush_pending(strm);
                    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
                    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3;
                };
                const deflateEnd = (strm)=>{
                    if (deflateStateCheck(strm)) return Z_STREAM_ERROR$2;
                    const status = strm.state.status;
                    strm.state = null;
                    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$2) : Z_OK$3;
                };
                /* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const deflateSetDictionary = (strm, dictionary)=>{
                    let dictLength = dictionary.length;
                    if (deflateStateCheck(strm)) return Z_STREAM_ERROR$2;
                    const s = strm.state;
                    const wrap = s.wrap;
                    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR$2;
                    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
                    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
                    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
                        if (wrap === 0) {
                            /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
                            s.strstart = 0;
                            s.block_start = 0;
                            s.insert = 0;
                        }
                        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
                        let tmpDict = new Uint8Array(s.w_size);
                        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
                        dictionary = tmpDict;
                        dictLength = s.w_size;
                    }
                    /* insert dictionary into window and hash */ const avail = strm.avail_in;
                    const next = strm.next_in;
                    const input = strm.input;
                    strm.avail_in = dictLength;
                    strm.next_in = 0;
                    strm.input = dictionary;
                    fill_window(s);
                    while(s.lookahead >= MIN_MATCH){
                        let str = s.strstart;
                        let n = s.lookahead - (MIN_MATCH - 1);
                        do {
                            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);
                            s.prev[str & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = str;
                            str++;
                        }while (--n);
                        s.strstart = str;
                        s.lookahead = MIN_MATCH - 1;
                        fill_window(s);
                    }
                    s.strstart += s.lookahead;
                    s.block_start = s.strstart;
                    s.insert = s.lookahead;
                    s.lookahead = 0;
                    s.match_length = s.prev_length = MIN_MATCH - 1;
                    s.match_available = 0;
                    strm.next_in = next;
                    strm.input = input;
                    strm.avail_in = avail;
                    s.wrap = wrap;
                    return Z_OK$3;
                };
                var deflateInit_1 = deflateInit;
                var deflateInit2_1 = deflateInit2;
                var deflateReset_1 = deflateReset;
                var deflateResetKeep_1 = deflateResetKeep;
                var deflateSetHeader_1 = deflateSetHeader;
                var deflate_2$1 = deflate$2;
                var deflateEnd_1 = deflateEnd;
                var deflateSetDictionary_1 = deflateSetDictionary;
                var deflateInfo = 'pako deflate (from Nodeca project)';
                /* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var deflate_1$2 = {
                    deflateInit: deflateInit_1,
                    deflateInit2: deflateInit2_1,
                    deflateReset: deflateReset_1,
                    deflateResetKeep: deflateResetKeep_1,
                    deflateSetHeader: deflateSetHeader_1,
                    deflate: deflate_2$1,
                    deflateEnd: deflateEnd_1,
                    deflateSetDictionary: deflateSetDictionary_1,
                    deflateInfo: deflateInfo
                };
                const _has = (obj, key)=>{
                    return Object.prototype.hasOwnProperty.call(obj, key);
                };
                var assign = function(obj /*from1, from2, from3, ...*/ ) {
                    const sources = Array.prototype.slice.call(arguments, 1);
                    while(sources.length){
                        const source = sources.shift();
                        if (!source) continue;
                        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
                        for(const p in source)if (_has(source, p)) obj[p] = source[p];
                    }
                    return obj;
                };
                // Join array of chunks to single array.
                var flattenChunks = (chunks)=>{
                    // calculate data length
                    let len = 0;
                    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
                    // join chunks
                    const result = new Uint8Array(len);
                    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
                        let chunk = chunks[i];
                        result.set(chunk, pos);
                        pos += chunk.length;
                    }
                    return result;
                };
                var common = {
                    assign: assign,
                    flattenChunks: flattenChunks
                };
                // String encode/decode helpers
                // Quick check if we can use fast array to bin string conversion
                //
                // - apply(Array) can fail on Android 2.2
                // - apply(Uint8Array) can fail on iOS 5.1 Safari
                //
                let STR_APPLY_UIA_OK = true;
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (__) {
                    STR_APPLY_UIA_OK = false;
                }
                // Table with utf8 lengths (calculated by first byte of sequence)
                // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
                // because max possible codepoint is 0x10ffff
                const _utf8len = new Uint8Array(256);
                for(let q = 0; q < 256; q++)_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
                _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
                // convert string to array (typed, when possible)
                var string2buf = (str)=>{
                    if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
                    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
                    // count binary size
                    for(m_pos = 0; m_pos < str_len; m_pos++){
                        c = str.charCodeAt(m_pos);
                        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                            c2 = str.charCodeAt(m_pos + 1);
                            if ((c2 & 0xfc00) === 0xdc00) {
                                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                                m_pos++;
                            }
                        }
                        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
                    }
                    // allocate buffer
                    buf = new Uint8Array(buf_len);
                    // convert
                    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
                        c = str.charCodeAt(m_pos);
                        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                            c2 = str.charCodeAt(m_pos + 1);
                            if ((c2 & 0xfc00) === 0xdc00) {
                                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                                m_pos++;
                            }
                        }
                        if (c < 0x80) /* one byte */ buf[i++] = c;
                        else if (c < 0x800) {
                            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
                            buf[i++] = 0x80 | c & 0x3f;
                        } else if (c < 0x10000) {
                            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
                            buf[i++] = 0x80 | c >>> 6 & 0x3f;
                            buf[i++] = 0x80 | c & 0x3f;
                        } else {
                            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
                            buf[i++] = 0x80 | c >>> 12 & 0x3f;
                            buf[i++] = 0x80 | c >>> 6 & 0x3f;
                            buf[i++] = 0x80 | c & 0x3f;
                        }
                    }
                    return buf;
                };
                // Helper
                const buf2binstring = (buf, len)=>{
                    // On Chrome, the arguments in a function call that are allowed is `65534`.
                    // If the length of the buffer is smaller than that, we can use this optimization,
                    // otherwise we will take a slower path.
                    if (len < 65534) {
                        if (buf.subarray && STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
                    }
                    let result = '';
                    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
                    return result;
                };
                // convert array to string
                var buf2string = (buf, max)=>{
                    const len = max || buf.length;
                    if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
                    let i, out;
                    // Reserve max possible length (2 words per char)
                    // NB: by unknown reasons, Array is significantly faster for
                    //     String.fromCharCode.apply than Uint16Array.
                    const utf16buf = new Array(len * 2);
                    for(out = 0, i = 0; i < len;){
                        let c = buf[i++];
                        // quick process ascii
                        if (c < 0x80) {
                            utf16buf[out++] = c;
                            continue;
                        }
                        let c_len = _utf8len[c];
                        // skip 5 & 6 byte codes
                        if (c_len > 4) {
                            utf16buf[out++] = 0xfffd;
                            i += c_len - 1;
                            continue;
                        }
                        // apply mask on first byte
                        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
                        // join the rest
                        while(c_len > 1 && i < len){
                            c = c << 6 | buf[i++] & 0x3f;
                            c_len--;
                        }
                        // terminated by end of string?
                        if (c_len > 1) {
                            utf16buf[out++] = 0xfffd;
                            continue;
                        }
                        if (c < 0x10000) utf16buf[out++] = c;
                        else {
                            c -= 0x10000;
                            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
                            utf16buf[out++] = 0xdc00 | c & 0x3ff;
                        }
                    }
                    return buf2binstring(utf16buf, out);
                };
                // Calculate max possible position in utf8 buffer,
                // that will not break sequence. If that's not possible
                // - (very small limits) return max size as is.
                //
                // buf[] - utf8 bytes array
                // max   - length limit (mandatory);
                var utf8border = (buf, max)=>{
                    max = max || buf.length;
                    if (max > buf.length) max = buf.length;
                    // go back from last position, until start of sequence found
                    let pos = max - 1;
                    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
                    // Very small and broken sequence,
                    // return max, because we should return something anyway.
                    if (pos < 0) return max;
                    // If we came to start of buffer - that means buffer is too small,
                    // return max too.
                    if (pos === 0) return max;
                    return pos + _utf8len[buf[pos]] > max ? pos : max;
                };
                var strings = {
                    string2buf: string2buf,
                    buf2string: buf2string,
                    utf8border: utf8border
                };
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                function ZStream() {
                    /* next input byte */ this.input = null; // JS specific, because we have no pointers
                    this.next_in = 0;
                    /* number of bytes available at input */ this.avail_in = 0;
                    /* total number of input bytes read so far */ this.total_in = 0;
                    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
                    this.next_out = 0;
                    /* remaining free space at output */ this.avail_out = 0;
                    /* total number of bytes output so far */ this.total_out = 0;
                    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
                    /* not visible by applications */ this.state = null;
                    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
                    /* adler32 value of the uncompressed data */ this.adler = 0;
                }
                var zstream = ZStream;
                const toString$1 = Object.prototype.toString;
                /* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: Z_NO_FLUSH$1, Z_SYNC_FLUSH, Z_FULL_FLUSH, Z_FINISH: Z_FINISH$2, Z_OK: Z_OK$2, Z_STREAM_END: Z_STREAM_END$2, Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY, Z_DEFLATED: Z_DEFLATED$1 } = constants$2;
                /* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function Deflate$1(options) {
                    this.options = common.assign({
                        level: Z_DEFAULT_COMPRESSION,
                        method: Z_DEFLATED$1,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: Z_DEFAULT_STRATEGY
                    }, options || {});
                    let opt = this.options;
                    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
                    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
                    this.err = 0; // error code, if happens (0 = Z_OK)
                    this.msg = ''; // error message
                    this.ended = false; // used to avoid multiple onEnd() calls
                    this.chunks = []; // chunks of compressed data
                    this.strm = new zstream();
                    this.strm.avail_out = 0;
                    let status = deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
                    if (status !== Z_OK$2) throw new Error(messages[status]);
                    if (opt.header) deflate_1$2.deflateSetHeader(this.strm, opt.header);
                    if (opt.dictionary) {
                        let dict;
                        // Convert data if needed
                        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
                        dict = strings.string2buf(opt.dictionary);
                        else if (toString$1.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
                        else dict = opt.dictionary;
                        status = deflate_1$2.deflateSetDictionary(this.strm, dict);
                        if (status !== Z_OK$2) throw new Error(messages[status]);
                        this._dict_set = true;
                    }
                }
                /**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ Deflate$1.prototype.push = function(data, flush_mode) {
                    const strm = this.strm;
                    const chunkSize = this.options.chunkSize;
                    let status, _flush_mode;
                    if (this.ended) return false;
                    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
                    else _flush_mode = flush_mode === true ? Z_FINISH$2 : Z_NO_FLUSH$1;
                    // Convert data if needed
                    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
                    strm.input = strings.string2buf(data);
                    else if (toString$1.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
                    else strm.input = data;
                    strm.next_in = 0;
                    strm.avail_in = strm.input.length;
                    for(;;){
                        if (strm.avail_out === 0) {
                            strm.output = new Uint8Array(chunkSize);
                            strm.next_out = 0;
                            strm.avail_out = chunkSize;
                        }
                        // Make sure avail_out > 6 to avoid repeating markers
                        if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH) && strm.avail_out <= 6) {
                            this.onData(strm.output.subarray(0, strm.next_out));
                            strm.avail_out = 0;
                            continue;
                        }
                        status = deflate_1$2.deflate(strm, _flush_mode);
                        // Ended => flush and finish
                        if (status === Z_STREAM_END$2) {
                            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
                            status = deflate_1$2.deflateEnd(this.strm);
                            this.onEnd(status);
                            this.ended = true;
                            return status === Z_OK$2;
                        }
                        // Flush if out buffer full
                        if (strm.avail_out === 0) {
                            this.onData(strm.output);
                            continue;
                        }
                        // Flush if requested and has data
                        if (_flush_mode > 0 && strm.next_out > 0) {
                            this.onData(strm.output.subarray(0, strm.next_out));
                            strm.avail_out = 0;
                            continue;
                        }
                        if (strm.avail_in === 0) break;
                    }
                    return true;
                };
                /**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ Deflate$1.prototype.onData = function(chunk) {
                    this.chunks.push(chunk);
                };
                /**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ Deflate$1.prototype.onEnd = function(status) {
                    // On success - join
                    if (status === Z_OK$2) this.result = common.flattenChunks(this.chunks);
                    this.chunks = [];
                    this.err = status;
                    this.msg = this.strm.msg;
                };
                /**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function deflate$1(input, options) {
                    const deflator = new Deflate$1(options);
                    deflator.push(input, true);
                    // That will never happens, if you don't cheat with options :)
                    if (deflator.err) throw deflator.msg || messages[deflator.err];
                    return deflator.result;
                }
                /**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function deflateRaw$1(input, options) {
                    options = options || {};
                    options.raw = true;
                    return deflate$1(input, options);
                }
                /**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function gzip$1(input, options) {
                    options = options || {};
                    options.gzip = true;
                    return deflate$1(input, options);
                }
                var Deflate_1$1 = Deflate$1;
                var deflate_2 = deflate$1;
                var deflateRaw_1$1 = deflateRaw$1;
                var gzip_1$1 = gzip$1;
                var constants$1 = constants$2;
                var deflate_1$1 = {
                    Deflate: Deflate_1$1,
                    deflate: deflate_2,
                    deflateRaw: deflateRaw_1$1,
                    gzip: gzip_1$1,
                    constants: constants$1
                };
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                // See state defs from inflate.js
                const BAD$1 = 16209; /* got a data error -- remain here until reset */ 
                const TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
                /*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var inffast = function inflate_fast(strm, start) {
                    let _in; /* local strm.input */ 
                    let last; /* have enough input while in < last */ 
                    let _out; /* local strm.output */ 
                    let beg; /* inflate()'s initial strm.output */ 
                    let end; /* while out < end, enough space available */ 
                    //#ifdef INFLATE_STRICT
                    let dmax; /* maximum distance from zlib header */ 
                    //#endif
                    let wsize; /* window size or zero if not using window */ 
                    let whave; /* valid bytes in the window */ 
                    let wnext; /* window write index */ 
                    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
                    let s_window; /* allocated sliding window, if wsize != 0 */ 
                    let hold; /* local strm.hold */ 
                    let bits; /* local strm.bits */ 
                    let lcode; /* local strm.lencode */ 
                    let dcode; /* local strm.distcode */ 
                    let lmask; /* mask for first level of length codes */ 
                    let dmask; /* mask for first level of distance codes */ 
                    let here; /* retrieved table entry */ 
                    let op; /* code bits, operation, extra bits, or */ 
                    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
                    let dist; /* match distance */ 
                    let from; /* where to copy match from */ 
                    let from_source;
                    let input, output; // JS specific, because we have no pointers
                    /* copy state to local variables */ const state = strm.state;
                    //here = state.here;
                    _in = strm.next_in;
                    input = strm.input;
                    last = _in + (strm.avail_in - 5);
                    _out = strm.next_out;
                    output = strm.output;
                    beg = _out - (start - strm.avail_out);
                    end = _out + (strm.avail_out - 257);
                    //#ifdef INFLATE_STRICT
                    dmax = state.dmax;
                    //#endif
                    wsize = state.wsize;
                    whave = state.whave;
                    wnext = state.wnext;
                    s_window = state.window;
                    hold = state.hold;
                    bits = state.bits;
                    lcode = state.lencode;
                    dcode = state.distcode;
                    lmask = (1 << state.lenbits) - 1;
                    dmask = (1 << state.distbits) - 1;
                    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
                        if (bits < 15) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            hold += input[_in++] << bits;
                            bits += 8;
                        }
                        here = lcode[hold & lmask];
                        dolen: for(;;){
                            op = here >>> 24 /*here.bits*/ ;
                            hold >>>= op;
                            bits -= op;
                            op = here >>> 16 & 0xff /*here.op*/ ;
                            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                            //        "inflate:         literal '%c'\n" :
                            //        "inflate:         literal 0x%02x\n", here.val));
                            output[_out++] = here & 0xffff /*here.val*/ ;
                            else if (op & 16) {
                                len = here & 0xffff /*here.val*/ ;
                                op &= 15; /* number of extra bits */ 
                                if (op) {
                                    if (bits < op) {
                                        hold += input[_in++] << bits;
                                        bits += 8;
                                    }
                                    len += hold & (1 << op) - 1;
                                    hold >>>= op;
                                    bits -= op;
                                }
                                //Tracevv((stderr, "inflate:         length %u\n", len));
                                if (bits < 15) {
                                    hold += input[_in++] << bits;
                                    bits += 8;
                                    hold += input[_in++] << bits;
                                    bits += 8;
                                }
                                here = dcode[hold & dmask];
                                dodist: for(;;){
                                    op = here >>> 24 /*here.bits*/ ;
                                    hold >>>= op;
                                    bits -= op;
                                    op = here >>> 16 & 0xff /*here.op*/ ;
                                    if (op & 16) {
                                        dist = here & 0xffff /*here.val*/ ;
                                        op &= 15; /* number of extra bits */ 
                                        if (bits < op) {
                                            hold += input[_in++] << bits;
                                            bits += 8;
                                            if (bits < op) {
                                                hold += input[_in++] << bits;
                                                bits += 8;
                                            }
                                        }
                                        dist += hold & (1 << op) - 1;
                                        //#ifdef INFLATE_STRICT
                                        if (dist > dmax) {
                                            strm.msg = 'invalid distance too far back';
                                            state.mode = BAD$1;
                                            break top;
                                        }
                                        //#endif
                                        hold >>>= op;
                                        bits -= op;
                                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                                        op = _out - beg; /* max distance in output */ 
                                        if (dist > op) {
                                            op = dist - op; /* distance back in window */ 
                                            if (op > whave) {
                                                if (state.sane) {
                                                    strm.msg = 'invalid distance too far back';
                                                    state.mode = BAD$1;
                                                    break top;
                                                }
                                            }
                                            from = 0; // window index
                                            from_source = s_window;
                                            if (wnext === 0) {
                                                from += wsize - op;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = s_window[from++];
                                                    while (--op);
                                                    from = _out - dist; /* rest from output */ 
                                                    from_source = output;
                                                }
                                            } else if (wnext < op) {
                                                from += wsize + wnext - op;
                                                op -= wnext;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = s_window[from++];
                                                    while (--op);
                                                    from = 0;
                                                    if (wnext < len) {
                                                        op = wnext;
                                                        len -= op;
                                                        do output[_out++] = s_window[from++];
                                                        while (--op);
                                                        from = _out - dist; /* rest from output */ 
                                                        from_source = output;
                                                    }
                                                }
                                            } else {
                                                from += wnext - op;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = s_window[from++];
                                                    while (--op);
                                                    from = _out - dist; /* rest from output */ 
                                                    from_source = output;
                                                }
                                            }
                                            while(len > 2){
                                                output[_out++] = from_source[from++];
                                                output[_out++] = from_source[from++];
                                                output[_out++] = from_source[from++];
                                                len -= 3;
                                            }
                                            if (len) {
                                                output[_out++] = from_source[from++];
                                                if (len > 1) output[_out++] = from_source[from++];
                                            }
                                        } else {
                                            from = _out - dist; /* copy direct from output */ 
                                            do {
                                                output[_out++] = output[from++];
                                                output[_out++] = output[from++];
                                                output[_out++] = output[from++];
                                                len -= 3;
                                            }while (len > 2);
                                            if (len) {
                                                output[_out++] = output[from++];
                                                if (len > 1) output[_out++] = output[from++];
                                            }
                                        }
                                    } else if ((op & 64) === 0) {
                                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                                        continue dodist;
                                    } else {
                                        strm.msg = 'invalid distance code';
                                        state.mode = BAD$1;
                                        break top;
                                    }
                                    break; // need to emulate goto via "continue"
                                }
                            } else if ((op & 64) === 0) {
                                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                                continue dolen;
                            } else if (op & 32) {
                                //Tracevv((stderr, "inflate:         end of block\n"));
                                state.mode = TYPE$1;
                                break top;
                            } else {
                                strm.msg = 'invalid literal/length code';
                                state.mode = BAD$1;
                                break top;
                            }
                            break; // need to emulate goto via "continue"
                        }
                    }while (_in < last && _out < end);
                    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
                    _in -= len;
                    bits -= len << 3;
                    hold &= (1 << bits) - 1;
                    /* update state and return */ strm.next_in = _in;
                    strm.next_out = _out;
                    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
                    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
                    state.hold = hold;
                    state.bits = bits;
                    return;
                };
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                const MAXBITS = 15;
                const ENOUGH_LENS$1 = 852;
                const ENOUGH_DISTS$1 = 592;
                //const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
                const CODES$1 = 0;
                const LENS$1 = 1;
                const DISTS$1 = 2;
                const lbase = new Uint16Array([
                    /* Length codes 257..285 base */ 3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ]);
                const lext = new Uint8Array([
                    /* Length codes 257..285 extra */ 16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ]);
                const dbase = new Uint16Array([
                    /* Distance codes 0..29 base */ 1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ]);
                const dext = new Uint8Array([
                    /* Distance codes 0..29 extra */ 16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ]);
                const inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
                    const bits = opts.bits;
                    //here = opts.here; /* table entry for duplication */
                    let len = 0; /* a code's length in bits */ 
                    let sym = 0; /* index of code symbols */ 
                    let min = 0, max = 0; /* minimum and maximum code lengths */ 
                    let root = 0; /* number of index bits for root table */ 
                    let curr = 0; /* number of index bits for current table */ 
                    let drop = 0; /* code bits to drop for sub-table */ 
                    let left = 0; /* number of prefix codes available */ 
                    let used = 0; /* code entries in table used */ 
                    let huff = 0; /* Huffman code */ 
                    let incr; /* for incrementing code, index */ 
                    let fill; /* index for replicating entries */ 
                    let low; /* low bits for current root entry */ 
                    let mask; /* mask for low root bits */ 
                    let next; /* next available space in table */ 
                    let base = null; /* base value table to use */ 
                    //  let shoextra;    /* extra bits table to use */
                    let match; /* use base and extra for symbol >= match */ 
                    const count = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
                    const offs = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
                    let extra = null;
                    let here_bits, here_op, here_val;
                    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
                    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
                    /* bound code lengths, force root to be within code lengths */ root = bits;
                    for(max = MAXBITS; max >= 1; max--){
                        if (count[max] !== 0) break;
                    }
                    if (root > max) root = max;
                    if (max === 0) {
                        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
                        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
                        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
                        table[table_index++] = 20971520;
                        //table.op[opts.table_index] = 64;
                        //table.bits[opts.table_index] = 1;
                        //table.val[opts.table_index++] = 0;
                        table[table_index++] = 20971520;
                        opts.bits = 1;
                        return 0; /* no symbols, but wait for decoding to report error */ 
                    }
                    for(min = 1; min < max; min++){
                        if (count[min] !== 0) break;
                    }
                    if (root < min) root = min;
                    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
                    for(len = 1; len <= MAXBITS; len++){
                        left <<= 1;
                        left -= count[len];
                        if (left < 0) return -1;
                         /* over-subscribed */ 
                    }
                    if (left > 0 && (type === CODES$1 || max !== 1)) return -1; /* incomplete set */ 
                    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
                    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
                    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
                    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
                    // to avoid deopts in old v8
                    if (type === CODES$1) {
                        base = extra = work; /* dummy value--not used */ 
                        match = 20;
                    } else if (type === LENS$1) {
                        base = lbase;
                        extra = lext;
                        match = 257;
                    } else {
                        base = dbase;
                        extra = dext;
                        match = 0;
                    }
                    /* initialize opts for loop */ huff = 0; /* starting code */ 
                    sym = 0; /* starting code symbol */ 
                    len = min; /* starting code length */ 
                    next = table_index; /* current table to fill in */ 
                    curr = root; /* current table index bits */ 
                    drop = 0; /* current bits to drop from code for index */ 
                    low = -1; /* trigger new sub-table when len > root */ 
                    used = 1 << root; /* use root table entries */ 
                    mask = used - 1; /* mask for comparing low */ 
                    /* check available table space */ if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
                    /* process all codes and make table entries */ for(;;){
                        /* create table entry */ here_bits = len - drop;
                        if (work[sym] + 1 < match) {
                            here_op = 0;
                            here_val = work[sym];
                        } else if (work[sym] >= match) {
                            here_op = extra[work[sym] - match];
                            here_val = base[work[sym] - match];
                        } else {
                            here_op = 96; /* end of block */ 
                            here_val = 0;
                        }
                        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
                        fill = 1 << curr;
                        min = fill; /* save offset to next table */ 
                        do {
                            fill -= incr;
                            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
                        }while (fill !== 0);
                        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
                        while(huff & incr)incr >>= 1;
                        if (incr !== 0) {
                            huff &= incr - 1;
                            huff += incr;
                        } else huff = 0;
                        /* go to next symbol, update count, len */ sym++;
                        if (--count[len] === 0) {
                            if (len === max) break;
                            len = lens[lens_index + work[sym]];
                        }
                        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
                            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
                            /* increment past last table */ next += min; /* here min is 1 << curr */ 
                            /* determine length of next table */ curr = len - drop;
                            left = 1 << curr;
                            while(curr + drop < max){
                                left -= count[curr + drop];
                                if (left <= 0) break;
                                curr++;
                                left <<= 1;
                            }
                            /* check for enough space */ used += 1 << curr;
                            if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
                            /* point entry in root table to sub-table */ low = huff & mask;
                            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
                        }
                    }
                    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
                    //table.bits[next + huff] = len - drop;
                    //table.val[next + huff] = 0;
                    table[next + huff] = len - drop << 24 | 4194304;
                    /* set return parameters */ //opts.table_index += used;
                    opts.bits = root;
                    return 0;
                };
                var inftrees = inflate_table;
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                const CODES = 0;
                const LENS = 1;
                const DISTS = 2;
                /* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: Z_FINISH$1, Z_BLOCK, Z_TREES, Z_OK: Z_OK$1, Z_STREAM_END: Z_STREAM_END$1, Z_NEED_DICT: Z_NEED_DICT$1, Z_STREAM_ERROR: Z_STREAM_ERROR$1, Z_DATA_ERROR: Z_DATA_ERROR$1, Z_MEM_ERROR: Z_MEM_ERROR$1, Z_BUF_ERROR, Z_DEFLATED } = constants$2;
                /* STATES ====================================================================*/ /* ===========================================================================*/ const HEAD = 16180; /* i: waiting for magic header */ 
                const FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
                const TIME = 16182; /* i: waiting for modification time (gzip) */ 
                const OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
                const EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
                const EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
                const NAME = 16186; /* i: waiting for end of file name (gzip) */ 
                const COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
                const HCRC = 16188; /* i: waiting for header crc (gzip) */ 
                const DICTID = 16189; /* i: waiting for dictionary check value */ 
                const DICT = 16190; /* waiting for inflateSetDictionary() call */ 
                const TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
                const TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
                const STORED = 16193; /* i: waiting for stored size (length and complement) */ 
                const COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
                const COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
                const TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
                const LENLENS = 16197; /* i: waiting for code length code lengths */ 
                const CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
                const LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
                const LEN = 16200; /* i: waiting for length/lit/eob code */ 
                const LENEXT = 16201; /* i: waiting for length extra bits */ 
                const DIST = 16202; /* i: waiting for distance code */ 
                const DISTEXT = 16203; /* i: waiting for distance extra bits */ 
                const MATCH = 16204; /* o: waiting for output space to copy string */ 
                const LIT = 16205; /* o: waiting for output space to write literal */ 
                const CHECK = 16206; /* i: waiting for 32-bit check value */ 
                const LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
                const DONE = 16208; /* finished check, done -- remain here until reset */ 
                const BAD = 16209; /* got a data error -- remain here until reset */ 
                const MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
                const SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
                /* ===========================================================================*/ const ENOUGH_LENS = 852;
                const ENOUGH_DISTS = 592;
                //const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
                const MAX_WBITS = 15;
                /* 32K LZ77 window */ const DEF_WBITS = MAX_WBITS;
                const zswap32 = (q)=>{
                    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
                };
                function InflateState() {
                    this.strm = null; /* pointer back to this zlib stream */ 
                    this.mode = 0; /* current inflate mode */ 
                    this.last = false; /* true if processing last block */ 
                    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
                    this.havedict = false; /* true if dictionary provided */ 
                    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
                    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
                    this.check = 0; /* protected copy of check value */ 
                    this.total = 0; /* protected copy of output count */ 
                    // TODO: may be {}
                    this.head = null; /* where to save gzip header information */ 
                    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
                    this.wsize = 0; /* window size or zero if not using window */ 
                    this.whave = 0; /* valid bytes in the window */ 
                    this.wnext = 0; /* window write index */ 
                    this.window = null; /* allocated sliding window, if needed */ 
                    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
                    this.bits = 0; /* number of bits in "in" */ 
                    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
                    this.offset = 0; /* distance back to copy string from */ 
                    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
                    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
                    this.distcode = null; /* starting table for distance codes */ 
                    this.lenbits = 0; /* index bits for lencode */ 
                    this.distbits = 0; /* index bits for distcode */ 
                    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
                    this.nlen = 0; /* number of length code lengths */ 
                    this.ndist = 0; /* number of distance code lengths */ 
                    this.have = 0; /* number of code lengths in lens[] */ 
                    this.next = null; /* next available space in codes[] */ 
                    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
                    this.work = new Uint16Array(288); /* work area for code table building */ 
                    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
                    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
                    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
                    this.sane = 0; /* if false, allow invalid distance too far */ 
                    this.back = 0; /* bits back of last unprocessed length/lit */ 
                    this.was = 0; /* initial length of match */ 
                }
                const inflateStateCheck = (strm)=>{
                    if (!strm) return 1;
                    const state = strm.state;
                    if (!state || state.strm !== strm || state.mode < HEAD || state.mode > SYNC) return 1;
                    return 0;
                };
                const inflateResetKeep = (strm)=>{
                    if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
                    const state = strm.state;
                    strm.total_in = strm.total_out = state.total = 0;
                    strm.msg = ''; /*Z_NULL*/ 
                    if (state.wrap) strm.adler = state.wrap & 1;
                    state.mode = HEAD;
                    state.last = 0;
                    state.havedict = 0;
                    state.flags = -1;
                    state.dmax = 32768;
                    state.head = null /*Z_NULL*/ ;
                    state.hold = 0;
                    state.bits = 0;
                    //state.lencode = state.distcode = state.next = state.codes;
                    state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS);
                    state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS);
                    state.sane = 1;
                    state.back = -1;
                    //Tracev((stderr, "inflate: reset\n"));
                    return Z_OK$1;
                };
                const inflateReset = (strm)=>{
                    if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
                    const state = strm.state;
                    state.wsize = 0;
                    state.whave = 0;
                    state.wnext = 0;
                    return inflateResetKeep(strm);
                };
                const inflateReset2 = (strm, windowBits)=>{
                    let wrap;
                    /* get the state */ if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
                    const state = strm.state;
                    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
                        wrap = 0;
                        windowBits = -windowBits;
                    } else {
                        wrap = (windowBits >> 4) + 5;
                        if (windowBits < 48) windowBits &= 15;
                    }
                    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR$1;
                    if (state.window !== null && state.wbits !== windowBits) state.window = null;
                    /* update state and reset the rest of it */ state.wrap = wrap;
                    state.wbits = windowBits;
                    return inflateReset(strm);
                };
                const inflateInit2 = (strm, windowBits)=>{
                    if (!strm) return Z_STREAM_ERROR$1;
                    //strm.msg = Z_NULL;                 /* in case we return an error */
                    const state = new InflateState();
                    //if (state === Z_NULL) return Z_MEM_ERROR;
                    //Tracev((stderr, "inflate: allocated\n"));
                    strm.state = state;
                    state.strm = strm;
                    state.window = null /*Z_NULL*/ ;
                    state.mode = HEAD; /* to pass state test in inflateReset2() */ 
                    const ret = inflateReset2(strm, windowBits);
                    if (ret !== Z_OK$1) strm.state = null /*Z_NULL*/ ;
                    return ret;
                };
                const inflateInit = (strm)=>{
                    return inflateInit2(strm, DEF_WBITS);
                };
                /*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let virgin = true;
                let lenfix, distfix; // We have no pointers in JS, so keep tables separate
                const fixedtables = (state)=>{
                    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
                        lenfix = new Int32Array(512);
                        distfix = new Int32Array(32);
                        /* literal/length table */ let sym = 0;
                        while(sym < 144)state.lens[sym++] = 8;
                        while(sym < 256)state.lens[sym++] = 9;
                        while(sym < 280)state.lens[sym++] = 7;
                        while(sym < 288)state.lens[sym++] = 8;
                        inftrees(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
                            bits: 9
                        });
                        /* distance table */ sym = 0;
                        while(sym < 32)state.lens[sym++] = 5;
                        inftrees(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
                            bits: 5
                        });
                        /* do this just once */ virgin = false;
                    }
                    state.lencode = lenfix;
                    state.lenbits = 9;
                    state.distcode = distfix;
                    state.distbits = 5;
                };
                /*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const updatewindow = (strm, src, end, copy)=>{
                    let dist;
                    const state = strm.state;
                    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
                        state.wsize = 1 << state.wbits;
                        state.wnext = 0;
                        state.whave = 0;
                        state.window = new Uint8Array(state.wsize);
                    }
                    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
                        state.window.set(src.subarray(end - state.wsize, end), 0);
                        state.wnext = 0;
                        state.whave = state.wsize;
                    } else {
                        dist = state.wsize - state.wnext;
                        if (dist > copy) dist = copy;
                        //zmemcpy(state->window + state->wnext, end - copy, dist);
                        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
                        copy -= dist;
                        if (copy) {
                            //zmemcpy(state->window, end - copy, copy);
                            state.window.set(src.subarray(end - copy, end), 0);
                            state.wnext = copy;
                            state.whave = state.wsize;
                        } else {
                            state.wnext += dist;
                            if (state.wnext === state.wsize) state.wnext = 0;
                            if (state.whave < state.wsize) state.whave += dist;
                        }
                    }
                    return 0;
                };
                const inflate$2 = (strm, flush)=>{
                    let state;
                    let input, output; // input/output buffers
                    let next; /* next input INDEX */ 
                    let put; /* next output INDEX */ 
                    let have, left; /* available input and output */ 
                    let hold; /* bit buffer */ 
                    let bits; /* bits in bit buffer */ 
                    let _in, _out; /* save starting available input and output */ 
                    let copy; /* number of stored or match bytes to copy */ 
                    let from; /* where to copy match bytes from */ 
                    let from_source;
                    let here = 0; /* current decoding table entry */ 
                    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
                    //let last;                   /* parent table entry */
                    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
                    let len; /* length to copy for repeats, bits to drop */ 
                    let ret; /* return code */ 
                    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
                    let opts;
                    let n; // temporary variable for NEED_BITS
                    const order = /* permutation of code lengths */ new Uint8Array([
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ]);
                    if (inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR$1;
                    state = strm.state;
                    if (state.mode === TYPE) state.mode = TYPEDO;
                     /* skip check */ 
                    //--- LOAD() ---
                    put = strm.next_out;
                    output = strm.output;
                    left = strm.avail_out;
                    next = strm.next_in;
                    input = strm.input;
                    have = strm.avail_in;
                    hold = state.hold;
                    bits = state.bits;
                    //---
                    _in = have;
                    _out = left;
                    ret = Z_OK$1;
                    inf_leave: for(;;)switch(state.mode){
                        case HEAD:
                            if (state.wrap === 0) {
                                state.mode = TYPEDO;
                                break;
                            }
                            //=== NEEDBITS(16);
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.wrap & 2 && hold === 0x8b1f) {
                                if (state.wbits === 0) state.wbits = 15;
                                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32_1(state.check, hbuf, 2, 0);
                                //===//
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                                //===//
                                state.mode = FLAGS;
                                break;
                            }
                            if (state.head) state.head.done = false;
                            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                                strm.msg = 'incorrect header check';
                                state.mode = BAD;
                                break;
                            }
                            if ((hold & 0x0f) !== Z_DEFLATED) {
                                strm.msg = 'unknown compression method';
                                state.mode = BAD;
                                break;
                            }
                            //--- DROPBITS(4) ---//
                            hold >>>= 4;
                            bits -= 4;
                            //---//
                            len = (hold & 0x0f) + 8;
                            if (state.wbits === 0) state.wbits = len;
                            if (len > 15 || len > state.wbits) {
                                strm.msg = 'invalid window size';
                                state.mode = BAD;
                                break;
                            }
                            // !!! pako patch. Force use `options.windowBits` if passed.
                            // Required to always use max window size by default.
                            state.dmax = 1 << state.wbits;
                            //state.dmax = 1 << len;
                            state.flags = 0; /* indicate zlib header */ 
                            //Tracev((stderr, "inflate:   zlib header ok\n"));
                            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
                            state.mode = hold & 0x200 ? DICTID : TYPE;
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            break;
                        case FLAGS:
                            //=== NEEDBITS(16); */
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.flags = hold;
                            if ((state.flags & 0xff) !== Z_DEFLATED) {
                                strm.msg = 'unknown compression method';
                                state.mode = BAD;
                                break;
                            }
                            if (state.flags & 0xe000) {
                                strm.msg = 'unknown header flags set';
                                state.mode = BAD;
                                break;
                            }
                            if (state.head) state.head.text = hold >> 8 & 1;
                            if (state.flags & 0x0200 && state.wrap & 4) {
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32_1(state.check, hbuf, 2, 0);
                            //===//
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = TIME;
                        /* falls through */ case TIME:
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.head) state.head.time = hold;
                            if (state.flags & 0x0200 && state.wrap & 4) {
                                //=== CRC4(state.check, hold)
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                hbuf[2] = hold >>> 16 & 0xff;
                                hbuf[3] = hold >>> 24 & 0xff;
                                state.check = crc32_1(state.check, hbuf, 4, 0);
                            //===
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = OS;
                        /* falls through */ case OS:
                            //=== NEEDBITS(16); */
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.head) {
                                state.head.xflags = hold & 0xff;
                                state.head.os = hold >> 8;
                            }
                            if (state.flags & 0x0200 && state.wrap & 4) {
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32_1(state.check, hbuf, 2, 0);
                            //===//
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = EXLEN;
                        /* falls through */ case EXLEN:
                            if (state.flags & 0x0400) {
                                //=== NEEDBITS(16); */
                                while(bits < 16){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.length = hold;
                                if (state.head) state.head.extra_len = hold;
                                if (state.flags & 0x0200 && state.wrap & 4) {
                                    //=== CRC2(state.check, hold);
                                    hbuf[0] = hold & 0xff;
                                    hbuf[1] = hold >>> 8 & 0xff;
                                    state.check = crc32_1(state.check, hbuf, 2, 0);
                                //===//
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
                            state.mode = EXTRA;
                        /* falls through */ case EXTRA:
                            if (state.flags & 0x0400) {
                                copy = state.length;
                                if (copy > have) copy = have;
                                if (copy) {
                                    if (state.head) {
                                        len = state.head.extra_len - state.length;
                                        if (!state.head.extra) // Use untyped array for more convenient processing later
                                        state.head.extra = new Uint8Array(state.head.extra_len);
                                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                                        // - no need for additional size check
                                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                                    //zmemcpy(state.head.extra + len, next,
                                    //        len + copy > state.head.extra_max ?
                                    //        state.head.extra_max - len : copy);
                                    }
                                    if (state.flags & 0x0200 && state.wrap & 4) state.check = crc32_1(state.check, input, copy, next);
                                    have -= copy;
                                    next += copy;
                                    state.length -= copy;
                                }
                                if (state.length) break inf_leave;
                            }
                            state.length = 0;
                            state.mode = NAME;
                        /* falls through */ case NAME:
                            if (state.flags & 0x0800) {
                                if (have === 0) break inf_leave;
                                copy = 0;
                                do {
                                    // TODO: 2 or 1 bytes?
                                    len = input[next + copy++];
                                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                                }while (len && copy < have);
                                if (state.flags & 0x0200 && state.wrap & 4) state.check = crc32_1(state.check, input, copy, next);
                                have -= copy;
                                next += copy;
                                if (len) break inf_leave;
                            } else if (state.head) state.head.name = null;
                            state.length = 0;
                            state.mode = COMMENT;
                        /* falls through */ case COMMENT:
                            if (state.flags & 0x1000) {
                                if (have === 0) break inf_leave;
                                copy = 0;
                                do {
                                    len = input[next + copy++];
                                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                                }while (len && copy < have);
                                if (state.flags & 0x0200 && state.wrap & 4) state.check = crc32_1(state.check, input, copy, next);
                                have -= copy;
                                next += copy;
                                if (len) break inf_leave;
                            } else if (state.head) state.head.comment = null;
                            state.mode = HCRC;
                        /* falls through */ case HCRC:
                            if (state.flags & 0x0200) {
                                //=== NEEDBITS(16); */
                                while(bits < 16){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                                    strm.msg = 'header crc mismatch';
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            }
                            if (state.head) {
                                state.head.hcrc = state.flags >> 9 & 1;
                                state.head.done = true;
                            }
                            strm.adler = state.check = 0;
                            state.mode = TYPE;
                            break;
                        case DICTID:
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            strm.adler = state.check = zswap32(hold);
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = DICT;
                        /* falls through */ case DICT:
                            if (state.havedict === 0) {
                                //--- RESTORE() ---
                                strm.next_out = put;
                                strm.avail_out = left;
                                strm.next_in = next;
                                strm.avail_in = have;
                                state.hold = hold;
                                state.bits = bits;
                                //---
                                return Z_NEED_DICT$1;
                            }
                            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
                            state.mode = TYPE;
                        /* falls through */ case TYPE:
                            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
                        /* falls through */ case TYPEDO:
                            if (state.last) {
                                //--- BYTEBITS() ---//
                                hold >>>= bits & 7;
                                bits -= bits & 7;
                                //---//
                                state.mode = CHECK;
                                break;
                            }
                            //=== NEEDBITS(3); */
                            while(bits < 3){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.last = hold & 0x01 /*BITS(1)*/ ;
                            //--- DROPBITS(1) ---//
                            hold >>>= 1;
                            bits -= 1;
                            //---//
                            switch(hold & 0x03){
                                case 0:
                                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = STORED;
                                    break;
                                case 1:
                                    /* fixed block */ fixedtables(state);
                                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = LEN_; /* decode codes */ 
                                    if (flush === Z_TREES) {
                                        //--- DROPBITS(2) ---//
                                        hold >>>= 2;
                                        bits -= 2;
                                        break inf_leave;
                                    }
                                    break;
                                case 2:
                                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = TABLE;
                                    break;
                                case 3:
                                    strm.msg = 'invalid block type';
                                    state.mode = BAD;
                            }
                            //--- DROPBITS(2) ---//
                            hold >>>= 2;
                            bits -= 2;
                            break;
                        case STORED:
                            //--- BYTEBITS() ---// /* go to byte boundary */
                            hold >>>= bits & 7;
                            bits -= bits & 7;
                            //---//
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                                strm.msg = 'invalid stored block lengths';
                                state.mode = BAD;
                                break;
                            }
                            state.length = hold & 0xffff;
                            //Tracev((stderr, "inflate:       stored length %u\n",
                            //        state.length));
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = COPY_;
                            if (flush === Z_TREES) break inf_leave;
                        /* falls through */ case COPY_:
                            state.mode = COPY;
                        /* falls through */ case COPY:
                            copy = state.length;
                            if (copy) {
                                if (copy > have) copy = have;
                                if (copy > left) copy = left;
                                if (copy === 0) break inf_leave;
                                //--- zmemcpy(put, next, copy); ---
                                output.set(input.subarray(next, next + copy), put);
                                //---//
                                have -= copy;
                                next += copy;
                                left -= copy;
                                put += copy;
                                state.length -= copy;
                                break;
                            }
                            //Tracev((stderr, "inflate:       stored end\n"));
                            state.mode = TYPE;
                            break;
                        case TABLE:
                            //=== NEEDBITS(14); */
                            while(bits < 14){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.nlen = (hold & 0x1f) + 257;
                            //--- DROPBITS(5) ---//
                            hold >>>= 5;
                            bits -= 5;
                            //---//
                            state.ndist = (hold & 0x1f) + 1;
                            //--- DROPBITS(5) ---//
                            hold >>>= 5;
                            bits -= 5;
                            //---//
                            state.ncode = (hold & 0x0f) + 4;
                            //--- DROPBITS(4) ---//
                            hold >>>= 4;
                            bits -= 4;
                            //---//
                            //#ifndef PKZIP_BUG_WORKAROUND
                            if (state.nlen > 286 || state.ndist > 30) {
                                strm.msg = 'too many length or distance symbols';
                                state.mode = BAD;
                                break;
                            }
                            //#endif
                            //Tracev((stderr, "inflate:       table sizes ok\n"));
                            state.have = 0;
                            state.mode = LENLENS;
                        /* falls through */ case LENLENS:
                            while(state.have < state.ncode){
                                //=== NEEDBITS(3);
                                while(bits < 3){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                                //--- DROPBITS(3) ---//
                                hold >>>= 3;
                                bits -= 3;
                            //---//
                            }
                            while(state.have < 19)state.lens[order[state.have++]] = 0;
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            //state.next = state.codes;
                            //state.lencode = state.next;
                            // Switch to use dynamic table
                            state.lencode = state.lendyn;
                            state.lenbits = 7;
                            opts = {
                                bits: state.lenbits
                            };
                            ret = inftrees(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
                            state.lenbits = opts.bits;
                            if (ret) {
                                strm.msg = 'invalid code lengths set';
                                state.mode = BAD;
                                break;
                            }
                            //Tracev((stderr, "inflate:       code lengths ok\n"));
                            state.have = 0;
                            state.mode = CODELENS;
                        /* falls through */ case CODELENS:
                            while(state.have < state.nlen + state.ndist){
                                for(;;){
                                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                if (here_val < 16) {
                                    //--- DROPBITS(here.bits) ---//
                                    hold >>>= here_bits;
                                    bits -= here_bits;
                                    //---//
                                    state.lens[state.have++] = here_val;
                                } else {
                                    if (here_val === 16) {
                                        //=== NEEDBITS(here.bits + 2);
                                        n = here_bits + 2;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        if (state.have === 0) {
                                            strm.msg = 'invalid bit length repeat';
                                            state.mode = BAD;
                                            break;
                                        }
                                        len = state.lens[state.have - 1];
                                        copy = 3 + (hold & 0x03); //BITS(2);
                                        //--- DROPBITS(2) ---//
                                        hold >>>= 2;
                                        bits -= 2;
                                    //---//
                                    } else if (here_val === 17) {
                                        //=== NEEDBITS(here.bits + 3);
                                        n = here_bits + 3;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        len = 0;
                                        copy = 3 + (hold & 0x07); //BITS(3);
                                        //--- DROPBITS(3) ---//
                                        hold >>>= 3;
                                        bits -= 3;
                                    //---//
                                    } else {
                                        //=== NEEDBITS(here.bits + 7);
                                        n = here_bits + 7;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        len = 0;
                                        copy = 11 + (hold & 0x7f); //BITS(7);
                                        //--- DROPBITS(7) ---//
                                        hold >>>= 7;
                                        bits -= 7;
                                    //---//
                                    }
                                    if (state.have + copy > state.nlen + state.ndist) {
                                        strm.msg = 'invalid bit length repeat';
                                        state.mode = BAD;
                                        break;
                                    }
                                    while(copy--)state.lens[state.have++] = len;
                                }
                            }
                            /* handle error breaks in while */ if (state.mode === BAD) break;
                            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                                strm.msg = 'invalid code -- missing end-of-block';
                                state.mode = BAD;
                                break;
                            }
                            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
                            opts = {
                                bits: state.lenbits
                            };
                            ret = inftrees(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            // state.next_index = opts.table_index;
                            state.lenbits = opts.bits;
                            // state.lencode = state.next;
                            if (ret) {
                                strm.msg = 'invalid literal/lengths set';
                                state.mode = BAD;
                                break;
                            }
                            state.distbits = 6;
                            //state.distcode.copy(state.codes);
                            // Switch to use dynamic table
                            state.distcode = state.distdyn;
                            opts = {
                                bits: state.distbits
                            };
                            ret = inftrees(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            // state.next_index = opts.table_index;
                            state.distbits = opts.bits;
                            // state.distcode = state.next;
                            if (ret) {
                                strm.msg = 'invalid distances set';
                                state.mode = BAD;
                                break;
                            }
                            //Tracev((stderr, 'inflate:       codes ok\n'));
                            state.mode = LEN_;
                            if (flush === Z_TREES) break inf_leave;
                        /* falls through */ case LEN_:
                            state.mode = LEN;
                        /* falls through */ case LEN:
                            if (have >= 6 && left >= 258) {
                                //--- RESTORE() ---
                                strm.next_out = put;
                                strm.avail_out = left;
                                strm.next_in = next;
                                strm.avail_in = have;
                                state.hold = hold;
                                state.bits = bits;
                                //---
                                inffast(strm, _out);
                                //--- LOAD() ---
                                put = strm.next_out;
                                output = strm.output;
                                left = strm.avail_out;
                                next = strm.next_in;
                                input = strm.input;
                                have = strm.avail_in;
                                hold = state.hold;
                                bits = state.bits;
                                //---
                                if (state.mode === TYPE) state.back = -1;
                                break;
                            }
                            state.back = 0;
                            for(;;){
                                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            if (here_op && (here_op & 0xf0) === 0) {
                                last_bits = here_bits;
                                last_op = here_op;
                                last_val = here_val;
                                for(;;){
                                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (last_bits + here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                //--- DROPBITS(last.bits) ---//
                                hold >>>= last_bits;
                                bits -= last_bits;
                                //---//
                                state.back += last_bits;
                            }
                            //--- DROPBITS(here.bits) ---//
                            hold >>>= here_bits;
                            bits -= here_bits;
                            //---//
                            state.back += here_bits;
                            state.length = here_val;
                            if (here_op === 0) {
                                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                                //        "inflate:         literal '%c'\n" :
                                //        "inflate:         literal 0x%02x\n", here.val));
                                state.mode = LIT;
                                break;
                            }
                            if (here_op & 32) {
                                //Tracevv((stderr, "inflate:         end of block\n"));
                                state.back = -1;
                                state.mode = TYPE;
                                break;
                            }
                            if (here_op & 64) {
                                strm.msg = 'invalid literal/length code';
                                state.mode = BAD;
                                break;
                            }
                            state.extra = here_op & 15;
                            state.mode = LENEXT;
                        /* falls through */ case LENEXT:
                            if (state.extra) {
                                //=== NEEDBITS(state.extra);
                                n = state.extra;
                                while(bits < n){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                                //--- DROPBITS(state.extra) ---//
                                hold >>>= state.extra;
                                bits -= state.extra;
                                //---//
                                state.back += state.extra;
                            }
                            //Tracevv((stderr, "inflate:         length %u\n", state.length));
                            state.was = state.length;
                            state.mode = DIST;
                        /* falls through */ case DIST:
                            for(;;){
                                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            if ((here_op & 0xf0) === 0) {
                                last_bits = here_bits;
                                last_op = here_op;
                                last_val = here_val;
                                for(;;){
                                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (last_bits + here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                //--- DROPBITS(last.bits) ---//
                                hold >>>= last_bits;
                                bits -= last_bits;
                                //---//
                                state.back += last_bits;
                            }
                            //--- DROPBITS(here.bits) ---//
                            hold >>>= here_bits;
                            bits -= here_bits;
                            //---//
                            state.back += here_bits;
                            if (here_op & 64) {
                                strm.msg = 'invalid distance code';
                                state.mode = BAD;
                                break;
                            }
                            state.offset = here_val;
                            state.extra = here_op & 15;
                            state.mode = DISTEXT;
                        /* falls through */ case DISTEXT:
                            if (state.extra) {
                                //=== NEEDBITS(state.extra);
                                n = state.extra;
                                while(bits < n){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                                //--- DROPBITS(state.extra) ---//
                                hold >>>= state.extra;
                                bits -= state.extra;
                                //---//
                                state.back += state.extra;
                            }
                            //#ifdef INFLATE_STRICT
                            if (state.offset > state.dmax) {
                                strm.msg = 'invalid distance too far back';
                                state.mode = BAD;
                                break;
                            }
                            //#endif
                            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
                            state.mode = MATCH;
                        /* falls through */ case MATCH:
                            if (left === 0) break inf_leave;
                            copy = _out - left;
                            if (state.offset > copy) {
                                copy = state.offset - copy;
                                if (copy > state.whave) {
                                    if (state.sane) {
                                        strm.msg = 'invalid distance too far back';
                                        state.mode = BAD;
                                        break;
                                    }
                                }
                                if (copy > state.wnext) {
                                    copy -= state.wnext;
                                    from = state.wsize - copy;
                                } else from = state.wnext - copy;
                                if (copy > state.length) copy = state.length;
                                from_source = state.window;
                            } else {
                                from_source = output;
                                from = put - state.offset;
                                copy = state.length;
                            }
                            if (copy > left) copy = left;
                            left -= copy;
                            state.length -= copy;
                            do output[put++] = from_source[from++];
                            while (--copy);
                            if (state.length === 0) state.mode = LEN;
                            break;
                        case LIT:
                            if (left === 0) break inf_leave;
                            output[put++] = state.length;
                            left--;
                            state.mode = LEN;
                            break;
                        case CHECK:
                            if (state.wrap) {
                                //=== NEEDBITS(32);
                                while(bits < 32){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    // Use '|' instead of '+' to make sure that result is signed
                                    hold |= input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                _out -= left;
                                strm.total_out += _out;
                                state.total += _out;
                                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? crc32_1(state.check, output, _out, put - _out) : adler32_1(state.check, output, _out, put - _out);
                                _out = left;
                                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                                if (state.wrap & 4 && (state.flags ? hold : zswap32(hold)) !== state.check) {
                                    strm.msg = 'incorrect data check';
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            //Tracev((stderr, "inflate:   check matches trailer\n"));
                            }
                            state.mode = LENGTH;
                        /* falls through */ case LENGTH:
                            if (state.wrap && state.flags) {
                                //=== NEEDBITS(32);
                                while(bits < 32){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                                    strm.msg = 'incorrect length check';
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            //Tracev((stderr, "inflate:   length matches trailer\n"));
                            }
                            state.mode = DONE;
                        /* falls through */ case DONE:
                            ret = Z_STREAM_END$1;
                            break inf_leave;
                        case BAD:
                            ret = Z_DATA_ERROR$1;
                            break inf_leave;
                        case MEM:
                            return Z_MEM_ERROR$1;
                        case SYNC:
                        /* falls through */ default:
                            return Z_STREAM_ERROR$1;
                    }
                    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
                    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
                    strm.next_out = put;
                    strm.avail_out = left;
                    strm.next_in = next;
                    strm.avail_in = have;
                    state.hold = hold;
                    state.bits = bits;
                    //---
                    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH$1)) updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
                    _in -= strm.avail_in;
                    _out -= strm.avail_out;
                    strm.total_in += _in;
                    strm.total_out += _out;
                    state.total += _out;
                    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32_1(state.check, output, _out, strm.next_out - _out) : adler32_1(state.check, output, _out, strm.next_out - _out);
                    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
                    if ((_in === 0 && _out === 0 || flush === Z_FINISH$1) && ret === Z_OK$1) ret = Z_BUF_ERROR;
                    return ret;
                };
                const inflateEnd = (strm)=>{
                    if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
                    let state = strm.state;
                    if (state.window) state.window = null;
                    strm.state = null;
                    return Z_OK$1;
                };
                const inflateGetHeader = (strm, head)=>{
                    /* check state */ if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
                    const state = strm.state;
                    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR$1;
                    /* save header structure */ state.head = head;
                    head.done = false;
                    return Z_OK$1;
                };
                const inflateSetDictionary = (strm, dictionary)=>{
                    const dictLength = dictionary.length;
                    let state;
                    let dictid;
                    let ret;
                    /* check state */ if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
                    state = strm.state;
                    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR$1;
                    /* check for correct dictionary identifier */ if (state.mode === DICT) {
                        dictid = 1; /* adler32(0, null, 0)*/ 
                        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32_1(dictid, dictionary, dictLength, 0);
                        if (dictid !== state.check) return Z_DATA_ERROR$1;
                    }
                    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
                    if (ret) {
                        state.mode = MEM;
                        return Z_MEM_ERROR$1;
                    }
                    state.havedict = 1;
                    // Tracev((stderr, "inflate:   dictionary set\n"));
                    return Z_OK$1;
                };
                var inflateReset_1 = inflateReset;
                var inflateReset2_1 = inflateReset2;
                var inflateResetKeep_1 = inflateResetKeep;
                var inflateInit_1 = inflateInit;
                var inflateInit2_1 = inflateInit2;
                var inflate_2$1 = inflate$2;
                var inflateEnd_1 = inflateEnd;
                var inflateGetHeader_1 = inflateGetHeader;
                var inflateSetDictionary_1 = inflateSetDictionary;
                var inflateInfo = 'pako inflate (from Nodeca project)';
                /* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var inflate_1$2 = {
                    inflateReset: inflateReset_1,
                    inflateReset2: inflateReset2_1,
                    inflateResetKeep: inflateResetKeep_1,
                    inflateInit: inflateInit_1,
                    inflateInit2: inflateInit2_1,
                    inflate: inflate_2$1,
                    inflateEnd: inflateEnd_1,
                    inflateGetHeader: inflateGetHeader_1,
                    inflateSetDictionary: inflateSetDictionary_1,
                    inflateInfo: inflateInfo
                };
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                function GZheader() {
                    /* true if compressed data believed to be text */ this.text = 0;
                    /* modification time */ this.time = 0;
                    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
                    /* operating system */ this.os = 0;
                    /* pointer to extra field or Z_NULL if none */ this.extra = null;
                    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
                    // but leave for few code modifications
                    //
                    // Setup limits is not necessary because in js we should not preallocate memory
                    // for inflate use constant limit in 65536 bytes
                    //
                    /* space at extra (only when reading header) */ // this.extra_max  = 0;
                    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
                    /* space at name (only when reading header) */ // this.name_max   = 0;
                    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
                    /* space at comment (only when reading header) */ // this.comm_max   = 0;
                    /* true if there was or will be a header crc */ this.hcrc = 0;
                    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
                }
                var gzheader = GZheader;
                const toString = Object.prototype.toString;
                /* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH, Z_FINISH, Z_OK, Z_STREAM_END, Z_NEED_DICT, Z_STREAM_ERROR, Z_DATA_ERROR, Z_MEM_ERROR } = constants$2;
                /* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function Inflate$1(options) {
                    this.options = common.assign({
                        chunkSize: 65536,
                        windowBits: 15,
                        to: ''
                    }, options || {});
                    const opt = this.options;
                    // Force window size for `raw` data, if not set directly,
                    // because we have no header for autodetect.
                    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
                        opt.windowBits = -opt.windowBits;
                        if (opt.windowBits === 0) opt.windowBits = -15;
                    }
                    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
                    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
                    // Gzip header has no info about windows size, we can do autodetect only
                    // for deflate. So, if window size not set, force it to max when gzip possible
                    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
                    // bit 4 (32) -> autodetect gzip/deflate
                    {
                        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
                    }
                    this.err = 0; // error code, if happens (0 = Z_OK)
                    this.msg = ''; // error message
                    this.ended = false; // used to avoid multiple onEnd() calls
                    this.chunks = []; // chunks of compressed data
                    this.strm = new zstream();
                    this.strm.avail_out = 0;
                    let status = inflate_1$2.inflateInit2(this.strm, opt.windowBits);
                    if (status !== Z_OK) throw new Error(messages[status]);
                    this.header = new gzheader();
                    inflate_1$2.inflateGetHeader(this.strm, this.header);
                    // Setup dictionary
                    if (opt.dictionary) {
                        // Convert data if needed
                        if (typeof opt.dictionary === 'string') opt.dictionary = strings.string2buf(opt.dictionary);
                        else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
                        if (opt.raw) {
                            status = inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
                            if (status !== Z_OK) throw new Error(messages[status]);
                        }
                    }
                }
                /**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ Inflate$1.prototype.push = function(data, flush_mode) {
                    const strm = this.strm;
                    const chunkSize = this.options.chunkSize;
                    const dictionary = this.options.dictionary;
                    let status, _flush_mode, last_avail_out;
                    if (this.ended) return false;
                    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
                    else _flush_mode = flush_mode === true ? Z_FINISH : Z_NO_FLUSH;
                    // Convert data if needed
                    if (toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
                    else strm.input = data;
                    strm.next_in = 0;
                    strm.avail_in = strm.input.length;
                    for(;;){
                        if (strm.avail_out === 0) {
                            strm.output = new Uint8Array(chunkSize);
                            strm.next_out = 0;
                            strm.avail_out = chunkSize;
                        }
                        status = inflate_1$2.inflate(strm, _flush_mode);
                        if (status === Z_NEED_DICT && dictionary) {
                            status = inflate_1$2.inflateSetDictionary(strm, dictionary);
                            if (status === Z_OK) status = inflate_1$2.inflate(strm, _flush_mode);
                            else if (status === Z_DATA_ERROR) // Replace code with more verbose
                            status = Z_NEED_DICT;
                        }
                        // Skip snyc markers if more data follows and not raw mode
                        while(strm.avail_in > 0 && status === Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
                            inflate_1$2.inflateReset(strm);
                            status = inflate_1$2.inflate(strm, _flush_mode);
                        }
                        switch(status){
                            case Z_STREAM_ERROR:
                            case Z_DATA_ERROR:
                            case Z_NEED_DICT:
                            case Z_MEM_ERROR:
                                this.onEnd(status);
                                this.ended = true;
                                return false;
                        }
                        // Remember real `avail_out` value, because we may patch out buffer content
                        // to align utf8 strings boundaries.
                        last_avail_out = strm.avail_out;
                        if (strm.next_out) {
                            if (strm.avail_out === 0 || status === Z_STREAM_END) {
                                if (this.options.to === 'string') {
                                    let next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
                                    let tail = strm.next_out - next_out_utf8;
                                    let utf8str = strings.buf2string(strm.output, next_out_utf8);
                                    // move tail & realign counters
                                    strm.next_out = tail;
                                    strm.avail_out = chunkSize - tail;
                                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                                    this.onData(utf8str);
                                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
                            }
                        }
                        // Must repeat iteration if out buffer is full
                        if (status === Z_OK && last_avail_out === 0) continue;
                        // Finalize if end of stream reached.
                        if (status === Z_STREAM_END) {
                            status = inflate_1$2.inflateEnd(this.strm);
                            this.onEnd(status);
                            this.ended = true;
                            return true;
                        }
                        if (strm.avail_in === 0) break;
                    }
                    return true;
                };
                /**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ Inflate$1.prototype.onData = function(chunk) {
                    this.chunks.push(chunk);
                };
                /**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ Inflate$1.prototype.onEnd = function(status) {
                    // On success - join
                    if (status === Z_OK) {
                        if (this.options.to === 'string') this.result = this.chunks.join('');
                        else this.result = common.flattenChunks(this.chunks);
                    }
                    this.chunks = [];
                    this.err = status;
                    this.msg = this.strm.msg;
                };
                /**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function inflate$1(input, options) {
                    const inflator = new Inflate$1(options);
                    inflator.push(input);
                    // That will never happens, if you don't cheat with options :)
                    if (inflator.err) throw inflator.msg || messages[inflator.err];
                    return inflator.result;
                }
                /**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function inflateRaw$1(input, options) {
                    options = options || {};
                    options.raw = true;
                    return inflate$1(input, options);
                }
                /**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var Inflate_1$1 = Inflate$1;
                var inflate_2 = inflate$1;
                var inflateRaw_1$1 = inflateRaw$1;
                var ungzip$1 = inflate$1;
                var constants = constants$2;
                var inflate_1$1 = {
                    Inflate: Inflate_1$1,
                    inflate: inflate_2,
                    inflateRaw: inflateRaw_1$1,
                    ungzip: ungzip$1,
                    constants: constants
                };
                const { Deflate, deflate, deflateRaw, gzip } = deflate_1$1;
                const { Inflate, inflate, inflateRaw, ungzip } = inflate_1$1;
                var Deflate_1 = Deflate;
                var deflate_1 = deflate;
                var deflateRaw_1 = deflateRaw;
                var gzip_1 = gzip;
                var Inflate_1 = Inflate;
                var inflate_1 = inflate;
                var inflateRaw_1 = inflateRaw;
                var ungzip_1 = ungzip;
                var constants_1 = constants$2;
                var pako = {
                    Deflate: Deflate_1,
                    deflate: deflate_1,
                    deflateRaw: deflateRaw_1,
                    gzip: gzip_1,
                    Inflate: Inflate_1,
                    inflate: inflate_1,
                    inflateRaw: inflateRaw_1,
                    ungzip: ungzip_1,
                    constants: constants_1
                };
            /***/ },
            /***/ "./node_modules/performance-now/lib/performance-now.js": /*!*************************************************************!*\
  !*** ./node_modules/performance-now/lib/performance-now.js ***!
  \*************************************************************/ /***/ function(module1) {
                // Generated by CoffeeScript 1.12.2
                (function() {
                    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
                    if (typeof performance !== "undefined" && performance !== null && performance.now) module1.exports = function() {
                        return performance.now();
                    };
                    else if (Date.now) {
                        module1.exports = function() {
                            return Date.now() - loadTime;
                        };
                        loadTime = Date.now();
                    } else {
                        module1.exports = function() {
                            return new Date().getTime() - loadTime;
                        };
                        loadTime = new Date().getTime();
                    }
                }).call(this);
            //# sourceMappingURL=performance-now.js.map
            /***/ },
            /***/ "./node_modules/raf/index.js": /*!***********************************!*\
  !*** ./node_modules/raf/index.js ***!
  \***********************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var now = __webpack_require__(/*! performance-now */ "./node_modules/performance-now/lib/performance-now.js"), root = typeof window === 'undefined' ? global : window, vendors = [
                    'moz',
                    'webkit'
                ], suffix = 'AnimationFrame', raf = root['request' + suffix], caf = root['cancel' + suffix] || root['cancelRequest' + suffix];
                for(var i = 0; !raf && i < vendors.length; i++){
                    raf = root[vendors[i] + 'Request' + suffix];
                    caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
                }
                // Some versions of FF have rAF but not cAF
                if (!raf || !caf) {
                    var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
                    raf = function(callback) {
                        if (queue.length === 0) {
                            var _now = now(), next = Math.max(0, frameDuration - (_now - last));
                            last = next + _now;
                            setTimeout(function() {
                                var cp = queue.slice(0);
                                // Clear queue here to prevent
                                // callbacks from appending listeners
                                // to the current frame's queue
                                queue.length = 0;
                                for(var i = 0; i < cp.length; i++){
                                    if (!cp[i].cancelled) try {
                                        cp[i].callback(last);
                                    } catch (e) {
                                        setTimeout(function() {
                                            throw e;
                                        }, 0);
                                    }
                                }
                            }, Math.round(next));
                        }
                        queue.push({
                            handle: ++id,
                            callback: callback,
                            cancelled: false
                        });
                        return id;
                    };
                    caf = function(handle) {
                        for(var i = 0; i < queue.length; i++)if (queue[i].handle === handle) queue[i].cancelled = true;
                    };
                }
                module1.exports = function(fn) {
                    // Wrap in a new function to prevent
                    // `cancel` potentially being assigned
                    // to the native rAF function
                    return raf.call(root, fn);
                };
                module1.exports.cancel = function() {
                    caf.apply(root, arguments);
                };
                module1.exports.polyfill = function(object) {
                    if (!object) object = root;
                    object.requestAnimationFrame = raf;
                    object.cancelAnimationFrame = caf;
                };
            /***/ },
            /***/ "./node_modules/rgbcolor/index.js": /*!****************************************!*\
  !*** ./node_modules/rgbcolor/index.js ***!
  \****************************************/ /***/ function(module1) {
                /*
	Based on rgbcolor.js by Stoyan Stefanov <sstoo@gmail.com>
	http://www.phpied.com/rgb-color-parser-in-javascript/
*/ module1.exports = function(color_string) {
                    this.ok = false;
                    this.alpha = 1.0;
                    // strip any leading #
                    if (color_string.charAt(0) == '#') color_string = color_string.substr(1, 6);
                    color_string = color_string.replace(/ /g, '');
                    color_string = color_string.toLowerCase();
                    // before getting into regexps, try simple matches
                    // and overwrite the input
                    var simple_colors = {
                        aliceblue: 'f0f8ff',
                        antiquewhite: 'faebd7',
                        aqua: '00ffff',
                        aquamarine: '7fffd4',
                        azure: 'f0ffff',
                        beige: 'f5f5dc',
                        bisque: 'ffe4c4',
                        black: '000000',
                        blanchedalmond: 'ffebcd',
                        blue: '0000ff',
                        blueviolet: '8a2be2',
                        brown: 'a52a2a',
                        burlywood: 'deb887',
                        cadetblue: '5f9ea0',
                        chartreuse: '7fff00',
                        chocolate: 'd2691e',
                        coral: 'ff7f50',
                        cornflowerblue: '6495ed',
                        cornsilk: 'fff8dc',
                        crimson: 'dc143c',
                        cyan: '00ffff',
                        darkblue: '00008b',
                        darkcyan: '008b8b',
                        darkgoldenrod: 'b8860b',
                        darkgray: 'a9a9a9',
                        darkgreen: '006400',
                        darkkhaki: 'bdb76b',
                        darkmagenta: '8b008b',
                        darkolivegreen: '556b2f',
                        darkorange: 'ff8c00',
                        darkorchid: '9932cc',
                        darkred: '8b0000',
                        darksalmon: 'e9967a',
                        darkseagreen: '8fbc8f',
                        darkslateblue: '483d8b',
                        darkslategray: '2f4f4f',
                        darkturquoise: '00ced1',
                        darkviolet: '9400d3',
                        deeppink: 'ff1493',
                        deepskyblue: '00bfff',
                        dimgray: '696969',
                        dodgerblue: '1e90ff',
                        feldspar: 'd19275',
                        firebrick: 'b22222',
                        floralwhite: 'fffaf0',
                        forestgreen: '228b22',
                        fuchsia: 'ff00ff',
                        gainsboro: 'dcdcdc',
                        ghostwhite: 'f8f8ff',
                        gold: 'ffd700',
                        goldenrod: 'daa520',
                        gray: '808080',
                        green: '008000',
                        greenyellow: 'adff2f',
                        honeydew: 'f0fff0',
                        hotpink: 'ff69b4',
                        indianred: 'cd5c5c',
                        indigo: '4b0082',
                        ivory: 'fffff0',
                        khaki: 'f0e68c',
                        lavender: 'e6e6fa',
                        lavenderblush: 'fff0f5',
                        lawngreen: '7cfc00',
                        lemonchiffon: 'fffacd',
                        lightblue: 'add8e6',
                        lightcoral: 'f08080',
                        lightcyan: 'e0ffff',
                        lightgoldenrodyellow: 'fafad2',
                        lightgrey: 'd3d3d3',
                        lightgreen: '90ee90',
                        lightpink: 'ffb6c1',
                        lightsalmon: 'ffa07a',
                        lightseagreen: '20b2aa',
                        lightskyblue: '87cefa',
                        lightslateblue: '8470ff',
                        lightslategray: '778899',
                        lightsteelblue: 'b0c4de',
                        lightyellow: 'ffffe0',
                        lime: '00ff00',
                        limegreen: '32cd32',
                        linen: 'faf0e6',
                        magenta: 'ff00ff',
                        maroon: '800000',
                        mediumaquamarine: '66cdaa',
                        mediumblue: '0000cd',
                        mediumorchid: 'ba55d3',
                        mediumpurple: '9370d8',
                        mediumseagreen: '3cb371',
                        mediumslateblue: '7b68ee',
                        mediumspringgreen: '00fa9a',
                        mediumturquoise: '48d1cc',
                        mediumvioletred: 'c71585',
                        midnightblue: '191970',
                        mintcream: 'f5fffa',
                        mistyrose: 'ffe4e1',
                        moccasin: 'ffe4b5',
                        navajowhite: 'ffdead',
                        navy: '000080',
                        oldlace: 'fdf5e6',
                        olive: '808000',
                        olivedrab: '6b8e23',
                        orange: 'ffa500',
                        orangered: 'ff4500',
                        orchid: 'da70d6',
                        palegoldenrod: 'eee8aa',
                        palegreen: '98fb98',
                        paleturquoise: 'afeeee',
                        palevioletred: 'd87093',
                        papayawhip: 'ffefd5',
                        peachpuff: 'ffdab9',
                        peru: 'cd853f',
                        pink: 'ffc0cb',
                        plum: 'dda0dd',
                        powderblue: 'b0e0e6',
                        purple: '800080',
                        rebeccapurple: '663399',
                        red: 'ff0000',
                        rosybrown: 'bc8f8f',
                        royalblue: '4169e1',
                        saddlebrown: '8b4513',
                        salmon: 'fa8072',
                        sandybrown: 'f4a460',
                        seagreen: '2e8b57',
                        seashell: 'fff5ee',
                        sienna: 'a0522d',
                        silver: 'c0c0c0',
                        skyblue: '87ceeb',
                        slateblue: '6a5acd',
                        slategray: '708090',
                        snow: 'fffafa',
                        springgreen: '00ff7f',
                        steelblue: '4682b4',
                        tan: 'd2b48c',
                        teal: '008080',
                        thistle: 'd8bfd8',
                        tomato: 'ff6347',
                        turquoise: '40e0d0',
                        violet: 'ee82ee',
                        violetred: 'd02090',
                        wheat: 'f5deb3',
                        white: 'ffffff',
                        whitesmoke: 'f5f5f5',
                        yellow: 'ffff00',
                        yellowgreen: '9acd32'
                    };
                    color_string = simple_colors[color_string] || color_string;
                    // emd of simple type-in colors
                    // array of color definition objects
                    var color_defs = [
                        {
                            re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
                            example: [
                                'rgba(123, 234, 45, 0.8)',
                                'rgba(255,234,245,1.0)'
                            ],
                            process: function(bits) {
                                return [
                                    parseInt(bits[1]),
                                    parseInt(bits[2]),
                                    parseInt(bits[3]),
                                    parseFloat(bits[4])
                                ];
                            }
                        },
                        {
                            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                            example: [
                                'rgb(123, 234, 45)',
                                'rgb(255,234,245)'
                            ],
                            process: function(bits) {
                                return [
                                    parseInt(bits[1]),
                                    parseInt(bits[2]),
                                    parseInt(bits[3])
                                ];
                            }
                        },
                        {
                            re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                            example: [
                                '#00ff00',
                                '336699'
                            ],
                            process: function(bits) {
                                return [
                                    parseInt(bits[1], 16),
                                    parseInt(bits[2], 16),
                                    parseInt(bits[3], 16)
                                ];
                            }
                        },
                        {
                            re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                            example: [
                                '#fb0',
                                'f0f'
                            ],
                            process: function(bits) {
                                return [
                                    parseInt(bits[1] + bits[1], 16),
                                    parseInt(bits[2] + bits[2], 16),
                                    parseInt(bits[3] + bits[3], 16)
                                ];
                            }
                        }
                    ];
                    // search through the definitions to find a match
                    for(var i = 0; i < color_defs.length; i++){
                        var re = color_defs[i].re;
                        var processor = color_defs[i].process;
                        var bits = re.exec(color_string);
                        if (bits) {
                            var channels = processor(bits);
                            this.r = channels[0];
                            this.g = channels[1];
                            this.b = channels[2];
                            if (channels.length > 3) this.alpha = channels[3];
                            this.ok = true;
                        }
                    }
                    // validate/cleanup values
                    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r;
                    this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g;
                    this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b;
                    this.alpha = this.alpha < 0 ? 0 : this.alpha > 1.0 || isNaN(this.alpha) ? 1.0 : this.alpha;
                    // some getters
                    this.toRGB = function() {
                        return 'rgb(' + this.r + ', ' + this.g + ', ' + this.b + ')';
                    };
                    this.toRGBA = function() {
                        return 'rgba(' + this.r + ', ' + this.g + ', ' + this.b + ', ' + this.alpha + ')';
                    };
                    this.toHex = function() {
                        var r = this.r.toString(16);
                        var g = this.g.toString(16);
                        var b = this.b.toString(16);
                        if (r.length == 1) r = '0' + r;
                        if (g.length == 1) g = '0' + g;
                        if (b.length == 1) b = '0' + b;
                        return '#' + r + g + b;
                    };
                    // help
                    this.getHelpXML = function() {
                        var examples = new Array();
                        // add regexps
                        for(var i = 0; i < color_defs.length; i++){
                            var example = color_defs[i].example;
                            for(var j = 0; j < example.length; j++)examples[examples.length] = example[j];
                        }
                        // add type-in colors
                        for(var sc in simple_colors)examples[examples.length] = sc;
                        var xml = document.createElement('ul');
                        xml.setAttribute('id', 'rgbcolor-examples');
                        for(var i = 0; i < examples.length; i++)try {
                            var list_item = document.createElement('li');
                            var list_color = new RGBColor(examples[i]);
                            var example_div = document.createElement('div');
                            example_div.style.cssText = "margin: 3px; border: 1px solid black; background:" + list_color.toHex() + '; ' + 'color:' + list_color.toHex();
                            example_div.appendChild(document.createTextNode('test'));
                            var list_item_value = document.createTextNode(' ' + examples[i] + ' -> ' + list_color.toRGB() + ' -> ' + list_color.toHex());
                            list_item.appendChild(example_div);
                            list_item.appendChild(list_item_value);
                            xml.appendChild(list_item);
                        } catch (e) {}
                        return xml;
                    };
                };
            /***/ },
            /***/ "./node_modules/stackblur-canvas/dist/stackblur-es.js": /*!************************************************************!*\
  !*** ./node_modules/stackblur-canvas/dist/stackblur-es.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BlurStack: function() {
                        return /* binding */ BlurStack;
                    },
                    /* harmony export */ canvasRGB: function() {
                        return /* binding */ processCanvasRGB;
                    },
                    /* harmony export */ canvasRGBA: function() {
                        return /* binding */ processCanvasRGBA;
                    },
                    /* harmony export */ image: function() {
                        return /* binding */ processImage;
                    },
                    /* harmony export */ imageDataRGB: function() {
                        return /* binding */ processImageDataRGB;
                    },
                    /* harmony export */ imageDataRGBA: function() {
                        return /* binding */ processImageDataRGBA;
                    }
                });
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
                        return typeof obj;
                    };
                    else _typeof = function(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                /* eslint-disable no-bitwise -- used for calculations */ /* eslint-disable unicorn/prefer-query-selector -- aiming at
  backward-compatibility */ /**
* StackBlur - a fast almost Gaussian Blur For Canvas
*
* In case you find this class useful - especially in commercial projects -
* I am not totally unhappy for a small donation to my PayPal account
* mario@quasimondo.de
*
* Or support me on flattr:
* {@link https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript}.
*
* @module StackBlur
* @author Mario Klingemann
* Contact: mario@quasimondo.com
* Website: {@link http://www.quasimondo.com/StackBlurForCanvas/StackBlurDemo.html}
* Twitter: @quasimondo
*
* @copyright (c) 2010 Mario Klingemann
*
* Permission is hereby granted, free of charge, to any person
* obtaining a copy of this software and associated documentation
* files (the "Software"), to deal in the Software without
* restriction, including without limitation the rights to use,
* copy, modify, merge, publish, distribute, sublicense, and/or sell
* copies of the Software, and to permit persons to whom the
* Software is furnished to do so, subject to the following
* conditions:
*
* The above copyright notice and this permission notice shall be
* included in all copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
* EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
* OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
* NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
* HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
* FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
* OTHER DEALINGS IN THE SOFTWARE.
*/ var mulTable = [
                    512,
                    512,
                    456,
                    512,
                    328,
                    456,
                    335,
                    512,
                    405,
                    328,
                    271,
                    456,
                    388,
                    335,
                    292,
                    512,
                    454,
                    405,
                    364,
                    328,
                    298,
                    271,
                    496,
                    456,
                    420,
                    388,
                    360,
                    335,
                    312,
                    292,
                    273,
                    512,
                    482,
                    454,
                    428,
                    405,
                    383,
                    364,
                    345,
                    328,
                    312,
                    298,
                    284,
                    271,
                    259,
                    496,
                    475,
                    456,
                    437,
                    420,
                    404,
                    388,
                    374,
                    360,
                    347,
                    335,
                    323,
                    312,
                    302,
                    292,
                    282,
                    273,
                    265,
                    512,
                    497,
                    482,
                    468,
                    454,
                    441,
                    428,
                    417,
                    405,
                    394,
                    383,
                    373,
                    364,
                    354,
                    345,
                    337,
                    328,
                    320,
                    312,
                    305,
                    298,
                    291,
                    284,
                    278,
                    271,
                    265,
                    259,
                    507,
                    496,
                    485,
                    475,
                    465,
                    456,
                    446,
                    437,
                    428,
                    420,
                    412,
                    404,
                    396,
                    388,
                    381,
                    374,
                    367,
                    360,
                    354,
                    347,
                    341,
                    335,
                    329,
                    323,
                    318,
                    312,
                    307,
                    302,
                    297,
                    292,
                    287,
                    282,
                    278,
                    273,
                    269,
                    265,
                    261,
                    512,
                    505,
                    497,
                    489,
                    482,
                    475,
                    468,
                    461,
                    454,
                    447,
                    441,
                    435,
                    428,
                    422,
                    417,
                    411,
                    405,
                    399,
                    394,
                    389,
                    383,
                    378,
                    373,
                    368,
                    364,
                    359,
                    354,
                    350,
                    345,
                    341,
                    337,
                    332,
                    328,
                    324,
                    320,
                    316,
                    312,
                    309,
                    305,
                    301,
                    298,
                    294,
                    291,
                    287,
                    284,
                    281,
                    278,
                    274,
                    271,
                    268,
                    265,
                    262,
                    259,
                    257,
                    507,
                    501,
                    496,
                    491,
                    485,
                    480,
                    475,
                    470,
                    465,
                    460,
                    456,
                    451,
                    446,
                    442,
                    437,
                    433,
                    428,
                    424,
                    420,
                    416,
                    412,
                    408,
                    404,
                    400,
                    396,
                    392,
                    388,
                    385,
                    381,
                    377,
                    374,
                    370,
                    367,
                    363,
                    360,
                    357,
                    354,
                    350,
                    347,
                    344,
                    341,
                    338,
                    335,
                    332,
                    329,
                    326,
                    323,
                    320,
                    318,
                    315,
                    312,
                    310,
                    307,
                    304,
                    302,
                    299,
                    297,
                    294,
                    292,
                    289,
                    287,
                    285,
                    282,
                    280,
                    278,
                    275,
                    273,
                    271,
                    269,
                    267,
                    265,
                    263,
                    261,
                    259
                ];
                var shgTable = [
                    9,
                    11,
                    12,
                    13,
                    13,
                    14,
                    14,
                    15,
                    15,
                    15,
                    15,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    18,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    19,
                    19,
                    19,
                    19,
                    19,
                    19,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    21,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    22,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    23,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24
                ];
                /**
 * @param {string|HTMLImageElement} img
 * @param {string|HTMLCanvasElement} canvas
 * @param {Float} radius
 * @param {boolean} blurAlphaChannel
 * @param {boolean} useOffset
 * @param {boolean} skipStyles
 * @returns {undefined}
 */ function processImage(img, canvas, radius, blurAlphaChannel, useOffset, skipStyles) {
                    if (typeof img === 'string') img = document.getElementById(img);
                    if (!img || Object.prototype.toString.call(img).slice(8, -1) === 'HTMLImageElement' && !('naturalWidth' in img)) return;
                    var dimensionType = useOffset ? 'offset' : 'natural';
                    var w = img[dimensionType + 'Width'];
                    var h = img[dimensionType + 'Height']; // add ImageBitmap support,can blur texture source
                    if (Object.prototype.toString.call(img).slice(8, -1) === 'ImageBitmap') {
                        w = img.width;
                        h = img.height;
                    }
                    if (typeof canvas === 'string') canvas = document.getElementById(canvas);
                    if (!canvas || !('getContext' in canvas)) return;
                    if (!skipStyles) {
                        canvas.style.width = w + 'px';
                        canvas.style.height = h + 'px';
                    }
                    canvas.width = w;
                    canvas.height = h;
                    var context = canvas.getContext('2d');
                    context.clearRect(0, 0, w, h);
                    context.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, w, h);
                    if (isNaN(radius) || radius < 1) return;
                    if (blurAlphaChannel) processCanvasRGBA(canvas, 0, 0, w, h, radius);
                    else processCanvasRGB(canvas, 0, 0, w, h, radius);
                }
                /**
 * @param {string|HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @throws {Error|TypeError}
 * @returns {ImageData} See {@link https://html.spec.whatwg.org/multipage/canvas.html#imagedata}
 */ function getImageDataFromCanvas(canvas, topX, topY, width, height) {
                    if (typeof canvas === 'string') canvas = document.getElementById(canvas);
                    if (!canvas || _typeof(canvas) !== 'object' || !('getContext' in canvas)) throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
                    var context = canvas.getContext('2d');
                    try {
                        return context.getImageData(topX, topY, width, height);
                    } catch (e) {
                        throw new Error('unable to access image data: ' + e);
                    }
                }
                /**
 * @param {HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {undefined}
 */ function processCanvasRGBA(canvas, topX, topY, width, height, radius) {
                    if (isNaN(radius) || radius < 1) return;
                    radius |= 0;
                    var imageData = getImageDataFromCanvas(canvas, topX, topY, width, height);
                    imageData = processImageDataRGBA(imageData, topX, topY, width, height, radius);
                    canvas.getContext('2d').putImageData(imageData, topX, topY);
                }
                /**
 * @param {ImageData} imageData
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {ImageData}
 */ function processImageDataRGBA(imageData, topX, topY, width, height, radius) {
                    var pixels = imageData.data;
                    var div = 2 * radius + 1; // const w4 = width << 2;
                    var widthMinus1 = width - 1;
                    var heightMinus1 = height - 1;
                    var radiusPlus1 = radius + 1;
                    var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;
                    var stackStart = new BlurStack();
                    var stack = stackStart;
                    var stackEnd;
                    for(var i = 1; i < div; i++){
                        stack = stack.next = new BlurStack();
                        if (i === radiusPlus1) stackEnd = stack;
                    }
                    stack.next = stackStart;
                    var stackIn = null, stackOut = null, yw = 0, yi = 0;
                    var mulSum = mulTable[radius];
                    var shgSum = shgTable[radius];
                    for(var y = 0; y < height; y++){
                        stack = stackStart;
                        var pr = pixels[yi], pg = pixels[yi + 1], pb = pixels[yi + 2], pa = pixels[yi + 3];
                        for(var _i = 0; _i < radiusPlus1; _i++){
                            stack.r = pr;
                            stack.g = pg;
                            stack.b = pb;
                            stack.a = pa;
                            stack = stack.next;
                        }
                        var rInSum = 0, gInSum = 0, bInSum = 0, aInSum = 0, rOutSum = radiusPlus1 * pr, gOutSum = radiusPlus1 * pg, bOutSum = radiusPlus1 * pb, aOutSum = radiusPlus1 * pa, rSum = sumFactor * pr, gSum = sumFactor * pg, bSum = sumFactor * pb, aSum = sumFactor * pa;
                        for(var _i2 = 1; _i2 < radiusPlus1; _i2++){
                            var p = yi + ((widthMinus1 < _i2 ? widthMinus1 : _i2) << 2);
                            var r = pixels[p], g = pixels[p + 1], b = pixels[p + 2], a = pixels[p + 3];
                            var rbs = radiusPlus1 - _i2;
                            rSum += (stack.r = r) * rbs;
                            gSum += (stack.g = g) * rbs;
                            bSum += (stack.b = b) * rbs;
                            aSum += (stack.a = a) * rbs;
                            rInSum += r;
                            gInSum += g;
                            bInSum += b;
                            aInSum += a;
                            stack = stack.next;
                        }
                        stackIn = stackStart;
                        stackOut = stackEnd;
                        for(var x = 0; x < width; x++){
                            var paInitial = aSum * mulSum >>> shgSum;
                            pixels[yi + 3] = paInitial;
                            if (paInitial !== 0) {
                                var _a2 = 255 / paInitial;
                                pixels[yi] = (rSum * mulSum >>> shgSum) * _a2;
                                pixels[yi + 1] = (gSum * mulSum >>> shgSum) * _a2;
                                pixels[yi + 2] = (bSum * mulSum >>> shgSum) * _a2;
                            } else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
                            rSum -= rOutSum;
                            gSum -= gOutSum;
                            bSum -= bOutSum;
                            aSum -= aOutSum;
                            rOutSum -= stackIn.r;
                            gOutSum -= stackIn.g;
                            bOutSum -= stackIn.b;
                            aOutSum -= stackIn.a;
                            var _p = x + radius + 1;
                            _p = yw + (_p < widthMinus1 ? _p : widthMinus1) << 2;
                            rInSum += stackIn.r = pixels[_p];
                            gInSum += stackIn.g = pixels[_p + 1];
                            bInSum += stackIn.b = pixels[_p + 2];
                            aInSum += stackIn.a = pixels[_p + 3];
                            rSum += rInSum;
                            gSum += gInSum;
                            bSum += bInSum;
                            aSum += aInSum;
                            stackIn = stackIn.next;
                            var _stackOut = stackOut, _r = _stackOut.r, _g = _stackOut.g, _b = _stackOut.b, _a = _stackOut.a;
                            rOutSum += _r;
                            gOutSum += _g;
                            bOutSum += _b;
                            aOutSum += _a;
                            rInSum -= _r;
                            gInSum -= _g;
                            bInSum -= _b;
                            aInSum -= _a;
                            stackOut = stackOut.next;
                            yi += 4;
                        }
                        yw += width;
                    }
                    for(var _x = 0; _x < width; _x++){
                        yi = _x << 2;
                        var _pr = pixels[yi], _pg = pixels[yi + 1], _pb = pixels[yi + 2], _pa = pixels[yi + 3], _rOutSum = radiusPlus1 * _pr, _gOutSum = radiusPlus1 * _pg, _bOutSum = radiusPlus1 * _pb, _aOutSum = radiusPlus1 * _pa, _rSum = sumFactor * _pr, _gSum = sumFactor * _pg, _bSum = sumFactor * _pb, _aSum = sumFactor * _pa;
                        stack = stackStart;
                        for(var _i3 = 0; _i3 < radiusPlus1; _i3++){
                            stack.r = _pr;
                            stack.g = _pg;
                            stack.b = _pb;
                            stack.a = _pa;
                            stack = stack.next;
                        }
                        var yp = width;
                        var _gInSum = 0, _bInSum = 0, _aInSum = 0, _rInSum = 0;
                        for(var _i4 = 1; _i4 <= radius; _i4++){
                            yi = yp + _x << 2;
                            var _rbs = radiusPlus1 - _i4;
                            _rSum += (stack.r = _pr = pixels[yi]) * _rbs;
                            _gSum += (stack.g = _pg = pixels[yi + 1]) * _rbs;
                            _bSum += (stack.b = _pb = pixels[yi + 2]) * _rbs;
                            _aSum += (stack.a = _pa = pixels[yi + 3]) * _rbs;
                            _rInSum += _pr;
                            _gInSum += _pg;
                            _bInSum += _pb;
                            _aInSum += _pa;
                            stack = stack.next;
                            if (_i4 < heightMinus1) yp += width;
                        }
                        yi = _x;
                        stackIn = stackStart;
                        stackOut = stackEnd;
                        for(var _y = 0; _y < height; _y++){
                            var _p2 = yi << 2;
                            pixels[_p2 + 3] = _pa = _aSum * mulSum >>> shgSum;
                            if (_pa > 0) {
                                _pa = 255 / _pa;
                                pixels[_p2] = (_rSum * mulSum >>> shgSum) * _pa;
                                pixels[_p2 + 1] = (_gSum * mulSum >>> shgSum) * _pa;
                                pixels[_p2 + 2] = (_bSum * mulSum >>> shgSum) * _pa;
                            } else pixels[_p2] = pixels[_p2 + 1] = pixels[_p2 + 2] = 0;
                            _rSum -= _rOutSum;
                            _gSum -= _gOutSum;
                            _bSum -= _bOutSum;
                            _aSum -= _aOutSum;
                            _rOutSum -= stackIn.r;
                            _gOutSum -= stackIn.g;
                            _bOutSum -= stackIn.b;
                            _aOutSum -= stackIn.a;
                            _p2 = _x + ((_p2 = _y + radiusPlus1) < heightMinus1 ? _p2 : heightMinus1) * width << 2;
                            _rSum += _rInSum += stackIn.r = pixels[_p2];
                            _gSum += _gInSum += stackIn.g = pixels[_p2 + 1];
                            _bSum += _bInSum += stackIn.b = pixels[_p2 + 2];
                            _aSum += _aInSum += stackIn.a = pixels[_p2 + 3];
                            stackIn = stackIn.next;
                            _rOutSum += _pr = stackOut.r;
                            _gOutSum += _pg = stackOut.g;
                            _bOutSum += _pb = stackOut.b;
                            _aOutSum += _pa = stackOut.a;
                            _rInSum -= _pr;
                            _gInSum -= _pg;
                            _bInSum -= _pb;
                            _aInSum -= _pa;
                            stackOut = stackOut.next;
                            yi += width;
                        }
                    }
                    return imageData;
                }
                /**
 * @param {HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {undefined}
 */ function processCanvasRGB(canvas, topX, topY, width, height, radius) {
                    if (isNaN(radius) || radius < 1) return;
                    radius |= 0;
                    var imageData = getImageDataFromCanvas(canvas, topX, topY, width, height);
                    imageData = processImageDataRGB(imageData, topX, topY, width, height, radius);
                    canvas.getContext('2d').putImageData(imageData, topX, topY);
                }
                /**
 * @param {ImageData} imageData
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {ImageData}
 */ function processImageDataRGB(imageData, topX, topY, width, height, radius) {
                    var pixels = imageData.data;
                    var div = 2 * radius + 1; // const w4 = width << 2;
                    var widthMinus1 = width - 1;
                    var heightMinus1 = height - 1;
                    var radiusPlus1 = radius + 1;
                    var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;
                    var stackStart = new BlurStack();
                    var stack = stackStart;
                    var stackEnd;
                    for(var i = 1; i < div; i++){
                        stack = stack.next = new BlurStack();
                        if (i === radiusPlus1) stackEnd = stack;
                    }
                    stack.next = stackStart;
                    var stackIn = null;
                    var stackOut = null;
                    var mulSum = mulTable[radius];
                    var shgSum = shgTable[radius];
                    var p, rbs;
                    var yw = 0, yi = 0;
                    for(var y = 0; y < height; y++){
                        var pr = pixels[yi], pg = pixels[yi + 1], pb = pixels[yi + 2], rOutSum = radiusPlus1 * pr, gOutSum = radiusPlus1 * pg, bOutSum = radiusPlus1 * pb, rSum = sumFactor * pr, gSum = sumFactor * pg, bSum = sumFactor * pb;
                        stack = stackStart;
                        for(var _i5 = 0; _i5 < radiusPlus1; _i5++){
                            stack.r = pr;
                            stack.g = pg;
                            stack.b = pb;
                            stack = stack.next;
                        }
                        var rInSum = 0, gInSum = 0, bInSum = 0;
                        for(var _i6 = 1; _i6 < radiusPlus1; _i6++){
                            p = yi + ((widthMinus1 < _i6 ? widthMinus1 : _i6) << 2);
                            rSum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - _i6);
                            gSum += (stack.g = pg = pixels[p + 1]) * rbs;
                            bSum += (stack.b = pb = pixels[p + 2]) * rbs;
                            rInSum += pr;
                            gInSum += pg;
                            bInSum += pb;
                            stack = stack.next;
                        }
                        stackIn = stackStart;
                        stackOut = stackEnd;
                        for(var x = 0; x < width; x++){
                            pixels[yi] = rSum * mulSum >>> shgSum;
                            pixels[yi + 1] = gSum * mulSum >>> shgSum;
                            pixels[yi + 2] = bSum * mulSum >>> shgSum;
                            rSum -= rOutSum;
                            gSum -= gOutSum;
                            bSum -= bOutSum;
                            rOutSum -= stackIn.r;
                            gOutSum -= stackIn.g;
                            bOutSum -= stackIn.b;
                            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
                            rInSum += stackIn.r = pixels[p];
                            gInSum += stackIn.g = pixels[p + 1];
                            bInSum += stackIn.b = pixels[p + 2];
                            rSum += rInSum;
                            gSum += gInSum;
                            bSum += bInSum;
                            stackIn = stackIn.next;
                            rOutSum += pr = stackOut.r;
                            gOutSum += pg = stackOut.g;
                            bOutSum += pb = stackOut.b;
                            rInSum -= pr;
                            gInSum -= pg;
                            bInSum -= pb;
                            stackOut = stackOut.next;
                            yi += 4;
                        }
                        yw += width;
                    }
                    for(var _x2 = 0; _x2 < width; _x2++){
                        yi = _x2 << 2;
                        var _pr2 = pixels[yi], _pg2 = pixels[yi + 1], _pb2 = pixels[yi + 2], _rOutSum2 = radiusPlus1 * _pr2, _gOutSum2 = radiusPlus1 * _pg2, _bOutSum2 = radiusPlus1 * _pb2, _rSum2 = sumFactor * _pr2, _gSum2 = sumFactor * _pg2, _bSum2 = sumFactor * _pb2;
                        stack = stackStart;
                        for(var _i7 = 0; _i7 < radiusPlus1; _i7++){
                            stack.r = _pr2;
                            stack.g = _pg2;
                            stack.b = _pb2;
                            stack = stack.next;
                        }
                        var _rInSum2 = 0, _gInSum2 = 0, _bInSum2 = 0;
                        for(var _i8 = 1, yp = width; _i8 <= radius; _i8++){
                            yi = yp + _x2 << 2;
                            _rSum2 += (stack.r = _pr2 = pixels[yi]) * (rbs = radiusPlus1 - _i8);
                            _gSum2 += (stack.g = _pg2 = pixels[yi + 1]) * rbs;
                            _bSum2 += (stack.b = _pb2 = pixels[yi + 2]) * rbs;
                            _rInSum2 += _pr2;
                            _gInSum2 += _pg2;
                            _bInSum2 += _pb2;
                            stack = stack.next;
                            if (_i8 < heightMinus1) yp += width;
                        }
                        yi = _x2;
                        stackIn = stackStart;
                        stackOut = stackEnd;
                        for(var _y2 = 0; _y2 < height; _y2++){
                            p = yi << 2;
                            pixels[p] = _rSum2 * mulSum >>> shgSum;
                            pixels[p + 1] = _gSum2 * mulSum >>> shgSum;
                            pixels[p + 2] = _bSum2 * mulSum >>> shgSum;
                            _rSum2 -= _rOutSum2;
                            _gSum2 -= _gOutSum2;
                            _bSum2 -= _bOutSum2;
                            _rOutSum2 -= stackIn.r;
                            _gOutSum2 -= stackIn.g;
                            _bOutSum2 -= stackIn.b;
                            p = _x2 + ((p = _y2 + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
                            _rSum2 += _rInSum2 += stackIn.r = pixels[p];
                            _gSum2 += _gInSum2 += stackIn.g = pixels[p + 1];
                            _bSum2 += _bInSum2 += stackIn.b = pixels[p + 2];
                            stackIn = stackIn.next;
                            _rOutSum2 += _pr2 = stackOut.r;
                            _gOutSum2 += _pg2 = stackOut.g;
                            _bOutSum2 += _pb2 = stackOut.b;
                            _rInSum2 -= _pr2;
                            _gInSum2 -= _pg2;
                            _bInSum2 -= _pb2;
                            stackOut = stackOut.next;
                            yi += width;
                        }
                    }
                    return imageData;
                }
                /**
 *
 */ var BlurStack = /**
 * Set properties.
 */ function BlurStack() {
                    _classCallCheck(this, BlurStack);
                    this.r = 0;
                    this.g = 0;
                    this.b = 0;
                    this.a = 0;
                    this.next = null;
                };
            /***/ },
            /***/ "./node_modules/svg-pathdata/lib/SVGPathData.module.js": /*!*************************************************************!*\
  !*** ./node_modules/svg-pathdata/lib/SVGPathData.module.js ***!
  \*************************************************************/ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ COMMAND_ARG_COUNTS: function() {
                        return /* binding */ N;
                    },
                    /* harmony export */ SVGPathData: function() {
                        return /* binding */ _;
                    },
                    /* harmony export */ SVGPathDataParser: function() {
                        return /* binding */ f;
                    },
                    /* harmony export */ SVGPathDataTransformer: function() {
                        return /* binding */ u;
                    },
                    /* harmony export */ encodeSVGPath: function() {
                        return /* binding */ e;
                    }
                });
                /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var t = function(r, e) {
                    return (t = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(t, r) {
                        t.__proto__ = r;
                    } || function(t, r) {
                        for(var e in r)Object.prototype.hasOwnProperty.call(r, e) && (t[e] = r[e]);
                    })(r, e);
                };
                function r(r, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
                    function i() {
                        this.constructor = r;
                    }
                    t(r, e), r.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
                }
                function e(t) {
                    var r = "";
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var e = 0; e < t.length; e++){
                        var i = t[e];
                        if (i.type === _.CLOSE_PATH) r += "z";
                        else if (i.type === _.HORIZ_LINE_TO) r += (i.relative ? "h" : "H") + i.x;
                        else if (i.type === _.VERT_LINE_TO) r += (i.relative ? "v" : "V") + i.y;
                        else if (i.type === _.MOVE_TO) r += (i.relative ? "m" : "M") + i.x + " " + i.y;
                        else if (i.type === _.LINE_TO) r += (i.relative ? "l" : "L") + i.x + " " + i.y;
                        else if (i.type === _.CURVE_TO) r += (i.relative ? "c" : "C") + i.x1 + " " + i.y1 + " " + i.x2 + " " + i.y2 + " " + i.x + " " + i.y;
                        else if (i.type === _.SMOOTH_CURVE_TO) r += (i.relative ? "s" : "S") + i.x2 + " " + i.y2 + " " + i.x + " " + i.y;
                        else if (i.type === _.QUAD_TO) r += (i.relative ? "q" : "Q") + i.x1 + " " + i.y1 + " " + i.x + " " + i.y;
                        else if (i.type === _.SMOOTH_QUAD_TO) r += (i.relative ? "t" : "T") + i.x + " " + i.y;
                        else {
                            if (i.type !== _.ARC) throw new Error('Unexpected command type "' + i.type + '" at index ' + e + ".");
                            r += (i.relative ? "a" : "A") + i.rX + " " + i.rY + " " + i.xRot + " " + +i.lArcFlag + " " + +i.sweepFlag + " " + i.x + " " + i.y;
                        }
                    }
                    return r;
                }
                function i(t, r) {
                    var e = t[0], i = t[1];
                    return [
                        e * Math.cos(r) - i * Math.sin(r),
                        e * Math.sin(r) + i * Math.cos(r)
                    ];
                }
                function a() {
                    for(var t = [], r = 0; r < arguments.length; r++)t[r] = arguments[r];
                    for(var e = 0; e < t.length; e++)if ("number" != typeof t[e]) throw new Error("assertNumbers arguments[" + e + "] is not a number. " + typeof t[e] + " == typeof " + t[e]);
                    return !0;
                }
                var n = Math.PI;
                function o(t, r, e) {
                    t.lArcFlag = 0 === t.lArcFlag ? 0 : 1, t.sweepFlag = 0 === t.sweepFlag ? 0 : 1;
                    var a = t.rX, o = t.rY, s = t.x, u = t.y;
                    a = Math.abs(t.rX), o = Math.abs(t.rY);
                    var h = i([
                        (r - s) / 2,
                        (e - u) / 2
                    ], -t.xRot / 180 * n), c = h[0], y = h[1], p = Math.pow(c, 2) / Math.pow(a, 2) + Math.pow(y, 2) / Math.pow(o, 2);
                    1 < p && (a *= Math.sqrt(p), o *= Math.sqrt(p)), t.rX = a, t.rY = o;
                    var m = Math.pow(a, 2) * Math.pow(y, 2) + Math.pow(o, 2) * Math.pow(c, 2), O = (t.lArcFlag !== t.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(a, 2) * Math.pow(o, 2) - m) / m)), l = a * y / o * O, T = -o * c / a * O, v = i([
                        l,
                        T
                    ], t.xRot / 180 * n);
                    t.cX = v[0] + (r + s) / 2, t.cY = v[1] + (e + u) / 2, t.phi1 = Math.atan2((y - T) / o, (c - l) / a), t.phi2 = Math.atan2((-y - T) / o, (-c - l) / a), 0 === t.sweepFlag && t.phi2 > t.phi1 && (t.phi2 -= 2 * n), 1 === t.sweepFlag && t.phi2 < t.phi1 && (t.phi2 += 2 * n), t.phi1 *= 180 / n, t.phi2 *= 180 / n;
                }
                function s(t, r, e) {
                    a(t, r, e);
                    var i = t * t + r * r - e * e;
                    if (0 > i) return [];
                    if (0 === i) return [
                        [
                            t * e / (t * t + r * r),
                            r * e / (t * t + r * r)
                        ]
                    ];
                    var n = Math.sqrt(i);
                    return [
                        [
                            (t * e + r * n) / (t * t + r * r),
                            (r * e - t * n) / (t * t + r * r)
                        ],
                        [
                            (t * e - r * n) / (t * t + r * r),
                            (r * e + t * n) / (t * t + r * r)
                        ]
                    ];
                }
                var u, h = Math.PI / 180;
                function c(t, r, e) {
                    return (1 - e) * t + e * r;
                }
                function y(t, r, e, i) {
                    return t + Math.cos(i / 180 * n) * r + Math.sin(i / 180 * n) * e;
                }
                function p(t, r, e, i) {
                    var a = 1e-6, n = r - t, o = e - r, s = 3 * n + 3 * (i - e) - 6 * o, u = 6 * (o - n), h = 3 * n;
                    return Math.abs(s) < a ? [
                        -h / u
                    ] : function(t, r, e) {
                        void 0 === e && (e = 1e-6);
                        var i = t * t / 4 - r;
                        if (i < -e) return [];
                        if (i <= e) return [
                            -t / 2
                        ];
                        var a = Math.sqrt(i);
                        return [
                            -t / 2 - a,
                            -t / 2 + a
                        ];
                    }(u / s, h / s, a);
                }
                function m(t, r, e, i, a) {
                    var n = 1 - a;
                    return t * (n * n * n) + r * (3 * n * n * a) + e * (3 * n * a * a) + i * (a * a * a);
                }
                !function(t) {
                    function r() {
                        return u(function(t, r, e) {
                            return t.relative && (void 0 !== t.x1 && (t.x1 += r), void 0 !== t.y1 && (t.y1 += e), void 0 !== t.x2 && (t.x2 += r), void 0 !== t.y2 && (t.y2 += e), void 0 !== t.x && (t.x += r), void 0 !== t.y && (t.y += e), t.relative = !1), t;
                        });
                    }
                    function e() {
                        var t = NaN, r = NaN, e = NaN, i = NaN;
                        return u(function(a, n, o) {
                            return a.type & _.SMOOTH_CURVE_TO && (a.type = _.CURVE_TO, t = isNaN(t) ? n : t, r = isNaN(r) ? o : r, a.x1 = a.relative ? n - t : 2 * n - t, a.y1 = a.relative ? o - r : 2 * o - r), a.type & _.CURVE_TO ? (t = a.relative ? n + a.x2 : a.x2, r = a.relative ? o + a.y2 : a.y2) : (t = NaN, r = NaN), a.type & _.SMOOTH_QUAD_TO && (a.type = _.QUAD_TO, e = isNaN(e) ? n : e, i = isNaN(i) ? o : i, a.x1 = a.relative ? n - e : 2 * n - e, a.y1 = a.relative ? o - i : 2 * o - i), a.type & _.QUAD_TO ? (e = a.relative ? n + a.x1 : a.x1, i = a.relative ? o + a.y1 : a.y1) : (e = NaN, i = NaN), a;
                        });
                    }
                    function n() {
                        var t = NaN, r = NaN;
                        return u(function(e, i, a) {
                            if (e.type & _.SMOOTH_QUAD_TO && (e.type = _.QUAD_TO, t = isNaN(t) ? i : t, r = isNaN(r) ? a : r, e.x1 = e.relative ? i - t : 2 * i - t, e.y1 = e.relative ? a - r : 2 * a - r), e.type & _.QUAD_TO) {
                                t = e.relative ? i + e.x1 : e.x1, r = e.relative ? a + e.y1 : e.y1;
                                var n = e.x1, o = e.y1;
                                e.type = _.CURVE_TO, e.x1 = ((e.relative ? 0 : i) + 2 * n) / 3, e.y1 = ((e.relative ? 0 : a) + 2 * o) / 3, e.x2 = (e.x + 2 * n) / 3, e.y2 = (e.y + 2 * o) / 3;
                            } else t = NaN, r = NaN;
                            return e;
                        });
                    }
                    function u(t) {
                        var r = 0, e = 0, i = NaN, a = NaN;
                        return function(n) {
                            if (isNaN(i) && !(n.type & _.MOVE_TO)) throw new Error("path must start with moveto");
                            var o = t(n, r, e, i, a);
                            return n.type & _.CLOSE_PATH && (r = i, e = a), void 0 !== n.x && (r = n.relative ? r + n.x : n.x), void 0 !== n.y && (e = n.relative ? e + n.y : n.y), n.type & _.MOVE_TO && (i = r, a = e), o;
                        };
                    }
                    function O(t, r, e, i, n, o) {
                        return a(t, r, e, i, n, o), u(function(a, s, u, h) {
                            var c = a.x1, y = a.x2, p = a.relative && !isNaN(h), m = void 0 !== a.x ? a.x : p ? 0 : s, O = void 0 !== a.y ? a.y : p ? 0 : u;
                            function l(t) {
                                return t * t;
                            }
                            a.type & _.HORIZ_LINE_TO && 0 !== r && (a.type = _.LINE_TO, a.y = a.relative ? 0 : u), a.type & _.VERT_LINE_TO && 0 !== e && (a.type = _.LINE_TO, a.x = a.relative ? 0 : s), void 0 !== a.x && (a.x = a.x * t + O * e + (p ? 0 : n)), void 0 !== a.y && (a.y = m * r + a.y * i + (p ? 0 : o)), void 0 !== a.x1 && (a.x1 = a.x1 * t + a.y1 * e + (p ? 0 : n)), void 0 !== a.y1 && (a.y1 = c * r + a.y1 * i + (p ? 0 : o)), void 0 !== a.x2 && (a.x2 = a.x2 * t + a.y2 * e + (p ? 0 : n)), void 0 !== a.y2 && (a.y2 = y * r + a.y2 * i + (p ? 0 : o));
                            var T = t * i - r * e;
                            if (void 0 !== a.xRot && (1 !== t || 0 !== r || 0 !== e || 1 !== i)) {
                                if (0 === T) delete a.rX, delete a.rY, delete a.xRot, delete a.lArcFlag, delete a.sweepFlag, a.type = _.LINE_TO;
                                else {
                                    var v = a.xRot * Math.PI / 180, f = Math.sin(v), N = Math.cos(v), x = 1 / l(a.rX), d = 1 / l(a.rY), E = l(N) * x + l(f) * d, A = 2 * f * N * (x - d), C = l(f) * x + l(N) * d, M = E * i * i - A * r * i + C * r * r, R = A * (t * i + r * e) - 2 * (E * e * i + C * t * r), g = E * e * e - A * t * e + C * t * t, I = (Math.atan2(R, M - g) + Math.PI) % Math.PI / 2, S = Math.sin(I), L = Math.cos(I);
                                    a.rX = Math.abs(T) / Math.sqrt(M * l(L) + R * S * L + g * l(S)), a.rY = Math.abs(T) / Math.sqrt(M * l(S) - R * S * L + g * l(L)), a.xRot = 180 * I / Math.PI;
                                }
                            }
                            return void 0 !== a.sweepFlag && 0 > T && (a.sweepFlag = +!a.sweepFlag), a;
                        });
                    }
                    function l() {
                        return function(t) {
                            var r = {};
                            for(var e in t)r[e] = t[e];
                            return r;
                        };
                    }
                    t.ROUND = function(t) {
                        function r(r) {
                            return Math.round(r * t) / t;
                        }
                        return void 0 === t && (t = 1e13), a(t), function(t) {
                            return void 0 !== t.x1 && (t.x1 = r(t.x1)), void 0 !== t.y1 && (t.y1 = r(t.y1)), void 0 !== t.x2 && (t.x2 = r(t.x2)), void 0 !== t.y2 && (t.y2 = r(t.y2)), void 0 !== t.x && (t.x = r(t.x)), void 0 !== t.y && (t.y = r(t.y)), void 0 !== t.rX && (t.rX = r(t.rX)), void 0 !== t.rY && (t.rY = r(t.rY)), t;
                        };
                    }, t.TO_ABS = r, t.TO_REL = function() {
                        return u(function(t, r, e) {
                            return t.relative || (void 0 !== t.x1 && (t.x1 -= r), void 0 !== t.y1 && (t.y1 -= e), void 0 !== t.x2 && (t.x2 -= r), void 0 !== t.y2 && (t.y2 -= e), void 0 !== t.x && (t.x -= r), void 0 !== t.y && (t.y -= e), t.relative = !0), t;
                        });
                    }, t.NORMALIZE_HVZ = function(t, r, e) {
                        return void 0 === t && (t = !0), void 0 === r && (r = !0), void 0 === e && (e = !0), u(function(i, a, n, o, s) {
                            if (isNaN(o) && !(i.type & _.MOVE_TO)) throw new Error("path must start with moveto");
                            return r && i.type & _.HORIZ_LINE_TO && (i.type = _.LINE_TO, i.y = i.relative ? 0 : n), e && i.type & _.VERT_LINE_TO && (i.type = _.LINE_TO, i.x = i.relative ? 0 : a), t && i.type & _.CLOSE_PATH && (i.type = _.LINE_TO, i.x = i.relative ? o - a : o, i.y = i.relative ? s - n : s), i.type & _.ARC && (0 === i.rX || 0 === i.rY) && (i.type = _.LINE_TO, delete i.rX, delete i.rY, delete i.xRot, delete i.lArcFlag, delete i.sweepFlag), i;
                        });
                    }, t.NORMALIZE_ST = e, t.QT_TO_C = n, t.INFO = u, t.SANITIZE = function(t) {
                        void 0 === t && (t = 0), a(t);
                        var r = NaN, e = NaN, i = NaN, n = NaN;
                        return u(function(a, o, s, u, h) {
                            var c = Math.abs, y = !1, p = 0, m = 0;
                            if (a.type & _.SMOOTH_CURVE_TO && (p = isNaN(r) ? 0 : o - r, m = isNaN(e) ? 0 : s - e), a.type & (_.CURVE_TO | _.SMOOTH_CURVE_TO) ? (r = a.relative ? o + a.x2 : a.x2, e = a.relative ? s + a.y2 : a.y2) : (r = NaN, e = NaN), a.type & _.SMOOTH_QUAD_TO ? (i = isNaN(i) ? o : 2 * o - i, n = isNaN(n) ? s : 2 * s - n) : a.type & _.QUAD_TO ? (i = a.relative ? o + a.x1 : a.x1, n = a.relative ? s + a.y1 : a.y2) : (i = NaN, n = NaN), a.type & _.LINE_COMMANDS || a.type & _.ARC && (0 === a.rX || 0 === a.rY || !a.lArcFlag) || a.type & _.CURVE_TO || a.type & _.SMOOTH_CURVE_TO || a.type & _.QUAD_TO || a.type & _.SMOOTH_QUAD_TO) {
                                var O = void 0 === a.x ? 0 : a.relative ? a.x : a.x - o, l = void 0 === a.y ? 0 : a.relative ? a.y : a.y - s;
                                p = isNaN(i) ? void 0 === a.x1 ? p : a.relative ? a.x : a.x1 - o : i - o, m = isNaN(n) ? void 0 === a.y1 ? m : a.relative ? a.y : a.y1 - s : n - s;
                                var T = void 0 === a.x2 ? 0 : a.relative ? a.x : a.x2 - o, v = void 0 === a.y2 ? 0 : a.relative ? a.y : a.y2 - s;
                                c(O) <= t && c(l) <= t && c(p) <= t && c(m) <= t && c(T) <= t && c(v) <= t && (y = !0);
                            }
                            return a.type & _.CLOSE_PATH && c(o - u) <= t && c(s - h) <= t && (y = !0), y ? [] : a;
                        });
                    }, t.MATRIX = O, t.ROTATE = function(t, r, e) {
                        void 0 === r && (r = 0), void 0 === e && (e = 0), a(t, r, e);
                        var i = Math.sin(t), n = Math.cos(t);
                        return O(n, i, -i, n, r - r * n + e * i, e - r * i - e * n);
                    }, t.TRANSLATE = function(t, r) {
                        return void 0 === r && (r = 0), a(t, r), O(1, 0, 0, 1, t, r);
                    }, t.SCALE = function(t, r) {
                        return void 0 === r && (r = t), a(t, r), O(t, 0, 0, r, 0, 0);
                    }, t.SKEW_X = function(t) {
                        return a(t), O(1, 0, Math.atan(t), 1, 0, 0);
                    }, t.SKEW_Y = function(t) {
                        return a(t), O(1, Math.atan(t), 0, 1, 0, 0);
                    }, t.X_AXIS_SYMMETRY = function(t) {
                        return void 0 === t && (t = 0), a(t), O(-1, 0, 0, 1, t, 0);
                    }, t.Y_AXIS_SYMMETRY = function(t) {
                        return void 0 === t && (t = 0), a(t), O(1, 0, 0, -1, 0, t);
                    }, t.A_TO_C = function() {
                        return u(function(t, r, e) {
                            return _.ARC === t.type ? function(t, r, e) {
                                var a, n, s, u;
                                t.cX || o(t, r, e);
                                for(var y = Math.min(t.phi1, t.phi2), p = Math.max(t.phi1, t.phi2) - y, m = Math.ceil(p / 90), O = new Array(m), l = r, T = e, v = 0; v < m; v++){
                                    var f = c(t.phi1, t.phi2, v / m), N = c(t.phi1, t.phi2, (v + 1) / m), x = N - f, d = 4 / 3 * Math.tan(x * h / 4), E = [
                                        Math.cos(f * h) - d * Math.sin(f * h),
                                        Math.sin(f * h) + d * Math.cos(f * h)
                                    ], A = E[0], C = E[1], M = [
                                        Math.cos(N * h),
                                        Math.sin(N * h)
                                    ], R = M[0], g = M[1], I = [
                                        R + d * Math.sin(N * h),
                                        g - d * Math.cos(N * h)
                                    ], S = I[0], L = I[1];
                                    O[v] = {
                                        relative: t.relative,
                                        type: _.CURVE_TO
                                    };
                                    var H = function(r, e) {
                                        var a = i([
                                            r * t.rX,
                                            e * t.rY
                                        ], t.xRot), n = a[0], o = a[1];
                                        return [
                                            t.cX + n,
                                            t.cY + o
                                        ];
                                    };
                                    a = H(A, C), O[v].x1 = a[0], O[v].y1 = a[1], n = H(S, L), O[v].x2 = n[0], O[v].y2 = n[1], s = H(R, g), O[v].x = s[0], O[v].y = s[1], t.relative && (O[v].x1 -= l, O[v].y1 -= T, O[v].x2 -= l, O[v].y2 -= T, O[v].x -= l, O[v].y -= T), l = (u = [
                                        O[v].x,
                                        O[v].y
                                    ])[0], T = u[1];
                                }
                                return O;
                            }(t, t.relative ? 0 : r, t.relative ? 0 : e) : t;
                        });
                    }, t.ANNOTATE_ARCS = function() {
                        return u(function(t, r, e) {
                            return t.relative && (r = 0, e = 0), _.ARC === t.type && o(t, r, e), t;
                        });
                    }, t.CLONE = l, t.CALCULATE_BOUNDS = function() {
                        var t = function(t) {
                            var r = {};
                            for(var e in t)r[e] = t[e];
                            return r;
                        }, i = r(), a = n(), h = e(), c = u(function(r, e, n) {
                            var u = h(a(i(t(r))));
                            function O(t) {
                                t > c.maxX && (c.maxX = t), t < c.minX && (c.minX = t);
                            }
                            function l(t) {
                                t > c.maxY && (c.maxY = t), t < c.minY && (c.minY = t);
                            }
                            if (u.type & _.DRAWING_COMMANDS && (O(e), l(n)), u.type & _.HORIZ_LINE_TO && O(u.x), u.type & _.VERT_LINE_TO && l(u.y), u.type & _.LINE_TO && (O(u.x), l(u.y)), u.type & _.CURVE_TO) {
                                O(u.x), l(u.y);
                                for(var T = 0, v = p(e, u.x1, u.x2, u.x); T < v.length; T++)0 < (w = v[T]) && 1 > w && O(m(e, u.x1, u.x2, u.x, w));
                                for(var f = 0, N = p(n, u.y1, u.y2, u.y); f < N.length; f++)0 < (w = N[f]) && 1 > w && l(m(n, u.y1, u.y2, u.y, w));
                            }
                            if (u.type & _.ARC) {
                                O(u.x), l(u.y), o(u, e, n);
                                for(var x = u.xRot / 180 * Math.PI, d = Math.cos(x) * u.rX, E = Math.sin(x) * u.rX, A = -Math.sin(x) * u.rY, C = Math.cos(x) * u.rY, M = u.phi1 < u.phi2 ? [
                                    u.phi1,
                                    u.phi2
                                ] : -180 > u.phi2 ? [
                                    u.phi2 + 360,
                                    u.phi1 + 360
                                ] : [
                                    u.phi2,
                                    u.phi1
                                ], R = M[0], g = M[1], I = function(t) {
                                    var r = t[0], e = t[1], i = 180 * Math.atan2(e, r) / Math.PI;
                                    return i < R ? i + 360 : i;
                                }, S = 0, L = s(A, -d, 0).map(I); S < L.length; S++)(w = L[S]) > R && w < g && O(y(u.cX, d, A, w));
                                for(var H = 0, U = s(C, -E, 0).map(I); H < U.length; H++){
                                    var w;
                                    (w = U[H]) > R && w < g && l(y(u.cY, E, C, w));
                                }
                            }
                            return r;
                        });
                        return c.minX = 1 / 0, c.maxX = -1 / 0, c.minY = 1 / 0, c.maxY = -1 / 0, c;
                    };
                }(u || (u = {}));
                var O, l = function() {
                    function t() {}
                    return t.prototype.round = function(t) {
                        return this.transform(u.ROUND(t));
                    }, t.prototype.toAbs = function() {
                        return this.transform(u.TO_ABS());
                    }, t.prototype.toRel = function() {
                        return this.transform(u.TO_REL());
                    }, t.prototype.normalizeHVZ = function(t, r, e) {
                        return this.transform(u.NORMALIZE_HVZ(t, r, e));
                    }, t.prototype.normalizeST = function() {
                        return this.transform(u.NORMALIZE_ST());
                    }, t.prototype.qtToC = function() {
                        return this.transform(u.QT_TO_C());
                    }, t.prototype.aToC = function() {
                        return this.transform(u.A_TO_C());
                    }, t.prototype.sanitize = function(t) {
                        return this.transform(u.SANITIZE(t));
                    }, t.prototype.translate = function(t, r) {
                        return this.transform(u.TRANSLATE(t, r));
                    }, t.prototype.scale = function(t, r) {
                        return this.transform(u.SCALE(t, r));
                    }, t.prototype.rotate = function(t, r, e) {
                        return this.transform(u.ROTATE(t, r, e));
                    }, t.prototype.matrix = function(t, r, e, i, a, n) {
                        return this.transform(u.MATRIX(t, r, e, i, a, n));
                    }, t.prototype.skewX = function(t) {
                        return this.transform(u.SKEW_X(t));
                    }, t.prototype.skewY = function(t) {
                        return this.transform(u.SKEW_Y(t));
                    }, t.prototype.xSymmetry = function(t) {
                        return this.transform(u.X_AXIS_SYMMETRY(t));
                    }, t.prototype.ySymmetry = function(t) {
                        return this.transform(u.Y_AXIS_SYMMETRY(t));
                    }, t.prototype.annotateArcs = function() {
                        return this.transform(u.ANNOTATE_ARCS());
                    }, t;
                }(), T = function(t) {
                    return " " === t || "\t" === t || "\r" === t || "\n" === t;
                }, v = function(t) {
                    return "0".charCodeAt(0) <= t.charCodeAt(0) && t.charCodeAt(0) <= "9".charCodeAt(0);
                }, f = function(t) {
                    function e() {
                        var r = t.call(this) || this;
                        return r.curNumber = "", r.curCommandType = -1, r.curCommandRelative = !1, r.canParseCommandOrComma = !0, r.curNumberHasExp = !1, r.curNumberHasExpDigits = !1, r.curNumberHasDecimal = !1, r.curArgs = [], r;
                    }
                    return r(e, t), e.prototype.finish = function(t) {
                        if (void 0 === t && (t = []), this.parse(" ", t), 0 !== this.curArgs.length || !this.canParseCommandOrComma) throw new SyntaxError("Unterminated command at the path end.");
                        return t;
                    }, e.prototype.parse = function(t, r) {
                        var e = this;
                        void 0 === r && (r = []);
                        for(var i = function(t) {
                            r.push(t), e.curArgs.length = 0, e.canParseCommandOrComma = !0;
                        }, a = 0; a < t.length; a++){
                            var n = t[a], o = !(this.curCommandType !== _.ARC || 3 !== this.curArgs.length && 4 !== this.curArgs.length || 1 !== this.curNumber.length || "0" !== this.curNumber && "1" !== this.curNumber), s = v(n) && ("0" === this.curNumber && "0" === n || o);
                            if (!v(n) || s) {
                                if ("e" !== n && "E" !== n) {
                                    if ("-" !== n && "+" !== n || !this.curNumberHasExp || this.curNumberHasExpDigits) {
                                        if ("." !== n || this.curNumberHasExp || this.curNumberHasDecimal || o) {
                                            if (this.curNumber && -1 !== this.curCommandType) {
                                                var u = Number(this.curNumber);
                                                if (isNaN(u)) throw new SyntaxError("Invalid number ending at " + a);
                                                if (this.curCommandType === _.ARC) {
                                                    if (0 === this.curArgs.length || 1 === this.curArgs.length) {
                                                        if (0 > u) throw new SyntaxError('Expected positive number, got "' + u + '" at index "' + a + '"');
                                                    } else if ((3 === this.curArgs.length || 4 === this.curArgs.length) && "0" !== this.curNumber && "1" !== this.curNumber) throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + a + '"');
                                                }
                                                this.curArgs.push(u), this.curArgs.length === N[this.curCommandType] && (_.HORIZ_LINE_TO === this.curCommandType ? i({
                                                    type: _.HORIZ_LINE_TO,
                                                    relative: this.curCommandRelative,
                                                    x: u
                                                }) : _.VERT_LINE_TO === this.curCommandType ? i({
                                                    type: _.VERT_LINE_TO,
                                                    relative: this.curCommandRelative,
                                                    y: u
                                                }) : this.curCommandType === _.MOVE_TO || this.curCommandType === _.LINE_TO || this.curCommandType === _.SMOOTH_QUAD_TO ? (i({
                                                    type: this.curCommandType,
                                                    relative: this.curCommandRelative,
                                                    x: this.curArgs[0],
                                                    y: this.curArgs[1]
                                                }), _.MOVE_TO === this.curCommandType && (this.curCommandType = _.LINE_TO)) : this.curCommandType === _.CURVE_TO ? i({
                                                    type: _.CURVE_TO,
                                                    relative: this.curCommandRelative,
                                                    x1: this.curArgs[0],
                                                    y1: this.curArgs[1],
                                                    x2: this.curArgs[2],
                                                    y2: this.curArgs[3],
                                                    x: this.curArgs[4],
                                                    y: this.curArgs[5]
                                                }) : this.curCommandType === _.SMOOTH_CURVE_TO ? i({
                                                    type: _.SMOOTH_CURVE_TO,
                                                    relative: this.curCommandRelative,
                                                    x2: this.curArgs[0],
                                                    y2: this.curArgs[1],
                                                    x: this.curArgs[2],
                                                    y: this.curArgs[3]
                                                }) : this.curCommandType === _.QUAD_TO ? i({
                                                    type: _.QUAD_TO,
                                                    relative: this.curCommandRelative,
                                                    x1: this.curArgs[0],
                                                    y1: this.curArgs[1],
                                                    x: this.curArgs[2],
                                                    y: this.curArgs[3]
                                                }) : this.curCommandType === _.ARC && i({
                                                    type: _.ARC,
                                                    relative: this.curCommandRelative,
                                                    rX: this.curArgs[0],
                                                    rY: this.curArgs[1],
                                                    xRot: this.curArgs[2],
                                                    lArcFlag: this.curArgs[3],
                                                    sweepFlag: this.curArgs[4],
                                                    x: this.curArgs[5],
                                                    y: this.curArgs[6]
                                                })), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
                                            }
                                            if (!T(n)) {
                                                if ("," === n && this.canParseCommandOrComma) this.canParseCommandOrComma = !1;
                                                else if ("+" !== n && "-" !== n && "." !== n) {
                                                    if (s) this.curNumber = n, this.curNumberHasDecimal = !1;
                                                    else {
                                                        if (0 !== this.curArgs.length) throw new SyntaxError("Unterminated command at index " + a + ".");
                                                        if (!this.canParseCommandOrComma) throw new SyntaxError('Unexpected character "' + n + '" at index ' + a + ". Command cannot follow comma");
                                                        if (this.canParseCommandOrComma = !1, "z" !== n && "Z" !== n) {
                                                            if ("h" === n || "H" === n) this.curCommandType = _.HORIZ_LINE_TO, this.curCommandRelative = "h" === n;
                                                            else if ("v" === n || "V" === n) this.curCommandType = _.VERT_LINE_TO, this.curCommandRelative = "v" === n;
                                                            else if ("m" === n || "M" === n) this.curCommandType = _.MOVE_TO, this.curCommandRelative = "m" === n;
                                                            else if ("l" === n || "L" === n) this.curCommandType = _.LINE_TO, this.curCommandRelative = "l" === n;
                                                            else if ("c" === n || "C" === n) this.curCommandType = _.CURVE_TO, this.curCommandRelative = "c" === n;
                                                            else if ("s" === n || "S" === n) this.curCommandType = _.SMOOTH_CURVE_TO, this.curCommandRelative = "s" === n;
                                                            else if ("q" === n || "Q" === n) this.curCommandType = _.QUAD_TO, this.curCommandRelative = "q" === n;
                                                            else if ("t" === n || "T" === n) this.curCommandType = _.SMOOTH_QUAD_TO, this.curCommandRelative = "t" === n;
                                                            else {
                                                                if ("a" !== n && "A" !== n) throw new SyntaxError('Unexpected character "' + n + '" at index ' + a + ".");
                                                                this.curCommandType = _.ARC, this.curCommandRelative = "a" === n;
                                                            }
                                                        } else r.push({
                                                            type: _.CLOSE_PATH
                                                        }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
                                                    }
                                                } else this.curNumber = n, this.curNumberHasDecimal = "." === n;
                                            }
                                        } else this.curNumber += n, this.curNumberHasDecimal = !0;
                                    } else this.curNumber += n;
                                } else this.curNumber += n, this.curNumberHasExp = !0;
                            } else this.curNumber += n, this.curNumberHasExpDigits = this.curNumberHasExp;
                        }
                        return r;
                    }, e.prototype.transform = function(t) {
                        return Object.create(this, {
                            parse: {
                                value: function(r, e) {
                                    void 0 === e && (e = []);
                                    for(var i = 0, a = Object.getPrototypeOf(this).parse.call(this, r); i < a.length; i++){
                                        var n = a[i], o = t(n);
                                        Array.isArray(o) ? e.push.apply(e, o) : e.push(o);
                                    }
                                    return e;
                                }
                            }
                        });
                    }, e;
                }(l), _ = function(t) {
                    function i(r) {
                        var e = t.call(this) || this;
                        return e.commands = "string" == typeof r ? i.parse(r) : r, e;
                    }
                    return r(i, t), i.prototype.encode = function() {
                        return i.encode(this.commands);
                    }, i.prototype.getBounds = function() {
                        var t = u.CALCULATE_BOUNDS();
                        return this.transform(t), t;
                    }, i.prototype.transform = function(t) {
                        for(var r = [], e = 0, i = this.commands; e < i.length; e++){
                            var a = t(i[e]);
                            Array.isArray(a) ? r.push.apply(r, a) : r.push(a);
                        }
                        return this.commands = r, this;
                    }, i.encode = function(t) {
                        return e(t);
                    }, i.parse = function(t) {
                        var r = new f, e = [];
                        return r.parse(t, e), r.finish(e), e;
                    }, i.CLOSE_PATH = 1, i.MOVE_TO = 2, i.HORIZ_LINE_TO = 4, i.VERT_LINE_TO = 8, i.LINE_TO = 16, i.CURVE_TO = 32, i.SMOOTH_CURVE_TO = 64, i.QUAD_TO = 128, i.SMOOTH_QUAD_TO = 256, i.ARC = 512, i.LINE_COMMANDS = i.LINE_TO | i.HORIZ_LINE_TO | i.VERT_LINE_TO, i.DRAWING_COMMANDS = i.HORIZ_LINE_TO | i.VERT_LINE_TO | i.LINE_TO | i.CURVE_TO | i.SMOOTH_CURVE_TO | i.QUAD_TO | i.SMOOTH_QUAD_TO | i.ARC, i;
                }(l), N = ((O = {})[_.MOVE_TO] = 2, O[_.LINE_TO] = 2, O[_.HORIZ_LINE_TO] = 1, O[_.VERT_LINE_TO] = 1, O[_.CLOSE_PATH] = 0, O[_.QUAD_TO] = 4, O[_.SMOOTH_QUAD_TO] = 2, O[_.CURVE_TO] = 6, O[_.SMOOTH_CURVE_TO] = 4, O[_.ARC] = 7, O);
            //# sourceMappingURL=SVGPathData.module.js.map
            /***/ },
            /***/ "./src/plugin/hyperlinks.js": /*!**********************************!*\
  !*** ./src/plugin/hyperlinks.js ***!
  \**********************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string.js */ "./node_modules/core-js/modules/es.object.to-string.js");
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.string.link.js */ "./node_modules/core-js/modules/es.string.link.js");
                /* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/esnext.iterator.constructor.js */ "./node_modules/core-js/modules/esnext.iterator.constructor.js");
                /* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/esnext.iterator.for-each.js */ "./node_modules/core-js/modules/esnext.iterator.for-each.js");
                /* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
                /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each.js */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
                /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
                /* harmony import */ var _worker_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../worker.js */ "./src/worker.js");
                /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils.js */ "./src/utils.js");
                // Add hyperlink functionality to the PDF creation.
                // Main link array, and refs to original functions.
                var linkInfo = [];
                var orig = {
                    toContainer: _worker_js__WEBPACK_IMPORTED_MODULE_5__["default"].prototype.toContainer,
                    toPdf: _worker_js__WEBPACK_IMPORTED_MODULE_5__["default"].prototype.toPdf
                };
                _worker_js__WEBPACK_IMPORTED_MODULE_5__["default"].prototype.toContainer = function toContainer() {
                    return orig.toContainer.call(this).then(function toContainer_hyperlink() {
                        // Retrieve hyperlink info if the option is enabled.
                        if (this.opt.enableLinks) {
                            // Find all anchor tags and get the container's bounds for reference.
                            var container = this.prop.container;
                            var links = container.querySelectorAll('a');
                            var containerRect = (0, _utils_js__WEBPACK_IMPORTED_MODULE_6__.unitConvert)(container.getBoundingClientRect(), this.prop.pageSize.k);
                            linkInfo = [];
                            // Loop through each anchor tag.
                            Array.prototype.forEach.call(links, function(link) {
                                // Treat each client rect as a separate link (for text-wrapping).
                                var clientRects = link.getClientRects();
                                for(var i = 0; i < clientRects.length; i++){
                                    var clientRect = (0, _utils_js__WEBPACK_IMPORTED_MODULE_6__.unitConvert)(clientRects[i], this.prop.pageSize.k);
                                    clientRect.left -= containerRect.left;
                                    clientRect.top -= containerRect.top;
                                    var page = Math.floor(clientRect.top / this.prop.pageSize.inner.height) + 1;
                                    var top = this.opt.margin[0] + clientRect.top % this.prop.pageSize.inner.height;
                                    var left = this.opt.margin[1] + clientRect.left;
                                    linkInfo.push({
                                        page: page,
                                        top: top,
                                        left: left,
                                        clientRect: clientRect,
                                        link: link
                                    });
                                }
                            }, this);
                        }
                    });
                };
                _worker_js__WEBPACK_IMPORTED_MODULE_5__["default"].prototype.toPdf = function toPdf() {
                    return orig.toPdf.call(this).then(function toPdf_hyperlink() {
                        // Add hyperlinks if the option is enabled.
                        if (this.opt.enableLinks) {
                            // Attach each anchor tag based on info from toContainer().
                            linkInfo.forEach(function(l) {
                                this.prop.pdf.setPage(l.page);
                                this.prop.pdf.link(l.left, l.top, l.clientRect.width, l.clientRect.height, {
                                    url: l.link.href
                                });
                            }, this);
                            // Reset the active page of the PDF to the final page.
                            var nPages = this.prop.pdf.internal.getNumberOfPages();
                            this.prop.pdf.setPage(nPages);
                        }
                    });
                };
            /***/ },
            /***/ "./src/plugin/jspdf-plugin.js": /*!************************************!*\
  !*** ./src/plugin/jspdf-plugin.js ***!
  \************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.js */ "./node_modules/core-js/modules/es.symbol.js");
                /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description.js */ "./node_modules/core-js/modules/es.symbol.description.js");
                /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator.js */ "./node_modules/core-js/modules/es.symbol.iterator.js");
                /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.iterator.js */ "./node_modules/core-js/modules/es.array.iterator.js");
                /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string.js */ "./node_modules/core-js/modules/es.object.to-string.js");
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
                /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.iterator.js */ "./node_modules/core-js/modules/es.string.iterator.js");
                /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
                /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator.js */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
                /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
                /* harmony import */ var jspdf_dist_jspdf_es_min_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! jspdf/dist/jspdf.es.min.js */ "./node_modules/jspdf/dist/jspdf.es.min.js");
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                // Import dependencies.
                // Get dimensions of a PDF page, as determined by jsPDF.
                jspdf_dist_jspdf_es_min_js__WEBPACK_IMPORTED_MODULE_7__.jsPDF.getPageSize = function(orientation, unit, format) {
                    // Decode options object
                    if (_typeof(orientation) === 'object') {
                        var options = orientation;
                        orientation = options.orientation;
                        unit = options.unit || unit;
                        format = options.format || format;
                    }
                    // Default options
                    unit = unit || 'mm';
                    format = format || 'a4';
                    orientation = ('' + (orientation || 'P')).toLowerCase();
                    var format_as_string = ('' + format).toLowerCase();
                    // Size in pt of various paper formats
                    var pageFormats = {
                        'a0': [
                            2383.94,
                            3370.39
                        ],
                        'a1': [
                            1683.78,
                            2383.94
                        ],
                        'a2': [
                            1190.55,
                            1683.78
                        ],
                        'a3': [
                            841.89,
                            1190.55
                        ],
                        'a4': [
                            595.28,
                            841.89
                        ],
                        'a5': [
                            419.53,
                            595.28
                        ],
                        'a6': [
                            297.64,
                            419.53
                        ],
                        'a7': [
                            209.76,
                            297.64
                        ],
                        'a8': [
                            147.40,
                            209.76
                        ],
                        'a9': [
                            104.88,
                            147.40
                        ],
                        'a10': [
                            73.70,
                            104.88
                        ],
                        'b0': [
                            2834.65,
                            4008.19
                        ],
                        'b1': [
                            2004.09,
                            2834.65
                        ],
                        'b2': [
                            1417.32,
                            2004.09
                        ],
                        'b3': [
                            1000.63,
                            1417.32
                        ],
                        'b4': [
                            708.66,
                            1000.63
                        ],
                        'b5': [
                            498.90,
                            708.66
                        ],
                        'b6': [
                            354.33,
                            498.90
                        ],
                        'b7': [
                            249.45,
                            354.33
                        ],
                        'b8': [
                            175.75,
                            249.45
                        ],
                        'b9': [
                            124.72,
                            175.75
                        ],
                        'b10': [
                            87.87,
                            124.72
                        ],
                        'c0': [
                            2599.37,
                            3676.54
                        ],
                        'c1': [
                            1836.85,
                            2599.37
                        ],
                        'c2': [
                            1298.27,
                            1836.85
                        ],
                        'c3': [
                            918.43,
                            1298.27
                        ],
                        'c4': [
                            649.13,
                            918.43
                        ],
                        'c5': [
                            459.21,
                            649.13
                        ],
                        'c6': [
                            323.15,
                            459.21
                        ],
                        'c7': [
                            229.61,
                            323.15
                        ],
                        'c8': [
                            161.57,
                            229.61
                        ],
                        'c9': [
                            113.39,
                            161.57
                        ],
                        'c10': [
                            79.37,
                            113.39
                        ],
                        'dl': [
                            311.81,
                            623.62
                        ],
                        'letter': [
                            612,
                            792
                        ],
                        'government-letter': [
                            576,
                            756
                        ],
                        'legal': [
                            612,
                            1008
                        ],
                        'junior-legal': [
                            576,
                            360
                        ],
                        'ledger': [
                            1224,
                            792
                        ],
                        'tabloid': [
                            792,
                            1224
                        ],
                        'credit-card': [
                            153,
                            243
                        ]
                    };
                    // Unit conversion
                    switch(unit){
                        case 'pt':
                            var k = 1;
                            break;
                        case 'mm':
                            var k = 72 / 25.4;
                            break;
                        case 'cm':
                            var k = 72 / 2.54;
                            break;
                        case 'in':
                            var k = 72;
                            break;
                        case 'px':
                            var k = 0.75;
                            break;
                        case 'pc':
                            var k = 12;
                            break;
                        case 'em':
                            var k = 12;
                            break;
                        case 'ex':
                            var k = 6;
                            break;
                        default:
                            throw 'Invalid unit: ' + unit;
                    }
                    // Dimensions are stored as user units and converted to points on output
                    if (pageFormats.hasOwnProperty(format_as_string)) {
                        var pageHeight = pageFormats[format_as_string][1] / k;
                        var pageWidth = pageFormats[format_as_string][0] / k;
                    } else try {
                        var pageHeight = format[1];
                        var pageWidth = format[0];
                    } catch (err) {
                        throw new Error('Invalid format: ' + format);
                    }
                    // Handle page orientation
                    if (orientation === 'p' || orientation === 'portrait') {
                        orientation = 'p';
                        if (pageWidth > pageHeight) {
                            var tmp = pageWidth;
                            pageWidth = pageHeight;
                            pageHeight = tmp;
                        }
                    } else if (orientation === 'l' || orientation === 'landscape') {
                        orientation = 'l';
                        if (pageHeight > pageWidth) {
                            var tmp = pageWidth;
                            pageWidth = pageHeight;
                            pageHeight = tmp;
                        }
                    } else throw 'Invalid orientation: ' + orientation;
                    // Return information (k is the unit conversion ratio from pts)
                    var info = {
                        'width': pageWidth,
                        'height': pageHeight,
                        'unit': unit,
                        'k': k
                    };
                    return info;
                };
                /* harmony default export */ __webpack_exports__["default"] = jspdf_dist_jspdf_es_min_js__WEBPACK_IMPORTED_MODULE_7__.jsPDF;
            /***/ },
            /***/ "./src/plugin/pagebreaks.js": /*!**********************************!*\
  !*** ./src/plugin/pagebreaks.js ***!
  \**********************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat.js */ "./node_modules/core-js/modules/es.array.concat.js");
                /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.join.js */ "./node_modules/core-js/modules/es.array.join.js");
                /* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.slice.js */ "./node_modules/core-js/modules/es.array.slice.js");
                /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.keys.js */ "./node_modules/core-js/modules/es.object.keys.js");
                /* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__);
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string.js */ "./node_modules/core-js/modules/es.object.to-string.js");
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
                /* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/esnext.iterator.constructor.js */ "./node_modules/core-js/modules/esnext.iterator.constructor.js");
                /* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_5__);
                /* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/esnext.iterator.for-each.js */ "./node_modules/core-js/modules/esnext.iterator.for-each.js");
                /* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
                /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each.js */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
                /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_7__);
                /* harmony import */ var _worker_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../worker.js */ "./src/worker.js");
                /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../utils.js */ "./src/utils.js");
                /* Pagebreak plugin:

    Adds page-break functionality to the html2pdf library. Page-breaks can be
    enabled by CSS styles, set on individual elements using selectors, or
    avoided from breaking inside all elements.

    Options on the `opt.pagebreak` object:

    mode:   String or array of strings: 'avoid-all', 'css', and/or 'legacy'
            Default: ['css', 'legacy']

    before: String or array of CSS selectors for which to add page-breaks
            before each element. Can be a specific element with an ID
            ('#myID'), all elements of a type (e.g. 'img'), all of a class
            ('.myClass'), or even '*' to match every element.

    after:  Like 'before', but adds a page-break immediately after the element.

    avoid:  Like 'before', but avoids page-breaks on these elements. You can
            enable this feature on every element using the 'avoid-all' mode.
*/ // Refs to original functions.
                var orig = {
                    toContainer: _worker_js__WEBPACK_IMPORTED_MODULE_8__["default"].prototype.toContainer
                };
                // Add pagebreak default options to the Worker template.
                _worker_js__WEBPACK_IMPORTED_MODULE_8__["default"].template.opt.pagebreak = {
                    mode: [
                        'css',
                        'legacy'
                    ],
                    before: [],
                    after: [],
                    avoid: []
                };
                _worker_js__WEBPACK_IMPORTED_MODULE_8__["default"].prototype.toContainer = function toContainer() {
                    return orig.toContainer.call(this).then(function toContainer_pagebreak() {
                        // Setup root element and inner page height.
                        var root = this.prop.container;
                        var pxPageHeight = this.prop.pageSize.inner.px.height;
                        // Check all requested modes.
                        var modeSrc = [].concat(this.opt.pagebreak.mode);
                        var mode = {
                            avoidAll: modeSrc.indexOf('avoid-all') !== -1,
                            css: modeSrc.indexOf('css') !== -1,
                            legacy: modeSrc.indexOf('legacy') !== -1
                        };
                        // Get arrays of all explicitly requested elements.
                        var select = {};
                        var self1 = this;
                        [
                            'before',
                            'after',
                            'avoid'
                        ].forEach(function(key) {
                            var all = mode.avoidAll && key === 'avoid';
                            select[key] = all ? [] : [].concat(self1.opt.pagebreak[key] || []);
                            if (select[key].length > 0) select[key] = Array.prototype.slice.call(root.querySelectorAll(select[key].join(', ')));
                        });
                        // Get all legacy page-break elements.
                        var legacyEls = root.querySelectorAll('.html2pdf__page-break');
                        legacyEls = Array.prototype.slice.call(legacyEls);
                        // Loop through all elements.
                        var els = root.querySelectorAll('*');
                        Array.prototype.forEach.call(els, function pagebreak_loop(el) {
                            // Setup pagebreak rules based on legacy and avoidAll modes.
                            var rules = {
                                before: false,
                                after: mode.legacy && legacyEls.indexOf(el) !== -1,
                                avoid: mode.avoidAll
                            };
                            // Add rules for css mode.
                            if (mode.css) {
                                // TODO: Check if this is valid with iFrames.
                                var style = window.getComputedStyle(el);
                                // TODO: Handle 'left' and 'right' correctly.
                                // TODO: Add support for 'avoid' on breakBefore/After.
                                var breakOpt = [
                                    'always',
                                    'page',
                                    'left',
                                    'right'
                                ];
                                var avoidOpt = [
                                    'avoid',
                                    'avoid-page'
                                ];
                                rules = {
                                    before: rules.before || breakOpt.indexOf(style.breakBefore || style.pageBreakBefore) !== -1,
                                    after: rules.after || breakOpt.indexOf(style.breakAfter || style.pageBreakAfter) !== -1,
                                    avoid: rules.avoid || avoidOpt.indexOf(style.breakInside || style.pageBreakInside) !== -1
                                };
                            }
                            // Add rules for explicit requests.
                            Object.keys(rules).forEach(function(key) {
                                rules[key] = rules[key] || select[key].indexOf(el) !== -1;
                            });
                            // Get element position on the screen.
                            // TODO: Subtract the top of the container from clientRect.top/bottom?
                            var clientRect = el.getBoundingClientRect();
                            // Avoid: Check if a break happens mid-element.
                            if (rules.avoid && !rules.before) {
                                var startPage = Math.floor(clientRect.top / pxPageHeight);
                                var endPage = Math.floor(clientRect.bottom / pxPageHeight);
                                var nPages = Math.abs(clientRect.bottom - clientRect.top) / pxPageHeight;
                                // Turn on rules.before if the el is broken and is at most one page long.
                                if (endPage !== startPage && nPages <= 1) rules.before = true;
                            }
                            // Before: Create a padding div to push the element to the next page.
                            if (rules.before) {
                                var pad = (0, _utils_js__WEBPACK_IMPORTED_MODULE_9__.createElement)('div', {
                                    style: {
                                        display: 'block',
                                        height: pxPageHeight - clientRect.top % pxPageHeight + 'px'
                                    }
                                });
                                el.parentNode.insertBefore(pad, el);
                            }
                            // After: Create a padding div to fill the remaining page.
                            if (rules.after) {
                                var pad = (0, _utils_js__WEBPACK_IMPORTED_MODULE_9__.createElement)('div', {
                                    style: {
                                        display: 'block',
                                        height: pxPageHeight - clientRect.bottom % pxPageHeight + 'px'
                                    }
                                });
                                el.parentNode.insertBefore(pad, el.nextSibling);
                            }
                        });
                    });
                };
            /***/ },
            /***/ "./src/snapdom/clone.js": /*!******************************!*\
  !*** ./src/snapdom/clone.js ***!
  \******************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ deepCloneBasic: function() {
                        return /* binding */ deepCloneBasic;
                    }
                });
                /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.js */ "./node_modules/core-js/modules/es.symbol.js");
                /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description.js */ "./node_modules/core-js/modules/es.symbol.description.js");
                /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator.js */ "./node_modules/core-js/modules/es.symbol.iterator.js");
                /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat.js */ "./node_modules/core-js/modules/es.array.concat.js");
                /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
                /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from.js */ "./node_modules/core-js/modules/es.array.from.js");
                /* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4__);
                /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator.js */ "./node_modules/core-js/modules/es.array.iterator.js");
                /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
                /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice.js */ "./node_modules/core-js/modules/es.array.slice.js");
                /* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__);
                /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name.js */ "./node_modules/core-js/modules/es.function.name.js");
                /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__);
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string.js */ "./node_modules/core-js/modules/es.object.to-string.js");
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
                /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.exec.js */ "./node_modules/core-js/modules/es.regexp.exec.js");
                /* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9__);
                /* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.test.js */ "./node_modules/core-js/modules/es.regexp.test.js");
                /* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_10__);
                /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string.js */ "./node_modules/core-js/modules/es.regexp.to-string.js");
                /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_11__);
                /* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.set.js */ "./node_modules/core-js/modules/es.set.js");
                /* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_12__);
                /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.string.iterator.js */ "./node_modules/core-js/modules/es.string.iterator.js");
                /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
                /* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all.js */ "./node_modules/core-js/modules/esnext.set.add-all.js");
                /* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_14__);
                /* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all.js */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
                /* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_15__);
                /* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.difference.js */ "./node_modules/core-js/modules/esnext.set.difference.js");
                /* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_16__);
                /* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.every.js */ "./node_modules/core-js/modules/esnext.set.every.js");
                /* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_17__);
                /* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.filter.js */ "./node_modules/core-js/modules/esnext.set.filter.js");
                /* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_18__);
                /* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.find.js */ "./node_modules/core-js/modules/esnext.set.find.js");
                /* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_19__);
                /* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection.js */ "./node_modules/core-js/modules/esnext.set.intersection.js");
                /* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_20__);
                /* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from.js */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
                /* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_21__);
                /* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of.js */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
                /* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_22__);
                /* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of.js */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
                /* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_23__);
                /* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.join.js */ "./node_modules/core-js/modules/esnext.set.join.js");
                /* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_24__);
                /* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.map.js */ "./node_modules/core-js/modules/esnext.set.map.js");
                /* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_25__);
                /* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce.js */ "./node_modules/core-js/modules/esnext.set.reduce.js");
                /* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_26__);
                /* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.some.js */ "./node_modules/core-js/modules/esnext.set.some.js");
                /* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_27__);
                /* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference.js */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
                /* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_28__);
                /* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.union.js */ "./node_modules/core-js/modules/esnext.set.union.js");
                /* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_29__);
                /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator.js */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
                /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_30__);
                function _createForOfIteratorHelper(r, e) {
                    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                    if (!t) {
                        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
                            t && (r = t);
                            var _n = 0, F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    return _n >= r.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: r[_n++]
                                    };
                                },
                                e: function e(r) {
                                    throw r;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var o, a = !0, u = !1;
                    return {
                        s: function s() {
                            t = t.call(r);
                        },
                        n: function n() {
                            var r = t.next();
                            return a = r.done, r;
                        },
                        e: function e(r) {
                            u = !0, o = r;
                        },
                        f: function f() {
                            try {
                                a || null == t.return || t.return();
                            } finally{
                                if (u) throw o;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(r, a) {
                    if (r) {
                        if ("string" == typeof r) return _arrayLikeToArray(r, a);
                        var t = ({}).toString.call(r).slice(8, -1);
                        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
                    }
                }
                function _arrayLikeToArray(r, a) {
                    (null == a || a > r.length) && (a = r.length);
                    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
                    return n;
                }
                // https://github.com/zumerlab/snapdom
                //
                // MIT License
                //
                // Copyright (c) 2025 ZumerLab
                //
                // Permission is hereby granted, free of charge, to any person obtaining a copy
                // of this software and associated documentation files (the "Software"), to deal
                // in the Software without restriction, including without limitation the rights
                // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                // copies of the Software, and to permit persons to whom the Software is
                // furnished to do so, subject to the following conditions:
                //
                // The above copyright notice and this permission notice shall be included in all
                // copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                // SOFTWARE.
                /**
 * Deep cloning utilities for DOM elements, including styles and shadow DOM.
 * @module clone
 */ /**
 * Freeze the responsive selection of an <img> that has srcset/sizes.
 * Copies a concrete URL into `src` and removes `srcset`/`sizes` so the clone
 * doesn't need layout to resolve a candidate.
 * Works with <picture> because currentSrc reflects the chosen source.
 * @param {HTMLImageElement} original - Image in the live DOM.
 * @param {HTMLImageElement} cloned - Just-created cloned <img>.
 */ function freezeImgSrcset(original, cloned) {
                    try {
                        var chosen = original.currentSrc || original.src || '';
                        if (!chosen) return;
                        cloned.setAttribute('src', chosen);
                        cloned.removeAttribute('srcset');
                        cloned.removeAttribute('sizes');
                        // Hint deterministic decode/load for capture
                        cloned.loading = 'eager';
                        cloned.decoding = 'sync';
                    } catch (_unused) {
                    // no-op
                    }
                }
                /**
 * Creates a deep clone of a DOM node, including styles, shadow DOM, and special handling for excluded/placeholder/canvas nodes.
 *
 * @param {Node} node - Node to clone
 * @returns {Node|null} Cloned node with styles and shadow DOM content, or null for empty text nodes or filtered elements
 */ function deepCloneBasic(node) {
                    if (!node) throw new Error('Invalid node');
                    // Local set to avoid duplicates in slot processing
                    var clonedAssignedNodes = new Set();
                    var pendingSelectValue = null; // Track select value for later fix
                    // 1. Text nodes
                    if (node.nodeType === Node.TEXT_NODE) return node.cloneNode(true);
                    // 2. Non-element nodes (comments, etc.)
                    if (node.nodeType !== Node.ELEMENT_NODE) return node.cloneNode(true);
                    // 6. Special case: iframe → fallback pattern
                    if (node.tagName === "IFRAME") {
                        var fallback = document.createElement("div");
                        fallback.style.cssText = "width:".concat(node.offsetWidth, "px;height:").concat(node.offsetHeight, "px;background-image:repeating-linear-gradient(45deg,#ddd,#ddd 5px,#f9f9f9 5px,#f9f9f9 10px);display:flex;align-items:center;justify-content:center;font-size:12px;color:#555;border:1px solid #aaa;");
                        return fallback;
                    }
                    // 8. Canvas → convert to image
                    if (node.tagName === "CANVAS") {
                        var dataURL = node.toDataURL();
                        var img = document.createElement("img");
                        img.src = dataURL;
                        img.width = node.width;
                        img.height = node.height;
                        return img;
                    }
                    // 9. Base clone (without children)
                    var clone;
                    try {
                        clone = node.cloneNode(false);
                        if (node.tagName === 'IMG') freezeImgSrcset(node, clone);
                    } catch (err) {
                        console.error("[Snapdom] Failed to clone node:", node, err);
                        throw err;
                    }
                    // Special handling: textarea (keep size and value)
                    if (node instanceof HTMLTextAreaElement) {
                        clone.textContent = node.value;
                        clone.value = node.value;
                        var rect = node.getBoundingClientRect();
                        clone.style.boxSizing = 'border-box';
                        clone.style.width = "".concat(rect.width, "px");
                        clone.style.height = "".concat(rect.height, "px");
                        return clone;
                    }
                    // Special handling: input
                    if (node instanceof HTMLInputElement) {
                        if (node.hasAttribute("value")) {
                            clone.value = node.value;
                            clone.setAttribute("value", node.value);
                        }
                        if (node.checked !== void 0) {
                            clone.checked = node.checked;
                            if (node.checked) clone.setAttribute("checked", "");
                            if (node.indeterminate) clone.indeterminate = node.indeterminate;
                        }
                    // return clone;
                    }
                    // Special handling: select → postpone value adjustment
                    if (node instanceof HTMLSelectElement) pendingSelectValue = node.value;
                    // 12. ShadowRoot logic
                    if (node.shadowRoot) {
                        var hasSlot = Array.from(node.shadowRoot.querySelectorAll("slot")).length > 0;
                        if (hasSlot) ;
                        else {
                            // ShadowRoot without slots: clone full content
                            var shadowFrag = document.createDocumentFragment();
                            var _iterator = _createForOfIteratorHelper(node.shadowRoot.childNodes), _step;
                            try {
                                for(_iterator.s(); !(_step = _iterator.n()).done;){
                                    var child = _step.value;
                                    if (child.nodeType === Node.ELEMENT_NODE && child.tagName === "STYLE") continue;
                                    var clonedChild = deepCloneBasic(child);
                                    if (clonedChild) shadowFrag.appendChild(clonedChild);
                                }
                            } catch (err) {
                                _iterator.e(err);
                            } finally{
                                _iterator.f();
                            }
                            clone.appendChild(shadowFrag);
                        }
                    }
                    // 13. Slot outside ShadowRoot
                    if (node.tagName === "SLOT") {
                        var _node$assignedNodes;
                        var assigned = ((_node$assignedNodes = node.assignedNodes) === null || _node$assignedNodes === void 0 ? void 0 : _node$assignedNodes.call(node, {
                            flatten: true
                        })) || [];
                        var nodesToClone = assigned.length > 0 ? assigned : Array.from(node.childNodes);
                        var fragment = document.createDocumentFragment();
                        var _iterator2 = _createForOfIteratorHelper(nodesToClone), _step2;
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                var _child = _step2.value;
                                var _clonedChild = deepCloneBasic(_child);
                                if (_clonedChild) fragment.appendChild(_clonedChild);
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                        return fragment;
                    }
                    // 14. Clone children (light DOM), skipping duplicates
                    var _iterator3 = _createForOfIteratorHelper(node.childNodes), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var _child2 = _step3.value;
                            if (clonedAssignedNodes.has(_child2)) continue;
                            var _clonedChild2 = deepCloneBasic(_child2);
                            if (_clonedChild2) clone.appendChild(_clonedChild2);
                        }
                    // Adjust select value after children are cloned
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                    if (pendingSelectValue !== null && clone instanceof HTMLSelectElement) {
                        clone.value = pendingSelectValue;
                        var _iterator4 = _createForOfIteratorHelper(clone.options), _step4;
                        try {
                            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                var opt = _step4.value;
                                if (opt.value === pendingSelectValue) opt.setAttribute("selected", "");
                                else opt.removeAttribute("selected");
                            }
                        } catch (err) {
                            _iterator4.e(err);
                        } finally{
                            _iterator4.f();
                        }
                    }
                    // Fix scrolling (taken from prepareClone).
                    var scrollX = node.scrollLeft;
                    var scrollY = node.scrollTop;
                    var hasScroll = scrollX || scrollY;
                    if (hasScroll && clone instanceof HTMLElement) {
                        clone.style.overflow = "hidden";
                        clone.style.scrollbarWidth = "none";
                        clone.style.msOverflowStyle = "none";
                        var inner = document.createElement("div");
                        inner.style.transform = "translate(".concat(-scrollX, "px, ").concat(-scrollY, "px)");
                        inner.style.willChange = "transform";
                        inner.style.display = "inline-block";
                        inner.style.width = "100%";
                        while(clone.firstChild)inner.appendChild(clone.firstChild);
                        clone.appendChild(inner);
                    }
                    return clone;
                }
            /***/ },
            /***/ "./src/utils.js": /*!**********************!*\
  !*** ./src/utils.js ***!
  \**********************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ createElement: function() {
                        return /* binding */ createElement;
                    },
                    /* harmony export */ objType: function() {
                        return /* binding */ objType;
                    },
                    /* harmony export */ toPx: function() {
                        return /* binding */ toPx;
                    },
                    /* harmony export */ unitConvert: function() {
                        return /* binding */ unitConvert;
                    }
                });
                /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.js */ "./node_modules/core-js/modules/es.symbol.js");
                /* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description.js */ "./node_modules/core-js/modules/es.symbol.description.js");
                /* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator.js */ "./node_modules/core-js/modules/es.symbol.iterator.js");
                /* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.iterator.js */ "./node_modules/core-js/modules/es.array.iterator.js");
                /* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
                /* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.number.constructor.js */ "./node_modules/core-js/modules/es.number.constructor.js");
                /* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4__);
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string.js */ "./node_modules/core-js/modules/es.object.to-string.js");
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
                /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.iterator.js */ "./node_modules/core-js/modules/es.string.iterator.js");
                /* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
                /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator.js */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
                /* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
                /* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! dompurify */ "./node_modules/dompurify/dist/purify.es.mjs");
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                // Determine the type of a variable/object.
                var objType = function objType(obj) {
                    var type = _typeof(obj);
                    if (type === 'undefined') return 'undefined';
                    else if (type === 'string' || obj instanceof String) return 'string';
                    else if (type === 'number' || obj instanceof Number) return 'number';
                    else if (type === 'function' || obj instanceof Function) return 'function';
                    else if (!!obj && obj.constructor === Array) return 'array';
                    else if (obj && obj.nodeType === 1) return 'element';
                    else if (type === 'object') return 'object';
                    else return 'unknown';
                };
                // Create an HTML element with optional className, innerHTML, and style.
                var createElement = function createElement(tagName, opt) {
                    var el = document.createElement(tagName);
                    if (opt.className) el.className = opt.className;
                    if (opt.innerHTML) el.innerHTML = dompurify__WEBPACK_IMPORTED_MODULE_8__["default"].sanitize(opt.innerHTML);
                    for(var key in opt.style)el.style[key] = opt.style[key];
                    return el;
                };
                // Convert units from px using the conversion value 'k' from jsPDF.
                var unitConvert = function unitConvert(obj, k) {
                    if (objType(obj) === 'number') return obj * 72 / 96 / k;
                    else {
                        var newObj = {};
                        for(var key in obj)newObj[key] = obj[key] * 72 / 96 / k;
                        return newObj;
                    }
                };
                // Convert units to px using the conversion value 'k' from jsPDF.
                var toPx = function toPx(val, k) {
                    return Math.floor(val * k / 72 * 96);
                };
            /***/ },
            /***/ "./src/worker.js": /*!***********************!*\
  !*** ./src/worker.js ***!
  \***********************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat.js */ "./node_modules/core-js/modules/es.array.concat.js");
                /* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map.js */ "./node_modules/core-js/modules/es.array.map.js");
                /* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.function.name.js */ "./node_modules/core-js/modules/es.function.name.js");
                /* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.json.stringify.js */ "./node_modules/core-js/modules/es.json.stringify.js");
                /* harmony import */ var core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_3__);
                /* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.assign.js */ "./node_modules/core-js/modules/es.object.assign.js");
                /* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_4__);
                /* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.keys.js */ "./node_modules/core-js/modules/es.object.keys.js");
                /* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5__);
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string.js */ "./node_modules/core-js/modules/es.object.to-string.js");
                /* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
                /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.promise.js */ "./node_modules/core-js/modules/es.promise.js");
                /* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7__);
                /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string.js */ "./node_modules/core-js/modules/es.regexp.to-string.js");
                /* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
                /* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.iterator.constructor.js */ "./node_modules/core-js/modules/esnext.iterator.constructor.js");
                /* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_9__);
                /* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.iterator.for-each.js */ "./node_modules/core-js/modules/esnext.iterator.for-each.js");
                /* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_10__);
                /* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.iterator.map.js */ "./node_modules/core-js/modules/esnext.iterator.map.js");
                /* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_11__);
                /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each.js */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
                /* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__);
                /* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/web.timers.js */ "./node_modules/core-js/modules/web.timers.js");
                /* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/ __webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_13__);
                /* harmony import */ var jspdf_dist_jspdf_es_min_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! jspdf/dist/jspdf.es.min.js */ "./node_modules/jspdf/dist/jspdf.es.min.js");
                /* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! html2canvas */ "html2canvas");
                /* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/ __webpack_require__.n(html2canvas__WEBPACK_IMPORTED_MODULE_15__);
                /* harmony import */ var _snapdom_clone_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./snapdom/clone.js */ "./src/snapdom/clone.js");
                /* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./utils.js */ "./src/utils.js");
                /* ----- CONSTRUCTOR ----- */ var Worker1 = function Worker1(opt) {
                    // Create the root parent for the proto chain, and the starting Worker.
                    var root = Object.assign(Worker1.convert(Promise.resolve()), JSON.parse(JSON.stringify(Worker1.template)));
                    var self1 = Worker1.convert(Promise.resolve(), root);
                    // Set progress, optional settings, and return.
                    self1 = self1.setProgress(1, Worker1, 1, [
                        Worker1
                    ]);
                    self1 = self1.set(opt);
                    return self1;
                };
                // Boilerplate for subclassing Promise.
                Worker1.prototype = Object.create(Promise.prototype);
                Worker1.prototype.constructor = Worker1;
                // Converts/casts promises into Workers.
                Worker1.convert = function convert(promise, inherit) {
                    // Uses prototypal inheritance to receive changes made to ancestors' properties.
                    promise.__proto__ = inherit || Worker1.prototype;
                    return promise;
                };
                Worker1.template = {
                    prop: {
                        src: null,
                        container: null,
                        overlay: null,
                        canvas: null,
                        img: null,
                        pdf: null,
                        pageSize: null
                    },
                    progress: {
                        val: 0,
                        state: null,
                        n: 0,
                        stack: []
                    },
                    opt: {
                        filename: 'file.pdf',
                        margin: [
                            0,
                            0,
                            0,
                            0
                        ],
                        image: {
                            type: 'jpeg',
                            quality: 0.95
                        },
                        enableLinks: true,
                        html2canvas: {},
                        jsPDF: {}
                    }
                };
                /* ----- FROM / TO ----- */ Worker1.prototype.from = function from(src, type) {
                    function getType(src) {
                        switch((0, _utils_js__WEBPACK_IMPORTED_MODULE_17__.objType)(src)){
                            case 'string':
                                return 'string';
                            case 'element':
                                return src.nodeName.toLowerCase && src.nodeName.toLowerCase() === 'canvas' ? 'canvas' : 'element';
                            default:
                                return 'unknown';
                        }
                    }
                    return this.then(function from_main() {
                        type = type || getType(src);
                        switch(type){
                            case 'string':
                                return this.set({
                                    src: (0, _utils_js__WEBPACK_IMPORTED_MODULE_17__.createElement)('div', {
                                        innerHTML: src
                                    })
                                });
                            case 'element':
                                return this.set({
                                    src: src
                                });
                            case 'canvas':
                                return this.set({
                                    canvas: src
                                });
                            case 'img':
                                return this.set({
                                    img: src
                                });
                            default:
                                return this.error('Unknown source type.');
                        }
                    });
                };
                Worker1.prototype.to = function to(target) {
                    // Route the 'to' request to the appropriate method.
                    switch(target){
                        case 'container':
                            return this.toContainer();
                        case 'canvas':
                            return this.toCanvas();
                        case 'img':
                            return this.toImg();
                        case 'pdf':
                            return this.toPdf();
                        default:
                            return this.error('Invalid target.');
                    }
                };
                Worker1.prototype.toContainer = function toContainer() {
                    // Set up function prerequisites.
                    var prereqs = [
                        function checkSrc() {
                            return this.prop.src || this.error('Cannot duplicate - no source HTML.');
                        },
                        function checkPageSize() {
                            return this.prop.pageSize || this.setPageSize();
                        }
                    ];
                    return this.thenList(prereqs).then(function toContainer_main() {
                        // Define the CSS styles for the container and its overlay parent.
                        var overlayCSS = {
                            position: 'fixed',
                            overflow: 'hidden',
                            zIndex: 1000,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            top: 0,
                            backgroundColor: 'rgba(0,0,0,0.8)'
                        };
                        var containerCSS = {
                            position: 'absolute',
                            width: this.prop.pageSize.inner.width + this.prop.pageSize.unit,
                            left: 0,
                            right: 0,
                            top: 0,
                            height: 'auto',
                            margin: 'auto',
                            backgroundColor: 'white'
                        };
                        // Set the overlay to hidden (could be changed in the future to provide a print preview).
                        overlayCSS.opacity = 0;
                        // Create and attach the elements.
                        var source = (0, _snapdom_clone_js__WEBPACK_IMPORTED_MODULE_16__.deepCloneBasic)(this.prop.src);
                        this.prop.overlay = (0, _utils_js__WEBPACK_IMPORTED_MODULE_17__.createElement)('div', {
                            className: 'html2pdf__overlay',
                            style: overlayCSS
                        });
                        this.prop.container = (0, _utils_js__WEBPACK_IMPORTED_MODULE_17__.createElement)('div', {
                            className: 'html2pdf__container',
                            style: containerCSS
                        });
                        this.prop.container.appendChild(source);
                        this.prop.overlay.appendChild(this.prop.container);
                        document.body.appendChild(this.prop.overlay);
                        // Delay to better ensure content is fully cloned and rendering before capturing.
                        return new Promise(function(resolve) {
                            return setTimeout(resolve, 10);
                        });
                    });
                };
                Worker1.prototype.toCanvas = function toCanvas() {
                    // Set up function prerequisites.
                    var prereqs = [
                        function checkContainer() {
                            return document.body.contains(this.prop.container) || this.toContainer();
                        }
                    ];
                    // Fulfill prereqs then create the canvas.
                    return this.thenList(prereqs).then(function toCanvas_main() {
                        // Handle old-fashioned 'onrendered' argument.
                        var options = Object.assign({}, this.opt.html2canvas);
                        delete options.onrendered;
                        return html2canvas__WEBPACK_IMPORTED_MODULE_15___default()(this.prop.container, options);
                    }).then(function toCanvas_post(canvas) {
                        // Handle old-fashioned 'onrendered' argument.
                        var onRendered = this.opt.html2canvas.onrendered || function() {};
                        onRendered(canvas);
                        this.prop.canvas = canvas;
                        document.body.removeChild(this.prop.overlay);
                    });
                };
                Worker1.prototype.toImg = function toImg() {
                    // Set up function prerequisites.
                    var prereqs = [
                        function checkCanvas() {
                            return this.prop.canvas || this.toCanvas();
                        }
                    ];
                    // Fulfill prereqs then create the image.
                    return this.thenList(prereqs).then(function toImg_main() {
                        var imgData = this.prop.canvas.toDataURL('image/' + this.opt.image.type, this.opt.image.quality);
                        this.prop.img = document.createElement('img');
                        this.prop.img.src = imgData;
                    });
                };
                Worker1.prototype.toPdf = function toPdf() {
                    // Set up function prerequisites.
                    var prereqs = [
                        function checkCanvas() {
                            return this.prop.canvas || this.toCanvas();
                        },
                        function checkPageSize() {
                            return this.prop.pageSize || this.setPageSize();
                        }
                    ];
                    // Fulfill prereqs then create the image.
                    return this.thenList(prereqs).then(function toPdf_main() {
                        // Create local copies of frequently used properties.
                        var canvas = this.prop.canvas;
                        var opt = this.opt;
                        // Calculate the number of pages.
                        var pxFullHeight = canvas.height;
                        var pxPageHeight = Math.floor(canvas.width * this.prop.pageSize.inner.ratio);
                        var nPages = Math.ceil(pxFullHeight / pxPageHeight);
                        // Define pageHeight separately so it can be trimmed on the final page.
                        var pageHeight = this.prop.pageSize.inner.height;
                        // Create a one-page canvas to split up the full image.
                        var pageCanvas = document.createElement('canvas');
                        var pageCtx = pageCanvas.getContext('2d');
                        pageCanvas.width = canvas.width;
                        pageCanvas.height = pxPageHeight;
                        // Initialize the PDF.
                        this.prop.pdf = this.prop.pdf || new jspdf_dist_jspdf_es_min_js__WEBPACK_IMPORTED_MODULE_14__.jsPDF(opt.jsPDF);
                        for(var page = 0; page < nPages; page++){
                            // Trim the final page to reduce file size.
                            if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
                                pageCanvas.height = pxFullHeight % pxPageHeight;
                                pageHeight = pageCanvas.height * this.prop.pageSize.inner.width / pageCanvas.width;
                            }
                            // Display the page.
                            var w = pageCanvas.width;
                            var h = pageCanvas.height;
                            pageCtx.fillStyle = 'white';
                            pageCtx.fillRect(0, 0, w, h);
                            pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);
                            // Add the page to the PDF.
                            if (page) this.prop.pdf.addPage();
                            var imgData = pageCanvas.toDataURL('image/' + opt.image.type, opt.image.quality);
                            this.prop.pdf.addImage(imgData, opt.image.type, opt.margin[1], opt.margin[0], this.prop.pageSize.inner.width, pageHeight);
                        }
                    });
                };
                /* ----- OUTPUT / SAVE ----- */ Worker1.prototype.output = function output(type, options, src) {
                    // Redirect requests to the correct function (outputPdf / outputImg).
                    src = src || 'pdf';
                    if (src.toLowerCase() === 'img' || src.toLowerCase() === 'image') return this.outputImg(type, options);
                    else return this.outputPdf(type, options);
                };
                Worker1.prototype.outputPdf = function outputPdf(type, options) {
                    // Set up function prerequisites.
                    var prereqs = [
                        function checkPdf() {
                            return this.prop.pdf || this.toPdf();
                        }
                    ];
                    // Fulfill prereqs then perform the appropriate output.
                    return this.thenList(prereqs).then(function outputPdf_main() {
                        /* Currently implemented output types:
     *    https://rawgit.com/MrRio/jsPDF/master/docs/jspdf.js.html#line992
     *  save(options), arraybuffer, blob, bloburi/bloburl,
     *  datauristring/dataurlstring, dataurlnewwindow, datauri/dataurl
     */ return this.prop.pdf.output(type, options);
                    });
                };
                Worker1.prototype.outputImg = function outputImg(type, options) {
                    // Set up function prerequisites.
                    var prereqs = [
                        function checkImg() {
                            return this.prop.img || this.toImg();
                        }
                    ];
                    // Fulfill prereqs then perform the appropriate output.
                    return this.thenList(prereqs).then(function outputImg_main() {
                        switch(type){
                            case undefined:
                            case 'img':
                                return this.prop.img;
                            case 'datauristring':
                            case 'dataurlstring':
                                return this.prop.img.src;
                            case 'datauri':
                            case 'dataurl':
                                return document.location.href = this.prop.img.src;
                            default:
                                throw 'Image output type "' + type + '" is not supported.';
                        }
                    });
                };
                Worker1.prototype.save = function save(filename) {
                    // Set up function prerequisites.
                    var prereqs = [
                        function checkPdf() {
                            return this.prop.pdf || this.toPdf();
                        }
                    ];
                    // Fulfill prereqs, update the filename (if provided), and save the PDF.
                    return this.thenList(prereqs).set(filename ? {
                        filename: filename
                    } : null).then(function save_main() {
                        this.prop.pdf.save(this.opt.filename);
                    });
                };
                /* ----- SET / GET ----- */ Worker1.prototype.set = function set(opt) {
                    // TODO: Implement ordered pairs?
                    // Silently ignore invalid or empty input.
                    if ((0, _utils_js__WEBPACK_IMPORTED_MODULE_17__.objType)(opt) !== 'object') return this;
                    // Build an array of setter functions to queue.
                    var fns = Object.keys(opt || {}).map(function(key) {
                        switch(key){
                            case 'margin':
                                return this.setMargin.bind(this, opt.margin);
                            case 'jsPDF':
                                return function set_jsPDF() {
                                    this.opt.jsPDF = opt.jsPDF;
                                    return this.setPageSize();
                                };
                            case 'pageSize':
                                return this.setPageSize.bind(this, opt.pageSize);
                            default:
                                if (key in Worker1.template.prop) // Set pre-defined properties in prop.
                                return function set_prop() {
                                    this.prop[key] = opt[key];
                                };
                                else // Set any other properties in opt.
                                return function set_opt() {
                                    this.opt[key] = opt[key];
                                };
                        }
                    }, this);
                    // Set properties within the promise chain.
                    return this.then(function set_main() {
                        return this.thenList(fns);
                    });
                };
                Worker1.prototype.get = function get(key, cbk) {
                    return this.then(function get_main() {
                        // Fetch the requested property, either as a predefined prop or in opt.
                        var val = key in Worker1.template.prop ? this.prop[key] : this.opt[key];
                        return cbk ? cbk(val) : val;
                    });
                };
                Worker1.prototype.setMargin = function setMargin(margin) {
                    return this.then(function setMargin_main() {
                        // Parse the margin property: [top, left, bottom, right].
                        switch((0, _utils_js__WEBPACK_IMPORTED_MODULE_17__.objType)(margin)){
                            case 'number':
                                margin = [
                                    margin,
                                    margin,
                                    margin,
                                    margin
                                ];
                            case 'array':
                                if (margin.length === 2) margin = [
                                    margin[0],
                                    margin[1],
                                    margin[0],
                                    margin[1]
                                ];
                                if (margin.length === 4) break;
                            default:
                                return this.error('Invalid margin array.');
                        }
                        // Set the margin property, then update pageSize.
                        this.opt.margin = margin;
                    }).then(this.setPageSize);
                };
                Worker1.prototype.setPageSize = function setPageSize(pageSize) {
                    return this.then(function setPageSize_main() {
                        // Retrieve page-size based on jsPDF settings, if not explicitly provided.
                        pageSize = pageSize || jspdf_dist_jspdf_es_min_js__WEBPACK_IMPORTED_MODULE_14__.jsPDF.getPageSize(this.opt.jsPDF);
                        // Add 'inner' field if not present.
                        if (!pageSize.hasOwnProperty('inner')) {
                            pageSize.inner = {
                                width: pageSize.width - this.opt.margin[1] - this.opt.margin[3],
                                height: pageSize.height - this.opt.margin[0] - this.opt.margin[2]
                            };
                            pageSize.inner.px = {
                                width: (0, _utils_js__WEBPACK_IMPORTED_MODULE_17__.toPx)(pageSize.inner.width, pageSize.k),
                                height: (0, _utils_js__WEBPACK_IMPORTED_MODULE_17__.toPx)(pageSize.inner.height, pageSize.k)
                            };
                            pageSize.inner.ratio = pageSize.inner.height / pageSize.inner.width;
                        }
                        // Attach pageSize to this.
                        this.prop.pageSize = pageSize;
                    });
                };
                Worker1.prototype.setProgress = function setProgress(val, state, n, stack) {
                    // Immediately update all progress values.
                    if (val != null) this.progress.val = val;
                    if (state != null) this.progress.state = state;
                    if (n != null) this.progress.n = n;
                    if (stack != null) this.progress.stack = stack;
                    this.progress.ratio = this.progress.val / this.progress.state;
                    // Return this for command chaining.
                    return this;
                };
                Worker1.prototype.updateProgress = function updateProgress(val, state, n, stack) {
                    // Immediately update all progress values, using setProgress.
                    return this.setProgress(val ? this.progress.val + val : null, state ? state : null, n ? this.progress.n + n : null, stack ? this.progress.stack.concat(stack) : null);
                };
                /* ----- PROMISE MAPPING ----- */ Worker1.prototype.then = function then(onFulfilled, onRejected) {
                    // Wrap `this` for encapsulation.
                    var self1 = this;
                    return this.thenCore(onFulfilled, onRejected, function then_main(onFulfilled, onRejected) {
                        // Update progress while queuing, calling, and resolving `then`.
                        self1.updateProgress(null, null, 1, [
                            onFulfilled
                        ]);
                        return Promise.prototype.then.call(this, function then_pre(val) {
                            self1.updateProgress(null, onFulfilled);
                            return val;
                        }).then(onFulfilled, onRejected).then(function then_post(val) {
                            self1.updateProgress(1);
                            return val;
                        });
                    });
                };
                Worker1.prototype.thenCore = function thenCore(onFulfilled, onRejected, thenBase) {
                    // Handle optional thenBase parameter.
                    thenBase = thenBase || Promise.prototype.then;
                    // Wrap `this` for encapsulation and bind it to the promise handlers.
                    var self1 = this;
                    if (onFulfilled) onFulfilled = onFulfilled.bind(self1);
                    if (onRejected) onRejected = onRejected.bind(self1);
                    // Cast self into a Promise to avoid polyfills recursively defining `then`.
                    var isNative = Promise.toString().indexOf('[native code]') !== -1 && Promise.name === 'Promise';
                    var selfPromise = isNative ? self1 : Worker1.convert(Object.assign({}, self1), Promise.prototype);
                    // Return the promise, after casting it into a Worker and preserving props.
                    var returnVal = thenBase.call(selfPromise, onFulfilled, onRejected);
                    return Worker1.convert(returnVal, self1.__proto__);
                };
                Worker1.prototype.thenExternal = function thenExternal(onFulfilled, onRejected) {
                    // Call `then` and return a standard promise (exits the Worker chain).
                    return Promise.prototype.then.call(this, onFulfilled, onRejected);
                };
                Worker1.prototype.thenList = function thenList(fns) {
                    // Queue a series of promise 'factories' into the promise chain.
                    var self1 = this;
                    fns.forEach(function thenList_forEach(fn) {
                        self1 = self1.thenCore(fn);
                    });
                    return self1;
                };
                Worker1.prototype['catch'] = function(onRejected) {
                    // Bind `this` to the promise handler, call `catch`, and return a Worker.
                    if (onRejected) onRejected = onRejected.bind(this);
                    var returnVal = Promise.prototype['catch'].call(this, onRejected);
                    return Worker1.convert(returnVal, this);
                };
                Worker1.prototype.catchExternal = function catchExternal(onRejected) {
                    // Call `catch` and return a standard promise (exits the Worker chain).
                    return Promise.prototype['catch'].call(this, onRejected);
                };
                Worker1.prototype.error = function error(msg) {
                    // Throw the error in the Promise chain.
                    return this.then(function error_main() {
                        throw new Error(msg);
                    });
                };
                /* ----- ALIASES ----- */ Worker1.prototype.using = Worker1.prototype.set;
                Worker1.prototype.saveAs = Worker1.prototype.save;
                Worker1.prototype.export = Worker1.prototype.output;
                Worker1.prototype.run = Worker1.prototype.then;
                /* ----- FINISHING ----- */ // Expose the Worker class.
                /* harmony default export */ __webpack_exports__["default"] = Worker1;
            /***/ },
            /***/ "html2canvas": /*!******************************!*\
  !*** external "html2canvas" ***!
  \******************************/ /***/ function(module1) {
                "use strict";
                module1.exports = __WEBPACK_EXTERNAL_MODULE_html2canvas__;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Check if module exists (development only)
            /******/ if (__webpack_modules__[moduleId] === undefined) {
                /******/ var e = new Error("Cannot find module '" + moduleId + "'");
                /******/ e.code = 'MODULE_NOT_FOUND';
                /******/ throw e;
            /******/ }
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/create fake namespace object */ /******/ !function() {
            /******/ var getProto = Object.getPrototypeOf ? function(obj) {
                return Object.getPrototypeOf(obj);
            } : function(obj) {
                return obj.__proto__;
            };
            /******/ var leafPrototypes;
            /******/ // create a fake namespace object
            /******/ // mode & 1: value is a module id, require it
            /******/ // mode & 2: merge all properties of value into the ns
            /******/ // mode & 4: return value when already ns object
            /******/ // mode & 16: return value when it's Promise-like
            /******/ // mode & 8|1: behave like require
            /******/ __webpack_require__.t = function(value, mode) {
                /******/ if (mode & 1) value = this(value);
                /******/ if (mode & 8) return value;
                /******/ if (typeof value === 'object' && value) {
                    /******/ if (mode & 4 && value.__esModule) return value;
                    /******/ if (mode & 16 && typeof value.then === 'function') return value;
                /******/ }
                /******/ var ns = Object.create(null);
                /******/ __webpack_require__.r(ns);
                /******/ var def = {};
                /******/ leafPrototypes = leafPrototypes || [
                    null,
                    getProto({}),
                    getProto([]),
                    getProto(getProto)
                ];
                /******/ for(var current = mode & 2 && value; (typeof current == 'object' || typeof current == 'function') && !~leafPrototypes.indexOf(current); current = getProto(current))/******/ Object.getOwnPropertyNames(current).forEach(function(key) {
                    def[key] = function() {
                        return value[key];
                    };
                });
                /******/ def['default'] = function() {
                    return value;
                };
                /******/ __webpack_require__.d(ns, def);
                /******/ return ns;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/ Object.defineProperty(exports, '__esModule', {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
        !function() {
            "use strict";
            /*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/ __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _worker_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./worker.js */ "./src/worker.js");
            /* harmony import */ var _plugin_jspdf_plugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./plugin/jspdf-plugin.js */ "./src/plugin/jspdf-plugin.js");
            /* harmony import */ var _plugin_pagebreaks_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./plugin/pagebreaks.js */ "./src/plugin/pagebreaks.js");
            /* harmony import */ var _plugin_hyperlinks_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./plugin/hyperlinks.js */ "./src/plugin/hyperlinks.js");
            /**
 * Generate a PDF from an HTML element or string using html2canvas and jsPDF.
 *
 * @param {Element|string} source The source element or HTML string.
 * @param {Object=} opt An object of optional settings: 'margin', 'filename',
 *    'image' ('type' and 'quality'), and 'html2canvas' / 'jspdf', which are
 *    sent as settings to their corresponding functions.
 */ var html2pdf = function html2pdf(src, opt) {
                // Create a new worker with the given options.
                var worker = new html2pdf.Worker(opt);
                if (src) // If src is specified, perform the traditional 'simple' operation.
                return worker.from(src).save();
                else // Otherwise, return the worker for new Promise-based operation.
                return worker;
            };
            html2pdf.Worker = _worker_js__WEBPACK_IMPORTED_MODULE_0__["default"];
            // Expose the html2pdf function.
            /* harmony default export */ __webpack_exports__["default"] = html2pdf;
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});

},{"3af49d75da587f8":"3eyQ5"}],"3eyQ5":[function(require,module,exports,__globalThis) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = 'AAAAAAAAAAAAEA4AGBkAAFAaAAACAAAAAAAIABAAGAAwADgACAAQAAgAEAAIABAACAAQAAgAEAAIABAACAAQAAgAEAAIABAAQABIAEQATAAIABAACAAQAAgAEAAIABAAVABcAAgAEAAIABAACAAQAGAAaABwAHgAgACIAI4AlgAIABAAmwCjAKgAsAC2AL4AvQDFAMoA0gBPAVYBWgEIAAgACACMANoAYgFkAWwBdAF8AX0BhQGNAZUBlgGeAaMBlQGWAasBswF8AbsBwwF0AcsBYwHTAQgA2wG/AOMBdAF8AekB8QF0AfkB+wHiAHQBfAEIAAMC5gQIAAsCEgIIAAgAFgIeAggAIgIpAggAMQI5AkACygEIAAgASAJQAlgCYAIIAAgACAAKBQoFCgUTBRMFGQUrBSsFCAAIAAgACAAIAAgACAAIAAgACABdAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABoAmgCrwGvAQgAbgJ2AggAHgEIAAgACADnAXsCCAAIAAgAgwIIAAgACAAIAAgACACKAggAkQKZAggAPADJAAgAoQKkAqwCsgK6AsICCADJAggA0AIIAAgACAAIANYC3gIIAAgACAAIAAgACABAAOYCCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAkASoB+QIEAAgACAA8AEMCCABCBQgACABJBVAFCAAIAAgACAAIAAgACAAIAAgACABTBVoFCAAIAFoFCABfBWUFCAAIAAgACAAIAAgAbQUIAAgACAAIAAgACABzBXsFfQWFBYoFigWKBZEFigWKBYoFmAWfBaYFrgWxBbkFCAAIAAgACAAIAAgACAAIAAgACAAIAMEFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAMgFCADQBQgACAAIAAgACAAIAAgACAAIAAgACAAIAO4CCAAIAAgAiQAIAAgACABAAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAD0AggACAD8AggACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIANYFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAMDvwAIAAgAJAIIAAgACAAIAAgACAAIAAgACwMTAwgACAB9BOsEGwMjAwgAKwMyAwsFYgE3A/MEPwMIAEUDTQNRAwgAWQOsAGEDCAAIAAgACAAIAAgACABpAzQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFIQUoBSwFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABtAwgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABMAEwACAAIAAgACAAIABgACAAIAAgACAC/AAgACAAyAQgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACAAIAAwAAgACAAIAAgACAAIAAgACAAIAAAARABIAAgACAAIABQASAAIAAgAIABwAEAAjgCIABsAqAC2AL0AigDQAtwC+IJIQqVAZUBWQqVAZUBlQGVAZUBlQGrC5UBlQGVAZUBlQGVAZUBlQGVAXsKlQGVAbAK6wsrDGUMpQzlDJUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAfAKAAuZA64AtwCJALoC6ADwAAgAuACgA/oEpgO6AqsD+AAIAAgAswMIAAgACAAIAIkAuwP5AfsBwwPLAwgACAAIAAgACADRA9kDCAAIAOED6QMIAAgACAAIAAgACADuA/YDCAAIAP4DyQAIAAgABgQIAAgAXQAOBAgACAAIAAgACAAIABMECAAIAAgACAAIAAgACAD8AAQBCAAIAAgAGgQiBCoECAExBAgAEAEIAAgACAAIAAgACAAIAAgACAAIAAgACAA4BAgACABABEYECAAIAAgATAQYAQgAVAQIAAgACAAIAAgACAAIAAgACAAIAFoECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAOQEIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAB+BAcACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAEABhgSMBAgACAAIAAgAlAQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAwAEAAQABAADAAMAAwADAAQABAAEAAQABAAEAAQABHATAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAdQMIAAgACAAIAAgACAAIAMkACAAIAAgAfQMIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACFA4kDCAAIAAgACAAIAOcBCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAIcDCAAIAAgACAAIAAgACAAIAAgACAAIAJEDCAAIAAgACADFAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABgBAgAZgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAbAQCBXIECAAIAHkECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABAAJwEQACjBKoEsgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAC6BMIECAAIAAgACAAIAAgACABmBAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAxwQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAGYECAAIAAgAzgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBd0FXwUIAOIF6gXxBYoF3gT5BQAGCAaKBYoFigWKBYoFigWKBYoFigWKBYoFigXWBIoFigWKBYoFigWKBYoFigWKBYsFEAaKBYoFigWKBYoFigWKBRQGCACKBYoFigWKBQgACAAIANEECAAIABgGigUgBggAJgYIAC4GMwaKBYoF0wQ3Bj4GigWKBYoFigWKBYoFigWKBYoFigWKBYoFigUIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWLBf///////wQABAAEAAQABAAEAAQABAAEAAQAAwAEAAQAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAQADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUAAAAFAAUAAAAFAAUAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAQAAAAUABQAFAAUABQAFAAAAAAAFAAUAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAFAAUAAQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAAABwAHAAcAAAAHAAcABwAFAAEAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAcABwAFAAUAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAAAAQABAAAAAAAAAAAAAAAFAAUABQAFAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAHAAcAAAAHAAcAAAAAAAUABQAHAAUAAQAHAAEABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwABAAUABQAFAAUAAAAAAAAAAAAAAAEAAQABAAEAAQABAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABQANAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAABQAHAAUABQAFAAAAAAAAAAcABQAFAAUABQAFAAQABAAEAAQABAAEAAQABAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUAAAAFAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAUAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAcABwAFAAcABwAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUABwAHAAUABQAFAAUAAAAAAAcABwAAAAAABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAAAAAAAAAAABQAFAAAAAAAFAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAFAAUABQAFAAUAAAAFAAUABwAAAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABwAFAAUABQAFAAAAAAAHAAcAAAAAAAcABwAFAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAAAAAAAAAHAAcABwAAAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAUABQAFAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAHAAcABQAHAAcAAAAFAAcABwAAAAcABwAFAAUAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAFAAcABwAFAAUABQAAAAUAAAAHAAcABwAHAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAHAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUAAAAFAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAUAAAAFAAUAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABwAFAAUABQAFAAUABQAAAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABQAFAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAFAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAHAAUABQAFAAUABQAFAAUABwAHAAcABwAHAAcABwAHAAUABwAHAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABwAHAAcABwAFAAUABwAHAAcAAAAAAAAAAAAHAAcABQAHAAcABwAHAAcABwAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAUABQAFAAUABQAFAAUAAAAFAAAABQAAAAAABQAFAAUABQAFAAUABQAFAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAUABQAFAAUABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABwAFAAcABwAHAAcABwAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAUABQAFAAUABwAHAAUABQAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABQAFAAcABwAHAAUABwAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAcABQAFAAUABQAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAAAAAABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAAAAAAAAAFAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAUABQAHAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAFAAUABQAFAAcABwAFAAUABwAHAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAcABwAFAAUABwAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABQAAAAAABQAFAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAcABwAAAAAAAAAAAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAcABwAFAAcABwAAAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAFAAUABQAAAAUABQAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABwAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAHAAcABQAHAAUABQAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAAABwAHAAAAAAAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAFAAUABwAFAAcABwAFAAcABQAFAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAAAAAABwAHAAcABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAFAAcABwAFAAUABQAFAAUABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAUABQAFAAcABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABQAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAAAAAAFAAUABwAHAAcABwAFAAAAAAAAAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAHAAUABQAFAAUABQAFAAUABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAABQAAAAUABQAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAHAAcAAAAFAAUAAAAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABQAFAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAABQAFAAUABQAFAAUABQAAAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAFAAUABQAFAAUADgAOAA4ADgAOAA4ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAMAAwADAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAAAAAAAAAAAAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAAAAAAAAAAAAsADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwACwAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAADgAOAA4AAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAAAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4AAAAOAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAAAAAAAAAAAA4AAAAOAAAAAAAAAAAADgAOAA4AAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAA=';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

},{}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["eAoc2"], "eAoc2", "parcelRequiredd39", {})

//# sourceMappingURL=sign.0abe86d9.js.map
